export const Data2:any = [
    {
        "dataID": "114840",
        "id": "52955757",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 02:27:42",
        "brokerTime": "2025-05-14 02:27:42",
        "commission": -0.7,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "55952702",
        "positionId": "55952702",
        "volume": 0.1,
        "price": 3254.85,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3354.85,
        "brokerComment": "Buy Order",
        "comment": "Buy Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.7,
        "priceIn": 3254.85,
        "doubleCheck": true
    },
    {
        "dataID": "114807",
        "id": "52955758",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 02:27:43",
        "brokerTime": "2025-05-14 02:27:43",
        "commission": -0.7,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "55952703",
        "positionId": "55952703",
        "volume": 0.1,
        "price": 3254.59,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3154.59,
        "brokerComment": "Sell Order",
        "comment": "Sell Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.7,
        "priceIn": 3254.59,
        "doubleCheck": true
    },
    {
        "dataID": "114808",
        "id": "52955783",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 02:37:05",
        "brokerTime": "2025-05-14 02:37:05",
        "commission": -0.84,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "55952731",
        "positionId": "55952731",
        "volume": 0.12,
        "price": 3253.79,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3353.83,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.84,
        "priceIn": 3253.79,
        "doubleCheck": true
    },
    {
        "dataID": "114809",
        "id": "52955901",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 02:39:37",
        "brokerTime": "2025-05-14 02:39:37",
        "commission": -0.98,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "55952845",
        "positionId": "55952845",
        "volume": 0.14,
        "price": 3252.79,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3352.79,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.98,
        "priceIn": 3252.79,
        "doubleCheck": true
    },
    {
        "dataID": "114810",
        "id": "52955960",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 02:46:23",
        "brokerTime": "2025-05-14 02:46:23",
        "commission": -0.84,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "55952907",
        "positionId": "55952907",
        "volume": 0.12,
        "price": 3255.63,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3155.63,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.84,
        "priceIn": 3255.63,
        "doubleCheck": true
    },
    {
        "dataID": "114811",
        "id": "52957843",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 03:01:27",
        "brokerTime": "2025-05-14 03:01:27",
        "commission": -1.19,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "55954454",
        "positionId": "55954454",
        "volume": 0.17,
        "price": 3251.79,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3351.79,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -1.19,
        "priceIn": 3251.79,
        "doubleCheck": true
    },
    {
        "dataID": "114812",
        "id": "52957871",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 03:02:00",
        "brokerTime": "2025-05-14 03:02:00",
        "commission": -1.47,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "55954479",
        "positionId": "55954479",
        "volume": 0.21,
        "price": 3250.51,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3350.51,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -1.47,
        "priceIn": 3250.51,
        "doubleCheck": true
    },
    {
        "dataID": "114813",
        "id": "52958016",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 03:03:00",
        "brokerTime": "2025-05-14 03:03:00",
        "commission": -1.75,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "55954602",
        "positionId": "55954602",
        "volume": 0.25,
        "price": 3248.15,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3348.26,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -1.75,
        "priceIn": 3248.15,
        "doubleCheck": true
    },
    {
        "dataID": "114814",
        "id": "52958211",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 02:46:23",
        "brokerTime": "2025-05-14 03:03:24",
        "commission": -0.84,
        "swap": 0,
        "profit": 75.36,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "55954736",
        "positionId": "55952907",
        "volume": 0.12,
        "price": 3249.35,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3155.89,
        "brokerComment": "",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 74.52,
        "priceIn": 3255.63,
        "doubleCheck": true,
        "isShow": false,
        "collapseIndex": "0",
        "tProfit": 127.76,
        "tnProfit": 126.22,
        "tVolume": 0.22,
        "tTrades": 2
    },
    {
        "dataID": "114815",
        "id": "52958212",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 02:27:43",
        "brokerTime": "2025-05-14 03:03:24",
        "commission": -0.7,
        "swap": 0,
        "profit": 52.4,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "55954737",
        "positionId": "55952703",
        "volume": 0.1,
        "price": 3249.35,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3155.89,
        "brokerComment": "",
        "comment": "Sell Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 51.699999999999996,
        "priceIn": 3254.59,
        "doubleCheck": true
    },
    {
        "dataID": "114816",
        "id": "52958217",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 03:03:37",
        "brokerTime": "2025-05-14 03:03:37",
        "commission": -0.7,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "55954741",
        "positionId": "55954741",
        "volume": 0.1,
        "price": 3249.18,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "RR",
        "comment": "RR",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.7,
        "priceIn": 3249.18,
        "doubleCheck": true
    },
    {
        "dataID": "114817",
        "id": "52958439",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 03:06:02",
        "brokerTime": "2025-05-14 03:06:02",
        "commission": -2.1,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "55954912",
        "positionId": "55954912",
        "volume": 0.3,
        "price": 3247.07,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3347.1,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -2.1,
        "priceIn": 3247.07,
        "doubleCheck": true
    },
    {
        "dataID": "114818",
        "id": "52958484",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 03:09:55",
        "brokerTime": "2025-05-14 03:09:55",
        "commission": -2.52,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "55954949",
        "positionId": "55954949",
        "volume": 0.36,
        "price": 3246.05,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3346.05,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -2.52,
        "priceIn": 3246.05,
        "doubleCheck": true
    },
    {
        "dataID": "114819",
        "id": "52958833",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 03:12:29",
        "brokerTime": "2025-05-14 03:12:29",
        "commission": -3.01,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "55955262",
        "positionId": "55955262",
        "volume": 0.43,
        "price": 3244.69,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3344.69,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -3.01,
        "priceIn": 3244.69,
        "doubleCheck": true
    },
    {
        "dataID": "114820",
        "id": "52958925",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 03:19:02",
        "brokerTime": "2025-05-14 03:19:02",
        "commission": -4.2,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "55955342",
        "positionId": "55955342",
        "volume": 0.6,
        "price": 3244.66,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "Manual BT",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -4.2,
        "priceIn": 3244.66,
        "doubleCheck": true
    },
    {
        "dataID": "114821",
        "id": "52958926",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 03:19:03",
        "brokerTime": "2025-05-14 03:19:03",
        "commission": -3.85,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "55955343",
        "positionId": "55955343",
        "volume": 0.55,
        "price": 3244.74,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "Manual BT",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -3.85,
        "priceIn": 3244.74,
        "doubleCheck": true
    },
    {
        "dataID": "114822",
        "id": "52958927",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 03:19:03",
        "brokerTime": "2025-05-14 03:19:03",
        "commission": -3.22,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "55955344",
        "positionId": "55955344",
        "volume": 0.46,
        "price": 3244.74,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "Manual BT",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -3.22,
        "priceIn": 3244.74,
        "doubleCheck": true
    },
    {
        "dataID": "114823",
        "id": "52958928",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 03:19:03",
        "brokerTime": "2025-05-14 03:19:03",
        "commission": -2.87,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "55955345",
        "positionId": "55955345",
        "volume": 0.41,
        "price": 3244.74,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "Manual BT",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -2.87,
        "priceIn": 3244.74,
        "doubleCheck": true
    },
    {
        "dataID": "114824",
        "id": "52958929",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 03:19:03",
        "brokerTime": "2025-05-14 03:19:03",
        "commission": -2.66,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "55955346",
        "positionId": "55955346",
        "volume": 0.38,
        "price": 3244.74,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "Manual BT",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -2.66,
        "priceIn": 3244.74,
        "doubleCheck": true
    },
    {
        "dataID": "114825",
        "id": "52958930",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 03:19:03",
        "brokerTime": "2025-05-14 03:19:04",
        "commission": -2.66,
        "swap": 0,
        "profit": -9.88,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "55955347",
        "positionId": "55955346",
        "volume": 0.38,
        "price": 3245,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -12.540000000000001,
        "priceIn": 3244.74,
        "doubleCheck": true,
        "isShow": false,
        "collapseIndex": "0,1,2",
        "tProfit": -10,
        "tnProfit": -27.5,
        "tVolume": 2.5,
        "tTrades": 6
    },
    {
        "dataID": "114826",
        "id": "52958931",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 03:19:03",
        "brokerTime": "2025-05-14 03:19:04",
        "commission": -2.87,
        "swap": 0,
        "profit": -10.66,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "55955348",
        "positionId": "55955345",
        "volume": 0.41,
        "price": 3245,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -13.530000000000001,
        "priceIn": 3244.74,
        "doubleCheck": true
    },
    {
        "dataID": "114827",
        "id": "52958932",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 03:19:03",
        "brokerTime": "2025-05-14 03:19:04",
        "commission": -3.22,
        "swap": 0,
        "profit": -11.96,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "55955349",
        "positionId": "55955344",
        "volume": 0.46,
        "price": 3245,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -15.180000000000001,
        "priceIn": 3244.74,
        "doubleCheck": true
    },
    {
        "dataID": "114828",
        "id": "52958933",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 03:19:03",
        "brokerTime": "2025-05-14 03:19:04",
        "commission": -3.85,
        "swap": 0,
        "profit": -9.9,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "55955350",
        "positionId": "55955343",
        "volume": 0.55,
        "price": 3244.92,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -13.75,
        "priceIn": 3244.74,
        "doubleCheck": true
    },
    {
        "dataID": "114829",
        "id": "52958934",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 03:19:02",
        "brokerTime": "2025-05-14 03:19:04",
        "commission": -4.2,
        "swap": 0,
        "profit": -15.6,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "55955351",
        "positionId": "55955342",
        "volume": 0.6,
        "price": 3244.92,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -19.8,
        "priceIn": 3244.66,
        "doubleCheck": true
    },
    {
        "dataID": "114830",
        "id": "52958940",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 03:12:29",
        "brokerTime": "2025-05-14 03:19:28",
        "commission": -3.01,
        "swap": 0,
        "profit": -24.51,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "55955356",
        "positionId": "55955262",
        "volume": 0.43,
        "price": 3244.12,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3344.44,
        "brokerComment": "",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -27.520000000000003,
        "priceIn": 3244.69,
        "doubleCheck": true,
        "isShow": false,
        "collapseIndex": "0,1",
        "tProfit": -892.54,
        "tnProfit": -907.1,
        "tVolume": 2.08,
        "tTrades": 9
    },
    {
        "dataID": "114831",
        "id": "52958941",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 03:09:55",
        "brokerTime": "2025-05-14 03:19:28",
        "commission": -2.52,
        "swap": 0,
        "profit": -69.48,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "55955357",
        "positionId": "55954949",
        "volume": 0.36,
        "price": 3244.12,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3344.44,
        "brokerComment": "",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -72,
        "priceIn": 3246.05,
        "doubleCheck": true
    },
    {
        "dataID": "114832",
        "id": "52958942",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 03:06:02",
        "brokerTime": "2025-05-14 03:19:28",
        "commission": -2.1,
        "swap": 0,
        "profit": -88.5,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "55955358",
        "positionId": "55954912",
        "volume": 0.3,
        "price": 3244.12,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3344.44,
        "brokerComment": "",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -90.6,
        "priceIn": 3247.07,
        "doubleCheck": true
    },
    {
        "dataID": "114833",
        "id": "52958943",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 03:03:37",
        "brokerTime": "2025-05-14 03:19:28",
        "commission": -0.7,
        "swap": 0,
        "profit": 48,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "55955359",
        "positionId": "55954741",
        "volume": 0.1,
        "price": 3244.38,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "RR",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 47.3,
        "priceIn": 3249.18,
        "doubleCheck": true
    },
    {
        "dataID": "114834",
        "id": "52958944",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 03:03:00",
        "brokerTime": "2025-05-14 03:19:28",
        "commission": -1.75,
        "swap": 0,
        "profit": -100.75,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "55955360",
        "positionId": "55954602",
        "volume": 0.25,
        "price": 3244.12,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3344.44,
        "brokerComment": "",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -102.5,
        "priceIn": 3248.15,
        "doubleCheck": true
    },
    {
        "dataID": "114835",
        "id": "52958945",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 03:02:00",
        "brokerTime": "2025-05-14 03:19:28",
        "commission": -1.47,
        "swap": 0,
        "profit": -134.19,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "55955361",
        "positionId": "55954479",
        "volume": 0.21,
        "price": 3244.12,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3344.44,
        "brokerComment": "",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -135.66,
        "priceIn": 3250.51,
        "doubleCheck": true
    },
    {
        "dataID": "114836",
        "id": "52958946",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 03:01:27",
        "brokerTime": "2025-05-14 03:19:28",
        "commission": -1.19,
        "swap": 0,
        "profit": -130.39,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "55955362",
        "positionId": "55954454",
        "volume": 0.17,
        "price": 3244.12,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3344.44,
        "brokerComment": "",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -131.57999999999998,
        "priceIn": 3251.79,
        "doubleCheck": true
    },
    {
        "dataID": "114837",
        "id": "52958947",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 02:39:37",
        "brokerTime": "2025-05-14 03:19:28",
        "commission": -0.98,
        "swap": 0,
        "profit": -121.38,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "55955363",
        "positionId": "55952845",
        "volume": 0.14,
        "price": 3244.12,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3344.44,
        "brokerComment": "",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -122.36,
        "priceIn": 3252.79,
        "doubleCheck": true
    },
    {
        "dataID": "114838",
        "id": "52958948",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 02:37:05",
        "brokerTime": "2025-05-14 03:19:28",
        "commission": -0.84,
        "swap": 0,
        "profit": -116.04,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "55955364",
        "positionId": "55952731",
        "volume": 0.12,
        "price": 3244.12,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3344.44,
        "brokerComment": "",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -116.88000000000001,
        "priceIn": 3253.79,
        "doubleCheck": true
    },
    {
        "dataID": "114839",
        "id": "52958949",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 02:27:42",
        "brokerTime": "2025-05-14 03:19:28",
        "commission": -0.7,
        "swap": 0,
        "profit": -107.3,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "55955365",
        "positionId": "55952702",
        "volume": 0.1,
        "price": 3244.12,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3344.44,
        "brokerComment": "",
        "comment": "Buy Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -108,
        "priceIn": 3254.85,
        "doubleCheck": true
    },
    {
        "dataID": "119657",
        "id": "53048709",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:38:35",
        "brokerTime": "2025-05-14 12:38:35",
        "commission": -0.7,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56022456",
        "positionId": "56022456",
        "volume": 0.1,
        "price": 3231.34,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3131.34,
        "brokerComment": "Sell Order",
        "comment": "Sell Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.7,
        "priceIn": 3231.34,
        "doubleCheck": true
    },
    {
        "dataID": "114842",
        "id": "53048710",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 12:38:36",
        "brokerTime": "2025-05-14 12:38:36",
        "commission": -0.7,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56022457",
        "positionId": "56022457",
        "volume": 0.1,
        "price": 3231.55,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3331.55,
        "brokerComment": "Buy Order",
        "comment": "Buy Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.7,
        "priceIn": 3231.55,
        "doubleCheck": true
    },
    {
        "dataID": "114843",
        "id": "53048711",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 12:38:38",
        "brokerTime": "2025-05-14 12:38:38",
        "commission": -0.84,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56022458",
        "positionId": "56022458",
        "volume": 0.12,
        "price": 3231.4,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3331.35,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.84,
        "priceIn": 3231.4,
        "doubleCheck": true
    },
    {
        "dataID": "114844",
        "id": "53048755",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 12:39:02",
        "brokerTime": "2025-05-14 12:39:02",
        "commission": -0.98,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56022496",
        "positionId": "56022496",
        "volume": 0.14,
        "price": 3231.29,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3331.29,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.98,
        "priceIn": 3231.29,
        "doubleCheck": true
    },
    {
        "dataID": "114845",
        "id": "53048756",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:39:02",
        "brokerTime": "2025-05-14 12:39:02",
        "commission": -2.31,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56022497",
        "positionId": "56022497",
        "volume": 0.33,
        "price": 3231.09,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -2.31,
        "priceIn": 3231.09,
        "doubleCheck": true
    },
    {
        "dataID": "114846",
        "id": "53048857",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:39:02",
        "brokerTime": "2025-05-14 12:42:28",
        "commission": -2.31,
        "swap": 0,
        "profit": -37.62,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56022575",
        "positionId": "56022497",
        "volume": 0.33,
        "price": 3232.23,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -39.93,
        "priceIn": 3231.09,
        "doubleCheck": true,
        "isShow": false,
        "collapseIndex": "0,1,2,3,4",
        "tProfit": -49.92,
        "tnProfit": -52.93,
        "tVolume": 0.43000000000000005,
        "tTrades": 2
    },
    {
        "dataID": "114847",
        "id": "53048858",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 12:39:02",
        "brokerTime": "2025-05-14 12:42:28",
        "commission": -0.98,
        "swap": 0,
        "profit": 10.5,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56022576",
        "positionId": "56022496",
        "volume": 0.14,
        "price": 3232.04,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3331.08,
        "brokerComment": "",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 9.52,
        "priceIn": 3231.29,
        "doubleCheck": true,
        "isShow": false,
        "collapseIndex": "0,1,2,3",
        "tProfit": 27.34,
        "tnProfit": 24.82,
        "tVolume": 0.36,
        "tTrades": 3
    },
    {
        "dataID": "114848",
        "id": "53048859",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 12:38:38",
        "brokerTime": "2025-05-14 12:42:28",
        "commission": -0.84,
        "swap": 0,
        "profit": 9.84,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56022577",
        "positionId": "56022458",
        "volume": 0.12,
        "price": 3232.22,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3331.08,
        "brokerComment": "",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 9,
        "priceIn": 3231.4,
        "doubleCheck": true
    },
    {
        "dataID": "114849",
        "id": "53048860",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 12:38:36",
        "brokerTime": "2025-05-14 12:42:28",
        "commission": -0.7,
        "swap": 0,
        "profit": 7,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56022578",
        "positionId": "56022457",
        "volume": 0.1,
        "price": 3232.25,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3331.08,
        "brokerComment": "",
        "comment": "Buy Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 6.3,
        "priceIn": 3231.55,
        "doubleCheck": true
    },
    {
        "dataID": "114850",
        "id": "53048861",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:38:35",
        "brokerTime": "2025-05-14 12:42:28",
        "commission": -0.7,
        "swap": 0,
        "profit": -12.3,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56022579",
        "positionId": "56022456",
        "volume": 0.1,
        "price": 3232.57,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3131.54,
        "brokerComment": "",
        "comment": "Sell Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -13,
        "priceIn": 3231.34,
        "doubleCheck": true
    },
    {
        "dataID": "114851",
        "id": "53049699",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 12:46:57",
        "brokerTime": "2025-05-14 12:46:57",
        "commission": -0.7,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56023253",
        "positionId": "56023253",
        "volume": 0.1,
        "price": 3234.49,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3334.49,
        "brokerComment": "Buy Order",
        "comment": "Buy Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.7,
        "priceIn": 3234.49,
        "doubleCheck": true
    },
    {
        "dataID": "114852",
        "id": "53049702",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:46:58",
        "brokerTime": "2025-05-14 12:46:58",
        "commission": -0.7,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56023255",
        "positionId": "56023255",
        "volume": 0.1,
        "price": 3234.24,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3134.24,
        "brokerComment": "Sell Order",
        "comment": "Sell Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.7,
        "priceIn": 3234.24,
        "doubleCheck": true
    },
    {
        "dataID": "114853",
        "id": "53049703",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:47:01",
        "brokerTime": "2025-05-14 12:47:01",
        "commission": -0.84,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56023256",
        "positionId": "56023256",
        "volume": 0.12,
        "price": 3234.4,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3134.38,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.84,
        "priceIn": 3234.4,
        "doubleCheck": true
    },
    {
        "dataID": "114854",
        "id": "53049740",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:48:00",
        "brokerTime": "2025-05-14 12:48:00",
        "commission": -0.98,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56023291",
        "positionId": "56023291",
        "volume": 0.14,
        "price": 3235.14,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3135.14,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.98,
        "priceIn": 3235.14,
        "doubleCheck": true
    },
    {
        "dataID": "114855",
        "id": "53049743",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 12:48:01",
        "brokerTime": "2025-05-14 12:48:01",
        "commission": -2.31,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56023294",
        "positionId": "56023294",
        "volume": 0.33,
        "price": 3235.38,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -2.31,
        "priceIn": 3235.38,
        "doubleCheck": true
    },
    {
        "dataID": "114856",
        "id": "53049766",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 12:48:01",
        "brokerTime": "2025-05-14 12:49:00",
        "commission": -2.31,
        "swap": 0,
        "profit": -2.31,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56023315",
        "positionId": "56023294",
        "volume": 0.33,
        "price": 3235.31,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -4.62,
        "priceIn": 3235.38,
        "doubleCheck": true,
        "isShow": false,
        "collapseIndex": "0,1,2,3,4,5",
        "tProfit": 6.39,
        "tnProfit": 3.38,
        "tVolume": 0.43000000000000005,
        "tTrades": 2
    },
    {
        "dataID": "114857",
        "id": "53049767",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:48:00",
        "brokerTime": "2025-05-14 12:49:00",
        "commission": -0.98,
        "swap": 0,
        "profit": -5.04,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56023316",
        "positionId": "56023291",
        "volume": 0.14,
        "price": 3235.5,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3135.33,
        "brokerComment": "",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -6.02,
        "priceIn": 3235.14,
        "doubleCheck": true,
        "isShow": false,
        "collapseIndex": "0,1,2,3,4,5,6",
        "tProfit": -31.82,
        "tnProfit": -34.34,
        "tVolume": 0.36,
        "tTrades": 3
    },
    {
        "dataID": "114858",
        "id": "53049768",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:47:01",
        "brokerTime": "2025-05-14 12:49:00",
        "commission": -0.84,
        "swap": 0,
        "profit": -13.68,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56023317",
        "positionId": "56023256",
        "volume": 0.12,
        "price": 3235.54,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3135.38,
        "brokerComment": "",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -14.52,
        "priceIn": 3234.4,
        "doubleCheck": true
    },
    {
        "dataID": "114859",
        "id": "53049769",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:46:58",
        "brokerTime": "2025-05-14 12:49:00",
        "commission": -0.7,
        "swap": 0,
        "profit": -13.1,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56023318",
        "positionId": "56023255",
        "volume": 0.1,
        "price": 3235.55,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3135.38,
        "brokerComment": "",
        "comment": "Sell Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -13.799999999999999,
        "priceIn": 3234.24,
        "doubleCheck": true
    },
    {
        "dataID": "114860",
        "id": "53049770",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 12:46:57",
        "brokerTime": "2025-05-14 12:49:00",
        "commission": -0.7,
        "swap": 0,
        "profit": 8.7,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56023319",
        "positionId": "56023253",
        "volume": 0.1,
        "price": 3235.36,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3334.29,
        "brokerComment": "",
        "comment": "Buy Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 7.999999999999999,
        "priceIn": 3234.49,
        "doubleCheck": true
    },
    {
        "dataID": "114861",
        "id": "53049778",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 12:49:21",
        "brokerTime": "2025-05-14 12:49:21",
        "commission": -0.7,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56023326",
        "positionId": "56023326",
        "volume": 0.1,
        "price": 3235.75,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3335.75,
        "brokerComment": "Buy Order",
        "comment": "Buy Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.7,
        "priceIn": 3235.75,
        "doubleCheck": true
    },
    {
        "dataID": "114862",
        "id": "53049779",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:49:21",
        "brokerTime": "2025-05-14 12:49:21",
        "commission": -0.7,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56023327",
        "positionId": "56023327",
        "volume": 0.1,
        "price": 3235.62,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3135.61,
        "brokerComment": "Sell Order",
        "comment": "Sell Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.7,
        "priceIn": 3235.62,
        "doubleCheck": true
    },
    {
        "dataID": "114863",
        "id": "53049781",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 12:49:24",
        "brokerTime": "2025-05-14 12:49:24",
        "commission": -0.84,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56023329",
        "positionId": "56023329",
        "volume": 0.12,
        "price": 3235.59,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3335.59,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.84,
        "priceIn": 3235.59,
        "doubleCheck": true
    },
    {
        "dataID": "114864",
        "id": "53050132",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:50:00",
        "brokerTime": "2025-05-14 12:50:00",
        "commission": -0.84,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56023584",
        "positionId": "56023584",
        "volume": 0.12,
        "price": 3235.96,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3135.96,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.84,
        "priceIn": 3235.96,
        "doubleCheck": true
    },
    {
        "dataID": "114865",
        "id": "53050859",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 12:51:00",
        "brokerTime": "2025-05-14 12:51:00",
        "commission": -0.98,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024047",
        "positionId": "56024047",
        "volume": 0.14,
        "price": 3235.38,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3335.41,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.98,
        "priceIn": 3235.38,
        "doubleCheck": true
    },
    {
        "dataID": "114866",
        "id": "53050860",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:01",
        "brokerTime": "2025-05-14 12:51:01",
        "commission": -1.47,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024048",
        "positionId": "56024048",
        "volume": 0.21,
        "price": 3235.2,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -1.47,
        "priceIn": 3235.2,
        "doubleCheck": true
    },
    {
        "dataID": "114867",
        "id": "53050869",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:01",
        "brokerTime": "2025-05-14 12:51:01",
        "commission": -1.47,
        "swap": 0,
        "profit": -3.99,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024053",
        "positionId": "56024048",
        "volume": 0.21,
        "price": 3235.39,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -5.46,
        "priceIn": 3235.2,
        "doubleCheck": true,
        "isShow": false,
        "collapseIndex": "0,1,2,3,4,5,6,7,8",
        "tProfit": -491.29,
        "tnProfit": -694.22,
        "tVolume": 28.990000000000066,
        "tTrades": 98
    },
    {
        "dataID": "114868",
        "id": "53050870",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:02",
        "brokerTime": "2025-05-14 12:51:02",
        "commission": -1.47,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024054",
        "positionId": "56024054",
        "volume": 0.21,
        "price": 3235.14,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -1.47,
        "priceIn": 3235.14,
        "doubleCheck": true
    },
    {
        "dataID": "114869",
        "id": "53050871",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:02",
        "brokerTime": "2025-05-14 12:51:02",
        "commission": -1.47,
        "swap": 0,
        "profit": -3.78,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024055",
        "positionId": "56024054",
        "volume": 0.21,
        "price": 3235.32,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -5.25,
        "priceIn": 3235.14,
        "doubleCheck": true
    },
    {
        "dataID": "114870",
        "id": "53050873",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:02",
        "brokerTime": "2025-05-14 12:51:02",
        "commission": -1.47,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024059",
        "positionId": "56024059",
        "volume": 0.21,
        "price": 3235.17,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -1.47,
        "priceIn": 3235.17,
        "doubleCheck": true
    },
    {
        "dataID": "114871",
        "id": "53050899",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:02",
        "brokerTime": "2025-05-14 12:51:03",
        "commission": -1.47,
        "swap": 0,
        "profit": -4.2,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024085",
        "positionId": "56024059",
        "volume": 0.21,
        "price": 3235.37,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -5.67,
        "priceIn": 3235.17,
        "doubleCheck": true
    },
    {
        "dataID": "114872",
        "id": "53050923",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:04",
        "brokerTime": "2025-05-14 12:51:04",
        "commission": -1.47,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024092",
        "positionId": "56024092",
        "volume": 0.21,
        "price": 3235,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -1.47,
        "priceIn": 3235,
        "doubleCheck": true
    },
    {
        "dataID": "114873",
        "id": "53050924",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:04",
        "brokerTime": "2025-05-14 12:51:05",
        "commission": -1.47,
        "swap": 0,
        "profit": -5.04,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024093",
        "positionId": "56024092",
        "volume": 0.21,
        "price": 3235.24,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -6.51,
        "priceIn": 3235,
        "doubleCheck": true
    },
    {
        "dataID": "114874",
        "id": "53050925",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:06",
        "brokerTime": "2025-05-14 12:51:06",
        "commission": -1.47,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024094",
        "positionId": "56024094",
        "volume": 0.21,
        "price": 3234.93,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -1.47,
        "priceIn": 3234.93,
        "doubleCheck": true
    },
    {
        "dataID": "114875",
        "id": "53050926",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:06",
        "brokerTime": "2025-05-14 12:51:07",
        "commission": -1.47,
        "swap": 0,
        "profit": -2.31,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024095",
        "positionId": "56024094",
        "volume": 0.21,
        "price": 3235.04,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -3.7800000000000002,
        "priceIn": 3234.93,
        "doubleCheck": true
    },
    {
        "dataID": "114876",
        "id": "53050927",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:07",
        "brokerTime": "2025-05-14 12:51:07",
        "commission": -1.47,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024096",
        "positionId": "56024096",
        "volume": 0.21,
        "price": 3234.75,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -1.47,
        "priceIn": 3234.75,
        "doubleCheck": true
    },
    {
        "dataID": "114877",
        "id": "53050928",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:07",
        "brokerTime": "2025-05-14 12:51:09",
        "commission": -1.47,
        "swap": 0,
        "profit": -4.83,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024097",
        "positionId": "56024096",
        "volume": 0.21,
        "price": 3234.98,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -6.3,
        "priceIn": 3234.75,
        "doubleCheck": true
    },
    {
        "dataID": "114878",
        "id": "53050929",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:09",
        "brokerTime": "2025-05-14 12:51:09",
        "commission": -1.47,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024098",
        "positionId": "56024098",
        "volume": 0.21,
        "price": 3234.75,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -1.47,
        "priceIn": 3234.75,
        "doubleCheck": true
    },
    {
        "dataID": "114879",
        "id": "53050930",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:09",
        "brokerTime": "2025-05-14 12:51:10",
        "commission": -1.47,
        "swap": 0,
        "profit": -3.99,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024099",
        "positionId": "56024098",
        "volume": 0.21,
        "price": 3234.94,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -5.46,
        "priceIn": 3234.75,
        "doubleCheck": true
    },
    {
        "dataID": "114880",
        "id": "53050931",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:12",
        "brokerTime": "2025-05-14 12:51:12",
        "commission": -1.47,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024100",
        "positionId": "56024100",
        "volume": 0.21,
        "price": 3234.53,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -1.47,
        "priceIn": 3234.53,
        "doubleCheck": true
    },
    {
        "dataID": "114881",
        "id": "53050932",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:12",
        "brokerTime": "2025-05-14 12:51:12",
        "commission": -1.47,
        "swap": 0,
        "profit": -4.41,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024101",
        "positionId": "56024100",
        "volume": 0.21,
        "price": 3234.74,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -5.88,
        "priceIn": 3234.53,
        "doubleCheck": true
    },
    {
        "dataID": "114882",
        "id": "53050933",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:12",
        "brokerTime": "2025-05-14 12:51:12",
        "commission": -1.47,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024102",
        "positionId": "56024102",
        "volume": 0.21,
        "price": 3234.51,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -1.47,
        "priceIn": 3234.51,
        "doubleCheck": true
    },
    {
        "dataID": "114883",
        "id": "53050934",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:12",
        "brokerTime": "2025-05-14 12:51:13",
        "commission": -1.47,
        "swap": 0,
        "profit": -5.88,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024103",
        "positionId": "56024102",
        "volume": 0.21,
        "price": 3234.79,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -7.35,
        "priceIn": 3234.51,
        "doubleCheck": true
    },
    {
        "dataID": "114884",
        "id": "53050935",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:13",
        "brokerTime": "2025-05-14 12:51:13",
        "commission": -1.47,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024104",
        "positionId": "56024104",
        "volume": 0.21,
        "price": 3234.55,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -1.47,
        "priceIn": 3234.55,
        "doubleCheck": true
    },
    {
        "dataID": "114885",
        "id": "53050936",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:13",
        "brokerTime": "2025-05-14 12:51:14",
        "commission": -1.47,
        "swap": 0,
        "profit": -2.31,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024105",
        "positionId": "56024104",
        "volume": 0.21,
        "price": 3234.66,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -3.7800000000000002,
        "priceIn": 3234.55,
        "doubleCheck": true
    },
    {
        "dataID": "114886",
        "id": "53050937",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:14",
        "brokerTime": "2025-05-14 12:51:14",
        "commission": -1.47,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024106",
        "positionId": "56024106",
        "volume": 0.21,
        "price": 3234.43,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -1.47,
        "priceIn": 3234.43,
        "doubleCheck": true
    },
    {
        "dataID": "114887",
        "id": "53050938",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:14",
        "brokerTime": "2025-05-14 12:51:14",
        "commission": -1.47,
        "swap": 0,
        "profit": -2.52,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024107",
        "positionId": "56024106",
        "volume": 0.21,
        "price": 3234.55,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -3.99,
        "priceIn": 3234.43,
        "doubleCheck": true
    },
    {
        "dataID": "114888",
        "id": "53050939",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:15",
        "brokerTime": "2025-05-14 12:51:15",
        "commission": -1.47,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024108",
        "positionId": "56024108",
        "volume": 0.21,
        "price": 3234.43,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -1.47,
        "priceIn": 3234.43,
        "doubleCheck": true
    },
    {
        "dataID": "114889",
        "id": "53050940",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:15",
        "brokerTime": "2025-05-14 12:51:15",
        "commission": -1.47,
        "swap": 0,
        "profit": -4.83,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024109",
        "positionId": "56024108",
        "volume": 0.21,
        "price": 3234.66,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -6.3,
        "priceIn": 3234.43,
        "doubleCheck": true
    },
    {
        "dataID": "114890",
        "id": "53050946",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:15",
        "brokerTime": "2025-05-14 12:51:15",
        "commission": -1.47,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024115",
        "positionId": "56024115",
        "volume": 0.21,
        "price": 3234.33,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -1.47,
        "priceIn": 3234.33,
        "doubleCheck": true
    },
    {
        "dataID": "114891",
        "id": "53050965",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:15",
        "brokerTime": "2025-05-14 12:51:16",
        "commission": -1.47,
        "swap": 0,
        "profit": -4.83,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024134",
        "positionId": "56024115",
        "volume": 0.21,
        "price": 3234.56,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -6.3,
        "priceIn": 3234.33,
        "doubleCheck": true
    },
    {
        "dataID": "114892",
        "id": "53050967",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:16",
        "brokerTime": "2025-05-14 12:51:16",
        "commission": -1.47,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024135",
        "positionId": "56024135",
        "volume": 0.21,
        "price": 3234.36,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -1.47,
        "priceIn": 3234.36,
        "doubleCheck": true
    },
    {
        "dataID": "114893",
        "id": "53050968",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:16",
        "brokerTime": "2025-05-14 12:51:18",
        "commission": -1.47,
        "swap": 0,
        "profit": -3.78,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024136",
        "positionId": "56024135",
        "volume": 0.21,
        "price": 3234.54,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -5.25,
        "priceIn": 3234.36,
        "doubleCheck": true
    },
    {
        "dataID": "114894",
        "id": "53050969",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:18",
        "brokerTime": "2025-05-14 12:51:18",
        "commission": -1.47,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024137",
        "positionId": "56024137",
        "volume": 0.21,
        "price": 3234.37,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -1.47,
        "priceIn": 3234.37,
        "doubleCheck": true
    },
    {
        "dataID": "114895",
        "id": "53050971",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:18",
        "brokerTime": "2025-05-14 12:51:22",
        "commission": -1.47,
        "swap": 0,
        "profit": -4.2,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024139",
        "positionId": "56024137",
        "volume": 0.21,
        "price": 3234.57,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -5.67,
        "priceIn": 3234.37,
        "doubleCheck": true
    },
    {
        "dataID": "114896",
        "id": "53050972",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:22",
        "brokerTime": "2025-05-14 12:51:22",
        "commission": -1.47,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024140",
        "positionId": "56024140",
        "volume": 0.21,
        "price": 3234.26,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -1.47,
        "priceIn": 3234.26,
        "doubleCheck": true
    },
    {
        "dataID": "114897",
        "id": "53050973",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:22",
        "brokerTime": "2025-05-14 12:51:23",
        "commission": -1.47,
        "swap": 0,
        "profit": 2.52,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024141",
        "positionId": "56024140",
        "volume": 0.21,
        "price": 3234.14,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 1.05,
        "priceIn": 3234.26,
        "doubleCheck": true
    },
    {
        "dataID": "114898",
        "id": "53050974",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:23",
        "brokerTime": "2025-05-14 12:51:23",
        "commission": -1.47,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024142",
        "positionId": "56024142",
        "volume": 0.21,
        "price": 3233.95,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -1.47,
        "priceIn": 3233.95,
        "doubleCheck": true
    },
    {
        "dataID": "114899",
        "id": "53050975",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:23",
        "brokerTime": "2025-05-14 12:51:24",
        "commission": -1.47,
        "swap": 0,
        "profit": -5.67,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024143",
        "positionId": "56024142",
        "volume": 0.21,
        "price": 3234.22,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -7.14,
        "priceIn": 3233.95,
        "doubleCheck": true
    },
    {
        "dataID": "114900",
        "id": "53050976",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:24",
        "brokerTime": "2025-05-14 12:51:24",
        "commission": -1.47,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024144",
        "positionId": "56024144",
        "volume": 0.21,
        "price": 3234.03,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -1.47,
        "priceIn": 3234.03,
        "doubleCheck": true
    },
    {
        "dataID": "114901",
        "id": "53050979",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:24",
        "brokerTime": "2025-05-14 12:51:25",
        "commission": -1.47,
        "swap": 0,
        "profit": -2.94,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024146",
        "positionId": "56024144",
        "volume": 0.21,
        "price": 3234.17,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -4.41,
        "priceIn": 3234.03,
        "doubleCheck": true
    },
    {
        "dataID": "114902",
        "id": "53050980",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:25",
        "brokerTime": "2025-05-14 12:51:25",
        "commission": -1.47,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024147",
        "positionId": "56024147",
        "volume": 0.21,
        "price": 3233.92,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -1.47,
        "priceIn": 3233.92,
        "doubleCheck": true
    },
    {
        "dataID": "114903",
        "id": "53050981",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:25",
        "brokerTime": "2025-05-14 12:51:26",
        "commission": -1.47,
        "swap": 0,
        "profit": -4.62,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024148",
        "positionId": "56024147",
        "volume": 0.21,
        "price": 3234.14,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -6.09,
        "priceIn": 3233.92,
        "doubleCheck": true
    },
    {
        "dataID": "114904",
        "id": "53050982",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:26",
        "brokerTime": "2025-05-14 12:51:26",
        "commission": -1.47,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024149",
        "positionId": "56024149",
        "volume": 0.21,
        "price": 3233.99,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -1.47,
        "priceIn": 3233.99,
        "doubleCheck": true
    },
    {
        "dataID": "114905",
        "id": "53050983",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:26",
        "brokerTime": "2025-05-14 12:51:27",
        "commission": -1.47,
        "swap": 0,
        "profit": -6.3,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024150",
        "positionId": "56024149",
        "volume": 0.21,
        "price": 3234.29,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -7.77,
        "priceIn": 3233.99,
        "doubleCheck": true
    },
    {
        "dataID": "114906",
        "id": "53050984",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:27",
        "brokerTime": "2025-05-14 12:51:27",
        "commission": -1.47,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024151",
        "positionId": "56024151",
        "volume": 0.21,
        "price": 3234.08,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -1.47,
        "priceIn": 3234.08,
        "doubleCheck": true
    },
    {
        "dataID": "114907",
        "id": "53050985",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:27",
        "brokerTime": "2025-05-14 12:51:27",
        "commission": -1.47,
        "swap": 0,
        "profit": -4.41,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024152",
        "positionId": "56024151",
        "volume": 0.21,
        "price": 3234.29,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -5.88,
        "priceIn": 3234.08,
        "doubleCheck": true
    },
    {
        "dataID": "114908",
        "id": "53050986",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:27",
        "brokerTime": "2025-05-14 12:51:27",
        "commission": -1.47,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024153",
        "positionId": "56024153",
        "volume": 0.21,
        "price": 3234.21,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -1.47,
        "priceIn": 3234.21,
        "doubleCheck": true
    },
    {
        "dataID": "114909",
        "id": "53050987",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:27",
        "brokerTime": "2025-05-14 12:51:28",
        "commission": -1.47,
        "swap": 0,
        "profit": -4.83,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024154",
        "positionId": "56024153",
        "volume": 0.21,
        "price": 3234.44,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -6.3,
        "priceIn": 3234.21,
        "doubleCheck": true
    },
    {
        "dataID": "114910",
        "id": "53050988",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:28",
        "brokerTime": "2025-05-14 12:51:28",
        "commission": -1.47,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024155",
        "positionId": "56024155",
        "volume": 0.21,
        "price": 3234.23,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -1.47,
        "priceIn": 3234.23,
        "doubleCheck": true
    },
    {
        "dataID": "114911",
        "id": "53050989",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:28",
        "brokerTime": "2025-05-14 12:51:29",
        "commission": -1.47,
        "swap": 0,
        "profit": -8.4,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024156",
        "positionId": "56024155",
        "volume": 0.21,
        "price": 3234.63,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -9.870000000000001,
        "priceIn": 3234.23,
        "doubleCheck": true
    },
    {
        "dataID": "114912",
        "id": "53050990",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:29",
        "brokerTime": "2025-05-14 12:51:29",
        "commission": -1.47,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024157",
        "positionId": "56024157",
        "volume": 0.21,
        "price": 3234.29,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -1.47,
        "priceIn": 3234.29,
        "doubleCheck": true
    },
    {
        "dataID": "114913",
        "id": "53050991",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:29",
        "brokerTime": "2025-05-14 12:51:29",
        "commission": -1.47,
        "swap": 0,
        "profit": -3.57,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024158",
        "positionId": "56024157",
        "volume": 0.21,
        "price": 3234.46,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -5.04,
        "priceIn": 3234.29,
        "doubleCheck": true
    },
    {
        "dataID": "114914",
        "id": "53050992",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:30",
        "brokerTime": "2025-05-14 12:51:30",
        "commission": -1.47,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024159",
        "positionId": "56024159",
        "volume": 0.21,
        "price": 3234.22,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -1.47,
        "priceIn": 3234.22,
        "doubleCheck": true
    },
    {
        "dataID": "114915",
        "id": "53050993",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:30",
        "brokerTime": "2025-05-14 12:51:30",
        "commission": -1.47,
        "swap": 0,
        "profit": -2.73,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024160",
        "positionId": "56024159",
        "volume": 0.21,
        "price": 3234.35,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -4.2,
        "priceIn": 3234.22,
        "doubleCheck": true
    },
    {
        "dataID": "114916",
        "id": "53050994",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:30",
        "brokerTime": "2025-05-14 12:51:30",
        "commission": -1.47,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024161",
        "positionId": "56024161",
        "volume": 0.21,
        "price": 3234.19,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -1.47,
        "priceIn": 3234.19,
        "doubleCheck": true
    },
    {
        "dataID": "114917",
        "id": "53050995",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:30",
        "brokerTime": "2025-05-14 12:51:31",
        "commission": -1.47,
        "swap": 0,
        "profit": -4.62,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024162",
        "positionId": "56024161",
        "volume": 0.21,
        "price": 3234.41,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -6.09,
        "priceIn": 3234.19,
        "doubleCheck": true
    },
    {
        "dataID": "114918",
        "id": "53050996",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:31",
        "brokerTime": "2025-05-14 12:51:31",
        "commission": -1.47,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024163",
        "positionId": "56024163",
        "volume": 0.21,
        "price": 3234.18,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -1.47,
        "priceIn": 3234.18,
        "doubleCheck": true
    },
    {
        "dataID": "114919",
        "id": "53050997",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:31",
        "brokerTime": "2025-05-14 12:51:32",
        "commission": -1.47,
        "swap": 0,
        "profit": -4.62,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024164",
        "positionId": "56024163",
        "volume": 0.21,
        "price": 3234.4,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -6.09,
        "priceIn": 3234.18,
        "doubleCheck": true
    },
    {
        "dataID": "114920",
        "id": "53050998",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:32",
        "brokerTime": "2025-05-14 12:51:32",
        "commission": -1.47,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024165",
        "positionId": "56024165",
        "volume": 0.21,
        "price": 3234.14,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -1.47,
        "priceIn": 3234.14,
        "doubleCheck": true
    },
    {
        "dataID": "114921",
        "id": "53050999",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:32",
        "brokerTime": "2025-05-14 12:51:33",
        "commission": -1.47,
        "swap": 0,
        "profit": -5.46,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024166",
        "positionId": "56024165",
        "volume": 0.21,
        "price": 3234.4,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -6.93,
        "priceIn": 3234.14,
        "doubleCheck": true
    },
    {
        "dataID": "114922",
        "id": "53051000",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:33",
        "brokerTime": "2025-05-14 12:51:33",
        "commission": -1.47,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024167",
        "positionId": "56024167",
        "volume": 0.21,
        "price": 3234.18,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -1.47,
        "priceIn": 3234.18,
        "doubleCheck": true
    },
    {
        "dataID": "114923",
        "id": "53051001",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:33",
        "brokerTime": "2025-05-14 12:51:33",
        "commission": -1.47,
        "swap": 0,
        "profit": -3.57,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024168",
        "positionId": "56024167",
        "volume": 0.21,
        "price": 3234.35,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -5.04,
        "priceIn": 3234.18,
        "doubleCheck": true
    },
    {
        "dataID": "114924",
        "id": "53051002",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:35",
        "brokerTime": "2025-05-14 12:51:35",
        "commission": -1.47,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024169",
        "positionId": "56024169",
        "volume": 0.21,
        "price": 3234.15,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -1.47,
        "priceIn": 3234.15,
        "doubleCheck": true
    },
    {
        "dataID": "114925",
        "id": "53051003",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:35",
        "brokerTime": "2025-05-14 12:51:36",
        "commission": -1.47,
        "swap": 0,
        "profit": -11.97,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024170",
        "positionId": "56024169",
        "volume": 0.21,
        "price": 3234.72,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -13.440000000000001,
        "priceIn": 3234.15,
        "doubleCheck": true
    },
    {
        "dataID": "114926",
        "id": "53051004",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:36",
        "brokerTime": "2025-05-14 12:51:36",
        "commission": -1.47,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024171",
        "positionId": "56024171",
        "volume": 0.21,
        "price": 3234.5,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -1.47,
        "priceIn": 3234.5,
        "doubleCheck": true
    },
    {
        "dataID": "114927",
        "id": "53051005",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:36",
        "brokerTime": "2025-05-14 12:51:36",
        "commission": -1.47,
        "swap": 0,
        "profit": -2.94,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024172",
        "positionId": "56024171",
        "volume": 0.21,
        "price": 3234.64,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -4.41,
        "priceIn": 3234.5,
        "doubleCheck": true
    },
    {
        "dataID": "114928",
        "id": "53051006",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:37",
        "brokerTime": "2025-05-14 12:51:37",
        "commission": -1.47,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024173",
        "positionId": "56024173",
        "volume": 0.21,
        "price": 3234.39,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -1.47,
        "priceIn": 3234.39,
        "doubleCheck": true
    },
    {
        "dataID": "114929",
        "id": "53051007",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:37",
        "brokerTime": "2025-05-14 12:51:37",
        "commission": -1.47,
        "swap": 0,
        "profit": -5.67,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024174",
        "positionId": "56024173",
        "volume": 0.21,
        "price": 3234.66,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -7.14,
        "priceIn": 3234.39,
        "doubleCheck": true
    },
    {
        "dataID": "114930",
        "id": "53051008",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:37",
        "brokerTime": "2025-05-14 12:51:37",
        "commission": -1.47,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024175",
        "positionId": "56024175",
        "volume": 0.21,
        "price": 3234.45,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -1.47,
        "priceIn": 3234.45,
        "doubleCheck": true
    },
    {
        "dataID": "114931",
        "id": "53051009",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:37",
        "brokerTime": "2025-05-14 12:51:38",
        "commission": -1.47,
        "swap": 0,
        "profit": -5.25,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024176",
        "positionId": "56024175",
        "volume": 0.21,
        "price": 3234.7,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -6.72,
        "priceIn": 3234.45,
        "doubleCheck": true
    },
    {
        "dataID": "114932",
        "id": "53051010",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:39",
        "brokerTime": "2025-05-14 12:51:39",
        "commission": -1.47,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024177",
        "positionId": "56024177",
        "volume": 0.21,
        "price": 3234.47,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -1.47,
        "priceIn": 3234.47,
        "doubleCheck": true
    },
    {
        "dataID": "114933",
        "id": "53051011",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:39",
        "brokerTime": "2025-05-14 12:51:41",
        "commission": -1.47,
        "swap": 0,
        "profit": -4.83,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024178",
        "positionId": "56024177",
        "volume": 0.21,
        "price": 3234.7,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -6.3,
        "priceIn": 3234.47,
        "doubleCheck": true
    },
    {
        "dataID": "114934",
        "id": "53051012",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:41",
        "brokerTime": "2025-05-14 12:51:41",
        "commission": -1.47,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024179",
        "positionId": "56024179",
        "volume": 0.21,
        "price": 3234.84,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -1.47,
        "priceIn": 3234.84,
        "doubleCheck": true
    },
    {
        "dataID": "114935",
        "id": "53051013",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:41",
        "brokerTime": "2025-05-14 12:51:42",
        "commission": -1.47,
        "swap": 0,
        "profit": -6.72,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024180",
        "positionId": "56024179",
        "volume": 0.21,
        "price": 3235.16,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -8.19,
        "priceIn": 3234.84,
        "doubleCheck": true
    },
    {
        "dataID": "114936",
        "id": "53051014",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:42",
        "brokerTime": "2025-05-14 12:51:42",
        "commission": -1.47,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024181",
        "positionId": "56024181",
        "volume": 0.21,
        "price": 3234.96,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -1.47,
        "priceIn": 3234.96,
        "doubleCheck": true
    },
    {
        "dataID": "114937",
        "id": "53051015",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:42",
        "brokerTime": "2025-05-14 12:51:43",
        "commission": -1.47,
        "swap": 0,
        "profit": -4.62,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024182",
        "positionId": "56024181",
        "volume": 0.21,
        "price": 3235.18,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -6.09,
        "priceIn": 3234.96,
        "doubleCheck": true
    },
    {
        "dataID": "114938",
        "id": "53051016",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:46",
        "brokerTime": "2025-05-14 12:51:46",
        "commission": -1.47,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024183",
        "positionId": "56024183",
        "volume": 0.21,
        "price": 3234.95,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -1.47,
        "priceIn": 3234.95,
        "doubleCheck": true
    },
    {
        "dataID": "114939",
        "id": "53051017",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:46",
        "brokerTime": "2025-05-14 12:51:46",
        "commission": -1.47,
        "swap": 0,
        "profit": -3.78,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024184",
        "positionId": "56024183",
        "volume": 0.21,
        "price": 3235.13,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -5.25,
        "priceIn": 3234.95,
        "doubleCheck": true
    },
    {
        "dataID": "114940",
        "id": "53051018",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:46",
        "brokerTime": "2025-05-14 12:51:46",
        "commission": -1.47,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024185",
        "positionId": "56024185",
        "volume": 0.21,
        "price": 3234.93,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -1.47,
        "priceIn": 3234.93,
        "doubleCheck": true
    },
    {
        "dataID": "114941",
        "id": "53051019",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:46",
        "brokerTime": "2025-05-14 12:51:47",
        "commission": -1.47,
        "swap": 0,
        "profit": -4.2,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024186",
        "positionId": "56024185",
        "volume": 0.21,
        "price": 3235.13,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -5.67,
        "priceIn": 3234.93,
        "doubleCheck": true
    },
    {
        "dataID": "114942",
        "id": "53051020",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:47",
        "brokerTime": "2025-05-14 12:51:47",
        "commission": -1.47,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024187",
        "positionId": "56024187",
        "volume": 0.21,
        "price": 3234.82,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -1.47,
        "priceIn": 3234.82,
        "doubleCheck": true
    },
    {
        "dataID": "114943",
        "id": "53051021",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:47",
        "brokerTime": "2025-05-14 12:51:47",
        "commission": -1.47,
        "swap": 0,
        "profit": -9.24,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024188",
        "positionId": "56024187",
        "volume": 0.21,
        "price": 3235.26,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -10.71,
        "priceIn": 3234.82,
        "doubleCheck": true
    },
    {
        "dataID": "114944",
        "id": "53051022",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:48",
        "brokerTime": "2025-05-14 12:51:48",
        "commission": -1.47,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024189",
        "positionId": "56024189",
        "volume": 0.21,
        "price": 3234.98,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -1.47,
        "priceIn": 3234.98,
        "doubleCheck": true
    },
    {
        "dataID": "114945",
        "id": "53051023",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:48",
        "brokerTime": "2025-05-14 12:51:49",
        "commission": -1.47,
        "swap": 0,
        "profit": -5.04,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024190",
        "positionId": "56024189",
        "volume": 0.21,
        "price": 3235.22,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -6.51,
        "priceIn": 3234.98,
        "doubleCheck": true
    },
    {
        "dataID": "114946",
        "id": "53051024",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:49",
        "brokerTime": "2025-05-14 12:51:49",
        "commission": -1.47,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024191",
        "positionId": "56024191",
        "volume": 0.21,
        "price": 3235.04,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -1.47,
        "priceIn": 3235.04,
        "doubleCheck": true
    },
    {
        "dataID": "114947",
        "id": "53051025",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:49",
        "brokerTime": "2025-05-14 12:51:50",
        "commission": -1.47,
        "swap": 0,
        "profit": -2.73,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024192",
        "positionId": "56024191",
        "volume": 0.21,
        "price": 3235.17,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -4.2,
        "priceIn": 3235.04,
        "doubleCheck": true
    },
    {
        "dataID": "114948",
        "id": "53051026",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:50",
        "brokerTime": "2025-05-14 12:51:50",
        "commission": -1.47,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024193",
        "positionId": "56024193",
        "volume": 0.21,
        "price": 3234.94,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -1.47,
        "priceIn": 3234.94,
        "doubleCheck": true
    },
    {
        "dataID": "114949",
        "id": "53051027",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:50",
        "brokerTime": "2025-05-14 12:51:51",
        "commission": -1.47,
        "swap": 0,
        "profit": -4.62,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024194",
        "positionId": "56024193",
        "volume": 0.21,
        "price": 3235.16,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -6.09,
        "priceIn": 3234.94,
        "doubleCheck": true
    },
    {
        "dataID": "114950",
        "id": "53051028",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:52",
        "brokerTime": "2025-05-14 12:51:52",
        "commission": -1.47,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024195",
        "positionId": "56024195",
        "volume": 0.21,
        "price": 3235.36,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -1.47,
        "priceIn": 3235.36,
        "doubleCheck": true
    },
    {
        "dataID": "114951",
        "id": "53051030",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:52",
        "brokerTime": "2025-05-14 12:51:52",
        "commission": -1.47,
        "swap": 0,
        "profit": -3.78,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024197",
        "positionId": "56024195",
        "volume": 0.21,
        "price": 3235.54,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -5.25,
        "priceIn": 3235.36,
        "doubleCheck": true
    },
    {
        "dataID": "114952",
        "id": "53051031",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:52",
        "brokerTime": "2025-05-14 12:51:52",
        "commission": -1.47,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024198",
        "positionId": "56024198",
        "volume": 0.21,
        "price": 3235.31,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -1.47,
        "priceIn": 3235.31,
        "doubleCheck": true
    },
    {
        "dataID": "114953",
        "id": "53051032",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:52",
        "brokerTime": "2025-05-14 12:51:53",
        "commission": -1.47,
        "swap": 0,
        "profit": -3.15,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024199",
        "positionId": "56024198",
        "volume": 0.21,
        "price": 3235.46,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -4.62,
        "priceIn": 3235.31,
        "doubleCheck": true
    },
    {
        "dataID": "114954",
        "id": "53051033",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:53",
        "brokerTime": "2025-05-14 12:51:53",
        "commission": -1.47,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024200",
        "positionId": "56024200",
        "volume": 0.21,
        "price": 3235.22,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -1.47,
        "priceIn": 3235.22,
        "doubleCheck": true
    },
    {
        "dataID": "114955",
        "id": "53051034",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:53",
        "brokerTime": "2025-05-14 12:51:54",
        "commission": -1.47,
        "swap": 0,
        "profit": -5.04,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024201",
        "positionId": "56024200",
        "volume": 0.21,
        "price": 3235.46,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -6.51,
        "priceIn": 3235.22,
        "doubleCheck": true
    },
    {
        "dataID": "114956",
        "id": "53051036",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:55",
        "brokerTime": "2025-05-14 12:51:55",
        "commission": -1.47,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024203",
        "positionId": "56024203",
        "volume": 0.21,
        "price": 3235.23,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -1.47,
        "priceIn": 3235.23,
        "doubleCheck": true
    },
    {
        "dataID": "114957",
        "id": "53051037",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:55",
        "brokerTime": "2025-05-14 12:51:56",
        "commission": -1.47,
        "swap": 0,
        "profit": -5.88,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024204",
        "positionId": "56024203",
        "volume": 0.21,
        "price": 3235.51,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -7.35,
        "priceIn": 3235.23,
        "doubleCheck": true
    },
    {
        "dataID": "114958",
        "id": "53051038",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:56",
        "brokerTime": "2025-05-14 12:51:56",
        "commission": -1.47,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024205",
        "positionId": "56024205",
        "volume": 0.21,
        "price": 3235.34,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -1.47,
        "priceIn": 3235.34,
        "doubleCheck": true
    },
    {
        "dataID": "114959",
        "id": "53051039",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:56",
        "brokerTime": "2025-05-14 12:51:56",
        "commission": -1.47,
        "swap": 0,
        "profit": -3.99,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024206",
        "positionId": "56024205",
        "volume": 0.21,
        "price": 3235.53,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -5.46,
        "priceIn": 3235.34,
        "doubleCheck": true
    },
    {
        "dataID": "114960",
        "id": "53051040",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:57",
        "brokerTime": "2025-05-14 12:51:57",
        "commission": -1.47,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024207",
        "positionId": "56024207",
        "volume": 0.21,
        "price": 3235.33,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -1.47,
        "priceIn": 3235.33,
        "doubleCheck": true
    },
    {
        "dataID": "114961",
        "id": "53051041",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:57",
        "brokerTime": "2025-05-14 12:51:57",
        "commission": -1.47,
        "swap": 0,
        "profit": -4.62,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024208",
        "positionId": "56024207",
        "volume": 0.21,
        "price": 3235.55,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -6.09,
        "priceIn": 3235.33,
        "doubleCheck": true
    },
    {
        "dataID": "114962",
        "id": "53051042",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:58",
        "brokerTime": "2025-05-14 12:51:58",
        "commission": -1.47,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024209",
        "positionId": "56024209",
        "volume": 0.21,
        "price": 3235.33,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -1.47,
        "priceIn": 3235.33,
        "doubleCheck": true
    },
    {
        "dataID": "114963",
        "id": "53051043",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:58",
        "brokerTime": "2025-05-14 12:51:58",
        "commission": -1.47,
        "swap": 0,
        "profit": -6.93,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024210",
        "positionId": "56024209",
        "volume": 0.21,
        "price": 3235.66,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -8.4,
        "priceIn": 3235.33,
        "doubleCheck": true
    },
    {
        "dataID": "114964",
        "id": "53051044",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:58",
        "brokerTime": "2025-05-14 12:51:58",
        "commission": -1.47,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024211",
        "positionId": "56024211",
        "volume": 0.21,
        "price": 3235.46,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -1.47,
        "priceIn": 3235.46,
        "doubleCheck": true
    },
    {
        "dataID": "114965",
        "id": "53051045",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:58",
        "brokerTime": "2025-05-14 12:51:59",
        "commission": -1.47,
        "swap": 0,
        "profit": -3.78,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024212",
        "positionId": "56024211",
        "volume": 0.21,
        "price": 3235.64,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -5.25,
        "priceIn": 3235.46,
        "doubleCheck": true
    },
    {
        "dataID": "114966",
        "id": "53051046",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:59",
        "brokerTime": "2025-05-14 12:51:59",
        "commission": -1.47,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024213",
        "positionId": "56024213",
        "volume": 0.21,
        "price": 3235.45,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -1.47,
        "priceIn": 3235.45,
        "doubleCheck": true
    },
    {
        "dataID": "114967",
        "id": "53051047",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:59",
        "brokerTime": "2025-05-14 12:52:00",
        "commission": -1.47,
        "swap": 0,
        "profit": -3.36,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024214",
        "positionId": "56024213",
        "volume": 0.21,
        "price": 3235.61,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -4.83,
        "priceIn": 3235.45,
        "doubleCheck": true
    },
    {
        "dataID": "114968",
        "id": "53051048",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:00",
        "brokerTime": "2025-05-14 12:52:00",
        "commission": -1.47,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024215",
        "positionId": "56024215",
        "volume": 0.21,
        "price": 3235.42,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -1.47,
        "priceIn": 3235.42,
        "doubleCheck": true
    },
    {
        "dataID": "114969",
        "id": "53051050",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:00",
        "brokerTime": "2025-05-14 12:52:01",
        "commission": -1.47,
        "swap": 0,
        "profit": -4.62,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024217",
        "positionId": "56024215",
        "volume": 0.21,
        "price": 3235.64,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -6.09,
        "priceIn": 3235.42,
        "doubleCheck": true
    },
    {
        "dataID": "114970",
        "id": "53051051",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:01",
        "brokerTime": "2025-05-14 12:52:01",
        "commission": -1.47,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024218",
        "positionId": "56024218",
        "volume": 0.21,
        "price": 3235.46,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -1.47,
        "priceIn": 3235.46,
        "doubleCheck": true
    },
    {
        "dataID": "114971",
        "id": "53051053",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:01",
        "brokerTime": "2025-05-14 12:52:02",
        "commission": -1.47,
        "swap": 0,
        "profit": -3.15,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024220",
        "positionId": "56024218",
        "volume": 0.21,
        "price": 3235.61,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -4.62,
        "priceIn": 3235.46,
        "doubleCheck": true
    },
    {
        "dataID": "114972",
        "id": "53051054",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:02",
        "brokerTime": "2025-05-14 12:52:02",
        "commission": -1.47,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024221",
        "positionId": "56024221",
        "volume": 0.21,
        "price": 3235.44,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -1.47,
        "priceIn": 3235.44,
        "doubleCheck": true
    },
    {
        "dataID": "114973",
        "id": "53051056",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:02",
        "brokerTime": "2025-05-14 12:52:03",
        "commission": -1.47,
        "swap": 0,
        "profit": -1.89,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024223",
        "positionId": "56024221",
        "volume": 0.21,
        "price": 3235.53,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -3.36,
        "priceIn": 3235.44,
        "doubleCheck": true
    },
    {
        "dataID": "114974",
        "id": "53051057",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:04",
        "brokerTime": "2025-05-14 12:52:04",
        "commission": -1.47,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024224",
        "positionId": "56024224",
        "volume": 0.21,
        "price": 3235.21,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -1.47,
        "priceIn": 3235.21,
        "doubleCheck": true
    },
    {
        "dataID": "114975",
        "id": "53051059",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:04",
        "brokerTime": "2025-05-14 12:52:04",
        "commission": -1.47,
        "swap": 0,
        "profit": 0.21,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024228",
        "positionId": "56024224",
        "volume": 0.21,
        "price": 3235.2,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -1.26,
        "priceIn": 3235.21,
        "doubleCheck": true
    },
    {
        "dataID": "114976",
        "id": "53051062",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 12:52:04",
        "brokerTime": "2025-05-14 12:52:04",
        "commission": -1.19,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024229",
        "positionId": "56024229",
        "volume": 0.17,
        "price": 3235.21,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3335.21,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -1.19,
        "priceIn": 3235.21,
        "doubleCheck": true
    },
    {
        "dataID": "114977",
        "id": "53051076",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:05",
        "brokerTime": "2025-05-14 12:52:05",
        "commission": -2.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024244",
        "positionId": "56024244",
        "volume": 0.42,
        "price": 3235.02,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -2.94,
        "priceIn": 3235.02,
        "doubleCheck": true
    },
    {
        "dataID": "114978",
        "id": "53051117",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:05",
        "brokerTime": "2025-05-14 12:52:06",
        "commission": -2.94,
        "swap": 0,
        "profit": -8.82,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024265",
        "positionId": "56024244",
        "volume": 0.42,
        "price": 3235.23,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -11.76,
        "priceIn": 3235.02,
        "doubleCheck": true
    },
    {
        "dataID": "114979",
        "id": "53051119",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:07",
        "brokerTime": "2025-05-14 12:52:07",
        "commission": -2.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024267",
        "positionId": "56024267",
        "volume": 0.42,
        "price": 3235.02,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -2.94,
        "priceIn": 3235.02,
        "doubleCheck": true
    },
    {
        "dataID": "114980",
        "id": "53051120",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:07",
        "brokerTime": "2025-05-14 12:52:07",
        "commission": -2.94,
        "swap": 0,
        "profit": -7.98,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024268",
        "positionId": "56024267",
        "volume": 0.42,
        "price": 3235.21,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -10.92,
        "priceIn": 3235.02,
        "doubleCheck": true
    },
    {
        "dataID": "114981",
        "id": "53051121",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:09",
        "brokerTime": "2025-05-14 12:52:09",
        "commission": -2.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024269",
        "positionId": "56024269",
        "volume": 0.42,
        "price": 3235.03,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -2.94,
        "priceIn": 3235.03,
        "doubleCheck": true
    },
    {
        "dataID": "114982",
        "id": "53051122",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:09",
        "brokerTime": "2025-05-14 12:52:10",
        "commission": -2.94,
        "swap": 0,
        "profit": -3.78,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024270",
        "positionId": "56024269",
        "volume": 0.42,
        "price": 3235.12,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -6.72,
        "priceIn": 3235.03,
        "doubleCheck": true
    },
    {
        "dataID": "114983",
        "id": "53051123",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:10",
        "brokerTime": "2025-05-14 12:52:10",
        "commission": -2.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024271",
        "positionId": "56024271",
        "volume": 0.42,
        "price": 3235.04,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -2.94,
        "priceIn": 3235.04,
        "doubleCheck": true
    },
    {
        "dataID": "114984",
        "id": "53051124",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:10",
        "brokerTime": "2025-05-14 12:52:11",
        "commission": -2.94,
        "swap": 0,
        "profit": -7.56,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024272",
        "positionId": "56024271",
        "volume": 0.42,
        "price": 3235.22,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -10.5,
        "priceIn": 3235.04,
        "doubleCheck": true
    },
    {
        "dataID": "114985",
        "id": "53051125",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:11",
        "brokerTime": "2025-05-14 12:52:11",
        "commission": -2.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024273",
        "positionId": "56024273",
        "volume": 0.42,
        "price": 3235.25,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -2.94,
        "priceIn": 3235.25,
        "doubleCheck": true
    },
    {
        "dataID": "114986",
        "id": "53051126",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:11",
        "brokerTime": "2025-05-14 12:52:12",
        "commission": -2.94,
        "swap": 0,
        "profit": -9.24,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024274",
        "positionId": "56024273",
        "volume": 0.42,
        "price": 3235.47,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -12.18,
        "priceIn": 3235.25,
        "doubleCheck": true
    },
    {
        "dataID": "114987",
        "id": "53051127",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:12",
        "brokerTime": "2025-05-14 12:52:12",
        "commission": -2.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024275",
        "positionId": "56024275",
        "volume": 0.42,
        "price": 3235.27,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -2.94,
        "priceIn": 3235.27,
        "doubleCheck": true
    },
    {
        "dataID": "114988",
        "id": "53051128",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:12",
        "brokerTime": "2025-05-14 12:52:12",
        "commission": -2.94,
        "swap": 0,
        "profit": -7.98,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024276",
        "positionId": "56024275",
        "volume": 0.42,
        "price": 3235.46,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -10.92,
        "priceIn": 3235.27,
        "doubleCheck": true
    },
    {
        "dataID": "114989",
        "id": "53051129",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:13",
        "brokerTime": "2025-05-14 12:52:13",
        "commission": -2.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024277",
        "positionId": "56024277",
        "volume": 0.42,
        "price": 3235.27,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -2.94,
        "priceIn": 3235.27,
        "doubleCheck": true
    },
    {
        "dataID": "114990",
        "id": "53051130",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:13",
        "brokerTime": "2025-05-14 12:52:13",
        "commission": -2.94,
        "swap": 0,
        "profit": -7.98,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024278",
        "positionId": "56024277",
        "volume": 0.42,
        "price": 3235.46,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -10.92,
        "priceIn": 3235.27,
        "doubleCheck": true
    },
    {
        "dataID": "114991",
        "id": "53051131",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:13",
        "brokerTime": "2025-05-14 12:52:13",
        "commission": -2.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024279",
        "positionId": "56024279",
        "volume": 0.42,
        "price": 3235.07,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -2.94,
        "priceIn": 3235.07,
        "doubleCheck": true
    },
    {
        "dataID": "114992",
        "id": "53051132",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:13",
        "brokerTime": "2025-05-14 12:52:14",
        "commission": -2.94,
        "swap": 0,
        "profit": -8.82,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024280",
        "positionId": "56024279",
        "volume": 0.42,
        "price": 3235.28,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -11.76,
        "priceIn": 3235.07,
        "doubleCheck": true
    },
    {
        "dataID": "114993",
        "id": "53051133",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:14",
        "brokerTime": "2025-05-14 12:52:14",
        "commission": -2.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024281",
        "positionId": "56024281",
        "volume": 0.42,
        "price": 3235.16,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -2.94,
        "priceIn": 3235.16,
        "doubleCheck": true
    },
    {
        "dataID": "114994",
        "id": "53051134",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:14",
        "brokerTime": "2025-05-14 12:52:14",
        "commission": -2.94,
        "swap": 0,
        "profit": -5.04,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024282",
        "positionId": "56024281",
        "volume": 0.42,
        "price": 3235.28,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -7.98,
        "priceIn": 3235.16,
        "doubleCheck": true
    },
    {
        "dataID": "114995",
        "id": "53051135",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:16",
        "brokerTime": "2025-05-14 12:52:16",
        "commission": -2.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024283",
        "positionId": "56024283",
        "volume": 0.42,
        "price": 3235.06,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -2.94,
        "priceIn": 3235.06,
        "doubleCheck": true
    },
    {
        "dataID": "114996",
        "id": "53051136",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:16",
        "brokerTime": "2025-05-14 12:52:16",
        "commission": -2.94,
        "swap": 0,
        "profit": -6.3,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024284",
        "positionId": "56024283",
        "volume": 0.42,
        "price": 3235.21,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -9.24,
        "priceIn": 3235.06,
        "doubleCheck": true
    },
    {
        "dataID": "114997",
        "id": "53051137",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:17",
        "brokerTime": "2025-05-14 12:52:17",
        "commission": -2.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024285",
        "positionId": "56024285",
        "volume": 0.42,
        "price": 3235.08,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -2.94,
        "priceIn": 3235.08,
        "doubleCheck": true
    },
    {
        "dataID": "114998",
        "id": "53051138",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:17",
        "brokerTime": "2025-05-14 12:52:19",
        "commission": -2.94,
        "swap": 0,
        "profit": -5.88,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024286",
        "positionId": "56024285",
        "volume": 0.42,
        "price": 3235.22,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -8.82,
        "priceIn": 3235.08,
        "doubleCheck": true
    },
    {
        "dataID": "114999",
        "id": "53051139",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:21",
        "brokerTime": "2025-05-14 12:52:21",
        "commission": -2.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024287",
        "positionId": "56024287",
        "volume": 0.42,
        "price": 3235.03,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -2.94,
        "priceIn": 3235.03,
        "doubleCheck": true
    },
    {
        "dataID": "115000",
        "id": "53051140",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:21",
        "brokerTime": "2025-05-14 12:52:21",
        "commission": -2.94,
        "swap": 0,
        "profit": 0.42,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024288",
        "positionId": "56024287",
        "volume": 0.42,
        "price": 3235.02,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -2.52,
        "priceIn": 3235.03,
        "doubleCheck": true
    },
    {
        "dataID": "115001",
        "id": "53051141",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:21",
        "brokerTime": "2025-05-14 12:52:21",
        "commission": -2.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024289",
        "positionId": "56024289",
        "volume": 0.42,
        "price": 3234.75,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -2.94,
        "priceIn": 3234.75,
        "doubleCheck": true
    },
    {
        "dataID": "115002",
        "id": "53051142",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:21",
        "brokerTime": "2025-05-14 12:52:22",
        "commission": -2.94,
        "swap": 0,
        "profit": -8.82,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024290",
        "positionId": "56024289",
        "volume": 0.42,
        "price": 3234.96,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -11.76,
        "priceIn": 3234.75,
        "doubleCheck": true
    },
    {
        "dataID": "115003",
        "id": "53051143",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:22",
        "brokerTime": "2025-05-14 12:52:22",
        "commission": -2.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024291",
        "positionId": "56024291",
        "volume": 0.42,
        "price": 3234.8,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -2.94,
        "priceIn": 3234.8,
        "doubleCheck": true
    },
    {
        "dataID": "115004",
        "id": "53051144",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:22",
        "brokerTime": "2025-05-14 12:52:23",
        "commission": -2.94,
        "swap": 0,
        "profit": -7.56,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024292",
        "positionId": "56024291",
        "volume": 0.42,
        "price": 3234.98,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -10.5,
        "priceIn": 3234.8,
        "doubleCheck": true
    },
    {
        "dataID": "115005",
        "id": "53051146",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:24",
        "brokerTime": "2025-05-14 12:52:24",
        "commission": -2.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024294",
        "positionId": "56024294",
        "volume": 0.42,
        "price": 3234.75,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -2.94,
        "priceIn": 3234.75,
        "doubleCheck": true
    },
    {
        "dataID": "115006",
        "id": "53051147",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:24",
        "brokerTime": "2025-05-14 12:52:24",
        "commission": -2.94,
        "swap": 0,
        "profit": -5.88,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024295",
        "positionId": "56024294",
        "volume": 0.42,
        "price": 3234.89,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -8.82,
        "priceIn": 3234.75,
        "doubleCheck": true
    },
    {
        "dataID": "115007",
        "id": "53051148",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:25",
        "brokerTime": "2025-05-14 12:52:25",
        "commission": -2.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024296",
        "positionId": "56024296",
        "volume": 0.42,
        "price": 3234.87,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -2.94,
        "priceIn": 3234.87,
        "doubleCheck": true
    },
    {
        "dataID": "115008",
        "id": "53051150",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:25",
        "brokerTime": "2025-05-14 12:52:25",
        "commission": -2.94,
        "swap": 0,
        "profit": 0.84,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024298",
        "positionId": "56024296",
        "volume": 0.42,
        "price": 3234.85,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -2.1,
        "priceIn": 3234.87,
        "doubleCheck": true
    },
    {
        "dataID": "115009",
        "id": "53051151",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:26",
        "brokerTime": "2025-05-14 12:52:26",
        "commission": -2.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024299",
        "positionId": "56024299",
        "volume": 0.42,
        "price": 3234.5,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -2.94,
        "priceIn": 3234.5,
        "doubleCheck": true
    },
    {
        "dataID": "115010",
        "id": "53051152",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:26",
        "brokerTime": "2025-05-14 12:52:26",
        "commission": -2.94,
        "swap": 0,
        "profit": -5.88,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024300",
        "positionId": "56024299",
        "volume": 0.42,
        "price": 3234.64,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -8.82,
        "priceIn": 3234.5,
        "doubleCheck": true
    },
    {
        "dataID": "115011",
        "id": "53051153",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:27",
        "brokerTime": "2025-05-14 12:52:27",
        "commission": -2.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024301",
        "positionId": "56024301",
        "volume": 0.42,
        "price": 3234.3,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -2.94,
        "priceIn": 3234.3,
        "doubleCheck": true
    },
    {
        "dataID": "115012",
        "id": "53051154",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:27",
        "brokerTime": "2025-05-14 12:52:27",
        "commission": -2.94,
        "swap": 0,
        "profit": -3.78,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024302",
        "positionId": "56024301",
        "volume": 0.42,
        "price": 3234.39,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -6.72,
        "priceIn": 3234.3,
        "doubleCheck": true
    },
    {
        "dataID": "115013",
        "id": "53051155",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:28",
        "brokerTime": "2025-05-14 12:52:28",
        "commission": -2.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024303",
        "positionId": "56024303",
        "volume": 0.42,
        "price": 3234.08,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -2.94,
        "priceIn": 3234.08,
        "doubleCheck": true
    },
    {
        "dataID": "115014",
        "id": "53051156",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:28",
        "brokerTime": "2025-05-14 12:52:28",
        "commission": -2.94,
        "swap": 0,
        "profit": -4.2,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024304",
        "positionId": "56024303",
        "volume": 0.42,
        "price": 3234.18,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -7.140000000000001,
        "priceIn": 3234.08,
        "doubleCheck": true
    },
    {
        "dataID": "115015",
        "id": "53051158",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:29",
        "brokerTime": "2025-05-14 12:52:29",
        "commission": -2.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024306",
        "positionId": "56024306",
        "volume": 0.42,
        "price": 3233.98,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -2.94,
        "priceIn": 3233.98,
        "doubleCheck": true
    },
    {
        "dataID": "115016",
        "id": "53051159",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:29",
        "brokerTime": "2025-05-14 12:52:29",
        "commission": -2.94,
        "swap": 0,
        "profit": -8.82,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024307",
        "positionId": "56024306",
        "volume": 0.42,
        "price": 3234.19,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -11.76,
        "priceIn": 3233.98,
        "doubleCheck": true
    },
    {
        "dataID": "115017",
        "id": "53051160",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:30",
        "brokerTime": "2025-05-14 12:52:30",
        "commission": -2.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024308",
        "positionId": "56024308",
        "volume": 0.42,
        "price": 3234.05,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -2.94,
        "priceIn": 3234.05,
        "doubleCheck": true
    },
    {
        "dataID": "115018",
        "id": "53051161",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:30",
        "brokerTime": "2025-05-14 12:52:30",
        "commission": -2.94,
        "swap": 0,
        "profit": -2.1,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024309",
        "positionId": "56024308",
        "volume": 0.42,
        "price": 3234.1,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -5.04,
        "priceIn": 3234.05,
        "doubleCheck": true
    },
    {
        "dataID": "115019",
        "id": "53051162",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:31",
        "brokerTime": "2025-05-14 12:52:31",
        "commission": -2.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024310",
        "positionId": "56024310",
        "volume": 0.42,
        "price": 3233.9,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -2.94,
        "priceIn": 3233.9,
        "doubleCheck": true
    },
    {
        "dataID": "115020",
        "id": "53051163",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:31",
        "brokerTime": "2025-05-14 12:52:31",
        "commission": -2.94,
        "swap": 0,
        "profit": -8.82,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024311",
        "positionId": "56024310",
        "volume": 0.42,
        "price": 3234.11,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -11.76,
        "priceIn": 3233.9,
        "doubleCheck": true
    },
    {
        "dataID": "115021",
        "id": "53051164",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:32",
        "brokerTime": "2025-05-14 12:52:32",
        "commission": -2.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024312",
        "positionId": "56024312",
        "volume": 0.42,
        "price": 3233.8,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -2.94,
        "priceIn": 3233.8,
        "doubleCheck": true
    },
    {
        "dataID": "115022",
        "id": "53051165",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:32",
        "brokerTime": "2025-05-14 12:52:32",
        "commission": -2.94,
        "swap": 0,
        "profit": -5.46,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024313",
        "positionId": "56024312",
        "volume": 0.42,
        "price": 3233.93,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -8.4,
        "priceIn": 3233.8,
        "doubleCheck": true
    },
    {
        "dataID": "115023",
        "id": "53051166",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:33",
        "brokerTime": "2025-05-14 12:52:33",
        "commission": -2.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024314",
        "positionId": "56024314",
        "volume": 0.42,
        "price": 3233.7,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -2.94,
        "priceIn": 3233.7,
        "doubleCheck": true
    },
    {
        "dataID": "115024",
        "id": "53051167",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:33",
        "brokerTime": "2025-05-14 12:52:33",
        "commission": -2.94,
        "swap": 0,
        "profit": -17.64,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024315",
        "positionId": "56024314",
        "volume": 0.42,
        "price": 3234.12,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -20.580000000000002,
        "priceIn": 3233.7,
        "doubleCheck": true
    },
    {
        "dataID": "115025",
        "id": "53051168",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:34",
        "brokerTime": "2025-05-14 12:52:34",
        "commission": -2.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024316",
        "positionId": "56024316",
        "volume": 0.42,
        "price": 3233.91,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -2.94,
        "priceIn": 3233.91,
        "doubleCheck": true
    },
    {
        "dataID": "115026",
        "id": "53051169",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:34",
        "brokerTime": "2025-05-14 12:52:34",
        "commission": -2.94,
        "swap": 0,
        "profit": -8.82,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024317",
        "positionId": "56024316",
        "volume": 0.42,
        "price": 3234.12,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -11.76,
        "priceIn": 3233.91,
        "doubleCheck": true
    },
    {
        "dataID": "115027",
        "id": "53051170",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:34",
        "brokerTime": "2025-05-14 12:52:34",
        "commission": -2.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024318",
        "positionId": "56024318",
        "volume": 0.42,
        "price": 3233.89,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -2.94,
        "priceIn": 3233.89,
        "doubleCheck": true
    },
    {
        "dataID": "115028",
        "id": "53051171",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:34",
        "brokerTime": "2025-05-14 12:52:35",
        "commission": -2.94,
        "swap": 0,
        "profit": -4.62,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024319",
        "positionId": "56024318",
        "volume": 0.42,
        "price": 3234,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -7.5600000000000005,
        "priceIn": 3233.89,
        "doubleCheck": true
    },
    {
        "dataID": "115029",
        "id": "53051172",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:35",
        "brokerTime": "2025-05-14 12:52:35",
        "commission": -2.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024320",
        "positionId": "56024320",
        "volume": 0.42,
        "price": 3233.85,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -2.94,
        "priceIn": 3233.85,
        "doubleCheck": true
    },
    {
        "dataID": "115030",
        "id": "53051173",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:35",
        "brokerTime": "2025-05-14 12:52:35",
        "commission": -2.94,
        "swap": 0,
        "profit": -5.04,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024321",
        "positionId": "56024320",
        "volume": 0.42,
        "price": 3233.97,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -7.98,
        "priceIn": 3233.85,
        "doubleCheck": true
    },
    {
        "dataID": "115031",
        "id": "53051174",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:36",
        "brokerTime": "2025-05-14 12:52:36",
        "commission": -2.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024322",
        "positionId": "56024322",
        "volume": 0.42,
        "price": 3233.73,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -2.94,
        "priceIn": 3233.73,
        "doubleCheck": true
    },
    {
        "dataID": "115032",
        "id": "53051175",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:36",
        "brokerTime": "2025-05-14 12:52:36",
        "commission": -2.94,
        "swap": 0,
        "profit": -10.92,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024323",
        "positionId": "56024322",
        "volume": 0.42,
        "price": 3233.99,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -13.86,
        "priceIn": 3233.73,
        "doubleCheck": true
    },
    {
        "dataID": "115033",
        "id": "53051176",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:36",
        "brokerTime": "2025-05-14 12:52:36",
        "commission": -2.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024324",
        "positionId": "56024324",
        "volume": 0.42,
        "price": 3233.8,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -2.94,
        "priceIn": 3233.8,
        "doubleCheck": true
    },
    {
        "dataID": "115034",
        "id": "53051177",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:36",
        "brokerTime": "2025-05-14 12:52:37",
        "commission": -2.94,
        "swap": 0,
        "profit": -10.08,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024325",
        "positionId": "56024324",
        "volume": 0.42,
        "price": 3234.04,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -13.02,
        "priceIn": 3233.8,
        "doubleCheck": true
    },
    {
        "dataID": "115035",
        "id": "53051178",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:38",
        "brokerTime": "2025-05-14 12:52:38",
        "commission": -2.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024326",
        "positionId": "56024326",
        "volume": 0.42,
        "price": 3233.81,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -2.94,
        "priceIn": 3233.81,
        "doubleCheck": true
    },
    {
        "dataID": "115036",
        "id": "53051179",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:38",
        "brokerTime": "2025-05-14 12:52:39",
        "commission": -2.94,
        "swap": 0,
        "profit": -6.3,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024327",
        "positionId": "56024326",
        "volume": 0.42,
        "price": 3233.96,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -9.24,
        "priceIn": 3233.81,
        "doubleCheck": true
    },
    {
        "dataID": "115037",
        "id": "53051180",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:39",
        "brokerTime": "2025-05-14 12:52:39",
        "commission": -2.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024328",
        "positionId": "56024328",
        "volume": 0.42,
        "price": 3233.79,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -2.94,
        "priceIn": 3233.79,
        "doubleCheck": true
    },
    {
        "dataID": "115038",
        "id": "53051181",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:39",
        "brokerTime": "2025-05-14 12:52:40",
        "commission": -2.94,
        "swap": 0,
        "profit": -10.5,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024329",
        "positionId": "56024328",
        "volume": 0.42,
        "price": 3234.04,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -13.44,
        "priceIn": 3233.79,
        "doubleCheck": true
    },
    {
        "dataID": "115039",
        "id": "53051182",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:40",
        "brokerTime": "2025-05-14 12:52:40",
        "commission": -2.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024330",
        "positionId": "56024330",
        "volume": 0.42,
        "price": 3233.85,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -2.94,
        "priceIn": 3233.85,
        "doubleCheck": true
    },
    {
        "dataID": "115040",
        "id": "53051183",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:40",
        "brokerTime": "2025-05-14 12:52:41",
        "commission": -2.94,
        "swap": 0,
        "profit": -7.98,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024331",
        "positionId": "56024330",
        "volume": 0.42,
        "price": 3234.04,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -10.92,
        "priceIn": 3233.85,
        "doubleCheck": true
    },
    {
        "dataID": "115041",
        "id": "53051184",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:41",
        "brokerTime": "2025-05-14 12:52:41",
        "commission": -2.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024332",
        "positionId": "56024332",
        "volume": 0.42,
        "price": 3233.72,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -2.94,
        "priceIn": 3233.72,
        "doubleCheck": true
    },
    {
        "dataID": "115042",
        "id": "53051185",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:41",
        "brokerTime": "2025-05-14 12:52:42",
        "commission": -2.94,
        "swap": 0,
        "profit": -20.16,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024333",
        "positionId": "56024332",
        "volume": 0.42,
        "price": 3234.2,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -23.1,
        "priceIn": 3233.72,
        "doubleCheck": true
    },
    {
        "dataID": "115043",
        "id": "53051186",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:42",
        "brokerTime": "2025-05-14 12:52:42",
        "commission": -2.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024334",
        "positionId": "56024334",
        "volume": 0.42,
        "price": 3233.9,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -2.94,
        "priceIn": 3233.9,
        "doubleCheck": true
    },
    {
        "dataID": "115044",
        "id": "53051187",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:42",
        "brokerTime": "2025-05-14 12:52:42",
        "commission": -2.94,
        "swap": 0,
        "profit": -8.82,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024335",
        "positionId": "56024334",
        "volume": 0.42,
        "price": 3234.11,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -11.76,
        "priceIn": 3233.9,
        "doubleCheck": true
    },
    {
        "dataID": "115045",
        "id": "53051188",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:43",
        "brokerTime": "2025-05-14 12:52:43",
        "commission": -2.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024336",
        "positionId": "56024336",
        "volume": 0.42,
        "price": 3233.91,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -2.94,
        "priceIn": 3233.91,
        "doubleCheck": true
    },
    {
        "dataID": "115046",
        "id": "53051189",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:43",
        "brokerTime": "2025-05-14 12:52:44",
        "commission": -2.94,
        "swap": 0,
        "profit": -8.82,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024337",
        "positionId": "56024336",
        "volume": 0.42,
        "price": 3234.12,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -11.76,
        "priceIn": 3233.91,
        "doubleCheck": true
    },
    {
        "dataID": "115047",
        "id": "53051190",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:45",
        "brokerTime": "2025-05-14 12:52:45",
        "commission": -2.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024338",
        "positionId": "56024338",
        "volume": 0.42,
        "price": 3233.81,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -2.94,
        "priceIn": 3233.81,
        "doubleCheck": true
    },
    {
        "dataID": "115048",
        "id": "53051192",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:45",
        "brokerTime": "2025-05-14 12:52:45",
        "commission": -2.94,
        "swap": 0,
        "profit": -7.56,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024340",
        "positionId": "56024338",
        "volume": 0.42,
        "price": 3233.99,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -10.5,
        "priceIn": 3233.81,
        "doubleCheck": true
    },
    {
        "dataID": "115049",
        "id": "53051193",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:45",
        "brokerTime": "2025-05-14 12:52:45",
        "commission": -2.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024341",
        "positionId": "56024341",
        "volume": 0.42,
        "price": 3233.73,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -2.94,
        "priceIn": 3233.73,
        "doubleCheck": true
    },
    {
        "dataID": "115050",
        "id": "53051195",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:45",
        "brokerTime": "2025-05-14 12:52:46",
        "commission": -2.94,
        "swap": 0,
        "profit": -9.66,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024343",
        "positionId": "56024341",
        "volume": 0.42,
        "price": 3233.96,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -12.6,
        "priceIn": 3233.73,
        "doubleCheck": true
    },
    {
        "dataID": "115051",
        "id": "53051196",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:46",
        "brokerTime": "2025-05-14 12:52:46",
        "commission": -2.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024344",
        "positionId": "56024344",
        "volume": 0.42,
        "price": 3233.76,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -2.94,
        "priceIn": 3233.76,
        "doubleCheck": true
    },
    {
        "dataID": "115052",
        "id": "53051197",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:46",
        "brokerTime": "2025-05-14 12:52:47",
        "commission": -2.94,
        "swap": 0,
        "profit": -7.98,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024345",
        "positionId": "56024344",
        "volume": 0.42,
        "price": 3233.95,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -10.92,
        "priceIn": 3233.76,
        "doubleCheck": true
    },
    {
        "dataID": "115053",
        "id": "53051198",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:48",
        "brokerTime": "2025-05-14 12:52:48",
        "commission": -2.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024346",
        "positionId": "56024346",
        "volume": 0.42,
        "price": 3233.87,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -2.94,
        "priceIn": 3233.87,
        "doubleCheck": true
    },
    {
        "dataID": "115054",
        "id": "53051199",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:48",
        "brokerTime": "2025-05-14 12:52:48",
        "commission": -2.94,
        "swap": 0,
        "profit": -3.36,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024347",
        "positionId": "56024346",
        "volume": 0.42,
        "price": 3233.95,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -6.3,
        "priceIn": 3233.87,
        "doubleCheck": true
    },
    {
        "dataID": "115055",
        "id": "53051200",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:50",
        "brokerTime": "2025-05-14 12:52:50",
        "commission": -2.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024348",
        "positionId": "56024348",
        "volume": 0.42,
        "price": 3233.75,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -2.94,
        "priceIn": 3233.75,
        "doubleCheck": true
    },
    {
        "dataID": "115056",
        "id": "53051201",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:50",
        "brokerTime": "2025-05-14 12:52:50",
        "commission": -2.94,
        "swap": 0,
        "profit": 0.42,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024349",
        "positionId": "56024348",
        "volume": 0.42,
        "price": 3233.74,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -2.52,
        "priceIn": 3233.75,
        "doubleCheck": true
    },
    {
        "dataID": "115057",
        "id": "53051202",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:50",
        "brokerTime": "2025-05-14 12:52:50",
        "commission": -2.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024350",
        "positionId": "56024350",
        "volume": 0.42,
        "price": 3233.51,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -2.94,
        "priceIn": 3233.51,
        "doubleCheck": true
    },
    {
        "dataID": "115058",
        "id": "53051203",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:50",
        "brokerTime": "2025-05-14 12:52:51",
        "commission": -2.94,
        "swap": 0,
        "profit": -8.4,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024351",
        "positionId": "56024350",
        "volume": 0.42,
        "price": 3233.71,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -11.34,
        "priceIn": 3233.51,
        "doubleCheck": true
    },
    {
        "dataID": "115059",
        "id": "53051204",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 12:52:04",
        "brokerTime": "2025-05-14 12:52:51",
        "commission": -1.19,
        "swap": 0,
        "profit": -28.73,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024352",
        "positionId": "56024229",
        "volume": 0.17,
        "price": 3233.52,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3335.01,
        "brokerComment": "",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -29.92,
        "priceIn": 3235.21,
        "doubleCheck": true,
        "isShow": false,
        "collapseIndex": "0,1,2,3,4,5,6,7",
        "tProfit": -101.91,
        "tnProfit": -105.62,
        "tVolume": 0.53,
        "tTrades": 4
    },
    {
        "dataID": "115060",
        "id": "53051205",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 12:51:00",
        "brokerTime": "2025-05-14 12:52:51",
        "commission": -0.98,
        "swap": 0,
        "profit": -26.04,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024353",
        "positionId": "56024047",
        "volume": 0.14,
        "price": 3233.52,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3335,
        "brokerComment": "",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -27.02,
        "priceIn": 3235.38,
        "doubleCheck": true
    },
    {
        "dataID": "115061",
        "id": "53051206",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:50:00",
        "brokerTime": "2025-05-14 12:52:51",
        "commission": -0.84,
        "swap": 0,
        "profit": 27,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024354",
        "positionId": "56023584",
        "volume": 0.12,
        "price": 3233.71,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3136.15,
        "brokerComment": "",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 26.16,
        "priceIn": 3235.96,
        "doubleCheck": true
    },
    {
        "dataID": "115062",
        "id": "53051207",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 12:49:24",
        "brokerTime": "2025-05-14 12:52:51",
        "commission": -0.84,
        "swap": 0,
        "profit": -24.84,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024355",
        "positionId": "56023329",
        "volume": 0.12,
        "price": 3233.52,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3335,
        "brokerComment": "",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -25.68,
        "priceIn": 3235.59,
        "doubleCheck": true
    },
    {
        "dataID": "115063",
        "id": "53051208",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:49:21",
        "brokerTime": "2025-05-14 12:52:51",
        "commission": -0.7,
        "swap": 0,
        "profit": 19.1,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024356",
        "positionId": "56023327",
        "volume": 0.1,
        "price": 3233.71,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3136.19,
        "brokerComment": "",
        "comment": "Sell Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 18.400000000000002,
        "priceIn": 3235.62,
        "doubleCheck": true
    },
    {
        "dataID": "115064",
        "id": "53051209",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 12:49:21",
        "brokerTime": "2025-05-14 12:52:51",
        "commission": -0.7,
        "swap": 0,
        "profit": -22.3,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024357",
        "positionId": "56023326",
        "volume": 0.1,
        "price": 3233.52,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3335,
        "brokerComment": "",
        "comment": "Buy Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -23,
        "priceIn": 3235.75,
        "doubleCheck": true
    },
    {
        "dataID": "115065",
        "id": "53051351",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 12:53:33",
        "brokerTime": "2025-05-14 12:53:33",
        "commission": -7,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024472",
        "positionId": "56024472",
        "volume": 1,
        "price": 3234.97,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3335.01,
        "brokerComment": "Buy Order",
        "comment": "Buy Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -7,
        "priceIn": 3234.97,
        "doubleCheck": true
    },
    {
        "dataID": "115066",
        "id": "53051352",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:53:35",
        "brokerTime": "2025-05-14 12:53:35",
        "commission": -7,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024473",
        "positionId": "56024473",
        "volume": 1,
        "price": 3234.82,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3134.82,
        "brokerComment": "Sell Order",
        "comment": "Sell Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -7,
        "priceIn": 3234.82,
        "doubleCheck": true
    },
    {
        "dataID": "115067",
        "id": "53051353",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:53:38",
        "brokerTime": "2025-05-14 12:53:38",
        "commission": -8.4,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024474",
        "positionId": "56024474",
        "volume": 1.2,
        "price": 3234.97,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3134.97,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -8.4,
        "priceIn": 3234.97,
        "doubleCheck": true
    },
    {
        "dataID": "115068",
        "id": "53051355",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 12:53:45",
        "brokerTime": "2025-05-14 12:53:45",
        "commission": -2.87,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024476",
        "positionId": "56024476",
        "volume": 0.41,
        "price": 3235.05,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "Manual BT",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -2.87,
        "priceIn": 3235.05,
        "doubleCheck": true
    },
    {
        "dataID": "115069",
        "id": "53051356",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 12:53:45",
        "brokerTime": "2025-05-14 12:53:45",
        "commission": -2.66,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024477",
        "positionId": "56024477",
        "volume": 0.38,
        "price": 3235.08,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "Manual BT",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -2.66,
        "priceIn": 3235.08,
        "doubleCheck": true
    },
    {
        "dataID": "115070",
        "id": "53051357",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 12:53:46",
        "brokerTime": "2025-05-14 12:53:46",
        "commission": -2.17,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024478",
        "positionId": "56024478",
        "volume": 0.31,
        "price": 3235.08,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "Manual BT",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -2.17,
        "priceIn": 3235.08,
        "doubleCheck": true
    },
    {
        "dataID": "115071",
        "id": "53051358",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 12:53:46",
        "brokerTime": "2025-05-14 12:53:46",
        "commission": -1.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024479",
        "positionId": "56024479",
        "volume": 0.28,
        "price": 3235.07,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "Manual BT",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -1.96,
        "priceIn": 3235.07,
        "doubleCheck": true
    },
    {
        "dataID": "115072",
        "id": "53051359",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 12:53:46",
        "brokerTime": "2025-05-14 12:53:46",
        "commission": -1.82,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024480",
        "positionId": "56024480",
        "volume": 0.26,
        "price": 3235.07,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "Manual BT",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -1.82,
        "priceIn": 3235.07,
        "doubleCheck": true
    },
    {
        "dataID": "115073",
        "id": "53051360",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 12:53:46",
        "brokerTime": "2025-05-14 12:53:53",
        "commission": -1.82,
        "swap": 0,
        "profit": 2.6,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024481",
        "positionId": "56024480",
        "volume": 0.26,
        "price": 3235.17,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 0.78,
        "priceIn": 3235.07,
        "doubleCheck": true,
        "isShow": false,
        "collapseIndex": "0,1,2,3,4,5,6,7,8,9",
        "tProfit": 59.06,
        "tnProfit": 40.58,
        "tVolume": 2.6399999999999997,
        "tTrades": 6
    },
    {
        "dataID": "115074",
        "id": "53051361",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 12:53:46",
        "brokerTime": "2025-05-14 12:53:53",
        "commission": -1.96,
        "swap": 0,
        "profit": 2.8,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024482",
        "positionId": "56024479",
        "volume": 0.28,
        "price": 3235.17,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 0.8399999999999999,
        "priceIn": 3235.07,
        "doubleCheck": true
    },
    {
        "dataID": "115075",
        "id": "53051362",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 12:53:46",
        "brokerTime": "2025-05-14 12:53:53",
        "commission": -2.17,
        "swap": 0,
        "profit": 2.79,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024483",
        "positionId": "56024478",
        "volume": 0.31,
        "price": 3235.17,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 0.6200000000000001,
        "priceIn": 3235.08,
        "doubleCheck": true
    },
    {
        "dataID": "115076",
        "id": "53051363",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 12:53:45",
        "brokerTime": "2025-05-14 12:53:53",
        "commission": -2.66,
        "swap": 0,
        "profit": 3.8,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024484",
        "positionId": "56024477",
        "volume": 0.38,
        "price": 3235.18,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 1.1399999999999997,
        "priceIn": 3235.08,
        "doubleCheck": true
    },
    {
        "dataID": "115077",
        "id": "53051364",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 12:53:45",
        "brokerTime": "2025-05-14 12:53:54",
        "commission": -2.87,
        "swap": 0,
        "profit": 11.07,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024485",
        "positionId": "56024476",
        "volume": 0.41,
        "price": 3235.32,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 8.2,
        "priceIn": 3235.05,
        "doubleCheck": true
    },
    {
        "dataID": "115078",
        "id": "53051365",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:53:38",
        "brokerTime": "2025-05-14 12:53:54",
        "commission": -8.4,
        "swap": 0,
        "profit": -63.6,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024486",
        "positionId": "56024474",
        "volume": 1.2,
        "price": 3235.5,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3135.16,
        "brokerComment": "",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -72,
        "priceIn": 3234.97,
        "doubleCheck": true,
        "isShow": false,
        "collapseIndex": "0,1,2,3,4,5,6,7,8,9,10",
        "tProfit": -131.6,
        "tnProfit": -147,
        "tVolume": 2.2,
        "tTrades": 2
    },
    {
        "dataID": "115079",
        "id": "53051366",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:53:35",
        "brokerTime": "2025-05-14 12:53:54",
        "commission": -7,
        "swap": 0,
        "profit": -68,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024487",
        "positionId": "56024473",
        "volume": 1,
        "price": 3235.5,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3135.16,
        "brokerComment": "",
        "comment": "Sell Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -75,
        "priceIn": 3234.82,
        "doubleCheck": true
    },
    {
        "dataID": "115080",
        "id": "53051367",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 12:53:33",
        "brokerTime": "2025-05-14 12:53:54",
        "commission": -7,
        "swap": 0,
        "profit": 36,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024488",
        "positionId": "56024472",
        "volume": 1,
        "price": 3235.33,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3334.75,
        "brokerComment": "",
        "comment": "Buy Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 29,
        "priceIn": 3234.97,
        "doubleCheck": true
    },
    {
        "dataID": "115081",
        "id": "53051373",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 12:54:53",
        "brokerTime": "2025-05-14 12:54:53",
        "commission": -7,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024494",
        "positionId": "56024494",
        "volume": 1,
        "price": 3234.52,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3334.52,
        "brokerComment": "Buy Order",
        "comment": "Buy Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -7,
        "priceIn": 3234.52,
        "doubleCheck": true
    },
    {
        "dataID": "115082",
        "id": "53051374",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:54:54",
        "brokerTime": "2025-05-14 12:54:54",
        "commission": -7,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024496",
        "positionId": "56024496",
        "volume": 1,
        "price": 3234.3,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3134.3,
        "brokerComment": "Sell Order",
        "comment": "Sell Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -7,
        "priceIn": 3234.3,
        "doubleCheck": true
    },
    {
        "dataID": "115083",
        "id": "53051376",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:54:57",
        "brokerTime": "2025-05-14 12:54:57",
        "commission": -8.4,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024497",
        "positionId": "56024497",
        "volume": 1.2,
        "price": 3234.6,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3134.55,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -8.4,
        "priceIn": 3234.6,
        "doubleCheck": true
    },
    {
        "dataID": "115084",
        "id": "53051380",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:55:00",
        "brokerTime": "2025-05-14 12:55:00",
        "commission": -10.08,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024501",
        "positionId": "56024501",
        "volume": 1.44,
        "price": 3234.91,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3134.91,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -10.08,
        "priceIn": 3234.91,
        "doubleCheck": true
    },
    {
        "dataID": "115085",
        "id": "53051382",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 12:55:01",
        "brokerTime": "2025-05-14 12:55:01",
        "commission": -23.59,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024503",
        "positionId": "56024503",
        "volume": 3.37,
        "price": 3235.12,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -23.59,
        "priceIn": 3235.12,
        "doubleCheck": true
    },
    {
        "dataID": "115086",
        "id": "53051384",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 12:55:01",
        "brokerTime": "2025-05-14 12:55:07",
        "commission": -23.59,
        "swap": 0,
        "profit": -104.47,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024504",
        "positionId": "56024503",
        "volume": 3.37,
        "price": 3234.81,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -128.06,
        "priceIn": 3235.12,
        "doubleCheck": true,
        "isShow": false,
        "collapseIndex": "0,1,2,3,4,5,6,7,8,9,10,11",
        "tProfit": -75.47,
        "tnProfit": -106.06,
        "tVolume": 4.37,
        "tTrades": 2
    },
    {
        "dataID": "115087",
        "id": "53051385",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:55:00",
        "brokerTime": "2025-05-14 12:55:07",
        "commission": -10.08,
        "swap": 0,
        "profit": -14.4,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024505",
        "positionId": "56024501",
        "volume": 1.44,
        "price": 3235.01,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3135.13,
        "brokerComment": "",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -24.48,
        "priceIn": 3234.91,
        "doubleCheck": true,
        "isShow": false,
        "collapseIndex": "0,1,2,3,4,5,6,7,8,9,10,11,12",
        "tProfit": -134.6,
        "tnProfit": -160.08,
        "tVolume": 3.6399999999999997,
        "tTrades": 3
    },
    {
        "dataID": "115088",
        "id": "53051386",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:54:57",
        "brokerTime": "2025-05-14 12:55:07",
        "commission": -8.4,
        "swap": 0,
        "profit": -49.2,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024506",
        "positionId": "56024497",
        "volume": 1.2,
        "price": 3235.01,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3135.12,
        "brokerComment": "",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.6,
        "priceIn": 3234.6,
        "doubleCheck": true
    },
    {
        "dataID": "115089",
        "id": "53051387",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:54:54",
        "brokerTime": "2025-05-14 12:55:07",
        "commission": -7,
        "swap": 0,
        "profit": -71,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024507",
        "positionId": "56024496",
        "volume": 1,
        "price": 3235.01,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3135.12,
        "brokerComment": "",
        "comment": "Sell Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -78,
        "priceIn": 3234.3,
        "doubleCheck": true
    },
    {
        "dataID": "115090",
        "id": "53051388",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 12:54:53",
        "brokerTime": "2025-05-14 12:55:07",
        "commission": -7,
        "swap": 0,
        "profit": 29,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024508",
        "positionId": "56024494",
        "volume": 1,
        "price": 3234.81,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3334.3,
        "brokerComment": "",
        "comment": "Buy Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 22,
        "priceIn": 3234.52,
        "doubleCheck": true
    },
    {
        "dataID": "115091",
        "id": "53051481",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 12:55:47",
        "brokerTime": "2025-05-14 12:55:47",
        "commission": -0.7,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024597",
        "positionId": "56024597",
        "volume": 0.1,
        "price": 3234.44,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3334.44,
        "brokerComment": "Buy Order",
        "comment": "Buy Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.7,
        "priceIn": 3234.44,
        "doubleCheck": true
    },
    {
        "dataID": "115092",
        "id": "53051483",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:55:48",
        "brokerTime": "2025-05-14 12:55:48",
        "commission": -0.7,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024599",
        "positionId": "56024599",
        "volume": 0.1,
        "price": 3234.41,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3134.41,
        "brokerComment": "Sell Order",
        "comment": "Sell Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.7,
        "priceIn": 3234.41,
        "doubleCheck": true
    },
    {
        "dataID": "115093",
        "id": "53051491",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 12:56:00",
        "brokerTime": "2025-05-14 12:56:00",
        "commission": -0.84,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024607",
        "positionId": "56024607",
        "volume": 0.12,
        "price": 3233.65,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3333.65,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.84,
        "priceIn": 3233.65,
        "doubleCheck": true
    },
    {
        "dataID": "115094",
        "id": "53051556",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:56:07",
        "brokerTime": "2025-05-14 12:56:07",
        "commission": -0.28,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024653",
        "positionId": "56024653",
        "volume": 0.04,
        "price": 3233.46,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "Manual BT",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.28,
        "priceIn": 3233.46,
        "doubleCheck": true
    },
    {
        "dataID": "115095",
        "id": "53051557",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:56:07",
        "brokerTime": "2025-05-14 12:56:07",
        "commission": -0.28,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024654",
        "positionId": "56024654",
        "volume": 0.04,
        "price": 3233.46,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "Manual BT",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.28,
        "priceIn": 3233.46,
        "doubleCheck": true
    },
    {
        "dataID": "115096",
        "id": "53051558",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:56:07",
        "brokerTime": "2025-05-14 12:56:07",
        "commission": -0.21,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024655",
        "positionId": "56024655",
        "volume": 0.03,
        "price": 3233.45,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "Manual BT",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.21,
        "priceIn": 3233.45,
        "doubleCheck": true
    },
    {
        "dataID": "115097",
        "id": "53051559",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:56:08",
        "brokerTime": "2025-05-14 12:56:08",
        "commission": -0.21,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024656",
        "positionId": "56024656",
        "volume": 0.03,
        "price": 3233.45,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "Manual BT",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.21,
        "priceIn": 3233.45,
        "doubleCheck": true
    },
    {
        "dataID": "115098",
        "id": "53051560",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:56:08",
        "brokerTime": "2025-05-14 12:56:08",
        "commission": -0.21,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024657",
        "positionId": "56024657",
        "volume": 0.03,
        "price": 3233.45,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "Manual BT",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.21,
        "priceIn": 3233.45,
        "doubleCheck": true
    },
    {
        "dataID": "115099",
        "id": "53051561",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:56:08",
        "brokerTime": "2025-05-14 12:56:08",
        "commission": -0.21,
        "swap": 0,
        "profit": -0.39,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024658",
        "positionId": "56024657",
        "volume": 0.03,
        "price": 3233.58,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.6,
        "priceIn": 3233.45,
        "doubleCheck": true,
        "isShow": false,
        "collapseIndex": "0,1,2,3,4,5,6,7,8,9,10,11,12,13,14",
        "tProfit": 0.67,
        "tnProfit": -1.22,
        "tVolume": 0.27,
        "tTrades": 6
    },
    {
        "dataID": "115100",
        "id": "53051562",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:56:08",
        "brokerTime": "2025-05-14 12:56:08",
        "commission": -0.21,
        "swap": 0,
        "profit": -0.39,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024659",
        "positionId": "56024656",
        "volume": 0.03,
        "price": 3233.58,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.6,
        "priceIn": 3233.45,
        "doubleCheck": true
    },
    {
        "dataID": "115101",
        "id": "53051563",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:56:07",
        "brokerTime": "2025-05-14 12:56:08",
        "commission": -0.21,
        "swap": 0,
        "profit": -0.39,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024660",
        "positionId": "56024655",
        "volume": 0.03,
        "price": 3233.58,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.6,
        "priceIn": 3233.45,
        "doubleCheck": true
    },
    {
        "dataID": "115102",
        "id": "53051564",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:56:07",
        "brokerTime": "2025-05-14 12:56:08",
        "commission": -0.28,
        "swap": 0,
        "profit": -0.48,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024661",
        "positionId": "56024654",
        "volume": 0.04,
        "price": 3233.58,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.76,
        "priceIn": 3233.46,
        "doubleCheck": true
    },
    {
        "dataID": "115103",
        "id": "53051565",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:56:07",
        "brokerTime": "2025-05-14 12:56:08",
        "commission": -0.28,
        "swap": 0,
        "profit": -0.48,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024662",
        "positionId": "56024653",
        "volume": 0.04,
        "price": 3233.58,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.76,
        "priceIn": 3233.46,
        "doubleCheck": true
    },
    {
        "dataID": "115104",
        "id": "53051638",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 12:56:00",
        "brokerTime": "2025-05-14 12:56:16",
        "commission": -0.84,
        "swap": 0,
        "profit": 3.24,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024727",
        "positionId": "56024607",
        "volume": 0.12,
        "price": 3233.92,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3333.45,
        "brokerComment": "",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 2.4000000000000004,
        "priceIn": 3233.65,
        "doubleCheck": true,
        "isShow": false,
        "collapseIndex": "0,1,2,3,4,5,6,7,8,9,10,11,12,13",
        "tProfit": -1.96,
        "tnProfit": -3.5,
        "tVolume": 0.22,
        "tTrades": 2
    },
    {
        "dataID": "115105",
        "id": "53051639",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:55:48",
        "brokerTime": "2025-05-14 12:56:16",
        "commission": -0.7,
        "swap": 0,
        "profit": 2.8,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024728",
        "positionId": "56024599",
        "volume": 0.1,
        "price": 3234.13,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3134.6,
        "brokerComment": "",
        "comment": "Sell Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 2.0999999999999996,
        "priceIn": 3234.41,
        "doubleCheck": true
    },
    {
        "dataID": "115106",
        "id": "53051640",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 12:55:47",
        "brokerTime": "2025-05-14 12:56:16",
        "commission": -0.7,
        "swap": 0,
        "profit": -5.2,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56024729",
        "positionId": "56024597",
        "volume": 0.1,
        "price": 3233.92,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3333.45,
        "brokerComment": "",
        "comment": "Buy Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -5.9,
        "priceIn": 3234.44,
        "doubleCheck": true
    },
    {
        "dataID": "115107",
        "id": "53052061",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 12:57:05",
        "brokerTime": "2025-05-14 12:57:05",
        "commission": -0.7,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56025093",
        "positionId": "56025093",
        "volume": 0.1,
        "price": 3234.17,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3334.17,
        "brokerComment": "Buy Order",
        "comment": "Buy Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.7,
        "priceIn": 3234.17,
        "doubleCheck": true
    },
    {
        "dataID": "115108",
        "id": "53052062",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:57:06",
        "brokerTime": "2025-05-14 12:57:06",
        "commission": -0.7,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56025094",
        "positionId": "56025094",
        "volume": 0.1,
        "price": 3233.97,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3133.97,
        "brokerComment": "Sell Order",
        "comment": "Sell Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.7,
        "priceIn": 3233.97,
        "doubleCheck": true
    },
    {
        "dataID": "115109",
        "id": "53052065",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 12:57:08",
        "brokerTime": "2025-05-14 12:57:08",
        "commission": -0.84,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56025097",
        "positionId": "56025097",
        "volume": 0.12,
        "price": 3233.97,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3333.99,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.84,
        "priceIn": 3233.97,
        "doubleCheck": true
    },
    {
        "dataID": "115110",
        "id": "53052066",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:57:14",
        "brokerTime": "2025-05-14 12:57:14",
        "commission": -0.28,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56025098",
        "positionId": "56025098",
        "volume": 0.04,
        "price": 3233.46,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "Manual BT",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.28,
        "priceIn": 3233.46,
        "doubleCheck": true
    },
    {
        "dataID": "115111",
        "id": "53052067",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:57:15",
        "brokerTime": "2025-05-14 12:57:15",
        "commission": -0.28,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56025099",
        "positionId": "56025099",
        "volume": 0.04,
        "price": 3233.45,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "Manual BT",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.28,
        "priceIn": 3233.45,
        "doubleCheck": true
    },
    {
        "dataID": "115112",
        "id": "53052068",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:57:15",
        "brokerTime": "2025-05-14 12:57:15",
        "commission": -0.21,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56025100",
        "positionId": "56025100",
        "volume": 0.03,
        "price": 3233.45,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "Manual BT",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.21,
        "priceIn": 3233.45,
        "doubleCheck": true
    },
    {
        "dataID": "115113",
        "id": "53052069",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:57:15",
        "brokerTime": "2025-05-14 12:57:15",
        "commission": -0.21,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56025101",
        "positionId": "56025101",
        "volume": 0.03,
        "price": 3233.49,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "Manual BT",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.21,
        "priceIn": 3233.49,
        "doubleCheck": true
    },
    {
        "dataID": "115114",
        "id": "53052070",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:57:15",
        "brokerTime": "2025-05-14 12:57:15",
        "commission": -0.21,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56025103",
        "positionId": "56025103",
        "volume": 0.03,
        "price": 3233.48,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "Manual BT",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.21,
        "priceIn": 3233.48,
        "doubleCheck": true
    },
    {
        "dataID": "115115",
        "id": "53052072",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:57:15",
        "brokerTime": "2025-05-14 12:57:16",
        "commission": -0.21,
        "swap": 0,
        "profit": -0.66,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56025104",
        "positionId": "56025103",
        "volume": 0.03,
        "price": 3233.7,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.87,
        "priceIn": 3233.48,
        "doubleCheck": true,
        "isShow": false,
        "collapseIndex": "0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15",
        "tProfit": -4,
        "tnProfit": -5.19,
        "tVolume": 0.17,
        "tTrades": 5
    },
    {
        "dataID": "115116",
        "id": "53052073",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:57:15",
        "brokerTime": "2025-05-14 12:57:16",
        "commission": -0.21,
        "swap": 0,
        "profit": -0.63,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56025105",
        "positionId": "56025101",
        "volume": 0.03,
        "price": 3233.7,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.84,
        "priceIn": 3233.49,
        "doubleCheck": true
    },
    {
        "dataID": "115117",
        "id": "53052074",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:57:15",
        "brokerTime": "2025-05-14 12:57:16",
        "commission": -0.21,
        "swap": 0,
        "profit": -0.75,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56025106",
        "positionId": "56025100",
        "volume": 0.03,
        "price": 3233.7,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.96,
        "priceIn": 3233.45,
        "doubleCheck": true
    },
    {
        "dataID": "115118",
        "id": "53052075",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:57:15",
        "brokerTime": "2025-05-14 12:57:16",
        "commission": -0.28,
        "swap": 0,
        "profit": -1,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56025107",
        "positionId": "56025099",
        "volume": 0.04,
        "price": 3233.7,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -1.28,
        "priceIn": 3233.45,
        "doubleCheck": true
    },
    {
        "dataID": "115119",
        "id": "53052076",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:57:14",
        "brokerTime": "2025-05-14 12:57:16",
        "commission": -0.28,
        "swap": 0,
        "profit": -0.96,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56025108",
        "positionId": "56025098",
        "volume": 0.04,
        "price": 3233.7,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -1.24,
        "priceIn": 3233.46,
        "doubleCheck": true
    },
    {
        "dataID": "115120",
        "id": "53052172",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:58:30",
        "brokerTime": "2025-05-14 12:58:30",
        "commission": -0.28,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56025180",
        "positionId": "56025180",
        "volume": 0.04,
        "price": 3232.9,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "Manual BT",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.28,
        "priceIn": 3232.9,
        "doubleCheck": true
    },
    {
        "dataID": "115121",
        "id": "53052173",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:58:30",
        "brokerTime": "2025-05-14 12:58:30",
        "commission": -0.28,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56025181",
        "positionId": "56025181",
        "volume": 0.04,
        "price": 3232.9,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "Manual BT",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.28,
        "priceIn": 3232.9,
        "doubleCheck": true
    },
    {
        "dataID": "115122",
        "id": "53052174",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:58:30",
        "brokerTime": "2025-05-14 12:58:30",
        "commission": -0.21,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56025182",
        "positionId": "56025182",
        "volume": 0.03,
        "price": 3232.9,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "Manual BT",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.21,
        "priceIn": 3232.9,
        "doubleCheck": true
    },
    {
        "dataID": "115123",
        "id": "53052175",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:58:30",
        "brokerTime": "2025-05-14 12:58:30",
        "commission": -0.21,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56025183",
        "positionId": "56025183",
        "volume": 0.03,
        "price": 3232.9,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "Manual BT",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.21,
        "priceIn": 3232.9,
        "doubleCheck": true
    },
    {
        "dataID": "115124",
        "id": "53052176",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:58:31",
        "brokerTime": "2025-05-14 12:58:31",
        "commission": -0.21,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56025184",
        "positionId": "56025184",
        "volume": 0.03,
        "price": 3232.89,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "Manual BT",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.21,
        "priceIn": 3232.89,
        "doubleCheck": true
    },
    {
        "dataID": "115125",
        "id": "53052177",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:58:31",
        "brokerTime": "2025-05-14 12:58:31",
        "commission": -0.21,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56025186",
        "positionId": "56025184",
        "volume": 0.03,
        "price": 3232.89,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.21,
        "priceIn": 3232.89,
        "doubleCheck": true
    },
    {
        "dataID": "115126",
        "id": "53052179",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:58:30",
        "brokerTime": "2025-05-14 12:58:31",
        "commission": -0.21,
        "swap": 0,
        "profit": 0.03,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56025187",
        "positionId": "56025183",
        "volume": 0.03,
        "price": 3232.89,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.18,
        "priceIn": 3232.9,
        "doubleCheck": true,
        "isShow": false,
        "collapseIndex": "0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17",
        "tProfit": 3.11,
        "tnProfit": -1.51,
        "tVolume": 0.6600000000000001,
        "tTrades": 13
    },
    {
        "dataID": "115127",
        "id": "53052180",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:58:30",
        "brokerTime": "2025-05-14 12:58:31",
        "commission": -0.21,
        "swap": 0,
        "profit": 0.03,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56025188",
        "positionId": "56025182",
        "volume": 0.03,
        "price": 3232.89,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.18,
        "priceIn": 3232.9,
        "doubleCheck": true
    },
    {
        "dataID": "115128",
        "id": "53052181",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:58:30",
        "brokerTime": "2025-05-14 12:58:31",
        "commission": -0.28,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56025189",
        "positionId": "56025181",
        "volume": 0.04,
        "price": 3232.9,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.28,
        "priceIn": 3232.9,
        "doubleCheck": true
    },
    {
        "dataID": "115129",
        "id": "53052182",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:58:30",
        "brokerTime": "2025-05-14 12:58:31",
        "commission": -0.28,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56025190",
        "positionId": "56025180",
        "volume": 0.04,
        "price": 3232.9,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.28,
        "priceIn": 3232.9,
        "doubleCheck": true
    },
    {
        "dataID": "115130",
        "id": "53052184",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 12:58:38",
        "brokerTime": "2025-05-14 12:58:38",
        "commission": -0.98,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56025192",
        "positionId": "56025192",
        "volume": 0.14,
        "price": 3232.88,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3332.88,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.98,
        "priceIn": 3232.88,
        "doubleCheck": true
    },
    {
        "dataID": "115131",
        "id": "53052185",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:58:42",
        "brokerTime": "2025-05-14 12:58:42",
        "commission": -0.56,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56025193",
        "positionId": "56025193",
        "volume": 0.08,
        "price": 3232.87,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "Manual BT",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.56,
        "priceIn": 3232.87,
        "doubleCheck": true
    },
    {
        "dataID": "115132",
        "id": "53052186",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:58:42",
        "brokerTime": "2025-05-14 12:58:42",
        "commission": -0.56,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56025194",
        "positionId": "56025194",
        "volume": 0.08,
        "price": 3232.87,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "Manual BT",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.56,
        "priceIn": 3232.87,
        "doubleCheck": true
    },
    {
        "dataID": "115133",
        "id": "53052187",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:58:43",
        "brokerTime": "2025-05-14 12:58:43",
        "commission": -0.42,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56025195",
        "positionId": "56025195",
        "volume": 0.06,
        "price": 3232.89,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "Manual BT",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.42,
        "priceIn": 3232.89,
        "doubleCheck": true
    },
    {
        "dataID": "115134",
        "id": "53052188",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:58:43",
        "brokerTime": "2025-05-14 12:58:43",
        "commission": -0.42,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56025196",
        "positionId": "56025196",
        "volume": 0.06,
        "price": 3232.88,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "Manual BT",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.42,
        "priceIn": 3232.88,
        "doubleCheck": true
    },
    {
        "dataID": "115135",
        "id": "53052189",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:58:43",
        "brokerTime": "2025-05-14 12:58:43",
        "commission": -0.35,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56025197",
        "positionId": "56025197",
        "volume": 0.05,
        "price": 3232.88,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "Manual BT",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.35,
        "priceIn": 3232.88,
        "doubleCheck": true
    },
    {
        "dataID": "115136",
        "id": "53052190",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:58:43",
        "brokerTime": "2025-05-14 12:58:43",
        "commission": -0.35,
        "swap": 0,
        "profit": -1.05,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56025198",
        "positionId": "56025197",
        "volume": 0.05,
        "price": 3233.09,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -1.4,
        "priceIn": 3232.88,
        "doubleCheck": true
    },
    {
        "dataID": "115137",
        "id": "53052191",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:58:43",
        "brokerTime": "2025-05-14 12:58:43",
        "commission": -0.42,
        "swap": 0,
        "profit": -1.26,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56025199",
        "positionId": "56025196",
        "volume": 0.06,
        "price": 3233.09,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -1.68,
        "priceIn": 3232.88,
        "doubleCheck": true
    },
    {
        "dataID": "115138",
        "id": "53052192",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:58:43",
        "brokerTime": "2025-05-14 12:58:44",
        "commission": -0.42,
        "swap": 0,
        "profit": -1.2,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56025200",
        "positionId": "56025195",
        "volume": 0.06,
        "price": 3233.09,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -1.6199999999999999,
        "priceIn": 3232.89,
        "doubleCheck": true
    },
    {
        "dataID": "115139",
        "id": "53052193",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:58:42",
        "brokerTime": "2025-05-14 12:58:44",
        "commission": -0.56,
        "swap": 0,
        "profit": -1.76,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56025201",
        "positionId": "56025194",
        "volume": 0.08,
        "price": 3233.09,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -2.3200000000000003,
        "priceIn": 3232.87,
        "doubleCheck": true
    },
    {
        "dataID": "115140",
        "id": "53052194",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:58:42",
        "brokerTime": "2025-05-14 12:58:44",
        "commission": -0.56,
        "swap": 0,
        "profit": -1.76,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56025202",
        "positionId": "56025193",
        "volume": 0.08,
        "price": 3233.09,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -2.3200000000000003,
        "priceIn": 3232.87,
        "doubleCheck": true
    },
    {
        "dataID": "115141",
        "id": "53052202",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 12:58:38",
        "brokerTime": "2025-05-14 12:59:22",
        "commission": -0.98,
        "swap": 0,
        "profit": -5.32,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56025210",
        "positionId": "56025192",
        "volume": 0.14,
        "price": 3232.5,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3332.67,
        "brokerComment": "",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -6.300000000000001,
        "priceIn": 3232.88,
        "doubleCheck": true,
        "isShow": false,
        "collapseIndex": "0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16",
        "tProfit": -39.66,
        "tnProfit": -42.18,
        "tVolume": 0.36,
        "tTrades": 3
    },
    {
        "dataID": "115142",
        "id": "53052203",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 12:57:08",
        "brokerTime": "2025-05-14 12:59:22",
        "commission": -0.84,
        "swap": 0,
        "profit": -17.64,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56025211",
        "positionId": "56025097",
        "volume": 0.12,
        "price": 3232.5,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3332.67,
        "brokerComment": "",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -18.48,
        "priceIn": 3233.97,
        "doubleCheck": true
    },
    {
        "dataID": "115143",
        "id": "53052204",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:57:06",
        "brokerTime": "2025-05-14 12:59:22",
        "commission": -0.7,
        "swap": 0,
        "profit": 12.5,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56025212",
        "positionId": "56025094",
        "volume": 0.1,
        "price": 3232.72,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3134.17,
        "brokerComment": "",
        "comment": "Sell Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 11.8,
        "priceIn": 3233.97,
        "doubleCheck": true
    },
    {
        "dataID": "115144",
        "id": "53052205",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 12:57:05",
        "brokerTime": "2025-05-14 12:59:22",
        "commission": -0.7,
        "swap": 0,
        "profit": -16.7,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56025213",
        "positionId": "56025093",
        "volume": 0.1,
        "price": 3232.5,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3332.67,
        "brokerComment": "",
        "comment": "Buy Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -17.4,
        "priceIn": 3234.17,
        "doubleCheck": true
    },
    {
        "dataID": "115145",
        "id": "53052207",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 12:59:59",
        "brokerTime": "2025-05-14 12:59:59",
        "commission": -0.7,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56025215",
        "positionId": "56025215",
        "volume": 0.1,
        "price": 3232.57,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3332.52,
        "brokerComment": "Buy Order",
        "comment": "Buy Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.7,
        "priceIn": 3232.57,
        "doubleCheck": true
    },
    {
        "dataID": "115146",
        "id": "53052208",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 13:00:00",
        "brokerTime": "2025-05-14 13:00:00",
        "commission": -0.7,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56025216",
        "positionId": "56025216",
        "volume": 0.1,
        "price": 3232.33,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3132.33,
        "brokerComment": "Sell Order",
        "comment": "Sell Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.7,
        "priceIn": 3232.33,
        "doubleCheck": true
    },
    {
        "dataID": "115147",
        "id": "53052279",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 13:00:02",
        "brokerTime": "2025-05-14 13:00:02",
        "commission": -0.84,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56025272",
        "positionId": "56025272",
        "volume": 0.12,
        "price": 3232.32,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3332.32,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.84,
        "priceIn": 3232.32,
        "doubleCheck": true
    },
    {
        "dataID": "115148",
        "id": "53053398",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 13:00:09",
        "brokerTime": "2025-05-14 13:00:09",
        "commission": -0.28,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56026283",
        "positionId": "56026283",
        "volume": 0.04,
        "price": 3231.83,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "Manual BT",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.28,
        "priceIn": 3231.83,
        "doubleCheck": true
    },
    {
        "dataID": "115149",
        "id": "53053399",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 13:00:09",
        "brokerTime": "2025-05-14 13:00:09",
        "commission": -0.28,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56026284",
        "positionId": "56026284",
        "volume": 0.04,
        "price": 3231.83,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "Manual BT",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.28,
        "priceIn": 3231.83,
        "doubleCheck": true
    },
    {
        "dataID": "115150",
        "id": "53053401",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 13:00:09",
        "brokerTime": "2025-05-14 13:00:09",
        "commission": -0.21,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56026286",
        "positionId": "56026286",
        "volume": 0.03,
        "price": 3231.79,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "Manual BT",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.21,
        "priceIn": 3231.79,
        "doubleCheck": true
    },
    {
        "dataID": "115151",
        "id": "53053402",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 13:00:10",
        "brokerTime": "2025-05-14 13:00:10",
        "commission": -0.21,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56026287",
        "positionId": "56026287",
        "volume": 0.03,
        "price": 3231.72,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "Manual BT",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.21,
        "priceIn": 3231.72,
        "doubleCheck": true
    },
    {
        "dataID": "115152",
        "id": "53053404",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 13:00:10",
        "brokerTime": "2025-05-14 13:00:10",
        "commission": -0.21,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56026289",
        "positionId": "56026289",
        "volume": 0.03,
        "price": 3231.74,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "Manual BT",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.21,
        "priceIn": 3231.74,
        "doubleCheck": true
    },
    {
        "dataID": "115153",
        "id": "53053406",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 13:00:10",
        "brokerTime": "2025-05-14 13:00:10",
        "commission": -0.21,
        "swap": 0,
        "profit": -0.57,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56026291",
        "positionId": "56026289",
        "volume": 0.03,
        "price": 3231.93,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.7799999999999999,
        "priceIn": 3231.74,
        "doubleCheck": true
    },
    {
        "dataID": "115154",
        "id": "53053407",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 13:00:10",
        "brokerTime": "2025-05-14 13:00:10",
        "commission": -0.21,
        "swap": 0,
        "profit": -0.63,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56026292",
        "positionId": "56026287",
        "volume": 0.03,
        "price": 3231.93,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.84,
        "priceIn": 3231.72,
        "doubleCheck": true
    },
    {
        "dataID": "115155",
        "id": "53053408",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 13:00:09",
        "brokerTime": "2025-05-14 13:00:11",
        "commission": -0.21,
        "swap": 0,
        "profit": -0.42,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56026293",
        "positionId": "56026286",
        "volume": 0.03,
        "price": 3231.93,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.63,
        "priceIn": 3231.79,
        "doubleCheck": true
    },
    {
        "dataID": "115156",
        "id": "53053409",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 13:00:09",
        "brokerTime": "2025-05-14 13:00:11",
        "commission": -0.28,
        "swap": 0,
        "profit": -0.4,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56026294",
        "positionId": "56026284",
        "volume": 0.04,
        "price": 3231.93,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.68,
        "priceIn": 3231.83,
        "doubleCheck": true
    },
    {
        "dataID": "115157",
        "id": "53053410",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 13:00:09",
        "brokerTime": "2025-05-14 13:00:11",
        "commission": -0.28,
        "swap": 0,
        "profit": -0.4,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56026295",
        "positionId": "56026283",
        "volume": 0.04,
        "price": 3231.93,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.68,
        "priceIn": 3231.83,
        "doubleCheck": true
    },
    {
        "dataID": "115158",
        "id": "53053637",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 13:05:59",
        "brokerTime": "2025-05-14 13:05:59",
        "commission": -0.98,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56026494",
        "positionId": "56026494",
        "volume": 0.14,
        "price": 3230.88,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3330.94,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.98,
        "priceIn": 3230.88,
        "doubleCheck": true
    },
    {
        "dataID": "115159",
        "id": "53053647",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 13:06:11",
        "brokerTime": "2025-05-14 13:06:11",
        "commission": -1.19,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56026501",
        "positionId": "56026501",
        "volume": 0.17,
        "price": 3230.75,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3330.75,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -1.19,
        "priceIn": 3230.75,
        "doubleCheck": true
    },
    {
        "dataID": "115160",
        "id": "53053652",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 13:06:36",
        "brokerTime": "2025-05-14 13:06:36",
        "commission": -3.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56026506",
        "positionId": "56026506",
        "volume": 0.54,
        "price": 3230.41,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -3.78,
        "priceIn": 3230.41,
        "doubleCheck": true
    },
    {
        "dataID": "115161",
        "id": "53053653",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 13:06:36",
        "brokerTime": "2025-05-14 13:06:36",
        "commission": -3.78,
        "swap": 0,
        "profit": -11.34,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56026507",
        "positionId": "56026506",
        "volume": 0.54,
        "price": 3230.62,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -15.12,
        "priceIn": 3230.41,
        "doubleCheck": true,
        "isShow": false,
        "collapseIndex": "0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19",
        "tProfit": -107.84,
        "tnProfit": -140.32,
        "tVolume": 4.64,
        "tTrades": 11
    },
    {
        "dataID": "115162",
        "id": "53053654",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 13:06:37",
        "brokerTime": "2025-05-14 13:06:37",
        "commission": -3.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56026508",
        "positionId": "56026508",
        "volume": 0.54,
        "price": 3230.41,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -3.78,
        "priceIn": 3230.41,
        "doubleCheck": true
    },
    {
        "dataID": "115163",
        "id": "53053655",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 13:06:37",
        "brokerTime": "2025-05-14 13:06:37",
        "commission": -3.78,
        "swap": 0,
        "profit": -11.34,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56026509",
        "positionId": "56026508",
        "volume": 0.54,
        "price": 3230.62,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -15.12,
        "priceIn": 3230.41,
        "doubleCheck": true
    },
    {
        "dataID": "115164",
        "id": "53053656",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 13:06:37",
        "brokerTime": "2025-05-14 13:06:37",
        "commission": -3.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56026510",
        "positionId": "56026510",
        "volume": 0.54,
        "price": 3230.59,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -3.78,
        "priceIn": 3230.59,
        "doubleCheck": true
    },
    {
        "dataID": "115165",
        "id": "53053657",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 13:06:37",
        "brokerTime": "2025-05-14 13:06:37",
        "commission": -3.78,
        "swap": 0,
        "profit": -16.2,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56026511",
        "positionId": "56026510",
        "volume": 0.54,
        "price": 3230.89,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -19.98,
        "priceIn": 3230.59,
        "doubleCheck": true
    },
    {
        "dataID": "115166",
        "id": "53053658",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 13:06:38",
        "brokerTime": "2025-05-14 13:06:38",
        "commission": -3.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56026512",
        "positionId": "56026512",
        "volume": 0.54,
        "price": 3230.68,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -3.78,
        "priceIn": 3230.68,
        "doubleCheck": true
    },
    {
        "dataID": "115167",
        "id": "53053659",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 13:06:38",
        "brokerTime": "2025-05-14 13:06:38",
        "commission": -3.78,
        "swap": 0,
        "profit": -10.8,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56026513",
        "positionId": "56026512",
        "volume": 0.54,
        "price": 3230.88,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -14.58,
        "priceIn": 3230.68,
        "doubleCheck": true
    },
    {
        "dataID": "115168",
        "id": "53053661",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 13:06:41",
        "brokerTime": "2025-05-14 13:06:41",
        "commission": -3.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56026515",
        "positionId": "56026515",
        "volume": 0.54,
        "price": 3230.58,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -3.78,
        "priceIn": 3230.58,
        "doubleCheck": true
    },
    {
        "dataID": "115169",
        "id": "53053662",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 13:06:41",
        "brokerTime": "2025-05-14 13:06:41",
        "commission": -3.78,
        "swap": 0,
        "profit": -11.88,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56026516",
        "positionId": "56026515",
        "volume": 0.54,
        "price": 3230.8,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -15.66,
        "priceIn": 3230.58,
        "doubleCheck": true
    },
    {
        "dataID": "115170",
        "id": "53053663",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 13:06:41",
        "brokerTime": "2025-05-14 13:06:41",
        "commission": -3.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56026518",
        "positionId": "56026518",
        "volume": 0.54,
        "price": 3230.6,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -3.78,
        "priceIn": 3230.6,
        "doubleCheck": true
    },
    {
        "dataID": "115171",
        "id": "53053665",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 13:06:41",
        "brokerTime": "2025-05-14 13:06:41",
        "commission": -3.78,
        "swap": 0,
        "profit": -11.34,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56026519",
        "positionId": "56026518",
        "volume": 0.54,
        "price": 3230.81,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -15.12,
        "priceIn": 3230.6,
        "doubleCheck": true
    },
    {
        "dataID": "115172",
        "id": "53053666",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 13:06:42",
        "brokerTime": "2025-05-14 13:06:42",
        "commission": -3.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56026520",
        "positionId": "56026520",
        "volume": 0.54,
        "price": 3230.6,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -3.78,
        "priceIn": 3230.6,
        "doubleCheck": true
    },
    {
        "dataID": "115173",
        "id": "53053667",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 13:06:42",
        "brokerTime": "2025-05-14 13:06:42",
        "commission": -3.78,
        "swap": 0,
        "profit": -10.26,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56026521",
        "positionId": "56026520",
        "volume": 0.54,
        "price": 3230.79,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -14.04,
        "priceIn": 3230.6,
        "doubleCheck": true
    },
    {
        "dataID": "115174",
        "id": "53053668",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 13:06:42",
        "brokerTime": "2025-05-14 13:06:42",
        "commission": -3.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56026522",
        "positionId": "56026522",
        "volume": 0.54,
        "price": 3230.67,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -3.78,
        "priceIn": 3230.67,
        "doubleCheck": true
    },
    {
        "dataID": "115175",
        "id": "53053669",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 13:06:42",
        "brokerTime": "2025-05-14 13:06:42",
        "commission": -3.78,
        "swap": 0,
        "profit": -11.34,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56026523",
        "positionId": "56026522",
        "volume": 0.54,
        "price": 3230.88,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -15.12,
        "priceIn": 3230.67,
        "doubleCheck": true
    },
    {
        "dataID": "115176",
        "id": "53053670",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 13:06:11",
        "brokerTime": "2025-05-14 13:06:43",
        "commission": -1.19,
        "swap": 0,
        "profit": -1.19,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56026524",
        "positionId": "56026501",
        "volume": 0.17,
        "price": 3230.68,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3330.54,
        "brokerComment": "",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -2.38,
        "priceIn": 3230.75,
        "doubleCheck": true,
        "isShow": false,
        "collapseIndex": "0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18",
        "tProfit": -30.87,
        "tnProfit": -35.28,
        "tVolume": 0.63,
        "tTrades": 5
    },
    {
        "dataID": "115177",
        "id": "53053671",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 13:05:59",
        "brokerTime": "2025-05-14 13:06:43",
        "commission": -0.98,
        "swap": 0,
        "profit": -2.8,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56026525",
        "positionId": "56026494",
        "volume": 0.14,
        "price": 3230.68,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3330.54,
        "brokerComment": "",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -3.78,
        "priceIn": 3230.88,
        "doubleCheck": true
    },
    {
        "dataID": "115178",
        "id": "53053672",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 13:00:02",
        "brokerTime": "2025-05-14 13:06:43",
        "commission": -0.84,
        "swap": 0,
        "profit": -19.68,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56026526",
        "positionId": "56025272",
        "volume": 0.12,
        "price": 3230.68,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3330.55,
        "brokerComment": "",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -20.52,
        "priceIn": 3232.32,
        "doubleCheck": true
    },
    {
        "dataID": "115179",
        "id": "53053673",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 13:00:00",
        "brokerTime": "2025-05-14 13:06:43",
        "commission": -0.7,
        "swap": 0,
        "profit": 14.5,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56026527",
        "positionId": "56025216",
        "volume": 0.1,
        "price": 3230.88,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3132.51,
        "brokerComment": "",
        "comment": "Sell Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 13.8,
        "priceIn": 3232.33,
        "doubleCheck": true
    },
    {
        "dataID": "115180",
        "id": "53053674",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 12:59:59",
        "brokerTime": "2025-05-14 13:06:43",
        "commission": -0.7,
        "swap": 0,
        "profit": -18.9,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56026528",
        "positionId": "56025215",
        "volume": 0.1,
        "price": 3230.68,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3330.55,
        "brokerComment": "",
        "comment": "Buy Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -19.599999999999998,
        "priceIn": 3232.57,
        "doubleCheck": true
    },
    {
        "dataID": "115181",
        "id": "53053675",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 13:06:48",
        "brokerTime": "2025-05-14 13:06:48",
        "commission": -0.7,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56026529",
        "positionId": "56026529",
        "volume": 0.1,
        "price": 3231.39,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3331.39,
        "brokerComment": "Buy Order",
        "comment": "Buy Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.7,
        "priceIn": 3231.39,
        "doubleCheck": true
    },
    {
        "dataID": "115182",
        "id": "53053676",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 13:06:49",
        "brokerTime": "2025-05-14 13:06:49",
        "commission": -0.7,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56026530",
        "positionId": "56026530",
        "volume": 0.1,
        "price": 3231.26,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3131.26,
        "brokerComment": "Sell Order",
        "comment": "Sell Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.7,
        "priceIn": 3231.26,
        "doubleCheck": true
    },
    {
        "dataID": "115183",
        "id": "53053678",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 13:07:00",
        "brokerTime": "2025-05-14 13:07:00",
        "commission": -0.84,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56026532",
        "positionId": "56026532",
        "volume": 0.12,
        "price": 3231.69,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3131.69,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.84,
        "priceIn": 3231.69,
        "doubleCheck": true
    },
    {
        "dataID": "115184",
        "id": "53053743",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 13:07:00",
        "brokerTime": "2025-05-14 13:07:16",
        "commission": -0.84,
        "swap": 0,
        "profit": -12.84,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56026577",
        "positionId": "56026532",
        "volume": 0.12,
        "price": 3232.76,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3131.88,
        "brokerComment": "",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -13.68,
        "priceIn": 3231.69,
        "doubleCheck": true
    },
    {
        "dataID": "115185",
        "id": "53053744",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 13:06:49",
        "brokerTime": "2025-05-14 13:07:16",
        "commission": -0.7,
        "swap": 0,
        "profit": -15,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56026578",
        "positionId": "56026530",
        "volume": 0.1,
        "price": 3232.76,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3131.88,
        "brokerComment": "",
        "comment": "Sell Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -15.7,
        "priceIn": 3231.26,
        "doubleCheck": true
    },
    {
        "dataID": "115186",
        "id": "53053745",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 13:06:48",
        "brokerTime": "2025-05-14 13:07:16",
        "commission": -0.7,
        "swap": 0,
        "profit": 11.7,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56026579",
        "positionId": "56026529",
        "volume": 0.1,
        "price": 3232.56,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3331.18,
        "brokerComment": "",
        "comment": "Buy Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 11,
        "priceIn": 3231.39,
        "doubleCheck": true
    },
    {
        "dataID": "115187",
        "id": "53053754",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 13:07:38",
        "brokerTime": "2025-05-14 13:07:38",
        "commission": -0.7,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56026587",
        "positionId": "56026587",
        "volume": 0.1,
        "price": 3233.09,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3333.09,
        "brokerComment": "Buy Order",
        "comment": "Buy Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.7,
        "priceIn": 3233.09,
        "doubleCheck": true
    },
    {
        "dataID": "115188",
        "id": "53053757",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 13:07:39",
        "brokerTime": "2025-05-14 13:07:39",
        "commission": -0.7,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56026589",
        "positionId": "56026589",
        "volume": 0.1,
        "price": 3232.89,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3132.89,
        "brokerComment": "Sell Order",
        "comment": "Sell Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.7,
        "priceIn": 3232.89,
        "doubleCheck": true
    },
    {
        "dataID": "115189",
        "id": "53053769",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 13:08:00",
        "brokerTime": "2025-05-14 13:08:00",
        "commission": -0.84,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56026599",
        "positionId": "56026599",
        "volume": 0.12,
        "price": 3232.8,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3332.72,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.84,
        "priceIn": 3232.8,
        "doubleCheck": true
    },
    {
        "dataID": "115190",
        "id": "53053784",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 13:09:00",
        "brokerTime": "2025-05-14 13:09:00",
        "commission": -0.84,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56026611",
        "positionId": "56026611",
        "volume": 0.12,
        "price": 3233.55,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3133.55,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.84,
        "priceIn": 3233.55,
        "doubleCheck": true
    },
    {
        "dataID": "115191",
        "id": "53053933",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 13:10:54",
        "brokerTime": "2025-05-14 13:10:54",
        "commission": -0.98,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56026721",
        "positionId": "56026721",
        "volume": 0.14,
        "price": 3233.78,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3133.68,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.98,
        "priceIn": 3233.78,
        "doubleCheck": true
    },
    {
        "dataID": "115192",
        "id": "53053935",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 13:10:55",
        "brokerTime": "2025-05-14 13:10:55",
        "commission": -1.47,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56026723",
        "positionId": "56026723",
        "volume": 0.21,
        "price": 3234.02,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -1.47,
        "priceIn": 3234.02,
        "doubleCheck": true
    },
    {
        "dataID": "115193",
        "id": "53054121",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 13:10:55",
        "brokerTime": "2025-05-14 13:11:04",
        "commission": -1.47,
        "swap": 0,
        "profit": -4.41,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56026972",
        "positionId": "56026723",
        "volume": 0.21,
        "price": 3233.81,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -5.88,
        "priceIn": 3234.02,
        "doubleCheck": true,
        "isShow": false,
        "collapseIndex": "0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20",
        "tProfit": -3.07,
        "tnProfit": -7.62,
        "tVolume": 0.6499999999999999,
        "tTrades": 5
    },
    {
        "dataID": "115194",
        "id": "53054122",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 13:10:54",
        "brokerTime": "2025-05-14 13:11:04",
        "commission": -0.98,
        "swap": 0,
        "profit": -3.36,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56026973",
        "positionId": "56026721",
        "volume": 0.14,
        "price": 3234.02,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3133.96,
        "brokerComment": "",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -4.34,
        "priceIn": 3233.78,
        "doubleCheck": true,
        "isShow": false,
        "collapseIndex": "0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21",
        "tProfit": -19.08,
        "tnProfit": -23.49,
        "tVolume": 0.63,
        "tTrades": 9
    },
    {
        "dataID": "115195",
        "id": "53054123",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 13:09:00",
        "brokerTime": "2025-05-14 13:11:04",
        "commission": -0.84,
        "swap": 0,
        "profit": -5.64,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56026974",
        "positionId": "56026611",
        "volume": 0.12,
        "price": 3234.02,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3133.96,
        "brokerComment": "",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -6.4799999999999995,
        "priceIn": 3233.55,
        "doubleCheck": true
    },
    {
        "dataID": "115196",
        "id": "53054124",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 13:08:00",
        "brokerTime": "2025-05-14 13:11:04",
        "commission": -0.84,
        "swap": 0,
        "profit": 12.12,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56026975",
        "positionId": "56026599",
        "volume": 0.12,
        "price": 3233.81,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3332.6,
        "brokerComment": "",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 11.28,
        "priceIn": 3232.8,
        "doubleCheck": true
    },
    {
        "dataID": "115197",
        "id": "53054125",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 13:07:39",
        "brokerTime": "2025-05-14 13:11:04",
        "commission": -0.7,
        "swap": 0,
        "profit": -11.3,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56026976",
        "positionId": "56026589",
        "volume": 0.1,
        "price": 3234.02,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3134.04,
        "brokerComment": "",
        "comment": "Sell Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -12,
        "priceIn": 3232.89,
        "doubleCheck": true
    },
    {
        "dataID": "115198",
        "id": "53054126",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 13:07:38",
        "brokerTime": "2025-05-14 13:11:04",
        "commission": -0.7,
        "swap": 0,
        "profit": 7.2,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56026977",
        "positionId": "56026587",
        "volume": 0.1,
        "price": 3233.81,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3332.6,
        "brokerComment": "",
        "comment": "Buy Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 6.5,
        "priceIn": 3233.09,
        "doubleCheck": true
    },
    {
        "dataID": "115199",
        "id": "53054132",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 13:11:10",
        "brokerTime": "2025-05-14 13:11:10",
        "commission": -0.7,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56026981",
        "positionId": "56026981",
        "volume": 0.1,
        "price": 3234.06,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3334.06,
        "brokerComment": "Buy Order",
        "comment": "Buy Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.7,
        "priceIn": 3234.06,
        "doubleCheck": true
    },
    {
        "dataID": "115200",
        "id": "53054133",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 13:11:11",
        "brokerTime": "2025-05-14 13:11:11",
        "commission": -0.7,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56026982",
        "positionId": "56026982",
        "volume": 0.1,
        "price": 3233.85,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3133.85,
        "brokerComment": "Sell Order",
        "comment": "Sell Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.7,
        "priceIn": 3233.85,
        "doubleCheck": true
    },
    {
        "dataID": "115201",
        "id": "53054134",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 13:11:13",
        "brokerTime": "2025-05-14 13:11:13",
        "commission": -0.84,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56026983",
        "positionId": "56026983",
        "volume": 0.12,
        "price": 3233.88,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3333.86,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.84,
        "priceIn": 3233.88,
        "doubleCheck": true
    },
    {
        "dataID": "115202",
        "id": "53054137",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 13:11:16",
        "brokerTime": "2025-05-14 13:11:16",
        "commission": -0.28,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56026985",
        "positionId": "56026985",
        "volume": 0.04,
        "price": 3233.35,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "Manual BT",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.28,
        "priceIn": 3233.35,
        "doubleCheck": true
    },
    {
        "dataID": "115203",
        "id": "53054138",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 13:11:16",
        "brokerTime": "2025-05-14 13:11:16",
        "commission": -0.28,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56026986",
        "positionId": "56026986",
        "volume": 0.04,
        "price": 3233.35,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "Manual BT",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.28,
        "priceIn": 3233.35,
        "doubleCheck": true
    },
    {
        "dataID": "115204",
        "id": "53054139",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 13:11:17",
        "brokerTime": "2025-05-14 13:11:17",
        "commission": -0.21,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56026987",
        "positionId": "56026987",
        "volume": 0.03,
        "price": 3233.35,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "Manual BT",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.21,
        "priceIn": 3233.35,
        "doubleCheck": true
    },
    {
        "dataID": "115205",
        "id": "53054140",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 13:11:17",
        "brokerTime": "2025-05-14 13:11:17",
        "commission": -0.21,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56026988",
        "positionId": "56026988",
        "volume": 0.03,
        "price": 3233.35,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "Manual BT",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.21,
        "priceIn": 3233.35,
        "doubleCheck": true
    },
    {
        "dataID": "115206",
        "id": "53054141",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 13:11:17",
        "brokerTime": "2025-05-14 13:11:17",
        "commission": -0.21,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56026989",
        "positionId": "56026989",
        "volume": 0.03,
        "price": 3233.35,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "Manual BT",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.21,
        "priceIn": 3233.35,
        "doubleCheck": true
    },
    {
        "dataID": "115207",
        "id": "53054142",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 13:11:17",
        "brokerTime": "2025-05-14 13:11:17",
        "commission": -0.21,
        "swap": 0,
        "profit": -0.66,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56026990",
        "positionId": "56026989",
        "volume": 0.03,
        "price": 3233.57,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.87,
        "priceIn": 3233.35,
        "doubleCheck": true
    },
    {
        "dataID": "115208",
        "id": "53054143",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 13:11:17",
        "brokerTime": "2025-05-14 13:11:17",
        "commission": -0.21,
        "swap": 0,
        "profit": -0.66,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56026991",
        "positionId": "56026988",
        "volume": 0.03,
        "price": 3233.57,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.87,
        "priceIn": 3233.35,
        "doubleCheck": true
    },
    {
        "dataID": "115209",
        "id": "53054144",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 13:11:17",
        "brokerTime": "2025-05-14 13:11:17",
        "commission": -0.21,
        "swap": 0,
        "profit": -0.66,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56026992",
        "positionId": "56026987",
        "volume": 0.03,
        "price": 3233.57,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.87,
        "priceIn": 3233.35,
        "doubleCheck": true
    },
    {
        "dataID": "115210",
        "id": "53054145",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 13:11:16",
        "brokerTime": "2025-05-14 13:11:17",
        "commission": -0.28,
        "swap": 0,
        "profit": -0.88,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56026993",
        "positionId": "56026986",
        "volume": 0.04,
        "price": 3233.57,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -1.1600000000000001,
        "priceIn": 3233.35,
        "doubleCheck": true
    },
    {
        "dataID": "115211",
        "id": "53054146",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 13:11:16",
        "brokerTime": "2025-05-14 13:11:17",
        "commission": -0.28,
        "swap": 0,
        "profit": -0.92,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56026994",
        "positionId": "56026985",
        "volume": 0.04,
        "price": 3233.58,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -1.2000000000000002,
        "priceIn": 3233.35,
        "doubleCheck": true
    },
    {
        "dataID": "115212",
        "id": "53054147",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 13:11:13",
        "brokerTime": "2025-05-14 13:11:22",
        "commission": -0.84,
        "swap": 0,
        "profit": -8.88,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56026995",
        "positionId": "56026983",
        "volume": 0.12,
        "price": 3233.14,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3333.68,
        "brokerComment": "",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -9.72,
        "priceIn": 3233.88,
        "doubleCheck": true
    },
    {
        "dataID": "115213",
        "id": "53054148",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 13:11:11",
        "brokerTime": "2025-05-14 13:11:22",
        "commission": -0.7,
        "swap": 0,
        "profit": 5,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56026996",
        "positionId": "56026982",
        "volume": 0.1,
        "price": 3233.35,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3134.05,
        "brokerComment": "",
        "comment": "Sell Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 4.3,
        "priceIn": 3233.85,
        "doubleCheck": true
    },
    {
        "dataID": "115214",
        "id": "53054149",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 13:11:10",
        "brokerTime": "2025-05-14 13:11:22",
        "commission": -0.7,
        "swap": 0,
        "profit": -9.1,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56026997",
        "positionId": "56026981",
        "volume": 0.1,
        "price": 3233.15,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3333.68,
        "brokerComment": "",
        "comment": "Buy Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -9.799999999999999,
        "priceIn": 3234.06,
        "doubleCheck": true
    },
    {
        "dataID": "115215",
        "id": "53055426",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 13:17:06",
        "brokerTime": "2025-05-14 13:17:06",
        "commission": -0.7,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56027913",
        "positionId": "56027913",
        "volume": 0.1,
        "price": 3233.57,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3333.57,
        "brokerComment": "Buy Order",
        "comment": "Buy Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.7,
        "priceIn": 3233.57,
        "doubleCheck": true
    },
    {
        "dataID": "115216",
        "id": "53055440",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 13:17:07",
        "brokerTime": "2025-05-14 13:17:07",
        "commission": -0.7,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56027921",
        "positionId": "56027921",
        "volume": 0.1,
        "price": 3233.37,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3133.37,
        "brokerComment": "Sell Order",
        "comment": "Sell Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.7,
        "priceIn": 3233.37,
        "doubleCheck": true
    },
    {
        "dataID": "115217",
        "id": "53055444",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 13:17:34",
        "brokerTime": "2025-05-14 13:17:34",
        "commission": -0.84,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56027925",
        "positionId": "56027925",
        "volume": 0.12,
        "price": 3234.38,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3134.38,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.84,
        "priceIn": 3234.38,
        "doubleCheck": true
    },
    {
        "dataID": "115218",
        "id": "53055844",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 13:20:34",
        "brokerTime": "2025-05-14 13:20:34",
        "commission": -0.7,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUEUR.PRO",
        "magic": "0",
        "orderId": "56028230",
        "positionId": "56028230",
        "volume": 0.1,
        "price": 2878.18,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2978.18,
        "brokerComment": "Buy Order",
        "comment": "Buy Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.7,
        "priceIn": 2878.18,
        "doubleCheck": true
    },
    {
        "dataID": "115219",
        "id": "53055845",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 13:20:35",
        "brokerTime": "2025-05-14 13:20:35",
        "commission": -0.7,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUEUR.PRO",
        "magic": "0",
        "orderId": "56028231",
        "positionId": "56028231",
        "volume": 0.1,
        "price": 2877.98,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2777.98,
        "brokerComment": "Sell Order",
        "comment": "Sell Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.7,
        "priceIn": 2877.98,
        "doubleCheck": true
    },
    {
        "dataID": "115220",
        "id": "53057077",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 13:28:43",
        "brokerTime": "2025-05-14 13:28:43",
        "commission": -0.84,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUEUR.PRO",
        "magic": "0",
        "orderId": "56029147",
        "positionId": "56029147",
        "volume": 0.12,
        "price": 2877.15,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2977.15,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.84,
        "priceIn": 2877.15,
        "doubleCheck": true
    },
    {
        "dataID": "115221",
        "id": "53057083",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 13:29:43",
        "brokerTime": "2025-05-14 13:29:43",
        "commission": -0.84,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56029153",
        "positionId": "56029153",
        "volume": 0.12,
        "price": 3232.5,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3332.5,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.84,
        "priceIn": 3232.5,
        "doubleCheck": true
    },
    {
        "dataID": "115222",
        "id": "53057149",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 13:32:21",
        "brokerTime": "2025-05-14 13:32:21",
        "commission": -0.98,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUEUR.PRO",
        "magic": "0",
        "orderId": "56029216",
        "positionId": "56029216",
        "volume": 0.14,
        "price": 2876.14,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2976.14,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.98,
        "priceIn": 2876.14,
        "doubleCheck": true
    },
    {
        "dataID": "115223",
        "id": "53057165",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 13:33:04",
        "brokerTime": "2025-05-14 13:33:04",
        "commission": -1.19,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUEUR.PRO",
        "magic": "0",
        "orderId": "56029233",
        "positionId": "56029233",
        "volume": 0.17,
        "price": 2875.11,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2975.11,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -1.19,
        "priceIn": 2875.11,
        "doubleCheck": true
    },
    {
        "dataID": "115224",
        "id": "53057178",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 13:34:19",
        "brokerTime": "2025-05-14 13:34:19",
        "commission": -0.98,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56029246",
        "positionId": "56029246",
        "volume": 0.14,
        "price": 3231.25,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3331.25,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.98,
        "priceIn": 3231.25,
        "doubleCheck": true
    },
    {
        "dataID": "115225",
        "id": "53057514",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 13:39:36",
        "brokerTime": "2025-05-14 13:39:36",
        "commission": -0.84,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUEUR.PRO",
        "magic": "0",
        "orderId": "56029504",
        "positionId": "56029504",
        "volume": 0.12,
        "price": 2879,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2779,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.84,
        "priceIn": 2879,
        "doubleCheck": true
    },
    {
        "dataID": "115226",
        "id": "53057517",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 13:33:04",
        "brokerTime": "2025-05-14 13:39:37",
        "commission": -1.19,
        "swap": 0,
        "profit": 61.49,
        "symbol": "XAUEUR.PRO",
        "magic": "0",
        "orderId": "56029506",
        "positionId": "56029233",
        "volume": 0.17,
        "price": 2878.33,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2974.84,
        "brokerComment": "",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 60.300000000000004,
        "priceIn": 2875.11,
        "doubleCheck": true,
        "isShow": false,
        "collapseIndex": "0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22",
        "tProfit": 107.59,
        "tnProfit": 103.88,
        "tVolume": 0.53,
        "tTrades": 4
    },
    {
        "dataID": "115227",
        "id": "53057518",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 13:32:21",
        "brokerTime": "2025-05-14 13:39:37",
        "commission": -0.98,
        "swap": 0,
        "profit": 34.44,
        "symbol": "XAUEUR.PRO",
        "magic": "0",
        "orderId": "56029507",
        "positionId": "56029216",
        "volume": 0.14,
        "price": 2878.33,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2974.84,
        "brokerComment": "",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 33.46,
        "priceIn": 2876.14,
        "doubleCheck": true
    },
    {
        "dataID": "115228",
        "id": "53057519",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 13:28:43",
        "brokerTime": "2025-05-14 13:39:37",
        "commission": -0.84,
        "swap": 0,
        "profit": 12.67,
        "symbol": "XAUEUR.PRO",
        "magic": "0",
        "orderId": "56029508",
        "positionId": "56029147",
        "volume": 0.12,
        "price": 2878.09,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2974.84,
        "brokerComment": "",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 11.83,
        "priceIn": 2877.15,
        "doubleCheck": true
    },
    {
        "dataID": "115229",
        "id": "53057520",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 13:20:34",
        "brokerTime": "2025-05-14 13:39:37",
        "commission": -0.7,
        "swap": 0,
        "profit": -1.01,
        "symbol": "XAUEUR.PRO",
        "magic": "0",
        "orderId": "56029509",
        "positionId": "56028230",
        "volume": 0.1,
        "price": 2878.09,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2974.84,
        "brokerComment": "",
        "comment": "Buy Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -1.71,
        "priceIn": 2878.18,
        "doubleCheck": true
    },
    {
        "dataID": "115230",
        "id": "53057523",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 13:39:43",
        "brokerTime": "2025-05-14 13:39:43",
        "commission": -0.7,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUEUR.PRO",
        "magic": "0",
        "orderId": "56029512",
        "positionId": "56029512",
        "volume": 0.1,
        "price": 2878.15,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "RR",
        "comment": "RR",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.7,
        "priceIn": 2878.15,
        "doubleCheck": true
    },
    {
        "dataID": "115231",
        "id": "53057556",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 13:42:57",
        "brokerTime": "2025-05-14 13:42:57",
        "commission": -0.84,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUEUR.PRO",
        "magic": "0",
        "orderId": "56029550",
        "positionId": "56029550",
        "volume": 0.12,
        "price": 2877.12,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2977.12,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.84,
        "priceIn": 2877.12,
        "doubleCheck": true
    },
    {
        "dataID": "115232",
        "id": "53058294",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 13:49:28",
        "brokerTime": "2025-05-14 13:49:28",
        "commission": -1.19,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56030064",
        "positionId": "56030064",
        "volume": 0.17,
        "price": 3230.25,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3330.25,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -1.19,
        "priceIn": 3230.25,
        "doubleCheck": true
    },
    {
        "dataID": "115233",
        "id": "53058565",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 13:17:34",
        "brokerTime": "2025-05-14 13:50:18",
        "commission": -0.84,
        "swap": 0,
        "profit": 37.68,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56030262",
        "positionId": "56027925",
        "volume": 0.12,
        "price": 3231.24,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3134.6,
        "brokerComment": "",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 36.839999999999996,
        "priceIn": 3234.38,
        "doubleCheck": true,
        "isShow": false,
        "collapseIndex": "0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23",
        "tProfit": 58.98,
        "tnProfit": 57.44,
        "tVolume": 0.22,
        "tTrades": 2
    },
    {
        "dataID": "115234",
        "id": "53058566",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 13:17:07",
        "brokerTime": "2025-05-14 13:50:18",
        "commission": -0.7,
        "swap": 0,
        "profit": 21.3,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56030263",
        "positionId": "56027921",
        "volume": 0.1,
        "price": 3231.24,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3134.6,
        "brokerComment": "",
        "comment": "Sell Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 20.6,
        "priceIn": 3233.37,
        "doubleCheck": true
    },
    {
        "dataID": "115235",
        "id": "53058575",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 13:50:24",
        "brokerTime": "2025-05-14 13:50:24",
        "commission": -0.7,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56030272",
        "positionId": "56030272",
        "volume": 0.1,
        "price": 3231.16,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "RR",
        "comment": "RR",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.7,
        "priceIn": 3231.16,
        "doubleCheck": true
    },
    {
        "dataID": "115236",
        "id": "53058775",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 13:52:39",
        "brokerTime": "2025-05-14 13:52:39",
        "commission": -0.84,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56030411",
        "positionId": "56030411",
        "volume": 0.12,
        "price": 3232.18,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3132.18,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.84,
        "priceIn": 3232.18,
        "doubleCheck": true
    },
    {
        "dataID": "115237",
        "id": "53058827",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 13:54:55",
        "brokerTime": "2025-05-14 13:54:55",
        "commission": -0.98,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56030465",
        "positionId": "56030465",
        "volume": 0.14,
        "price": 3233.24,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3133.24,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.98,
        "priceIn": 3233.24,
        "doubleCheck": true
    },
    {
        "dataID": "115238",
        "id": "53058846",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 13:55:58",
        "brokerTime": "2025-05-14 13:55:58",
        "commission": -1.19,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56030482",
        "positionId": "56030482",
        "volume": 0.17,
        "price": 3234.34,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3134.34,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -1.19,
        "priceIn": 3234.34,
        "doubleCheck": true
    },
    {
        "dataID": "115239",
        "id": "53058863",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 13:57:28",
        "brokerTime": "2025-05-14 13:57:28",
        "commission": -1.47,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56030496",
        "positionId": "56030496",
        "volume": 0.21,
        "price": 3235.38,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3135.38,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -1.47,
        "priceIn": 3235.38,
        "doubleCheck": true
    },
    {
        "dataID": "115240",
        "id": "53058888",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 13:57:59",
        "brokerTime": "2025-05-14 13:57:59",
        "commission": -0.98,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUEUR.PRO",
        "magic": "0",
        "orderId": "56030517",
        "positionId": "56030517",
        "volume": 0.14,
        "price": 2880.06,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2780.06,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.98,
        "priceIn": 2880.06,
        "doubleCheck": true
    },
    {
        "dataID": "115241",
        "id": "53058912",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 13:49:28",
        "brokerTime": "2025-05-14 13:59:05",
        "commission": -1.19,
        "swap": 0,
        "profit": 86.02,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56030539",
        "positionId": "56030064",
        "volume": 0.17,
        "price": 3235.31,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3330.05,
        "brokerComment": "",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 84.83,
        "priceIn": 3230.25,
        "doubleCheck": true,
        "isShow": false,
        "collapseIndex": "0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24",
        "tProfit": 193.98,
        "tnProfit": 190.27,
        "tVolume": 0.53,
        "tTrades": 4
    },
    {
        "dataID": "115242",
        "id": "53058913",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 13:34:19",
        "brokerTime": "2025-05-14 13:59:05",
        "commission": -0.98,
        "swap": 0,
        "profit": 56.84,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56030540",
        "positionId": "56029246",
        "volume": 0.14,
        "price": 3235.31,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3330.05,
        "brokerComment": "",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 55.86000000000001,
        "priceIn": 3231.25,
        "doubleCheck": true
    },
    {
        "dataID": "115243",
        "id": "53058914",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 13:29:43",
        "brokerTime": "2025-05-14 13:59:05",
        "commission": -0.84,
        "swap": 0,
        "profit": 33.72,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56030541",
        "positionId": "56029153",
        "volume": 0.12,
        "price": 3235.31,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3330.05,
        "brokerComment": "",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 32.879999999999995,
        "priceIn": 3232.5,
        "doubleCheck": true
    },
    {
        "dataID": "115244",
        "id": "53058915",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 13:17:06",
        "brokerTime": "2025-05-14 13:59:05",
        "commission": -0.7,
        "swap": 0,
        "profit": 17.4,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56030542",
        "positionId": "56027913",
        "volume": 0.1,
        "price": 3235.31,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3330.05,
        "brokerComment": "",
        "comment": "Buy Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 16.7,
        "priceIn": 3233.57,
        "doubleCheck": true
    },
    {
        "dataID": "115245",
        "id": "53058916",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 13:59:12",
        "brokerTime": "2025-05-14 13:59:12",
        "commission": -0.7,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56030544",
        "positionId": "56030544",
        "volume": 0.1,
        "price": 3235.77,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "RR",
        "comment": "RR",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.7,
        "priceIn": 3235.77,
        "doubleCheck": true
    },
    {
        "dataID": "115246",
        "id": "53058917",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 13:59:29",
        "brokerTime": "2025-05-14 13:59:29",
        "commission": -1.19,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUEUR.PRO",
        "magic": "0",
        "orderId": "56030546",
        "positionId": "56030546",
        "volume": 0.17,
        "price": 2881.09,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2781.09,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -1.19,
        "priceIn": 2881.09,
        "doubleCheck": true
    },
    {
        "dataID": "115247",
        "id": "53058918",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 13:59:39",
        "brokerTime": "2025-05-14 13:59:39",
        "commission": -1.75,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56030547",
        "positionId": "56030547",
        "volume": 0.25,
        "price": 3236.41,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3136.41,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -1.75,
        "priceIn": 3236.41,
        "doubleCheck": true
    },
    {
        "dataID": "115248",
        "id": "53059965",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 14:01:00",
        "brokerTime": "2025-05-14 14:01:00",
        "commission": -0.84,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56031491",
        "positionId": "56031491",
        "volume": 0.12,
        "price": 3234.69,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3334.67,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.84,
        "priceIn": 3234.69,
        "doubleCheck": true
    },
    {
        "dataID": "115249",
        "id": "53059989",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 13:42:57",
        "brokerTime": "2025-05-14 14:02:33",
        "commission": -0.84,
        "swap": 0,
        "profit": 42.19,
        "symbol": "XAUEUR.PRO",
        "magic": "0",
        "orderId": "56031514",
        "positionId": "56029550",
        "volume": 0.12,
        "price": 2880.25,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2976.87,
        "brokerComment": "",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 41.349999999999994,
        "priceIn": 2877.12,
        "doubleCheck": true,
        "isShow": false,
        "collapseIndex": "0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25",
        "tProfit": 65.78,
        "tnProfit": 64.24,
        "tVolume": 0.22,
        "tTrades": 2
    },
    {
        "dataID": "115250",
        "id": "53059990",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 13:39:43",
        "brokerTime": "2025-05-14 14:02:33",
        "commission": -0.7,
        "swap": 0,
        "profit": 23.59,
        "symbol": "XAUEUR.PRO",
        "magic": "0",
        "orderId": "56031515",
        "positionId": "56029512",
        "volume": 0.1,
        "price": 2880.25,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2976.87,
        "brokerComment": "",
        "comment": "RR",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 22.89,
        "priceIn": 2878.15,
        "doubleCheck": true
    },
    {
        "dataID": "115251",
        "id": "53059991",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 14:02:40",
        "brokerTime": "2025-05-14 14:02:40",
        "commission": -0.7,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUEUR.PRO",
        "magic": "0",
        "orderId": "56031516",
        "positionId": "56031516",
        "volume": 0.1,
        "price": 2880.64,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "RR",
        "comment": "RR",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.7,
        "priceIn": 2880.64,
        "doubleCheck": true
    },
    {
        "dataID": "115252",
        "id": "53060775",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:09:11",
        "brokerTime": "2025-05-14 14:09:11",
        "commission": -1.47,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUEUR.PRO",
        "magic": "0",
        "orderId": "56032160",
        "positionId": "56032160",
        "volume": 0.21,
        "price": 2882.15,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2782.15,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -1.47,
        "priceIn": 2882.15,
        "doubleCheck": true
    },
    {
        "dataID": "115253",
        "id": "53061646",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:13:21",
        "brokerTime": "2025-05-14 14:13:21",
        "commission": -2.1,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56032843",
        "positionId": "56032843",
        "volume": 0.3,
        "price": 3237.47,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3137.47,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -2.1,
        "priceIn": 3237.47,
        "doubleCheck": true
    },
    {
        "dataID": "115254",
        "id": "53061651",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:13:35",
        "brokerTime": "2025-05-14 14:13:35",
        "commission": -1.75,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUEUR.PRO",
        "magic": "0",
        "orderId": "56032846",
        "positionId": "56032846",
        "volume": 0.25,
        "price": 2883.16,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2783.16,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -1.75,
        "priceIn": 2883.16,
        "doubleCheck": true
    },
    {
        "dataID": "115255",
        "id": "53062152",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:15:56",
        "brokerTime": "2025-05-14 14:15:56",
        "commission": -2.1,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUEUR.PRO",
        "magic": "0",
        "orderId": "56033307",
        "positionId": "56033307",
        "volume": 0.3,
        "price": 2884.25,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2784.23,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -2.1,
        "priceIn": 2884.25,
        "doubleCheck": true
    },
    {
        "dataID": "115256",
        "id": "53063472",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:17:17",
        "brokerTime": "2025-05-14 14:17:17",
        "commission": -2.52,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUEUR.PRO",
        "magic": "0",
        "orderId": "56034354",
        "positionId": "56034354",
        "volume": 0.36,
        "price": 2885.33,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2785.33,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -2.52,
        "priceIn": 2885.33,
        "doubleCheck": true
    },
    {
        "dataID": "115257",
        "id": "53084036",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:24:24",
        "brokerTime": "2025-05-14 14:24:24",
        "commission": -2.52,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56048114",
        "positionId": "56048114",
        "volume": 0.36,
        "price": 3238.53,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3138.53,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -2.52,
        "priceIn": 3238.53,
        "doubleCheck": true
    },
    {
        "dataID": "115258",
        "id": "53084240",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 14:01:00",
        "brokerTime": "2025-05-14 14:26:29",
        "commission": -0.84,
        "swap": 0,
        "profit": 36.84,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56048270",
        "positionId": "56031491",
        "volume": 0.12,
        "price": 3237.76,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3334.5,
        "brokerComment": "",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 36,
        "priceIn": 3234.69,
        "doubleCheck": true,
        "isShow": false,
        "collapseIndex": "0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26",
        "tProfit": 56.74,
        "tnProfit": 55.2,
        "tVolume": 0.22,
        "tTrades": 2
    },
    {
        "dataID": "115259",
        "id": "53084241",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 13:59:12",
        "brokerTime": "2025-05-14 14:26:29",
        "commission": -0.7,
        "swap": 0,
        "profit": 19.9,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56048271",
        "positionId": "56030544",
        "volume": 0.1,
        "price": 3237.76,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3334.5,
        "brokerComment": "",
        "comment": "RR",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 19.2,
        "priceIn": 3235.77,
        "doubleCheck": true
    },
    {
        "dataID": "115260",
        "id": "53084242",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 14:26:36",
        "brokerTime": "2025-05-14 14:26:36",
        "commission": -0.7,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56048272",
        "positionId": "56048272",
        "volume": 0.1,
        "price": 3238.09,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "RR",
        "comment": "RR",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.7,
        "priceIn": 3238.09,
        "doubleCheck": true
    },
    {
        "dataID": "115261",
        "id": "53084247",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:27:25",
        "brokerTime": "2025-05-14 14:27:25",
        "commission": -3.01,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUEUR.PRO",
        "magic": "0",
        "orderId": "56048276",
        "positionId": "56048276",
        "volume": 0.43,
        "price": 2886.34,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2786.34,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -3.01,
        "priceIn": 2886.34,
        "doubleCheck": true
    },
    {
        "dataID": "115262",
        "id": "53084248",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 14:27:25",
        "brokerTime": "2025-05-14 14:27:25",
        "commission": -16.8,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUEUR.PRO",
        "magic": "0",
        "orderId": "56048277",
        "positionId": "56048277",
        "volume": 2.4,
        "price": 2886.55,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -16.8,
        "priceIn": 2886.55,
        "doubleCheck": true
    },
    {
        "dataID": "115263",
        "id": "53084297",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 14:32:18",
        "brokerTime": "2025-05-14 14:32:18",
        "commission": -0.84,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56048322",
        "positionId": "56048322",
        "volume": 0.12,
        "price": 3237.07,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3337.07,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.84,
        "priceIn": 3237.07,
        "doubleCheck": true
    },
    {
        "dataID": "115264",
        "id": "53084350",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 14:27:25",
        "brokerTime": "2025-05-14 14:35:41",
        "commission": -16.8,
        "swap": 0,
        "profit": -829.66,
        "symbol": "XAUEUR.PRO",
        "magic": "0",
        "orderId": "56048373",
        "positionId": "56048277",
        "volume": 2.4,
        "price": 2883.47,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -846.4599999999999,
        "priceIn": 2886.55,
        "doubleCheck": true,
        "tProfit": -829.66,
        "tnProfit": -846.46,
        "tVolume": 2.4,
        "tTrades": 1
    },
    {
        "dataID": "115265",
        "id": "53084351",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 14:35:43",
        "brokerTime": "2025-05-14 14:35:43",
        "commission": -16.8,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUEUR.PRO",
        "magic": "0",
        "orderId": "56048374",
        "positionId": "56048374",
        "volume": 2.4,
        "price": 2883.77,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -16.8,
        "priceIn": 2883.77,
        "doubleCheck": true
    },
    {
        "dataID": "115266",
        "id": "53084468",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 14:36:01",
        "brokerTime": "2025-05-14 14:36:01",
        "commission": -0.98,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56048484",
        "positionId": "56048484",
        "volume": 0.14,
        "price": 3235.96,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3335.96,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.98,
        "priceIn": 3235.96,
        "doubleCheck": true
    },
    {
        "dataID": "115267",
        "id": "53084510",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 14:37:06",
        "brokerTime": "2025-05-14 14:37:06",
        "commission": -1.19,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56048522",
        "positionId": "56048522",
        "volume": 0.17,
        "price": 3234.96,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3334.96,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -1.19,
        "priceIn": 3234.96,
        "doubleCheck": true
    },
    {
        "dataID": "115268",
        "id": "53084526",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:24:24",
        "brokerTime": "2025-05-14 14:37:16",
        "commission": -2.52,
        "swap": 0,
        "profit": 114.48,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56048537",
        "positionId": "56048114",
        "volume": 0.36,
        "price": 3235.35,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3138.67,
        "brokerComment": "",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 111.96000000000001,
        "priceIn": 3238.53,
        "doubleCheck": true,
        "isShow": false,
        "collapseIndex": "0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28",
        "tProfit": 79.3,
        "tnProfit": 67.75,
        "tVolume": 1.65,
        "tTrades": 8
    },
    {
        "dataID": "115269",
        "id": "53084527",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:13:21",
        "brokerTime": "2025-05-14 14:37:16",
        "commission": -2.1,
        "swap": 0,
        "profit": 63.6,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56048538",
        "positionId": "56032843",
        "volume": 0.3,
        "price": 3235.35,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3138.67,
        "brokerComment": "",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 61.5,
        "priceIn": 3237.47,
        "doubleCheck": true
    },
    {
        "dataID": "115270",
        "id": "53084528",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 13:59:39",
        "brokerTime": "2025-05-14 14:37:17",
        "commission": -1.75,
        "swap": 0,
        "profit": 26.5,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56048539",
        "positionId": "56030547",
        "volume": 0.25,
        "price": 3235.35,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3138.67,
        "brokerComment": "",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 24.75,
        "priceIn": 3236.41,
        "doubleCheck": true
    },
    {
        "dataID": "115271",
        "id": "53084529",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 13:57:28",
        "brokerTime": "2025-05-14 14:37:17",
        "commission": -1.47,
        "swap": 0,
        "profit": 0.84,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56048540",
        "positionId": "56030496",
        "volume": 0.21,
        "price": 3235.34,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3138.67,
        "brokerComment": "",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.63,
        "priceIn": 3235.38,
        "doubleCheck": true
    },
    {
        "dataID": "115272",
        "id": "53084530",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 13:55:58",
        "brokerTime": "2025-05-14 14:37:17",
        "commission": -1.19,
        "swap": 0,
        "profit": -17,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56048541",
        "positionId": "56030482",
        "volume": 0.17,
        "price": 3235.34,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3138.63,
        "brokerComment": "",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -18.19,
        "priceIn": 3234.34,
        "doubleCheck": true
    },
    {
        "dataID": "115273",
        "id": "53084531",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 13:54:55",
        "brokerTime": "2025-05-14 14:37:17",
        "commission": -0.98,
        "swap": 0,
        "profit": -29.4,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56048542",
        "positionId": "56030465",
        "volume": 0.14,
        "price": 3235.34,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3138.63,
        "brokerComment": "",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -30.38,
        "priceIn": 3233.24,
        "doubleCheck": true
    },
    {
        "dataID": "115274",
        "id": "53084532",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 13:52:39",
        "brokerTime": "2025-05-14 14:37:17",
        "commission": -0.84,
        "swap": 0,
        "profit": -37.92,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56048543",
        "positionId": "56030411",
        "volume": 0.12,
        "price": 3235.34,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3138.63,
        "brokerComment": "",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -38.760000000000005,
        "priceIn": 3232.18,
        "doubleCheck": true
    },
    {
        "dataID": "115275",
        "id": "53084533",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 13:50:24",
        "brokerTime": "2025-05-14 14:37:17",
        "commission": -0.7,
        "swap": 0,
        "profit": -41.8,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56048544",
        "positionId": "56030272",
        "volume": 0.1,
        "price": 3235.34,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3138.63,
        "brokerComment": "",
        "comment": "RR",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -42.5,
        "priceIn": 3231.16,
        "doubleCheck": true
    },
    {
        "dataID": "115276",
        "id": "53084539",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:37:23",
        "brokerTime": "2025-05-14 14:37:23",
        "commission": -0.7,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56048550",
        "positionId": "56048550",
        "volume": 0.1,
        "price": 3234.54,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "RR",
        "comment": "RR",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.7,
        "priceIn": 3234.54,
        "doubleCheck": true
    },
    {
        "dataID": "115277",
        "id": "53084566",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 14:38:53",
        "brokerTime": "2025-05-14 14:38:53",
        "commission": -1.47,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56048576",
        "positionId": "56048576",
        "volume": 0.21,
        "price": 3233.83,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3333.96,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -1.47,
        "priceIn": 3233.83,
        "doubleCheck": true
    },
    {
        "dataID": "115278",
        "id": "53084778",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 14:42:39",
        "brokerTime": "2025-05-14 14:42:39",
        "commission": -1.75,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56048738",
        "positionId": "56048738",
        "volume": 0.25,
        "price": 3232.72,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3332.72,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -1.75,
        "priceIn": 3232.72,
        "doubleCheck": true
    },
    {
        "dataID": "115279",
        "id": "53084804",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 14:43:00",
        "brokerTime": "2025-05-14 14:43:00",
        "commission": -2.1,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56048759",
        "positionId": "56048759",
        "volume": 0.3,
        "price": 3231.66,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3331.66,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -2.1,
        "priceIn": 3231.66,
        "doubleCheck": true
    },
    {
        "dataID": "115280",
        "id": "53084874",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 14:46:02",
        "brokerTime": "2025-05-14 14:46:02",
        "commission": -2.52,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56048820",
        "positionId": "56048820",
        "volume": 0.36,
        "price": 3230.66,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3330.66,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -2.52,
        "priceIn": 3230.66,
        "doubleCheck": true
    },
    {
        "dataID": "115281",
        "id": "53085036",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 14:47:21",
        "brokerTime": "2025-05-14 14:47:21",
        "commission": -3.01,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56048939",
        "positionId": "56048939",
        "volume": 0.43,
        "price": 3229.65,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3329.65,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -3.01,
        "priceIn": 3229.65,
        "doubleCheck": true
    },
    {
        "dataID": "115282",
        "id": "53085037",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:47:22",
        "brokerTime": "2025-05-14 14:47:22",
        "commission": -16.8,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56048940",
        "positionId": "56048940",
        "volume": 2.4,
        "price": 3229.42,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -16.8,
        "priceIn": 3229.42,
        "doubleCheck": true
    },
    {
        "dataID": "115283",
        "id": "53085038",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:47:22",
        "brokerTime": "2025-05-14 14:47:23",
        "commission": -16.8,
        "swap": 0,
        "profit": -38.4,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56048941",
        "positionId": "56048940",
        "volume": 2.4,
        "price": 3229.58,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -55.2,
        "priceIn": 3229.42,
        "doubleCheck": true,
        "isShow": false,
        "collapseIndex": "0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31",
        "tProfit": -313704.93,
        "tnProfit": -425448.17,
        "tVolume": 15963.319999999949,
        "tTrades": 1970
    },
    {
        "dataID": "115284",
        "id": "53085039",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:47:23",
        "brokerTime": "2025-05-14 14:47:23",
        "commission": -16.8,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56048942",
        "positionId": "56048942",
        "volume": 2.4,
        "price": 3229.34,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -16.8,
        "priceIn": 3229.34,
        "doubleCheck": true
    },
    {
        "dataID": "115285",
        "id": "53085040",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:47:23",
        "brokerTime": "2025-05-14 14:47:24",
        "commission": -16.8,
        "swap": 0,
        "profit": -52.8,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56048943",
        "positionId": "56048942",
        "volume": 2.4,
        "price": 3229.56,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.6,
        "priceIn": 3229.34,
        "doubleCheck": true
    },
    {
        "dataID": "115286",
        "id": "53085041",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:47:24",
        "brokerTime": "2025-05-14 14:47:24",
        "commission": -16.8,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56048944",
        "positionId": "56048944",
        "volume": 2.4,
        "price": 3229.44,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -16.8,
        "priceIn": 3229.44,
        "doubleCheck": true
    },
    {
        "dataID": "115287",
        "id": "53085042",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:47:24",
        "brokerTime": "2025-05-14 14:47:25",
        "commission": -16.8,
        "swap": 0,
        "profit": -96,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56048945",
        "positionId": "56048944",
        "volume": 2.4,
        "price": 3229.84,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -112.8,
        "priceIn": 3229.44,
        "doubleCheck": true
    },
    {
        "dataID": "115288",
        "id": "53085043",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:47:25",
        "brokerTime": "2025-05-14 14:47:25",
        "commission": -16.8,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56048946",
        "positionId": "56048946",
        "volume": 2.4,
        "price": 3229.63,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -16.8,
        "priceIn": 3229.63,
        "doubleCheck": true
    },
    {
        "dataID": "115289",
        "id": "53085044",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:47:25",
        "brokerTime": "2025-05-14 14:47:26",
        "commission": -16.8,
        "swap": 0,
        "profit": -38.4,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56048947",
        "positionId": "56048946",
        "volume": 2.4,
        "price": 3229.79,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -55.2,
        "priceIn": 3229.63,
        "doubleCheck": true
    },
    {
        "dataID": "115290",
        "id": "53085045",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:47:26",
        "brokerTime": "2025-05-14 14:47:26",
        "commission": -16.8,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56048948",
        "positionId": "56048948",
        "volume": 2.4,
        "price": 3229.5,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -16.8,
        "priceIn": 3229.5,
        "doubleCheck": true
    },
    {
        "dataID": "115291",
        "id": "53085046",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:47:26",
        "brokerTime": "2025-05-14 14:47:27",
        "commission": -16.8,
        "swap": 0,
        "profit": -36,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56048949",
        "positionId": "56048948",
        "volume": 2.4,
        "price": 3229.65,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -52.8,
        "priceIn": 3229.5,
        "doubleCheck": true
    },
    {
        "dataID": "115292",
        "id": "53085047",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:47:28",
        "brokerTime": "2025-05-14 14:47:28",
        "commission": -16.8,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56048950",
        "positionId": "56048950",
        "volume": 2.4,
        "price": 3229.45,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -16.8,
        "priceIn": 3229.45,
        "doubleCheck": true
    },
    {
        "dataID": "115293",
        "id": "53085048",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:47:28",
        "brokerTime": "2025-05-14 14:47:29",
        "commission": -16.8,
        "swap": 0,
        "profit": -24,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56048951",
        "positionId": "56048950",
        "volume": 2.4,
        "price": 3229.55,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -40.8,
        "priceIn": 3229.45,
        "doubleCheck": true
    },
    {
        "dataID": "115294",
        "id": "53085049",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:47:30",
        "brokerTime": "2025-05-14 14:47:30",
        "commission": -16.8,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56048952",
        "positionId": "56048952",
        "volume": 2.4,
        "price": 3229.14,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -16.8,
        "priceIn": 3229.14,
        "doubleCheck": true
    },
    {
        "dataID": "115295",
        "id": "53085050",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:47:30",
        "brokerTime": "2025-05-14 14:47:30",
        "commission": -16.8,
        "swap": 0,
        "profit": -50.4,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56048953",
        "positionId": "56048952",
        "volume": 2.4,
        "price": 3229.35,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -67.2,
        "priceIn": 3229.14,
        "doubleCheck": true
    },
    {
        "dataID": "115296",
        "id": "53085051",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:47:36",
        "brokerTime": "2025-05-14 14:47:36",
        "commission": -16.8,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56048954",
        "positionId": "56048954",
        "volume": 2.4,
        "price": 3229.11,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -16.8,
        "priceIn": 3229.11,
        "doubleCheck": true
    },
    {
        "dataID": "115297",
        "id": "53085052",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:47:36",
        "brokerTime": "2025-05-14 14:47:36",
        "commission": -16.8,
        "swap": 0,
        "profit": -57.6,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56048955",
        "positionId": "56048954",
        "volume": 2.4,
        "price": 3229.35,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -74.4,
        "priceIn": 3229.11,
        "doubleCheck": true
    },
    {
        "dataID": "115298",
        "id": "53085053",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:47:37",
        "brokerTime": "2025-05-14 14:47:37",
        "commission": -16.8,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56048956",
        "positionId": "56048956",
        "volume": 2.4,
        "price": 3229.13,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -16.8,
        "priceIn": 3229.13,
        "doubleCheck": true
    },
    {
        "dataID": "115299",
        "id": "53085054",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:47:37",
        "brokerTime": "2025-05-14 14:47:38",
        "commission": -16.8,
        "swap": 0,
        "profit": -79.2,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56048957",
        "positionId": "56048956",
        "volume": 2.4,
        "price": 3229.46,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -96,
        "priceIn": 3229.13,
        "doubleCheck": true
    },
    {
        "dataID": "115300",
        "id": "53085055",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:47:38",
        "brokerTime": "2025-05-14 14:47:38",
        "commission": -16.8,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56048958",
        "positionId": "56048958",
        "volume": 2.4,
        "price": 3229.24,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -16.8,
        "priceIn": 3229.24,
        "doubleCheck": true
    },
    {
        "dataID": "115301",
        "id": "53085056",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:47:38",
        "brokerTime": "2025-05-14 14:47:39",
        "commission": -16.8,
        "swap": 0,
        "profit": -50.4,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56048959",
        "positionId": "56048958",
        "volume": 2.4,
        "price": 3229.45,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -67.2,
        "priceIn": 3229.24,
        "doubleCheck": true
    },
    {
        "dataID": "115302",
        "id": "53085057",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:47:39",
        "brokerTime": "2025-05-14 14:47:39",
        "commission": -16.8,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56048960",
        "positionId": "56048960",
        "volume": 2.4,
        "price": 3229.24,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -16.8,
        "priceIn": 3229.24,
        "doubleCheck": true
    },
    {
        "dataID": "115303",
        "id": "53085058",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:47:39",
        "brokerTime": "2025-05-14 14:47:41",
        "commission": -16.8,
        "swap": 0,
        "profit": -62.4,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56048961",
        "positionId": "56048960",
        "volume": 2.4,
        "price": 3229.5,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -79.2,
        "priceIn": 3229.24,
        "doubleCheck": true
    },
    {
        "dataID": "115304",
        "id": "53085060",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:47:42",
        "brokerTime": "2025-05-14 14:47:42",
        "commission": -16.8,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56048962",
        "positionId": "56048962",
        "volume": 2.4,
        "price": 3229.28,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -16.8,
        "priceIn": 3229.28,
        "doubleCheck": true
    },
    {
        "dataID": "115305",
        "id": "53085061",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:47:42",
        "brokerTime": "2025-05-14 14:47:43",
        "commission": -16.8,
        "swap": 0,
        "profit": -33.6,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56048963",
        "positionId": "56048962",
        "volume": 2.4,
        "price": 3229.42,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -50.400000000000006,
        "priceIn": 3229.28,
        "doubleCheck": true
    },
    {
        "dataID": "115306",
        "id": "53085062",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:47:43",
        "brokerTime": "2025-05-14 14:47:43",
        "commission": -16.8,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56048964",
        "positionId": "56048964",
        "volume": 2.4,
        "price": 3229.22,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -16.8,
        "priceIn": 3229.22,
        "doubleCheck": true
    },
    {
        "dataID": "115307",
        "id": "53085063",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:47:43",
        "brokerTime": "2025-05-14 14:47:44",
        "commission": -16.8,
        "swap": 0,
        "profit": -45.6,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56048965",
        "positionId": "56048964",
        "volume": 2.4,
        "price": 3229.41,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -62.400000000000006,
        "priceIn": 3229.22,
        "doubleCheck": true
    },
    {
        "dataID": "115308",
        "id": "53085064",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:47:44",
        "brokerTime": "2025-05-14 14:47:44",
        "commission": -16.8,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56048966",
        "positionId": "56048966",
        "volume": 2.4,
        "price": 3229.19,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -16.8,
        "priceIn": 3229.19,
        "doubleCheck": true
    },
    {
        "dataID": "115309",
        "id": "53085066",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:47:44",
        "brokerTime": "2025-05-14 14:47:44",
        "commission": -16.8,
        "swap": 0,
        "profit": -40.8,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56048967",
        "positionId": "56048966",
        "volume": 2.4,
        "price": 3229.36,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.599999999999994,
        "priceIn": 3229.19,
        "doubleCheck": true
    },
    {
        "dataID": "115310",
        "id": "53085067",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:47:44",
        "brokerTime": "2025-05-14 14:47:44",
        "commission": -16.8,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56048968",
        "positionId": "56048968",
        "volume": 2.4,
        "price": 3229.12,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -16.8,
        "priceIn": 3229.12,
        "doubleCheck": true
    },
    {
        "dataID": "115311",
        "id": "53085068",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:47:44",
        "brokerTime": "2025-05-14 14:47:45",
        "commission": -16.8,
        "swap": 0,
        "profit": -45.6,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56048969",
        "positionId": "56048968",
        "volume": 2.4,
        "price": 3229.31,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -62.400000000000006,
        "priceIn": 3229.12,
        "doubleCheck": true
    },
    {
        "dataID": "115312",
        "id": "53085069",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:47:46",
        "brokerTime": "2025-05-14 14:47:46",
        "commission": -16.8,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56048970",
        "positionId": "56048970",
        "volume": 2.4,
        "price": 3229.14,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -16.8,
        "priceIn": 3229.14,
        "doubleCheck": true
    },
    {
        "dataID": "115313",
        "id": "53085070",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:47:46",
        "brokerTime": "2025-05-14 14:47:46",
        "commission": -16.8,
        "swap": 0,
        "profit": -36,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56048971",
        "positionId": "56048970",
        "volume": 2.4,
        "price": 3229.29,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -52.8,
        "priceIn": 3229.14,
        "doubleCheck": true
    },
    {
        "dataID": "115314",
        "id": "53085071",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:47:47",
        "brokerTime": "2025-05-14 14:47:47",
        "commission": -16.8,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56048972",
        "positionId": "56048972",
        "volume": 2.4,
        "price": 3229.08,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -16.8,
        "priceIn": 3229.08,
        "doubleCheck": true
    },
    {
        "dataID": "115315",
        "id": "53085072",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:47:47",
        "brokerTime": "2025-05-14 14:47:47",
        "commission": -16.8,
        "swap": 0,
        "profit": -57.6,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56048973",
        "positionId": "56048972",
        "volume": 2.4,
        "price": 3229.32,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -74.4,
        "priceIn": 3229.08,
        "doubleCheck": true
    },
    {
        "dataID": "115316",
        "id": "53085073",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:47:48",
        "brokerTime": "2025-05-14 14:47:48",
        "commission": -16.8,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56048974",
        "positionId": "56048974",
        "volume": 2.4,
        "price": 3229.13,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -16.8,
        "priceIn": 3229.13,
        "doubleCheck": true
    },
    {
        "dataID": "115317",
        "id": "53085074",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:47:48",
        "brokerTime": "2025-05-14 14:47:49",
        "commission": -16.8,
        "swap": 0,
        "profit": -50.4,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56048975",
        "positionId": "56048974",
        "volume": 2.4,
        "price": 3229.34,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -67.2,
        "priceIn": 3229.13,
        "doubleCheck": true
    },
    {
        "dataID": "115318",
        "id": "53085075",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:47:51",
        "brokerTime": "2025-05-14 14:47:51",
        "commission": -16.8,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56048976",
        "positionId": "56048976",
        "volume": 2.4,
        "price": 3229.11,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -16.8,
        "priceIn": 3229.11,
        "doubleCheck": true
    },
    {
        "dataID": "115319",
        "id": "53085076",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:47:51",
        "brokerTime": "2025-05-14 14:47:52",
        "commission": -16.8,
        "swap": 0,
        "profit": -50.4,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56048977",
        "positionId": "56048976",
        "volume": 2.4,
        "price": 3229.32,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -67.2,
        "priceIn": 3229.11,
        "doubleCheck": true
    },
    {
        "dataID": "115320",
        "id": "53085077",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:47:53",
        "brokerTime": "2025-05-14 14:47:53",
        "commission": -16.8,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56048978",
        "positionId": "56048978",
        "volume": 2.4,
        "price": 3229.07,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -16.8,
        "priceIn": 3229.07,
        "doubleCheck": true
    },
    {
        "dataID": "115321",
        "id": "53085078",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:47:53",
        "brokerTime": "2025-05-14 14:47:55",
        "commission": -16.8,
        "swap": 0,
        "profit": -31.2,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56048979",
        "positionId": "56048978",
        "volume": 2.4,
        "price": 3229.2,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -48,
        "priceIn": 3229.07,
        "doubleCheck": true
    },
    {
        "dataID": "115322",
        "id": "53085079",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:47:55",
        "brokerTime": "2025-05-14 14:47:55",
        "commission": -16.8,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56048980",
        "positionId": "56048980",
        "volume": 2.4,
        "price": 3229.02,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -16.8,
        "priceIn": 3229.02,
        "doubleCheck": true
    },
    {
        "dataID": "115323",
        "id": "53085080",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:47:55",
        "brokerTime": "2025-05-14 14:47:56",
        "commission": -16.8,
        "swap": 0,
        "profit": -26.4,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56048981",
        "positionId": "56048980",
        "volume": 2.4,
        "price": 3229.13,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -43.2,
        "priceIn": 3229.02,
        "doubleCheck": true
    },
    {
        "dataID": "115324",
        "id": "53085081",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:47:56",
        "brokerTime": "2025-05-14 14:47:56",
        "commission": -16.8,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56048982",
        "positionId": "56048982",
        "volume": 2.4,
        "price": 3228.92,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -16.8,
        "priceIn": 3228.92,
        "doubleCheck": true
    },
    {
        "dataID": "115325",
        "id": "53085082",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:47:56",
        "brokerTime": "2025-05-14 14:47:57",
        "commission": -16.8,
        "swap": 0,
        "profit": -57.6,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56048983",
        "positionId": "56048982",
        "volume": 2.4,
        "price": 3229.16,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -74.4,
        "priceIn": 3228.92,
        "doubleCheck": true
    },
    {
        "dataID": "115326",
        "id": "53085083",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:47:57",
        "brokerTime": "2025-05-14 14:47:57",
        "commission": -16.8,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56048984",
        "positionId": "56048984",
        "volume": 2.4,
        "price": 3228.98,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -16.8,
        "priceIn": 3228.98,
        "doubleCheck": true
    },
    {
        "dataID": "115327",
        "id": "53085084",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:47:57",
        "brokerTime": "2025-05-14 14:47:57",
        "commission": -16.8,
        "swap": 0,
        "profit": -43.2,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56048985",
        "positionId": "56048984",
        "volume": 2.4,
        "price": 3229.16,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -60,
        "priceIn": 3228.98,
        "doubleCheck": true
    },
    {
        "dataID": "115328",
        "id": "53085085",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:47:58",
        "brokerTime": "2025-05-14 14:47:58",
        "commission": -16.8,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56048986",
        "positionId": "56048986",
        "volume": 2.4,
        "price": 3228.92,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -16.8,
        "priceIn": 3228.92,
        "doubleCheck": true
    },
    {
        "dataID": "115329",
        "id": "53085086",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:47:58",
        "brokerTime": "2025-05-14 14:47:59",
        "commission": -16.8,
        "swap": 0,
        "profit": -57.6,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56048987",
        "positionId": "56048986",
        "volume": 2.4,
        "price": 3229.16,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -74.4,
        "priceIn": 3228.92,
        "doubleCheck": true
    },
    {
        "dataID": "115330",
        "id": "53085087",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:47:59",
        "brokerTime": "2025-05-14 14:47:59",
        "commission": -16.8,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56048988",
        "positionId": "56048988",
        "volume": 2.4,
        "price": 3228.93,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -16.8,
        "priceIn": 3228.93,
        "doubleCheck": true
    },
    {
        "dataID": "115331",
        "id": "53085088",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:47:59",
        "brokerTime": "2025-05-14 14:48:00",
        "commission": -16.8,
        "swap": 0,
        "profit": -40.8,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56048989",
        "positionId": "56048988",
        "volume": 2.4,
        "price": 3229.1,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.599999999999994,
        "priceIn": 3228.93,
        "doubleCheck": true
    },
    {
        "dataID": "115332",
        "id": "53085090",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:00",
        "brokerTime": "2025-05-14 14:48:00",
        "commission": -16.8,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56048992",
        "positionId": "56048992",
        "volume": 2.4,
        "price": 3228.91,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -16.8,
        "priceIn": 3228.91,
        "doubleCheck": true
    },
    {
        "dataID": "115333",
        "id": "53085095",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:00",
        "brokerTime": "2025-05-14 14:48:01",
        "commission": -16.8,
        "swap": 0,
        "profit": 24,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56048996",
        "positionId": "56048992",
        "volume": 2.4,
        "price": 3228.81,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 7.199999999999999,
        "priceIn": 3228.91,
        "doubleCheck": true
    },
    {
        "dataID": "115334",
        "id": "53085096",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:01",
        "brokerTime": "2025-05-14 14:48:01",
        "commission": -16.8,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56048997",
        "positionId": "56048997",
        "volume": 2.4,
        "price": 3228.61,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -16.8,
        "priceIn": 3228.61,
        "doubleCheck": true
    },
    {
        "dataID": "115335",
        "id": "53085097",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:01",
        "brokerTime": "2025-05-14 14:48:02",
        "commission": -16.8,
        "swap": 0,
        "profit": 7.2,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56048998",
        "positionId": "56048997",
        "volume": 2.4,
        "price": 3228.58,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -9.600000000000001,
        "priceIn": 3228.61,
        "doubleCheck": true
    },
    {
        "dataID": "115336",
        "id": "53085098",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 14:48:02",
        "brokerTime": "2025-05-14 14:48:02",
        "commission": -3.64,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56048999",
        "positionId": "56048999",
        "volume": 0.52,
        "price": 3228.58,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3328.58,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -3.64,
        "priceIn": 3228.58,
        "doubleCheck": true
    },
    {
        "dataID": "115337",
        "id": "53085100",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:03",
        "brokerTime": "2025-05-14 14:48:03",
        "commission": -21.14,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049001",
        "positionId": "56049001",
        "volume": 3.02,
        "price": 3228.33,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -21.14,
        "priceIn": 3228.33,
        "doubleCheck": true
    },
    {
        "dataID": "115338",
        "id": "53085101",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:03",
        "brokerTime": "2025-05-14 14:48:03",
        "commission": -21.14,
        "swap": 0,
        "profit": -60.4,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049002",
        "positionId": "56049001",
        "volume": 3.02,
        "price": 3228.53,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -81.53999999999999,
        "priceIn": 3228.33,
        "doubleCheck": true
    },
    {
        "dataID": "115339",
        "id": "53085102",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:04",
        "brokerTime": "2025-05-14 14:48:04",
        "commission": -21.14,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049003",
        "positionId": "56049003",
        "volume": 3.02,
        "price": 3228.33,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -21.14,
        "priceIn": 3228.33,
        "doubleCheck": true
    },
    {
        "dataID": "115340",
        "id": "53085104",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:04",
        "brokerTime": "2025-05-14 14:48:05",
        "commission": -21.14,
        "swap": 0,
        "profit": -63.42,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049005",
        "positionId": "56049003",
        "volume": 3.02,
        "price": 3228.54,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -84.56,
        "priceIn": 3228.33,
        "doubleCheck": true
    },
    {
        "dataID": "115341",
        "id": "53085105",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:05",
        "brokerTime": "2025-05-14 14:48:05",
        "commission": -21.14,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049006",
        "positionId": "56049006",
        "volume": 3.02,
        "price": 3228.18,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -21.14,
        "priceIn": 3228.18,
        "doubleCheck": true
    },
    {
        "dataID": "115342",
        "id": "53085123",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:05",
        "brokerTime": "2025-05-14 14:48:06",
        "commission": -21.14,
        "swap": 0,
        "profit": -54.36,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049022",
        "positionId": "56049006",
        "volume": 3.02,
        "price": 3228.36,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -75.5,
        "priceIn": 3228.18,
        "doubleCheck": true
    },
    {
        "dataID": "115343",
        "id": "53085132",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:06",
        "brokerTime": "2025-05-14 14:48:06",
        "commission": -21.14,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049026",
        "positionId": "56049026",
        "volume": 3.02,
        "price": 3228.16,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -21.14,
        "priceIn": 3228.16,
        "doubleCheck": true
    },
    {
        "dataID": "115344",
        "id": "53085169",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:06",
        "brokerTime": "2025-05-14 14:48:09",
        "commission": -21.14,
        "swap": 0,
        "profit": -33.22,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049051",
        "positionId": "56049026",
        "volume": 3.02,
        "price": 3228.27,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -54.36,
        "priceIn": 3228.16,
        "doubleCheck": true
    },
    {
        "dataID": "115345",
        "id": "53085174",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:10",
        "brokerTime": "2025-05-14 14:48:10",
        "commission": -21.14,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049056",
        "positionId": "56049056",
        "volume": 3.02,
        "price": 3228.03,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -21.14,
        "priceIn": 3228.03,
        "doubleCheck": true
    },
    {
        "dataID": "115346",
        "id": "53085178",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:10",
        "brokerTime": "2025-05-14 14:48:10",
        "commission": -21.14,
        "swap": 0,
        "profit": -51.34,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049058",
        "positionId": "56049056",
        "volume": 3.02,
        "price": 3228.2,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -72.48,
        "priceIn": 3228.03,
        "doubleCheck": true
    },
    {
        "dataID": "115347",
        "id": "53085181",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:11",
        "brokerTime": "2025-05-14 14:48:11",
        "commission": -21.14,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049060",
        "positionId": "56049060",
        "volume": 3.02,
        "price": 3227.91,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -21.14,
        "priceIn": 3227.91,
        "doubleCheck": true
    },
    {
        "dataID": "115348",
        "id": "53085182",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:11",
        "brokerTime": "2025-05-14 14:48:12",
        "commission": -21.14,
        "swap": 0,
        "profit": -54.36,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049061",
        "positionId": "56049060",
        "volume": 3.02,
        "price": 3228.09,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -75.5,
        "priceIn": 3227.91,
        "doubleCheck": true
    },
    {
        "dataID": "115349",
        "id": "53085183",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:12",
        "brokerTime": "2025-05-14 14:48:12",
        "commission": -21.14,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049062",
        "positionId": "56049062",
        "volume": 3.02,
        "price": 3227.98,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -21.14,
        "priceIn": 3227.98,
        "doubleCheck": true
    },
    {
        "dataID": "115350",
        "id": "53085185",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:12",
        "brokerTime": "2025-05-14 14:48:12",
        "commission": -21.14,
        "swap": 0,
        "profit": -45.3,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049064",
        "positionId": "56049062",
        "volume": 3.02,
        "price": 3228.13,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -66.44,
        "priceIn": 3227.98,
        "doubleCheck": true
    },
    {
        "dataID": "115351",
        "id": "53085188",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:13",
        "brokerTime": "2025-05-14 14:48:13",
        "commission": -21.14,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049066",
        "positionId": "56049066",
        "volume": 3.02,
        "price": 3227.95,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -21.14,
        "priceIn": 3227.95,
        "doubleCheck": true
    },
    {
        "dataID": "115352",
        "id": "53085189",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:13",
        "brokerTime": "2025-05-14 14:48:13",
        "commission": -21.14,
        "swap": 0,
        "profit": -99.66,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049067",
        "positionId": "56049066",
        "volume": 3.02,
        "price": 3228.28,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -120.8,
        "priceIn": 3227.95,
        "doubleCheck": true
    },
    {
        "dataID": "115353",
        "id": "53085190",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:14",
        "brokerTime": "2025-05-14 14:48:14",
        "commission": -21.14,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049068",
        "positionId": "56049068",
        "volume": 3.02,
        "price": 3228.04,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -21.14,
        "priceIn": 3228.04,
        "doubleCheck": true
    },
    {
        "dataID": "115354",
        "id": "53085191",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:14",
        "brokerTime": "2025-05-14 14:48:15",
        "commission": -21.14,
        "swap": 0,
        "profit": -39.26,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049069",
        "positionId": "56049068",
        "volume": 3.02,
        "price": 3228.17,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -60.4,
        "priceIn": 3228.04,
        "doubleCheck": true
    },
    {
        "dataID": "115355",
        "id": "53085192",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:16",
        "brokerTime": "2025-05-14 14:48:16",
        "commission": -21.14,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049070",
        "positionId": "56049070",
        "volume": 3.02,
        "price": 3227.94,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -21.14,
        "priceIn": 3227.94,
        "doubleCheck": true
    },
    {
        "dataID": "115356",
        "id": "53085193",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:16",
        "brokerTime": "2025-05-14 14:48:16",
        "commission": -21.14,
        "swap": 0,
        "profit": -60.4,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049071",
        "positionId": "56049070",
        "volume": 3.02,
        "price": 3228.14,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -81.53999999999999,
        "priceIn": 3227.94,
        "doubleCheck": true
    },
    {
        "dataID": "115357",
        "id": "53085194",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:16",
        "brokerTime": "2025-05-14 14:48:16",
        "commission": -21.14,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049072",
        "positionId": "56049072",
        "volume": 3.02,
        "price": 3227.97,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -21.14,
        "priceIn": 3227.97,
        "doubleCheck": true
    },
    {
        "dataID": "115358",
        "id": "53085195",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:16",
        "brokerTime": "2025-05-14 14:48:17",
        "commission": -21.14,
        "swap": 0,
        "profit": -57.38,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049073",
        "positionId": "56049072",
        "volume": 3.02,
        "price": 3228.16,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -78.52000000000001,
        "priceIn": 3227.97,
        "doubleCheck": true
    },
    {
        "dataID": "115359",
        "id": "53085196",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:17",
        "brokerTime": "2025-05-14 14:48:17",
        "commission": -21.14,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049074",
        "positionId": "56049074",
        "volume": 3.02,
        "price": 3228.07,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -21.14,
        "priceIn": 3228.07,
        "doubleCheck": true
    },
    {
        "dataID": "115360",
        "id": "53085197",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:17",
        "brokerTime": "2025-05-14 14:48:18",
        "commission": -21.14,
        "swap": 0,
        "profit": -81.54,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049075",
        "positionId": "56049074",
        "volume": 3.02,
        "price": 3228.34,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -102.68,
        "priceIn": 3228.07,
        "doubleCheck": true
    },
    {
        "dataID": "115361",
        "id": "53085198",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:18",
        "brokerTime": "2025-05-14 14:48:18",
        "commission": -21.14,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049076",
        "positionId": "56049076",
        "volume": 3.02,
        "price": 3228.13,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -21.14,
        "priceIn": 3228.13,
        "doubleCheck": true
    },
    {
        "dataID": "115362",
        "id": "53085199",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:18",
        "brokerTime": "2025-05-14 14:48:18",
        "commission": -21.14,
        "swap": 0,
        "profit": -39.26,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049077",
        "positionId": "56049076",
        "volume": 3.02,
        "price": 3228.26,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -60.4,
        "priceIn": 3228.13,
        "doubleCheck": true
    },
    {
        "dataID": "115363",
        "id": "53085200",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:19",
        "brokerTime": "2025-05-14 14:48:19",
        "commission": -21.14,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049078",
        "positionId": "56049078",
        "volume": 3.02,
        "price": 3228.17,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -21.14,
        "priceIn": 3228.17,
        "doubleCheck": true
    },
    {
        "dataID": "115364",
        "id": "53085201",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:19",
        "brokerTime": "2025-05-14 14:48:20",
        "commission": -21.14,
        "swap": 0,
        "profit": -60.4,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049079",
        "positionId": "56049078",
        "volume": 3.02,
        "price": 3228.37,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -81.53999999999999,
        "priceIn": 3228.17,
        "doubleCheck": true
    },
    {
        "dataID": "115365",
        "id": "53085202",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:21",
        "brokerTime": "2025-05-14 14:48:21",
        "commission": -21.14,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049080",
        "positionId": "56049080",
        "volume": 3.02,
        "price": 3228.29,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -21.14,
        "priceIn": 3228.29,
        "doubleCheck": true
    },
    {
        "dataID": "115366",
        "id": "53085204",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:21",
        "brokerTime": "2025-05-14 14:48:21",
        "commission": -21.14,
        "swap": 0,
        "profit": -75.5,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049082",
        "positionId": "56049080",
        "volume": 3.02,
        "price": 3228.54,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -96.64,
        "priceIn": 3228.29,
        "doubleCheck": true
    },
    {
        "dataID": "115367",
        "id": "53085205",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:21",
        "brokerTime": "2025-05-14 14:48:21",
        "commission": -21.14,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049083",
        "positionId": "56049083",
        "volume": 3.02,
        "price": 3228.37,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -21.14,
        "priceIn": 3228.37,
        "doubleCheck": true
    },
    {
        "dataID": "115368",
        "id": "53085206",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:21",
        "brokerTime": "2025-05-14 14:48:22",
        "commission": -21.14,
        "swap": 0,
        "profit": 39.26,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049084",
        "positionId": "56049083",
        "volume": 3.02,
        "price": 3228.24,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 18.119999999999997,
        "priceIn": 3228.37,
        "doubleCheck": true
    },
    {
        "dataID": "115369",
        "id": "53085207",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:22",
        "brokerTime": "2025-05-14 14:48:22",
        "commission": -21.14,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049085",
        "positionId": "56049085",
        "volume": 3.02,
        "price": 3227.91,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -21.14,
        "priceIn": 3227.91,
        "doubleCheck": true
    },
    {
        "dataID": "115370",
        "id": "53085208",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:22",
        "brokerTime": "2025-05-14 14:48:23",
        "commission": -21.14,
        "swap": 0,
        "profit": -63.42,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049086",
        "positionId": "56049085",
        "volume": 3.02,
        "price": 3228.12,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -84.56,
        "priceIn": 3227.91,
        "doubleCheck": true
    },
    {
        "dataID": "115371",
        "id": "53085209",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:23",
        "brokerTime": "2025-05-14 14:48:23",
        "commission": -21.14,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049087",
        "positionId": "56049087",
        "volume": 3.02,
        "price": 3227.92,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -21.14,
        "priceIn": 3227.92,
        "doubleCheck": true
    },
    {
        "dataID": "115372",
        "id": "53085212",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:23",
        "brokerTime": "2025-05-14 14:48:24",
        "commission": -21.14,
        "swap": 0,
        "profit": -21.14,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049090",
        "positionId": "56049087",
        "volume": 3.02,
        "price": 3227.99,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -42.28,
        "priceIn": 3227.92,
        "doubleCheck": true
    },
    {
        "dataID": "115373",
        "id": "53085213",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:25",
        "brokerTime": "2025-05-14 14:48:25",
        "commission": -21.14,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049091",
        "positionId": "56049091",
        "volume": 3.02,
        "price": 3227.78,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -21.14,
        "priceIn": 3227.78,
        "doubleCheck": true
    },
    {
        "dataID": "115374",
        "id": "53085214",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:25",
        "brokerTime": "2025-05-14 14:48:25",
        "commission": -21.14,
        "swap": 0,
        "profit": -57.38,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049092",
        "positionId": "56049091",
        "volume": 3.02,
        "price": 3227.97,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -78.52000000000001,
        "priceIn": 3227.78,
        "doubleCheck": true
    },
    {
        "dataID": "115375",
        "id": "53085215",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:26",
        "brokerTime": "2025-05-14 14:48:26",
        "commission": -21.14,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049093",
        "positionId": "56049093",
        "volume": 3.02,
        "price": 3227.8,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -21.14,
        "priceIn": 3227.8,
        "doubleCheck": true
    },
    {
        "dataID": "115376",
        "id": "53085216",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:26",
        "brokerTime": "2025-05-14 14:48:26",
        "commission": -21.14,
        "swap": 0,
        "profit": -87.58,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049094",
        "positionId": "56049093",
        "volume": 3.02,
        "price": 3228.09,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -108.72,
        "priceIn": 3227.8,
        "doubleCheck": true
    },
    {
        "dataID": "115377",
        "id": "53085218",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:27",
        "brokerTime": "2025-05-14 14:48:27",
        "commission": -21.14,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049096",
        "positionId": "56049096",
        "volume": 3.02,
        "price": 3227.91,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -21.14,
        "priceIn": 3227.91,
        "doubleCheck": true
    },
    {
        "dataID": "115378",
        "id": "53085219",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:27",
        "brokerTime": "2025-05-14 14:48:28",
        "commission": -21.14,
        "swap": 0,
        "profit": -63.42,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049097",
        "positionId": "56049096",
        "volume": 3.02,
        "price": 3228.12,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -84.56,
        "priceIn": 3227.91,
        "doubleCheck": true
    },
    {
        "dataID": "115379",
        "id": "53085220",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:29",
        "brokerTime": "2025-05-14 14:48:29",
        "commission": -21.14,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049098",
        "positionId": "56049098",
        "volume": 3.02,
        "price": 3227.9,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -21.14,
        "priceIn": 3227.9,
        "doubleCheck": true
    },
    {
        "dataID": "115380",
        "id": "53085221",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:29",
        "brokerTime": "2025-05-14 14:48:29",
        "commission": -21.14,
        "swap": 0,
        "profit": -45.3,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049099",
        "positionId": "56049098",
        "volume": 3.02,
        "price": 3228.05,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -66.44,
        "priceIn": 3227.9,
        "doubleCheck": true
    },
    {
        "dataID": "115381",
        "id": "53085222",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:29",
        "brokerTime": "2025-05-14 14:48:29",
        "commission": -21.14,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049100",
        "positionId": "56049100",
        "volume": 3.02,
        "price": 3227.84,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -21.14,
        "priceIn": 3227.84,
        "doubleCheck": true
    },
    {
        "dataID": "115382",
        "id": "53085223",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:29",
        "brokerTime": "2025-05-14 14:48:30",
        "commission": -21.14,
        "swap": 0,
        "profit": -66.44,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049101",
        "positionId": "56049100",
        "volume": 3.02,
        "price": 3228.06,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -87.58,
        "priceIn": 3227.84,
        "doubleCheck": true
    },
    {
        "dataID": "115383",
        "id": "53085224",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:30",
        "brokerTime": "2025-05-14 14:48:30",
        "commission": -21.14,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049102",
        "positionId": "56049102",
        "volume": 3.02,
        "price": 3227.86,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -21.14,
        "priceIn": 3227.86,
        "doubleCheck": true
    },
    {
        "dataID": "115384",
        "id": "53085225",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:30",
        "brokerTime": "2025-05-14 14:48:31",
        "commission": -21.14,
        "swap": 0,
        "profit": -57.38,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049103",
        "positionId": "56049102",
        "volume": 3.02,
        "price": 3228.05,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -78.52000000000001,
        "priceIn": 3227.86,
        "doubleCheck": true
    },
    {
        "dataID": "115385",
        "id": "53085226",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:31",
        "brokerTime": "2025-05-14 14:48:31",
        "commission": -21.14,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049106",
        "positionId": "56049106",
        "volume": 3.02,
        "price": 3227.7,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -21.14,
        "priceIn": 3227.7,
        "doubleCheck": true
    },
    {
        "dataID": "115386",
        "id": "53085231",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:31",
        "brokerTime": "2025-05-14 14:48:32",
        "commission": -21.14,
        "swap": 0,
        "profit": -39.26,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049109",
        "positionId": "56049106",
        "volume": 3.02,
        "price": 3227.83,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -60.4,
        "priceIn": 3227.7,
        "doubleCheck": true
    },
    {
        "dataID": "115387",
        "id": "53085232",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:32",
        "brokerTime": "2025-05-14 14:48:32",
        "commission": -21.14,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049110",
        "positionId": "56049110",
        "volume": 3.02,
        "price": 3227.63,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -21.14,
        "priceIn": 3227.63,
        "doubleCheck": true
    },
    {
        "dataID": "115388",
        "id": "53085233",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:32",
        "brokerTime": "2025-05-14 14:48:32",
        "commission": -21.14,
        "swap": 0,
        "profit": -30.2,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049111",
        "positionId": "56049110",
        "volume": 3.02,
        "price": 3227.73,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -51.34,
        "priceIn": 3227.63,
        "doubleCheck": true
    },
    {
        "dataID": "115389",
        "id": "53085238",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:33",
        "brokerTime": "2025-05-14 14:48:33",
        "commission": -21.14,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049116",
        "positionId": "56049116",
        "volume": 3.02,
        "price": 3227.46,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -21.14,
        "priceIn": 3227.46,
        "doubleCheck": true
    },
    {
        "dataID": "115390",
        "id": "53085239",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:33",
        "brokerTime": "2025-05-14 14:48:33",
        "commission": -21.14,
        "swap": 0,
        "profit": -57.38,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049117",
        "positionId": "56049116",
        "volume": 3.02,
        "price": 3227.65,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -78.52000000000001,
        "priceIn": 3227.46,
        "doubleCheck": true
    },
    {
        "dataID": "115391",
        "id": "53085240",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:33",
        "brokerTime": "2025-05-14 14:48:33",
        "commission": -21.14,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049118",
        "positionId": "56049118",
        "volume": 3.02,
        "price": 3227.42,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -21.14,
        "priceIn": 3227.42,
        "doubleCheck": true
    },
    {
        "dataID": "115392",
        "id": "53085241",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:33",
        "brokerTime": "2025-05-14 14:48:35",
        "commission": -21.14,
        "swap": 0,
        "profit": -84.56,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049120",
        "positionId": "56049118",
        "volume": 3.02,
        "price": 3227.7,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -105.7,
        "priceIn": 3227.42,
        "doubleCheck": true
    },
    {
        "dataID": "115393",
        "id": "53085243",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:35",
        "brokerTime": "2025-05-14 14:48:35",
        "commission": -21.14,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049121",
        "positionId": "56049121",
        "volume": 3.02,
        "price": 3227.52,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -21.14,
        "priceIn": 3227.52,
        "doubleCheck": true
    },
    {
        "dataID": "115394",
        "id": "53085244",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:35",
        "brokerTime": "2025-05-14 14:48:35",
        "commission": -21.14,
        "swap": 0,
        "profit": -135.9,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049122",
        "positionId": "56049121",
        "volume": 3.02,
        "price": 3227.97,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -157.04000000000002,
        "priceIn": 3227.52,
        "doubleCheck": true
    },
    {
        "dataID": "115395",
        "id": "53085245",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:36",
        "brokerTime": "2025-05-14 14:48:36",
        "commission": -21.14,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049123",
        "positionId": "56049123",
        "volume": 3.02,
        "price": 3227.82,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -21.14,
        "priceIn": 3227.82,
        "doubleCheck": true
    },
    {
        "dataID": "115396",
        "id": "53085246",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:36",
        "brokerTime": "2025-05-14 14:48:36",
        "commission": -21.14,
        "swap": 0,
        "profit": -60.4,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049124",
        "positionId": "56049123",
        "volume": 3.02,
        "price": 3228.02,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -81.53999999999999,
        "priceIn": 3227.82,
        "doubleCheck": true
    },
    {
        "dataID": "115397",
        "id": "53085247",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:36",
        "brokerTime": "2025-05-14 14:48:36",
        "commission": -21.14,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049125",
        "positionId": "56049125",
        "volume": 3.02,
        "price": 3227.81,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -21.14,
        "priceIn": 3227.81,
        "doubleCheck": true
    },
    {
        "dataID": "115398",
        "id": "53085248",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:36",
        "brokerTime": "2025-05-14 14:48:37",
        "commission": -21.14,
        "swap": 0,
        "profit": -81.54,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049126",
        "positionId": "56049125",
        "volume": 3.02,
        "price": 3228.08,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -102.68,
        "priceIn": 3227.81,
        "doubleCheck": true
    },
    {
        "dataID": "115399",
        "id": "53085249",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:37",
        "brokerTime": "2025-05-14 14:48:37",
        "commission": -21.14,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049127",
        "positionId": "56049127",
        "volume": 3.02,
        "price": 3227.85,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -21.14,
        "priceIn": 3227.85,
        "doubleCheck": true
    },
    {
        "dataID": "115400",
        "id": "53085250",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:37",
        "brokerTime": "2025-05-14 14:48:38",
        "commission": -21.14,
        "swap": 0,
        "profit": -36.24,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049128",
        "positionId": "56049127",
        "volume": 3.02,
        "price": 3227.97,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.38,
        "priceIn": 3227.85,
        "doubleCheck": true
    },
    {
        "dataID": "115401",
        "id": "53085251",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:38",
        "brokerTime": "2025-05-14 14:48:38",
        "commission": -21.14,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049129",
        "positionId": "56049129",
        "volume": 3.02,
        "price": 3227.76,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -21.14,
        "priceIn": 3227.76,
        "doubleCheck": true
    },
    {
        "dataID": "115402",
        "id": "53085252",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:38",
        "brokerTime": "2025-05-14 14:48:39",
        "commission": -21.14,
        "swap": 0,
        "profit": -57.38,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049130",
        "positionId": "56049129",
        "volume": 3.02,
        "price": 3227.95,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -78.52000000000001,
        "priceIn": 3227.76,
        "doubleCheck": true
    },
    {
        "dataID": "115403",
        "id": "53085253",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:39",
        "brokerTime": "2025-05-14 14:48:39",
        "commission": -21.14,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049131",
        "positionId": "56049131",
        "volume": 3.02,
        "price": 3227.75,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -21.14,
        "priceIn": 3227.75,
        "doubleCheck": true
    },
    {
        "dataID": "115404",
        "id": "53085254",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:39",
        "brokerTime": "2025-05-14 14:48:40",
        "commission": -21.14,
        "swap": 0,
        "profit": -84.56,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049132",
        "positionId": "56049131",
        "volume": 3.02,
        "price": 3228.03,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -105.7,
        "priceIn": 3227.75,
        "doubleCheck": true
    },
    {
        "dataID": "115405",
        "id": "53085255",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:41",
        "brokerTime": "2025-05-14 14:48:41",
        "commission": -21.14,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049133",
        "positionId": "56049133",
        "volume": 3.02,
        "price": 3227.85,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -21.14,
        "priceIn": 3227.85,
        "doubleCheck": true
    },
    {
        "dataID": "115406",
        "id": "53085257",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:41",
        "brokerTime": "2025-05-14 14:48:41",
        "commission": -21.14,
        "swap": 0,
        "profit": -42.28,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049135",
        "positionId": "56049133",
        "volume": 3.02,
        "price": 3227.99,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -63.42,
        "priceIn": 3227.85,
        "doubleCheck": true
    },
    {
        "dataID": "115407",
        "id": "53085258",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:42",
        "brokerTime": "2025-05-14 14:48:42",
        "commission": -21.14,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049136",
        "positionId": "56049136",
        "volume": 3.02,
        "price": 3227.75,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -21.14,
        "priceIn": 3227.75,
        "doubleCheck": true
    },
    {
        "dataID": "115408",
        "id": "53085259",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:42",
        "brokerTime": "2025-05-14 14:48:42",
        "commission": -21.14,
        "swap": 0,
        "profit": -36.24,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049137",
        "positionId": "56049136",
        "volume": 3.02,
        "price": 3227.87,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.38,
        "priceIn": 3227.75,
        "doubleCheck": true
    },
    {
        "dataID": "115409",
        "id": "53085260",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:43",
        "brokerTime": "2025-05-14 14:48:43",
        "commission": -21.14,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049138",
        "positionId": "56049138",
        "volume": 3.02,
        "price": 3227.66,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -21.14,
        "priceIn": 3227.66,
        "doubleCheck": true
    },
    {
        "dataID": "115410",
        "id": "53085261",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:43",
        "brokerTime": "2025-05-14 14:48:43",
        "commission": -21.14,
        "swap": 0,
        "profit": -18.12,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049139",
        "positionId": "56049138",
        "volume": 3.02,
        "price": 3227.72,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -39.260000000000005,
        "priceIn": 3227.66,
        "doubleCheck": true
    },
    {
        "dataID": "115411",
        "id": "53085262",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:44",
        "brokerTime": "2025-05-14 14:48:44",
        "commission": -21.14,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049140",
        "positionId": "56049140",
        "volume": 3.02,
        "price": 3227.49,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -21.14,
        "priceIn": 3227.49,
        "doubleCheck": true
    },
    {
        "dataID": "115412",
        "id": "53085263",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:44",
        "brokerTime": "2025-05-14 14:48:45",
        "commission": -21.14,
        "swap": 0,
        "profit": -102.68,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049141",
        "positionId": "56049140",
        "volume": 3.02,
        "price": 3227.83,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -123.82000000000001,
        "priceIn": 3227.49,
        "doubleCheck": true
    },
    {
        "dataID": "115413",
        "id": "53085264",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:47",
        "brokerTime": "2025-05-14 14:48:47",
        "commission": -21.14,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049142",
        "positionId": "56049142",
        "volume": 3.02,
        "price": 3227.65,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -21.14,
        "priceIn": 3227.65,
        "doubleCheck": true
    },
    {
        "dataID": "115414",
        "id": "53085265",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:47",
        "brokerTime": "2025-05-14 14:48:47",
        "commission": -21.14,
        "swap": 0,
        "profit": -36.24,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049143",
        "positionId": "56049142",
        "volume": 3.02,
        "price": 3227.77,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.38,
        "priceIn": 3227.65,
        "doubleCheck": true
    },
    {
        "dataID": "115415",
        "id": "53085266",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:48",
        "brokerTime": "2025-05-14 14:48:48",
        "commission": -21.14,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049144",
        "positionId": "56049144",
        "volume": 3.02,
        "price": 3227.56,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -21.14,
        "priceIn": 3227.56,
        "doubleCheck": true
    },
    {
        "dataID": "115416",
        "id": "53085268",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:48",
        "brokerTime": "2025-05-14 14:48:49",
        "commission": -21.14,
        "swap": 0,
        "profit": -87.58,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049146",
        "positionId": "56049144",
        "volume": 3.02,
        "price": 3227.85,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -108.72,
        "priceIn": 3227.56,
        "doubleCheck": true
    },
    {
        "dataID": "115417",
        "id": "53085269",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:51",
        "brokerTime": "2025-05-14 14:48:51",
        "commission": -21.14,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049147",
        "positionId": "56049147",
        "volume": 3.02,
        "price": 3227.66,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -21.14,
        "priceIn": 3227.66,
        "doubleCheck": true
    },
    {
        "dataID": "115418",
        "id": "53085270",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:51",
        "brokerTime": "2025-05-14 14:48:52",
        "commission": -21.14,
        "swap": 0,
        "profit": -57.38,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049148",
        "positionId": "56049147",
        "volume": 3.02,
        "price": 3227.85,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -78.52000000000001,
        "priceIn": 3227.66,
        "doubleCheck": true
    },
    {
        "dataID": "115419",
        "id": "53085271",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:53",
        "brokerTime": "2025-05-14 14:48:53",
        "commission": -21.14,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049149",
        "positionId": "56049149",
        "volume": 3.02,
        "price": 3227.64,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -21.14,
        "priceIn": 3227.64,
        "doubleCheck": true
    },
    {
        "dataID": "115420",
        "id": "53085272",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:53",
        "brokerTime": "2025-05-14 14:48:53",
        "commission": -21.14,
        "swap": 0,
        "profit": -54.36,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049150",
        "positionId": "56049149",
        "volume": 3.02,
        "price": 3227.82,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -75.5,
        "priceIn": 3227.64,
        "doubleCheck": true
    },
    {
        "dataID": "115421",
        "id": "53085273",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:54",
        "brokerTime": "2025-05-14 14:48:54",
        "commission": -21.14,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049151",
        "positionId": "56049151",
        "volume": 3.02,
        "price": 3227.61,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -21.14,
        "priceIn": 3227.61,
        "doubleCheck": true
    },
    {
        "dataID": "115422",
        "id": "53085274",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:54",
        "brokerTime": "2025-05-14 14:48:54",
        "commission": -21.14,
        "swap": 0,
        "profit": -45.3,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049152",
        "positionId": "56049151",
        "volume": 3.02,
        "price": 3227.76,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -66.44,
        "priceIn": 3227.61,
        "doubleCheck": true
    },
    {
        "dataID": "115423",
        "id": "53085275",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:55",
        "brokerTime": "2025-05-14 14:48:55",
        "commission": -21.14,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049153",
        "positionId": "56049153",
        "volume": 3.02,
        "price": 3227.57,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -21.14,
        "priceIn": 3227.57,
        "doubleCheck": true
    },
    {
        "dataID": "115424",
        "id": "53085276",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:55",
        "brokerTime": "2025-05-14 14:48:55",
        "commission": -21.14,
        "swap": 0,
        "profit": -45.3,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049154",
        "positionId": "56049153",
        "volume": 3.02,
        "price": 3227.72,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -66.44,
        "priceIn": 3227.57,
        "doubleCheck": true
    },
    {
        "dataID": "115425",
        "id": "53085277",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:56",
        "brokerTime": "2025-05-14 14:48:56",
        "commission": -21.14,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049155",
        "positionId": "56049155",
        "volume": 3.02,
        "price": 3227.5,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -21.14,
        "priceIn": 3227.5,
        "doubleCheck": true
    },
    {
        "dataID": "115426",
        "id": "53085278",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:56",
        "brokerTime": "2025-05-14 14:48:56",
        "commission": -21.14,
        "swap": 0,
        "profit": -45.3,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049156",
        "positionId": "56049155",
        "volume": 3.02,
        "price": 3227.65,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -66.44,
        "priceIn": 3227.5,
        "doubleCheck": true
    },
    {
        "dataID": "115427",
        "id": "53085279",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:56",
        "brokerTime": "2025-05-14 14:48:56",
        "commission": -21.14,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049157",
        "positionId": "56049157",
        "volume": 3.02,
        "price": 3227.56,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -21.14,
        "priceIn": 3227.56,
        "doubleCheck": true
    },
    {
        "dataID": "115428",
        "id": "53085280",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:56",
        "brokerTime": "2025-05-14 14:48:57",
        "commission": -21.14,
        "swap": 0,
        "profit": -60.4,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049158",
        "positionId": "56049157",
        "volume": 3.02,
        "price": 3227.76,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -81.53999999999999,
        "priceIn": 3227.56,
        "doubleCheck": true
    },
    {
        "dataID": "115429",
        "id": "53085281",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:57",
        "brokerTime": "2025-05-14 14:48:57",
        "commission": -21.14,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049159",
        "positionId": "56049159",
        "volume": 3.02,
        "price": 3227.55,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -21.14,
        "priceIn": 3227.55,
        "doubleCheck": true
    },
    {
        "dataID": "115430",
        "id": "53085282",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:57",
        "brokerTime": "2025-05-14 14:48:58",
        "commission": -21.14,
        "swap": 0,
        "profit": -60.4,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049160",
        "positionId": "56049159",
        "volume": 3.02,
        "price": 3227.75,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -81.53999999999999,
        "priceIn": 3227.55,
        "doubleCheck": true
    },
    {
        "dataID": "115431",
        "id": "53085283",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:58",
        "brokerTime": "2025-05-14 14:48:58",
        "commission": -21.14,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049161",
        "positionId": "56049161",
        "volume": 3.02,
        "price": 3227.55,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -21.14,
        "priceIn": 3227.55,
        "doubleCheck": true
    },
    {
        "dataID": "115432",
        "id": "53085284",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:58",
        "brokerTime": "2025-05-14 14:48:59",
        "commission": -21.14,
        "swap": 0,
        "profit": -54.36,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049162",
        "positionId": "56049161",
        "volume": 3.02,
        "price": 3227.73,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -75.5,
        "priceIn": 3227.55,
        "doubleCheck": true
    },
    {
        "dataID": "115433",
        "id": "53085285",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:00",
        "brokerTime": "2025-05-14 14:49:00",
        "commission": -21.14,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049163",
        "positionId": "56049163",
        "volume": 3.02,
        "price": 3227.52,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -21.14,
        "priceIn": 3227.52,
        "doubleCheck": true
    },
    {
        "dataID": "115434",
        "id": "53085288",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:00",
        "brokerTime": "2025-05-14 14:49:00",
        "commission": -21.14,
        "swap": 0,
        "profit": -48.32,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049166",
        "positionId": "56049163",
        "volume": 3.02,
        "price": 3227.68,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.46000000000001,
        "priceIn": 3227.52,
        "doubleCheck": true
    },
    {
        "dataID": "115435",
        "id": "53085292",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:01",
        "brokerTime": "2025-05-14 14:49:01",
        "commission": -21.14,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049170",
        "positionId": "56049170",
        "volume": 3.02,
        "price": 3227.5,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -21.14,
        "priceIn": 3227.5,
        "doubleCheck": true
    },
    {
        "dataID": "115436",
        "id": "53085293",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:01",
        "brokerTime": "2025-05-14 14:49:01",
        "commission": -21.14,
        "swap": 0,
        "profit": 12.08,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049171",
        "positionId": "56049170",
        "volume": 3.02,
        "price": 3227.46,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -9.06,
        "priceIn": 3227.5,
        "doubleCheck": true
    },
    {
        "dataID": "115437",
        "id": "53085294",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 14:49:02",
        "brokerTime": "2025-05-14 14:49:02",
        "commission": -4.34,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049172",
        "positionId": "56049172",
        "volume": 0.62,
        "price": 3227.47,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3327.47,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -4.34,
        "priceIn": 3227.47,
        "doubleCheck": true
    },
    {
        "dataID": "115438",
        "id": "53085297",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:03",
        "brokerTime": "2025-05-14 14:49:03",
        "commission": -26.32,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049175",
        "positionId": "56049175",
        "volume": 3.76,
        "price": 3227.11,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -26.32,
        "priceIn": 3227.11,
        "doubleCheck": true
    },
    {
        "dataID": "115439",
        "id": "53085299",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:03",
        "brokerTime": "2025-05-14 14:49:03",
        "commission": -26.32,
        "swap": 0,
        "profit": -48.88,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049177",
        "positionId": "56049175",
        "volume": 3.76,
        "price": 3227.24,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -75.2,
        "priceIn": 3227.11,
        "doubleCheck": true
    },
    {
        "dataID": "115440",
        "id": "53085300",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:03",
        "brokerTime": "2025-05-14 14:49:03",
        "commission": -26.32,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049178",
        "positionId": "56049178",
        "volume": 3.76,
        "price": 3227.01,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -26.32,
        "priceIn": 3227.01,
        "doubleCheck": true
    },
    {
        "dataID": "115441",
        "id": "53085301",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:03",
        "brokerTime": "2025-05-14 14:49:04",
        "commission": -26.32,
        "swap": 0,
        "profit": -60.16,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049179",
        "positionId": "56049178",
        "volume": 3.76,
        "price": 3227.17,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -86.47999999999999,
        "priceIn": 3227.01,
        "doubleCheck": true
    },
    {
        "dataID": "115442",
        "id": "53085302",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:04",
        "brokerTime": "2025-05-14 14:49:04",
        "commission": -26.32,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049180",
        "positionId": "56049180",
        "volume": 3.76,
        "price": 3226.97,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -26.32,
        "priceIn": 3226.97,
        "doubleCheck": true
    },
    {
        "dataID": "115443",
        "id": "53085304",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:04",
        "brokerTime": "2025-05-14 14:49:05",
        "commission": -26.32,
        "swap": 0,
        "profit": -86.48,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049182",
        "positionId": "56049180",
        "volume": 3.76,
        "price": 3227.2,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -112.80000000000001,
        "priceIn": 3226.97,
        "doubleCheck": true
    },
    {
        "dataID": "115444",
        "id": "53085306",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:05",
        "brokerTime": "2025-05-14 14:49:05",
        "commission": -26.32,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049184",
        "positionId": "56049184",
        "volume": 3.76,
        "price": 3227,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -26.32,
        "priceIn": 3227,
        "doubleCheck": true
    },
    {
        "dataID": "115445",
        "id": "53085308",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:05",
        "brokerTime": "2025-05-14 14:49:05",
        "commission": -26.32,
        "swap": 0,
        "profit": -82.72,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049185",
        "positionId": "56049184",
        "volume": 3.76,
        "price": 3227.22,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -109.03999999999999,
        "priceIn": 3227,
        "doubleCheck": true
    },
    {
        "dataID": "115446",
        "id": "53085309",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:05",
        "brokerTime": "2025-05-14 14:49:05",
        "commission": -26.32,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049186",
        "positionId": "56049186",
        "volume": 3.76,
        "price": 3226.97,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -26.32,
        "priceIn": 3226.97,
        "doubleCheck": true
    },
    {
        "dataID": "115447",
        "id": "53085310",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:05",
        "brokerTime": "2025-05-14 14:49:06",
        "commission": -26.32,
        "swap": 0,
        "profit": -30.08,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049187",
        "positionId": "56049186",
        "volume": 3.76,
        "price": 3227.05,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.4,
        "priceIn": 3226.97,
        "doubleCheck": true
    },
    {
        "dataID": "115448",
        "id": "53085312",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:06",
        "brokerTime": "2025-05-14 14:49:06",
        "commission": -26.32,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049189",
        "positionId": "56049189",
        "volume": 3.76,
        "price": 3226.73,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -26.32,
        "priceIn": 3226.73,
        "doubleCheck": true
    },
    {
        "dataID": "115449",
        "id": "53085314",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:06",
        "brokerTime": "2025-05-14 14:49:07",
        "commission": -26.32,
        "swap": 0,
        "profit": -22.56,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049191",
        "positionId": "56049189",
        "volume": 3.76,
        "price": 3226.79,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -48.879999999999995,
        "priceIn": 3226.73,
        "doubleCheck": true
    },
    {
        "dataID": "115450",
        "id": "53085315",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:07",
        "brokerTime": "2025-05-14 14:49:07",
        "commission": -26.32,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049192",
        "positionId": "56049192",
        "volume": 3.76,
        "price": 3226.4,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -26.32,
        "priceIn": 3226.4,
        "doubleCheck": true
    },
    {
        "dataID": "115451",
        "id": "53085316",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:07",
        "brokerTime": "2025-05-14 14:49:07",
        "commission": -26.32,
        "swap": 0,
        "profit": -82.72,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049193",
        "positionId": "56049192",
        "volume": 3.76,
        "price": 3226.62,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -109.03999999999999,
        "priceIn": 3226.4,
        "doubleCheck": true
    },
    {
        "dataID": "115452",
        "id": "53085320",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:08",
        "brokerTime": "2025-05-14 14:49:08",
        "commission": -26.32,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049197",
        "positionId": "56049197",
        "volume": 3.76,
        "price": 3226.33,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -26.32,
        "priceIn": 3226.33,
        "doubleCheck": true
    },
    {
        "dataID": "115453",
        "id": "53085323",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:08",
        "brokerTime": "2025-05-14 14:49:08",
        "commission": -26.32,
        "swap": 0,
        "profit": -112.8,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049198",
        "positionId": "56049197",
        "volume": 3.76,
        "price": 3226.63,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -139.12,
        "priceIn": 3226.33,
        "doubleCheck": true
    },
    {
        "dataID": "115454",
        "id": "53085324",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:08",
        "brokerTime": "2025-05-14 14:49:08",
        "commission": -26.32,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049199",
        "positionId": "56049199",
        "volume": 3.76,
        "price": 3226.56,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -26.32,
        "priceIn": 3226.56,
        "doubleCheck": true
    },
    {
        "dataID": "115455",
        "id": "53085325",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:08",
        "brokerTime": "2025-05-14 14:49:09",
        "commission": -26.32,
        "swap": 0,
        "profit": -225.6,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049200",
        "positionId": "56049199",
        "volume": 3.76,
        "price": 3227.16,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -251.92,
        "priceIn": 3226.56,
        "doubleCheck": true
    },
    {
        "dataID": "115456",
        "id": "53085326",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:09",
        "brokerTime": "2025-05-14 14:49:09",
        "commission": -26.32,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049201",
        "positionId": "56049201",
        "volume": 3.76,
        "price": 3226.95,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -26.32,
        "priceIn": 3226.95,
        "doubleCheck": true
    },
    {
        "dataID": "115457",
        "id": "53085327",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:09",
        "brokerTime": "2025-05-14 14:49:09",
        "commission": -26.32,
        "swap": 0,
        "profit": -105.28,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049202",
        "positionId": "56049201",
        "volume": 3.76,
        "price": 3227.23,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -131.6,
        "priceIn": 3226.95,
        "doubleCheck": true
    },
    {
        "dataID": "115458",
        "id": "53085328",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:10",
        "brokerTime": "2025-05-14 14:49:10",
        "commission": -26.32,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049203",
        "positionId": "56049203",
        "volume": 3.76,
        "price": 3227.04,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -26.32,
        "priceIn": 3227.04,
        "doubleCheck": true
    },
    {
        "dataID": "115459",
        "id": "53085329",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:10",
        "brokerTime": "2025-05-14 14:49:10",
        "commission": -26.32,
        "swap": 0,
        "profit": -75.2,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049204",
        "positionId": "56049203",
        "volume": 3.76,
        "price": 3227.24,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -101.52000000000001,
        "priceIn": 3227.04,
        "doubleCheck": true
    },
    {
        "dataID": "115460",
        "id": "53085330",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:10",
        "brokerTime": "2025-05-14 14:49:10",
        "commission": -26.32,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049205",
        "positionId": "56049205",
        "volume": 3.76,
        "price": 3226.98,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -26.32,
        "priceIn": 3226.98,
        "doubleCheck": true
    },
    {
        "dataID": "115461",
        "id": "53085332",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:10",
        "brokerTime": "2025-05-14 14:49:10",
        "commission": -26.32,
        "swap": 0,
        "profit": -71.44,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049207",
        "positionId": "56049205",
        "volume": 3.76,
        "price": 3227.17,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -97.75999999999999,
        "priceIn": 3226.98,
        "doubleCheck": true
    },
    {
        "dataID": "115462",
        "id": "53085333",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:11",
        "brokerTime": "2025-05-14 14:49:11",
        "commission": -26.32,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049208",
        "positionId": "56049208",
        "volume": 3.76,
        "price": 3226.82,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -26.32,
        "priceIn": 3226.82,
        "doubleCheck": true
    },
    {
        "dataID": "115463",
        "id": "53085334",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:11",
        "brokerTime": "2025-05-14 14:49:11",
        "commission": -26.32,
        "swap": 0,
        "profit": 7.52,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049209",
        "positionId": "56049208",
        "volume": 3.76,
        "price": 3226.8,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -18.8,
        "priceIn": 3226.82,
        "doubleCheck": true
    },
    {
        "dataID": "115464",
        "id": "53085335",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:11",
        "brokerTime": "2025-05-14 14:49:11",
        "commission": -26.32,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049211",
        "positionId": "56049211",
        "volume": 3.76,
        "price": 3226.61,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -26.32,
        "priceIn": 3226.61,
        "doubleCheck": true
    },
    {
        "dataID": "115465",
        "id": "53085336",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:11",
        "brokerTime": "2025-05-14 14:49:12",
        "commission": -26.32,
        "swap": 0,
        "profit": -195.52,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049212",
        "positionId": "56049211",
        "volume": 3.76,
        "price": 3227.13,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -221.84,
        "priceIn": 3226.61,
        "doubleCheck": true
    },
    {
        "dataID": "115466",
        "id": "53085337",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:12",
        "brokerTime": "2025-05-14 14:49:12",
        "commission": -26.32,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049213",
        "positionId": "56049213",
        "volume": 3.76,
        "price": 3226.92,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -26.32,
        "priceIn": 3226.92,
        "doubleCheck": true
    },
    {
        "dataID": "115467",
        "id": "53085338",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:12",
        "brokerTime": "2025-05-14 14:49:13",
        "commission": -26.32,
        "swap": 0,
        "profit": -105.28,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049214",
        "positionId": "56049213",
        "volume": 3.76,
        "price": 3227.2,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -131.6,
        "priceIn": 3226.92,
        "doubleCheck": true
    },
    {
        "dataID": "115468",
        "id": "53085339",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:13",
        "brokerTime": "2025-05-14 14:49:13",
        "commission": -26.32,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049215",
        "positionId": "56049215",
        "volume": 3.76,
        "price": 3226.93,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -26.32,
        "priceIn": 3226.93,
        "doubleCheck": true
    },
    {
        "dataID": "115469",
        "id": "53085340",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:13",
        "brokerTime": "2025-05-14 14:49:14",
        "commission": -26.32,
        "swap": 0,
        "profit": -11.28,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049216",
        "positionId": "56049215",
        "volume": 3.76,
        "price": 3226.96,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -37.6,
        "priceIn": 3226.93,
        "doubleCheck": true
    },
    {
        "dataID": "115470",
        "id": "53085341",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:14",
        "brokerTime": "2025-05-14 14:49:14",
        "commission": -26.32,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049217",
        "positionId": "56049217",
        "volume": 3.76,
        "price": 3226.68,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -26.32,
        "priceIn": 3226.68,
        "doubleCheck": true
    },
    {
        "dataID": "115471",
        "id": "53085342",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:14",
        "brokerTime": "2025-05-14 14:49:14",
        "commission": -26.32,
        "swap": 0,
        "profit": -82.72,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049218",
        "positionId": "56049217",
        "volume": 3.76,
        "price": 3226.9,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -109.03999999999999,
        "priceIn": 3226.68,
        "doubleCheck": true
    },
    {
        "dataID": "115472",
        "id": "53085343",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:15",
        "brokerTime": "2025-05-14 14:49:15",
        "commission": -26.32,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049219",
        "positionId": "56049219",
        "volume": 3.76,
        "price": 3226.76,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -26.32,
        "priceIn": 3226.76,
        "doubleCheck": true
    },
    {
        "dataID": "115473",
        "id": "53085346",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:15",
        "brokerTime": "2025-05-14 14:49:15",
        "commission": -26.32,
        "swap": 0,
        "profit": -150.4,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049221",
        "positionId": "56049219",
        "volume": 3.76,
        "price": 3227.16,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -176.72,
        "priceIn": 3226.76,
        "doubleCheck": true
    },
    {
        "dataID": "115474",
        "id": "53085347",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:16",
        "brokerTime": "2025-05-14 14:49:16",
        "commission": -26.32,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049222",
        "positionId": "56049222",
        "volume": 3.76,
        "price": 3226.85,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -26.32,
        "priceIn": 3226.85,
        "doubleCheck": true
    },
    {
        "dataID": "115475",
        "id": "53085350",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:16",
        "brokerTime": "2025-05-14 14:49:16",
        "commission": -26.32,
        "swap": 0,
        "profit": -82.72,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049224",
        "positionId": "56049222",
        "volume": 3.76,
        "price": 3227.07,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -109.03999999999999,
        "priceIn": 3226.85,
        "doubleCheck": true
    },
    {
        "dataID": "115476",
        "id": "53085351",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:17",
        "brokerTime": "2025-05-14 14:49:17",
        "commission": -26.32,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049225",
        "positionId": "56049225",
        "volume": 3.76,
        "price": 3226.8,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -26.32,
        "priceIn": 3226.8,
        "doubleCheck": true
    },
    {
        "dataID": "115477",
        "id": "53085352",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:17",
        "brokerTime": "2025-05-14 14:49:17",
        "commission": -26.32,
        "swap": 0,
        "profit": -71.44,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049226",
        "positionId": "56049225",
        "volume": 3.76,
        "price": 3226.99,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -97.75999999999999,
        "priceIn": 3226.8,
        "doubleCheck": true
    },
    {
        "dataID": "115478",
        "id": "53085353",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:18",
        "brokerTime": "2025-05-14 14:49:18",
        "commission": -26.32,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049227",
        "positionId": "56049227",
        "volume": 3.76,
        "price": 3226.82,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -26.32,
        "priceIn": 3226.82,
        "doubleCheck": true
    },
    {
        "dataID": "115479",
        "id": "53085354",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:18",
        "brokerTime": "2025-05-14 14:49:18",
        "commission": -26.32,
        "swap": 0,
        "profit": -86.48,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049228",
        "positionId": "56049227",
        "volume": 3.76,
        "price": 3227.05,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -112.80000000000001,
        "priceIn": 3226.82,
        "doubleCheck": true
    },
    {
        "dataID": "115480",
        "id": "53085355",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:18",
        "brokerTime": "2025-05-14 14:49:18",
        "commission": -26.32,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049229",
        "positionId": "56049229",
        "volume": 3.76,
        "price": 3226.84,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -26.32,
        "priceIn": 3226.84,
        "doubleCheck": true
    },
    {
        "dataID": "115481",
        "id": "53085356",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:18",
        "brokerTime": "2025-05-14 14:49:19",
        "commission": -26.32,
        "swap": 0,
        "profit": -37.6,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049230",
        "positionId": "56049229",
        "volume": 3.76,
        "price": 3226.94,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -63.92,
        "priceIn": 3226.84,
        "doubleCheck": true
    },
    {
        "dataID": "115482",
        "id": "53085357",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:19",
        "brokerTime": "2025-05-14 14:49:19",
        "commission": -26.32,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049231",
        "positionId": "56049231",
        "volume": 3.76,
        "price": 3226.74,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -26.32,
        "priceIn": 3226.74,
        "doubleCheck": true
    },
    {
        "dataID": "115483",
        "id": "53085358",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:19",
        "brokerTime": "2025-05-14 14:49:20",
        "commission": -26.32,
        "swap": 0,
        "profit": -56.4,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049232",
        "positionId": "56049231",
        "volume": 3.76,
        "price": 3226.89,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -82.72,
        "priceIn": 3226.74,
        "doubleCheck": true
    },
    {
        "dataID": "115484",
        "id": "53085359",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:20",
        "brokerTime": "2025-05-14 14:49:20",
        "commission": -26.32,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049233",
        "positionId": "56049233",
        "volume": 3.76,
        "price": 3226.63,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -26.32,
        "priceIn": 3226.63,
        "doubleCheck": true
    },
    {
        "dataID": "115485",
        "id": "53085360",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:20",
        "brokerTime": "2025-05-14 14:49:21",
        "commission": -26.32,
        "swap": 0,
        "profit": -150.4,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049234",
        "positionId": "56049233",
        "volume": 3.76,
        "price": 3227.03,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -176.72,
        "priceIn": 3226.63,
        "doubleCheck": true
    },
    {
        "dataID": "115486",
        "id": "53085361",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:21",
        "brokerTime": "2025-05-14 14:49:21",
        "commission": -26.32,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049235",
        "positionId": "56049235",
        "volume": 3.76,
        "price": 3226.82,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -26.32,
        "priceIn": 3226.82,
        "doubleCheck": true
    },
    {
        "dataID": "115487",
        "id": "53085362",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:21",
        "brokerTime": "2025-05-14 14:49:22",
        "commission": -26.32,
        "swap": 0,
        "profit": -97.76,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049236",
        "positionId": "56049235",
        "volume": 3.76,
        "price": 3227.08,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -124.08000000000001,
        "priceIn": 3226.82,
        "doubleCheck": true
    },
    {
        "dataID": "115488",
        "id": "53085363",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:23",
        "brokerTime": "2025-05-14 14:49:23",
        "commission": -26.32,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049237",
        "positionId": "56049237",
        "volume": 3.76,
        "price": 3226.84,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -26.32,
        "priceIn": 3226.84,
        "doubleCheck": true
    },
    {
        "dataID": "115489",
        "id": "53085364",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:23",
        "brokerTime": "2025-05-14 14:49:23",
        "commission": -26.32,
        "swap": 0,
        "profit": -142.88,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049238",
        "positionId": "56049237",
        "volume": 3.76,
        "price": 3227.22,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -169.2,
        "priceIn": 3226.84,
        "doubleCheck": true
    },
    {
        "dataID": "115490",
        "id": "53085365",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:23",
        "brokerTime": "2025-05-14 14:49:23",
        "commission": -26.32,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049239",
        "positionId": "56049239",
        "volume": 3.76,
        "price": 3227.04,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -26.32,
        "priceIn": 3227.04,
        "doubleCheck": true
    },
    {
        "dataID": "115491",
        "id": "53085366",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:23",
        "brokerTime": "2025-05-14 14:49:24",
        "commission": -26.32,
        "swap": 0,
        "profit": -154.16,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049240",
        "positionId": "56049239",
        "volume": 3.76,
        "price": 3227.45,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -180.48,
        "priceIn": 3227.04,
        "doubleCheck": true
    },
    {
        "dataID": "115492",
        "id": "53085367",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:24",
        "brokerTime": "2025-05-14 14:49:24",
        "commission": -26.32,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049241",
        "positionId": "56049241",
        "volume": 3.76,
        "price": 3227.25,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -26.32,
        "priceIn": 3227.25,
        "doubleCheck": true
    },
    {
        "dataID": "115493",
        "id": "53085369",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:24",
        "brokerTime": "2025-05-14 14:49:25",
        "commission": -26.32,
        "swap": 0,
        "profit": -60.16,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049243",
        "positionId": "56049241",
        "volume": 3.76,
        "price": 3227.41,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -86.47999999999999,
        "priceIn": 3227.25,
        "doubleCheck": true
    },
    {
        "dataID": "115494",
        "id": "53085371",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:25",
        "brokerTime": "2025-05-14 14:49:25",
        "commission": -26.32,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049244",
        "positionId": "56049244",
        "volume": 3.76,
        "price": 3227.18,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -26.32,
        "priceIn": 3227.18,
        "doubleCheck": true
    },
    {
        "dataID": "115495",
        "id": "53085372",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:25",
        "brokerTime": "2025-05-14 14:49:26",
        "commission": -26.32,
        "swap": 0,
        "profit": -75.2,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049245",
        "positionId": "56049244",
        "volume": 3.76,
        "price": 3227.38,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -101.52000000000001,
        "priceIn": 3227.18,
        "doubleCheck": true
    },
    {
        "dataID": "115496",
        "id": "53085373",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:26",
        "brokerTime": "2025-05-14 14:49:26",
        "commission": -26.32,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049246",
        "positionId": "56049246",
        "volume": 3.76,
        "price": 3227.23,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -26.32,
        "priceIn": 3227.23,
        "doubleCheck": true
    },
    {
        "dataID": "115497",
        "id": "53085374",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:26",
        "brokerTime": "2025-05-14 14:49:27",
        "commission": -26.32,
        "swap": 0,
        "profit": -75.2,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049247",
        "positionId": "56049246",
        "volume": 3.76,
        "price": 3227.43,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -101.52000000000001,
        "priceIn": 3227.23,
        "doubleCheck": true
    },
    {
        "dataID": "115498",
        "id": "53085375",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:27",
        "brokerTime": "2025-05-14 14:49:27",
        "commission": -26.32,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049248",
        "positionId": "56049248",
        "volume": 3.76,
        "price": 3227.19,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -26.32,
        "priceIn": 3227.19,
        "doubleCheck": true
    },
    {
        "dataID": "115499",
        "id": "53085376",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:27",
        "brokerTime": "2025-05-14 14:49:27",
        "commission": -26.32,
        "swap": 0,
        "profit": -75.2,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049249",
        "positionId": "56049248",
        "volume": 3.76,
        "price": 3227.39,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -101.52000000000001,
        "priceIn": 3227.19,
        "doubleCheck": true
    },
    {
        "dataID": "115500",
        "id": "53085377",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:28",
        "brokerTime": "2025-05-14 14:49:28",
        "commission": -26.32,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049250",
        "positionId": "56049250",
        "volume": 3.76,
        "price": 3227.16,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -26.32,
        "priceIn": 3227.16,
        "doubleCheck": true
    },
    {
        "dataID": "115501",
        "id": "53085378",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:28",
        "brokerTime": "2025-05-14 14:49:29",
        "commission": -26.32,
        "swap": 0,
        "profit": -75.2,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049251",
        "positionId": "56049250",
        "volume": 3.76,
        "price": 3227.36,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -101.52000000000001,
        "priceIn": 3227.16,
        "doubleCheck": true
    },
    {
        "dataID": "115502",
        "id": "53085379",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:29",
        "brokerTime": "2025-05-14 14:49:29",
        "commission": -26.32,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049252",
        "positionId": "56049252",
        "volume": 3.76,
        "price": 3227.25,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -26.32,
        "priceIn": 3227.25,
        "doubleCheck": true
    },
    {
        "dataID": "115503",
        "id": "53085380",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:29",
        "brokerTime": "2025-05-14 14:49:30",
        "commission": -26.32,
        "swap": 0,
        "profit": -78.96,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049253",
        "positionId": "56049252",
        "volume": 3.76,
        "price": 3227.46,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -105.28,
        "priceIn": 3227.25,
        "doubleCheck": true
    },
    {
        "dataID": "115504",
        "id": "53085382",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:31",
        "brokerTime": "2025-05-14 14:49:31",
        "commission": -26.32,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049255",
        "positionId": "56049255",
        "volume": 3.76,
        "price": 3227.21,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -26.32,
        "priceIn": 3227.21,
        "doubleCheck": true
    },
    {
        "dataID": "115505",
        "id": "53085383",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:31",
        "brokerTime": "2025-05-14 14:49:31",
        "commission": -26.32,
        "swap": 0,
        "profit": -75.2,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049256",
        "positionId": "56049255",
        "volume": 3.76,
        "price": 3227.41,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -101.52000000000001,
        "priceIn": 3227.21,
        "doubleCheck": true
    },
    {
        "dataID": "115506",
        "id": "53085385",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:32",
        "brokerTime": "2025-05-14 14:49:32",
        "commission": -26.32,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049258",
        "positionId": "56049258",
        "volume": 3.76,
        "price": 3227.2,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -26.32,
        "priceIn": 3227.2,
        "doubleCheck": true
    },
    {
        "dataID": "115507",
        "id": "53085386",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:32",
        "brokerTime": "2025-05-14 14:49:32",
        "commission": -26.32,
        "swap": 0,
        "profit": -67.68,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049259",
        "positionId": "56049258",
        "volume": 3.76,
        "price": 3227.38,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -94,
        "priceIn": 3227.2,
        "doubleCheck": true
    },
    {
        "dataID": "115508",
        "id": "53085387",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:33",
        "brokerTime": "2025-05-14 14:49:33",
        "commission": -26.32,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049260",
        "positionId": "56049260",
        "volume": 3.76,
        "price": 3227.12,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -26.32,
        "priceIn": 3227.12,
        "doubleCheck": true
    },
    {
        "dataID": "115509",
        "id": "53085388",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:33",
        "brokerTime": "2025-05-14 14:49:34",
        "commission": -26.32,
        "swap": 0,
        "profit": -48.88,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049261",
        "positionId": "56049260",
        "volume": 3.76,
        "price": 3227.25,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -75.2,
        "priceIn": 3227.12,
        "doubleCheck": true
    },
    {
        "dataID": "115510",
        "id": "53085389",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:34",
        "brokerTime": "2025-05-14 14:49:34",
        "commission": -26.32,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049262",
        "positionId": "56049262",
        "volume": 3.76,
        "price": 3227.02,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -26.32,
        "priceIn": 3227.02,
        "doubleCheck": true
    },
    {
        "dataID": "115511",
        "id": "53085390",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:34",
        "brokerTime": "2025-05-14 14:49:35",
        "commission": -26.32,
        "swap": 0,
        "profit": -86.48,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049263",
        "positionId": "56049262",
        "volume": 3.76,
        "price": 3227.25,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -112.80000000000001,
        "priceIn": 3227.02,
        "doubleCheck": true
    },
    {
        "dataID": "115512",
        "id": "53085391",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:35",
        "brokerTime": "2025-05-14 14:49:35",
        "commission": -26.32,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049264",
        "positionId": "56049264",
        "volume": 3.76,
        "price": 3226.96,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -26.32,
        "priceIn": 3226.96,
        "doubleCheck": true
    },
    {
        "dataID": "115513",
        "id": "53085392",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:35",
        "brokerTime": "2025-05-14 14:49:36",
        "commission": -26.32,
        "swap": 0,
        "profit": 124.08,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049265",
        "positionId": "56049264",
        "volume": 3.76,
        "price": 3226.63,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 97.75999999999999,
        "priceIn": 3226.96,
        "doubleCheck": true
    },
    {
        "dataID": "115514",
        "id": "53085393",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:37",
        "brokerTime": "2025-05-14 14:49:37",
        "commission": -26.32,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049266",
        "positionId": "56049266",
        "volume": 3.76,
        "price": 3226.54,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -26.32,
        "priceIn": 3226.54,
        "doubleCheck": true
    },
    {
        "dataID": "115515",
        "id": "53085394",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:37",
        "brokerTime": "2025-05-14 14:49:37",
        "commission": -26.32,
        "swap": 0,
        "profit": -135.36,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049267",
        "positionId": "56049266",
        "volume": 3.76,
        "price": 3226.9,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -161.68,
        "priceIn": 3226.54,
        "doubleCheck": true
    },
    {
        "dataID": "115516",
        "id": "53085395",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:37",
        "brokerTime": "2025-05-14 14:49:37",
        "commission": -26.32,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049268",
        "positionId": "56049268",
        "volume": 3.76,
        "price": 3226.65,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -26.32,
        "priceIn": 3226.65,
        "doubleCheck": true
    },
    {
        "dataID": "115517",
        "id": "53085396",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:37",
        "brokerTime": "2025-05-14 14:49:38",
        "commission": -26.32,
        "swap": 0,
        "profit": -131.6,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049269",
        "positionId": "56049268",
        "volume": 3.76,
        "price": 3227,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -157.92,
        "priceIn": 3226.65,
        "doubleCheck": true
    },
    {
        "dataID": "115518",
        "id": "53085397",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:38",
        "brokerTime": "2025-05-14 14:49:38",
        "commission": -26.32,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049270",
        "positionId": "56049270",
        "volume": 3.76,
        "price": 3226.79,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -26.32,
        "priceIn": 3226.79,
        "doubleCheck": true
    },
    {
        "dataID": "115519",
        "id": "53085398",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:38",
        "brokerTime": "2025-05-14 14:49:39",
        "commission": -26.32,
        "swap": 0,
        "profit": -22.56,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049272",
        "positionId": "56049270",
        "volume": 3.76,
        "price": 3226.85,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -48.879999999999995,
        "priceIn": 3226.79,
        "doubleCheck": true
    },
    {
        "dataID": "115520",
        "id": "53085399",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:39",
        "brokerTime": "2025-05-14 14:49:39",
        "commission": -26.32,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049273",
        "positionId": "56049273",
        "volume": 3.76,
        "price": 3226.61,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -26.32,
        "priceIn": 3226.61,
        "doubleCheck": true
    },
    {
        "dataID": "115521",
        "id": "53085400",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:39",
        "brokerTime": "2025-05-14 14:49:40",
        "commission": -26.32,
        "swap": 0,
        "profit": -75.2,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049274",
        "positionId": "56049273",
        "volume": 3.76,
        "price": 3226.81,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -101.52000000000001,
        "priceIn": 3226.61,
        "doubleCheck": true
    },
    {
        "dataID": "115522",
        "id": "53085403",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:40",
        "brokerTime": "2025-05-14 14:49:40",
        "commission": -26.32,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049277",
        "positionId": "56049277",
        "volume": 3.76,
        "price": 3226.97,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -26.32,
        "priceIn": 3226.97,
        "doubleCheck": true
    },
    {
        "dataID": "115523",
        "id": "53085404",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:40",
        "brokerTime": "2025-05-14 14:49:40",
        "commission": -26.32,
        "swap": 0,
        "profit": -86.48,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049278",
        "positionId": "56049277",
        "volume": 3.76,
        "price": 3227.2,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -112.80000000000001,
        "priceIn": 3226.97,
        "doubleCheck": true
    },
    {
        "dataID": "115524",
        "id": "53085405",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:41",
        "brokerTime": "2025-05-14 14:49:41",
        "commission": -26.32,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049279",
        "positionId": "56049279",
        "volume": 3.76,
        "price": 3226.97,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -26.32,
        "priceIn": 3226.97,
        "doubleCheck": true
    },
    {
        "dataID": "115525",
        "id": "53085406",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:41",
        "brokerTime": "2025-05-14 14:49:41",
        "commission": -26.32,
        "swap": 0,
        "profit": -127.84,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049280",
        "positionId": "56049279",
        "volume": 3.76,
        "price": 3227.31,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -154.16,
        "priceIn": 3226.97,
        "doubleCheck": true
    },
    {
        "dataID": "115526",
        "id": "53085407",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:42",
        "brokerTime": "2025-05-14 14:49:42",
        "commission": -26.32,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049281",
        "positionId": "56049281",
        "volume": 3.76,
        "price": 3227.08,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -26.32,
        "priceIn": 3227.08,
        "doubleCheck": true
    },
    {
        "dataID": "115527",
        "id": "53085408",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:42",
        "brokerTime": "2025-05-14 14:49:43",
        "commission": -26.32,
        "swap": 0,
        "profit": -78.96,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049282",
        "positionId": "56049281",
        "volume": 3.76,
        "price": 3227.29,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -105.28,
        "priceIn": 3227.08,
        "doubleCheck": true
    },
    {
        "dataID": "115528",
        "id": "53085409",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:44",
        "brokerTime": "2025-05-14 14:49:44",
        "commission": -26.32,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049283",
        "positionId": "56049283",
        "volume": 3.76,
        "price": 3227.03,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -26.32,
        "priceIn": 3227.03,
        "doubleCheck": true
    },
    {
        "dataID": "115529",
        "id": "53085410",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:44",
        "brokerTime": "2025-05-14 14:49:44",
        "commission": -26.32,
        "swap": 0,
        "profit": -48.88,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049284",
        "positionId": "56049283",
        "volume": 3.76,
        "price": 3227.16,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -75.2,
        "priceIn": 3227.03,
        "doubleCheck": true
    },
    {
        "dataID": "115530",
        "id": "53085411",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:45",
        "brokerTime": "2025-05-14 14:49:45",
        "commission": -26.32,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049285",
        "positionId": "56049285",
        "volume": 3.76,
        "price": 3226.99,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -26.32,
        "priceIn": 3226.99,
        "doubleCheck": true
    },
    {
        "dataID": "115531",
        "id": "53085412",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:45",
        "brokerTime": "2025-05-14 14:49:45",
        "commission": -26.32,
        "swap": 0,
        "profit": -78.96,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049286",
        "positionId": "56049285",
        "volume": 3.76,
        "price": 3227.2,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -105.28,
        "priceIn": 3226.99,
        "doubleCheck": true
    },
    {
        "dataID": "115532",
        "id": "53085413",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:46",
        "brokerTime": "2025-05-14 14:49:46",
        "commission": -26.32,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049287",
        "positionId": "56049287",
        "volume": 3.76,
        "price": 3226.98,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -26.32,
        "priceIn": 3226.98,
        "doubleCheck": true
    },
    {
        "dataID": "115533",
        "id": "53085414",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:46",
        "brokerTime": "2025-05-14 14:49:46",
        "commission": -26.32,
        "swap": 0,
        "profit": -105.28,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049288",
        "positionId": "56049287",
        "volume": 3.76,
        "price": 3227.26,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -131.6,
        "priceIn": 3226.98,
        "doubleCheck": true
    },
    {
        "dataID": "115534",
        "id": "53085415",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:46",
        "brokerTime": "2025-05-14 14:49:46",
        "commission": -26.32,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049289",
        "positionId": "56049289",
        "volume": 3.76,
        "price": 3227.05,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -26.32,
        "priceIn": 3227.05,
        "doubleCheck": true
    },
    {
        "dataID": "115535",
        "id": "53085416",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:46",
        "brokerTime": "2025-05-14 14:49:47",
        "commission": -26.32,
        "swap": 0,
        "profit": -86.48,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049290",
        "positionId": "56049289",
        "volume": 3.76,
        "price": 3227.28,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -112.80000000000001,
        "priceIn": 3227.05,
        "doubleCheck": true
    },
    {
        "dataID": "115536",
        "id": "53085417",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:48",
        "brokerTime": "2025-05-14 14:49:48",
        "commission": -26.32,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049291",
        "positionId": "56049291",
        "volume": 3.76,
        "price": 3227.12,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -26.32,
        "priceIn": 3227.12,
        "doubleCheck": true
    },
    {
        "dataID": "115537",
        "id": "53085418",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:48",
        "brokerTime": "2025-05-14 14:49:48",
        "commission": -26.32,
        "swap": 0,
        "profit": -78.96,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049292",
        "positionId": "56049291",
        "volume": 3.76,
        "price": 3227.33,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -105.28,
        "priceIn": 3227.12,
        "doubleCheck": true
    },
    {
        "dataID": "115538",
        "id": "53085420",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:49",
        "brokerTime": "2025-05-14 14:49:49",
        "commission": -26.32,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049293",
        "positionId": "56049293",
        "volume": 3.76,
        "price": 3227.06,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -26.32,
        "priceIn": 3227.06,
        "doubleCheck": true
    },
    {
        "dataID": "115539",
        "id": "53085421",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:49",
        "brokerTime": "2025-05-14 14:49:49",
        "commission": -26.32,
        "swap": 0,
        "profit": -86.48,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049294",
        "positionId": "56049293",
        "volume": 3.76,
        "price": 3227.29,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -112.80000000000001,
        "priceIn": 3227.06,
        "doubleCheck": true
    },
    {
        "dataID": "115540",
        "id": "53085422",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:51",
        "brokerTime": "2025-05-14 14:49:51",
        "commission": -26.32,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049295",
        "positionId": "56049295",
        "volume": 3.76,
        "price": 3227.05,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -26.32,
        "priceIn": 3227.05,
        "doubleCheck": true
    },
    {
        "dataID": "115541",
        "id": "53085423",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:51",
        "brokerTime": "2025-05-14 14:49:51",
        "commission": -26.32,
        "swap": 0,
        "profit": -127.84,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049296",
        "positionId": "56049295",
        "volume": 3.76,
        "price": 3227.39,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -154.16,
        "priceIn": 3227.05,
        "doubleCheck": true
    },
    {
        "dataID": "115542",
        "id": "53085424",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:51",
        "brokerTime": "2025-05-14 14:49:51",
        "commission": -26.32,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049297",
        "positionId": "56049297",
        "volume": 3.76,
        "price": 3227.17,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -26.32,
        "priceIn": 3227.17,
        "doubleCheck": true
    },
    {
        "dataID": "115543",
        "id": "53085425",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:51",
        "brokerTime": "2025-05-14 14:49:52",
        "commission": -26.32,
        "swap": 0,
        "profit": 11.28,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049298",
        "positionId": "56049297",
        "volume": 3.76,
        "price": 3227.14,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -15.040000000000001,
        "priceIn": 3227.17,
        "doubleCheck": true
    },
    {
        "dataID": "115544",
        "id": "53085426",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:52",
        "brokerTime": "2025-05-14 14:49:52",
        "commission": -26.32,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049299",
        "positionId": "56049299",
        "volume": 3.76,
        "price": 3226.86,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -26.32,
        "priceIn": 3226.86,
        "doubleCheck": true
    },
    {
        "dataID": "115545",
        "id": "53085427",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:52",
        "brokerTime": "2025-05-14 14:49:53",
        "commission": -26.32,
        "swap": 0,
        "profit": -157.92,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049300",
        "positionId": "56049299",
        "volume": 3.76,
        "price": 3227.28,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -184.23999999999998,
        "priceIn": 3226.86,
        "doubleCheck": true
    },
    {
        "dataID": "115546",
        "id": "53085429",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:53",
        "brokerTime": "2025-05-14 14:49:53",
        "commission": -26.32,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049302",
        "positionId": "56049302",
        "volume": 3.76,
        "price": 3227.07,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -26.32,
        "priceIn": 3227.07,
        "doubleCheck": true
    },
    {
        "dataID": "115547",
        "id": "53085430",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:53",
        "brokerTime": "2025-05-14 14:49:53",
        "commission": -26.32,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049303",
        "positionId": "56049302",
        "volume": 3.76,
        "price": 3227.07,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -26.32,
        "priceIn": 3227.07,
        "doubleCheck": true
    },
    {
        "dataID": "115548",
        "id": "53085431",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:54",
        "brokerTime": "2025-05-14 14:49:54",
        "commission": -26.32,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049304",
        "positionId": "56049304",
        "volume": 3.76,
        "price": 3226.81,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -26.32,
        "priceIn": 3226.81,
        "doubleCheck": true
    },
    {
        "dataID": "115549",
        "id": "53085432",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:54",
        "brokerTime": "2025-05-14 14:49:54",
        "commission": -26.32,
        "swap": 0,
        "profit": -131.6,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049305",
        "positionId": "56049304",
        "volume": 3.76,
        "price": 3227.16,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -157.92,
        "priceIn": 3226.81,
        "doubleCheck": true
    },
    {
        "dataID": "115550",
        "id": "53085433",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:55",
        "brokerTime": "2025-05-14 14:49:55",
        "commission": -26.32,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049306",
        "positionId": "56049306",
        "volume": 3.76,
        "price": 3226.86,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -26.32,
        "priceIn": 3226.86,
        "doubleCheck": true
    },
    {
        "dataID": "115551",
        "id": "53085434",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:55",
        "brokerTime": "2025-05-14 14:49:55",
        "commission": -26.32,
        "swap": 0,
        "profit": -75.2,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049307",
        "positionId": "56049306",
        "volume": 3.76,
        "price": 3227.06,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -101.52000000000001,
        "priceIn": 3226.86,
        "doubleCheck": true
    },
    {
        "dataID": "115552",
        "id": "53085435",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:56",
        "brokerTime": "2025-05-14 14:49:56",
        "commission": -26.32,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049308",
        "positionId": "56049308",
        "volume": 3.76,
        "price": 3226.78,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -26.32,
        "priceIn": 3226.78,
        "doubleCheck": true
    },
    {
        "dataID": "115553",
        "id": "53085436",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:56",
        "brokerTime": "2025-05-14 14:49:56",
        "commission": -26.32,
        "swap": 0,
        "profit": -82.72,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049310",
        "positionId": "56049308",
        "volume": 3.76,
        "price": 3227,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -109.03999999999999,
        "priceIn": 3226.78,
        "doubleCheck": true
    },
    {
        "dataID": "115554",
        "id": "53085437",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:57",
        "brokerTime": "2025-05-14 14:49:57",
        "commission": -26.32,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049311",
        "positionId": "56049311",
        "volume": 3.76,
        "price": 3226.72,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -26.32,
        "priceIn": 3226.72,
        "doubleCheck": true
    },
    {
        "dataID": "115555",
        "id": "53085438",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:57",
        "brokerTime": "2025-05-14 14:49:58",
        "commission": -26.32,
        "swap": 0,
        "profit": -30.08,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049312",
        "positionId": "56049311",
        "volume": 3.76,
        "price": 3226.8,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.4,
        "priceIn": 3226.72,
        "doubleCheck": true
    },
    {
        "dataID": "115556",
        "id": "53085439",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:58",
        "brokerTime": "2025-05-14 14:49:58",
        "commission": -26.32,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049313",
        "positionId": "56049313",
        "volume": 3.76,
        "price": 3226.5,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -26.32,
        "priceIn": 3226.5,
        "doubleCheck": true
    },
    {
        "dataID": "115557",
        "id": "53085440",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:58",
        "brokerTime": "2025-05-14 14:49:59",
        "commission": -26.32,
        "swap": 0,
        "profit": -90.24,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049314",
        "positionId": "56049313",
        "volume": 3.76,
        "price": 3226.74,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -116.56,
        "priceIn": 3226.5,
        "doubleCheck": true
    },
    {
        "dataID": "115558",
        "id": "53085441",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:59",
        "brokerTime": "2025-05-14 14:49:59",
        "commission": -26.32,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049315",
        "positionId": "56049315",
        "volume": 3.76,
        "price": 3226.52,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -26.32,
        "priceIn": 3226.52,
        "doubleCheck": true
    },
    {
        "dataID": "115559",
        "id": "53085443",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:59",
        "brokerTime": "2025-05-14 14:50:00",
        "commission": -26.32,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049317",
        "positionId": "56049315",
        "volume": 3.76,
        "price": 3226.52,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -26.32,
        "priceIn": 3226.52,
        "doubleCheck": true
    },
    {
        "dataID": "115560",
        "id": "53085444",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:00",
        "brokerTime": "2025-05-14 14:50:00",
        "commission": -26.32,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049318",
        "positionId": "56049318",
        "volume": 3.76,
        "price": 3226.27,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -26.32,
        "priceIn": 3226.27,
        "doubleCheck": true
    },
    {
        "dataID": "115561",
        "id": "53085449",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:00",
        "brokerTime": "2025-05-14 14:50:01",
        "commission": -26.32,
        "swap": 0,
        "profit": -127.84,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049322",
        "positionId": "56049318",
        "volume": 3.76,
        "price": 3226.61,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -154.16,
        "priceIn": 3226.27,
        "doubleCheck": true
    },
    {
        "dataID": "115562",
        "id": "53085450",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:01",
        "brokerTime": "2025-05-14 14:50:01",
        "commission": -26.32,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049323",
        "positionId": "56049323",
        "volume": 3.76,
        "price": 3226.37,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -26.32,
        "priceIn": 3226.37,
        "doubleCheck": true
    },
    {
        "dataID": "115563",
        "id": "53085453",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:01",
        "brokerTime": "2025-05-14 14:50:01",
        "commission": -26.32,
        "swap": 0,
        "profit": -131.6,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049326",
        "positionId": "56049323",
        "volume": 3.76,
        "price": 3226.72,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -157.92,
        "priceIn": 3226.37,
        "doubleCheck": true
    },
    {
        "dataID": "115564",
        "id": "53085455",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:02",
        "brokerTime": "2025-05-14 14:50:02",
        "commission": -26.32,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049328",
        "positionId": "56049328",
        "volume": 3.76,
        "price": 3226.5,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -26.32,
        "priceIn": 3226.5,
        "doubleCheck": true
    },
    {
        "dataID": "115565",
        "id": "53085456",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:02",
        "brokerTime": "2025-05-14 14:50:03",
        "commission": -26.32,
        "swap": 0,
        "profit": -63.92,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049329",
        "positionId": "56049328",
        "volume": 3.76,
        "price": 3226.67,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -90.24000000000001,
        "priceIn": 3226.5,
        "doubleCheck": true
    },
    {
        "dataID": "115566",
        "id": "53085457",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:03",
        "brokerTime": "2025-05-14 14:50:03",
        "commission": -26.32,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049330",
        "positionId": "56049330",
        "volume": 3.76,
        "price": 3226.41,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -26.32,
        "priceIn": 3226.41,
        "doubleCheck": true
    },
    {
        "dataID": "115567",
        "id": "53085459",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:03",
        "brokerTime": "2025-05-14 14:50:04",
        "commission": -26.32,
        "swap": 0,
        "profit": -78.96,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049332",
        "positionId": "56049330",
        "volume": 3.76,
        "price": 3226.62,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -105.28,
        "priceIn": 3226.41,
        "doubleCheck": true
    },
    {
        "dataID": "115568",
        "id": "53085462",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:04",
        "brokerTime": "2025-05-14 14:50:04",
        "commission": -26.32,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049334",
        "positionId": "56049334",
        "volume": 3.76,
        "price": 3226.24,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -26.32,
        "priceIn": 3226.24,
        "doubleCheck": true
    },
    {
        "dataID": "115569",
        "id": "53085463",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:04",
        "brokerTime": "2025-05-14 14:50:05",
        "commission": -26.32,
        "swap": 0,
        "profit": -48.88,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049336",
        "positionId": "56049334",
        "volume": 3.76,
        "price": 3226.37,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -75.2,
        "priceIn": 3226.24,
        "doubleCheck": true
    },
    {
        "dataID": "115570",
        "id": "53085464",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 14:50:05",
        "brokerTime": "2025-05-14 14:50:05",
        "commission": -5.18,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049337",
        "positionId": "56049337",
        "volume": 0.74,
        "price": 3226.32,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3326.37,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -5.18,
        "priceIn": 3226.32,
        "doubleCheck": true
    },
    {
        "dataID": "115571",
        "id": "53085470",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:06",
        "brokerTime": "2025-05-14 14:50:06",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049340",
        "positionId": "56049340",
        "volume": 4.65,
        "price": 3226.23,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.23,
        "doubleCheck": true
    },
    {
        "dataID": "115572",
        "id": "53085471",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:06",
        "brokerTime": "2025-05-14 14:50:06",
        "commission": -32.55,
        "swap": 0,
        "profit": -139.5,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049341",
        "positionId": "56049340",
        "volume": 4.65,
        "price": 3226.53,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -172.05,
        "priceIn": 3226.23,
        "doubleCheck": true
    },
    {
        "dataID": "115573",
        "id": "53085472",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:08",
        "brokerTime": "2025-05-14 14:50:08",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049342",
        "positionId": "56049342",
        "volume": 4.65,
        "price": 3226.68,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.68,
        "doubleCheck": true
    },
    {
        "dataID": "115574",
        "id": "53085473",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:08",
        "brokerTime": "2025-05-14 14:50:08",
        "commission": -32.55,
        "swap": 0,
        "profit": -97.65,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049343",
        "positionId": "56049342",
        "volume": 4.65,
        "price": 3226.89,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -130.2,
        "priceIn": 3226.68,
        "doubleCheck": true
    },
    {
        "dataID": "115575",
        "id": "53085474",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:09",
        "brokerTime": "2025-05-14 14:50:09",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049344",
        "positionId": "56049344",
        "volume": 4.65,
        "price": 3226.72,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.72,
        "doubleCheck": true
    },
    {
        "dataID": "115576",
        "id": "53085475",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:09",
        "brokerTime": "2025-05-14 14:50:09",
        "commission": -32.55,
        "swap": 0,
        "profit": -102.3,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049345",
        "positionId": "56049344",
        "volume": 4.65,
        "price": 3226.94,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -134.85,
        "priceIn": 3226.72,
        "doubleCheck": true
    },
    {
        "dataID": "115577",
        "id": "53085476",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:09",
        "brokerTime": "2025-05-14 14:50:09",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049346",
        "positionId": "56049346",
        "volume": 4.65,
        "price": 3226.8,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.8,
        "doubleCheck": true
    },
    {
        "dataID": "115578",
        "id": "53085477",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:09",
        "brokerTime": "2025-05-14 14:50:09",
        "commission": -32.55,
        "swap": 0,
        "profit": -102.3,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049347",
        "positionId": "56049346",
        "volume": 4.65,
        "price": 3227.02,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -134.85,
        "priceIn": 3226.8,
        "doubleCheck": true
    },
    {
        "dataID": "115579",
        "id": "53085478",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:10",
        "brokerTime": "2025-05-14 14:50:10",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049348",
        "positionId": "56049348",
        "volume": 4.65,
        "price": 3226.81,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.81,
        "doubleCheck": true
    },
    {
        "dataID": "115580",
        "id": "53085479",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:10",
        "brokerTime": "2025-05-14 14:50:10",
        "commission": -32.55,
        "swap": 0,
        "profit": -204.6,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049349",
        "positionId": "56049348",
        "volume": 4.65,
        "price": 3227.25,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -237.14999999999998,
        "priceIn": 3226.81,
        "doubleCheck": true
    },
    {
        "dataID": "115581",
        "id": "53085480",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:10",
        "brokerTime": "2025-05-14 14:50:10",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049350",
        "positionId": "56049350",
        "volume": 4.65,
        "price": 3227.02,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3227.02,
        "doubleCheck": true
    },
    {
        "dataID": "115582",
        "id": "53085481",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:10",
        "brokerTime": "2025-05-14 14:50:10",
        "commission": -32.55,
        "swap": 0,
        "profit": -97.65,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049351",
        "positionId": "56049350",
        "volume": 4.65,
        "price": 3227.23,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -130.2,
        "priceIn": 3227.02,
        "doubleCheck": true
    },
    {
        "dataID": "115583",
        "id": "53085482",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:11",
        "brokerTime": "2025-05-14 14:50:11",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049352",
        "positionId": "56049352",
        "volume": 4.65,
        "price": 3227,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3227,
        "doubleCheck": true
    },
    {
        "dataID": "115584",
        "id": "53085483",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:11",
        "brokerTime": "2025-05-14 14:50:11",
        "commission": -32.55,
        "swap": 0,
        "profit": -102.3,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049353",
        "positionId": "56049352",
        "volume": 4.65,
        "price": 3227.22,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -134.85,
        "priceIn": 3227,
        "doubleCheck": true
    },
    {
        "dataID": "115585",
        "id": "53085484",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:12",
        "brokerTime": "2025-05-14 14:50:12",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049354",
        "positionId": "56049354",
        "volume": 4.65,
        "price": 3226.97,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.97,
        "doubleCheck": true
    },
    {
        "dataID": "115586",
        "id": "53085485",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:12",
        "brokerTime": "2025-05-14 14:50:12",
        "commission": -32.55,
        "swap": 0,
        "profit": -102.3,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049355",
        "positionId": "56049354",
        "volume": 4.65,
        "price": 3227.19,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -134.85,
        "priceIn": 3226.97,
        "doubleCheck": true
    },
    {
        "dataID": "115587",
        "id": "53085486",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:12",
        "brokerTime": "2025-05-14 14:50:12",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049356",
        "positionId": "56049356",
        "volume": 4.65,
        "price": 3227.06,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3227.06,
        "doubleCheck": true
    },
    {
        "dataID": "115588",
        "id": "53085487",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:12",
        "brokerTime": "2025-05-14 14:50:13",
        "commission": -32.55,
        "swap": 0,
        "profit": -116.25,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049357",
        "positionId": "56049356",
        "volume": 4.65,
        "price": 3227.31,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -148.8,
        "priceIn": 3227.06,
        "doubleCheck": true
    },
    {
        "dataID": "115589",
        "id": "53085489",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:13",
        "brokerTime": "2025-05-14 14:50:13",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049359",
        "positionId": "56049359",
        "volume": 4.65,
        "price": 3227.16,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3227.16,
        "doubleCheck": true
    },
    {
        "dataID": "115590",
        "id": "53085490",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:13",
        "brokerTime": "2025-05-14 14:50:13",
        "commission": -32.55,
        "swap": 0,
        "profit": -97.65,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049360",
        "positionId": "56049359",
        "volume": 4.65,
        "price": 3227.37,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -130.2,
        "priceIn": 3227.16,
        "doubleCheck": true
    },
    {
        "dataID": "115591",
        "id": "53085491",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:14",
        "brokerTime": "2025-05-14 14:50:14",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049361",
        "positionId": "56049361",
        "volume": 4.65,
        "price": 3227.1,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3227.1,
        "doubleCheck": true
    },
    {
        "dataID": "115592",
        "id": "53085493",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:14",
        "brokerTime": "2025-05-14 14:50:14",
        "commission": -32.55,
        "swap": 0,
        "profit": -130.2,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049363",
        "positionId": "56049361",
        "volume": 4.65,
        "price": 3227.38,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -162.75,
        "priceIn": 3227.1,
        "doubleCheck": true
    },
    {
        "dataID": "115593",
        "id": "53085494",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:14",
        "brokerTime": "2025-05-14 14:50:14",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049364",
        "positionId": "56049364",
        "volume": 4.65,
        "price": 3227.19,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3227.19,
        "doubleCheck": true
    },
    {
        "dataID": "115594",
        "id": "53085495",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:14",
        "brokerTime": "2025-05-14 14:50:15",
        "commission": -32.55,
        "swap": 0,
        "profit": -167.4,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049365",
        "positionId": "56049364",
        "volume": 4.65,
        "price": 3227.55,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -199.95,
        "priceIn": 3227.19,
        "doubleCheck": true
    },
    {
        "dataID": "115595",
        "id": "53085496",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:15",
        "brokerTime": "2025-05-14 14:50:15",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049366",
        "positionId": "56049366",
        "volume": 4.65,
        "price": 3227.27,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3227.27,
        "doubleCheck": true
    },
    {
        "dataID": "115596",
        "id": "53085497",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:15",
        "brokerTime": "2025-05-14 14:50:15",
        "commission": -32.55,
        "swap": 0,
        "profit": -102.3,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049367",
        "positionId": "56049366",
        "volume": 4.65,
        "price": 3227.49,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -134.85,
        "priceIn": 3227.27,
        "doubleCheck": true
    },
    {
        "dataID": "115597",
        "id": "53085498",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:15",
        "brokerTime": "2025-05-14 14:50:15",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049368",
        "positionId": "56049368",
        "volume": 4.65,
        "price": 3227.26,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3227.26,
        "doubleCheck": true
    },
    {
        "dataID": "115599",
        "id": "53085500",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:16",
        "brokerTime": "2025-05-14 14:50:16",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049370",
        "positionId": "56049370",
        "volume": 4.65,
        "price": 3227.31,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3227.31,
        "doubleCheck": true
    },
    {
        "dataID": "115600",
        "id": "53085502",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:16",
        "brokerTime": "2025-05-14 14:50:16",
        "commission": -32.55,
        "swap": 0,
        "profit": -195.3,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049372",
        "positionId": "56049370",
        "volume": 4.65,
        "price": 3227.73,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -227.85000000000002,
        "priceIn": 3227.31,
        "doubleCheck": true
    },
    {
        "dataID": "115601",
        "id": "53085503",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:16",
        "brokerTime": "2025-05-14 14:50:16",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049373",
        "positionId": "56049373",
        "volume": 4.65,
        "price": 3227.44,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3227.44,
        "doubleCheck": true
    },
    {
        "dataID": "115598",
        "id": "53085499",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:15",
        "brokerTime": "2025-05-14 14:50:16",
        "commission": -32.55,
        "swap": 0,
        "profit": -97.65,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049369",
        "positionId": "56049368",
        "volume": 4.65,
        "price": 3227.47,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -130.2,
        "priceIn": 3227.26,
        "doubleCheck": true
    },
    {
        "dataID": "115602",
        "id": "53085504",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:16",
        "brokerTime": "2025-05-14 14:50:17",
        "commission": -32.55,
        "swap": 0,
        "profit": -97.65,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049374",
        "positionId": "56049373",
        "volume": 4.65,
        "price": 3227.65,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -130.2,
        "priceIn": 3227.44,
        "doubleCheck": true
    },
    {
        "dataID": "115603",
        "id": "53085505",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:17",
        "brokerTime": "2025-05-14 14:50:17",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049375",
        "positionId": "56049375",
        "volume": 4.65,
        "price": 3227.42,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3227.42,
        "doubleCheck": true
    },
    {
        "dataID": "115604",
        "id": "53085506",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:17",
        "brokerTime": "2025-05-14 14:50:17",
        "commission": -32.55,
        "swap": 0,
        "profit": -83.7,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049376",
        "positionId": "56049375",
        "volume": 4.65,
        "price": 3227.6,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -116.25,
        "priceIn": 3227.42,
        "doubleCheck": true
    },
    {
        "dataID": "115605",
        "id": "53085507",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:18",
        "brokerTime": "2025-05-14 14:50:18",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049377",
        "positionId": "56049377",
        "volume": 4.65,
        "price": 3227.38,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3227.38,
        "doubleCheck": true
    },
    {
        "dataID": "115606",
        "id": "53085508",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:18",
        "brokerTime": "2025-05-14 14:50:18",
        "commission": -32.55,
        "swap": 0,
        "profit": -97.65,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049378",
        "positionId": "56049377",
        "volume": 4.65,
        "price": 3227.59,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -130.2,
        "priceIn": 3227.38,
        "doubleCheck": true
    },
    {
        "dataID": "115607",
        "id": "53085509",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:18",
        "brokerTime": "2025-05-14 14:50:18",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049379",
        "positionId": "56049379",
        "volume": 4.65,
        "price": 3227.47,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3227.47,
        "doubleCheck": true
    },
    {
        "dataID": "115608",
        "id": "53085510",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:18",
        "brokerTime": "2025-05-14 14:50:18",
        "commission": -32.55,
        "swap": 0,
        "profit": -46.5,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049380",
        "positionId": "56049379",
        "volume": 4.65,
        "price": 3227.57,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -79.05,
        "priceIn": 3227.47,
        "doubleCheck": true
    },
    {
        "dataID": "115609",
        "id": "53085511",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:19",
        "brokerTime": "2025-05-14 14:50:19",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049382",
        "positionId": "56049382",
        "volume": 4.65,
        "price": 3227.2,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3227.2,
        "doubleCheck": true
    },
    {
        "dataID": "115610",
        "id": "53085512",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:19",
        "brokerTime": "2025-05-14 14:50:19",
        "commission": -32.55,
        "swap": 0,
        "profit": -102.3,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049383",
        "positionId": "56049382",
        "volume": 4.65,
        "price": 3227.42,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -134.85,
        "priceIn": 3227.2,
        "doubleCheck": true
    },
    {
        "dataID": "115611",
        "id": "53085513",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:20",
        "brokerTime": "2025-05-14 14:50:20",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049384",
        "positionId": "56049384",
        "volume": 4.65,
        "price": 3227.19,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3227.19,
        "doubleCheck": true
    },
    {
        "dataID": "115612",
        "id": "53085514",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:20",
        "brokerTime": "2025-05-14 14:50:20",
        "commission": -32.55,
        "swap": 0,
        "profit": -102.3,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049385",
        "positionId": "56049384",
        "volume": 4.65,
        "price": 3227.41,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -134.85,
        "priceIn": 3227.19,
        "doubleCheck": true
    },
    {
        "dataID": "115613",
        "id": "53085515",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:21",
        "brokerTime": "2025-05-14 14:50:21",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049386",
        "positionId": "56049386",
        "volume": 4.65,
        "price": 3227.15,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3227.15,
        "doubleCheck": true
    },
    {
        "dataID": "115614",
        "id": "53085516",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:21",
        "brokerTime": "2025-05-14 14:50:21",
        "commission": -32.55,
        "swap": 0,
        "profit": -88.35,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049387",
        "positionId": "56049386",
        "volume": 4.65,
        "price": 3227.34,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -120.89999999999999,
        "priceIn": 3227.15,
        "doubleCheck": true
    },
    {
        "dataID": "115615",
        "id": "53085517",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:21",
        "brokerTime": "2025-05-14 14:50:21",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049388",
        "positionId": "56049388",
        "volume": 4.65,
        "price": 3227.11,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3227.11,
        "doubleCheck": true
    },
    {
        "dataID": "115616",
        "id": "53085518",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:21",
        "brokerTime": "2025-05-14 14:50:22",
        "commission": -32.55,
        "swap": 0,
        "profit": -102.3,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049389",
        "positionId": "56049388",
        "volume": 4.65,
        "price": 3227.33,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -134.85,
        "priceIn": 3227.11,
        "doubleCheck": true
    },
    {
        "dataID": "115617",
        "id": "53085519",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:22",
        "brokerTime": "2025-05-14 14:50:22",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049390",
        "positionId": "56049390",
        "volume": 4.65,
        "price": 3227.09,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3227.09,
        "doubleCheck": true
    },
    {
        "dataID": "115618",
        "id": "53085520",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:22",
        "brokerTime": "2025-05-14 14:50:22",
        "commission": -32.55,
        "swap": 0,
        "profit": -106.95,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049391",
        "positionId": "56049390",
        "volume": 4.65,
        "price": 3227.32,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -139.5,
        "priceIn": 3227.09,
        "doubleCheck": true
    },
    {
        "dataID": "115619",
        "id": "53085521",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:23",
        "brokerTime": "2025-05-14 14:50:23",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049392",
        "positionId": "56049392",
        "volume": 4.65,
        "price": 3227.19,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3227.19,
        "doubleCheck": true
    },
    {
        "dataID": "115620",
        "id": "53085522",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:23",
        "brokerTime": "2025-05-14 14:50:23",
        "commission": -32.55,
        "swap": 0,
        "profit": -102.3,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049393",
        "positionId": "56049392",
        "volume": 4.65,
        "price": 3227.41,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -134.85,
        "priceIn": 3227.19,
        "doubleCheck": true
    },
    {
        "dataID": "115621",
        "id": "53085523",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:24",
        "brokerTime": "2025-05-14 14:50:24",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049394",
        "positionId": "56049394",
        "volume": 4.65,
        "price": 3227.03,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3227.03,
        "doubleCheck": true
    },
    {
        "dataID": "115622",
        "id": "53085524",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:24",
        "brokerTime": "2025-05-14 14:50:24",
        "commission": -32.55,
        "swap": 0,
        "profit": -97.65,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049395",
        "positionId": "56049394",
        "volume": 4.65,
        "price": 3227.24,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -130.2,
        "priceIn": 3227.03,
        "doubleCheck": true
    },
    {
        "dataID": "115623",
        "id": "53085527",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:25",
        "brokerTime": "2025-05-14 14:50:25",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049398",
        "positionId": "56049398",
        "volume": 4.65,
        "price": 3227.05,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3227.05,
        "doubleCheck": true
    },
    {
        "dataID": "115624",
        "id": "53085528",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:25",
        "brokerTime": "2025-05-14 14:50:25",
        "commission": -32.55,
        "swap": 0,
        "profit": -93,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049399",
        "positionId": "56049398",
        "volume": 4.65,
        "price": 3227.25,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -125.55,
        "priceIn": 3227.05,
        "doubleCheck": true
    },
    {
        "dataID": "115625",
        "id": "53085529",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:25",
        "brokerTime": "2025-05-14 14:50:25",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049400",
        "positionId": "56049400",
        "volume": 4.65,
        "price": 3227.01,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3227.01,
        "doubleCheck": true
    },
    {
        "dataID": "115626",
        "id": "53085530",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:25",
        "brokerTime": "2025-05-14 14:50:25",
        "commission": -32.55,
        "swap": 0,
        "profit": -69.75,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049401",
        "positionId": "56049400",
        "volume": 4.65,
        "price": 3227.16,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -102.3,
        "priceIn": 3227.01,
        "doubleCheck": true
    },
    {
        "dataID": "115627",
        "id": "53085531",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:26",
        "brokerTime": "2025-05-14 14:50:26",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049402",
        "positionId": "56049402",
        "volume": 4.65,
        "price": 3226.92,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.92,
        "doubleCheck": true
    },
    {
        "dataID": "115628",
        "id": "53085532",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:26",
        "brokerTime": "2025-05-14 14:50:26",
        "commission": -32.55,
        "swap": 0,
        "profit": -97.65,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049403",
        "positionId": "56049402",
        "volume": 4.65,
        "price": 3227.13,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -130.2,
        "priceIn": 3226.92,
        "doubleCheck": true
    },
    {
        "dataID": "115629",
        "id": "53085533",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:26",
        "brokerTime": "2025-05-14 14:50:26",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049404",
        "positionId": "56049404",
        "volume": 4.65,
        "price": 3226.92,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.92,
        "doubleCheck": true
    },
    {
        "dataID": "115630",
        "id": "53085534",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:26",
        "brokerTime": "2025-05-14 14:50:27",
        "commission": -32.55,
        "swap": 0,
        "profit": -102.3,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049405",
        "positionId": "56049404",
        "volume": 4.65,
        "price": 3227.14,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -134.85,
        "priceIn": 3226.92,
        "doubleCheck": true
    },
    {
        "dataID": "115631",
        "id": "53085535",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:27",
        "brokerTime": "2025-05-14 14:50:27",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049406",
        "positionId": "56049406",
        "volume": 4.65,
        "price": 3227.1,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3227.1,
        "doubleCheck": true
    },
    {
        "dataID": "115632",
        "id": "53085536",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:27",
        "brokerTime": "2025-05-14 14:50:27",
        "commission": -32.55,
        "swap": 0,
        "profit": -106.95,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049407",
        "positionId": "56049406",
        "volume": 4.65,
        "price": 3227.33,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -139.5,
        "priceIn": 3227.1,
        "doubleCheck": true
    },
    {
        "dataID": "115633",
        "id": "53085537",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:27",
        "brokerTime": "2025-05-14 14:50:27",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049408",
        "positionId": "56049408",
        "volume": 4.65,
        "price": 3227.12,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3227.12,
        "doubleCheck": true
    },
    {
        "dataID": "115634",
        "id": "53085538",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:27",
        "brokerTime": "2025-05-14 14:50:28",
        "commission": -32.55,
        "swap": 0,
        "profit": -106.95,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049409",
        "positionId": "56049408",
        "volume": 4.65,
        "price": 3227.35,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -139.5,
        "priceIn": 3227.12,
        "doubleCheck": true
    },
    {
        "dataID": "115635",
        "id": "53085539",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:28",
        "brokerTime": "2025-05-14 14:50:28",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049410",
        "positionId": "56049410",
        "volume": 4.65,
        "price": 3227.2,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3227.2,
        "doubleCheck": true
    },
    {
        "dataID": "115636",
        "id": "53085540",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:28",
        "brokerTime": "2025-05-14 14:50:28",
        "commission": -32.55,
        "swap": 0,
        "profit": -83.7,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049411",
        "positionId": "56049410",
        "volume": 4.65,
        "price": 3227.38,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -116.25,
        "priceIn": 3227.2,
        "doubleCheck": true
    },
    {
        "dataID": "115637",
        "id": "53085541",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:29",
        "brokerTime": "2025-05-14 14:50:29",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049412",
        "positionId": "56049412",
        "volume": 4.65,
        "price": 3227.2,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3227.2,
        "doubleCheck": true
    },
    {
        "dataID": "115638",
        "id": "53085542",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:29",
        "brokerTime": "2025-05-14 14:50:29",
        "commission": -32.55,
        "swap": 0,
        "profit": -102.3,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049413",
        "positionId": "56049412",
        "volume": 4.65,
        "price": 3227.42,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -134.85,
        "priceIn": 3227.2,
        "doubleCheck": true
    },
    {
        "dataID": "115639",
        "id": "53085543",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:29",
        "brokerTime": "2025-05-14 14:50:29",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049414",
        "positionId": "56049414",
        "volume": 4.65,
        "price": 3227.21,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3227.21,
        "doubleCheck": true
    },
    {
        "dataID": "115640",
        "id": "53085544",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:29",
        "brokerTime": "2025-05-14 14:50:29",
        "commission": -32.55,
        "swap": 0,
        "profit": -102.3,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049415",
        "positionId": "56049414",
        "volume": 4.65,
        "price": 3227.43,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -134.85,
        "priceIn": 3227.21,
        "doubleCheck": true
    },
    {
        "dataID": "115641",
        "id": "53085545",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:30",
        "brokerTime": "2025-05-14 14:50:30",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049416",
        "positionId": "56049416",
        "volume": 4.65,
        "price": 3227.27,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3227.27,
        "doubleCheck": true
    },
    {
        "dataID": "115642",
        "id": "53085546",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:30",
        "brokerTime": "2025-05-14 14:50:30",
        "commission": -32.55,
        "swap": 0,
        "profit": -102.3,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049417",
        "positionId": "56049416",
        "volume": 4.65,
        "price": 3227.49,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -134.85,
        "priceIn": 3227.27,
        "doubleCheck": true
    },
    {
        "dataID": "115643",
        "id": "53085548",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:30",
        "brokerTime": "2025-05-14 14:50:30",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049419",
        "positionId": "56049419",
        "volume": 4.65,
        "price": 3227.06,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3227.06,
        "doubleCheck": true
    },
    {
        "dataID": "115644",
        "id": "53085549",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:30",
        "brokerTime": "2025-05-14 14:50:31",
        "commission": -32.55,
        "swap": 0,
        "profit": -88.35,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049420",
        "positionId": "56049419",
        "volume": 4.65,
        "price": 3227.25,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -120.89999999999999,
        "priceIn": 3227.06,
        "doubleCheck": true
    },
    {
        "dataID": "115645",
        "id": "53085550",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:31",
        "brokerTime": "2025-05-14 14:50:31",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049424",
        "positionId": "56049424",
        "volume": 4.65,
        "price": 3227.02,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3227.02,
        "doubleCheck": true
    },
    {
        "dataID": "115646",
        "id": "53085555",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:31",
        "brokerTime": "2025-05-14 14:50:31",
        "commission": -32.55,
        "swap": 0,
        "profit": -97.65,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049426",
        "positionId": "56049424",
        "volume": 4.65,
        "price": 3227.23,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -130.2,
        "priceIn": 3227.02,
        "doubleCheck": true
    },
    {
        "dataID": "115647",
        "id": "53085556",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:31",
        "brokerTime": "2025-05-14 14:50:31",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049427",
        "positionId": "56049427",
        "volume": 4.65,
        "price": 3227,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3227,
        "doubleCheck": true
    },
    {
        "dataID": "115648",
        "id": "53085557",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:31",
        "brokerTime": "2025-05-14 14:50:32",
        "commission": -32.55,
        "swap": 0,
        "profit": -97.65,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049428",
        "positionId": "56049427",
        "volume": 4.65,
        "price": 3227.21,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -130.2,
        "priceIn": 3227,
        "doubleCheck": true
    },
    {
        "dataID": "115649",
        "id": "53085558",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:32",
        "brokerTime": "2025-05-14 14:50:32",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049429",
        "positionId": "56049429",
        "volume": 4.65,
        "price": 3227.16,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3227.16,
        "doubleCheck": true
    },
    {
        "dataID": "115650",
        "id": "53085559",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:32",
        "brokerTime": "2025-05-14 14:50:32",
        "commission": -32.55,
        "swap": 0,
        "profit": -93,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049430",
        "positionId": "56049429",
        "volume": 4.65,
        "price": 3227.36,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -125.55,
        "priceIn": 3227.16,
        "doubleCheck": true
    },
    {
        "dataID": "115651",
        "id": "53085560",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:33",
        "brokerTime": "2025-05-14 14:50:33",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049431",
        "positionId": "56049431",
        "volume": 4.65,
        "price": 3227.12,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3227.12,
        "doubleCheck": true
    },
    {
        "dataID": "115652",
        "id": "53085561",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:33",
        "brokerTime": "2025-05-14 14:50:33",
        "commission": -32.55,
        "swap": 0,
        "profit": -60.45,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049432",
        "positionId": "56049431",
        "volume": 4.65,
        "price": 3227.25,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -93,
        "priceIn": 3227.12,
        "doubleCheck": true
    },
    {
        "dataID": "115653",
        "id": "53085562",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:33",
        "brokerTime": "2025-05-14 14:50:33",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049433",
        "positionId": "56049433",
        "volume": 4.65,
        "price": 3226.85,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.85,
        "doubleCheck": true
    },
    {
        "dataID": "115654",
        "id": "53085563",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:33",
        "brokerTime": "2025-05-14 14:50:33",
        "commission": -32.55,
        "swap": 0,
        "profit": -60.45,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049434",
        "positionId": "56049433",
        "volume": 4.65,
        "price": 3226.98,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -93,
        "priceIn": 3226.85,
        "doubleCheck": true
    },
    {
        "dataID": "115655",
        "id": "53085564",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:33",
        "brokerTime": "2025-05-14 14:50:33",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049435",
        "positionId": "56049435",
        "volume": 4.65,
        "price": 3226.87,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.87,
        "doubleCheck": true
    },
    {
        "dataID": "115656",
        "id": "53085565",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:33",
        "brokerTime": "2025-05-14 14:50:34",
        "commission": -32.55,
        "swap": 0,
        "profit": -116.25,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049437",
        "positionId": "56049435",
        "volume": 4.65,
        "price": 3227.12,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -148.8,
        "priceIn": 3226.87,
        "doubleCheck": true
    },
    {
        "dataID": "115657",
        "id": "53085566",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:35",
        "brokerTime": "2025-05-14 14:50:35",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049438",
        "positionId": "56049438",
        "volume": 4.65,
        "price": 3226.85,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.85,
        "doubleCheck": true
    },
    {
        "dataID": "115658",
        "id": "53085567",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:35",
        "brokerTime": "2025-05-14 14:50:35",
        "commission": -32.55,
        "swap": 0,
        "profit": -102.3,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049439",
        "positionId": "56049438",
        "volume": 4.65,
        "price": 3227.07,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -134.85,
        "priceIn": 3226.85,
        "doubleCheck": true
    },
    {
        "dataID": "115659",
        "id": "53085568",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:36",
        "brokerTime": "2025-05-14 14:50:36",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049440",
        "positionId": "56049440",
        "volume": 4.65,
        "price": 3226.81,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.81,
        "doubleCheck": true
    },
    {
        "dataID": "115660",
        "id": "53085569",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:36",
        "brokerTime": "2025-05-14 14:50:36",
        "commission": -32.55,
        "swap": 0,
        "profit": -223.2,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049441",
        "positionId": "56049440",
        "volume": 4.65,
        "price": 3227.29,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -255.75,
        "priceIn": 3226.81,
        "doubleCheck": true
    },
    {
        "dataID": "115661",
        "id": "53085570",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:38",
        "brokerTime": "2025-05-14 14:50:38",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049442",
        "positionId": "56049442",
        "volume": 4.65,
        "price": 3227.02,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3227.02,
        "doubleCheck": true
    },
    {
        "dataID": "115662",
        "id": "53085571",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:38",
        "brokerTime": "2025-05-14 14:50:38",
        "commission": -32.55,
        "swap": 0,
        "profit": -111.6,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049443",
        "positionId": "56049442",
        "volume": 4.65,
        "price": 3227.26,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -144.14999999999998,
        "priceIn": 3227.02,
        "doubleCheck": true
    },
    {
        "dataID": "115663",
        "id": "53085572",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:38",
        "brokerTime": "2025-05-14 14:50:38",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049444",
        "positionId": "56049444",
        "volume": 4.65,
        "price": 3227.02,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3227.02,
        "doubleCheck": true
    },
    {
        "dataID": "115664",
        "id": "53085573",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:38",
        "brokerTime": "2025-05-14 14:50:39",
        "commission": -32.55,
        "swap": 0,
        "profit": -97.65,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049445",
        "positionId": "56049444",
        "volume": 4.65,
        "price": 3227.23,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -130.2,
        "priceIn": 3227.02,
        "doubleCheck": true
    },
    {
        "dataID": "115665",
        "id": "53085574",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:39",
        "brokerTime": "2025-05-14 14:50:39",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049446",
        "positionId": "56049446",
        "volume": 4.65,
        "price": 3226.98,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.98,
        "doubleCheck": true
    },
    {
        "dataID": "115666",
        "id": "53085575",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:39",
        "brokerTime": "2025-05-14 14:50:39",
        "commission": -32.55,
        "swap": 0,
        "profit": -153.45,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049447",
        "positionId": "56049446",
        "volume": 4.65,
        "price": 3227.31,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -186,
        "priceIn": 3226.98,
        "doubleCheck": true
    },
    {
        "dataID": "115667",
        "id": "53085576",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:40",
        "brokerTime": "2025-05-14 14:50:40",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049448",
        "positionId": "56049448",
        "volume": 4.65,
        "price": 3227.07,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3227.07,
        "doubleCheck": true
    },
    {
        "dataID": "115668",
        "id": "53085577",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:40",
        "brokerTime": "2025-05-14 14:50:40",
        "commission": -32.55,
        "swap": 0,
        "profit": -106.95,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049449",
        "positionId": "56049448",
        "volume": 4.65,
        "price": 3227.3,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -139.5,
        "priceIn": 3227.07,
        "doubleCheck": true
    },
    {
        "dataID": "115669",
        "id": "53085578",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:40",
        "brokerTime": "2025-05-14 14:50:40",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049450",
        "positionId": "56049450",
        "volume": 4.65,
        "price": 3227.07,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3227.07,
        "doubleCheck": true
    },
    {
        "dataID": "115670",
        "id": "53085579",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:40",
        "brokerTime": "2025-05-14 14:50:41",
        "commission": -32.55,
        "swap": 0,
        "profit": -102.3,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049451",
        "positionId": "56049450",
        "volume": 4.65,
        "price": 3227.29,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -134.85,
        "priceIn": 3227.07,
        "doubleCheck": true
    },
    {
        "dataID": "115671",
        "id": "53085580",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:42",
        "brokerTime": "2025-05-14 14:50:42",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049452",
        "positionId": "56049452",
        "volume": 4.65,
        "price": 3227.08,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3227.08,
        "doubleCheck": true
    },
    {
        "dataID": "115672",
        "id": "53085581",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:42",
        "brokerTime": "2025-05-14 14:50:42",
        "commission": -32.55,
        "swap": 0,
        "profit": -102.3,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049453",
        "positionId": "56049452",
        "volume": 4.65,
        "price": 3227.3,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -134.85,
        "priceIn": 3227.08,
        "doubleCheck": true
    },
    {
        "dataID": "115673",
        "id": "53085582",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:42",
        "brokerTime": "2025-05-14 14:50:42",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049454",
        "positionId": "56049454",
        "volume": 4.65,
        "price": 3226.99,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.99,
        "doubleCheck": true
    },
    {
        "dataID": "115674",
        "id": "53085583",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:42",
        "brokerTime": "2025-05-14 14:50:42",
        "commission": -32.55,
        "swap": 0,
        "profit": -102.3,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049455",
        "positionId": "56049454",
        "volume": 4.65,
        "price": 3227.21,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -134.85,
        "priceIn": 3226.99,
        "doubleCheck": true
    },
    {
        "dataID": "115675",
        "id": "53085586",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:43",
        "brokerTime": "2025-05-14 14:50:43",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049458",
        "positionId": "56049458",
        "volume": 4.65,
        "price": 3226.99,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.99,
        "doubleCheck": true
    },
    {
        "dataID": "115676",
        "id": "53085587",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:43",
        "brokerTime": "2025-05-14 14:50:43",
        "commission": -32.55,
        "swap": 0,
        "profit": -102.3,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049459",
        "positionId": "56049458",
        "volume": 4.65,
        "price": 3227.21,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -134.85,
        "priceIn": 3226.99,
        "doubleCheck": true
    },
    {
        "dataID": "115677",
        "id": "53085588",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:44",
        "brokerTime": "2025-05-14 14:50:44",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049460",
        "positionId": "56049460",
        "volume": 4.65,
        "price": 3226.98,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.98,
        "doubleCheck": true
    },
    {
        "dataID": "115678",
        "id": "53085589",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:44",
        "brokerTime": "2025-05-14 14:50:44",
        "commission": -32.55,
        "swap": 0,
        "profit": -102.3,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049461",
        "positionId": "56049460",
        "volume": 4.65,
        "price": 3227.2,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -134.85,
        "priceIn": 3226.98,
        "doubleCheck": true
    },
    {
        "dataID": "115679",
        "id": "53085590",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:44",
        "brokerTime": "2025-05-14 14:50:44",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049462",
        "positionId": "56049462",
        "volume": 4.65,
        "price": 3226.98,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.98,
        "doubleCheck": true
    },
    {
        "dataID": "115680",
        "id": "53085591",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:44",
        "brokerTime": "2025-05-14 14:50:44",
        "commission": -32.55,
        "swap": 0,
        "profit": -102.3,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049463",
        "positionId": "56049462",
        "volume": 4.65,
        "price": 3227.2,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -134.85,
        "priceIn": 3226.98,
        "doubleCheck": true
    },
    {
        "dataID": "115681",
        "id": "53085592",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:45",
        "brokerTime": "2025-05-14 14:50:45",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049464",
        "positionId": "56049464",
        "volume": 4.65,
        "price": 3226.63,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.63,
        "doubleCheck": true
    },
    {
        "dataID": "115682",
        "id": "53085593",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:45",
        "brokerTime": "2025-05-14 14:50:45",
        "commission": -32.55,
        "swap": 0,
        "profit": -130.2,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049465",
        "positionId": "56049464",
        "volume": 4.65,
        "price": 3226.91,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -162.75,
        "priceIn": 3226.63,
        "doubleCheck": true
    },
    {
        "dataID": "115683",
        "id": "53085594",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:45",
        "brokerTime": "2025-05-14 14:50:45",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049466",
        "positionId": "56049466",
        "volume": 4.65,
        "price": 3226.68,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.68,
        "doubleCheck": true
    },
    {
        "dataID": "115684",
        "id": "53085595",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:45",
        "brokerTime": "2025-05-14 14:50:46",
        "commission": -32.55,
        "swap": 0,
        "profit": -97.65,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049467",
        "positionId": "56049466",
        "volume": 4.65,
        "price": 3226.89,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -130.2,
        "priceIn": 3226.68,
        "doubleCheck": true
    },
    {
        "dataID": "115685",
        "id": "53085596",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:46",
        "brokerTime": "2025-05-14 14:50:46",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049468",
        "positionId": "56049468",
        "volume": 4.65,
        "price": 3226.68,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.68,
        "doubleCheck": true
    },
    {
        "dataID": "115686",
        "id": "53085597",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:46",
        "brokerTime": "2025-05-14 14:50:46",
        "commission": -32.55,
        "swap": 0,
        "profit": -102.3,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049469",
        "positionId": "56049468",
        "volume": 4.65,
        "price": 3226.9,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -134.85,
        "priceIn": 3226.68,
        "doubleCheck": true
    },
    {
        "dataID": "115687",
        "id": "53085598",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:47",
        "brokerTime": "2025-05-14 14:50:47",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049470",
        "positionId": "56049470",
        "volume": 4.65,
        "price": 3226.66,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.66,
        "doubleCheck": true
    },
    {
        "dataID": "115688",
        "id": "53085599",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:47",
        "brokerTime": "2025-05-14 14:50:47",
        "commission": -32.55,
        "swap": 0,
        "profit": -106.95,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049471",
        "positionId": "56049470",
        "volume": 4.65,
        "price": 3226.89,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -139.5,
        "priceIn": 3226.66,
        "doubleCheck": true
    },
    {
        "dataID": "115689",
        "id": "53085600",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:48",
        "brokerTime": "2025-05-14 14:50:48",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049472",
        "positionId": "56049472",
        "volume": 4.65,
        "price": 3226.65,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.65,
        "doubleCheck": true
    },
    {
        "dataID": "115690",
        "id": "53085601",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:48",
        "brokerTime": "2025-05-14 14:50:48",
        "commission": -32.55,
        "swap": 0,
        "profit": -93,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049473",
        "positionId": "56049472",
        "volume": 4.65,
        "price": 3226.85,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -125.55,
        "priceIn": 3226.65,
        "doubleCheck": true
    },
    {
        "dataID": "115691",
        "id": "53085602",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:49",
        "brokerTime": "2025-05-14 14:50:49",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049474",
        "positionId": "56049474",
        "volume": 4.65,
        "price": 3226.6,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.6,
        "doubleCheck": true
    },
    {
        "dataID": "115692",
        "id": "53085603",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:49",
        "brokerTime": "2025-05-14 14:50:49",
        "commission": -32.55,
        "swap": 0,
        "profit": -106.95,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049475",
        "positionId": "56049474",
        "volume": 4.65,
        "price": 3226.83,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -139.5,
        "priceIn": 3226.6,
        "doubleCheck": true
    },
    {
        "dataID": "115693",
        "id": "53085604",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:49",
        "brokerTime": "2025-05-14 14:50:49",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049476",
        "positionId": "56049476",
        "volume": 4.65,
        "price": 3226.61,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.61,
        "doubleCheck": true
    },
    {
        "dataID": "115694",
        "id": "53085605",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:49",
        "brokerTime": "2025-05-14 14:50:49",
        "commission": -32.55,
        "swap": 0,
        "profit": -97.65,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049477",
        "positionId": "56049476",
        "volume": 4.65,
        "price": 3226.82,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -130.2,
        "priceIn": 3226.61,
        "doubleCheck": true
    },
    {
        "dataID": "115695",
        "id": "53085606",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:50",
        "brokerTime": "2025-05-14 14:50:50",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049478",
        "positionId": "56049478",
        "volume": 4.65,
        "price": 3226.74,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.74,
        "doubleCheck": true
    },
    {
        "dataID": "115696",
        "id": "53085607",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:50",
        "brokerTime": "2025-05-14 14:50:50",
        "commission": -32.55,
        "swap": 0,
        "profit": -93,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049479",
        "positionId": "56049478",
        "volume": 4.65,
        "price": 3226.94,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -125.55,
        "priceIn": 3226.74,
        "doubleCheck": true
    },
    {
        "dataID": "115697",
        "id": "53085608",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:51",
        "brokerTime": "2025-05-14 14:50:51",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049480",
        "positionId": "56049480",
        "volume": 4.65,
        "price": 3226.69,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.69,
        "doubleCheck": true
    },
    {
        "dataID": "115698",
        "id": "53085609",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:51",
        "brokerTime": "2025-05-14 14:50:51",
        "commission": -32.55,
        "swap": 0,
        "profit": -97.65,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049481",
        "positionId": "56049480",
        "volume": 4.65,
        "price": 3226.9,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -130.2,
        "priceIn": 3226.69,
        "doubleCheck": true
    },
    {
        "dataID": "115699",
        "id": "53085610",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:52",
        "brokerTime": "2025-05-14 14:50:52",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049482",
        "positionId": "56049482",
        "volume": 4.65,
        "price": 3226.68,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.68,
        "doubleCheck": true
    },
    {
        "dataID": "115700",
        "id": "53085611",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:52",
        "brokerTime": "2025-05-14 14:50:52",
        "commission": -32.55,
        "swap": 0,
        "profit": -97.65,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049483",
        "positionId": "56049482",
        "volume": 4.65,
        "price": 3226.89,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -130.2,
        "priceIn": 3226.68,
        "doubleCheck": true
    },
    {
        "dataID": "115701",
        "id": "53085612",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:52",
        "brokerTime": "2025-05-14 14:50:52",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049484",
        "positionId": "56049484",
        "volume": 4.65,
        "price": 3226.73,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.73,
        "doubleCheck": true
    },
    {
        "dataID": "115702",
        "id": "53085613",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:52",
        "brokerTime": "2025-05-14 14:50:52",
        "commission": -32.55,
        "swap": 0,
        "profit": -97.65,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049485",
        "positionId": "56049484",
        "volume": 4.65,
        "price": 3226.94,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -130.2,
        "priceIn": 3226.73,
        "doubleCheck": true
    },
    {
        "dataID": "115703",
        "id": "53085614",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:53",
        "brokerTime": "2025-05-14 14:50:53",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049486",
        "positionId": "56049486",
        "volume": 4.65,
        "price": 3226.74,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.74,
        "doubleCheck": true
    },
    {
        "dataID": "115704",
        "id": "53085616",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:53",
        "brokerTime": "2025-05-14 14:50:53",
        "commission": -32.55,
        "swap": 0,
        "profit": -97.65,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049488",
        "positionId": "56049486",
        "volume": 4.65,
        "price": 3226.95,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -130.2,
        "priceIn": 3226.74,
        "doubleCheck": true
    },
    {
        "dataID": "115705",
        "id": "53085617",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:54",
        "brokerTime": "2025-05-14 14:50:54",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049489",
        "positionId": "56049489",
        "volume": 4.65,
        "price": 3226.75,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.75,
        "doubleCheck": true
    },
    {
        "dataID": "115706",
        "id": "53085618",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:54",
        "brokerTime": "2025-05-14 14:50:54",
        "commission": -32.55,
        "swap": 0,
        "profit": -97.65,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049491",
        "positionId": "56049489",
        "volume": 4.65,
        "price": 3226.96,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -130.2,
        "priceIn": 3226.75,
        "doubleCheck": true
    },
    {
        "dataID": "115707",
        "id": "53085619",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:55",
        "brokerTime": "2025-05-14 14:50:55",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049492",
        "positionId": "56049492",
        "volume": 4.65,
        "price": 3227.18,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3227.18,
        "doubleCheck": true
    },
    {
        "dataID": "115708",
        "id": "53085620",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:55",
        "brokerTime": "2025-05-14 14:50:56",
        "commission": -32.55,
        "swap": 0,
        "profit": -106.95,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049493",
        "positionId": "56049492",
        "volume": 4.65,
        "price": 3227.41,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -139.5,
        "priceIn": 3227.18,
        "doubleCheck": true
    },
    {
        "dataID": "115709",
        "id": "53085621",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:56",
        "brokerTime": "2025-05-14 14:50:56",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049494",
        "positionId": "56049494",
        "volume": 4.65,
        "price": 3227.13,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3227.13,
        "doubleCheck": true
    },
    {
        "dataID": "115710",
        "id": "53085622",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:56",
        "brokerTime": "2025-05-14 14:50:57",
        "commission": -32.55,
        "swap": 0,
        "profit": -74.4,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049495",
        "positionId": "56049494",
        "volume": 4.65,
        "price": 3227.29,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.95,
        "priceIn": 3227.13,
        "doubleCheck": true
    },
    {
        "dataID": "115711",
        "id": "53085623",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:57",
        "brokerTime": "2025-05-14 14:50:57",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049496",
        "positionId": "56049496",
        "volume": 4.65,
        "price": 3227.07,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3227.07,
        "doubleCheck": true
    },
    {
        "dataID": "115712",
        "id": "53085624",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:57",
        "brokerTime": "2025-05-14 14:50:57",
        "commission": -32.55,
        "swap": 0,
        "profit": -102.3,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049497",
        "positionId": "56049496",
        "volume": 4.65,
        "price": 3227.29,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -134.85,
        "priceIn": 3227.07,
        "doubleCheck": true
    },
    {
        "dataID": "115713",
        "id": "53085625",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:58",
        "brokerTime": "2025-05-14 14:50:58",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049498",
        "positionId": "56049498",
        "volume": 4.65,
        "price": 3227.07,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3227.07,
        "doubleCheck": true
    },
    {
        "dataID": "115714",
        "id": "53085626",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:58",
        "brokerTime": "2025-05-14 14:50:58",
        "commission": -32.55,
        "swap": 0,
        "profit": -102.3,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049499",
        "positionId": "56049498",
        "volume": 4.65,
        "price": 3227.29,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -134.85,
        "priceIn": 3227.07,
        "doubleCheck": true
    },
    {
        "dataID": "115715",
        "id": "53085627",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:59",
        "brokerTime": "2025-05-14 14:50:59",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049500",
        "positionId": "56049500",
        "volume": 4.65,
        "price": 3227.07,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3227.07,
        "doubleCheck": true
    },
    {
        "dataID": "115716",
        "id": "53085628",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:59",
        "brokerTime": "2025-05-14 14:50:59",
        "commission": -32.55,
        "swap": 0,
        "profit": -102.3,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049501",
        "positionId": "56049500",
        "volume": 4.65,
        "price": 3227.29,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -134.85,
        "priceIn": 3227.07,
        "doubleCheck": true
    },
    {
        "dataID": "115717",
        "id": "53085629",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:59",
        "brokerTime": "2025-05-14 14:50:59",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049502",
        "positionId": "56049502",
        "volume": 4.65,
        "price": 3227.11,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3227.11,
        "doubleCheck": true
    },
    {
        "dataID": "115718",
        "id": "53085630",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:59",
        "brokerTime": "2025-05-14 14:50:59",
        "commission": -32.55,
        "swap": 0,
        "profit": -83.7,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049503",
        "positionId": "56049502",
        "volume": 4.65,
        "price": 3227.29,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -116.25,
        "priceIn": 3227.11,
        "doubleCheck": true
    },
    {
        "dataID": "115719",
        "id": "53085631",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:00",
        "brokerTime": "2025-05-14 14:51:00",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049504",
        "positionId": "56049504",
        "volume": 4.65,
        "price": 3227.19,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3227.19,
        "doubleCheck": true
    },
    {
        "dataID": "115720",
        "id": "53085633",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:00",
        "brokerTime": "2025-05-14 14:51:00",
        "commission": -32.55,
        "swap": 0,
        "profit": -106.95,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049506",
        "positionId": "56049504",
        "volume": 4.65,
        "price": 3227.42,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -139.5,
        "priceIn": 3227.19,
        "doubleCheck": true
    },
    {
        "dataID": "115721",
        "id": "53085634",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:01",
        "brokerTime": "2025-05-14 14:51:01",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049507",
        "positionId": "56049507",
        "volume": 4.65,
        "price": 3227.36,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3227.36,
        "doubleCheck": true
    },
    {
        "dataID": "115722",
        "id": "53085635",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:01",
        "brokerTime": "2025-05-14 14:51:01",
        "commission": -32.55,
        "swap": 0,
        "profit": -111.6,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049508",
        "positionId": "56049507",
        "volume": 4.65,
        "price": 3227.6,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -144.14999999999998,
        "priceIn": 3227.36,
        "doubleCheck": true
    },
    {
        "dataID": "115723",
        "id": "53085636",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:01",
        "brokerTime": "2025-05-14 14:51:01",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049509",
        "positionId": "56049509",
        "volume": 4.65,
        "price": 3227.53,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3227.53,
        "doubleCheck": true
    },
    {
        "dataID": "115724",
        "id": "53085637",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:01",
        "brokerTime": "2025-05-14 14:51:02",
        "commission": -32.55,
        "swap": 0,
        "profit": -97.65,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049510",
        "positionId": "56049509",
        "volume": 4.65,
        "price": 3227.74,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -130.2,
        "priceIn": 3227.53,
        "doubleCheck": true
    },
    {
        "dataID": "115725",
        "id": "53085638",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:02",
        "brokerTime": "2025-05-14 14:51:02",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049511",
        "positionId": "56049511",
        "volume": 4.65,
        "price": 3227.5,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3227.5,
        "doubleCheck": true
    },
    {
        "dataID": "115726",
        "id": "53085639",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:02",
        "brokerTime": "2025-05-14 14:51:03",
        "commission": -32.55,
        "swap": 0,
        "profit": -83.7,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049512",
        "positionId": "56049511",
        "volume": 4.65,
        "price": 3227.68,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -116.25,
        "priceIn": 3227.5,
        "doubleCheck": true
    },
    {
        "dataID": "115727",
        "id": "53085640",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:03",
        "brokerTime": "2025-05-14 14:51:03",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049513",
        "positionId": "56049513",
        "volume": 4.65,
        "price": 3227.46,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3227.46,
        "doubleCheck": true
    },
    {
        "dataID": "115728",
        "id": "53085643",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:03",
        "brokerTime": "2025-05-14 14:51:04",
        "commission": -32.55,
        "swap": 0,
        "profit": -111.6,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049515",
        "positionId": "56049513",
        "volume": 4.65,
        "price": 3227.7,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -144.14999999999998,
        "priceIn": 3227.46,
        "doubleCheck": true
    },
    {
        "dataID": "115729",
        "id": "53085644",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:05",
        "brokerTime": "2025-05-14 14:51:05",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049516",
        "positionId": "56049516",
        "volume": 4.65,
        "price": 3227.46,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3227.46,
        "doubleCheck": true
    },
    {
        "dataID": "115730",
        "id": "53085645",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:05",
        "brokerTime": "2025-05-14 14:51:06",
        "commission": -32.55,
        "swap": 0,
        "profit": -83.7,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049517",
        "positionId": "56049516",
        "volume": 4.65,
        "price": 3227.64,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -116.25,
        "priceIn": 3227.46,
        "doubleCheck": true
    },
    {
        "dataID": "115731",
        "id": "53085649",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:06",
        "brokerTime": "2025-05-14 14:51:06",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049520",
        "positionId": "56049520",
        "volume": 4.65,
        "price": 3227.11,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3227.11,
        "doubleCheck": true
    },
    {
        "dataID": "115732",
        "id": "53085651",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:06",
        "brokerTime": "2025-05-14 14:51:07",
        "commission": -32.55,
        "swap": 0,
        "profit": -55.8,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049522",
        "positionId": "56049520",
        "volume": 4.65,
        "price": 3227.23,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.35,
        "priceIn": 3227.11,
        "doubleCheck": true
    },
    {
        "dataID": "115733",
        "id": "53085652",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:07",
        "brokerTime": "2025-05-14 14:51:07",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049523",
        "positionId": "56049523",
        "volume": 4.65,
        "price": 3226.79,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.79,
        "doubleCheck": true
    },
    {
        "dataID": "115734",
        "id": "53085653",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:07",
        "brokerTime": "2025-05-14 14:51:08",
        "commission": -32.55,
        "swap": 0,
        "profit": -65.1,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049524",
        "positionId": "56049523",
        "volume": 4.65,
        "price": 3226.93,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -97.64999999999999,
        "priceIn": 3226.79,
        "doubleCheck": true
    },
    {
        "dataID": "115735",
        "id": "53085654",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:08",
        "brokerTime": "2025-05-14 14:51:08",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049525",
        "positionId": "56049525",
        "volume": 4.65,
        "price": 3226.59,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.59,
        "doubleCheck": true
    },
    {
        "dataID": "115736",
        "id": "53085655",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:08",
        "brokerTime": "2025-05-14 14:51:08",
        "commission": -32.55,
        "swap": 0,
        "profit": -83.7,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049526",
        "positionId": "56049525",
        "volume": 4.65,
        "price": 3226.77,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -116.25,
        "priceIn": 3226.59,
        "doubleCheck": true
    },
    {
        "dataID": "115737",
        "id": "53085656",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:09",
        "brokerTime": "2025-05-14 14:51:09",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049527",
        "positionId": "56049527",
        "volume": 4.65,
        "price": 3226.54,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.54,
        "doubleCheck": true
    },
    {
        "dataID": "115738",
        "id": "53085657",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:09",
        "brokerTime": "2025-05-14 14:51:09",
        "commission": -32.55,
        "swap": 0,
        "profit": -130.2,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049528",
        "positionId": "56049527",
        "volume": 4.65,
        "price": 3226.82,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -162.75,
        "priceIn": 3226.54,
        "doubleCheck": true
    },
    {
        "dataID": "115739",
        "id": "53085658",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:09",
        "brokerTime": "2025-05-14 14:51:09",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049529",
        "positionId": "56049529",
        "volume": 4.65,
        "price": 3226.67,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.67,
        "doubleCheck": true
    },
    {
        "dataID": "115740",
        "id": "53085659",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:09",
        "brokerTime": "2025-05-14 14:51:10",
        "commission": -32.55,
        "swap": 0,
        "profit": -320.85,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049530",
        "positionId": "56049529",
        "volume": 4.65,
        "price": 3227.36,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -353.40000000000003,
        "priceIn": 3226.67,
        "doubleCheck": true
    },
    {
        "dataID": "115741",
        "id": "53085660",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:11",
        "brokerTime": "2025-05-14 14:51:11",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049531",
        "positionId": "56049531",
        "volume": 4.65,
        "price": 3227.16,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3227.16,
        "doubleCheck": true
    },
    {
        "dataID": "115742",
        "id": "53085661",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:11",
        "brokerTime": "2025-05-14 14:51:11",
        "commission": -32.55,
        "swap": 0,
        "profit": -97.65,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049532",
        "positionId": "56049531",
        "volume": 4.65,
        "price": 3227.37,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -130.2,
        "priceIn": 3227.16,
        "doubleCheck": true
    },
    {
        "dataID": "115743",
        "id": "53085662",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:12",
        "brokerTime": "2025-05-14 14:51:12",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049533",
        "positionId": "56049533",
        "volume": 4.65,
        "price": 3227.03,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3227.03,
        "doubleCheck": true
    },
    {
        "dataID": "115744",
        "id": "53085663",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:12",
        "brokerTime": "2025-05-14 14:51:12",
        "commission": -32.55,
        "swap": 0,
        "profit": -93,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049534",
        "positionId": "56049533",
        "volume": 4.65,
        "price": 3227.23,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -125.55,
        "priceIn": 3227.03,
        "doubleCheck": true
    },
    {
        "dataID": "115745",
        "id": "53085664",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:13",
        "brokerTime": "2025-05-14 14:51:13",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049535",
        "positionId": "56049535",
        "volume": 4.65,
        "price": 3226.91,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.91,
        "doubleCheck": true
    },
    {
        "dataID": "115746",
        "id": "53085666",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:13",
        "brokerTime": "2025-05-14 14:51:13",
        "commission": -32.55,
        "swap": 0,
        "profit": -46.5,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049537",
        "positionId": "56049535",
        "volume": 4.65,
        "price": 3227.01,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -79.05,
        "priceIn": 3226.91,
        "doubleCheck": true
    },
    {
        "dataID": "115747",
        "id": "53085667",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:14",
        "brokerTime": "2025-05-14 14:51:14",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049538",
        "positionId": "56049538",
        "volume": 4.65,
        "price": 3226.78,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.78,
        "doubleCheck": true
    },
    {
        "dataID": "115748",
        "id": "53085668",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:14",
        "brokerTime": "2025-05-14 14:51:14",
        "commission": -32.55,
        "swap": 0,
        "profit": -111.6,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049539",
        "positionId": "56049538",
        "volume": 4.65,
        "price": 3227.02,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -144.14999999999998,
        "priceIn": 3226.78,
        "doubleCheck": true
    },
    {
        "dataID": "115749",
        "id": "53085669",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:15",
        "brokerTime": "2025-05-14 14:51:15",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049540",
        "positionId": "56049540",
        "volume": 4.65,
        "price": 3226.74,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.74,
        "doubleCheck": true
    },
    {
        "dataID": "115750",
        "id": "53085670",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:15",
        "brokerTime": "2025-05-14 14:51:15",
        "commission": -32.55,
        "swap": 0,
        "profit": -120.9,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049541",
        "positionId": "56049540",
        "volume": 4.65,
        "price": 3227,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -153.45,
        "priceIn": 3226.74,
        "doubleCheck": true
    },
    {
        "dataID": "115751",
        "id": "53085671",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:16",
        "brokerTime": "2025-05-14 14:51:16",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049542",
        "positionId": "56049542",
        "volume": 4.65,
        "price": 3226.77,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.77,
        "doubleCheck": true
    },
    {
        "dataID": "115752",
        "id": "53085672",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:16",
        "brokerTime": "2025-05-14 14:51:16",
        "commission": -32.55,
        "swap": 0,
        "profit": -106.95,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049543",
        "positionId": "56049542",
        "volume": 4.65,
        "price": 3227,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -139.5,
        "priceIn": 3226.77,
        "doubleCheck": true
    },
    {
        "dataID": "115753",
        "id": "53085673",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:19",
        "brokerTime": "2025-05-14 14:51:19",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049544",
        "positionId": "56049544",
        "volume": 4.65,
        "price": 3226.79,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.79,
        "doubleCheck": true
    },
    {
        "dataID": "115754",
        "id": "53085674",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:19",
        "brokerTime": "2025-05-14 14:51:20",
        "commission": -32.55,
        "swap": 0,
        "profit": -88.35,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049545",
        "positionId": "56049544",
        "volume": 4.65,
        "price": 3226.98,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -120.89999999999999,
        "priceIn": 3226.79,
        "doubleCheck": true
    },
    {
        "dataID": "115755",
        "id": "53085675",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:20",
        "brokerTime": "2025-05-14 14:51:20",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049546",
        "positionId": "56049546",
        "volume": 4.65,
        "price": 3226.69,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.69,
        "doubleCheck": true
    },
    {
        "dataID": "115756",
        "id": "53085676",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:20",
        "brokerTime": "2025-05-14 14:51:21",
        "commission": -32.55,
        "swap": 0,
        "profit": -69.75,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049547",
        "positionId": "56049546",
        "volume": 4.65,
        "price": 3226.84,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -102.3,
        "priceIn": 3226.69,
        "doubleCheck": true
    },
    {
        "dataID": "115757",
        "id": "53085677",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:21",
        "brokerTime": "2025-05-14 14:51:21",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049548",
        "positionId": "56049548",
        "volume": 4.65,
        "price": 3226.59,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.59,
        "doubleCheck": true
    },
    {
        "dataID": "115758",
        "id": "53085678",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:21",
        "brokerTime": "2025-05-14 14:51:22",
        "commission": -32.55,
        "swap": 0,
        "profit": -97.65,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049549",
        "positionId": "56049548",
        "volume": 4.65,
        "price": 3226.8,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -130.2,
        "priceIn": 3226.59,
        "doubleCheck": true
    },
    {
        "dataID": "115759",
        "id": "53085679",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:23",
        "brokerTime": "2025-05-14 14:51:23",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049550",
        "positionId": "56049550",
        "volume": 4.65,
        "price": 3226.59,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.59,
        "doubleCheck": true
    },
    {
        "dataID": "115760",
        "id": "53085680",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:23",
        "brokerTime": "2025-05-14 14:51:23",
        "commission": -32.55,
        "swap": 0,
        "profit": -97.65,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049551",
        "positionId": "56049550",
        "volume": 4.65,
        "price": 3226.8,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -130.2,
        "priceIn": 3226.59,
        "doubleCheck": true
    },
    {
        "dataID": "115761",
        "id": "53085681",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:24",
        "brokerTime": "2025-05-14 14:51:24",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049552",
        "positionId": "56049552",
        "volume": 4.65,
        "price": 3226.87,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.87,
        "doubleCheck": true
    },
    {
        "dataID": "115762",
        "id": "53085682",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:24",
        "brokerTime": "2025-05-14 14:51:24",
        "commission": -32.55,
        "swap": 0,
        "profit": -79.05,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049554",
        "positionId": "56049552",
        "volume": 4.65,
        "price": 3227.04,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -111.6,
        "priceIn": 3226.87,
        "doubleCheck": true
    },
    {
        "dataID": "115763",
        "id": "53085683",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:25",
        "brokerTime": "2025-05-14 14:51:25",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049555",
        "positionId": "56049555",
        "volume": 4.65,
        "price": 3226.68,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.68,
        "doubleCheck": true
    },
    {
        "dataID": "115764",
        "id": "53085684",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:25",
        "brokerTime": "2025-05-14 14:51:25",
        "commission": -32.55,
        "swap": 0,
        "profit": -69.75,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049556",
        "positionId": "56049555",
        "volume": 4.65,
        "price": 3226.83,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -102.3,
        "priceIn": 3226.68,
        "doubleCheck": true
    },
    {
        "dataID": "115765",
        "id": "53085685",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:26",
        "brokerTime": "2025-05-14 14:51:26",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049557",
        "positionId": "56049557",
        "volume": 4.65,
        "price": 3226.58,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.58,
        "doubleCheck": true
    },
    {
        "dataID": "115766",
        "id": "53085686",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:26",
        "brokerTime": "2025-05-14 14:51:27",
        "commission": -32.55,
        "swap": 0,
        "profit": -153.45,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049558",
        "positionId": "56049557",
        "volume": 4.65,
        "price": 3226.91,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -186,
        "priceIn": 3226.58,
        "doubleCheck": true
    },
    {
        "dataID": "115767",
        "id": "53085687",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:28",
        "brokerTime": "2025-05-14 14:51:28",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049559",
        "positionId": "56049559",
        "volume": 4.65,
        "price": 3226.73,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.73,
        "doubleCheck": true
    },
    {
        "dataID": "115768",
        "id": "53085688",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:28",
        "brokerTime": "2025-05-14 14:51:28",
        "commission": -32.55,
        "swap": 0,
        "profit": -97.65,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049560",
        "positionId": "56049559",
        "volume": 4.65,
        "price": 3226.94,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -130.2,
        "priceIn": 3226.73,
        "doubleCheck": true
    },
    {
        "dataID": "115769",
        "id": "53085689",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:28",
        "brokerTime": "2025-05-14 14:51:28",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049561",
        "positionId": "56049561",
        "volume": 4.65,
        "price": 3226.73,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.73,
        "doubleCheck": true
    },
    {
        "dataID": "115770",
        "id": "53085690",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:28",
        "brokerTime": "2025-05-14 14:51:29",
        "commission": -32.55,
        "swap": 0,
        "profit": -93,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049562",
        "positionId": "56049561",
        "volume": 4.65,
        "price": 3226.93,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -125.55,
        "priceIn": 3226.73,
        "doubleCheck": true
    },
    {
        "dataID": "115771",
        "id": "53085691",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:29",
        "brokerTime": "2025-05-14 14:51:29",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049564",
        "positionId": "56049564",
        "volume": 4.65,
        "price": 3226.71,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.71,
        "doubleCheck": true
    },
    {
        "dataID": "115772",
        "id": "53085693",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:29",
        "brokerTime": "2025-05-14 14:51:30",
        "commission": -32.55,
        "swap": 0,
        "profit": -46.5,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049565",
        "positionId": "56049564",
        "volume": 4.65,
        "price": 3226.81,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -79.05,
        "priceIn": 3226.71,
        "doubleCheck": true
    },
    {
        "dataID": "115773",
        "id": "53085694",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:30",
        "brokerTime": "2025-05-14 14:51:30",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049566",
        "positionId": "56049566",
        "volume": 4.65,
        "price": 3226.72,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.72,
        "doubleCheck": true
    },
    {
        "dataID": "115774",
        "id": "53085695",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:30",
        "brokerTime": "2025-05-14 14:51:31",
        "commission": -32.55,
        "swap": 0,
        "profit": -74.4,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049567",
        "positionId": "56049566",
        "volume": 4.65,
        "price": 3226.88,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.95,
        "priceIn": 3226.72,
        "doubleCheck": true
    },
    {
        "dataID": "115775",
        "id": "53085696",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:31",
        "brokerTime": "2025-05-14 14:51:31",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049568",
        "positionId": "56049568",
        "volume": 4.65,
        "price": 3226.66,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.66,
        "doubleCheck": true
    },
    {
        "dataID": "115776",
        "id": "53085697",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:31",
        "brokerTime": "2025-05-14 14:51:31",
        "commission": -32.55,
        "swap": 0,
        "profit": -120.9,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049569",
        "positionId": "56049568",
        "volume": 4.65,
        "price": 3226.92,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -153.45,
        "priceIn": 3226.66,
        "doubleCheck": true
    },
    {
        "dataID": "115777",
        "id": "53085699",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:32",
        "brokerTime": "2025-05-14 14:51:32",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049571",
        "positionId": "56049571",
        "volume": 4.65,
        "price": 3226.72,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.72,
        "doubleCheck": true
    },
    {
        "dataID": "115778",
        "id": "53085701",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:32",
        "brokerTime": "2025-05-14 14:51:32",
        "commission": -32.55,
        "swap": 0,
        "profit": -139.5,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049573",
        "positionId": "56049571",
        "volume": 4.65,
        "price": 3227.02,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -172.05,
        "priceIn": 3226.72,
        "doubleCheck": true
    },
    {
        "dataID": "115779",
        "id": "53085702",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:33",
        "brokerTime": "2025-05-14 14:51:33",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049574",
        "positionId": "56049574",
        "volume": 4.65,
        "price": 3226.78,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.78,
        "doubleCheck": true
    },
    {
        "dataID": "115780",
        "id": "53085704",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:33",
        "brokerTime": "2025-05-14 14:51:33",
        "commission": -32.55,
        "swap": 0,
        "profit": -93,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049576",
        "positionId": "56049574",
        "volume": 4.65,
        "price": 3226.98,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -125.55,
        "priceIn": 3226.78,
        "doubleCheck": true
    },
    {
        "dataID": "115781",
        "id": "53085705",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:34",
        "brokerTime": "2025-05-14 14:51:34",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049577",
        "positionId": "56049577",
        "volume": 4.65,
        "price": 3226.85,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.85,
        "doubleCheck": true
    },
    {
        "dataID": "115782",
        "id": "53085708",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:34",
        "brokerTime": "2025-05-14 14:51:34",
        "commission": -32.55,
        "swap": 0,
        "profit": -148.8,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049580",
        "positionId": "56049577",
        "volume": 4.65,
        "price": 3227.17,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -181.35000000000002,
        "priceIn": 3226.85,
        "doubleCheck": true
    },
    {
        "dataID": "115783",
        "id": "53085709",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:35",
        "brokerTime": "2025-05-14 14:51:35",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049581",
        "positionId": "56049581",
        "volume": 4.65,
        "price": 3227.05,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3227.05,
        "doubleCheck": true
    },
    {
        "dataID": "115784",
        "id": "53085710",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:35",
        "brokerTime": "2025-05-14 14:51:35",
        "commission": -32.55,
        "swap": 0,
        "profit": -97.65,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049582",
        "positionId": "56049581",
        "volume": 4.65,
        "price": 3227.26,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -130.2,
        "priceIn": 3227.05,
        "doubleCheck": true
    },
    {
        "dataID": "115785",
        "id": "53085711",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:36",
        "brokerTime": "2025-05-14 14:51:36",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049583",
        "positionId": "56049583",
        "volume": 4.65,
        "price": 3226.96,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.96,
        "doubleCheck": true
    },
    {
        "dataID": "115786",
        "id": "53085713",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:36",
        "brokerTime": "2025-05-14 14:51:36",
        "commission": -32.55,
        "swap": 0,
        "profit": -55.8,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049585",
        "positionId": "56049583",
        "volume": 4.65,
        "price": 3227.08,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.35,
        "priceIn": 3226.96,
        "doubleCheck": true
    },
    {
        "dataID": "115787",
        "id": "53085714",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:37",
        "brokerTime": "2025-05-14 14:51:37",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049586",
        "positionId": "56049586",
        "volume": 4.65,
        "price": 3226.86,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.86,
        "doubleCheck": true
    },
    {
        "dataID": "115788",
        "id": "53085715",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:37",
        "brokerTime": "2025-05-14 14:51:37",
        "commission": -32.55,
        "swap": 0,
        "profit": -93,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049587",
        "positionId": "56049586",
        "volume": 4.65,
        "price": 3227.06,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -125.55,
        "priceIn": 3226.86,
        "doubleCheck": true
    },
    {
        "dataID": "115789",
        "id": "53085716",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:38",
        "brokerTime": "2025-05-14 14:51:38",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049588",
        "positionId": "56049588",
        "volume": 4.65,
        "price": 3226.71,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.71,
        "doubleCheck": true
    },
    {
        "dataID": "115790",
        "id": "53085717",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:38",
        "brokerTime": "2025-05-14 14:51:38",
        "commission": -32.55,
        "swap": 0,
        "profit": -93,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049589",
        "positionId": "56049588",
        "volume": 4.65,
        "price": 3226.91,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -125.55,
        "priceIn": 3226.71,
        "doubleCheck": true
    },
    {
        "dataID": "115791",
        "id": "53085718",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:38",
        "brokerTime": "2025-05-14 14:51:38",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049590",
        "positionId": "56049590",
        "volume": 4.65,
        "price": 3226.63,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.63,
        "doubleCheck": true
    },
    {
        "dataID": "115792",
        "id": "53085719",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:38",
        "brokerTime": "2025-05-14 14:51:39",
        "commission": -32.55,
        "swap": 0,
        "profit": -65.1,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049591",
        "positionId": "56049590",
        "volume": 4.65,
        "price": 3226.77,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -97.64999999999999,
        "priceIn": 3226.63,
        "doubleCheck": true
    },
    {
        "dataID": "115793",
        "id": "53085720",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:39",
        "brokerTime": "2025-05-14 14:51:39",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049592",
        "positionId": "56049592",
        "volume": 4.65,
        "price": 3226.37,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.37,
        "doubleCheck": true
    },
    {
        "dataID": "115794",
        "id": "53085721",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:39",
        "brokerTime": "2025-05-14 14:51:40",
        "commission": -32.55,
        "swap": 0,
        "profit": -116.25,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049593",
        "positionId": "56049592",
        "volume": 4.65,
        "price": 3226.62,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -148.8,
        "priceIn": 3226.37,
        "doubleCheck": true
    },
    {
        "dataID": "115795",
        "id": "53085722",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:40",
        "brokerTime": "2025-05-14 14:51:40",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049594",
        "positionId": "56049594",
        "volume": 4.65,
        "price": 3226.4,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.4,
        "doubleCheck": true
    },
    {
        "dataID": "115796",
        "id": "53085723",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:40",
        "brokerTime": "2025-05-14 14:51:40",
        "commission": -32.55,
        "swap": 0,
        "profit": -153.45,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049595",
        "positionId": "56049594",
        "volume": 4.65,
        "price": 3226.73,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -186,
        "priceIn": 3226.4,
        "doubleCheck": true
    },
    {
        "dataID": "115797",
        "id": "53085724",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:41",
        "brokerTime": "2025-05-14 14:51:41",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049596",
        "positionId": "56049596",
        "volume": 4.65,
        "price": 3226.54,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.54,
        "doubleCheck": true
    },
    {
        "dataID": "115798",
        "id": "53085726",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:41",
        "brokerTime": "2025-05-14 14:51:41",
        "commission": -32.55,
        "swap": 0,
        "profit": -88.35,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049598",
        "positionId": "56049596",
        "volume": 4.65,
        "price": 3226.73,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -120.89999999999999,
        "priceIn": 3226.54,
        "doubleCheck": true
    },
    {
        "dataID": "115799",
        "id": "53085728",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:42",
        "brokerTime": "2025-05-14 14:51:42",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049599",
        "positionId": "56049599",
        "volume": 4.65,
        "price": 3226.54,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.54,
        "doubleCheck": true
    },
    {
        "dataID": "115800",
        "id": "53085729",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:42",
        "brokerTime": "2025-05-14 14:51:43",
        "commission": -32.55,
        "swap": 0,
        "profit": -69.75,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049600",
        "positionId": "56049599",
        "volume": 4.65,
        "price": 3226.69,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -102.3,
        "priceIn": 3226.54,
        "doubleCheck": true
    },
    {
        "dataID": "115801",
        "id": "53085730",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:43",
        "brokerTime": "2025-05-14 14:51:43",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049601",
        "positionId": "56049601",
        "volume": 4.65,
        "price": 3226.46,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.46,
        "doubleCheck": true
    },
    {
        "dataID": "115802",
        "id": "53085731",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:43",
        "brokerTime": "2025-05-14 14:51:44",
        "commission": -32.55,
        "swap": 0,
        "profit": -23.25,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049602",
        "positionId": "56049601",
        "volume": 4.65,
        "price": 3226.51,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -55.8,
        "priceIn": 3226.46,
        "doubleCheck": true
    },
    {
        "dataID": "115803",
        "id": "53085732",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:44",
        "brokerTime": "2025-05-14 14:51:44",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049603",
        "positionId": "56049603",
        "volume": 4.65,
        "price": 3226.36,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.36,
        "doubleCheck": true
    },
    {
        "dataID": "115804",
        "id": "53085733",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:44",
        "brokerTime": "2025-05-14 14:51:44",
        "commission": -32.55,
        "swap": 0,
        "profit": -46.5,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049604",
        "positionId": "56049603",
        "volume": 4.65,
        "price": 3226.46,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -79.05,
        "priceIn": 3226.36,
        "doubleCheck": true
    },
    {
        "dataID": "115805",
        "id": "53085734",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:44",
        "brokerTime": "2025-05-14 14:51:44",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049605",
        "positionId": "56049605",
        "volume": 4.65,
        "price": 3226.27,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.27,
        "doubleCheck": true
    },
    {
        "dataID": "115806",
        "id": "53085735",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:44",
        "brokerTime": "2025-05-14 14:51:45",
        "commission": -32.55,
        "swap": 0,
        "profit": -120.9,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049606",
        "positionId": "56049605",
        "volume": 4.65,
        "price": 3226.53,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -153.45,
        "priceIn": 3226.27,
        "doubleCheck": true
    },
    {
        "dataID": "115807",
        "id": "53085736",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:45",
        "brokerTime": "2025-05-14 14:51:45",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049607",
        "positionId": "56049607",
        "volume": 4.65,
        "price": 3226.42,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.42,
        "doubleCheck": true
    },
    {
        "dataID": "115808",
        "id": "53085738",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:45",
        "brokerTime": "2025-05-14 14:51:46",
        "commission": -32.55,
        "swap": 0,
        "profit": -106.95,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049609",
        "positionId": "56049607",
        "volume": 4.65,
        "price": 3226.65,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -139.5,
        "priceIn": 3226.42,
        "doubleCheck": true
    },
    {
        "dataID": "115809",
        "id": "53085739",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:46",
        "brokerTime": "2025-05-14 14:51:46",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049610",
        "positionId": "56049610",
        "volume": 4.65,
        "price": 3226.39,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.39,
        "doubleCheck": true
    },
    {
        "dataID": "115810",
        "id": "53085740",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:46",
        "brokerTime": "2025-05-14 14:51:48",
        "commission": -32.55,
        "swap": 0,
        "profit": -116.25,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049611",
        "positionId": "56049610",
        "volume": 4.65,
        "price": 3226.64,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -148.8,
        "priceIn": 3226.39,
        "doubleCheck": true
    },
    {
        "dataID": "115811",
        "id": "53085741",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:48",
        "brokerTime": "2025-05-14 14:51:48",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049612",
        "positionId": "56049612",
        "volume": 4.65,
        "price": 3226.46,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.46,
        "doubleCheck": true
    },
    {
        "dataID": "115812",
        "id": "53085742",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:48",
        "brokerTime": "2025-05-14 14:51:49",
        "commission": -32.55,
        "swap": 0,
        "profit": -125.55,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049613",
        "positionId": "56049612",
        "volume": 4.65,
        "price": 3226.73,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -158.1,
        "priceIn": 3226.46,
        "doubleCheck": true
    },
    {
        "dataID": "115813",
        "id": "53085743",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:49",
        "brokerTime": "2025-05-14 14:51:49",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049614",
        "positionId": "56049614",
        "volume": 4.65,
        "price": 3226.55,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.55,
        "doubleCheck": true
    },
    {
        "dataID": "115814",
        "id": "53085744",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:49",
        "brokerTime": "2025-05-14 14:51:49",
        "commission": -32.55,
        "swap": 0,
        "profit": -111.6,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049615",
        "positionId": "56049614",
        "volume": 4.65,
        "price": 3226.79,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -144.14999999999998,
        "priceIn": 3226.55,
        "doubleCheck": true
    },
    {
        "dataID": "115815",
        "id": "53085745",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:50",
        "brokerTime": "2025-05-14 14:51:50",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049616",
        "positionId": "56049616",
        "volume": 4.65,
        "price": 3226.58,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.58,
        "doubleCheck": true
    },
    {
        "dataID": "115816",
        "id": "53085746",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:50",
        "brokerTime": "2025-05-14 14:51:50",
        "commission": -32.55,
        "swap": 0,
        "profit": -93,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049617",
        "positionId": "56049616",
        "volume": 4.65,
        "price": 3226.78,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -125.55,
        "priceIn": 3226.58,
        "doubleCheck": true
    },
    {
        "dataID": "115817",
        "id": "53085747",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:51",
        "brokerTime": "2025-05-14 14:51:51",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049618",
        "positionId": "56049618",
        "volume": 4.65,
        "price": 3226.63,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.63,
        "doubleCheck": true
    },
    {
        "dataID": "115818",
        "id": "53085748",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:51",
        "brokerTime": "2025-05-14 14:51:52",
        "commission": -32.55,
        "swap": 0,
        "profit": -153.45,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049619",
        "positionId": "56049618",
        "volume": 4.65,
        "price": 3226.96,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -186,
        "priceIn": 3226.63,
        "doubleCheck": true
    },
    {
        "dataID": "115819",
        "id": "53085750",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:52",
        "brokerTime": "2025-05-14 14:51:52",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049621",
        "positionId": "56049621",
        "volume": 4.65,
        "price": 3226.73,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.73,
        "doubleCheck": true
    },
    {
        "dataID": "115820",
        "id": "53085751",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:52",
        "brokerTime": "2025-05-14 14:51:52",
        "commission": -32.55,
        "swap": 0,
        "profit": 51.15,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049622",
        "positionId": "56049621",
        "volume": 4.65,
        "price": 3226.62,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 18.6,
        "priceIn": 3226.73,
        "doubleCheck": true
    },
    {
        "dataID": "115821",
        "id": "53085753",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:53",
        "brokerTime": "2025-05-14 14:51:53",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049624",
        "positionId": "56049624",
        "volume": 4.65,
        "price": 3226.6,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.6,
        "doubleCheck": true
    },
    {
        "dataID": "115822",
        "id": "53085755",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:53",
        "brokerTime": "2025-05-14 14:51:53",
        "commission": -32.55,
        "swap": 0,
        "profit": -65.1,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049626",
        "positionId": "56049624",
        "volume": 4.65,
        "price": 3226.74,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -97.64999999999999,
        "priceIn": 3226.6,
        "doubleCheck": true
    },
    {
        "dataID": "115823",
        "id": "53085756",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:54",
        "brokerTime": "2025-05-14 14:51:54",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049627",
        "positionId": "56049627",
        "volume": 4.65,
        "price": 3226.48,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.48,
        "doubleCheck": true
    },
    {
        "dataID": "115824",
        "id": "53085757",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:54",
        "brokerTime": "2025-05-14 14:51:55",
        "commission": -32.55,
        "swap": 0,
        "profit": -88.35,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049628",
        "positionId": "56049627",
        "volume": 4.65,
        "price": 3226.67,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -120.89999999999999,
        "priceIn": 3226.48,
        "doubleCheck": true
    },
    {
        "dataID": "115825",
        "id": "53085760",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:55",
        "brokerTime": "2025-05-14 14:51:55",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049631",
        "positionId": "56049631",
        "volume": 4.65,
        "price": 3226.48,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.48,
        "doubleCheck": true
    },
    {
        "dataID": "115826",
        "id": "53085761",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:55",
        "brokerTime": "2025-05-14 14:51:56",
        "commission": -32.55,
        "swap": 0,
        "profit": -106.95,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049632",
        "positionId": "56049631",
        "volume": 4.65,
        "price": 3226.71,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -139.5,
        "priceIn": 3226.48,
        "doubleCheck": true
    },
    {
        "dataID": "115827",
        "id": "53085763",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:56",
        "brokerTime": "2025-05-14 14:51:56",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049633",
        "positionId": "56049633",
        "volume": 4.65,
        "price": 3226.47,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.47,
        "doubleCheck": true
    },
    {
        "dataID": "115828",
        "id": "53085764",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:56",
        "brokerTime": "2025-05-14 14:51:57",
        "commission": -32.55,
        "swap": 0,
        "profit": -102.3,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049634",
        "positionId": "56049633",
        "volume": 4.65,
        "price": 3226.69,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -134.85,
        "priceIn": 3226.47,
        "doubleCheck": true
    },
    {
        "dataID": "115829",
        "id": "53085765",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:57",
        "brokerTime": "2025-05-14 14:51:57",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049635",
        "positionId": "56049635",
        "volume": 4.65,
        "price": 3226.51,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.51,
        "doubleCheck": true
    },
    {
        "dataID": "115830",
        "id": "53085766",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:57",
        "brokerTime": "2025-05-14 14:51:58",
        "commission": -32.55,
        "swap": 0,
        "profit": -125.55,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049636",
        "positionId": "56049635",
        "volume": 4.65,
        "price": 3226.78,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -158.1,
        "priceIn": 3226.51,
        "doubleCheck": true
    },
    {
        "dataID": "115831",
        "id": "53085767",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:58",
        "brokerTime": "2025-05-14 14:51:58",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049637",
        "positionId": "56049637",
        "volume": 4.65,
        "price": 3226.55,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.55,
        "doubleCheck": true
    },
    {
        "dataID": "115832",
        "id": "53085770",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:58",
        "brokerTime": "2025-05-14 14:51:59",
        "commission": -32.55,
        "swap": 0,
        "profit": 60.45,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049640",
        "positionId": "56049637",
        "volume": 4.65,
        "price": 3226.42,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 27.900000000000006,
        "priceIn": 3226.55,
        "doubleCheck": true
    },
    {
        "dataID": "115833",
        "id": "53085771",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:00",
        "brokerTime": "2025-05-14 14:52:00",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049641",
        "positionId": "56049641",
        "volume": 4.65,
        "price": 3226.23,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.23,
        "doubleCheck": true
    },
    {
        "dataID": "115834",
        "id": "53085772",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:00",
        "brokerTime": "2025-05-14 14:52:00",
        "commission": -32.55,
        "swap": 0,
        "profit": -106.95,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049642",
        "positionId": "56049641",
        "volume": 4.65,
        "price": 3226.46,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -139.5,
        "priceIn": 3226.23,
        "doubleCheck": true
    },
    {
        "dataID": "115835",
        "id": "53085774",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:00",
        "brokerTime": "2025-05-14 14:52:00",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049644",
        "positionId": "56049644",
        "volume": 4.65,
        "price": 3226.29,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.29,
        "doubleCheck": true
    },
    {
        "dataID": "115836",
        "id": "53085775",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:00",
        "brokerTime": "2025-05-14 14:52:01",
        "commission": -32.55,
        "swap": 0,
        "profit": -93,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049645",
        "positionId": "56049644",
        "volume": 4.65,
        "price": 3226.49,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -125.55,
        "priceIn": 3226.29,
        "doubleCheck": true
    },
    {
        "dataID": "115837",
        "id": "53085776",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:01",
        "brokerTime": "2025-05-14 14:52:01",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049646",
        "positionId": "56049646",
        "volume": 4.65,
        "price": 3226.29,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.29,
        "doubleCheck": true
    },
    {
        "dataID": "115838",
        "id": "53085777",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:01",
        "brokerTime": "2025-05-14 14:52:02",
        "commission": -32.55,
        "swap": 0,
        "profit": -134.85,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049647",
        "positionId": "56049646",
        "volume": 4.65,
        "price": 3226.58,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -167.39999999999998,
        "priceIn": 3226.29,
        "doubleCheck": true
    },
    {
        "dataID": "115839",
        "id": "53085778",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:02",
        "brokerTime": "2025-05-14 14:52:02",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049648",
        "positionId": "56049648",
        "volume": 4.65,
        "price": 3226.54,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.54,
        "doubleCheck": true
    },
    {
        "dataID": "115840",
        "id": "53085779",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:02",
        "brokerTime": "2025-05-14 14:52:03",
        "commission": -32.55,
        "swap": 0,
        "profit": -102.3,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049649",
        "positionId": "56049648",
        "volume": 4.65,
        "price": 3226.76,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -134.85,
        "priceIn": 3226.54,
        "doubleCheck": true
    },
    {
        "dataID": "119656",
        "id": "53085780",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:03",
        "brokerTime": "2025-05-14 14:52:03",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049650",
        "positionId": "56049650",
        "volume": 4.65,
        "price": 3226.54,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.54,
        "doubleCheck": true
    },
    {
        "dataID": "115841",
        "id": "53085781",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:03",
        "brokerTime": "2025-05-14 14:52:04",
        "commission": -32.55,
        "swap": 0,
        "profit": -102.3,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049651",
        "positionId": "56049650",
        "volume": 4.65,
        "price": 3226.76,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -134.85,
        "priceIn": 3226.54,
        "doubleCheck": true
    },
    {
        "dataID": "115842",
        "id": "53085782",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:05",
        "brokerTime": "2025-05-14 14:52:05",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049652",
        "positionId": "56049652",
        "volume": 4.65,
        "price": 3226.7,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.7,
        "doubleCheck": true
    },
    {
        "dataID": "115843",
        "id": "53085783",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:05",
        "brokerTime": "2025-05-14 14:52:05",
        "commission": -32.55,
        "swap": 0,
        "profit": -79.05,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049653",
        "positionId": "56049652",
        "volume": 4.65,
        "price": 3226.87,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -111.6,
        "priceIn": 3226.7,
        "doubleCheck": true
    },
    {
        "dataID": "115844",
        "id": "53085784",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:05",
        "brokerTime": "2025-05-14 14:52:05",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049654",
        "positionId": "56049654",
        "volume": 4.65,
        "price": 3226.64,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.64,
        "doubleCheck": true
    },
    {
        "dataID": "115845",
        "id": "53085785",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:05",
        "brokerTime": "2025-05-14 14:52:06",
        "commission": -32.55,
        "swap": 0,
        "profit": -93,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049655",
        "positionId": "56049654",
        "volume": 4.65,
        "price": 3226.84,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -125.55,
        "priceIn": 3226.64,
        "doubleCheck": true
    },
    {
        "dataID": "115846",
        "id": "53085786",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:06",
        "brokerTime": "2025-05-14 14:52:06",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049656",
        "positionId": "56049656",
        "volume": 4.65,
        "price": 3226.6,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.6,
        "doubleCheck": true
    },
    {
        "dataID": "115847",
        "id": "53085789",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:06",
        "brokerTime": "2025-05-14 14:52:07",
        "commission": -32.55,
        "swap": 0,
        "profit": -204.6,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049659",
        "positionId": "56049656",
        "volume": 4.65,
        "price": 3227.04,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -237.14999999999998,
        "priceIn": 3226.6,
        "doubleCheck": true
    },
    {
        "dataID": "115848",
        "id": "53085790",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:08",
        "brokerTime": "2025-05-14 14:52:08",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049660",
        "positionId": "56049660",
        "volume": 4.65,
        "price": 3226.8,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.8,
        "doubleCheck": true
    },
    {
        "dataID": "115849",
        "id": "53085791",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:08",
        "brokerTime": "2025-05-14 14:52:08",
        "commission": -32.55,
        "swap": 0,
        "profit": -88.35,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049661",
        "positionId": "56049660",
        "volume": 4.65,
        "price": 3226.99,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -120.89999999999999,
        "priceIn": 3226.8,
        "doubleCheck": true
    },
    {
        "dataID": "115850",
        "id": "53085792",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:08",
        "brokerTime": "2025-05-14 14:52:08",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049662",
        "positionId": "56049662",
        "volume": 4.65,
        "price": 3226.78,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.78,
        "doubleCheck": true
    },
    {
        "dataID": "115851",
        "id": "53085793",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:08",
        "brokerTime": "2025-05-14 14:52:09",
        "commission": -32.55,
        "swap": 0,
        "profit": -97.65,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049663",
        "positionId": "56049662",
        "volume": 4.65,
        "price": 3226.99,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -130.2,
        "priceIn": 3226.78,
        "doubleCheck": true
    },
    {
        "dataID": "115852",
        "id": "53085794",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:09",
        "brokerTime": "2025-05-14 14:52:09",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049664",
        "positionId": "56049664",
        "volume": 4.65,
        "price": 3226.84,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.84,
        "doubleCheck": true
    },
    {
        "dataID": "115853",
        "id": "53085795",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:09",
        "brokerTime": "2025-05-14 14:52:10",
        "commission": -32.55,
        "swap": 0,
        "profit": -167.4,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049665",
        "positionId": "56049664",
        "volume": 4.65,
        "price": 3227.2,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -199.95,
        "priceIn": 3226.84,
        "doubleCheck": true
    },
    {
        "dataID": "115854",
        "id": "53085796",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:11",
        "brokerTime": "2025-05-14 14:52:11",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049666",
        "positionId": "56049666",
        "volume": 4.65,
        "price": 3226.98,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.98,
        "doubleCheck": true
    },
    {
        "dataID": "115855",
        "id": "53085798",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:11",
        "brokerTime": "2025-05-14 14:52:11",
        "commission": -32.55,
        "swap": 0,
        "profit": -18.6,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049668",
        "positionId": "56049666",
        "volume": 4.65,
        "price": 3227.02,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -51.15,
        "priceIn": 3226.98,
        "doubleCheck": true
    },
    {
        "dataID": "115856",
        "id": "53085799",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:12",
        "brokerTime": "2025-05-14 14:52:12",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049669",
        "positionId": "56049669",
        "volume": 4.65,
        "price": 3226.81,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.81,
        "doubleCheck": true
    },
    {
        "dataID": "115857",
        "id": "53085800",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:12",
        "brokerTime": "2025-05-14 14:52:12",
        "commission": -32.55,
        "swap": 0,
        "profit": -144.15,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049670",
        "positionId": "56049669",
        "volume": 4.65,
        "price": 3227.12,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -176.7,
        "priceIn": 3226.81,
        "doubleCheck": true
    },
    {
        "dataID": "115858",
        "id": "53085801",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:13",
        "brokerTime": "2025-05-14 14:52:13",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049671",
        "positionId": "56049671",
        "volume": 4.65,
        "price": 3226.97,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.97,
        "doubleCheck": true
    },
    {
        "dataID": "115859",
        "id": "53085802",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:13",
        "brokerTime": "2025-05-14 14:52:14",
        "commission": -32.55,
        "swap": 0,
        "profit": -74.4,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049672",
        "positionId": "56049671",
        "volume": 4.65,
        "price": 3227.13,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.95,
        "priceIn": 3226.97,
        "doubleCheck": true
    },
    {
        "dataID": "115860",
        "id": "53085803",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:15",
        "brokerTime": "2025-05-14 14:52:15",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049673",
        "positionId": "56049673",
        "volume": 4.65,
        "price": 3227.2,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3227.2,
        "doubleCheck": true
    },
    {
        "dataID": "115861",
        "id": "53085804",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:15",
        "brokerTime": "2025-05-14 14:52:15",
        "commission": -32.55,
        "swap": 0,
        "profit": -97.65,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049674",
        "positionId": "56049673",
        "volume": 4.65,
        "price": 3227.41,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -130.2,
        "priceIn": 3227.2,
        "doubleCheck": true
    },
    {
        "dataID": "115862",
        "id": "53085806",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:16",
        "brokerTime": "2025-05-14 14:52:16",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049676",
        "positionId": "56049676",
        "volume": 4.65,
        "price": 3227.2,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3227.2,
        "doubleCheck": true
    },
    {
        "dataID": "115863",
        "id": "53085807",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:16",
        "brokerTime": "2025-05-14 14:52:16",
        "commission": -32.55,
        "swap": 0,
        "profit": -125.55,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049677",
        "positionId": "56049676",
        "volume": 4.65,
        "price": 3227.47,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -158.1,
        "priceIn": 3227.2,
        "doubleCheck": true
    },
    {
        "dataID": "115864",
        "id": "53085808",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:17",
        "brokerTime": "2025-05-14 14:52:17",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049678",
        "positionId": "56049678",
        "volume": 4.65,
        "price": 3227.27,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3227.27,
        "doubleCheck": true
    },
    {
        "dataID": "115865",
        "id": "53085809",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:17",
        "brokerTime": "2025-05-14 14:52:18",
        "commission": -32.55,
        "swap": 0,
        "profit": -102.3,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049679",
        "positionId": "56049678",
        "volume": 4.65,
        "price": 3227.49,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -134.85,
        "priceIn": 3227.27,
        "doubleCheck": true
    },
    {
        "dataID": "115866",
        "id": "53085810",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:18",
        "brokerTime": "2025-05-14 14:52:18",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049680",
        "positionId": "56049680",
        "volume": 4.65,
        "price": 3226.77,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.77,
        "doubleCheck": true
    },
    {
        "dataID": "115867",
        "id": "53085811",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:18",
        "brokerTime": "2025-05-14 14:52:19",
        "commission": -32.55,
        "swap": 0,
        "profit": -79.05,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049681",
        "positionId": "56049680",
        "volume": 4.65,
        "price": 3226.94,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -111.6,
        "priceIn": 3226.77,
        "doubleCheck": true
    },
    {
        "dataID": "115868",
        "id": "53085812",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:19",
        "brokerTime": "2025-05-14 14:52:19",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049682",
        "positionId": "56049682",
        "volume": 4.65,
        "price": 3226.78,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.78,
        "doubleCheck": true
    },
    {
        "dataID": "115869",
        "id": "53085813",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:19",
        "brokerTime": "2025-05-14 14:52:20",
        "commission": -32.55,
        "swap": 0,
        "profit": -79.05,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049683",
        "positionId": "56049682",
        "volume": 4.65,
        "price": 3226.95,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -111.6,
        "priceIn": 3226.78,
        "doubleCheck": true
    },
    {
        "dataID": "115870",
        "id": "53085814",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:20",
        "brokerTime": "2025-05-14 14:52:20",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049684",
        "positionId": "56049684",
        "volume": 4.65,
        "price": 3226.73,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.73,
        "doubleCheck": true
    },
    {
        "dataID": "115871",
        "id": "53085815",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:20",
        "brokerTime": "2025-05-14 14:52:21",
        "commission": -32.55,
        "swap": 0,
        "profit": -55.8,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049685",
        "positionId": "56049684",
        "volume": 4.65,
        "price": 3226.85,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.35,
        "priceIn": 3226.73,
        "doubleCheck": true
    },
    {
        "dataID": "115872",
        "id": "53085816",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:22",
        "brokerTime": "2025-05-14 14:52:22",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049686",
        "positionId": "56049686",
        "volume": 4.65,
        "price": 3226.63,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.63,
        "doubleCheck": true
    },
    {
        "dataID": "115873",
        "id": "53085817",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:22",
        "brokerTime": "2025-05-14 14:52:23",
        "commission": -32.55,
        "swap": 0,
        "profit": -55.8,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049687",
        "positionId": "56049686",
        "volume": 4.65,
        "price": 3226.75,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.35,
        "priceIn": 3226.63,
        "doubleCheck": true
    },
    {
        "dataID": "115874",
        "id": "53085818",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:24",
        "brokerTime": "2025-05-14 14:52:24",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049688",
        "positionId": "56049688",
        "volume": 4.65,
        "price": 3226.54,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.54,
        "doubleCheck": true
    },
    {
        "dataID": "115875",
        "id": "53085819",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:24",
        "brokerTime": "2025-05-14 14:52:24",
        "commission": -32.55,
        "swap": 0,
        "profit": -134.85,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049689",
        "positionId": "56049688",
        "volume": 4.65,
        "price": 3226.83,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -167.39999999999998,
        "priceIn": 3226.54,
        "doubleCheck": true
    },
    {
        "dataID": "115876",
        "id": "53085820",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:24",
        "brokerTime": "2025-05-14 14:52:24",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049690",
        "positionId": "56049690",
        "volume": 4.65,
        "price": 3226.63,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.63,
        "doubleCheck": true
    },
    {
        "dataID": "115877",
        "id": "53085821",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:24",
        "brokerTime": "2025-05-14 14:52:25",
        "commission": -32.55,
        "swap": 0,
        "profit": -93,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049691",
        "positionId": "56049690",
        "volume": 4.65,
        "price": 3226.83,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -125.55,
        "priceIn": 3226.63,
        "doubleCheck": true
    },
    {
        "dataID": "115878",
        "id": "53085822",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:26",
        "brokerTime": "2025-05-14 14:52:26",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049692",
        "positionId": "56049692",
        "volume": 4.65,
        "price": 3226.62,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.62,
        "doubleCheck": true
    },
    {
        "dataID": "115879",
        "id": "53085823",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:26",
        "brokerTime": "2025-05-14 14:52:28",
        "commission": -32.55,
        "swap": 0,
        "profit": -88.35,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049693",
        "positionId": "56049692",
        "volume": 4.65,
        "price": 3226.81,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -120.89999999999999,
        "priceIn": 3226.62,
        "doubleCheck": true
    },
    {
        "dataID": "115880",
        "id": "53085824",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:29",
        "brokerTime": "2025-05-14 14:52:29",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049694",
        "positionId": "56049694",
        "volume": 4.65,
        "price": 3226.62,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.62,
        "doubleCheck": true
    },
    {
        "dataID": "115881",
        "id": "53085825",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:29",
        "brokerTime": "2025-05-14 14:52:30",
        "commission": -32.55,
        "swap": 0,
        "profit": -93,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049695",
        "positionId": "56049694",
        "volume": 4.65,
        "price": 3226.82,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -125.55,
        "priceIn": 3226.62,
        "doubleCheck": true
    },
    {
        "dataID": "115882",
        "id": "53085826",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:31",
        "brokerTime": "2025-05-14 14:52:31",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049696",
        "positionId": "56049696",
        "volume": 4.65,
        "price": 3226.58,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.58,
        "doubleCheck": true
    },
    {
        "dataID": "115883",
        "id": "53085827",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:31",
        "brokerTime": "2025-05-14 14:52:31",
        "commission": -32.55,
        "swap": 0,
        "profit": -106.95,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049697",
        "positionId": "56049696",
        "volume": 4.65,
        "price": 3226.81,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -139.5,
        "priceIn": 3226.58,
        "doubleCheck": true
    },
    {
        "dataID": "115884",
        "id": "53085828",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:32",
        "brokerTime": "2025-05-14 14:52:32",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049698",
        "positionId": "56049698",
        "volume": 4.65,
        "price": 3226.57,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.57,
        "doubleCheck": true
    },
    {
        "dataID": "115885",
        "id": "53085829",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:32",
        "brokerTime": "2025-05-14 14:52:32",
        "commission": -32.55,
        "swap": 0,
        "profit": -102.3,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049699",
        "positionId": "56049698",
        "volume": 4.65,
        "price": 3226.79,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -134.85,
        "priceIn": 3226.57,
        "doubleCheck": true
    },
    {
        "dataID": "115886",
        "id": "53085830",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:33",
        "brokerTime": "2025-05-14 14:52:33",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049700",
        "positionId": "56049700",
        "volume": 4.65,
        "price": 3226.63,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.63,
        "doubleCheck": true
    },
    {
        "dataID": "115887",
        "id": "53085832",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:33",
        "brokerTime": "2025-05-14 14:52:34",
        "commission": -32.55,
        "swap": 0,
        "profit": -88.35,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049702",
        "positionId": "56049700",
        "volume": 4.65,
        "price": 3226.82,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -120.89999999999999,
        "priceIn": 3226.63,
        "doubleCheck": true
    },
    {
        "dataID": "115888",
        "id": "53085833",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:34",
        "brokerTime": "2025-05-14 14:52:34",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049703",
        "positionId": "56049703",
        "volume": 4.65,
        "price": 3227.03,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3227.03,
        "doubleCheck": true
    },
    {
        "dataID": "115889",
        "id": "53085834",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:34",
        "brokerTime": "2025-05-14 14:52:34",
        "commission": -32.55,
        "swap": 0,
        "profit": -60.45,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049704",
        "positionId": "56049703",
        "volume": 4.65,
        "price": 3227.16,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -93,
        "priceIn": 3227.03,
        "doubleCheck": true
    },
    {
        "dataID": "115890",
        "id": "53085835",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:34",
        "brokerTime": "2025-05-14 14:52:34",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049705",
        "positionId": "56049705",
        "volume": 4.65,
        "price": 3226.87,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.87,
        "doubleCheck": true
    },
    {
        "dataID": "115891",
        "id": "53085836",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:34",
        "brokerTime": "2025-05-14 14:52:35",
        "commission": -32.55,
        "swap": 0,
        "profit": -69.75,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049706",
        "positionId": "56049705",
        "volume": 4.65,
        "price": 3227.02,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -102.3,
        "priceIn": 3226.87,
        "doubleCheck": true
    },
    {
        "dataID": "115892",
        "id": "53085837",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:36",
        "brokerTime": "2025-05-14 14:52:36",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049707",
        "positionId": "56049707",
        "volume": 4.65,
        "price": 3226.8,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.8,
        "doubleCheck": true
    },
    {
        "dataID": "115893",
        "id": "53085838",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:36",
        "brokerTime": "2025-05-14 14:52:36",
        "commission": -32.55,
        "swap": 0,
        "profit": -144.15,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049708",
        "positionId": "56049707",
        "volume": 4.65,
        "price": 3227.11,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -176.7,
        "priceIn": 3226.8,
        "doubleCheck": true
    },
    {
        "dataID": "115894",
        "id": "53085840",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:36",
        "brokerTime": "2025-05-14 14:52:36",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049710",
        "positionId": "56049710",
        "volume": 4.65,
        "price": 3226.96,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.96,
        "doubleCheck": true
    },
    {
        "dataID": "115895",
        "id": "53085841",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:36",
        "brokerTime": "2025-05-14 14:52:37",
        "commission": -32.55,
        "swap": 0,
        "profit": -93,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049711",
        "positionId": "56049710",
        "volume": 4.65,
        "price": 3227.16,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -125.55,
        "priceIn": 3226.96,
        "doubleCheck": true
    },
    {
        "dataID": "115896",
        "id": "53085842",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:37",
        "brokerTime": "2025-05-14 14:52:37",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049712",
        "positionId": "56049712",
        "volume": 4.65,
        "price": 3226.96,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.96,
        "doubleCheck": true
    },
    {
        "dataID": "115897",
        "id": "53085843",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:37",
        "brokerTime": "2025-05-14 14:52:38",
        "commission": -32.55,
        "swap": 0,
        "profit": -93,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049713",
        "positionId": "56049712",
        "volume": 4.65,
        "price": 3227.16,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -125.55,
        "priceIn": 3226.96,
        "doubleCheck": true
    },
    {
        "dataID": "115898",
        "id": "53085844",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:38",
        "brokerTime": "2025-05-14 14:52:38",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049714",
        "positionId": "56049714",
        "volume": 4.65,
        "price": 3226.96,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.96,
        "doubleCheck": true
    },
    {
        "dataID": "115899",
        "id": "53085845",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:38",
        "brokerTime": "2025-05-14 14:52:38",
        "commission": -32.55,
        "swap": 0,
        "profit": -148.8,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049715",
        "positionId": "56049714",
        "volume": 4.65,
        "price": 3227.28,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -181.35000000000002,
        "priceIn": 3226.96,
        "doubleCheck": true
    },
    {
        "dataID": "115900",
        "id": "53085846",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:39",
        "brokerTime": "2025-05-14 14:52:39",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049716",
        "positionId": "56049716",
        "volume": 4.65,
        "price": 3227.08,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3227.08,
        "doubleCheck": true
    },
    {
        "dataID": "115901",
        "id": "53085847",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:39",
        "brokerTime": "2025-05-14 14:52:39",
        "commission": -32.55,
        "swap": 0,
        "profit": -97.65,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049717",
        "positionId": "56049716",
        "volume": 4.65,
        "price": 3227.29,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -130.2,
        "priceIn": 3227.08,
        "doubleCheck": true
    },
    {
        "dataID": "115902",
        "id": "53085848",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:40",
        "brokerTime": "2025-05-14 14:52:40",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049718",
        "positionId": "56049718",
        "volume": 4.65,
        "price": 3227.05,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3227.05,
        "doubleCheck": true
    },
    {
        "dataID": "115903",
        "id": "53085849",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:40",
        "brokerTime": "2025-05-14 14:52:40",
        "commission": -32.55,
        "swap": 0,
        "profit": -79.05,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049719",
        "positionId": "56049718",
        "volume": 4.65,
        "price": 3227.22,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -111.6,
        "priceIn": 3227.05,
        "doubleCheck": true
    },
    {
        "dataID": "115904",
        "id": "53085850",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:41",
        "brokerTime": "2025-05-14 14:52:41",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049720",
        "positionId": "56049720",
        "volume": 4.65,
        "price": 3226.88,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.88,
        "doubleCheck": true
    },
    {
        "dataID": "115905",
        "id": "53085851",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:41",
        "brokerTime": "2025-05-14 14:52:41",
        "commission": -32.55,
        "swap": 0,
        "profit": -69.75,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049721",
        "positionId": "56049720",
        "volume": 4.65,
        "price": 3227.03,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -102.3,
        "priceIn": 3226.88,
        "doubleCheck": true
    },
    {
        "dataID": "115906",
        "id": "53085852",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:41",
        "brokerTime": "2025-05-14 14:52:41",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049722",
        "positionId": "56049722",
        "volume": 4.65,
        "price": 3226.71,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.71,
        "doubleCheck": true
    },
    {
        "dataID": "115907",
        "id": "53085853",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:41",
        "brokerTime": "2025-05-14 14:52:42",
        "commission": -32.55,
        "swap": 0,
        "profit": -102.3,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049723",
        "positionId": "56049722",
        "volume": 4.65,
        "price": 3226.93,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -134.85,
        "priceIn": 3226.71,
        "doubleCheck": true
    },
    {
        "dataID": "115908",
        "id": "53085854",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:42",
        "brokerTime": "2025-05-14 14:52:42",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049724",
        "positionId": "56049724",
        "volume": 4.65,
        "price": 3226.71,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.71,
        "doubleCheck": true
    },
    {
        "dataID": "115909",
        "id": "53085855",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:42",
        "brokerTime": "2025-05-14 14:52:42",
        "commission": -32.55,
        "swap": 0,
        "profit": -139.5,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049725",
        "positionId": "56049724",
        "volume": 4.65,
        "price": 3227.01,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -172.05,
        "priceIn": 3226.71,
        "doubleCheck": true
    },
    {
        "dataID": "115910",
        "id": "53085856",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:43",
        "brokerTime": "2025-05-14 14:52:43",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049726",
        "positionId": "56049726",
        "volume": 4.65,
        "price": 3226.87,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.87,
        "doubleCheck": true
    },
    {
        "dataID": "115911",
        "id": "53085857",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:43",
        "brokerTime": "2025-05-14 14:52:43",
        "commission": -32.55,
        "swap": 0,
        "profit": -79.05,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049727",
        "positionId": "56049726",
        "volume": 4.65,
        "price": 3227.04,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -111.6,
        "priceIn": 3226.87,
        "doubleCheck": true
    },
    {
        "dataID": "115912",
        "id": "53085858",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:44",
        "brokerTime": "2025-05-14 14:52:44",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049728",
        "positionId": "56049728",
        "volume": 4.65,
        "price": 3226.8,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.8,
        "doubleCheck": true
    },
    {
        "dataID": "115913",
        "id": "53085859",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:44",
        "brokerTime": "2025-05-14 14:52:44",
        "commission": -32.55,
        "swap": 0,
        "profit": -97.65,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049729",
        "positionId": "56049728",
        "volume": 4.65,
        "price": 3227.01,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -130.2,
        "priceIn": 3226.8,
        "doubleCheck": true
    },
    {
        "dataID": "115914",
        "id": "53085860",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:45",
        "brokerTime": "2025-05-14 14:52:45",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049730",
        "positionId": "56049730",
        "volume": 4.65,
        "price": 3226.79,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.79,
        "doubleCheck": true
    },
    {
        "dataID": "115915",
        "id": "53085862",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:45",
        "brokerTime": "2025-05-14 14:52:47",
        "commission": -32.55,
        "swap": 0,
        "profit": -139.5,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049732",
        "positionId": "56049730",
        "volume": 4.65,
        "price": 3227.09,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -172.05,
        "priceIn": 3226.79,
        "doubleCheck": true
    },
    {
        "dataID": "115916",
        "id": "53085865",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:49",
        "brokerTime": "2025-05-14 14:52:49",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049735",
        "positionId": "56049735",
        "volume": 4.65,
        "price": 3226.84,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.84,
        "doubleCheck": true
    },
    {
        "dataID": "115917",
        "id": "53085869",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:49",
        "brokerTime": "2025-05-14 14:52:50",
        "commission": -32.55,
        "swap": 0,
        "profit": -97.65,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049739",
        "positionId": "56049735",
        "volume": 4.65,
        "price": 3227.05,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -130.2,
        "priceIn": 3226.84,
        "doubleCheck": true
    },
    {
        "dataID": "115918",
        "id": "53085870",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:51",
        "brokerTime": "2025-05-14 14:52:51",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049740",
        "positionId": "56049740",
        "volume": 4.65,
        "price": 3226.9,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.9,
        "doubleCheck": true
    },
    {
        "dataID": "115919",
        "id": "53085871",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:51",
        "brokerTime": "2025-05-14 14:52:51",
        "commission": -32.55,
        "swap": 0,
        "profit": -241.8,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049741",
        "positionId": "56049740",
        "volume": 4.65,
        "price": 3227.42,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -274.35,
        "priceIn": 3226.9,
        "doubleCheck": true
    },
    {
        "dataID": "115920",
        "id": "53085872",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:52",
        "brokerTime": "2025-05-14 14:52:52",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049742",
        "positionId": "56049742",
        "volume": 4.65,
        "price": 3227.23,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3227.23,
        "doubleCheck": true
    },
    {
        "dataID": "115921",
        "id": "53085873",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:52",
        "brokerTime": "2025-05-14 14:52:52",
        "commission": -32.55,
        "swap": 0,
        "profit": -83.7,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049743",
        "positionId": "56049742",
        "volume": 4.65,
        "price": 3227.41,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -116.25,
        "priceIn": 3227.23,
        "doubleCheck": true
    },
    {
        "dataID": "115922",
        "id": "53085874",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:53",
        "brokerTime": "2025-05-14 14:52:53",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049744",
        "positionId": "56049744",
        "volume": 4.65,
        "price": 3227.22,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3227.22,
        "doubleCheck": true
    },
    {
        "dataID": "115923",
        "id": "53085875",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:53",
        "brokerTime": "2025-05-14 14:52:54",
        "commission": -32.55,
        "swap": 0,
        "profit": -74.4,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049745",
        "positionId": "56049744",
        "volume": 4.65,
        "price": 3227.38,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.95,
        "priceIn": 3227.22,
        "doubleCheck": true
    },
    {
        "dataID": "115924",
        "id": "53085876",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:54",
        "brokerTime": "2025-05-14 14:52:54",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049746",
        "positionId": "56049746",
        "volume": 4.65,
        "price": 3226.99,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.99,
        "doubleCheck": true
    },
    {
        "dataID": "115925",
        "id": "53085877",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:54",
        "brokerTime": "2025-05-14 14:52:55",
        "commission": -32.55,
        "swap": 0,
        "profit": -83.7,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049747",
        "positionId": "56049746",
        "volume": 4.65,
        "price": 3227.17,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -116.25,
        "priceIn": 3226.99,
        "doubleCheck": true
    },
    {
        "dataID": "115926",
        "id": "53085878",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:55",
        "brokerTime": "2025-05-14 14:52:55",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049748",
        "positionId": "56049748",
        "volume": 4.65,
        "price": 3226.96,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.96,
        "doubleCheck": true
    },
    {
        "dataID": "115927",
        "id": "53085879",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:55",
        "brokerTime": "2025-05-14 14:52:55",
        "commission": -32.55,
        "swap": 0,
        "profit": -106.95,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049749",
        "positionId": "56049748",
        "volume": 4.65,
        "price": 3227.19,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -139.5,
        "priceIn": 3226.96,
        "doubleCheck": true
    },
    {
        "dataID": "115928",
        "id": "53085880",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:56",
        "brokerTime": "2025-05-14 14:52:56",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049750",
        "positionId": "56049750",
        "volume": 4.65,
        "price": 3226.96,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.96,
        "doubleCheck": true
    },
    {
        "dataID": "115929",
        "id": "53085881",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:56",
        "brokerTime": "2025-05-14 14:52:56",
        "commission": -32.55,
        "swap": 0,
        "profit": -88.35,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049751",
        "positionId": "56049750",
        "volume": 4.65,
        "price": 3227.15,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -120.89999999999999,
        "priceIn": 3226.96,
        "doubleCheck": true
    },
    {
        "dataID": "115930",
        "id": "53085882",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:56",
        "brokerTime": "2025-05-14 14:52:56",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049752",
        "positionId": "56049752",
        "volume": 4.65,
        "price": 3226.89,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.89,
        "doubleCheck": true
    },
    {
        "dataID": "115931",
        "id": "53085883",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:56",
        "brokerTime": "2025-05-14 14:52:57",
        "commission": -32.55,
        "swap": 0,
        "profit": -116.25,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049753",
        "positionId": "56049752",
        "volume": 4.65,
        "price": 3227.14,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -148.8,
        "priceIn": 3226.89,
        "doubleCheck": true
    },
    {
        "dataID": "115932",
        "id": "53085884",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:57",
        "brokerTime": "2025-05-14 14:52:57",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049754",
        "positionId": "56049754",
        "volume": 4.65,
        "price": 3227.04,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3227.04,
        "doubleCheck": true
    },
    {
        "dataID": "115933",
        "id": "53085885",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:57",
        "brokerTime": "2025-05-14 14:52:58",
        "commission": -32.55,
        "swap": 0,
        "profit": -97.65,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049755",
        "positionId": "56049754",
        "volume": 4.65,
        "price": 3227.25,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -130.2,
        "priceIn": 3227.04,
        "doubleCheck": true
    },
    {
        "dataID": "115934",
        "id": "53085887",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:59",
        "brokerTime": "2025-05-14 14:52:59",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049757",
        "positionId": "56049757",
        "volume": 4.65,
        "price": 3227.06,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3227.06,
        "doubleCheck": true
    },
    {
        "dataID": "115935",
        "id": "53085888",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:59",
        "brokerTime": "2025-05-14 14:53:00",
        "commission": -32.55,
        "swap": 0,
        "profit": -88.35,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049758",
        "positionId": "56049757",
        "volume": 4.65,
        "price": 3227.25,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -120.89999999999999,
        "priceIn": 3227.06,
        "doubleCheck": true
    },
    {
        "dataID": "115936",
        "id": "53085889",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:00",
        "brokerTime": "2025-05-14 14:53:00",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049759",
        "positionId": "56049759",
        "volume": 4.65,
        "price": 3227.05,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3227.05,
        "doubleCheck": true
    },
    {
        "dataID": "115937",
        "id": "53085890",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:00",
        "brokerTime": "2025-05-14 14:53:01",
        "commission": -32.55,
        "swap": 0,
        "profit": -88.35,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049760",
        "positionId": "56049759",
        "volume": 4.65,
        "price": 3227.24,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -120.89999999999999,
        "priceIn": 3227.05,
        "doubleCheck": true
    },
    {
        "dataID": "115938",
        "id": "53085891",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:01",
        "brokerTime": "2025-05-14 14:53:01",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049761",
        "positionId": "56049761",
        "volume": 4.65,
        "price": 3227.05,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3227.05,
        "doubleCheck": true
    },
    {
        "dataID": "115939",
        "id": "53085892",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:01",
        "brokerTime": "2025-05-14 14:53:02",
        "commission": -32.55,
        "swap": 0,
        "profit": -37.2,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049762",
        "positionId": "56049761",
        "volume": 4.65,
        "price": 3227.13,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.75,
        "priceIn": 3227.05,
        "doubleCheck": true
    },
    {
        "dataID": "115940",
        "id": "53085893",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:03",
        "brokerTime": "2025-05-14 14:53:03",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049763",
        "positionId": "56049763",
        "volume": 4.65,
        "price": 3226.86,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.86,
        "doubleCheck": true
    },
    {
        "dataID": "115941",
        "id": "53085894",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:03",
        "brokerTime": "2025-05-14 14:53:03",
        "commission": -32.55,
        "swap": 0,
        "profit": -65.1,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049764",
        "positionId": "56049763",
        "volume": 4.65,
        "price": 3227,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -97.64999999999999,
        "priceIn": 3226.86,
        "doubleCheck": true
    },
    {
        "dataID": "115942",
        "id": "53085896",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:04",
        "brokerTime": "2025-05-14 14:53:04",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049766",
        "positionId": "56049766",
        "volume": 4.65,
        "price": 3226.66,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.66,
        "doubleCheck": true
    },
    {
        "dataID": "115943",
        "id": "53085897",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:04",
        "brokerTime": "2025-05-14 14:53:04",
        "commission": -32.55,
        "swap": 0,
        "profit": -79.05,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049767",
        "positionId": "56049766",
        "volume": 4.65,
        "price": 3226.83,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -111.6,
        "priceIn": 3226.66,
        "doubleCheck": true
    },
    {
        "dataID": "115944",
        "id": "53085898",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:05",
        "brokerTime": "2025-05-14 14:53:05",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049768",
        "positionId": "56049768",
        "volume": 4.65,
        "price": 3226.64,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.64,
        "doubleCheck": true
    },
    {
        "dataID": "115945",
        "id": "53085899",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:05",
        "brokerTime": "2025-05-14 14:53:06",
        "commission": -32.55,
        "swap": 0,
        "profit": -130.2,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049769",
        "positionId": "56049768",
        "volume": 4.65,
        "price": 3226.92,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -162.75,
        "priceIn": 3226.64,
        "doubleCheck": true
    },
    {
        "dataID": "115946",
        "id": "53085900",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:07",
        "brokerTime": "2025-05-14 14:53:07",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049770",
        "positionId": "56049770",
        "volume": 4.65,
        "price": 3226.81,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.81,
        "doubleCheck": true
    },
    {
        "dataID": "115947",
        "id": "53085901",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:07",
        "brokerTime": "2025-05-14 14:53:08",
        "commission": -32.55,
        "swap": 0,
        "profit": -139.5,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049771",
        "positionId": "56049770",
        "volume": 4.65,
        "price": 3227.11,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -172.05,
        "priceIn": 3226.81,
        "doubleCheck": true
    },
    {
        "dataID": "115948",
        "id": "53085902",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:09",
        "brokerTime": "2025-05-14 14:53:09",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049772",
        "positionId": "56049772",
        "volume": 4.65,
        "price": 3226.9,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.9,
        "doubleCheck": true
    },
    {
        "dataID": "115949",
        "id": "53085903",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:09",
        "brokerTime": "2025-05-14 14:53:09",
        "commission": -32.55,
        "swap": 0,
        "profit": -83.7,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049773",
        "positionId": "56049772",
        "volume": 4.65,
        "price": 3227.08,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -116.25,
        "priceIn": 3226.9,
        "doubleCheck": true
    },
    {
        "dataID": "115950",
        "id": "53085904",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:10",
        "brokerTime": "2025-05-14 14:53:10",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049774",
        "positionId": "56049774",
        "volume": 4.65,
        "price": 3226.86,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.86,
        "doubleCheck": true
    },
    {
        "dataID": "115951",
        "id": "53085905",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:10",
        "brokerTime": "2025-05-14 14:53:10",
        "commission": -32.55,
        "swap": 0,
        "profit": -88.35,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049775",
        "positionId": "56049774",
        "volume": 4.65,
        "price": 3227.05,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -120.89999999999999,
        "priceIn": 3226.86,
        "doubleCheck": true
    },
    {
        "dataID": "115952",
        "id": "53085906",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:11",
        "brokerTime": "2025-05-14 14:53:11",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049776",
        "positionId": "56049776",
        "volume": 4.65,
        "price": 3226.83,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.83,
        "doubleCheck": true
    },
    {
        "dataID": "115953",
        "id": "53085907",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:11",
        "brokerTime": "2025-05-14 14:53:11",
        "commission": -32.55,
        "swap": 0,
        "profit": -172.05,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049777",
        "positionId": "56049776",
        "volume": 4.65,
        "price": 3227.2,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -204.60000000000002,
        "priceIn": 3226.83,
        "doubleCheck": true
    },
    {
        "dataID": "115954",
        "id": "53085908",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:12",
        "brokerTime": "2025-05-14 14:53:12",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049778",
        "positionId": "56049778",
        "volume": 4.65,
        "price": 3226.95,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.95,
        "doubleCheck": true
    },
    {
        "dataID": "115955",
        "id": "53085909",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:12",
        "brokerTime": "2025-05-14 14:53:13",
        "commission": -32.55,
        "swap": 0,
        "profit": -79.05,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049779",
        "positionId": "56049778",
        "volume": 4.65,
        "price": 3227.12,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -111.6,
        "priceIn": 3226.95,
        "doubleCheck": true
    },
    {
        "dataID": "115956",
        "id": "53085910",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:13",
        "brokerTime": "2025-05-14 14:53:13",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049780",
        "positionId": "56049780",
        "volume": 4.65,
        "price": 3226.92,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.92,
        "doubleCheck": true
    },
    {
        "dataID": "115957",
        "id": "53085911",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:13",
        "brokerTime": "2025-05-14 14:53:16",
        "commission": -32.55,
        "swap": 0,
        "profit": -125.55,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049781",
        "positionId": "56049780",
        "volume": 4.65,
        "price": 3227.19,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -158.1,
        "priceIn": 3226.92,
        "doubleCheck": true
    },
    {
        "dataID": "115958",
        "id": "53085912",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:16",
        "brokerTime": "2025-05-14 14:53:16",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049782",
        "positionId": "56049782",
        "volume": 4.65,
        "price": 3227.11,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3227.11,
        "doubleCheck": true
    },
    {
        "dataID": "115959",
        "id": "53085913",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:16",
        "brokerTime": "2025-05-14 14:53:17",
        "commission": -32.55,
        "swap": 0,
        "profit": -111.6,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049783",
        "positionId": "56049782",
        "volume": 4.65,
        "price": 3227.35,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -144.14999999999998,
        "priceIn": 3227.11,
        "doubleCheck": true
    },
    {
        "dataID": "115960",
        "id": "53085914",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:17",
        "brokerTime": "2025-05-14 14:53:17",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049784",
        "positionId": "56049784",
        "volume": 4.65,
        "price": 3227.15,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3227.15,
        "doubleCheck": true
    },
    {
        "dataID": "115961",
        "id": "53085916",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:17",
        "brokerTime": "2025-05-14 14:53:18",
        "commission": -32.55,
        "swap": 0,
        "profit": -125.55,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049786",
        "positionId": "56049784",
        "volume": 4.65,
        "price": 3227.42,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -158.1,
        "priceIn": 3227.15,
        "doubleCheck": true
    },
    {
        "dataID": "115962",
        "id": "53085917",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:18",
        "brokerTime": "2025-05-14 14:53:18",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049787",
        "positionId": "56049787",
        "volume": 4.65,
        "price": 3227.21,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3227.21,
        "doubleCheck": true
    },
    {
        "dataID": "115963",
        "id": "53085918",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:18",
        "brokerTime": "2025-05-14 14:53:19",
        "commission": -32.55,
        "swap": 0,
        "profit": -79.05,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049788",
        "positionId": "56049787",
        "volume": 4.65,
        "price": 3227.38,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -111.6,
        "priceIn": 3227.21,
        "doubleCheck": true
    },
    {
        "dataID": "115964",
        "id": "53085919",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:19",
        "brokerTime": "2025-05-14 14:53:19",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049789",
        "positionId": "56049789",
        "volume": 4.65,
        "price": 3227.1,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3227.1,
        "doubleCheck": true
    },
    {
        "dataID": "115965",
        "id": "53085920",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:19",
        "brokerTime": "2025-05-14 14:53:20",
        "commission": -32.55,
        "swap": 0,
        "profit": -102.3,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049790",
        "positionId": "56049789",
        "volume": 4.65,
        "price": 3227.32,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -134.85,
        "priceIn": 3227.1,
        "doubleCheck": true
    },
    {
        "dataID": "115966",
        "id": "53085921",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:20",
        "brokerTime": "2025-05-14 14:53:20",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049791",
        "positionId": "56049791",
        "volume": 4.65,
        "price": 3227.12,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3227.12,
        "doubleCheck": true
    },
    {
        "dataID": "115967",
        "id": "53085922",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:20",
        "brokerTime": "2025-05-14 14:53:21",
        "commission": -32.55,
        "swap": 0,
        "profit": -97.65,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049792",
        "positionId": "56049791",
        "volume": 4.65,
        "price": 3227.33,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -130.2,
        "priceIn": 3227.12,
        "doubleCheck": true
    },
    {
        "dataID": "115968",
        "id": "53085923",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:21",
        "brokerTime": "2025-05-14 14:53:21",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049793",
        "positionId": "56049793",
        "volume": 4.65,
        "price": 3227.12,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3227.12,
        "doubleCheck": true
    },
    {
        "dataID": "115969",
        "id": "53085924",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:21",
        "brokerTime": "2025-05-14 14:53:21",
        "commission": -32.55,
        "swap": 0,
        "profit": -74.4,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049794",
        "positionId": "56049793",
        "volume": 4.65,
        "price": 3227.28,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.95,
        "priceIn": 3227.12,
        "doubleCheck": true
    },
    {
        "dataID": "115970",
        "id": "53085925",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:22",
        "brokerTime": "2025-05-14 14:53:22",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049795",
        "positionId": "56049795",
        "volume": 4.65,
        "price": 3227.15,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3227.15,
        "doubleCheck": true
    },
    {
        "dataID": "115971",
        "id": "53085926",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:22",
        "brokerTime": "2025-05-14 14:53:22",
        "commission": -32.55,
        "swap": 0,
        "profit": -60.45,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049796",
        "positionId": "56049795",
        "volume": 4.65,
        "price": 3227.28,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -93,
        "priceIn": 3227.15,
        "doubleCheck": true
    },
    {
        "dataID": "115972",
        "id": "53085927",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:23",
        "brokerTime": "2025-05-14 14:53:23",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049797",
        "positionId": "56049797",
        "volume": 4.65,
        "price": 3227.01,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3227.01,
        "doubleCheck": true
    },
    {
        "dataID": "115973",
        "id": "53085928",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:23",
        "brokerTime": "2025-05-14 14:53:23",
        "commission": -32.55,
        "swap": 0,
        "profit": -65.1,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049798",
        "positionId": "56049797",
        "volume": 4.65,
        "price": 3227.15,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -97.64999999999999,
        "priceIn": 3227.01,
        "doubleCheck": true
    },
    {
        "dataID": "115974",
        "id": "53085929",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:23",
        "brokerTime": "2025-05-14 14:53:23",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049799",
        "positionId": "56049799",
        "volume": 4.65,
        "price": 3226.8,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.8,
        "doubleCheck": true
    },
    {
        "dataID": "115975",
        "id": "53085930",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:23",
        "brokerTime": "2025-05-14 14:53:24",
        "commission": -32.55,
        "swap": 0,
        "profit": -120.9,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049800",
        "positionId": "56049799",
        "volume": 4.65,
        "price": 3227.06,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -153.45,
        "priceIn": 3226.8,
        "doubleCheck": true
    },
    {
        "dataID": "115976",
        "id": "53085931",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:24",
        "brokerTime": "2025-05-14 14:53:24",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049801",
        "positionId": "56049801",
        "volume": 4.65,
        "price": 3226.97,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.97,
        "doubleCheck": true
    },
    {
        "dataID": "115977",
        "id": "53085932",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:24",
        "brokerTime": "2025-05-14 14:53:24",
        "commission": -32.55,
        "swap": 0,
        "profit": -74.4,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049802",
        "positionId": "56049801",
        "volume": 4.65,
        "price": 3227.13,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.95,
        "priceIn": 3226.97,
        "doubleCheck": true
    },
    {
        "dataID": "115978",
        "id": "53085933",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:25",
        "brokerTime": "2025-05-14 14:53:25",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049803",
        "positionId": "56049803",
        "volume": 4.65,
        "price": 3226.95,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.95,
        "doubleCheck": true
    },
    {
        "dataID": "115979",
        "id": "53085934",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:25",
        "brokerTime": "2025-05-14 14:53:25",
        "commission": -32.55,
        "swap": 0,
        "profit": -55.8,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049804",
        "positionId": "56049803",
        "volume": 4.65,
        "price": 3227.07,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.35,
        "priceIn": 3226.95,
        "doubleCheck": true
    },
    {
        "dataID": "115980",
        "id": "53085935",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:26",
        "brokerTime": "2025-05-14 14:53:26",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049805",
        "positionId": "56049805",
        "volume": 4.65,
        "price": 3226.75,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.75,
        "doubleCheck": true
    },
    {
        "dataID": "115981",
        "id": "53085936",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:26",
        "brokerTime": "2025-05-14 14:53:26",
        "commission": -32.55,
        "swap": 0,
        "profit": -102.3,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049806",
        "positionId": "56049805",
        "volume": 4.65,
        "price": 3226.97,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -134.85,
        "priceIn": 3226.75,
        "doubleCheck": true
    },
    {
        "dataID": "115982",
        "id": "53085937",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:26",
        "brokerTime": "2025-05-14 14:53:26",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049807",
        "positionId": "56049807",
        "volume": 4.65,
        "price": 3226.78,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.78,
        "doubleCheck": true
    },
    {
        "dataID": "115983",
        "id": "53085938",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:26",
        "brokerTime": "2025-05-14 14:53:27",
        "commission": -32.55,
        "swap": 0,
        "profit": -130.2,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049808",
        "positionId": "56049807",
        "volume": 4.65,
        "price": 3227.06,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -162.75,
        "priceIn": 3226.78,
        "doubleCheck": true
    },
    {
        "dataID": "115984",
        "id": "53085939",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:27",
        "brokerTime": "2025-05-14 14:53:27",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049809",
        "positionId": "56049809",
        "volume": 4.65,
        "price": 3226.75,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.75,
        "doubleCheck": true
    },
    {
        "dataID": "115985",
        "id": "53085940",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:27",
        "brokerTime": "2025-05-14 14:53:28",
        "commission": -32.55,
        "swap": 0,
        "profit": -27.9,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049810",
        "positionId": "56049809",
        "volume": 4.65,
        "price": 3226.81,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -60.449999999999996,
        "priceIn": 3226.75,
        "doubleCheck": true
    },
    {
        "dataID": "115986",
        "id": "53085941",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:28",
        "brokerTime": "2025-05-14 14:53:28",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049811",
        "positionId": "56049811",
        "volume": 4.65,
        "price": 3226.89,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.89,
        "doubleCheck": true
    },
    {
        "dataID": "115987",
        "id": "53085942",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:28",
        "brokerTime": "2025-05-14 14:53:29",
        "commission": -32.55,
        "swap": 0,
        "profit": -111.6,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049812",
        "positionId": "56049811",
        "volume": 4.65,
        "price": 3227.13,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -144.14999999999998,
        "priceIn": 3226.89,
        "doubleCheck": true
    },
    {
        "dataID": "115988",
        "id": "53085943",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:29",
        "brokerTime": "2025-05-14 14:53:29",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049813",
        "positionId": "56049813",
        "volume": 4.65,
        "price": 3226.95,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.95,
        "doubleCheck": true
    },
    {
        "dataID": "115989",
        "id": "53085946",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:29",
        "brokerTime": "2025-05-14 14:53:30",
        "commission": -32.55,
        "swap": 0,
        "profit": -83.7,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049815",
        "positionId": "56049813",
        "volume": 4.65,
        "price": 3227.13,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -116.25,
        "priceIn": 3226.95,
        "doubleCheck": true
    },
    {
        "dataID": "115990",
        "id": "53085947",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:30",
        "brokerTime": "2025-05-14 14:53:30",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049816",
        "positionId": "56049816",
        "volume": 4.65,
        "price": 3226.95,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.95,
        "doubleCheck": true
    },
    {
        "dataID": "115991",
        "id": "53085949",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:30",
        "brokerTime": "2025-05-14 14:53:31",
        "commission": -32.55,
        "swap": 0,
        "profit": -148.8,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049818",
        "positionId": "56049816",
        "volume": 4.65,
        "price": 3227.27,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -181.35000000000002,
        "priceIn": 3226.95,
        "doubleCheck": true
    },
    {
        "dataID": "115992",
        "id": "53085950",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:31",
        "brokerTime": "2025-05-14 14:53:31",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049819",
        "positionId": "56049819",
        "volume": 4.65,
        "price": 3227.02,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3227.02,
        "doubleCheck": true
    },
    {
        "dataID": "115993",
        "id": "53085951",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:31",
        "brokerTime": "2025-05-14 14:53:32",
        "commission": -32.55,
        "swap": 0,
        "profit": 74.4,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049820",
        "positionId": "56049819",
        "volume": 4.65,
        "price": 3226.86,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 41.85000000000001,
        "priceIn": 3227.02,
        "doubleCheck": true
    },
    {
        "dataID": "115994",
        "id": "53085952",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:32",
        "brokerTime": "2025-05-14 14:53:32",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049821",
        "positionId": "56049821",
        "volume": 4.65,
        "price": 3226.58,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.58,
        "doubleCheck": true
    },
    {
        "dataID": "115995",
        "id": "53085953",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:32",
        "brokerTime": "2025-05-14 14:53:32",
        "commission": -32.55,
        "swap": 0,
        "profit": -74.4,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049822",
        "positionId": "56049821",
        "volume": 4.65,
        "price": 3226.74,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.95,
        "priceIn": 3226.58,
        "doubleCheck": true
    },
    {
        "dataID": "115996",
        "id": "53085954",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:33",
        "brokerTime": "2025-05-14 14:53:33",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049823",
        "positionId": "56049823",
        "volume": 4.65,
        "price": 3226.48,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.48,
        "doubleCheck": true
    },
    {
        "dataID": "115997",
        "id": "53085955",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:33",
        "brokerTime": "2025-05-14 14:53:33",
        "commission": -32.55,
        "swap": 0,
        "profit": -148.8,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049824",
        "positionId": "56049823",
        "volume": 4.65,
        "price": 3226.8,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -181.35000000000002,
        "priceIn": 3226.48,
        "doubleCheck": true
    },
    {
        "dataID": "115998",
        "id": "53085956",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:34",
        "brokerTime": "2025-05-14 14:53:34",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049825",
        "positionId": "56049825",
        "volume": 4.65,
        "price": 3226.75,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.75,
        "doubleCheck": true
    },
    {
        "dataID": "115999",
        "id": "53085957",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:34",
        "brokerTime": "2025-05-14 14:53:34",
        "commission": -32.55,
        "swap": 0,
        "profit": -83.7,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049826",
        "positionId": "56049825",
        "volume": 4.65,
        "price": 3226.93,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -116.25,
        "priceIn": 3226.75,
        "doubleCheck": true
    },
    {
        "dataID": "116000",
        "id": "53085958",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:35",
        "brokerTime": "2025-05-14 14:53:35",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049827",
        "positionId": "56049827",
        "volume": 4.65,
        "price": 3226.56,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.56,
        "doubleCheck": true
    },
    {
        "dataID": "116001",
        "id": "53085959",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:35",
        "brokerTime": "2025-05-14 14:53:35",
        "commission": -32.55,
        "swap": 0,
        "profit": -74.4,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049828",
        "positionId": "56049827",
        "volume": 4.65,
        "price": 3226.72,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.95,
        "priceIn": 3226.56,
        "doubleCheck": true
    },
    {
        "dataID": "116002",
        "id": "53085960",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:36",
        "brokerTime": "2025-05-14 14:53:36",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049829",
        "positionId": "56049829",
        "volume": 4.65,
        "price": 3226.52,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.52,
        "doubleCheck": true
    },
    {
        "dataID": "116003",
        "id": "53085961",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:36",
        "brokerTime": "2025-05-14 14:53:37",
        "commission": -32.55,
        "swap": 0,
        "profit": -176.7,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049830",
        "positionId": "56049829",
        "volume": 4.65,
        "price": 3226.9,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -209.25,
        "priceIn": 3226.52,
        "doubleCheck": true
    },
    {
        "dataID": "116004",
        "id": "53085962",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:37",
        "brokerTime": "2025-05-14 14:53:37",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049831",
        "positionId": "56049831",
        "volume": 4.65,
        "price": 3226.72,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.72,
        "doubleCheck": true
    },
    {
        "dataID": "116005",
        "id": "53085963",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:37",
        "brokerTime": "2025-05-14 14:53:38",
        "commission": -32.55,
        "swap": 0,
        "profit": -60.45,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049832",
        "positionId": "56049831",
        "volume": 4.65,
        "price": 3226.85,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -93,
        "priceIn": 3226.72,
        "doubleCheck": true
    },
    {
        "dataID": "116006",
        "id": "53085964",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:38",
        "brokerTime": "2025-05-14 14:53:38",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049833",
        "positionId": "56049833",
        "volume": 4.65,
        "price": 3226.73,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.73,
        "doubleCheck": true
    },
    {
        "dataID": "116007",
        "id": "53085965",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:38",
        "brokerTime": "2025-05-14 14:53:39",
        "commission": -32.55,
        "swap": 0,
        "profit": -83.7,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049834",
        "positionId": "56049833",
        "volume": 4.65,
        "price": 3226.91,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -116.25,
        "priceIn": 3226.73,
        "doubleCheck": true
    },
    {
        "dataID": "116008",
        "id": "53085966",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:39",
        "brokerTime": "2025-05-14 14:53:39",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049835",
        "positionId": "56049835",
        "volume": 4.65,
        "price": 3226.73,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.73,
        "doubleCheck": true
    },
    {
        "dataID": "116009",
        "id": "53085967",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:39",
        "brokerTime": "2025-05-14 14:53:39",
        "commission": -32.55,
        "swap": 0,
        "profit": -83.7,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049836",
        "positionId": "56049835",
        "volume": 4.65,
        "price": 3226.91,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -116.25,
        "priceIn": 3226.73,
        "doubleCheck": true
    },
    {
        "dataID": "116010",
        "id": "53085968",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:40",
        "brokerTime": "2025-05-14 14:53:40",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049837",
        "positionId": "56049837",
        "volume": 4.65,
        "price": 3226.64,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.64,
        "doubleCheck": true
    },
    {
        "dataID": "116011",
        "id": "53085969",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:40",
        "brokerTime": "2025-05-14 14:53:40",
        "commission": -32.55,
        "swap": 0,
        "profit": -125.55,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049838",
        "positionId": "56049837",
        "volume": 4.65,
        "price": 3226.91,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -158.1,
        "priceIn": 3226.64,
        "doubleCheck": true
    },
    {
        "dataID": "116012",
        "id": "53085970",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:40",
        "brokerTime": "2025-05-14 14:53:40",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049839",
        "positionId": "56049839",
        "volume": 4.65,
        "price": 3226.71,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.71,
        "doubleCheck": true
    },
    {
        "dataID": "116013",
        "id": "53085971",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:40",
        "brokerTime": "2025-05-14 14:53:41",
        "commission": -32.55,
        "swap": 0,
        "profit": -69.75,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049840",
        "positionId": "56049839",
        "volume": 4.65,
        "price": 3226.86,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -102.3,
        "priceIn": 3226.71,
        "doubleCheck": true
    },
    {
        "dataID": "116014",
        "id": "53085972",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:41",
        "brokerTime": "2025-05-14 14:53:41",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049841",
        "positionId": "56049841",
        "volume": 4.65,
        "price": 3226.61,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.61,
        "doubleCheck": true
    },
    {
        "dataID": "116015",
        "id": "53085973",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:41",
        "brokerTime": "2025-05-14 14:53:42",
        "commission": -32.55,
        "swap": 0,
        "profit": -125.55,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049842",
        "positionId": "56049841",
        "volume": 4.65,
        "price": 3226.88,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -158.1,
        "priceIn": 3226.61,
        "doubleCheck": true
    },
    {
        "dataID": "116016",
        "id": "53085974",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:42",
        "brokerTime": "2025-05-14 14:53:42",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049843",
        "positionId": "56049843",
        "volume": 4.65,
        "price": 3226.87,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.87,
        "doubleCheck": true
    },
    {
        "dataID": "116017",
        "id": "53085975",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:42",
        "brokerTime": "2025-05-14 14:53:42",
        "commission": -32.55,
        "swap": 0,
        "profit": -88.35,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049844",
        "positionId": "56049843",
        "volume": 4.65,
        "price": 3227.06,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -120.89999999999999,
        "priceIn": 3226.87,
        "doubleCheck": true
    },
    {
        "dataID": "116018",
        "id": "53085976",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:43",
        "brokerTime": "2025-05-14 14:53:43",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049845",
        "positionId": "56049845",
        "volume": 4.65,
        "price": 3226.86,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.86,
        "doubleCheck": true
    },
    {
        "dataID": "116019",
        "id": "53085977",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:43",
        "brokerTime": "2025-05-14 14:53:43",
        "commission": -32.55,
        "swap": 0,
        "profit": -93,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049846",
        "positionId": "56049845",
        "volume": 4.65,
        "price": 3227.06,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -125.55,
        "priceIn": 3226.86,
        "doubleCheck": true
    },
    {
        "dataID": "116020",
        "id": "53085978",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:44",
        "brokerTime": "2025-05-14 14:53:44",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049847",
        "positionId": "56049847",
        "volume": 4.65,
        "price": 3226.91,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.91,
        "doubleCheck": true
    },
    {
        "dataID": "116021",
        "id": "53085979",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:44",
        "brokerTime": "2025-05-14 14:53:45",
        "commission": -32.55,
        "swap": 0,
        "profit": -27.9,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049848",
        "positionId": "56049847",
        "volume": 4.65,
        "price": 3226.97,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -60.449999999999996,
        "priceIn": 3226.91,
        "doubleCheck": true
    },
    {
        "dataID": "116022",
        "id": "53085980",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:45",
        "brokerTime": "2025-05-14 14:53:45",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049849",
        "positionId": "56049849",
        "volume": 4.65,
        "price": 3226.77,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.77,
        "doubleCheck": true
    },
    {
        "dataID": "116023",
        "id": "53085981",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:45",
        "brokerTime": "2025-05-14 14:53:46",
        "commission": -32.55,
        "swap": 0,
        "profit": -88.35,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049850",
        "positionId": "56049849",
        "volume": 4.65,
        "price": 3226.96,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -120.89999999999999,
        "priceIn": 3226.77,
        "doubleCheck": true
    },
    {
        "dataID": "116024",
        "id": "53085982",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:46",
        "brokerTime": "2025-05-14 14:53:46",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049851",
        "positionId": "56049851",
        "volume": 4.65,
        "price": 3226.79,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.79,
        "doubleCheck": true
    },
    {
        "dataID": "116025",
        "id": "53085983",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:46",
        "brokerTime": "2025-05-14 14:53:46",
        "commission": -32.55,
        "swap": 0,
        "profit": -65.1,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049852",
        "positionId": "56049851",
        "volume": 4.65,
        "price": 3226.93,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -97.64999999999999,
        "priceIn": 3226.79,
        "doubleCheck": true
    },
    {
        "dataID": "116026",
        "id": "53085984",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:47",
        "brokerTime": "2025-05-14 14:53:47",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049853",
        "positionId": "56049853",
        "volume": 4.65,
        "price": 3226.76,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.76,
        "doubleCheck": true
    },
    {
        "dataID": "116027",
        "id": "53085986",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:47",
        "brokerTime": "2025-05-14 14:53:47",
        "commission": -32.55,
        "swap": 0,
        "profit": -93,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049855",
        "positionId": "56049853",
        "volume": 4.65,
        "price": 3226.96,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -125.55,
        "priceIn": 3226.76,
        "doubleCheck": true
    },
    {
        "dataID": "116028",
        "id": "53085987",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:49",
        "brokerTime": "2025-05-14 14:53:49",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049856",
        "positionId": "56049856",
        "volume": 4.65,
        "price": 3226.81,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.81,
        "doubleCheck": true
    },
    {
        "dataID": "116029",
        "id": "53085988",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:49",
        "brokerTime": "2025-05-14 14:53:49",
        "commission": -32.55,
        "swap": 0,
        "profit": -37.2,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049857",
        "positionId": "56049856",
        "volume": 4.65,
        "price": 3226.89,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.75,
        "priceIn": 3226.81,
        "doubleCheck": true
    },
    {
        "dataID": "116030",
        "id": "53085989",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:50",
        "brokerTime": "2025-05-14 14:53:50",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049858",
        "positionId": "56049858",
        "volume": 4.65,
        "price": 3226.78,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.78,
        "doubleCheck": true
    },
    {
        "dataID": "116031",
        "id": "53085990",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:50",
        "brokerTime": "2025-05-14 14:53:50",
        "commission": -32.55,
        "swap": 0,
        "profit": -79.05,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049859",
        "positionId": "56049858",
        "volume": 4.65,
        "price": 3226.95,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -111.6,
        "priceIn": 3226.78,
        "doubleCheck": true
    },
    {
        "dataID": "116032",
        "id": "53085991",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:51",
        "brokerTime": "2025-05-14 14:53:51",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049860",
        "positionId": "56049860",
        "volume": 4.65,
        "price": 3226.78,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.78,
        "doubleCheck": true
    },
    {
        "dataID": "116033",
        "id": "53085992",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:51",
        "brokerTime": "2025-05-14 14:53:51",
        "commission": -32.55,
        "swap": 0,
        "profit": -97.65,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049861",
        "positionId": "56049860",
        "volume": 4.65,
        "price": 3226.99,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -130.2,
        "priceIn": 3226.78,
        "doubleCheck": true
    },
    {
        "dataID": "116034",
        "id": "53085993",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:52",
        "brokerTime": "2025-05-14 14:53:52",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049862",
        "positionId": "56049862",
        "volume": 4.65,
        "price": 3226.9,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.9,
        "doubleCheck": true
    },
    {
        "dataID": "116035",
        "id": "53085994",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:52",
        "brokerTime": "2025-05-14 14:53:53",
        "commission": -32.55,
        "swap": 0,
        "profit": -120.9,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049863",
        "positionId": "56049862",
        "volume": 4.65,
        "price": 3227.16,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -153.45,
        "priceIn": 3226.9,
        "doubleCheck": true
    },
    {
        "dataID": "116036",
        "id": "53085995",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:53",
        "brokerTime": "2025-05-14 14:53:53",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049864",
        "positionId": "56049864",
        "volume": 4.65,
        "price": 3227,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3227,
        "doubleCheck": true
    },
    {
        "dataID": "116037",
        "id": "53085996",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:53",
        "brokerTime": "2025-05-14 14:53:54",
        "commission": -32.55,
        "swap": 0,
        "profit": -162.75,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049866",
        "positionId": "56049864",
        "volume": 4.65,
        "price": 3227.35,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -195.3,
        "priceIn": 3227,
        "doubleCheck": true
    },
    {
        "dataID": "116038",
        "id": "53085998",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:56",
        "brokerTime": "2025-05-14 14:53:56",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049868",
        "positionId": "56049868",
        "volume": 4.65,
        "price": 3227.2,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3227.2,
        "doubleCheck": true
    },
    {
        "dataID": "116039",
        "id": "53086001",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:56",
        "brokerTime": "2025-05-14 14:53:57",
        "commission": -32.55,
        "swap": 0,
        "profit": -65.1,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049871",
        "positionId": "56049868",
        "volume": 4.65,
        "price": 3227.34,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -97.64999999999999,
        "priceIn": 3227.2,
        "doubleCheck": true
    },
    {
        "dataID": "116040",
        "id": "53086002",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:57",
        "brokerTime": "2025-05-14 14:53:57",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049873",
        "positionId": "56049873",
        "volume": 4.65,
        "price": 3227.28,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3227.28,
        "doubleCheck": true
    },
    {
        "dataID": "116041",
        "id": "53086004",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:57",
        "brokerTime": "2025-05-14 14:53:57",
        "commission": -32.55,
        "swap": 0,
        "profit": -69.75,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049874",
        "positionId": "56049873",
        "volume": 4.65,
        "price": 3227.43,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -102.3,
        "priceIn": 3227.28,
        "doubleCheck": true
    },
    {
        "dataID": "116042",
        "id": "53086006",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:58",
        "brokerTime": "2025-05-14 14:53:58",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049876",
        "positionId": "56049876",
        "volume": 4.65,
        "price": 3227.26,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3227.26,
        "doubleCheck": true
    },
    {
        "dataID": "116043",
        "id": "53086007",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:58",
        "brokerTime": "2025-05-14 14:53:58",
        "commission": -32.55,
        "swap": 0,
        "profit": -93,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049877",
        "positionId": "56049876",
        "volume": 4.65,
        "price": 3227.46,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -125.55,
        "priceIn": 3227.26,
        "doubleCheck": true
    },
    {
        "dataID": "116044",
        "id": "53086008",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:58",
        "brokerTime": "2025-05-14 14:53:58",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049878",
        "positionId": "56049878",
        "volume": 4.65,
        "price": 3227.28,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3227.28,
        "doubleCheck": true
    },
    {
        "dataID": "116045",
        "id": "53086009",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:58",
        "brokerTime": "2025-05-14 14:53:59",
        "commission": -32.55,
        "swap": 0,
        "profit": -74.4,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049879",
        "positionId": "56049878",
        "volume": 4.65,
        "price": 3227.44,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.95,
        "priceIn": 3227.28,
        "doubleCheck": true
    },
    {
        "dataID": "116046",
        "id": "53086010",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:00",
        "brokerTime": "2025-05-14 14:54:00",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049880",
        "positionId": "56049880",
        "volume": 4.65,
        "price": 3227.33,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3227.33,
        "doubleCheck": true
    },
    {
        "dataID": "116047",
        "id": "53086011",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:00",
        "brokerTime": "2025-05-14 14:54:00",
        "commission": -32.55,
        "swap": 0,
        "profit": -93,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049881",
        "positionId": "56049880",
        "volume": 4.65,
        "price": 3227.53,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -125.55,
        "priceIn": 3227.33,
        "doubleCheck": true
    },
    {
        "dataID": "116048",
        "id": "53086012",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:00",
        "brokerTime": "2025-05-14 14:54:00",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049882",
        "positionId": "56049882",
        "volume": 4.65,
        "price": 3227.35,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3227.35,
        "doubleCheck": true
    },
    {
        "dataID": "116049",
        "id": "53086013",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:00",
        "brokerTime": "2025-05-14 14:54:00",
        "commission": -32.55,
        "swap": 0,
        "profit": -139.5,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049883",
        "positionId": "56049882",
        "volume": 4.65,
        "price": 3227.65,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -172.05,
        "priceIn": 3227.35,
        "doubleCheck": true
    },
    {
        "dataID": "116050",
        "id": "53086016",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:01",
        "brokerTime": "2025-05-14 14:54:01",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049886",
        "positionId": "56049886",
        "volume": 4.65,
        "price": 3227.01,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3227.01,
        "doubleCheck": true
    },
    {
        "dataID": "116051",
        "id": "53086017",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:01",
        "brokerTime": "2025-05-14 14:54:02",
        "commission": -32.55,
        "swap": 0,
        "profit": 176.7,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049887",
        "positionId": "56049886",
        "volume": 4.65,
        "price": 3226.63,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 144.14999999999998,
        "priceIn": 3227.01,
        "doubleCheck": true
    },
    {
        "dataID": "116052",
        "id": "53086018",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:02",
        "brokerTime": "2025-05-14 14:54:02",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049888",
        "positionId": "56049888",
        "volume": 4.65,
        "price": 3226.21,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.21,
        "doubleCheck": true
    },
    {
        "dataID": "116053",
        "id": "53086019",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:02",
        "brokerTime": "2025-05-14 14:54:03",
        "commission": -32.55,
        "swap": 0,
        "profit": -46.5,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049889",
        "positionId": "56049888",
        "volume": 4.65,
        "price": 3226.31,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -79.05,
        "priceIn": 3226.21,
        "doubleCheck": true
    },
    {
        "dataID": "116054",
        "id": "53086020",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:03",
        "brokerTime": "2025-05-14 14:54:03",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049890",
        "positionId": "56049890",
        "volume": 4.65,
        "price": 3226.12,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.12,
        "doubleCheck": true
    },
    {
        "dataID": "116055",
        "id": "53086021",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:03",
        "brokerTime": "2025-05-14 14:54:03",
        "commission": -32.55,
        "swap": 0,
        "profit": -102.3,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049891",
        "positionId": "56049890",
        "volume": 4.65,
        "price": 3226.34,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -134.85,
        "priceIn": 3226.12,
        "doubleCheck": true
    },
    {
        "dataID": "116056",
        "id": "53086022",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:04",
        "brokerTime": "2025-05-14 14:54:04",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049892",
        "positionId": "56049892",
        "volume": 4.65,
        "price": 3226.41,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.41,
        "doubleCheck": true
    },
    {
        "dataID": "116057",
        "id": "53086023",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:04",
        "brokerTime": "2025-05-14 14:54:04",
        "commission": -32.55,
        "swap": 0,
        "profit": -134.85,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049893",
        "positionId": "56049892",
        "volume": 4.65,
        "price": 3226.7,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -167.39999999999998,
        "priceIn": 3226.41,
        "doubleCheck": true
    },
    {
        "dataID": "116058",
        "id": "53086024",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:05",
        "brokerTime": "2025-05-14 14:54:05",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049894",
        "positionId": "56049894",
        "volume": 4.65,
        "price": 3226.29,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.29,
        "doubleCheck": true
    },
    {
        "dataID": "116059",
        "id": "53086025",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:05",
        "brokerTime": "2025-05-14 14:54:05",
        "commission": -32.55,
        "swap": 0,
        "profit": -144.15,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049895",
        "positionId": "56049894",
        "volume": 4.65,
        "price": 3226.6,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -176.7,
        "priceIn": 3226.29,
        "doubleCheck": true
    },
    {
        "dataID": "116060",
        "id": "53086026",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:05",
        "brokerTime": "2025-05-14 14:54:05",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049896",
        "positionId": "56049896",
        "volume": 4.65,
        "price": 3226.4,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.4,
        "doubleCheck": true
    },
    {
        "dataID": "116061",
        "id": "53086027",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:05",
        "brokerTime": "2025-05-14 14:54:06",
        "commission": -32.55,
        "swap": 0,
        "profit": -111.6,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049897",
        "positionId": "56049896",
        "volume": 4.65,
        "price": 3226.64,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -144.14999999999998,
        "priceIn": 3226.4,
        "doubleCheck": true
    },
    {
        "dataID": "116062",
        "id": "53086028",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:07",
        "brokerTime": "2025-05-14 14:54:07",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049898",
        "positionId": "56049898",
        "volume": 4.65,
        "price": 3226.47,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.47,
        "doubleCheck": true
    },
    {
        "dataID": "116063",
        "id": "53086029",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:07",
        "brokerTime": "2025-05-14 14:54:07",
        "commission": -32.55,
        "swap": 0,
        "profit": -97.65,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049899",
        "positionId": "56049898",
        "volume": 4.65,
        "price": 3226.68,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -130.2,
        "priceIn": 3226.47,
        "doubleCheck": true
    },
    {
        "dataID": "116064",
        "id": "53086030",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:08",
        "brokerTime": "2025-05-14 14:54:08",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049900",
        "positionId": "56049900",
        "volume": 4.65,
        "price": 3226.59,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.59,
        "doubleCheck": true
    },
    {
        "dataID": "116065",
        "id": "53086031",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:08",
        "brokerTime": "2025-05-14 14:54:08",
        "commission": -32.55,
        "swap": 0,
        "profit": -116.25,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049901",
        "positionId": "56049900",
        "volume": 4.65,
        "price": 3226.84,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -148.8,
        "priceIn": 3226.59,
        "doubleCheck": true
    },
    {
        "dataID": "116066",
        "id": "53086032",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:09",
        "brokerTime": "2025-05-14 14:54:09",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049902",
        "positionId": "56049902",
        "volume": 4.65,
        "price": 3226.6,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.6,
        "doubleCheck": true
    },
    {
        "dataID": "116067",
        "id": "53086033",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:09",
        "brokerTime": "2025-05-14 14:54:10",
        "commission": -32.55,
        "swap": 0,
        "profit": -88.35,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049903",
        "positionId": "56049902",
        "volume": 4.65,
        "price": 3226.79,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -120.89999999999999,
        "priceIn": 3226.6,
        "doubleCheck": true
    },
    {
        "dataID": "116068",
        "id": "53086034",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:10",
        "brokerTime": "2025-05-14 14:54:10",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049904",
        "positionId": "56049904",
        "volume": 4.65,
        "price": 3226.54,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.54,
        "doubleCheck": true
    },
    {
        "dataID": "116069",
        "id": "53086035",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:10",
        "brokerTime": "2025-05-14 14:54:10",
        "commission": -32.55,
        "swap": 0,
        "profit": -116.25,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049905",
        "positionId": "56049904",
        "volume": 4.65,
        "price": 3226.79,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -148.8,
        "priceIn": 3226.54,
        "doubleCheck": true
    },
    {
        "dataID": "116070",
        "id": "53086036",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:10",
        "brokerTime": "2025-05-14 14:54:10",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049906",
        "positionId": "56049906",
        "volume": 4.65,
        "price": 3226.58,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.58,
        "doubleCheck": true
    },
    {
        "dataID": "116071",
        "id": "53086037",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:10",
        "brokerTime": "2025-05-14 14:54:11",
        "commission": -32.55,
        "swap": 0,
        "profit": -93,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049907",
        "positionId": "56049906",
        "volume": 4.65,
        "price": 3226.78,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -125.55,
        "priceIn": 3226.58,
        "doubleCheck": true
    },
    {
        "dataID": "116072",
        "id": "53086038",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:11",
        "brokerTime": "2025-05-14 14:54:11",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049908",
        "positionId": "56049908",
        "volume": 4.65,
        "price": 3226.62,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.62,
        "doubleCheck": true
    },
    {
        "dataID": "116073",
        "id": "53086039",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:11",
        "brokerTime": "2025-05-14 14:54:11",
        "commission": -32.55,
        "swap": 0,
        "profit": 41.85,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049909",
        "positionId": "56049908",
        "volume": 4.65,
        "price": 3226.53,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 9.300000000000004,
        "priceIn": 3226.62,
        "doubleCheck": true
    },
    {
        "dataID": "116074",
        "id": "53086040",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:12",
        "brokerTime": "2025-05-14 14:54:12",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049910",
        "positionId": "56049910",
        "volume": 4.65,
        "price": 3226.33,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.33,
        "doubleCheck": true
    },
    {
        "dataID": "116075",
        "id": "53086041",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:12",
        "brokerTime": "2025-05-14 14:54:12",
        "commission": -32.55,
        "swap": 0,
        "profit": -181.35,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049911",
        "positionId": "56049910",
        "volume": 4.65,
        "price": 3226.72,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -213.89999999999998,
        "priceIn": 3226.33,
        "doubleCheck": true
    },
    {
        "dataID": "116076",
        "id": "53086042",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:12",
        "brokerTime": "2025-05-14 14:54:12",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049912",
        "positionId": "56049912",
        "volume": 4.65,
        "price": 3226.61,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.61,
        "doubleCheck": true
    },
    {
        "dataID": "116077",
        "id": "53086046",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:12",
        "brokerTime": "2025-05-14 14:54:14",
        "commission": -32.55,
        "swap": 0,
        "profit": -134.85,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049916",
        "positionId": "56049912",
        "volume": 4.65,
        "price": 3226.9,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -167.39999999999998,
        "priceIn": 3226.61,
        "doubleCheck": true
    },
    {
        "dataID": "116078",
        "id": "53086051",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:15",
        "brokerTime": "2025-05-14 14:54:15",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049921",
        "positionId": "56049921",
        "volume": 4.65,
        "price": 3226.78,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.78,
        "doubleCheck": true
    },
    {
        "dataID": "116079",
        "id": "53086053",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:15",
        "brokerTime": "2025-05-14 14:54:16",
        "commission": -32.55,
        "swap": 0,
        "profit": -125.55,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049923",
        "positionId": "56049921",
        "volume": 4.65,
        "price": 3227.05,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -158.1,
        "priceIn": 3226.78,
        "doubleCheck": true
    },
    {
        "dataID": "116080",
        "id": "53086055",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:16",
        "brokerTime": "2025-05-14 14:54:16",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049925",
        "positionId": "56049925",
        "volume": 4.65,
        "price": 3226.82,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.82,
        "doubleCheck": true
    },
    {
        "dataID": "116081",
        "id": "53086056",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:16",
        "brokerTime": "2025-05-14 14:54:16",
        "commission": -32.55,
        "swap": 0,
        "profit": -116.25,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049926",
        "positionId": "56049925",
        "volume": 4.65,
        "price": 3227.07,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -148.8,
        "priceIn": 3226.82,
        "doubleCheck": true
    },
    {
        "dataID": "116082",
        "id": "53086058",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:17",
        "brokerTime": "2025-05-14 14:54:17",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049929",
        "positionId": "56049929",
        "volume": 4.65,
        "price": 3226.84,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.84,
        "doubleCheck": true
    },
    {
        "dataID": "116083",
        "id": "53086060",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:17",
        "brokerTime": "2025-05-14 14:54:18",
        "commission": -32.55,
        "swap": 0,
        "profit": -65.1,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049931",
        "positionId": "56049929",
        "volume": 4.65,
        "price": 3226.98,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -97.64999999999999,
        "priceIn": 3226.84,
        "doubleCheck": true
    },
    {
        "dataID": "116084",
        "id": "53086061",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:18",
        "brokerTime": "2025-05-14 14:54:18",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049932",
        "positionId": "56049932",
        "volume": 4.65,
        "price": 3226.97,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.97,
        "doubleCheck": true
    },
    {
        "dataID": "116085",
        "id": "53086062",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:18",
        "brokerTime": "2025-05-14 14:54:19",
        "commission": -32.55,
        "swap": 0,
        "profit": -93,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049933",
        "positionId": "56049932",
        "volume": 4.65,
        "price": 3227.17,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -125.55,
        "priceIn": 3226.97,
        "doubleCheck": true
    },
    {
        "dataID": "116086",
        "id": "53086063",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:20",
        "brokerTime": "2025-05-14 14:54:20",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049934",
        "positionId": "56049934",
        "volume": 4.65,
        "price": 3226.83,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.83,
        "doubleCheck": true
    },
    {
        "dataID": "116087",
        "id": "53086064",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:20",
        "brokerTime": "2025-05-14 14:54:20",
        "commission": -32.55,
        "swap": 0,
        "profit": -130.2,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049935",
        "positionId": "56049934",
        "volume": 4.65,
        "price": 3227.11,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -162.75,
        "priceIn": 3226.83,
        "doubleCheck": true
    },
    {
        "dataID": "116088",
        "id": "53086065",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:20",
        "brokerTime": "2025-05-14 14:54:20",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049936",
        "positionId": "56049936",
        "volume": 4.65,
        "price": 3226.87,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.87,
        "doubleCheck": true
    },
    {
        "dataID": "116089",
        "id": "53086066",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:20",
        "brokerTime": "2025-05-14 14:54:22",
        "commission": -32.55,
        "swap": 0,
        "profit": -51.15,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049937",
        "positionId": "56049936",
        "volume": 4.65,
        "price": 3226.98,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -83.69999999999999,
        "priceIn": 3226.87,
        "doubleCheck": true
    },
    {
        "dataID": "116090",
        "id": "53086067",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:23",
        "brokerTime": "2025-05-14 14:54:23",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049938",
        "positionId": "56049938",
        "volume": 4.65,
        "price": 3226.84,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.84,
        "doubleCheck": true
    },
    {
        "dataID": "116091",
        "id": "53086068",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:23",
        "brokerTime": "2025-05-14 14:54:23",
        "commission": -32.55,
        "swap": 0,
        "profit": -199.95,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049939",
        "positionId": "56049938",
        "volume": 4.65,
        "price": 3227.27,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -232.5,
        "priceIn": 3226.84,
        "doubleCheck": true
    },
    {
        "dataID": "116092",
        "id": "53086069",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:24",
        "brokerTime": "2025-05-14 14:54:24",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049940",
        "positionId": "56049940",
        "volume": 4.65,
        "price": 3227.07,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3227.07,
        "doubleCheck": true
    },
    {
        "dataID": "116093",
        "id": "53086070",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:24",
        "brokerTime": "2025-05-14 14:54:25",
        "commission": -32.55,
        "swap": 0,
        "profit": -74.4,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049941",
        "positionId": "56049940",
        "volume": 4.65,
        "price": 3227.23,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.95,
        "priceIn": 3227.07,
        "doubleCheck": true
    },
    {
        "dataID": "116094",
        "id": "53086071",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:25",
        "brokerTime": "2025-05-14 14:54:25",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049942",
        "positionId": "56049942",
        "volume": 4.65,
        "price": 3227,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3227,
        "doubleCheck": true
    },
    {
        "dataID": "116095",
        "id": "53086072",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:25",
        "brokerTime": "2025-05-14 14:54:25",
        "commission": -32.55,
        "swap": 0,
        "profit": -83.7,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049945",
        "positionId": "56049942",
        "volume": 4.65,
        "price": 3227.18,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -116.25,
        "priceIn": 3227,
        "doubleCheck": true
    },
    {
        "dataID": "116096",
        "id": "53086074",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:27",
        "brokerTime": "2025-05-14 14:54:27",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049946",
        "positionId": "56049946",
        "volume": 4.65,
        "price": 3227.02,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3227.02,
        "doubleCheck": true
    },
    {
        "dataID": "116097",
        "id": "53086075",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:27",
        "brokerTime": "2025-05-14 14:54:28",
        "commission": -32.55,
        "swap": 0,
        "profit": -65.1,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049947",
        "positionId": "56049946",
        "volume": 4.65,
        "price": 3227.16,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -97.64999999999999,
        "priceIn": 3227.02,
        "doubleCheck": true
    },
    {
        "dataID": "116098",
        "id": "53086076",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:28",
        "brokerTime": "2025-05-14 14:54:28",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049948",
        "positionId": "56049948",
        "volume": 4.65,
        "price": 3226.98,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.98,
        "doubleCheck": true
    },
    {
        "dataID": "116099",
        "id": "53086077",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:28",
        "brokerTime": "2025-05-14 14:54:29",
        "commission": -32.55,
        "swap": 0,
        "profit": -120.9,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049949",
        "positionId": "56049948",
        "volume": 4.65,
        "price": 3227.24,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -153.45,
        "priceIn": 3226.98,
        "doubleCheck": true
    },
    {
        "dataID": "116100",
        "id": "53086078",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:29",
        "brokerTime": "2025-05-14 14:54:29",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049950",
        "positionId": "56049950",
        "volume": 4.65,
        "price": 3227.02,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3227.02,
        "doubleCheck": true
    },
    {
        "dataID": "116101",
        "id": "53086079",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:29",
        "brokerTime": "2025-05-14 14:54:29",
        "commission": -32.55,
        "swap": 0,
        "profit": 41.85,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049951",
        "positionId": "56049950",
        "volume": 4.65,
        "price": 3226.93,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 9.300000000000004,
        "priceIn": 3227.02,
        "doubleCheck": true
    },
    {
        "dataID": "116102",
        "id": "53086080",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:30",
        "brokerTime": "2025-05-14 14:54:30",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049952",
        "positionId": "56049952",
        "volume": 4.65,
        "price": 3226.63,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.63,
        "doubleCheck": true
    },
    {
        "dataID": "116103",
        "id": "53086081",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:30",
        "brokerTime": "2025-05-14 14:54:31",
        "commission": -32.55,
        "swap": 0,
        "profit": -83.7,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049953",
        "positionId": "56049952",
        "volume": 4.65,
        "price": 3226.81,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -116.25,
        "priceIn": 3226.63,
        "doubleCheck": true
    },
    {
        "dataID": "116104",
        "id": "53086082",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:31",
        "brokerTime": "2025-05-14 14:54:31",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049954",
        "positionId": "56049954",
        "volume": 4.65,
        "price": 3226.61,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.61,
        "doubleCheck": true
    },
    {
        "dataID": "116105",
        "id": "53086083",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:31",
        "brokerTime": "2025-05-14 14:54:31",
        "commission": -32.55,
        "swap": 0,
        "profit": -93,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049955",
        "positionId": "56049954",
        "volume": 4.65,
        "price": 3226.81,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -125.55,
        "priceIn": 3226.61,
        "doubleCheck": true
    },
    {
        "dataID": "116106",
        "id": "53086084",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:32",
        "brokerTime": "2025-05-14 14:54:32",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049956",
        "positionId": "56049956",
        "volume": 4.65,
        "price": 3226.54,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.54,
        "doubleCheck": true
    },
    {
        "dataID": "116107",
        "id": "53086085",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:32",
        "brokerTime": "2025-05-14 14:54:32",
        "commission": -32.55,
        "swap": 0,
        "profit": -93,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049957",
        "positionId": "56049956",
        "volume": 4.65,
        "price": 3226.74,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -125.55,
        "priceIn": 3226.54,
        "doubleCheck": true
    },
    {
        "dataID": "116108",
        "id": "53086086",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:33",
        "brokerTime": "2025-05-14 14:54:33",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049958",
        "positionId": "56049958",
        "volume": 4.65,
        "price": 3226.61,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.61,
        "doubleCheck": true
    },
    {
        "dataID": "116109",
        "id": "53086087",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:33",
        "brokerTime": "2025-05-14 14:54:33",
        "commission": -32.55,
        "swap": 0,
        "profit": -158.1,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049959",
        "positionId": "56049958",
        "volume": 4.65,
        "price": 3226.95,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -190.64999999999998,
        "priceIn": 3226.61,
        "doubleCheck": true
    },
    {
        "dataID": "116110",
        "id": "53086088",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:33",
        "brokerTime": "2025-05-14 14:54:33",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049960",
        "positionId": "56049960",
        "volume": 4.65,
        "price": 3226.71,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.71,
        "doubleCheck": true
    },
    {
        "dataID": "116111",
        "id": "53086089",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:33",
        "brokerTime": "2025-05-14 14:54:34",
        "commission": -32.55,
        "swap": 0,
        "profit": -60.45,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049961",
        "positionId": "56049960",
        "volume": 4.65,
        "price": 3226.84,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -93,
        "priceIn": 3226.71,
        "doubleCheck": true
    },
    {
        "dataID": "116112",
        "id": "53086090",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:34",
        "brokerTime": "2025-05-14 14:54:34",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049962",
        "positionId": "56049962",
        "volume": 4.65,
        "price": 3226.64,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.64,
        "doubleCheck": true
    },
    {
        "dataID": "116113",
        "id": "53086091",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:34",
        "brokerTime": "2025-05-14 14:54:34",
        "commission": -32.55,
        "swap": 0,
        "profit": -41.85,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049963",
        "positionId": "56049962",
        "volume": 4.65,
        "price": 3226.73,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -74.4,
        "priceIn": 3226.64,
        "doubleCheck": true
    },
    {
        "dataID": "116114",
        "id": "53086092",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:35",
        "brokerTime": "2025-05-14 14:54:35",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049964",
        "positionId": "56049964",
        "volume": 4.65,
        "price": 3226.53,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.53,
        "doubleCheck": true
    },
    {
        "dataID": "116115",
        "id": "53086093",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:35",
        "brokerTime": "2025-05-14 14:54:35",
        "commission": -32.55,
        "swap": 0,
        "profit": -93,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049965",
        "positionId": "56049964",
        "volume": 4.65,
        "price": 3226.73,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -125.55,
        "priceIn": 3226.53,
        "doubleCheck": true
    },
    {
        "dataID": "116116",
        "id": "53086094",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:35",
        "brokerTime": "2025-05-14 14:54:35",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049966",
        "positionId": "56049966",
        "volume": 4.65,
        "price": 3226.53,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.53,
        "doubleCheck": true
    },
    {
        "dataID": "116117",
        "id": "53086095",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:35",
        "brokerTime": "2025-05-14 14:54:36",
        "commission": -32.55,
        "swap": 0,
        "profit": -93,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049967",
        "positionId": "56049966",
        "volume": 4.65,
        "price": 3226.73,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -125.55,
        "priceIn": 3226.53,
        "doubleCheck": true
    },
    {
        "dataID": "116118",
        "id": "53086096",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:36",
        "brokerTime": "2025-05-14 14:54:36",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049968",
        "positionId": "56049968",
        "volume": 4.65,
        "price": 3226.53,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.53,
        "doubleCheck": true
    },
    {
        "dataID": "116119",
        "id": "53086097",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:36",
        "brokerTime": "2025-05-14 14:54:36",
        "commission": -32.55,
        "swap": 0,
        "profit": -102.3,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049969",
        "positionId": "56049968",
        "volume": 4.65,
        "price": 3226.75,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -134.85,
        "priceIn": 3226.53,
        "doubleCheck": true
    },
    {
        "dataID": "116120",
        "id": "53086098",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:37",
        "brokerTime": "2025-05-14 14:54:37",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049970",
        "positionId": "56049970",
        "volume": 4.65,
        "price": 3226.62,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.62,
        "doubleCheck": true
    },
    {
        "dataID": "116121",
        "id": "53086099",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:37",
        "brokerTime": "2025-05-14 14:54:38",
        "commission": -32.55,
        "swap": 0,
        "profit": -88.35,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049971",
        "positionId": "56049970",
        "volume": 4.65,
        "price": 3226.81,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -120.89999999999999,
        "priceIn": 3226.62,
        "doubleCheck": true
    },
    {
        "dataID": "116122",
        "id": "53086100",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:39",
        "brokerTime": "2025-05-14 14:54:39",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049972",
        "positionId": "56049972",
        "volume": 4.65,
        "price": 3226.59,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.59,
        "doubleCheck": true
    },
    {
        "dataID": "116123",
        "id": "53086101",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:39",
        "brokerTime": "2025-05-14 14:54:39",
        "commission": -32.55,
        "swap": 0,
        "profit": -111.6,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049975",
        "positionId": "56049972",
        "volume": 4.65,
        "price": 3226.83,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -144.14999999999998,
        "priceIn": 3226.59,
        "doubleCheck": true
    },
    {
        "dataID": "116124",
        "id": "53086102",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:40",
        "brokerTime": "2025-05-14 14:54:40",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049976",
        "positionId": "56049976",
        "volume": 4.65,
        "price": 3226.63,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.63,
        "doubleCheck": true
    },
    {
        "dataID": "116125",
        "id": "53086103",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:40",
        "brokerTime": "2025-05-14 14:54:40",
        "commission": -32.55,
        "swap": 0,
        "profit": -79.05,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049977",
        "positionId": "56049976",
        "volume": 4.65,
        "price": 3226.8,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -111.6,
        "priceIn": 3226.63,
        "doubleCheck": true
    },
    {
        "dataID": "116126",
        "id": "53086104",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:40",
        "brokerTime": "2025-05-14 14:54:40",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049978",
        "positionId": "56049978",
        "volume": 4.65,
        "price": 3226.54,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.54,
        "doubleCheck": true
    },
    {
        "dataID": "116127",
        "id": "53086105",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:40",
        "brokerTime": "2025-05-14 14:54:41",
        "commission": -32.55,
        "swap": 0,
        "profit": -83.7,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049979",
        "positionId": "56049978",
        "volume": 4.65,
        "price": 3226.72,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -116.25,
        "priceIn": 3226.54,
        "doubleCheck": true
    },
    {
        "dataID": "116128",
        "id": "53086106",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:42",
        "brokerTime": "2025-05-14 14:54:42",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049980",
        "positionId": "56049980",
        "volume": 4.65,
        "price": 3226.56,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.56,
        "doubleCheck": true
    },
    {
        "dataID": "116129",
        "id": "53086107",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:42",
        "brokerTime": "2025-05-14 14:54:42",
        "commission": -32.55,
        "swap": 0,
        "profit": -88.35,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049981",
        "positionId": "56049980",
        "volume": 4.65,
        "price": 3226.75,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -120.89999999999999,
        "priceIn": 3226.56,
        "doubleCheck": true
    },
    {
        "dataID": "116130",
        "id": "53086108",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:43",
        "brokerTime": "2025-05-14 14:54:43",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049982",
        "positionId": "56049982",
        "volume": 4.65,
        "price": 3226.32,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.32,
        "doubleCheck": true
    },
    {
        "dataID": "116131",
        "id": "53086109",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:43",
        "brokerTime": "2025-05-14 14:54:44",
        "commission": -32.55,
        "swap": 0,
        "profit": -23.25,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049983",
        "positionId": "56049982",
        "volume": 4.65,
        "price": 3226.37,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -55.8,
        "priceIn": 3226.32,
        "doubleCheck": true
    },
    {
        "dataID": "116132",
        "id": "53086110",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:44",
        "brokerTime": "2025-05-14 14:54:44",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049984",
        "positionId": "56049984",
        "volume": 4.65,
        "price": 3226.13,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.13,
        "doubleCheck": true
    },
    {
        "dataID": "116133",
        "id": "53086112",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:44",
        "brokerTime": "2025-05-14 14:54:45",
        "commission": -32.55,
        "swap": 0,
        "profit": -65.1,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049986",
        "positionId": "56049984",
        "volume": 4.65,
        "price": 3226.27,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -97.64999999999999,
        "priceIn": 3226.13,
        "doubleCheck": true
    },
    {
        "dataID": "116134",
        "id": "53086113",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:45",
        "brokerTime": "2025-05-14 14:54:45",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049987",
        "positionId": "56049987",
        "volume": 4.65,
        "price": 3226.04,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.04,
        "doubleCheck": true
    },
    {
        "dataID": "116135",
        "id": "53086115",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:45",
        "brokerTime": "2025-05-14 14:54:46",
        "commission": -32.55,
        "swap": 0,
        "profit": -79.05,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049989",
        "positionId": "56049987",
        "volume": 4.65,
        "price": 3226.21,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -111.6,
        "priceIn": 3226.04,
        "doubleCheck": true
    },
    {
        "dataID": "116136",
        "id": "53086116",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:47",
        "brokerTime": "2025-05-14 14:54:47",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049990",
        "positionId": "56049990",
        "volume": 4.65,
        "price": 3225.98,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3225.98,
        "doubleCheck": true
    },
    {
        "dataID": "116137",
        "id": "53086119",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:47",
        "brokerTime": "2025-05-14 14:54:47",
        "commission": -32.55,
        "swap": 0,
        "profit": -9.3,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049992",
        "positionId": "56049990",
        "volume": 4.65,
        "price": 3226,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -41.849999999999994,
        "priceIn": 3225.98,
        "doubleCheck": true
    },
    {
        "dataID": "116138",
        "id": "53086120",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:47",
        "brokerTime": "2025-05-14 14:54:47",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049993",
        "positionId": "56049993",
        "volume": 4.65,
        "price": 3225.96,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3225.96,
        "doubleCheck": true
    },
    {
        "dataID": "116139",
        "id": "53086122",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:47",
        "brokerTime": "2025-05-14 14:54:48",
        "commission": -32.55,
        "swap": 0,
        "profit": -4.65,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049995",
        "positionId": "56049993",
        "volume": 4.65,
        "price": 3225.97,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -37.199999999999996,
        "priceIn": 3225.96,
        "doubleCheck": true
    },
    {
        "dataID": "116140",
        "id": "53086124",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:48",
        "brokerTime": "2025-05-14 14:54:48",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049996",
        "positionId": "56049996",
        "volume": 4.65,
        "price": 3225.9,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3225.9,
        "doubleCheck": true
    },
    {
        "dataID": "116141",
        "id": "53086125",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:48",
        "brokerTime": "2025-05-14 14:54:51",
        "commission": -32.55,
        "swap": 0,
        "profit": -125.55,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049997",
        "positionId": "56049996",
        "volume": 4.65,
        "price": 3226.17,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -158.1,
        "priceIn": 3225.9,
        "doubleCheck": true
    },
    {
        "dataID": "116142",
        "id": "53086126",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:51",
        "brokerTime": "2025-05-14 14:54:51",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049998",
        "positionId": "56049998",
        "volume": 4.65,
        "price": 3225.81,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3225.81,
        "doubleCheck": true
    },
    {
        "dataID": "116143",
        "id": "53086127",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:51",
        "brokerTime": "2025-05-14 14:54:52",
        "commission": -32.55,
        "swap": 0,
        "profit": -139.5,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56049999",
        "positionId": "56049998",
        "volume": 4.65,
        "price": 3226.11,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -172.05,
        "priceIn": 3225.81,
        "doubleCheck": true
    },
    {
        "dataID": "116144",
        "id": "53086128",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:52",
        "brokerTime": "2025-05-14 14:54:52",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050000",
        "positionId": "56050000",
        "volume": 4.65,
        "price": 3225.92,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3225.92,
        "doubleCheck": true
    },
    {
        "dataID": "116145",
        "id": "53086129",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:52",
        "brokerTime": "2025-05-14 14:54:52",
        "commission": -32.55,
        "swap": 0,
        "profit": -97.65,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050001",
        "positionId": "56050000",
        "volume": 4.65,
        "price": 3226.13,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -130.2,
        "priceIn": 3225.92,
        "doubleCheck": true
    },
    {
        "dataID": "116146",
        "id": "53086130",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:53",
        "brokerTime": "2025-05-14 14:54:53",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050002",
        "positionId": "56050002",
        "volume": 4.65,
        "price": 3225.96,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3225.96,
        "doubleCheck": true
    },
    {
        "dataID": "116147",
        "id": "53086131",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:53",
        "brokerTime": "2025-05-14 14:54:54",
        "commission": -32.55,
        "swap": 0,
        "profit": -172.05,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050003",
        "positionId": "56050002",
        "volume": 4.65,
        "price": 3226.33,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -204.60000000000002,
        "priceIn": 3225.96,
        "doubleCheck": true
    },
    {
        "dataID": "116148",
        "id": "53086132",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:54",
        "brokerTime": "2025-05-14 14:54:54",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050004",
        "positionId": "56050004",
        "volume": 4.65,
        "price": 3226.08,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.08,
        "doubleCheck": true
    },
    {
        "dataID": "116149",
        "id": "53086133",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:54",
        "brokerTime": "2025-05-14 14:54:54",
        "commission": -32.55,
        "swap": 0,
        "profit": -60.45,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050005",
        "positionId": "56050004",
        "volume": 4.65,
        "price": 3226.21,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -93,
        "priceIn": 3226.08,
        "doubleCheck": true
    },
    {
        "dataID": "116150",
        "id": "53086134",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:55",
        "brokerTime": "2025-05-14 14:54:55",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050006",
        "positionId": "56050006",
        "volume": 4.65,
        "price": 3226.14,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.14,
        "doubleCheck": true
    },
    {
        "dataID": "116151",
        "id": "53086135",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:55",
        "brokerTime": "2025-05-14 14:54:55",
        "commission": -32.55,
        "swap": 0,
        "profit": -60.45,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050007",
        "positionId": "56050006",
        "volume": 4.65,
        "price": 3226.27,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -93,
        "priceIn": 3226.14,
        "doubleCheck": true
    },
    {
        "dataID": "116152",
        "id": "53086136",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:55",
        "brokerTime": "2025-05-14 14:54:55",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050008",
        "positionId": "56050008",
        "volume": 4.65,
        "price": 3226.04,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3226.04,
        "doubleCheck": true
    },
    {
        "dataID": "116153",
        "id": "53086137",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:55",
        "brokerTime": "2025-05-14 14:54:56",
        "commission": -32.55,
        "swap": 0,
        "profit": -32.55,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050009",
        "positionId": "56050008",
        "volume": 4.65,
        "price": 3226.11,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -65.1,
        "priceIn": 3226.04,
        "doubleCheck": true
    },
    {
        "dataID": "116154",
        "id": "53086138",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:56",
        "brokerTime": "2025-05-14 14:54:56",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050010",
        "positionId": "56050010",
        "volume": 4.65,
        "price": 3225.88,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3225.88,
        "doubleCheck": true
    },
    {
        "dataID": "116155",
        "id": "53086139",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:56",
        "brokerTime": "2025-05-14 14:54:58",
        "commission": -32.55,
        "swap": 0,
        "profit": -93,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050011",
        "positionId": "56050010",
        "volume": 4.65,
        "price": 3226.08,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -125.55,
        "priceIn": 3225.88,
        "doubleCheck": true
    },
    {
        "dataID": "116156",
        "id": "53086140",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:59",
        "brokerTime": "2025-05-14 14:54:59",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050012",
        "positionId": "56050012",
        "volume": 4.65,
        "price": 3225.84,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3225.84,
        "doubleCheck": true
    },
    {
        "dataID": "116157",
        "id": "53086141",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:59",
        "brokerTime": "2025-05-14 14:55:00",
        "commission": -32.55,
        "swap": 0,
        "profit": -130.2,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050013",
        "positionId": "56050012",
        "volume": 4.65,
        "price": 3226.12,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -162.75,
        "priceIn": 3225.84,
        "doubleCheck": true
    },
    {
        "dataID": "116158",
        "id": "53086144",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:01",
        "brokerTime": "2025-05-14 14:55:01",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050017",
        "positionId": "56050017",
        "volume": 4.65,
        "price": 3225.49,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3225.49,
        "doubleCheck": true
    },
    {
        "dataID": "116159",
        "id": "53086147",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:01",
        "brokerTime": "2025-05-14 14:55:01",
        "commission": -32.55,
        "swap": 0,
        "profit": -181.35,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050020",
        "positionId": "56050017",
        "volume": 4.65,
        "price": 3225.88,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -213.89999999999998,
        "priceIn": 3225.49,
        "doubleCheck": true
    },
    {
        "dataID": "116160",
        "id": "53086148",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:01",
        "brokerTime": "2025-05-14 14:55:01",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050021",
        "positionId": "56050021",
        "volume": 4.65,
        "price": 3225.66,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3225.66,
        "doubleCheck": true
    },
    {
        "dataID": "116161",
        "id": "53086149",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:01",
        "brokerTime": "2025-05-14 14:55:02",
        "commission": -32.55,
        "swap": 0,
        "profit": -74.4,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050022",
        "positionId": "56050021",
        "volume": 4.65,
        "price": 3225.82,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.95,
        "priceIn": 3225.66,
        "doubleCheck": true
    },
    {
        "dataID": "116162",
        "id": "53086150",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:02",
        "brokerTime": "2025-05-14 14:55:02",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050023",
        "positionId": "56050023",
        "volume": 4.65,
        "price": 3225.54,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3225.54,
        "doubleCheck": true
    },
    {
        "dataID": "116163",
        "id": "53086152",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:02",
        "brokerTime": "2025-05-14 14:55:03",
        "commission": -32.55,
        "swap": 0,
        "profit": -130.2,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050025",
        "positionId": "56050023",
        "volume": 4.65,
        "price": 3225.82,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -162.75,
        "priceIn": 3225.54,
        "doubleCheck": true
    },
    {
        "dataID": "116164",
        "id": "53086153",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:03",
        "brokerTime": "2025-05-14 14:55:03",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050026",
        "positionId": "56050026",
        "volume": 4.65,
        "price": 3225.59,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3225.59,
        "doubleCheck": true
    },
    {
        "dataID": "116165",
        "id": "53086154",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:03",
        "brokerTime": "2025-05-14 14:55:04",
        "commission": -32.55,
        "swap": 0,
        "profit": -32.55,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050027",
        "positionId": "56050026",
        "volume": 4.65,
        "price": 3225.66,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -65.1,
        "priceIn": 3225.59,
        "doubleCheck": true
    },
    {
        "dataID": "116166",
        "id": "53086158",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:04",
        "brokerTime": "2025-05-14 14:55:04",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050030",
        "positionId": "56050030",
        "volume": 4.65,
        "price": 3225.32,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3225.32,
        "doubleCheck": true
    },
    {
        "dataID": "116167",
        "id": "53086159",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:04",
        "brokerTime": "2025-05-14 14:55:05",
        "commission": -32.55,
        "swap": 0,
        "profit": -69.75,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050031",
        "positionId": "56050030",
        "volume": 4.65,
        "price": 3225.47,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -102.3,
        "priceIn": 3225.32,
        "doubleCheck": true
    },
    {
        "dataID": "116168",
        "id": "53086162",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:05",
        "brokerTime": "2025-05-14 14:55:05",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050033",
        "positionId": "56050033",
        "volume": 4.65,
        "price": 3225.23,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3225.23,
        "doubleCheck": true
    },
    {
        "dataID": "116169",
        "id": "53086163",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:05",
        "brokerTime": "2025-05-14 14:55:06",
        "commission": -32.55,
        "swap": 0,
        "profit": -83.7,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050034",
        "positionId": "56050033",
        "volume": 4.65,
        "price": 3225.41,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -116.25,
        "priceIn": 3225.23,
        "doubleCheck": true
    },
    {
        "dataID": "116170",
        "id": "53086167",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:07",
        "brokerTime": "2025-05-14 14:55:07",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050037",
        "positionId": "56050037",
        "volume": 4.65,
        "price": 3224.96,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.55,
        "priceIn": 3224.96,
        "doubleCheck": true
    },
    {
        "dataID": "116171",
        "id": "53086170",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:07",
        "brokerTime": "2025-05-14 14:55:07",
        "commission": -32.55,
        "swap": 0,
        "profit": 4.65,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050057",
        "positionId": "56050037",
        "volume": 4.65,
        "price": 3224.95,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -27.9,
        "priceIn": 3224.96,
        "doubleCheck": true
    },
    {
        "dataID": "116172",
        "id": "53086199",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 14:55:07",
        "brokerTime": "2025-05-14 14:55:07",
        "commission": -6.23,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050074",
        "positionId": "56050074",
        "volume": 0.89,
        "price": 3224.96,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3324.96,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -6.23,
        "priceIn": 3224.96,
        "doubleCheck": true
    },
    {
        "dataID": "116173",
        "id": "53086213",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:08",
        "brokerTime": "2025-05-14 14:55:08",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050076",
        "positionId": "56050076",
        "volume": 5.72,
        "price": 3224.72,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -40.04,
        "priceIn": 3224.72,
        "doubleCheck": true
    },
    {
        "dataID": "116174",
        "id": "53086214",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:08",
        "brokerTime": "2025-05-14 14:55:08",
        "commission": -40.04,
        "swap": 0,
        "profit": -102.96,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050077",
        "positionId": "56050076",
        "volume": 5.72,
        "price": 3224.9,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -143,
        "priceIn": 3224.72,
        "doubleCheck": true
    },
    {
        "dataID": "116175",
        "id": "53086215",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:09",
        "brokerTime": "2025-05-14 14:55:09",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050078",
        "positionId": "56050078",
        "volume": 5.72,
        "price": 3224.68,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -40.04,
        "priceIn": 3224.68,
        "doubleCheck": true
    },
    {
        "dataID": "116176",
        "id": "53086216",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:09",
        "brokerTime": "2025-05-14 14:55:09",
        "commission": -40.04,
        "swap": 0,
        "profit": -80.08,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050079",
        "positionId": "56050078",
        "volume": 5.72,
        "price": 3224.82,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -120.12,
        "priceIn": 3224.68,
        "doubleCheck": true
    },
    {
        "dataID": "116177",
        "id": "53086217",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:09",
        "brokerTime": "2025-05-14 14:55:09",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050080",
        "positionId": "56050080",
        "volume": 5.72,
        "price": 3224.62,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -40.04,
        "priceIn": 3224.62,
        "doubleCheck": true
    },
    {
        "dataID": "116178",
        "id": "53086218",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:09",
        "brokerTime": "2025-05-14 14:55:10",
        "commission": -40.04,
        "swap": 0,
        "profit": -120.12,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050081",
        "positionId": "56050080",
        "volume": 5.72,
        "price": 3224.83,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -160.16,
        "priceIn": 3224.62,
        "doubleCheck": true
    },
    {
        "dataID": "116179",
        "id": "53086219",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:10",
        "brokerTime": "2025-05-14 14:55:10",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050082",
        "positionId": "56050082",
        "volume": 5.72,
        "price": 3224.57,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -40.04,
        "priceIn": 3224.57,
        "doubleCheck": true
    },
    {
        "dataID": "116180",
        "id": "53086221",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:10",
        "brokerTime": "2025-05-14 14:55:11",
        "commission": -40.04,
        "swap": 0,
        "profit": -114.4,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050084",
        "positionId": "56050082",
        "volume": 5.72,
        "price": 3224.77,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -154.44,
        "priceIn": 3224.57,
        "doubleCheck": true
    },
    {
        "dataID": "116181",
        "id": "53086222",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:11",
        "brokerTime": "2025-05-14 14:55:11",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050085",
        "positionId": "56050085",
        "volume": 5.72,
        "price": 3224.37,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -40.04,
        "priceIn": 3224.37,
        "doubleCheck": true
    },
    {
        "dataID": "116182",
        "id": "53086223",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:11",
        "brokerTime": "2025-05-14 14:55:12",
        "commission": -40.04,
        "swap": 0,
        "profit": -91.52,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050086",
        "positionId": "56050085",
        "volume": 5.72,
        "price": 3224.53,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -131.56,
        "priceIn": 3224.37,
        "doubleCheck": true
    },
    {
        "dataID": "116183",
        "id": "53086224",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:12",
        "brokerTime": "2025-05-14 14:55:12",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050087",
        "positionId": "56050087",
        "volume": 5.72,
        "price": 3224.43,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -40.04,
        "priceIn": 3224.43,
        "doubleCheck": true
    },
    {
        "dataID": "116184",
        "id": "53086261",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:12",
        "brokerTime": "2025-05-14 14:55:13",
        "commission": -40.04,
        "swap": 0,
        "profit": -11.44,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050121",
        "positionId": "56050087",
        "volume": 5.72,
        "price": 3224.45,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -51.48,
        "priceIn": 3224.43,
        "doubleCheck": true
    },
    {
        "dataID": "116185",
        "id": "53086263",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:13",
        "brokerTime": "2025-05-14 14:55:13",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050122",
        "positionId": "56050122",
        "volume": 5.72,
        "price": 3224.24,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -40.04,
        "priceIn": 3224.24,
        "doubleCheck": true
    },
    {
        "dataID": "116186",
        "id": "53086267",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:13",
        "brokerTime": "2025-05-14 14:55:14",
        "commission": -40.04,
        "swap": 0,
        "profit": -80.08,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050123",
        "positionId": "56050122",
        "volume": 5.72,
        "price": 3224.38,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -120.12,
        "priceIn": 3224.24,
        "doubleCheck": true
    },
    {
        "dataID": "116187",
        "id": "53086269",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:14",
        "brokerTime": "2025-05-14 14:55:14",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050125",
        "positionId": "56050125",
        "volume": 5.72,
        "price": 3224.16,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -40.04,
        "priceIn": 3224.16,
        "doubleCheck": true
    },
    {
        "dataID": "116188",
        "id": "53086738",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:14",
        "brokerTime": "2025-05-14 14:55:15",
        "commission": -40.04,
        "swap": 0,
        "profit": -74.36,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050459",
        "positionId": "56050125",
        "volume": 5.72,
        "price": 3224.29,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -114.4,
        "priceIn": 3224.16,
        "doubleCheck": true
    },
    {
        "dataID": "116189",
        "id": "53086741",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:15",
        "brokerTime": "2025-05-14 14:55:15",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050461",
        "positionId": "56050461",
        "volume": 5.72,
        "price": 3224.04,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -40.04,
        "priceIn": 3224.04,
        "doubleCheck": true
    },
    {
        "dataID": "116190",
        "id": "53086755",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:15",
        "brokerTime": "2025-05-14 14:55:15",
        "commission": -40.04,
        "swap": 0,
        "profit": -160.16,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050471",
        "positionId": "56050461",
        "volume": 5.72,
        "price": 3224.32,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -200.2,
        "priceIn": 3224.04,
        "doubleCheck": true
    },
    {
        "dataID": "116191",
        "id": "53086783",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:16",
        "brokerTime": "2025-05-14 14:55:16",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050488",
        "positionId": "56050488",
        "volume": 5.72,
        "price": 3224.07,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -40.04,
        "priceIn": 3224.07,
        "doubleCheck": true
    },
    {
        "dataID": "116192",
        "id": "53086807",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:16",
        "brokerTime": "2025-05-14 14:55:16",
        "commission": -40.04,
        "swap": 0,
        "profit": -108.68,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050500",
        "positionId": "56050488",
        "volume": 5.72,
        "price": 3224.26,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -148.72,
        "priceIn": 3224.07,
        "doubleCheck": true
    },
    {
        "dataID": "116193",
        "id": "53086820",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:17",
        "brokerTime": "2025-05-14 14:55:17",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050505",
        "positionId": "56050505",
        "volume": 5.72,
        "price": 3224,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -40.04,
        "priceIn": 3224,
        "doubleCheck": true
    },
    {
        "dataID": "116194",
        "id": "53086822",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:17",
        "brokerTime": "2025-05-14 14:55:17",
        "commission": -40.04,
        "swap": 0,
        "profit": -125.84,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050506",
        "positionId": "56050505",
        "volume": 5.72,
        "price": 3224.22,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -165.88,
        "priceIn": 3224,
        "doubleCheck": true
    },
    {
        "dataID": "116195",
        "id": "53086823",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:17",
        "brokerTime": "2025-05-14 14:55:17",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050507",
        "positionId": "56050507",
        "volume": 5.72,
        "price": 3224.01,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -40.04,
        "priceIn": 3224.01,
        "doubleCheck": true
    },
    {
        "dataID": "116196",
        "id": "53086824",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:17",
        "brokerTime": "2025-05-14 14:55:18",
        "commission": -40.04,
        "swap": 0,
        "profit": -120.12,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050508",
        "positionId": "56050507",
        "volume": 5.72,
        "price": 3224.22,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -160.16,
        "priceIn": 3224.01,
        "doubleCheck": true
    },
    {
        "dataID": "116197",
        "id": "53086825",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:18",
        "brokerTime": "2025-05-14 14:55:18",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050509",
        "positionId": "56050509",
        "volume": 5.72,
        "price": 3224.03,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -40.04,
        "priceIn": 3224.03,
        "doubleCheck": true
    },
    {
        "dataID": "116198",
        "id": "53086826",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:18",
        "brokerTime": "2025-05-14 14:55:19",
        "commission": -40.04,
        "swap": 0,
        "profit": -160.16,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050510",
        "positionId": "56050509",
        "volume": 5.72,
        "price": 3224.31,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -200.2,
        "priceIn": 3224.03,
        "doubleCheck": true
    },
    {
        "dataID": "116199",
        "id": "53086827",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:19",
        "brokerTime": "2025-05-14 14:55:19",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050511",
        "positionId": "56050511",
        "volume": 5.72,
        "price": 3224.04,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -40.04,
        "priceIn": 3224.04,
        "doubleCheck": true
    },
    {
        "dataID": "116200",
        "id": "53086828",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:19",
        "brokerTime": "2025-05-14 14:55:19",
        "commission": -40.04,
        "swap": 0,
        "profit": -143,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050512",
        "positionId": "56050511",
        "volume": 5.72,
        "price": 3224.29,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -183.04,
        "priceIn": 3224.04,
        "doubleCheck": true
    },
    {
        "dataID": "116201",
        "id": "53086829",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:20",
        "brokerTime": "2025-05-14 14:55:20",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050513",
        "positionId": "56050513",
        "volume": 5.72,
        "price": 3224.16,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -40.04,
        "priceIn": 3224.16,
        "doubleCheck": true
    },
    {
        "dataID": "116202",
        "id": "53086830",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:20",
        "brokerTime": "2025-05-14 14:55:20",
        "commission": -40.04,
        "swap": 0,
        "profit": -91.52,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050514",
        "positionId": "56050513",
        "volume": 5.72,
        "price": 3224.32,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -131.56,
        "priceIn": 3224.16,
        "doubleCheck": true
    },
    {
        "dataID": "116203",
        "id": "53086831",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:20",
        "brokerTime": "2025-05-14 14:55:20",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050515",
        "positionId": "56050515",
        "volume": 5.72,
        "price": 3224.28,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -40.04,
        "priceIn": 3224.28,
        "doubleCheck": true
    },
    {
        "dataID": "116204",
        "id": "53086833",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:20",
        "brokerTime": "2025-05-14 14:55:21",
        "commission": -40.04,
        "swap": 0,
        "profit": -85.8,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050517",
        "positionId": "56050515",
        "volume": 5.72,
        "price": 3224.43,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -125.84,
        "priceIn": 3224.28,
        "doubleCheck": true
    },
    {
        "dataID": "116205",
        "id": "53086834",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:21",
        "brokerTime": "2025-05-14 14:55:21",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050518",
        "positionId": "56050518",
        "volume": 5.72,
        "price": 3224.18,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -40.04,
        "priceIn": 3224.18,
        "doubleCheck": true
    },
    {
        "dataID": "116206",
        "id": "53086835",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:21",
        "brokerTime": "2025-05-14 14:55:22",
        "commission": -40.04,
        "swap": 0,
        "profit": -28.6,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050519",
        "positionId": "56050518",
        "volume": 5.72,
        "price": 3224.23,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -68.64,
        "priceIn": 3224.18,
        "doubleCheck": true
    },
    {
        "dataID": "116207",
        "id": "53086836",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:22",
        "brokerTime": "2025-05-14 14:55:22",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050521",
        "positionId": "56050521",
        "volume": 5.72,
        "price": 3224,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -40.04,
        "priceIn": 3224,
        "doubleCheck": true
    },
    {
        "dataID": "116208",
        "id": "53086839",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:22",
        "brokerTime": "2025-05-14 14:55:23",
        "commission": -40.04,
        "swap": 0,
        "profit": -143,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050523",
        "positionId": "56050521",
        "volume": 5.72,
        "price": 3224.25,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -183.04,
        "priceIn": 3224,
        "doubleCheck": true
    },
    {
        "dataID": "116209",
        "id": "53086840",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:23",
        "brokerTime": "2025-05-14 14:55:23",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050524",
        "positionId": "56050524",
        "volume": 5.72,
        "price": 3224.03,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -40.04,
        "priceIn": 3224.03,
        "doubleCheck": true
    },
    {
        "dataID": "116210",
        "id": "53086842",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:23",
        "brokerTime": "2025-05-14 14:55:24",
        "commission": -40.04,
        "swap": 0,
        "profit": -91.52,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050526",
        "positionId": "56050524",
        "volume": 5.72,
        "price": 3224.19,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -131.56,
        "priceIn": 3224.03,
        "doubleCheck": true
    },
    {
        "dataID": "116211",
        "id": "53086843",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:24",
        "brokerTime": "2025-05-14 14:55:24",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050527",
        "positionId": "56050527",
        "volume": 5.72,
        "price": 3223.97,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -40.04,
        "priceIn": 3223.97,
        "doubleCheck": true
    },
    {
        "dataID": "116212",
        "id": "53086844",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:24",
        "brokerTime": "2025-05-14 14:55:24",
        "commission": -40.04,
        "swap": 0,
        "profit": -102.96,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050528",
        "positionId": "56050527",
        "volume": 5.72,
        "price": 3224.15,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -143,
        "priceIn": 3223.97,
        "doubleCheck": true
    },
    {
        "dataID": "116213",
        "id": "53086845",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:24",
        "brokerTime": "2025-05-14 14:55:24",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050529",
        "positionId": "56050529",
        "volume": 5.72,
        "price": 3223.98,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -40.04,
        "priceIn": 3223.98,
        "doubleCheck": true
    },
    {
        "dataID": "116214",
        "id": "53086846",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:24",
        "brokerTime": "2025-05-14 14:55:25",
        "commission": -40.04,
        "swap": 0,
        "profit": -114.4,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050530",
        "positionId": "56050529",
        "volume": 5.72,
        "price": 3224.18,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -154.44,
        "priceIn": 3223.98,
        "doubleCheck": true
    },
    {
        "dataID": "116215",
        "id": "53086847",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:26",
        "brokerTime": "2025-05-14 14:55:26",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050531",
        "positionId": "56050531",
        "volume": 5.72,
        "price": 3224.06,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -40.04,
        "priceIn": 3224.06,
        "doubleCheck": true
    },
    {
        "dataID": "116216",
        "id": "53086848",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:26",
        "brokerTime": "2025-05-14 14:55:26",
        "commission": -40.04,
        "swap": 0,
        "profit": -102.96,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050532",
        "positionId": "56050531",
        "volume": 5.72,
        "price": 3224.24,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -143,
        "priceIn": 3224.06,
        "doubleCheck": true
    },
    {
        "dataID": "116217",
        "id": "53086849",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:27",
        "brokerTime": "2025-05-14 14:55:27",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050534",
        "positionId": "56050534",
        "volume": 5.72,
        "price": 3224.01,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -40.04,
        "priceIn": 3224.01,
        "doubleCheck": true
    },
    {
        "dataID": "116218",
        "id": "53086851",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:27",
        "brokerTime": "2025-05-14 14:55:27",
        "commission": -40.04,
        "swap": 0,
        "profit": -80.08,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050535",
        "positionId": "56050534",
        "volume": 5.72,
        "price": 3224.15,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -120.12,
        "priceIn": 3224.01,
        "doubleCheck": true
    },
    {
        "dataID": "116219",
        "id": "53086852",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:29",
        "brokerTime": "2025-05-14 14:55:29",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050536",
        "positionId": "56050536",
        "volume": 5.72,
        "price": 3224.06,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -40.04,
        "priceIn": 3224.06,
        "doubleCheck": true
    },
    {
        "dataID": "116220",
        "id": "53086853",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:29",
        "brokerTime": "2025-05-14 14:55:29",
        "commission": -40.04,
        "swap": 0,
        "profit": -125.84,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050537",
        "positionId": "56050536",
        "volume": 5.72,
        "price": 3224.28,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -165.88,
        "priceIn": 3224.06,
        "doubleCheck": true
    },
    {
        "dataID": "116221",
        "id": "53086854",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:29",
        "brokerTime": "2025-05-14 14:55:29",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050538",
        "positionId": "56050538",
        "volume": 5.72,
        "price": 3224.09,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -40.04,
        "priceIn": 3224.09,
        "doubleCheck": true
    },
    {
        "dataID": "116222",
        "id": "53086861",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:29",
        "brokerTime": "2025-05-14 14:55:30",
        "commission": -40.04,
        "swap": 0,
        "profit": 97.24,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050542",
        "positionId": "56050538",
        "volume": 5.72,
        "price": 3223.92,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 57.199999999999996,
        "priceIn": 3224.09,
        "doubleCheck": true
    },
    {
        "dataID": "116223",
        "id": "53086862",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:31",
        "brokerTime": "2025-05-14 14:55:31",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050543",
        "positionId": "56050543",
        "volume": 5.72,
        "price": 3223.75,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -40.04,
        "priceIn": 3223.75,
        "doubleCheck": true
    },
    {
        "dataID": "116224",
        "id": "53086864",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:31",
        "brokerTime": "2025-05-14 14:55:31",
        "commission": -40.04,
        "swap": 0,
        "profit": -102.96,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050545",
        "positionId": "56050543",
        "volume": 5.72,
        "price": 3223.93,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -143,
        "priceIn": 3223.75,
        "doubleCheck": true
    },
    {
        "dataID": "116225",
        "id": "53086865",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:31",
        "brokerTime": "2025-05-14 14:55:31",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050546",
        "positionId": "56050546",
        "volume": 5.72,
        "price": 3223.7,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -40.04,
        "priceIn": 3223.7,
        "doubleCheck": true
    },
    {
        "dataID": "116226",
        "id": "53086866",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:31",
        "brokerTime": "2025-05-14 14:55:32",
        "commission": -40.04,
        "swap": 0,
        "profit": -114.4,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050547",
        "positionId": "56050546",
        "volume": 5.72,
        "price": 3223.9,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -154.44,
        "priceIn": 3223.7,
        "doubleCheck": true
    },
    {
        "dataID": "116227",
        "id": "53086867",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:32",
        "brokerTime": "2025-05-14 14:55:32",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050548",
        "positionId": "56050548",
        "volume": 5.72,
        "price": 3223.7,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -40.04,
        "priceIn": 3223.7,
        "doubleCheck": true
    },
    {
        "dataID": "116228",
        "id": "53086868",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:32",
        "brokerTime": "2025-05-14 14:55:33",
        "commission": -40.04,
        "swap": 0,
        "profit": -114.4,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050549",
        "positionId": "56050548",
        "volume": 5.72,
        "price": 3223.9,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -154.44,
        "priceIn": 3223.7,
        "doubleCheck": true
    },
    {
        "dataID": "116229",
        "id": "53086869",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:33",
        "brokerTime": "2025-05-14 14:55:33",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050550",
        "positionId": "56050550",
        "volume": 5.72,
        "price": 3223.72,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -40.04,
        "priceIn": 3223.72,
        "doubleCheck": true
    },
    {
        "dataID": "116230",
        "id": "53086872",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:33",
        "brokerTime": "2025-05-14 14:55:34",
        "commission": -40.04,
        "swap": 0,
        "profit": -97.24,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050552",
        "positionId": "56050550",
        "volume": 5.72,
        "price": 3223.89,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -137.28,
        "priceIn": 3223.72,
        "doubleCheck": true
    },
    {
        "dataID": "116231",
        "id": "53086873",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:34",
        "brokerTime": "2025-05-14 14:55:34",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050553",
        "positionId": "56050553",
        "volume": 5.72,
        "price": 3223.58,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -40.04,
        "priceIn": 3223.58,
        "doubleCheck": true
    },
    {
        "dataID": "116232",
        "id": "53086876",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:34",
        "brokerTime": "2025-05-14 14:55:35",
        "commission": -40.04,
        "swap": 0,
        "profit": -102.96,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050556",
        "positionId": "56050553",
        "volume": 5.72,
        "price": 3223.76,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -143,
        "priceIn": 3223.58,
        "doubleCheck": true
    },
    {
        "dataID": "116233",
        "id": "53086878",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:35",
        "brokerTime": "2025-05-14 14:55:35",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050557",
        "positionId": "56050557",
        "volume": 5.72,
        "price": 3223.63,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -40.04,
        "priceIn": 3223.63,
        "doubleCheck": true
    },
    {
        "dataID": "116234",
        "id": "53086879",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:35",
        "brokerTime": "2025-05-14 14:55:36",
        "commission": -40.04,
        "swap": 0,
        "profit": -91.52,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050558",
        "positionId": "56050557",
        "volume": 5.72,
        "price": 3223.79,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -131.56,
        "priceIn": 3223.63,
        "doubleCheck": true
    },
    {
        "dataID": "116235",
        "id": "53086880",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:36",
        "brokerTime": "2025-05-14 14:55:36",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050559",
        "positionId": "56050559",
        "volume": 5.72,
        "price": 3223.6,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -40.04,
        "priceIn": 3223.6,
        "doubleCheck": true
    },
    {
        "dataID": "116236",
        "id": "53086882",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:36",
        "brokerTime": "2025-05-14 14:55:37",
        "commission": -40.04,
        "swap": 0,
        "profit": -102.96,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050560",
        "positionId": "56050559",
        "volume": 5.72,
        "price": 3223.78,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -143,
        "priceIn": 3223.6,
        "doubleCheck": true
    },
    {
        "dataID": "116237",
        "id": "53086883",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:38",
        "brokerTime": "2025-05-14 14:55:38",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050561",
        "positionId": "56050561",
        "volume": 5.72,
        "price": 3223.62,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -40.04,
        "priceIn": 3223.62,
        "doubleCheck": true
    },
    {
        "dataID": "116238",
        "id": "53086884",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:38",
        "brokerTime": "2025-05-14 14:55:38",
        "commission": -40.04,
        "swap": 0,
        "profit": -102.96,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050562",
        "positionId": "56050561",
        "volume": 5.72,
        "price": 3223.8,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -143,
        "priceIn": 3223.62,
        "doubleCheck": true
    },
    {
        "dataID": "116239",
        "id": "53086885",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:39",
        "brokerTime": "2025-05-14 14:55:39",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050563",
        "positionId": "56050563",
        "volume": 5.72,
        "price": 3223.71,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -40.04,
        "priceIn": 3223.71,
        "doubleCheck": true
    },
    {
        "dataID": "116240",
        "id": "53086886",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:39",
        "brokerTime": "2025-05-14 14:55:39",
        "commission": -40.04,
        "swap": 0,
        "profit": -114.4,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050564",
        "positionId": "56050563",
        "volume": 5.72,
        "price": 3223.91,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -154.44,
        "priceIn": 3223.71,
        "doubleCheck": true
    },
    {
        "dataID": "116241",
        "id": "53086887",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:40",
        "brokerTime": "2025-05-14 14:55:40",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050565",
        "positionId": "56050565",
        "volume": 5.72,
        "price": 3223.66,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -40.04,
        "priceIn": 3223.66,
        "doubleCheck": true
    },
    {
        "dataID": "116242",
        "id": "53086889",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:40",
        "brokerTime": "2025-05-14 14:55:40",
        "commission": -40.04,
        "swap": 0,
        "profit": -114.4,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050567",
        "positionId": "56050565",
        "volume": 5.72,
        "price": 3223.86,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -154.44,
        "priceIn": 3223.66,
        "doubleCheck": true
    },
    {
        "dataID": "116243",
        "id": "53086890",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:41",
        "brokerTime": "2025-05-14 14:55:41",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050568",
        "positionId": "56050568",
        "volume": 5.72,
        "price": 3223.69,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -40.04,
        "priceIn": 3223.69,
        "doubleCheck": true
    },
    {
        "dataID": "116244",
        "id": "53086891",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:41",
        "brokerTime": "2025-05-14 14:55:41",
        "commission": -40.04,
        "swap": 0,
        "profit": -120.12,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050569",
        "positionId": "56050568",
        "volume": 5.72,
        "price": 3223.9,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -160.16,
        "priceIn": 3223.69,
        "doubleCheck": true
    },
    {
        "dataID": "116245",
        "id": "53086892",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:41",
        "brokerTime": "2025-05-14 14:55:41",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050570",
        "positionId": "56050570",
        "volume": 5.72,
        "price": 3223.74,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -40.04,
        "priceIn": 3223.74,
        "doubleCheck": true
    },
    {
        "dataID": "116246",
        "id": "53086893",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:41",
        "brokerTime": "2025-05-14 14:55:42",
        "commission": -40.04,
        "swap": 0,
        "profit": -108.68,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050571",
        "positionId": "56050570",
        "volume": 5.72,
        "price": 3223.93,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -148.72,
        "priceIn": 3223.74,
        "doubleCheck": true
    },
    {
        "dataID": "116247",
        "id": "53086895",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:43",
        "brokerTime": "2025-05-14 14:55:43",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050573",
        "positionId": "56050573",
        "volume": 5.72,
        "price": 3223.57,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -40.04,
        "priceIn": 3223.57,
        "doubleCheck": true
    },
    {
        "dataID": "116248",
        "id": "53086896",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:43",
        "brokerTime": "2025-05-14 14:55:44",
        "commission": -40.04,
        "swap": 0,
        "profit": -188.76,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050574",
        "positionId": "56050573",
        "volume": 5.72,
        "price": 3223.9,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -228.79999999999998,
        "priceIn": 3223.57,
        "doubleCheck": true
    },
    {
        "dataID": "116249",
        "id": "53086897",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:44",
        "brokerTime": "2025-05-14 14:55:44",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050575",
        "positionId": "56050575",
        "volume": 5.72,
        "price": 3223.72,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -40.04,
        "priceIn": 3223.72,
        "doubleCheck": true
    },
    {
        "dataID": "116250",
        "id": "53086898",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:44",
        "brokerTime": "2025-05-14 14:55:45",
        "commission": -40.04,
        "swap": 0,
        "profit": -68.64,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050576",
        "positionId": "56050575",
        "volume": 5.72,
        "price": 3223.84,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -108.68,
        "priceIn": 3223.72,
        "doubleCheck": true
    },
    {
        "dataID": "116251",
        "id": "53086899",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:45",
        "brokerTime": "2025-05-14 14:55:45",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050577",
        "positionId": "56050577",
        "volume": 5.72,
        "price": 3223.64,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -40.04,
        "priceIn": 3223.64,
        "doubleCheck": true
    },
    {
        "dataID": "116252",
        "id": "53086900",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:45",
        "brokerTime": "2025-05-14 14:55:46",
        "commission": -40.04,
        "swap": 0,
        "profit": -108.68,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050578",
        "positionId": "56050577",
        "volume": 5.72,
        "price": 3223.83,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -148.72,
        "priceIn": 3223.64,
        "doubleCheck": true
    },
    {
        "dataID": "116253",
        "id": "53086901",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:46",
        "brokerTime": "2025-05-14 14:55:46",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050579",
        "positionId": "56050579",
        "volume": 5.72,
        "price": 3223.66,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -40.04,
        "priceIn": 3223.66,
        "doubleCheck": true
    },
    {
        "dataID": "116254",
        "id": "53086902",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:46",
        "brokerTime": "2025-05-14 14:55:47",
        "commission": -40.04,
        "swap": 0,
        "profit": -80.08,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050580",
        "positionId": "56050579",
        "volume": 5.72,
        "price": 3223.8,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -120.12,
        "priceIn": 3223.66,
        "doubleCheck": true
    },
    {
        "dataID": "116255",
        "id": "53086903",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:47",
        "brokerTime": "2025-05-14 14:55:47",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050581",
        "positionId": "56050581",
        "volume": 5.72,
        "price": 3223.65,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -40.04,
        "priceIn": 3223.65,
        "doubleCheck": true
    },
    {
        "dataID": "116256",
        "id": "53086904",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:47",
        "brokerTime": "2025-05-14 14:55:48",
        "commission": -40.04,
        "swap": 0,
        "profit": -108.68,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050582",
        "positionId": "56050581",
        "volume": 5.72,
        "price": 3223.84,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -148.72,
        "priceIn": 3223.65,
        "doubleCheck": true
    },
    {
        "dataID": "116257",
        "id": "53086905",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:48",
        "brokerTime": "2025-05-14 14:55:48",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050583",
        "positionId": "56050583",
        "volume": 5.72,
        "price": 3223.65,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -40.04,
        "priceIn": 3223.65,
        "doubleCheck": true
    },
    {
        "dataID": "116258",
        "id": "53086906",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:48",
        "brokerTime": "2025-05-14 14:55:49",
        "commission": -40.04,
        "swap": 0,
        "profit": -91.52,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050584",
        "positionId": "56050583",
        "volume": 5.72,
        "price": 3223.81,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -131.56,
        "priceIn": 3223.65,
        "doubleCheck": true
    },
    {
        "dataID": "116259",
        "id": "53086907",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:49",
        "brokerTime": "2025-05-14 14:55:49",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050585",
        "positionId": "56050585",
        "volume": 5.72,
        "price": 3223.75,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -40.04,
        "priceIn": 3223.75,
        "doubleCheck": true
    },
    {
        "dataID": "116260",
        "id": "53086908",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:49",
        "brokerTime": "2025-05-14 14:55:49",
        "commission": -40.04,
        "swap": 0,
        "profit": -80.08,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050586",
        "positionId": "56050585",
        "volume": 5.72,
        "price": 3223.89,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -120.12,
        "priceIn": 3223.75,
        "doubleCheck": true
    },
    {
        "dataID": "116261",
        "id": "53086909",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:50",
        "brokerTime": "2025-05-14 14:55:50",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050587",
        "positionId": "56050587",
        "volume": 5.72,
        "price": 3223.65,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -40.04,
        "priceIn": 3223.65,
        "doubleCheck": true
    },
    {
        "dataID": "116262",
        "id": "53086910",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:50",
        "brokerTime": "2025-05-14 14:55:50",
        "commission": -40.04,
        "swap": 0,
        "profit": -108.68,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050588",
        "positionId": "56050587",
        "volume": 5.72,
        "price": 3223.84,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -148.72,
        "priceIn": 3223.65,
        "doubleCheck": true
    },
    {
        "dataID": "116263",
        "id": "53086911",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:50",
        "brokerTime": "2025-05-14 14:55:50",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050589",
        "positionId": "56050589",
        "volume": 5.72,
        "price": 3223.68,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -40.04,
        "priceIn": 3223.68,
        "doubleCheck": true
    },
    {
        "dataID": "116264",
        "id": "53086912",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:50",
        "brokerTime": "2025-05-14 14:55:51",
        "commission": -40.04,
        "swap": 0,
        "profit": -68.64,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050590",
        "positionId": "56050589",
        "volume": 5.72,
        "price": 3223.8,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -108.68,
        "priceIn": 3223.68,
        "doubleCheck": true
    },
    {
        "dataID": "116265",
        "id": "53086913",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:51",
        "brokerTime": "2025-05-14 14:55:51",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050591",
        "positionId": "56050591",
        "volume": 5.72,
        "price": 3223.62,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -40.04,
        "priceIn": 3223.62,
        "doubleCheck": true
    },
    {
        "dataID": "116266",
        "id": "53086914",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:51",
        "brokerTime": "2025-05-14 14:55:52",
        "commission": -40.04,
        "swap": 0,
        "profit": -114.4,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050592",
        "positionId": "56050591",
        "volume": 5.72,
        "price": 3223.82,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -154.44,
        "priceIn": 3223.62,
        "doubleCheck": true
    },
    {
        "dataID": "116267",
        "id": "53086915",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:52",
        "brokerTime": "2025-05-14 14:55:52",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050593",
        "positionId": "56050593",
        "volume": 5.72,
        "price": 3223.63,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -40.04,
        "priceIn": 3223.63,
        "doubleCheck": true
    },
    {
        "dataID": "116268",
        "id": "53086916",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:52",
        "brokerTime": "2025-05-14 14:55:53",
        "commission": -40.04,
        "swap": 0,
        "profit": -97.24,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050594",
        "positionId": "56050593",
        "volume": 5.72,
        "price": 3223.8,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -137.28,
        "priceIn": 3223.63,
        "doubleCheck": true
    },
    {
        "dataID": "116269",
        "id": "53086917",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:53",
        "brokerTime": "2025-05-14 14:55:53",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050595",
        "positionId": "56050595",
        "volume": 5.72,
        "price": 3223.66,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -40.04,
        "priceIn": 3223.66,
        "doubleCheck": true
    },
    {
        "dataID": "116270",
        "id": "53086918",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:53",
        "brokerTime": "2025-05-14 14:55:54",
        "commission": -40.04,
        "swap": 0,
        "profit": -80.08,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050596",
        "positionId": "56050595",
        "volume": 5.72,
        "price": 3223.8,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -120.12,
        "priceIn": 3223.66,
        "doubleCheck": true
    },
    {
        "dataID": "116271",
        "id": "53086919",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:54",
        "brokerTime": "2025-05-14 14:55:54",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050597",
        "positionId": "56050597",
        "volume": 5.72,
        "price": 3223.63,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -40.04,
        "priceIn": 3223.63,
        "doubleCheck": true
    },
    {
        "dataID": "116272",
        "id": "53086920",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:54",
        "brokerTime": "2025-05-14 14:55:54",
        "commission": -40.04,
        "swap": 0,
        "profit": -102.96,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050598",
        "positionId": "56050597",
        "volume": 5.72,
        "price": 3223.81,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -143,
        "priceIn": 3223.63,
        "doubleCheck": true
    },
    {
        "dataID": "116273",
        "id": "53086921",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:54",
        "brokerTime": "2025-05-14 14:55:54",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050599",
        "positionId": "56050599",
        "volume": 5.72,
        "price": 3223.65,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -40.04,
        "priceIn": 3223.65,
        "doubleCheck": true
    },
    {
        "dataID": "116274",
        "id": "53086922",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:54",
        "brokerTime": "2025-05-14 14:55:55",
        "commission": -40.04,
        "swap": 0,
        "profit": -97.24,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050600",
        "positionId": "56050599",
        "volume": 5.72,
        "price": 3223.82,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -137.28,
        "priceIn": 3223.65,
        "doubleCheck": true
    },
    {
        "dataID": "116275",
        "id": "53086923",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:55",
        "brokerTime": "2025-05-14 14:55:55",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050601",
        "positionId": "56050601",
        "volume": 5.72,
        "price": 3223.67,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -40.04,
        "priceIn": 3223.67,
        "doubleCheck": true
    },
    {
        "dataID": "116276",
        "id": "53086924",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:55",
        "brokerTime": "2025-05-14 14:55:56",
        "commission": -40.04,
        "swap": 0,
        "profit": -97.24,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050602",
        "positionId": "56050601",
        "volume": 5.72,
        "price": 3223.84,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -137.28,
        "priceIn": 3223.67,
        "doubleCheck": true
    },
    {
        "dataID": "116277",
        "id": "53086925",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:56",
        "brokerTime": "2025-05-14 14:55:56",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050603",
        "positionId": "56050603",
        "volume": 5.72,
        "price": 3223.57,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -40.04,
        "priceIn": 3223.57,
        "doubleCheck": true
    },
    {
        "dataID": "116278",
        "id": "53086926",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:56",
        "brokerTime": "2025-05-14 14:55:57",
        "commission": -40.04,
        "swap": 0,
        "profit": -125.84,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050604",
        "positionId": "56050603",
        "volume": 5.72,
        "price": 3223.79,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -165.88,
        "priceIn": 3223.57,
        "doubleCheck": true
    },
    {
        "dataID": "116279",
        "id": "53086927",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:57",
        "brokerTime": "2025-05-14 14:55:57",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050605",
        "positionId": "56050605",
        "volume": 5.72,
        "price": 3223.46,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -40.04,
        "priceIn": 3223.46,
        "doubleCheck": true
    },
    {
        "dataID": "116280",
        "id": "53086928",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:57",
        "brokerTime": "2025-05-14 14:55:58",
        "commission": -40.04,
        "swap": 0,
        "profit": -188.76,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050606",
        "positionId": "56050605",
        "volume": 5.72,
        "price": 3223.79,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -228.79999999999998,
        "priceIn": 3223.46,
        "doubleCheck": true
    },
    {
        "dataID": "116281",
        "id": "53086929",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:58",
        "brokerTime": "2025-05-14 14:55:58",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050607",
        "positionId": "56050607",
        "volume": 5.72,
        "price": 3223.6,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -40.04,
        "priceIn": 3223.6,
        "doubleCheck": true
    },
    {
        "dataID": "116282",
        "id": "53086930",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:58",
        "brokerTime": "2025-05-14 14:55:58",
        "commission": -40.04,
        "swap": 0,
        "profit": -102.96,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050608",
        "positionId": "56050607",
        "volume": 5.72,
        "price": 3223.78,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -143,
        "priceIn": 3223.6,
        "doubleCheck": true
    },
    {
        "dataID": "116283",
        "id": "53086931",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:58",
        "brokerTime": "2025-05-14 14:55:58",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050609",
        "positionId": "56050609",
        "volume": 5.72,
        "price": 3223.67,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -40.04,
        "priceIn": 3223.67,
        "doubleCheck": true
    },
    {
        "dataID": "116284",
        "id": "53086932",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:58",
        "brokerTime": "2025-05-14 14:55:59",
        "commission": -40.04,
        "swap": 0,
        "profit": -154.44,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050610",
        "positionId": "56050609",
        "volume": 5.72,
        "price": 3223.94,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -194.48,
        "priceIn": 3223.67,
        "doubleCheck": true
    },
    {
        "dataID": "116285",
        "id": "53086933",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:59",
        "brokerTime": "2025-05-14 14:55:59",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050611",
        "positionId": "56050611",
        "volume": 5.72,
        "price": 3224.04,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -40.04,
        "priceIn": 3224.04,
        "doubleCheck": true
    },
    {
        "dataID": "116286",
        "id": "53086934",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:59",
        "brokerTime": "2025-05-14 14:56:00",
        "commission": -40.04,
        "swap": 0,
        "profit": -68.64,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050612",
        "positionId": "56050611",
        "volume": 5.72,
        "price": 3224.16,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -108.68,
        "priceIn": 3224.04,
        "doubleCheck": true
    },
    {
        "dataID": "116287",
        "id": "53086935",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:00",
        "brokerTime": "2025-05-14 14:56:00",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050613",
        "positionId": "56050613",
        "volume": 5.72,
        "price": 3223.81,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -40.04,
        "priceIn": 3223.81,
        "doubleCheck": true
    },
    {
        "dataID": "116288",
        "id": "53086941",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:00",
        "brokerTime": "2025-05-14 14:56:01",
        "commission": -40.04,
        "swap": 0,
        "profit": -51.48,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050620",
        "positionId": "56050613",
        "volume": 5.72,
        "price": 3223.9,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -91.52,
        "priceIn": 3223.81,
        "doubleCheck": true
    },
    {
        "dataID": "116289",
        "id": "53086942",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:01",
        "brokerTime": "2025-05-14 14:56:01",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050621",
        "positionId": "56050621",
        "volume": 5.72,
        "price": 3223.83,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -40.04,
        "priceIn": 3223.83,
        "doubleCheck": true
    },
    {
        "dataID": "116290",
        "id": "53086949",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:01",
        "brokerTime": "2025-05-14 14:56:01",
        "commission": -40.04,
        "swap": 0,
        "profit": -22.88,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050626",
        "positionId": "56050621",
        "volume": 5.72,
        "price": 3223.87,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -62.92,
        "priceIn": 3223.83,
        "doubleCheck": true
    },
    {
        "dataID": "116291",
        "id": "53086953",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:02",
        "brokerTime": "2025-05-14 14:56:02",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050630",
        "positionId": "56050630",
        "volume": 5.72,
        "price": 3223.7,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -40.04,
        "priceIn": 3223.7,
        "doubleCheck": true
    },
    {
        "dataID": "116292",
        "id": "53087001",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:02",
        "brokerTime": "2025-05-14 14:56:02",
        "commission": -40.04,
        "swap": 0,
        "profit": -68.64,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050663",
        "positionId": "56050630",
        "volume": 5.72,
        "price": 3223.82,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -108.68,
        "priceIn": 3223.7,
        "doubleCheck": true
    },
    {
        "dataID": "116293",
        "id": "53087004",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:03",
        "brokerTime": "2025-05-14 14:56:03",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050664",
        "positionId": "56050664",
        "volume": 5.72,
        "price": 3223.7,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -40.04,
        "priceIn": 3223.7,
        "doubleCheck": true
    },
    {
        "dataID": "116294",
        "id": "53087005",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:03",
        "brokerTime": "2025-05-14 14:56:03",
        "commission": -40.04,
        "swap": 0,
        "profit": -114.4,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050665",
        "positionId": "56050664",
        "volume": 5.72,
        "price": 3223.9,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -154.44,
        "priceIn": 3223.7,
        "doubleCheck": true
    },
    {
        "dataID": "116295",
        "id": "53087007",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:04",
        "brokerTime": "2025-05-14 14:56:04",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050667",
        "positionId": "56050667",
        "volume": 5.72,
        "price": 3223.74,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -40.04,
        "priceIn": 3223.74,
        "doubleCheck": true
    },
    {
        "dataID": "116296",
        "id": "53087008",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:04",
        "brokerTime": "2025-05-14 14:56:04",
        "commission": -40.04,
        "swap": 0,
        "profit": -188.76,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050668",
        "positionId": "56050667",
        "volume": 5.72,
        "price": 3224.07,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -228.79999999999998,
        "priceIn": 3223.74,
        "doubleCheck": true
    },
    {
        "dataID": "116297",
        "id": "53087009",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:05",
        "brokerTime": "2025-05-14 14:56:05",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050669",
        "positionId": "56050669",
        "volume": 5.72,
        "price": 3223.81,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -40.04,
        "priceIn": 3223.81,
        "doubleCheck": true
    },
    {
        "dataID": "116298",
        "id": "53087010",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:05",
        "brokerTime": "2025-05-14 14:56:06",
        "commission": -40.04,
        "swap": 0,
        "profit": -91.52,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050671",
        "positionId": "56050669",
        "volume": 5.72,
        "price": 3223.97,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -131.56,
        "priceIn": 3223.81,
        "doubleCheck": true
    },
    {
        "dataID": "116299",
        "id": "53087011",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:06",
        "brokerTime": "2025-05-14 14:56:06",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050672",
        "positionId": "56050672",
        "volume": 5.72,
        "price": 3223.84,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -40.04,
        "priceIn": 3223.84,
        "doubleCheck": true
    },
    {
        "dataID": "116300",
        "id": "53087012",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:06",
        "brokerTime": "2025-05-14 14:56:07",
        "commission": -40.04,
        "swap": 0,
        "profit": -108.68,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050673",
        "positionId": "56050672",
        "volume": 5.72,
        "price": 3224.03,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -148.72,
        "priceIn": 3223.84,
        "doubleCheck": true
    },
    {
        "dataID": "116301",
        "id": "53087014",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:07",
        "brokerTime": "2025-05-14 14:56:07",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050675",
        "positionId": "56050675",
        "volume": 5.72,
        "price": 3223.9,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -40.04,
        "priceIn": 3223.9,
        "doubleCheck": true
    },
    {
        "dataID": "116302",
        "id": "53087015",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:07",
        "brokerTime": "2025-05-14 14:56:08",
        "commission": -40.04,
        "swap": 0,
        "profit": -217.36,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050676",
        "positionId": "56050675",
        "volume": 5.72,
        "price": 3224.28,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -257.40000000000003,
        "priceIn": 3223.9,
        "doubleCheck": true
    },
    {
        "dataID": "116303",
        "id": "53087016",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:08",
        "brokerTime": "2025-05-14 14:56:08",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050677",
        "positionId": "56050677",
        "volume": 5.72,
        "price": 3224.08,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -40.04,
        "priceIn": 3224.08,
        "doubleCheck": true
    },
    {
        "dataID": "116304",
        "id": "53087017",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:08",
        "brokerTime": "2025-05-14 14:56:09",
        "commission": -40.04,
        "swap": 0,
        "profit": -91.52,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050678",
        "positionId": "56050677",
        "volume": 5.72,
        "price": 3224.24,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -131.56,
        "priceIn": 3224.08,
        "doubleCheck": true
    },
    {
        "dataID": "116305",
        "id": "53087018",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:09",
        "brokerTime": "2025-05-14 14:56:09",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050679",
        "positionId": "56050679",
        "volume": 5.72,
        "price": 3224.11,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -40.04,
        "priceIn": 3224.11,
        "doubleCheck": true
    },
    {
        "dataID": "116306",
        "id": "53087019",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:09",
        "brokerTime": "2025-05-14 14:56:10",
        "commission": -40.04,
        "swap": 0,
        "profit": -137.28,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050680",
        "positionId": "56050679",
        "volume": 5.72,
        "price": 3224.35,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -177.32,
        "priceIn": 3224.11,
        "doubleCheck": true
    },
    {
        "dataID": "116307",
        "id": "53087020",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:10",
        "brokerTime": "2025-05-14 14:56:10",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050681",
        "positionId": "56050681",
        "volume": 5.72,
        "price": 3224.23,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -40.04,
        "priceIn": 3224.23,
        "doubleCheck": true
    },
    {
        "dataID": "116308",
        "id": "53087022",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:10",
        "brokerTime": "2025-05-14 14:56:10",
        "commission": -40.04,
        "swap": 0,
        "profit": -97.24,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050683",
        "positionId": "56050681",
        "volume": 5.72,
        "price": 3224.4,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -137.28,
        "priceIn": 3224.23,
        "doubleCheck": true
    },
    {
        "dataID": "116309",
        "id": "53087023",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:11",
        "brokerTime": "2025-05-14 14:56:11",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050684",
        "positionId": "56050684",
        "volume": 5.72,
        "price": 3224.21,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -40.04,
        "priceIn": 3224.21,
        "doubleCheck": true
    },
    {
        "dataID": "116310",
        "id": "53087024",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:11",
        "brokerTime": "2025-05-14 14:56:11",
        "commission": -40.04,
        "swap": 0,
        "profit": -120.12,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050685",
        "positionId": "56050684",
        "volume": 5.72,
        "price": 3224.42,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -160.16,
        "priceIn": 3224.21,
        "doubleCheck": true
    },
    {
        "dataID": "116311",
        "id": "53087025",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:12",
        "brokerTime": "2025-05-14 14:56:12",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050686",
        "positionId": "56050686",
        "volume": 5.72,
        "price": 3224.2,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -40.04,
        "priceIn": 3224.2,
        "doubleCheck": true
    },
    {
        "dataID": "116312",
        "id": "53087031",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:12",
        "brokerTime": "2025-05-14 14:56:13",
        "commission": -40.04,
        "swap": 0,
        "profit": -205.92,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050692",
        "positionId": "56050686",
        "volume": 5.72,
        "price": 3224.56,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -245.95999999999998,
        "priceIn": 3224.2,
        "doubleCheck": true
    },
    {
        "dataID": "116313",
        "id": "53087032",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:13",
        "brokerTime": "2025-05-14 14:56:13",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050693",
        "positionId": "56050693",
        "volume": 5.72,
        "price": 3223.63,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -40.04,
        "priceIn": 3223.63,
        "doubleCheck": true
    },
    {
        "dataID": "116314",
        "id": "53087033",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:13",
        "brokerTime": "2025-05-14 14:56:14",
        "commission": -40.04,
        "swap": 0,
        "profit": -108.68,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050694",
        "positionId": "56050693",
        "volume": 5.72,
        "price": 3223.82,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -148.72,
        "priceIn": 3223.63,
        "doubleCheck": true
    },
    {
        "dataID": "116315",
        "id": "53087034",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:14",
        "brokerTime": "2025-05-14 14:56:14",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050695",
        "positionId": "56050695",
        "volume": 5.72,
        "price": 3223.56,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -40.04,
        "priceIn": 3223.56,
        "doubleCheck": true
    },
    {
        "dataID": "116316",
        "id": "53087035",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:14",
        "brokerTime": "2025-05-14 14:56:15",
        "commission": -40.04,
        "swap": 0,
        "profit": -194.48,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050696",
        "positionId": "56050695",
        "volume": 5.72,
        "price": 3223.9,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -234.51999999999998,
        "priceIn": 3223.56,
        "doubleCheck": true
    },
    {
        "dataID": "116317",
        "id": "53087036",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:15",
        "brokerTime": "2025-05-14 14:56:15",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050697",
        "positionId": "56050697",
        "volume": 5.72,
        "price": 3223.96,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -40.04,
        "priceIn": 3223.96,
        "doubleCheck": true
    },
    {
        "dataID": "116318",
        "id": "53087037",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:15",
        "brokerTime": "2025-05-14 14:56:15",
        "commission": -40.04,
        "swap": 0,
        "profit": -137.28,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050698",
        "positionId": "56050697",
        "volume": 5.72,
        "price": 3224.2,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -177.32,
        "priceIn": 3223.96,
        "doubleCheck": true
    },
    {
        "dataID": "116319",
        "id": "53087038",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:16",
        "brokerTime": "2025-05-14 14:56:16",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050699",
        "positionId": "56050699",
        "volume": 5.72,
        "price": 3223.98,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -40.04,
        "priceIn": 3223.98,
        "doubleCheck": true
    },
    {
        "dataID": "116320",
        "id": "53087039",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:16",
        "brokerTime": "2025-05-14 14:56:17",
        "commission": -40.04,
        "swap": 0,
        "profit": -68.64,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050700",
        "positionId": "56050699",
        "volume": 5.72,
        "price": 3224.1,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -108.68,
        "priceIn": 3223.98,
        "doubleCheck": true
    },
    {
        "dataID": "116321",
        "id": "53087040",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:18",
        "brokerTime": "2025-05-14 14:56:18",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050701",
        "positionId": "56050701",
        "volume": 5.72,
        "price": 3224.09,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -40.04,
        "priceIn": 3224.09,
        "doubleCheck": true
    },
    {
        "dataID": "116322",
        "id": "53087041",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:18",
        "brokerTime": "2025-05-14 14:56:19",
        "commission": -40.04,
        "swap": 0,
        "profit": -91.52,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050702",
        "positionId": "56050701",
        "volume": 5.72,
        "price": 3224.25,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -131.56,
        "priceIn": 3224.09,
        "doubleCheck": true
    },
    {
        "dataID": "116323",
        "id": "53087042",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:20",
        "brokerTime": "2025-05-14 14:56:20",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050703",
        "positionId": "56050703",
        "volume": 5.72,
        "price": 3224.08,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -40.04,
        "priceIn": 3224.08,
        "doubleCheck": true
    },
    {
        "dataID": "116324",
        "id": "53087043",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:20",
        "brokerTime": "2025-05-14 14:56:21",
        "commission": -40.04,
        "swap": 0,
        "profit": -97.24,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050704",
        "positionId": "56050703",
        "volume": 5.72,
        "price": 3224.25,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -137.28,
        "priceIn": 3224.08,
        "doubleCheck": true
    },
    {
        "dataID": "116325",
        "id": "53087044",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:21",
        "brokerTime": "2025-05-14 14:56:21",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050705",
        "positionId": "56050705",
        "volume": 5.72,
        "price": 3224.08,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -40.04,
        "priceIn": 3224.08,
        "doubleCheck": true
    },
    {
        "dataID": "116326",
        "id": "53087045",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:21",
        "brokerTime": "2025-05-14 14:56:21",
        "commission": -40.04,
        "swap": 0,
        "profit": -91.52,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050706",
        "positionId": "56050705",
        "volume": 5.72,
        "price": 3224.24,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -131.56,
        "priceIn": 3224.08,
        "doubleCheck": true
    },
    {
        "dataID": "116327",
        "id": "53087046",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:22",
        "brokerTime": "2025-05-14 14:56:22",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050707",
        "positionId": "56050707",
        "volume": 5.72,
        "price": 3223.94,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -40.04,
        "priceIn": 3223.94,
        "doubleCheck": true
    },
    {
        "dataID": "116328",
        "id": "53087047",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:22",
        "brokerTime": "2025-05-14 14:56:23",
        "commission": -40.04,
        "swap": 0,
        "profit": -97.24,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050708",
        "positionId": "56050707",
        "volume": 5.72,
        "price": 3224.11,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -137.28,
        "priceIn": 3223.94,
        "doubleCheck": true
    },
    {
        "dataID": "116329",
        "id": "53087048",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:23",
        "brokerTime": "2025-05-14 14:56:23",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050709",
        "positionId": "56050709",
        "volume": 5.72,
        "price": 3223.89,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -40.04,
        "priceIn": 3223.89,
        "doubleCheck": true
    },
    {
        "dataID": "116330",
        "id": "53087049",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:23",
        "brokerTime": "2025-05-14 14:56:24",
        "commission": -40.04,
        "swap": 0,
        "profit": -108.68,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050710",
        "positionId": "56050709",
        "volume": 5.72,
        "price": 3224.08,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -148.72,
        "priceIn": 3223.89,
        "doubleCheck": true
    },
    {
        "dataID": "116331",
        "id": "53087050",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:24",
        "brokerTime": "2025-05-14 14:56:24",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050711",
        "positionId": "56050711",
        "volume": 5.72,
        "price": 3223.84,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -40.04,
        "priceIn": 3223.84,
        "doubleCheck": true
    },
    {
        "dataID": "116332",
        "id": "53087051",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:24",
        "brokerTime": "2025-05-14 14:56:25",
        "commission": -40.04,
        "swap": 0,
        "profit": -148.72,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050712",
        "positionId": "56050711",
        "volume": 5.72,
        "price": 3224.1,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -188.76,
        "priceIn": 3223.84,
        "doubleCheck": true
    },
    {
        "dataID": "116333",
        "id": "53087052",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:25",
        "brokerTime": "2025-05-14 14:56:25",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050713",
        "positionId": "56050713",
        "volume": 5.72,
        "price": 3223.97,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -40.04,
        "priceIn": 3223.97,
        "doubleCheck": true
    },
    {
        "dataID": "116334",
        "id": "53087053",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:25",
        "brokerTime": "2025-05-14 14:56:25",
        "commission": -40.04,
        "swap": 0,
        "profit": -120.12,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050714",
        "positionId": "56050713",
        "volume": 5.72,
        "price": 3224.18,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -160.16,
        "priceIn": 3223.97,
        "doubleCheck": true
    },
    {
        "dataID": "116335",
        "id": "53087054",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:25",
        "brokerTime": "2025-05-14 14:56:25",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050715",
        "positionId": "56050715",
        "volume": 5.72,
        "price": 3223.88,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -40.04,
        "priceIn": 3223.88,
        "doubleCheck": true
    },
    {
        "dataID": "116336",
        "id": "53087055",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:25",
        "brokerTime": "2025-05-14 14:56:26",
        "commission": -40.04,
        "swap": 0,
        "profit": -120.12,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050716",
        "positionId": "56050715",
        "volume": 5.72,
        "price": 3224.09,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -160.16,
        "priceIn": 3223.88,
        "doubleCheck": true
    },
    {
        "dataID": "116337",
        "id": "53087056",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:26",
        "brokerTime": "2025-05-14 14:56:26",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050717",
        "positionId": "56050717",
        "volume": 5.72,
        "price": 3223.88,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -40.04,
        "priceIn": 3223.88,
        "doubleCheck": true
    },
    {
        "dataID": "116338",
        "id": "53087057",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:26",
        "brokerTime": "2025-05-14 14:56:27",
        "commission": -40.04,
        "swap": 0,
        "profit": -62.92,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050718",
        "positionId": "56050717",
        "volume": 5.72,
        "price": 3223.99,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -102.96000000000001,
        "priceIn": 3223.88,
        "doubleCheck": true
    },
    {
        "dataID": "116339",
        "id": "53087058",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:27",
        "brokerTime": "2025-05-14 14:56:27",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050719",
        "positionId": "56050719",
        "volume": 5.72,
        "price": 3223.78,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -40.04,
        "priceIn": 3223.78,
        "doubleCheck": true
    },
    {
        "dataID": "116340",
        "id": "53087059",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:27",
        "brokerTime": "2025-05-14 14:56:28",
        "commission": -40.04,
        "swap": 0,
        "profit": -114.4,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050721",
        "positionId": "56050719",
        "volume": 5.72,
        "price": 3223.98,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -154.44,
        "priceIn": 3223.78,
        "doubleCheck": true
    },
    {
        "dataID": "116341",
        "id": "53087061",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:29",
        "brokerTime": "2025-05-14 14:56:29",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050722",
        "positionId": "56050722",
        "volume": 5.72,
        "price": 3223.82,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -40.04,
        "priceIn": 3223.82,
        "doubleCheck": true
    },
    {
        "dataID": "116342",
        "id": "53087062",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:29",
        "brokerTime": "2025-05-14 14:56:29",
        "commission": -40.04,
        "swap": 0,
        "profit": -137.28,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050723",
        "positionId": "56050722",
        "volume": 5.72,
        "price": 3224.06,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -177.32,
        "priceIn": 3223.82,
        "doubleCheck": true
    },
    {
        "dataID": "116343",
        "id": "53087063",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:30",
        "brokerTime": "2025-05-14 14:56:30",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050724",
        "positionId": "56050724",
        "volume": 5.72,
        "price": 3223.91,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -40.04,
        "priceIn": 3223.91,
        "doubleCheck": true
    },
    {
        "dataID": "116344",
        "id": "53087064",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:30",
        "brokerTime": "2025-05-14 14:56:31",
        "commission": -40.04,
        "swap": 0,
        "profit": -108.68,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050725",
        "positionId": "56050724",
        "volume": 5.72,
        "price": 3224.1,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -148.72,
        "priceIn": 3223.91,
        "doubleCheck": true
    },
    {
        "dataID": "116345",
        "id": "53087065",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:32",
        "brokerTime": "2025-05-14 14:56:32",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050726",
        "positionId": "56050726",
        "volume": 5.72,
        "price": 3223.97,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -40.04,
        "priceIn": 3223.97,
        "doubleCheck": true
    },
    {
        "dataID": "116346",
        "id": "53087066",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:32",
        "brokerTime": "2025-05-14 14:56:33",
        "commission": -40.04,
        "swap": 0,
        "profit": -194.48,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050727",
        "positionId": "56050726",
        "volume": 5.72,
        "price": 3224.31,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -234.51999999999998,
        "priceIn": 3223.97,
        "doubleCheck": true
    },
    {
        "dataID": "116347",
        "id": "53087067",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:33",
        "brokerTime": "2025-05-14 14:56:33",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050728",
        "positionId": "56050728",
        "volume": 5.72,
        "price": 3224.13,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -40.04,
        "priceIn": 3224.13,
        "doubleCheck": true
    },
    {
        "dataID": "116348",
        "id": "53087068",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:33",
        "brokerTime": "2025-05-14 14:56:34",
        "commission": -40.04,
        "swap": 0,
        "profit": -183.04,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050729",
        "positionId": "56050728",
        "volume": 5.72,
        "price": 3224.45,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -223.07999999999998,
        "priceIn": 3224.13,
        "doubleCheck": true
    },
    {
        "dataID": "116349",
        "id": "53087069",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:34",
        "brokerTime": "2025-05-14 14:56:34",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050730",
        "positionId": "56050730",
        "volume": 5.72,
        "price": 3224.12,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -40.04,
        "priceIn": 3224.12,
        "doubleCheck": true
    },
    {
        "dataID": "116350",
        "id": "53087070",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:34",
        "brokerTime": "2025-05-14 14:56:34",
        "commission": -40.04,
        "swap": 0,
        "profit": -91.52,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050731",
        "positionId": "56050730",
        "volume": 5.72,
        "price": 3224.28,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -131.56,
        "priceIn": 3224.12,
        "doubleCheck": true
    },
    {
        "dataID": "116351",
        "id": "53087071",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:34",
        "brokerTime": "2025-05-14 14:56:34",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050732",
        "positionId": "56050732",
        "volume": 5.72,
        "price": 3224.13,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -40.04,
        "priceIn": 3224.13,
        "doubleCheck": true
    },
    {
        "dataID": "116352",
        "id": "53087074",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:34",
        "brokerTime": "2025-05-14 14:56:35",
        "commission": -40.04,
        "swap": 0,
        "profit": -22.88,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050734",
        "positionId": "56050732",
        "volume": 5.72,
        "price": 3224.17,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -62.92,
        "priceIn": 3224.13,
        "doubleCheck": true
    },
    {
        "dataID": "116353",
        "id": "53087075",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:36",
        "brokerTime": "2025-05-14 14:56:36",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050735",
        "positionId": "56050735",
        "volume": 5.72,
        "price": 3223.97,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -40.04,
        "priceIn": 3223.97,
        "doubleCheck": true
    },
    {
        "dataID": "116354",
        "id": "53087076",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:36",
        "brokerTime": "2025-05-14 14:56:36",
        "commission": -40.04,
        "swap": 0,
        "profit": -131.56,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050736",
        "positionId": "56050735",
        "volume": 5.72,
        "price": 3224.2,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -171.6,
        "priceIn": 3223.97,
        "doubleCheck": true
    },
    {
        "dataID": "116355",
        "id": "53087077",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:36",
        "brokerTime": "2025-05-14 14:56:36",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050737",
        "positionId": "56050737",
        "volume": 5.72,
        "price": 3223.99,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -40.04,
        "priceIn": 3223.99,
        "doubleCheck": true
    },
    {
        "dataID": "116356",
        "id": "53087078",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:36",
        "brokerTime": "2025-05-14 14:56:37",
        "commission": -40.04,
        "swap": 0,
        "profit": -160.16,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050738",
        "positionId": "56050737",
        "volume": 5.72,
        "price": 3224.27,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -200.2,
        "priceIn": 3223.99,
        "doubleCheck": true
    },
    {
        "dataID": "116357",
        "id": "53087079",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:37",
        "brokerTime": "2025-05-14 14:56:37",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050739",
        "positionId": "56050739",
        "volume": 5.72,
        "price": 3224.06,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -40.04,
        "priceIn": 3224.06,
        "doubleCheck": true
    },
    {
        "dataID": "116358",
        "id": "53087080",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:37",
        "brokerTime": "2025-05-14 14:56:38",
        "commission": -40.04,
        "swap": 0,
        "profit": -102.96,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050740",
        "positionId": "56050739",
        "volume": 5.72,
        "price": 3224.24,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -143,
        "priceIn": 3224.06,
        "doubleCheck": true
    },
    {
        "dataID": "116359",
        "id": "53087081",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:38",
        "brokerTime": "2025-05-14 14:56:38",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050741",
        "positionId": "56050741",
        "volume": 5.72,
        "price": 3224.06,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -40.04,
        "priceIn": 3224.06,
        "doubleCheck": true
    },
    {
        "dataID": "116360",
        "id": "53087082",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:38",
        "brokerTime": "2025-05-14 14:56:38",
        "commission": -40.04,
        "swap": 0,
        "profit": -200.2,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050742",
        "positionId": "56050741",
        "volume": 5.72,
        "price": 3224.41,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -240.23999999999998,
        "priceIn": 3224.06,
        "doubleCheck": true
    },
    {
        "dataID": "116361",
        "id": "53087083",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:39",
        "brokerTime": "2025-05-14 14:56:39",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050743",
        "positionId": "56050743",
        "volume": 5.72,
        "price": 3224.27,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -40.04,
        "priceIn": 3224.27,
        "doubleCheck": true
    },
    {
        "dataID": "116362",
        "id": "53087084",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:39",
        "brokerTime": "2025-05-14 14:56:39",
        "commission": -40.04,
        "swap": 0,
        "profit": -74.36,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050744",
        "positionId": "56050743",
        "volume": 5.72,
        "price": 3224.4,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -114.4,
        "priceIn": 3224.27,
        "doubleCheck": true
    },
    {
        "dataID": "116363",
        "id": "53087085",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:39",
        "brokerTime": "2025-05-14 14:56:39",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050745",
        "positionId": "56050745",
        "volume": 5.72,
        "price": 3224.25,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -40.04,
        "priceIn": 3224.25,
        "doubleCheck": true
    },
    {
        "dataID": "116364",
        "id": "53087086",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:39",
        "brokerTime": "2025-05-14 14:56:40",
        "commission": -40.04,
        "swap": 0,
        "profit": -137.28,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050746",
        "positionId": "56050745",
        "volume": 5.72,
        "price": 3224.49,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -177.32,
        "priceIn": 3224.25,
        "doubleCheck": true
    },
    {
        "dataID": "116365",
        "id": "53087087",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:40",
        "brokerTime": "2025-05-14 14:56:40",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050747",
        "positionId": "56050747",
        "volume": 5.72,
        "price": 3224.35,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -40.04,
        "priceIn": 3224.35,
        "doubleCheck": true
    },
    {
        "dataID": "116366",
        "id": "53087088",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:40",
        "brokerTime": "2025-05-14 14:56:41",
        "commission": -40.04,
        "swap": 0,
        "profit": -22.88,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050748",
        "positionId": "56050747",
        "volume": 5.72,
        "price": 3224.39,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -62.92,
        "priceIn": 3224.35,
        "doubleCheck": true
    },
    {
        "dataID": "116367",
        "id": "53087089",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:41",
        "brokerTime": "2025-05-14 14:56:41",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050749",
        "positionId": "56050749",
        "volume": 5.72,
        "price": 3224.17,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -40.04,
        "priceIn": 3224.17,
        "doubleCheck": true
    },
    {
        "dataID": "116368",
        "id": "53087090",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:41",
        "brokerTime": "2025-05-14 14:56:41",
        "commission": -40.04,
        "swap": 0,
        "profit": 51.48,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050750",
        "positionId": "56050749",
        "volume": 5.72,
        "price": 3224.08,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 11.439999999999998,
        "priceIn": 3224.17,
        "doubleCheck": true
    },
    {
        "dataID": "116369",
        "id": "53087091",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:42",
        "brokerTime": "2025-05-14 14:56:42",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050751",
        "positionId": "56050751",
        "volume": 5.72,
        "price": 3223.86,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -40.04,
        "priceIn": 3223.86,
        "doubleCheck": true
    },
    {
        "dataID": "116370",
        "id": "53087092",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:42",
        "brokerTime": "2025-05-14 14:56:42",
        "commission": -40.04,
        "swap": 0,
        "profit": -114.4,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050752",
        "positionId": "56050751",
        "volume": 5.72,
        "price": 3224.06,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -154.44,
        "priceIn": 3223.86,
        "doubleCheck": true
    },
    {
        "dataID": "116371",
        "id": "53087093",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:42",
        "brokerTime": "2025-05-14 14:56:42",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050753",
        "positionId": "56050753",
        "volume": 5.72,
        "price": 3223.87,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -40.04,
        "priceIn": 3223.87,
        "doubleCheck": true
    },
    {
        "dataID": "116372",
        "id": "53087094",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:42",
        "brokerTime": "2025-05-14 14:56:43",
        "commission": -40.04,
        "swap": 0,
        "profit": -108.68,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050754",
        "positionId": "56050753",
        "volume": 5.72,
        "price": 3224.06,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -148.72,
        "priceIn": 3223.87,
        "doubleCheck": true
    },
    {
        "dataID": "116373",
        "id": "53087095",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:43",
        "brokerTime": "2025-05-14 14:56:43",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050755",
        "positionId": "56050755",
        "volume": 5.72,
        "price": 3224.04,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -40.04,
        "priceIn": 3224.04,
        "doubleCheck": true
    },
    {
        "dataID": "116374",
        "id": "53087096",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:43",
        "brokerTime": "2025-05-14 14:56:44",
        "commission": -40.04,
        "swap": 0,
        "profit": -108.68,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050756",
        "positionId": "56050755",
        "volume": 5.72,
        "price": 3224.23,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -148.72,
        "priceIn": 3224.04,
        "doubleCheck": true
    },
    {
        "dataID": "116375",
        "id": "53087097",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:44",
        "brokerTime": "2025-05-14 14:56:44",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050757",
        "positionId": "56050757",
        "volume": 5.72,
        "price": 3224.04,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -40.04,
        "priceIn": 3224.04,
        "doubleCheck": true
    },
    {
        "dataID": "116376",
        "id": "53087098",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:44",
        "brokerTime": "2025-05-14 14:56:45",
        "commission": -40.04,
        "swap": 0,
        "profit": 143,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050758",
        "positionId": "56050757",
        "volume": 5.72,
        "price": 3223.79,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 102.96000000000001,
        "priceIn": 3224.04,
        "doubleCheck": true
    },
    {
        "dataID": "116377",
        "id": "53087099",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:45",
        "brokerTime": "2025-05-14 14:56:45",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050759",
        "positionId": "56050759",
        "volume": 5.72,
        "price": 3223.56,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -40.04,
        "priceIn": 3223.56,
        "doubleCheck": true
    },
    {
        "dataID": "116378",
        "id": "53087100",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:45",
        "brokerTime": "2025-05-14 14:56:46",
        "commission": -40.04,
        "swap": 0,
        "profit": -102.96,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050760",
        "positionId": "56050759",
        "volume": 5.72,
        "price": 3223.74,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -143,
        "priceIn": 3223.56,
        "doubleCheck": true
    },
    {
        "dataID": "116379",
        "id": "53087101",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:46",
        "brokerTime": "2025-05-14 14:56:46",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050761",
        "positionId": "56050761",
        "volume": 5.72,
        "price": 3223.48,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -40.04,
        "priceIn": 3223.48,
        "doubleCheck": true
    },
    {
        "dataID": "116380",
        "id": "53087102",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:46",
        "brokerTime": "2025-05-14 14:56:47",
        "commission": -40.04,
        "swap": 0,
        "profit": -102.96,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050762",
        "positionId": "56050761",
        "volume": 5.72,
        "price": 3223.66,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -143,
        "priceIn": 3223.48,
        "doubleCheck": true
    },
    {
        "dataID": "116381",
        "id": "53087103",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:47",
        "brokerTime": "2025-05-14 14:56:47",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050763",
        "positionId": "56050763",
        "volume": 5.72,
        "price": 3223.5,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -40.04,
        "priceIn": 3223.5,
        "doubleCheck": true
    },
    {
        "dataID": "116382",
        "id": "53087104",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:47",
        "brokerTime": "2025-05-14 14:56:48",
        "commission": -40.04,
        "swap": 0,
        "profit": -74.36,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050764",
        "positionId": "56050763",
        "volume": 5.72,
        "price": 3223.63,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -114.4,
        "priceIn": 3223.5,
        "doubleCheck": true
    },
    {
        "dataID": "116383",
        "id": "53087105",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:49",
        "brokerTime": "2025-05-14 14:56:49",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050766",
        "positionId": "56050766",
        "volume": 5.72,
        "price": 3223.11,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -40.04,
        "priceIn": 3223.11,
        "doubleCheck": true
    },
    {
        "dataID": "116384",
        "id": "53087112",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:49",
        "brokerTime": "2025-05-14 14:56:50",
        "commission": -40.04,
        "swap": 0,
        "profit": 11.44,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050771",
        "positionId": "56050766",
        "volume": 5.72,
        "price": 3223.09,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -28.6,
        "priceIn": 3223.11,
        "doubleCheck": true
    },
    {
        "dataID": "116385",
        "id": "53087114",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:50",
        "brokerTime": "2025-05-14 14:56:50",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050772",
        "positionId": "56050772",
        "volume": 5.72,
        "price": 3222.72,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -40.04,
        "priceIn": 3222.72,
        "doubleCheck": true
    },
    {
        "dataID": "116386",
        "id": "53087115",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:50",
        "brokerTime": "2025-05-14 14:56:51",
        "commission": -40.04,
        "swap": 0,
        "profit": -148.72,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050773",
        "positionId": "56050772",
        "volume": 5.72,
        "price": 3222.98,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -188.76,
        "priceIn": 3222.72,
        "doubleCheck": true
    },
    {
        "dataID": "116387",
        "id": "53087116",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:51",
        "brokerTime": "2025-05-14 14:56:51",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050774",
        "positionId": "56050774",
        "volume": 5.72,
        "price": 3222.71,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -40.04,
        "priceIn": 3222.71,
        "doubleCheck": true
    },
    {
        "dataID": "116388",
        "id": "53087117",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:51",
        "brokerTime": "2025-05-14 14:56:52",
        "commission": -40.04,
        "swap": 0,
        "profit": -102.96,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050775",
        "positionId": "56050774",
        "volume": 5.72,
        "price": 3222.89,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -143,
        "priceIn": 3222.71,
        "doubleCheck": true
    },
    {
        "dataID": "116389",
        "id": "53087118",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:52",
        "brokerTime": "2025-05-14 14:56:52",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050777",
        "positionId": "56050777",
        "volume": 5.72,
        "price": 3222.81,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -40.04,
        "priceIn": 3222.81,
        "doubleCheck": true
    },
    {
        "dataID": "116390",
        "id": "53087120",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:52",
        "brokerTime": "2025-05-14 14:56:53",
        "commission": -40.04,
        "swap": 0,
        "profit": -137.28,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050778",
        "positionId": "56050777",
        "volume": 5.72,
        "price": 3223.05,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -177.32,
        "priceIn": 3222.81,
        "doubleCheck": true
    },
    {
        "dataID": "116391",
        "id": "53087121",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:54",
        "brokerTime": "2025-05-14 14:56:54",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050779",
        "positionId": "56050779",
        "volume": 5.72,
        "price": 3222.83,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -40.04,
        "priceIn": 3222.83,
        "doubleCheck": true
    },
    {
        "dataID": "116392",
        "id": "53087122",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:54",
        "brokerTime": "2025-05-14 14:56:54",
        "commission": -40.04,
        "swap": 0,
        "profit": -120.12,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050780",
        "positionId": "56050779",
        "volume": 5.72,
        "price": 3223.04,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -160.16,
        "priceIn": 3222.83,
        "doubleCheck": true
    },
    {
        "dataID": "116393",
        "id": "53087123",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:55",
        "brokerTime": "2025-05-14 14:56:55",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050781",
        "positionId": "56050781",
        "volume": 5.72,
        "price": 3222.83,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -40.04,
        "priceIn": 3222.83,
        "doubleCheck": true
    },
    {
        "dataID": "116394",
        "id": "53087124",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:55",
        "brokerTime": "2025-05-14 14:56:55",
        "commission": -40.04,
        "swap": 0,
        "profit": -200.2,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050782",
        "positionId": "56050781",
        "volume": 5.72,
        "price": 3223.18,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -240.23999999999998,
        "priceIn": 3222.83,
        "doubleCheck": true
    },
    {
        "dataID": "116395",
        "id": "53087125",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:55",
        "brokerTime": "2025-05-14 14:56:55",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050783",
        "positionId": "56050783",
        "volume": 5.72,
        "price": 3223.01,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -40.04,
        "priceIn": 3223.01,
        "doubleCheck": true
    },
    {
        "dataID": "116396",
        "id": "53087126",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:55",
        "brokerTime": "2025-05-14 14:56:56",
        "commission": -40.04,
        "swap": 0,
        "profit": 17.16,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050784",
        "positionId": "56050783",
        "volume": 5.72,
        "price": 3222.98,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -22.88,
        "priceIn": 3223.01,
        "doubleCheck": true
    },
    {
        "dataID": "116397",
        "id": "53087127",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:57",
        "brokerTime": "2025-05-14 14:56:57",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050785",
        "positionId": "56050785",
        "volume": 5.72,
        "price": 3222.73,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -40.04,
        "priceIn": 3222.73,
        "doubleCheck": true
    },
    {
        "dataID": "116398",
        "id": "53087128",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:57",
        "brokerTime": "2025-05-14 14:56:57",
        "commission": -40.04,
        "swap": 0,
        "profit": -97.24,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050786",
        "positionId": "56050785",
        "volume": 5.72,
        "price": 3222.9,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -137.28,
        "priceIn": 3222.73,
        "doubleCheck": true
    },
    {
        "dataID": "116399",
        "id": "53087130",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:57",
        "brokerTime": "2025-05-14 14:56:57",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050787",
        "positionId": "56050787",
        "volume": 5.72,
        "price": 3222.5,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -40.04,
        "priceIn": 3222.5,
        "doubleCheck": true
    },
    {
        "dataID": "116400",
        "id": "53087132",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:57",
        "brokerTime": "2025-05-14 14:56:58",
        "commission": -40.04,
        "swap": 0,
        "profit": -80.08,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050789",
        "positionId": "56050787",
        "volume": 5.72,
        "price": 3222.64,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -120.12,
        "priceIn": 3222.5,
        "doubleCheck": true
    },
    {
        "dataID": "116401",
        "id": "53087134",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:58",
        "brokerTime": "2025-05-14 14:56:58",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050790",
        "positionId": "56050790",
        "volume": 5.72,
        "price": 3222.37,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -40.04,
        "priceIn": 3222.37,
        "doubleCheck": true
    },
    {
        "dataID": "116402",
        "id": "53087138",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:58",
        "brokerTime": "2025-05-14 14:56:59",
        "commission": -40.04,
        "swap": 0,
        "profit": -97.24,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050794",
        "positionId": "56050790",
        "volume": 5.72,
        "price": 3222.54,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -137.28,
        "priceIn": 3222.37,
        "doubleCheck": true
    },
    {
        "dataID": "116403",
        "id": "53087142",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:59",
        "brokerTime": "2025-05-14 14:56:59",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050796",
        "positionId": "56050796",
        "volume": 5.72,
        "price": 3222.27,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -40.04,
        "priceIn": 3222.27,
        "doubleCheck": true
    },
    {
        "dataID": "116404",
        "id": "53087143",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:59",
        "brokerTime": "2025-05-14 14:57:00",
        "commission": -40.04,
        "swap": 0,
        "profit": -137.28,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050797",
        "positionId": "56050796",
        "volume": 5.72,
        "price": 3222.51,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -177.32,
        "priceIn": 3222.27,
        "doubleCheck": true
    },
    {
        "dataID": "116405",
        "id": "53087144",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:00",
        "brokerTime": "2025-05-14 14:57:00",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050798",
        "positionId": "56050798",
        "volume": 5.72,
        "price": 3222.23,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -40.04,
        "priceIn": 3222.23,
        "doubleCheck": true
    },
    {
        "dataID": "116406",
        "id": "53087162",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:00",
        "brokerTime": "2025-05-14 14:57:00",
        "commission": -40.04,
        "swap": 0,
        "profit": -97.24,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050816",
        "positionId": "56050798",
        "volume": 5.72,
        "price": 3222.4,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -137.28,
        "priceIn": 3222.23,
        "doubleCheck": true
    },
    {
        "dataID": "116407",
        "id": "53087164",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:01",
        "brokerTime": "2025-05-14 14:57:01",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050817",
        "positionId": "56050817",
        "volume": 5.72,
        "price": 3222.06,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -40.04,
        "priceIn": 3222.06,
        "doubleCheck": true
    },
    {
        "dataID": "116408",
        "id": "53087169",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:01",
        "brokerTime": "2025-05-14 14:57:01",
        "commission": -40.04,
        "swap": 0,
        "profit": 114.4,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050821",
        "positionId": "56050817",
        "volume": 5.72,
        "price": 3221.86,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 74.36000000000001,
        "priceIn": 3222.06,
        "doubleCheck": true
    },
    {
        "dataID": "116409",
        "id": "53087170",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 14:57:01",
        "brokerTime": "2025-05-14 14:57:01",
        "commission": -7.49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050822",
        "positionId": "56050822",
        "volume": 1.07,
        "price": 3221.82,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3321.82,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -7.49,
        "priceIn": 3221.82,
        "doubleCheck": true
    },
    {
        "dataID": "116410",
        "id": "53087237",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:03",
        "brokerTime": "2025-05-14 14:57:03",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050855",
        "positionId": "56050855",
        "volume": 7,
        "price": 3219.89,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3219.89,
        "doubleCheck": true
    },
    {
        "dataID": "116411",
        "id": "53087325",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:03",
        "brokerTime": "2025-05-14 14:57:04",
        "commission": -49,
        "swap": 0,
        "profit": -154,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050955",
        "positionId": "56050855",
        "volume": 7,
        "price": 3220.11,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -203,
        "priceIn": 3219.89,
        "doubleCheck": true
    },
    {
        "dataID": "116412",
        "id": "53087425",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:04",
        "brokerTime": "2025-05-14 14:57:04",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56050986",
        "positionId": "56050986",
        "volume": 7,
        "price": 3220.03,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3220.03,
        "doubleCheck": true
    },
    {
        "dataID": "116413",
        "id": "53087535",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:04",
        "brokerTime": "2025-05-14 14:57:04",
        "commission": -49,
        "swap": 0,
        "profit": -105,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051046",
        "positionId": "56050986",
        "volume": 7,
        "price": 3220.18,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -154,
        "priceIn": 3220.03,
        "doubleCheck": true
    },
    {
        "dataID": "116414",
        "id": "53087552",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:05",
        "brokerTime": "2025-05-14 14:57:05",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051061",
        "positionId": "56051061",
        "volume": 7,
        "price": 3219.93,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3219.93,
        "doubleCheck": true
    },
    {
        "dataID": "116415",
        "id": "53087571",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:05",
        "brokerTime": "2025-05-14 14:57:05",
        "commission": -49,
        "swap": 0,
        "profit": -133,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051072",
        "positionId": "56051061",
        "volume": 7,
        "price": 3220.12,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -182,
        "priceIn": 3219.93,
        "doubleCheck": true
    },
    {
        "dataID": "116416",
        "id": "53087581",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:05",
        "brokerTime": "2025-05-14 14:57:05",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051073",
        "positionId": "56051073",
        "volume": 7,
        "price": 3219.88,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3219.88,
        "doubleCheck": true
    },
    {
        "dataID": "116417",
        "id": "53087585",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:05",
        "brokerTime": "2025-05-14 14:57:06",
        "commission": -49,
        "swap": 0,
        "profit": -140,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051077",
        "positionId": "56051073",
        "volume": 7,
        "price": 3220.08,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -189,
        "priceIn": 3219.88,
        "doubleCheck": true
    },
    {
        "dataID": "116418",
        "id": "53087586",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:06",
        "brokerTime": "2025-05-14 14:57:06",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051078",
        "positionId": "56051078",
        "volume": 7,
        "price": 3219.85,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3219.85,
        "doubleCheck": true
    },
    {
        "dataID": "116419",
        "id": "53087590",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:06",
        "brokerTime": "2025-05-14 14:57:07",
        "commission": -49,
        "swap": 0,
        "profit": 49,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051082",
        "positionId": "56051078",
        "volume": 7,
        "price": 3219.78,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 0,
        "priceIn": 3219.85,
        "doubleCheck": true
    },
    {
        "dataID": "116420",
        "id": "53087594",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:07",
        "brokerTime": "2025-05-14 14:57:07",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051086",
        "positionId": "56051086",
        "volume": 7,
        "price": 3219.83,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3219.83,
        "doubleCheck": true
    },
    {
        "dataID": "116421",
        "id": "53087598",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:07",
        "brokerTime": "2025-05-14 14:57:08",
        "commission": -49,
        "swap": 0,
        "profit": -308,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051090",
        "positionId": "56051086",
        "volume": 7,
        "price": 3220.27,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -357,
        "priceIn": 3219.83,
        "doubleCheck": true
    },
    {
        "dataID": "116422",
        "id": "53087600",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:08",
        "brokerTime": "2025-05-14 14:57:08",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051092",
        "positionId": "56051092",
        "volume": 7,
        "price": 3220.2,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3220.2,
        "doubleCheck": true
    },
    {
        "dataID": "116423",
        "id": "53087602",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:08",
        "brokerTime": "2025-05-14 14:57:09",
        "commission": -49,
        "swap": 0,
        "profit": -84,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051093",
        "positionId": "56051092",
        "volume": 7,
        "price": 3220.32,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -133,
        "priceIn": 3220.2,
        "doubleCheck": true
    },
    {
        "dataID": "116424",
        "id": "53087603",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:10",
        "brokerTime": "2025-05-14 14:57:10",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051094",
        "positionId": "56051094",
        "volume": 7,
        "price": 3220.27,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3220.27,
        "doubleCheck": true
    },
    {
        "dataID": "116425",
        "id": "53087604",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:10",
        "brokerTime": "2025-05-14 14:57:10",
        "commission": -49,
        "swap": 0,
        "profit": -147,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051095",
        "positionId": "56051094",
        "volume": 7,
        "price": 3220.48,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -196,
        "priceIn": 3220.27,
        "doubleCheck": true
    },
    {
        "dataID": "116426",
        "id": "53087606",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:10",
        "brokerTime": "2025-05-14 14:57:10",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051097",
        "positionId": "56051097",
        "volume": 7,
        "price": 3220.32,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3220.32,
        "doubleCheck": true
    },
    {
        "dataID": "116427",
        "id": "53087608",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:10",
        "brokerTime": "2025-05-14 14:57:11",
        "commission": -49,
        "swap": 0,
        "profit": -266,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051099",
        "positionId": "56051097",
        "volume": 7,
        "price": 3220.7,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -315,
        "priceIn": 3220.32,
        "doubleCheck": true
    },
    {
        "dataID": "116428",
        "id": "53087610",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:11",
        "brokerTime": "2025-05-14 14:57:11",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051100",
        "positionId": "56051100",
        "volume": 7,
        "price": 3220.52,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3220.52,
        "doubleCheck": true
    },
    {
        "dataID": "116429",
        "id": "53087611",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:11",
        "brokerTime": "2025-05-14 14:57:11",
        "commission": -49,
        "swap": 0,
        "profit": -28,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051101",
        "positionId": "56051100",
        "volume": 7,
        "price": 3220.56,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -77,
        "priceIn": 3220.52,
        "doubleCheck": true
    },
    {
        "dataID": "116430",
        "id": "53087612",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:12",
        "brokerTime": "2025-05-14 14:57:12",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051102",
        "positionId": "56051102",
        "volume": 7,
        "price": 3219.97,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3219.97,
        "doubleCheck": true
    },
    {
        "dataID": "116431",
        "id": "53087613",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:12",
        "brokerTime": "2025-05-14 14:57:13",
        "commission": -49,
        "swap": 0,
        "profit": -105,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051103",
        "positionId": "56051102",
        "volume": 7,
        "price": 3220.12,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -154,
        "priceIn": 3219.97,
        "doubleCheck": true
    },
    {
        "dataID": "116432",
        "id": "53087614",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:13",
        "brokerTime": "2025-05-14 14:57:13",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051104",
        "positionId": "56051104",
        "volume": 7,
        "price": 3219.84,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3219.84,
        "doubleCheck": true
    },
    {
        "dataID": "116433",
        "id": "53087615",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:13",
        "brokerTime": "2025-05-14 14:57:14",
        "commission": -49,
        "swap": 0,
        "profit": -21,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051105",
        "positionId": "56051104",
        "volume": 7,
        "price": 3219.87,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -70,
        "priceIn": 3219.84,
        "doubleCheck": true
    },
    {
        "dataID": "116434",
        "id": "53087616",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:14",
        "brokerTime": "2025-05-14 14:57:14",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051106",
        "positionId": "56051106",
        "volume": 7,
        "price": 3219.95,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3219.95,
        "doubleCheck": true
    },
    {
        "dataID": "116435",
        "id": "53087617",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:14",
        "brokerTime": "2025-05-14 14:57:14",
        "commission": -49,
        "swap": 0,
        "profit": -70,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051107",
        "positionId": "56051106",
        "volume": 7,
        "price": 3220.05,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -119,
        "priceIn": 3219.95,
        "doubleCheck": true
    },
    {
        "dataID": "116436",
        "id": "53087618",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:15",
        "brokerTime": "2025-05-14 14:57:15",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051108",
        "positionId": "56051108",
        "volume": 7,
        "price": 3219.58,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3219.58,
        "doubleCheck": true
    },
    {
        "dataID": "116437",
        "id": "53087619",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:15",
        "brokerTime": "2025-05-14 14:57:16",
        "commission": -49,
        "swap": 0,
        "profit": -126,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051109",
        "positionId": "56051108",
        "volume": 7,
        "price": 3219.76,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -175,
        "priceIn": 3219.58,
        "doubleCheck": true
    },
    {
        "dataID": "116438",
        "id": "53087621",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:16",
        "brokerTime": "2025-05-14 14:57:16",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051111",
        "positionId": "56051111",
        "volume": 7,
        "price": 3219.63,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3219.63,
        "doubleCheck": true
    },
    {
        "dataID": "116439",
        "id": "53087623",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:16",
        "brokerTime": "2025-05-14 14:57:16",
        "commission": -49,
        "swap": 0,
        "profit": -140,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051112",
        "positionId": "56051111",
        "volume": 7,
        "price": 3219.83,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -189,
        "priceIn": 3219.63,
        "doubleCheck": true
    },
    {
        "dataID": "116440",
        "id": "53087626",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:17",
        "brokerTime": "2025-05-14 14:57:17",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051114",
        "positionId": "56051114",
        "volume": 7,
        "price": 3220.36,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3220.36,
        "doubleCheck": true
    },
    {
        "dataID": "116441",
        "id": "53087627",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:17",
        "brokerTime": "2025-05-14 14:57:18",
        "commission": -49,
        "swap": 0,
        "profit": -441,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051115",
        "positionId": "56051114",
        "volume": 7,
        "price": 3220.99,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -490,
        "priceIn": 3220.36,
        "doubleCheck": true
    },
    {
        "dataID": "116442",
        "id": "53087628",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:18",
        "brokerTime": "2025-05-14 14:57:18",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051116",
        "positionId": "56051116",
        "volume": 7,
        "price": 3220.58,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3220.58,
        "doubleCheck": true
    },
    {
        "dataID": "116443",
        "id": "53087629",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:18",
        "brokerTime": "2025-05-14 14:57:18",
        "commission": -49,
        "swap": 0,
        "profit": -70,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051117",
        "positionId": "56051116",
        "volume": 7,
        "price": 3220.68,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -119,
        "priceIn": 3220.58,
        "doubleCheck": true
    },
    {
        "dataID": "116444",
        "id": "53087630",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:19",
        "brokerTime": "2025-05-14 14:57:19",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051118",
        "positionId": "56051118",
        "volume": 7,
        "price": 3220.33,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3220.33,
        "doubleCheck": true
    },
    {
        "dataID": "116445",
        "id": "53087631",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:19",
        "brokerTime": "2025-05-14 14:57:20",
        "commission": -49,
        "swap": 0,
        "profit": -371,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051119",
        "positionId": "56051118",
        "volume": 7,
        "price": 3220.86,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -420,
        "priceIn": 3220.33,
        "doubleCheck": true
    },
    {
        "dataID": "116446",
        "id": "53087632",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:20",
        "brokerTime": "2025-05-14 14:57:20",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051120",
        "positionId": "56051120",
        "volume": 7,
        "price": 3220.71,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3220.71,
        "doubleCheck": true
    },
    {
        "dataID": "116447",
        "id": "53087634",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:20",
        "brokerTime": "2025-05-14 14:57:21",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051122",
        "positionId": "56051120",
        "volume": 7,
        "price": 3220.71,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3220.71,
        "doubleCheck": true
    },
    {
        "dataID": "116448",
        "id": "53087635",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:21",
        "brokerTime": "2025-05-14 14:57:21",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051123",
        "positionId": "56051123",
        "volume": 7,
        "price": 3220.56,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3220.56,
        "doubleCheck": true
    },
    {
        "dataID": "116449",
        "id": "53087636",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:21",
        "brokerTime": "2025-05-14 14:57:22",
        "commission": -49,
        "swap": 0,
        "profit": -273,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051124",
        "positionId": "56051123",
        "volume": 7,
        "price": 3220.95,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -322,
        "priceIn": 3220.56,
        "doubleCheck": true
    },
    {
        "dataID": "116450",
        "id": "53087638",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:22",
        "brokerTime": "2025-05-14 14:57:22",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051126",
        "positionId": "56051126",
        "volume": 7,
        "price": 3220.8,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3220.8,
        "doubleCheck": true
    },
    {
        "dataID": "116451",
        "id": "53087639",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:22",
        "brokerTime": "2025-05-14 14:57:23",
        "commission": -49,
        "swap": 0,
        "profit": -14,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051127",
        "positionId": "56051126",
        "volume": 7,
        "price": 3220.82,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -63,
        "priceIn": 3220.8,
        "doubleCheck": true
    },
    {
        "dataID": "116452",
        "id": "53087641",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:23",
        "brokerTime": "2025-05-14 14:57:23",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051129",
        "positionId": "56051129",
        "volume": 7,
        "price": 3220.46,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3220.46,
        "doubleCheck": true
    },
    {
        "dataID": "116453",
        "id": "53087642",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:23",
        "brokerTime": "2025-05-14 14:57:24",
        "commission": -49,
        "swap": 0,
        "profit": -217,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051130",
        "positionId": "56051129",
        "volume": 7,
        "price": 3220.77,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -266,
        "priceIn": 3220.46,
        "doubleCheck": true
    },
    {
        "dataID": "116454",
        "id": "53087643",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:24",
        "brokerTime": "2025-05-14 14:57:24",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051131",
        "positionId": "56051131",
        "volume": 7,
        "price": 3220.76,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3220.76,
        "doubleCheck": true
    },
    {
        "dataID": "116455",
        "id": "53087644",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:24",
        "brokerTime": "2025-05-14 14:57:24",
        "commission": -49,
        "swap": 0,
        "profit": -77,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051132",
        "positionId": "56051131",
        "volume": 7,
        "price": 3220.87,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -126,
        "priceIn": 3220.76,
        "doubleCheck": true
    },
    {
        "dataID": "116456",
        "id": "53087645",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:25",
        "brokerTime": "2025-05-14 14:57:25",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051133",
        "positionId": "56051133",
        "volume": 7,
        "price": 3221.3,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3221.3,
        "doubleCheck": true
    },
    {
        "dataID": "116457",
        "id": "53087646",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:25",
        "brokerTime": "2025-05-14 14:57:26",
        "commission": -49,
        "swap": 0,
        "profit": -14,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051134",
        "positionId": "56051133",
        "volume": 7,
        "price": 3221.32,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -63,
        "priceIn": 3221.3,
        "doubleCheck": true
    },
    {
        "dataID": "116458",
        "id": "53087647",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:26",
        "brokerTime": "2025-05-14 14:57:26",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051135",
        "positionId": "56051135",
        "volume": 7,
        "price": 3221.04,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3221.04,
        "doubleCheck": true
    },
    {
        "dataID": "116459",
        "id": "53087648",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:26",
        "brokerTime": "2025-05-14 14:57:26",
        "commission": -49,
        "swap": 0,
        "profit": -35,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051136",
        "positionId": "56051135",
        "volume": 7,
        "price": 3221.09,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -84,
        "priceIn": 3221.04,
        "doubleCheck": true
    },
    {
        "dataID": "116460",
        "id": "53087649",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:27",
        "brokerTime": "2025-05-14 14:57:27",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051137",
        "positionId": "56051137",
        "volume": 7,
        "price": 3220.83,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3220.83,
        "doubleCheck": true
    },
    {
        "dataID": "116461",
        "id": "53087650",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:27",
        "brokerTime": "2025-05-14 14:57:27",
        "commission": -49,
        "swap": 0,
        "profit": -224,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051138",
        "positionId": "56051137",
        "volume": 7,
        "price": 3221.15,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -273,
        "priceIn": 3220.83,
        "doubleCheck": true
    },
    {
        "dataID": "116462",
        "id": "53087651",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:28",
        "brokerTime": "2025-05-14 14:57:28",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051139",
        "positionId": "56051139",
        "volume": 7,
        "price": 3221.23,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3221.23,
        "doubleCheck": true
    },
    {
        "dataID": "116463",
        "id": "53087652",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:28",
        "brokerTime": "2025-05-14 14:57:28",
        "commission": -49,
        "swap": 0,
        "profit": -224,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051140",
        "positionId": "56051139",
        "volume": 7,
        "price": 3221.55,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -273,
        "priceIn": 3221.23,
        "doubleCheck": true
    },
    {
        "dataID": "116464",
        "id": "53087653",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:29",
        "brokerTime": "2025-05-14 14:57:29",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051141",
        "positionId": "56051141",
        "volume": 7,
        "price": 3221.26,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3221.26,
        "doubleCheck": true
    },
    {
        "dataID": "116465",
        "id": "53087654",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:29",
        "brokerTime": "2025-05-14 14:57:29",
        "commission": -49,
        "swap": 0,
        "profit": -98,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051142",
        "positionId": "56051141",
        "volume": 7,
        "price": 3221.4,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -147,
        "priceIn": 3221.26,
        "doubleCheck": true
    },
    {
        "dataID": "116466",
        "id": "53087655",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:29",
        "brokerTime": "2025-05-14 14:57:29",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051143",
        "positionId": "56051143",
        "volume": 7,
        "price": 3221.07,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3221.07,
        "doubleCheck": true
    },
    {
        "dataID": "116467",
        "id": "53087656",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:29",
        "brokerTime": "2025-05-14 14:57:30",
        "commission": -49,
        "swap": 0,
        "profit": -315,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051144",
        "positionId": "56051143",
        "volume": 7,
        "price": 3221.52,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -364,
        "priceIn": 3221.07,
        "doubleCheck": true
    },
    {
        "dataID": "116468",
        "id": "53087657",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:30",
        "brokerTime": "2025-05-14 14:57:30",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051145",
        "positionId": "56051145",
        "volume": 7,
        "price": 3221.37,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3221.37,
        "doubleCheck": true
    },
    {
        "dataID": "116469",
        "id": "53087661",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:30",
        "brokerTime": "2025-05-14 14:57:31",
        "commission": -49,
        "swap": 0,
        "profit": -581,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051150",
        "positionId": "56051145",
        "volume": 7,
        "price": 3222.2,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -630,
        "priceIn": 3221.37,
        "doubleCheck": true
    },
    {
        "dataID": "116470",
        "id": "53087663",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:31",
        "brokerTime": "2025-05-14 14:57:31",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051151",
        "positionId": "56051151",
        "volume": 7,
        "price": 3221.81,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3221.81,
        "doubleCheck": true
    },
    {
        "dataID": "116471",
        "id": "53087664",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:31",
        "brokerTime": "2025-05-14 14:57:32",
        "commission": -49,
        "swap": 0,
        "profit": -84,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051152",
        "positionId": "56051151",
        "volume": 7,
        "price": 3221.93,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -133,
        "priceIn": 3221.81,
        "doubleCheck": true
    },
    {
        "dataID": "116472",
        "id": "53087667",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:32",
        "brokerTime": "2025-05-14 14:57:32",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051155",
        "positionId": "56051155",
        "volume": 7,
        "price": 3221.63,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3221.63,
        "doubleCheck": true
    },
    {
        "dataID": "116473",
        "id": "53087670",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:32",
        "brokerTime": "2025-05-14 14:57:33",
        "commission": -49,
        "swap": 0,
        "profit": -168,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051156",
        "positionId": "56051155",
        "volume": 7,
        "price": 3221.87,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -217,
        "priceIn": 3221.63,
        "doubleCheck": true
    },
    {
        "dataID": "116474",
        "id": "53087671",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:33",
        "brokerTime": "2025-05-14 14:57:33",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051157",
        "positionId": "56051157",
        "volume": 7,
        "price": 3221.43,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3221.43,
        "doubleCheck": true
    },
    {
        "dataID": "116475",
        "id": "53087672",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:33",
        "brokerTime": "2025-05-14 14:57:34",
        "commission": -49,
        "swap": 0,
        "profit": -28,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051158",
        "positionId": "56051157",
        "volume": 7,
        "price": 3221.47,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -77,
        "priceIn": 3221.43,
        "doubleCheck": true
    },
    {
        "dataID": "116476",
        "id": "53087673",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:34",
        "brokerTime": "2025-05-14 14:57:34",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051159",
        "positionId": "56051159",
        "volume": 7,
        "price": 3221.32,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3221.32,
        "doubleCheck": true
    },
    {
        "dataID": "116477",
        "id": "53087674",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:34",
        "brokerTime": "2025-05-14 14:57:34",
        "commission": -49,
        "swap": 0,
        "profit": -126,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051160",
        "positionId": "56051159",
        "volume": 7,
        "price": 3221.5,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -175,
        "priceIn": 3221.32,
        "doubleCheck": true
    },
    {
        "dataID": "116478",
        "id": "53087675",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:35",
        "brokerTime": "2025-05-14 14:57:35",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051161",
        "positionId": "56051161",
        "volume": 7,
        "price": 3221.53,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3221.53,
        "doubleCheck": true
    },
    {
        "dataID": "116479",
        "id": "53087676",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:35",
        "brokerTime": "2025-05-14 14:57:35",
        "commission": -49,
        "swap": 0,
        "profit": -77,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051162",
        "positionId": "56051161",
        "volume": 7,
        "price": 3221.64,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -126,
        "priceIn": 3221.53,
        "doubleCheck": true
    },
    {
        "dataID": "116480",
        "id": "53087677",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:35",
        "brokerTime": "2025-05-14 14:57:35",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051163",
        "positionId": "56051163",
        "volume": 7,
        "price": 3221.39,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3221.39,
        "doubleCheck": true
    },
    {
        "dataID": "116481",
        "id": "53087678",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:35",
        "brokerTime": "2025-05-14 14:57:36",
        "commission": -49,
        "swap": 0,
        "profit": 42,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051164",
        "positionId": "56051163",
        "volume": 7,
        "price": 3221.33,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -7,
        "priceIn": 3221.39,
        "doubleCheck": true
    },
    {
        "dataID": "116482",
        "id": "53087679",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:36",
        "brokerTime": "2025-05-14 14:57:36",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051165",
        "positionId": "56051165",
        "volume": 7,
        "price": 3221.09,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3221.09,
        "doubleCheck": true
    },
    {
        "dataID": "116483",
        "id": "53087680",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:36",
        "brokerTime": "2025-05-14 14:57:37",
        "commission": -49,
        "swap": 0,
        "profit": -322,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051166",
        "positionId": "56051165",
        "volume": 7,
        "price": 3221.55,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -371,
        "priceIn": 3221.09,
        "doubleCheck": true
    },
    {
        "dataID": "116484",
        "id": "53087681",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:37",
        "brokerTime": "2025-05-14 14:57:37",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051167",
        "positionId": "56051167",
        "volume": 7,
        "price": 3221.43,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3221.43,
        "doubleCheck": true
    },
    {
        "dataID": "116485",
        "id": "53087682",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:37",
        "brokerTime": "2025-05-14 14:57:38",
        "commission": -49,
        "swap": 0,
        "profit": -161,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051168",
        "positionId": "56051167",
        "volume": 7,
        "price": 3221.66,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -210,
        "priceIn": 3221.43,
        "doubleCheck": true
    },
    {
        "dataID": "116486",
        "id": "53087683",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:38",
        "brokerTime": "2025-05-14 14:57:38",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051169",
        "positionId": "56051169",
        "volume": 7,
        "price": 3221.39,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3221.39,
        "doubleCheck": true
    },
    {
        "dataID": "116487",
        "id": "53087684",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:38",
        "brokerTime": "2025-05-14 14:57:39",
        "commission": -49,
        "swap": 0,
        "profit": -196,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051170",
        "positionId": "56051169",
        "volume": 7,
        "price": 3221.67,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -245,
        "priceIn": 3221.39,
        "doubleCheck": true
    },
    {
        "dataID": "116488",
        "id": "53087685",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:39",
        "brokerTime": "2025-05-14 14:57:39",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051171",
        "positionId": "56051171",
        "volume": 7,
        "price": 3221.75,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3221.75,
        "doubleCheck": true
    },
    {
        "dataID": "116489",
        "id": "53087722",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:39",
        "brokerTime": "2025-05-14 14:57:40",
        "commission": -49,
        "swap": 0,
        "profit": -791,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051208",
        "positionId": "56051171",
        "volume": 7,
        "price": 3222.88,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -840,
        "priceIn": 3221.75,
        "doubleCheck": true
    },
    {
        "dataID": "116490",
        "id": "53087725",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:41",
        "brokerTime": "2025-05-14 14:57:41",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051211",
        "positionId": "56051211",
        "volume": 7,
        "price": 3222.52,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3222.52,
        "doubleCheck": true
    },
    {
        "dataID": "116491",
        "id": "53087786",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:41",
        "brokerTime": "2025-05-14 14:57:41",
        "commission": -49,
        "swap": 0,
        "profit": -252,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051276",
        "positionId": "56051211",
        "volume": 7,
        "price": 3222.88,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -301,
        "priceIn": 3222.52,
        "doubleCheck": true
    },
    {
        "dataID": "116492",
        "id": "53087810",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:41",
        "brokerTime": "2025-05-14 14:57:41",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051287",
        "positionId": "56051287",
        "volume": 7,
        "price": 3222.62,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3222.62,
        "doubleCheck": true
    },
    {
        "dataID": "116493",
        "id": "53087817",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:41",
        "brokerTime": "2025-05-14 14:57:42",
        "commission": -49,
        "swap": 0,
        "profit": -189,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051294",
        "positionId": "56051287",
        "volume": 7,
        "price": 3222.89,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -238,
        "priceIn": 3222.62,
        "doubleCheck": true
    },
    {
        "dataID": "116494",
        "id": "53087824",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:43",
        "brokerTime": "2025-05-14 14:57:43",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051299",
        "positionId": "56051299",
        "volume": 7,
        "price": 3222.74,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3222.74,
        "doubleCheck": true
    },
    {
        "dataID": "116495",
        "id": "53087826",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:43",
        "brokerTime": "2025-05-14 14:57:43",
        "commission": -49,
        "swap": 0,
        "profit": -63,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051301",
        "positionId": "56051299",
        "volume": 7,
        "price": 3222.83,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -112,
        "priceIn": 3222.74,
        "doubleCheck": true
    },
    {
        "dataID": "116496",
        "id": "53087827",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:44",
        "brokerTime": "2025-05-14 14:57:44",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051302",
        "positionId": "56051302",
        "volume": 7,
        "price": 3222.47,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3222.47,
        "doubleCheck": true
    },
    {
        "dataID": "116497",
        "id": "53087828",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:44",
        "brokerTime": "2025-05-14 14:57:44",
        "commission": -49,
        "swap": 0,
        "profit": -133,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051303",
        "positionId": "56051302",
        "volume": 7,
        "price": 3222.66,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -182,
        "priceIn": 3222.47,
        "doubleCheck": true
    },
    {
        "dataID": "116498",
        "id": "53087829",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:45",
        "brokerTime": "2025-05-14 14:57:45",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051304",
        "positionId": "56051304",
        "volume": 7,
        "price": 3222.69,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3222.69,
        "doubleCheck": true
    },
    {
        "dataID": "116499",
        "id": "53087830",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:45",
        "brokerTime": "2025-05-14 14:57:45",
        "commission": -49,
        "swap": 0,
        "profit": -140,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051305",
        "positionId": "56051304",
        "volume": 7,
        "price": 3222.89,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -189,
        "priceIn": 3222.69,
        "doubleCheck": true
    },
    {
        "dataID": "116500",
        "id": "53087831",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:45",
        "brokerTime": "2025-05-14 14:57:45",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051306",
        "positionId": "56051306",
        "volume": 7,
        "price": 3222.71,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3222.71,
        "doubleCheck": true
    },
    {
        "dataID": "116501",
        "id": "53087865",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:45",
        "brokerTime": "2025-05-14 14:57:46",
        "commission": -49,
        "swap": 0,
        "profit": -133,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051340",
        "positionId": "56051306",
        "volume": 7,
        "price": 3222.9,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -182,
        "priceIn": 3222.71,
        "doubleCheck": true
    },
    {
        "dataID": "116502",
        "id": "53087872",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:47",
        "brokerTime": "2025-05-14 14:57:47",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051341",
        "positionId": "56051341",
        "volume": 7,
        "price": 3222.66,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3222.66,
        "doubleCheck": true
    },
    {
        "dataID": "116503",
        "id": "53087873",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:47",
        "brokerTime": "2025-05-14 14:57:47",
        "commission": -49,
        "swap": 0,
        "profit": -161,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051342",
        "positionId": "56051341",
        "volume": 7,
        "price": 3222.89,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -210,
        "priceIn": 3222.66,
        "doubleCheck": true
    },
    {
        "dataID": "116504",
        "id": "53087874",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:47",
        "brokerTime": "2025-05-14 14:57:47",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051343",
        "positionId": "56051343",
        "volume": 7,
        "price": 3222.69,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3222.69,
        "doubleCheck": true
    },
    {
        "dataID": "116505",
        "id": "53087875",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:47",
        "brokerTime": "2025-05-14 14:57:48",
        "commission": -49,
        "swap": 0,
        "profit": -119,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051344",
        "positionId": "56051343",
        "volume": 7,
        "price": 3222.86,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -168,
        "priceIn": 3222.69,
        "doubleCheck": true
    },
    {
        "dataID": "116506",
        "id": "53087876",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:48",
        "brokerTime": "2025-05-14 14:57:48",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051345",
        "positionId": "56051345",
        "volume": 7,
        "price": 3222.61,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3222.61,
        "doubleCheck": true
    },
    {
        "dataID": "116507",
        "id": "53087877",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:48",
        "brokerTime": "2025-05-14 14:57:49",
        "commission": -49,
        "swap": 0,
        "profit": -161,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051346",
        "positionId": "56051345",
        "volume": 7,
        "price": 3222.84,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -210,
        "priceIn": 3222.61,
        "doubleCheck": true
    },
    {
        "dataID": "116508",
        "id": "53087878",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:50",
        "brokerTime": "2025-05-14 14:57:50",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051347",
        "positionId": "56051347",
        "volume": 7,
        "price": 3222.33,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3222.33,
        "doubleCheck": true
    },
    {
        "dataID": "116509",
        "id": "53087896",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:50",
        "brokerTime": "2025-05-14 14:57:50",
        "commission": -49,
        "swap": 0,
        "profit": -182,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051365",
        "positionId": "56051347",
        "volume": 7,
        "price": 3222.59,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -231,
        "priceIn": 3222.33,
        "doubleCheck": true
    },
    {
        "dataID": "116510",
        "id": "53087898",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:50",
        "brokerTime": "2025-05-14 14:57:50",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051366",
        "positionId": "56051366",
        "volume": 7,
        "price": 3222.39,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3222.39,
        "doubleCheck": true
    },
    {
        "dataID": "116511",
        "id": "53087917",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:50",
        "brokerTime": "2025-05-14 14:57:51",
        "commission": -49,
        "swap": 0,
        "profit": -133,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051384",
        "positionId": "56051366",
        "volume": 7,
        "price": 3222.58,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -182,
        "priceIn": 3222.39,
        "doubleCheck": true
    },
    {
        "dataID": "116512",
        "id": "53087919",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:52",
        "brokerTime": "2025-05-14 14:57:52",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051385",
        "positionId": "56051385",
        "volume": 7,
        "price": 3222.32,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3222.32,
        "doubleCheck": true
    },
    {
        "dataID": "116513",
        "id": "53087920",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:52",
        "brokerTime": "2025-05-14 14:57:52",
        "commission": -49,
        "swap": 0,
        "profit": -119,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051386",
        "positionId": "56051385",
        "volume": 7,
        "price": 3222.49,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -168,
        "priceIn": 3222.32,
        "doubleCheck": true
    },
    {
        "dataID": "116514",
        "id": "53087921",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:52",
        "brokerTime": "2025-05-14 14:57:52",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051387",
        "positionId": "56051387",
        "volume": 7,
        "price": 3222.48,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3222.48,
        "doubleCheck": true
    },
    {
        "dataID": "116515",
        "id": "53087922",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:52",
        "brokerTime": "2025-05-14 14:57:53",
        "commission": -49,
        "swap": 0,
        "profit": -175,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051388",
        "positionId": "56051387",
        "volume": 7,
        "price": 3222.73,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -224,
        "priceIn": 3222.48,
        "doubleCheck": true
    },
    {
        "dataID": "116516",
        "id": "53087923",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:53",
        "brokerTime": "2025-05-14 14:57:53",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051389",
        "positionId": "56051389",
        "volume": 7,
        "price": 3222.5,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3222.5,
        "doubleCheck": true
    },
    {
        "dataID": "116517",
        "id": "53087924",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:53",
        "brokerTime": "2025-05-14 14:57:55",
        "commission": -49,
        "swap": 0,
        "profit": -154,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051390",
        "positionId": "56051389",
        "volume": 7,
        "price": 3222.72,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -203,
        "priceIn": 3222.5,
        "doubleCheck": true
    },
    {
        "dataID": "116518",
        "id": "53087925",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:55",
        "brokerTime": "2025-05-14 14:57:55",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051391",
        "positionId": "56051391",
        "volume": 7,
        "price": 3222.41,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3222.41,
        "doubleCheck": true
    },
    {
        "dataID": "116519",
        "id": "53087926",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:55",
        "brokerTime": "2025-05-14 14:57:56",
        "commission": -49,
        "swap": 0,
        "profit": -112,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051392",
        "positionId": "56051391",
        "volume": 7,
        "price": 3222.57,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -161,
        "priceIn": 3222.41,
        "doubleCheck": true
    },
    {
        "dataID": "116520",
        "id": "53087927",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:56",
        "brokerTime": "2025-05-14 14:57:56",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051393",
        "positionId": "56051393",
        "volume": 7,
        "price": 3222.34,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3222.34,
        "doubleCheck": true
    },
    {
        "dataID": "116521",
        "id": "53087928",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:56",
        "brokerTime": "2025-05-14 14:57:56",
        "commission": -49,
        "swap": 0,
        "profit": -70,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051394",
        "positionId": "56051393",
        "volume": 7,
        "price": 3222.44,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -119,
        "priceIn": 3222.34,
        "doubleCheck": true
    },
    {
        "dataID": "116522",
        "id": "53087929",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:57",
        "brokerTime": "2025-05-14 14:57:57",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051395",
        "positionId": "56051395",
        "volume": 7,
        "price": 3222.21,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3222.21,
        "doubleCheck": true
    },
    {
        "dataID": "116523",
        "id": "53087930",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:57",
        "brokerTime": "2025-05-14 14:57:57",
        "commission": -49,
        "swap": 0,
        "profit": -294,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051396",
        "positionId": "56051395",
        "volume": 7,
        "price": 3222.63,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -343,
        "priceIn": 3222.21,
        "doubleCheck": true
    },
    {
        "dataID": "116524",
        "id": "53087931",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:58",
        "brokerTime": "2025-05-14 14:57:58",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051397",
        "positionId": "56051397",
        "volume": 7,
        "price": 3222.48,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3222.48,
        "doubleCheck": true
    },
    {
        "dataID": "116525",
        "id": "53087932",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:58",
        "brokerTime": "2025-05-14 14:57:58",
        "commission": -49,
        "swap": 0,
        "profit": -126,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051398",
        "positionId": "56051397",
        "volume": 7,
        "price": 3222.66,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -175,
        "priceIn": 3222.48,
        "doubleCheck": true
    },
    {
        "dataID": "116526",
        "id": "53087933",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:58",
        "brokerTime": "2025-05-14 14:57:58",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051399",
        "positionId": "56051399",
        "volume": 7,
        "price": 3222.35,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3222.35,
        "doubleCheck": true
    },
    {
        "dataID": "116527",
        "id": "53087934",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:58",
        "brokerTime": "2025-05-14 14:57:59",
        "commission": -49,
        "swap": 0,
        "profit": -126,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051400",
        "positionId": "56051399",
        "volume": 7,
        "price": 3222.53,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -175,
        "priceIn": 3222.35,
        "doubleCheck": true
    },
    {
        "dataID": "116528",
        "id": "53087935",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:59",
        "brokerTime": "2025-05-14 14:57:59",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051401",
        "positionId": "56051401",
        "volume": 7,
        "price": 3222.32,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3222.32,
        "doubleCheck": true
    },
    {
        "dataID": "116529",
        "id": "53087936",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:59",
        "brokerTime": "2025-05-14 14:58:00",
        "commission": -49,
        "swap": 0,
        "profit": -161,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051402",
        "positionId": "56051401",
        "volume": 7,
        "price": 3222.55,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -210,
        "priceIn": 3222.32,
        "doubleCheck": true
    },
    {
        "dataID": "116530",
        "id": "53087938",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:00",
        "brokerTime": "2025-05-14 14:58:00",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051404",
        "positionId": "56051404",
        "volume": 7,
        "price": 3222.4,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3222.4,
        "doubleCheck": true
    },
    {
        "dataID": "116531",
        "id": "53087939",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:00",
        "brokerTime": "2025-05-14 14:58:01",
        "commission": -49,
        "swap": 0,
        "profit": -91,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051405",
        "positionId": "56051404",
        "volume": 7,
        "price": 3222.53,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -140,
        "priceIn": 3222.4,
        "doubleCheck": true
    },
    {
        "dataID": "116532",
        "id": "53087945",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:01",
        "brokerTime": "2025-05-14 14:58:01",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051411",
        "positionId": "56051411",
        "volume": 7,
        "price": 3222.3,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3222.3,
        "doubleCheck": true
    },
    {
        "dataID": "116533",
        "id": "53088004",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:01",
        "brokerTime": "2025-05-14 14:58:02",
        "commission": -49,
        "swap": 0,
        "profit": -182,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051480",
        "positionId": "56051411",
        "volume": 7,
        "price": 3222.56,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -231,
        "priceIn": 3222.3,
        "doubleCheck": true
    },
    {
        "dataID": "116534",
        "id": "53088115",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:02",
        "brokerTime": "2025-05-14 14:58:02",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051538",
        "positionId": "56051538",
        "volume": 7,
        "price": 3222.25,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3222.25,
        "doubleCheck": true
    },
    {
        "dataID": "116535",
        "id": "53088141",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:02",
        "brokerTime": "2025-05-14 14:58:03",
        "commission": -49,
        "swap": 0,
        "profit": -147,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051541",
        "positionId": "56051538",
        "volume": 7,
        "price": 3222.46,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -196,
        "priceIn": 3222.25,
        "doubleCheck": true
    },
    {
        "dataID": "116536",
        "id": "53088142",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:04",
        "brokerTime": "2025-05-14 14:58:04",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051542",
        "positionId": "56051542",
        "volume": 7,
        "price": 3222.23,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3222.23,
        "doubleCheck": true
    },
    {
        "dataID": "116537",
        "id": "53088146",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:04",
        "brokerTime": "2025-05-14 14:58:04",
        "commission": -49,
        "swap": 0,
        "profit": -98,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051545",
        "positionId": "56051542",
        "volume": 7,
        "price": 3222.37,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -147,
        "priceIn": 3222.23,
        "doubleCheck": true
    },
    {
        "dataID": "116538",
        "id": "53088147",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:05",
        "brokerTime": "2025-05-14 14:58:05",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051546",
        "positionId": "56051546",
        "volume": 7,
        "price": 3222.1,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3222.1,
        "doubleCheck": true
    },
    {
        "dataID": "116539",
        "id": "53088148",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:05",
        "brokerTime": "2025-05-14 14:58:05",
        "commission": -49,
        "swap": 0,
        "profit": -112,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051547",
        "positionId": "56051546",
        "volume": 7,
        "price": 3222.26,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -161,
        "priceIn": 3222.1,
        "doubleCheck": true
    },
    {
        "dataID": "116540",
        "id": "53088149",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:05",
        "brokerTime": "2025-05-14 14:58:05",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051548",
        "positionId": "56051548",
        "volume": 7,
        "price": 3222.03,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3222.03,
        "doubleCheck": true
    },
    {
        "dataID": "116541",
        "id": "53088150",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:05",
        "brokerTime": "2025-05-14 14:58:06",
        "commission": -49,
        "swap": 0,
        "profit": -63,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051549",
        "positionId": "56051548",
        "volume": 7,
        "price": 3222.12,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -112,
        "priceIn": 3222.03,
        "doubleCheck": true
    },
    {
        "dataID": "116542",
        "id": "53088151",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:06",
        "brokerTime": "2025-05-14 14:58:06",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051550",
        "positionId": "56051550",
        "volume": 7,
        "price": 3221.86,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3221.86,
        "doubleCheck": true
    },
    {
        "dataID": "116543",
        "id": "53088152",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:06",
        "brokerTime": "2025-05-14 14:58:07",
        "commission": -49,
        "swap": 0,
        "profit": -182,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051551",
        "positionId": "56051550",
        "volume": 7,
        "price": 3222.12,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -231,
        "priceIn": 3221.86,
        "doubleCheck": true
    },
    {
        "dataID": "116544",
        "id": "53088153",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:07",
        "brokerTime": "2025-05-14 14:58:07",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051552",
        "positionId": "56051552",
        "volume": 7,
        "price": 3221.86,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3221.86,
        "doubleCheck": true
    },
    {
        "dataID": "116545",
        "id": "53088154",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:07",
        "brokerTime": "2025-05-14 14:58:07",
        "commission": -49,
        "swap": 0,
        "profit": -133,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051553",
        "positionId": "56051552",
        "volume": 7,
        "price": 3222.05,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -182,
        "priceIn": 3221.86,
        "doubleCheck": true
    },
    {
        "dataID": "116546",
        "id": "53088155",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:08",
        "brokerTime": "2025-05-14 14:58:08",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051554",
        "positionId": "56051554",
        "volume": 7,
        "price": 3221.85,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3221.85,
        "doubleCheck": true
    },
    {
        "dataID": "116547",
        "id": "53088156",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:08",
        "brokerTime": "2025-05-14 14:58:08",
        "commission": -49,
        "swap": 0,
        "profit": -203,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051555",
        "positionId": "56051554",
        "volume": 7,
        "price": 3222.14,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -252,
        "priceIn": 3221.85,
        "doubleCheck": true
    },
    {
        "dataID": "116548",
        "id": "53088158",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:09",
        "brokerTime": "2025-05-14 14:58:09",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051557",
        "positionId": "56051557",
        "volume": 7,
        "price": 3221.94,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3221.94,
        "doubleCheck": true
    },
    {
        "dataID": "116549",
        "id": "53088159",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:09",
        "brokerTime": "2025-05-14 14:58:10",
        "commission": -49,
        "swap": 0,
        "profit": 14,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051558",
        "positionId": "56051557",
        "volume": 7,
        "price": 3221.92,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -35,
        "priceIn": 3221.94,
        "doubleCheck": true
    },
    {
        "dataID": "116550",
        "id": "53088160",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:10",
        "brokerTime": "2025-05-14 14:58:10",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051559",
        "positionId": "56051559",
        "volume": 7,
        "price": 3221.65,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3221.65,
        "doubleCheck": true
    },
    {
        "dataID": "116551",
        "id": "53088161",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:10",
        "brokerTime": "2025-05-14 14:58:11",
        "commission": -49,
        "swap": 0,
        "profit": -119,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051560",
        "positionId": "56051559",
        "volume": 7,
        "price": 3221.82,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -168,
        "priceIn": 3221.65,
        "doubleCheck": true
    },
    {
        "dataID": "116552",
        "id": "53088162",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:11",
        "brokerTime": "2025-05-14 14:58:11",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051561",
        "positionId": "56051561",
        "volume": 7,
        "price": 3221.64,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3221.64,
        "doubleCheck": true
    },
    {
        "dataID": "116553",
        "id": "53088163",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:11",
        "brokerTime": "2025-05-14 14:58:12",
        "commission": -49,
        "swap": 0,
        "profit": -70,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051562",
        "positionId": "56051561",
        "volume": 7,
        "price": 3221.74,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -119,
        "priceIn": 3221.64,
        "doubleCheck": true
    },
    {
        "dataID": "116554",
        "id": "53088164",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:12",
        "brokerTime": "2025-05-14 14:58:12",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051563",
        "positionId": "56051563",
        "volume": 7,
        "price": 3221.45,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3221.45,
        "doubleCheck": true
    },
    {
        "dataID": "116555",
        "id": "53088165",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:12",
        "brokerTime": "2025-05-14 14:58:12",
        "commission": -49,
        "swap": 0,
        "profit": -259,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051564",
        "positionId": "56051563",
        "volume": 7,
        "price": 3221.82,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -308,
        "priceIn": 3221.45,
        "doubleCheck": true
    },
    {
        "dataID": "116556",
        "id": "53088166",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:13",
        "brokerTime": "2025-05-14 14:58:13",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051565",
        "positionId": "56051565",
        "volume": 7,
        "price": 3221.54,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3221.54,
        "doubleCheck": true
    },
    {
        "dataID": "116557",
        "id": "53088167",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:13",
        "brokerTime": "2025-05-14 14:58:14",
        "commission": -49,
        "swap": 0,
        "profit": -154,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051566",
        "positionId": "56051565",
        "volume": 7,
        "price": 3221.76,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -203,
        "priceIn": 3221.54,
        "doubleCheck": true
    },
    {
        "dataID": "116558",
        "id": "53088168",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:14",
        "brokerTime": "2025-05-14 14:58:14",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051567",
        "positionId": "56051567",
        "volume": 7,
        "price": 3221.55,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3221.55,
        "doubleCheck": true
    },
    {
        "dataID": "116559",
        "id": "53088170",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:14",
        "brokerTime": "2025-05-14 14:58:15",
        "commission": -49,
        "swap": 0,
        "profit": -84,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051569",
        "positionId": "56051567",
        "volume": 7,
        "price": 3221.67,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -133,
        "priceIn": 3221.55,
        "doubleCheck": true
    },
    {
        "dataID": "116560",
        "id": "53088171",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:15",
        "brokerTime": "2025-05-14 14:58:15",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051570",
        "positionId": "56051570",
        "volume": 7,
        "price": 3221.72,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3221.72,
        "doubleCheck": true
    },
    {
        "dataID": "116561",
        "id": "53088172",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:15",
        "brokerTime": "2025-05-14 14:58:16",
        "commission": -49,
        "swap": 0,
        "profit": -217,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051571",
        "positionId": "56051570",
        "volume": 7,
        "price": 3222.03,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -266,
        "priceIn": 3221.72,
        "doubleCheck": true
    },
    {
        "dataID": "116562",
        "id": "53088173",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:16",
        "brokerTime": "2025-05-14 14:58:16",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051572",
        "positionId": "56051572",
        "volume": 7,
        "price": 3221.89,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3221.89,
        "doubleCheck": true
    },
    {
        "dataID": "116563",
        "id": "53088174",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:16",
        "brokerTime": "2025-05-14 14:58:17",
        "commission": -49,
        "swap": 0,
        "profit": 105,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051573",
        "positionId": "56051572",
        "volume": 7,
        "price": 3221.74,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 56,
        "priceIn": 3221.89,
        "doubleCheck": true
    },
    {
        "dataID": "116564",
        "id": "53088175",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:17",
        "brokerTime": "2025-05-14 14:58:17",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051574",
        "positionId": "56051574",
        "volume": 7,
        "price": 3221.47,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3221.47,
        "doubleCheck": true
    },
    {
        "dataID": "116565",
        "id": "53088176",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:17",
        "brokerTime": "2025-05-14 14:58:18",
        "commission": -49,
        "swap": 0,
        "profit": -70,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051575",
        "positionId": "56051574",
        "volume": 7,
        "price": 3221.57,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -119,
        "priceIn": 3221.47,
        "doubleCheck": true
    },
    {
        "dataID": "116566",
        "id": "53088177",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:18",
        "brokerTime": "2025-05-14 14:58:18",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051576",
        "positionId": "56051576",
        "volume": 7,
        "price": 3221.29,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3221.29,
        "doubleCheck": true
    },
    {
        "dataID": "116567",
        "id": "53088178",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:18",
        "brokerTime": "2025-05-14 14:58:18",
        "commission": -49,
        "swap": 0,
        "profit": -518,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051577",
        "positionId": "56051576",
        "volume": 7,
        "price": 3222.03,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -567,
        "priceIn": 3221.29,
        "doubleCheck": true
    },
    {
        "dataID": "116568",
        "id": "53088179",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:19",
        "brokerTime": "2025-05-14 14:58:19",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051578",
        "positionId": "56051578",
        "volume": 7,
        "price": 3221.79,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3221.79,
        "doubleCheck": true
    },
    {
        "dataID": "116569",
        "id": "53088180",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:19",
        "brokerTime": "2025-05-14 14:58:19",
        "commission": -49,
        "swap": 0,
        "profit": -147,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051579",
        "positionId": "56051578",
        "volume": 7,
        "price": 3222,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -196,
        "priceIn": 3221.79,
        "doubleCheck": true
    },
    {
        "dataID": "116570",
        "id": "53088181",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:20",
        "brokerTime": "2025-05-14 14:58:20",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051580",
        "positionId": "56051580",
        "volume": 7,
        "price": 3221.89,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3221.89,
        "doubleCheck": true
    },
    {
        "dataID": "116571",
        "id": "53088182",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:20",
        "brokerTime": "2025-05-14 14:58:20",
        "commission": -49,
        "swap": 0,
        "profit": -84,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051581",
        "positionId": "56051580",
        "volume": 7,
        "price": 3222.01,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -133,
        "priceIn": 3221.89,
        "doubleCheck": true
    },
    {
        "dataID": "116572",
        "id": "53088183",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:20",
        "brokerTime": "2025-05-14 14:58:20",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051582",
        "positionId": "56051582",
        "volume": 7,
        "price": 3221.65,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3221.65,
        "doubleCheck": true
    },
    {
        "dataID": "116573",
        "id": "53088184",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:20",
        "brokerTime": "2025-05-14 14:58:21",
        "commission": -49,
        "swap": 0,
        "profit": -133,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051583",
        "positionId": "56051582",
        "volume": 7,
        "price": 3221.84,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -182,
        "priceIn": 3221.65,
        "doubleCheck": true
    },
    {
        "dataID": "116574",
        "id": "53088186",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:21",
        "brokerTime": "2025-05-14 14:58:21",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051585",
        "positionId": "56051585",
        "volume": 7,
        "price": 3221.63,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3221.63,
        "doubleCheck": true
    },
    {
        "dataID": "116575",
        "id": "53088187",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:21",
        "brokerTime": "2025-05-14 14:58:22",
        "commission": -49,
        "swap": 0,
        "profit": -231,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051586",
        "positionId": "56051585",
        "volume": 7,
        "price": 3221.96,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -280,
        "priceIn": 3221.63,
        "doubleCheck": true
    },
    {
        "dataID": "116576",
        "id": "53088188",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:22",
        "brokerTime": "2025-05-14 14:58:22",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051587",
        "positionId": "56051587",
        "volume": 7,
        "price": 3221.73,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3221.73,
        "doubleCheck": true
    },
    {
        "dataID": "116577",
        "id": "53088189",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:22",
        "brokerTime": "2025-05-14 14:58:23",
        "commission": -49,
        "swap": 0,
        "profit": -154,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051588",
        "positionId": "56051587",
        "volume": 7,
        "price": 3221.95,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -203,
        "priceIn": 3221.73,
        "doubleCheck": true
    },
    {
        "dataID": "116578",
        "id": "53088190",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:23",
        "brokerTime": "2025-05-14 14:58:23",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051589",
        "positionId": "56051589",
        "volume": 7,
        "price": 3221.74,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3221.74,
        "doubleCheck": true
    },
    {
        "dataID": "116579",
        "id": "53088191",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:23",
        "brokerTime": "2025-05-14 14:58:24",
        "commission": -49,
        "swap": 0,
        "profit": -280,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051591",
        "positionId": "56051589",
        "volume": 7,
        "price": 3222.14,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -329,
        "priceIn": 3221.74,
        "doubleCheck": true
    },
    {
        "dataID": "116580",
        "id": "53088192",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:25",
        "brokerTime": "2025-05-14 14:58:25",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051592",
        "positionId": "56051592",
        "volume": 7,
        "price": 3221.82,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3221.82,
        "doubleCheck": true
    },
    {
        "dataID": "116581",
        "id": "53088193",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:25",
        "brokerTime": "2025-05-14 14:58:25",
        "commission": -49,
        "swap": 0,
        "profit": -91,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051593",
        "positionId": "56051592",
        "volume": 7,
        "price": 3221.95,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -140,
        "priceIn": 3221.82,
        "doubleCheck": true
    },
    {
        "dataID": "116582",
        "id": "53088194",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:26",
        "brokerTime": "2025-05-14 14:58:26",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051594",
        "positionId": "56051594",
        "volume": 7,
        "price": 3221.84,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3221.84,
        "doubleCheck": true
    },
    {
        "dataID": "116583",
        "id": "53088195",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:26",
        "brokerTime": "2025-05-14 14:58:26",
        "commission": -49,
        "swap": 0,
        "profit": -119,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051595",
        "positionId": "56051594",
        "volume": 7,
        "price": 3222.01,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -168,
        "priceIn": 3221.84,
        "doubleCheck": true
    },
    {
        "dataID": "116584",
        "id": "53088196",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:26",
        "brokerTime": "2025-05-14 14:58:26",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051596",
        "positionId": "56051596",
        "volume": 7,
        "price": 3221.75,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3221.75,
        "doubleCheck": true
    },
    {
        "dataID": "116585",
        "id": "53088197",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:26",
        "brokerTime": "2025-05-14 14:58:27",
        "commission": -49,
        "swap": 0,
        "profit": -140,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051597",
        "positionId": "56051596",
        "volume": 7,
        "price": 3221.95,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -189,
        "priceIn": 3221.75,
        "doubleCheck": true
    },
    {
        "dataID": "116586",
        "id": "53088198",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:27",
        "brokerTime": "2025-05-14 14:58:27",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051598",
        "positionId": "56051598",
        "volume": 7,
        "price": 3221.69,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3221.69,
        "doubleCheck": true
    },
    {
        "dataID": "116587",
        "id": "53088199",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:27",
        "brokerTime": "2025-05-14 14:58:28",
        "commission": -49,
        "swap": 0,
        "profit": -63,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051599",
        "positionId": "56051598",
        "volume": 7,
        "price": 3221.78,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -112,
        "priceIn": 3221.69,
        "doubleCheck": true
    },
    {
        "dataID": "116588",
        "id": "53088200",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:28",
        "brokerTime": "2025-05-14 14:58:28",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051600",
        "positionId": "56051600",
        "volume": 7,
        "price": 3221.66,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3221.66,
        "doubleCheck": true
    },
    {
        "dataID": "116589",
        "id": "53088201",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:28",
        "brokerTime": "2025-05-14 14:58:29",
        "commission": -49,
        "swap": 0,
        "profit": -119,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051601",
        "positionId": "56051600",
        "volume": 7,
        "price": 3221.83,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -168,
        "priceIn": 3221.66,
        "doubleCheck": true
    },
    {
        "dataID": "116590",
        "id": "53088202",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:30",
        "brokerTime": "2025-05-14 14:58:30",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051602",
        "positionId": "56051602",
        "volume": 7,
        "price": 3221.62,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3221.62,
        "doubleCheck": true
    },
    {
        "dataID": "116591",
        "id": "53088203",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:30",
        "brokerTime": "2025-05-14 14:58:30",
        "commission": -49,
        "swap": 0,
        "profit": -147,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051603",
        "positionId": "56051602",
        "volume": 7,
        "price": 3221.83,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -196,
        "priceIn": 3221.62,
        "doubleCheck": true
    },
    {
        "dataID": "116592",
        "id": "53088204",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:30",
        "brokerTime": "2025-05-14 14:58:30",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051604",
        "positionId": "56051604",
        "volume": 7,
        "price": 3221.58,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3221.58,
        "doubleCheck": true
    },
    {
        "dataID": "116593",
        "id": "53088205",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:30",
        "brokerTime": "2025-05-14 14:58:31",
        "commission": -49,
        "swap": 0,
        "profit": -168,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051605",
        "positionId": "56051604",
        "volume": 7,
        "price": 3221.82,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -217,
        "priceIn": 3221.58,
        "doubleCheck": true
    },
    {
        "dataID": "116594",
        "id": "53088206",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:31",
        "brokerTime": "2025-05-14 14:58:31",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051606",
        "positionId": "56051606",
        "volume": 7,
        "price": 3221.6,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3221.6,
        "doubleCheck": true
    },
    {
        "dataID": "116595",
        "id": "53088207",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:31",
        "brokerTime": "2025-05-14 14:58:32",
        "commission": -49,
        "swap": 0,
        "profit": -189,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051607",
        "positionId": "56051606",
        "volume": 7,
        "price": 3221.87,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -238,
        "priceIn": 3221.6,
        "doubleCheck": true
    },
    {
        "dataID": "116596",
        "id": "53088208",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:32",
        "brokerTime": "2025-05-14 14:58:32",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051608",
        "positionId": "56051608",
        "volume": 7,
        "price": 3221.69,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3221.69,
        "doubleCheck": true
    },
    {
        "dataID": "116597",
        "id": "53088209",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:32",
        "brokerTime": "2025-05-14 14:58:33",
        "commission": -49,
        "swap": 0,
        "profit": -140,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051609",
        "positionId": "56051608",
        "volume": 7,
        "price": 3221.89,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -189,
        "priceIn": 3221.69,
        "doubleCheck": true
    },
    {
        "dataID": "116598",
        "id": "53088210",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:33",
        "brokerTime": "2025-05-14 14:58:33",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051610",
        "positionId": "56051610",
        "volume": 7,
        "price": 3221.64,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3221.64,
        "doubleCheck": true
    },
    {
        "dataID": "116599",
        "id": "53088211",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:33",
        "brokerTime": "2025-05-14 14:58:33",
        "commission": -49,
        "swap": 0,
        "profit": -231,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051611",
        "positionId": "56051610",
        "volume": 7,
        "price": 3221.97,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -280,
        "priceIn": 3221.64,
        "doubleCheck": true
    },
    {
        "dataID": "116600",
        "id": "53088212",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:34",
        "brokerTime": "2025-05-14 14:58:34",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051612",
        "positionId": "56051612",
        "volume": 7,
        "price": 3221.75,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3221.75,
        "doubleCheck": true
    },
    {
        "dataID": "116601",
        "id": "53088213",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:34",
        "brokerTime": "2025-05-14 14:58:34",
        "commission": -49,
        "swap": 0,
        "profit": -140,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051613",
        "positionId": "56051612",
        "volume": 7,
        "price": 3221.95,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -189,
        "priceIn": 3221.75,
        "doubleCheck": true
    },
    {
        "dataID": "116602",
        "id": "53088216",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:35",
        "brokerTime": "2025-05-14 14:58:35",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051615",
        "positionId": "56051615",
        "volume": 7,
        "price": 3221.72,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3221.72,
        "doubleCheck": true
    },
    {
        "dataID": "116603",
        "id": "53088217",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:35",
        "brokerTime": "2025-05-14 14:58:36",
        "commission": -49,
        "swap": 0,
        "profit": -168,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051616",
        "positionId": "56051615",
        "volume": 7,
        "price": 3221.96,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -217,
        "priceIn": 3221.72,
        "doubleCheck": true
    },
    {
        "dataID": "116604",
        "id": "53088218",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:36",
        "brokerTime": "2025-05-14 14:58:36",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051617",
        "positionId": "56051617",
        "volume": 7,
        "price": 3221.85,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3221.85,
        "doubleCheck": true
    },
    {
        "dataID": "116605",
        "id": "53088219",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:36",
        "brokerTime": "2025-05-14 14:58:39",
        "commission": -49,
        "swap": 0,
        "profit": -84,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051618",
        "positionId": "56051617",
        "volume": 7,
        "price": 3221.97,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -133,
        "priceIn": 3221.85,
        "doubleCheck": true
    },
    {
        "dataID": "116606",
        "id": "53088220",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:39",
        "brokerTime": "2025-05-14 14:58:39",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051619",
        "positionId": "56051619",
        "volume": 7,
        "price": 3221.76,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3221.76,
        "doubleCheck": true
    },
    {
        "dataID": "116607",
        "id": "53088221",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:39",
        "brokerTime": "2025-05-14 14:58:40",
        "commission": -49,
        "swap": 0,
        "profit": -196,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051620",
        "positionId": "56051619",
        "volume": 7,
        "price": 3222.04,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -245,
        "priceIn": 3221.76,
        "doubleCheck": true
    },
    {
        "dataID": "116608",
        "id": "53088222",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:40",
        "brokerTime": "2025-05-14 14:58:40",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051621",
        "positionId": "56051621",
        "volume": 7,
        "price": 3221.79,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3221.79,
        "doubleCheck": true
    },
    {
        "dataID": "116609",
        "id": "53088223",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:40",
        "brokerTime": "2025-05-14 14:58:41",
        "commission": -49,
        "swap": 0,
        "profit": -119,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051622",
        "positionId": "56051621",
        "volume": 7,
        "price": 3221.96,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -168,
        "priceIn": 3221.79,
        "doubleCheck": true
    },
    {
        "dataID": "116610",
        "id": "53088224",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:41",
        "brokerTime": "2025-05-14 14:58:41",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051623",
        "positionId": "56051623",
        "volume": 7,
        "price": 3221.75,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3221.75,
        "doubleCheck": true
    },
    {
        "dataID": "116611",
        "id": "53088225",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:41",
        "brokerTime": "2025-05-14 14:58:42",
        "commission": -49,
        "swap": 0,
        "profit": -196,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051624",
        "positionId": "56051623",
        "volume": 7,
        "price": 3222.03,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -245,
        "priceIn": 3221.75,
        "doubleCheck": true
    },
    {
        "dataID": "116612",
        "id": "53088226",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:42",
        "brokerTime": "2025-05-14 14:58:42",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051625",
        "positionId": "56051625",
        "volume": 7,
        "price": 3221.77,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3221.77,
        "doubleCheck": true
    },
    {
        "dataID": "116613",
        "id": "53088227",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:42",
        "brokerTime": "2025-05-14 14:58:43",
        "commission": -49,
        "swap": 0,
        "profit": -147,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051626",
        "positionId": "56051625",
        "volume": 7,
        "price": 3221.98,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -196,
        "priceIn": 3221.77,
        "doubleCheck": true
    },
    {
        "dataID": "116614",
        "id": "53088228",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:43",
        "brokerTime": "2025-05-14 14:58:43",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051627",
        "positionId": "56051627",
        "volume": 7,
        "price": 3221.72,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3221.72,
        "doubleCheck": true
    },
    {
        "dataID": "116615",
        "id": "53088229",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:43",
        "brokerTime": "2025-05-14 14:58:44",
        "commission": -49,
        "swap": 0,
        "profit": -161,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051628",
        "positionId": "56051627",
        "volume": 7,
        "price": 3221.95,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -210,
        "priceIn": 3221.72,
        "doubleCheck": true
    },
    {
        "dataID": "116616",
        "id": "53088230",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:44",
        "brokerTime": "2025-05-14 14:58:44",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051629",
        "positionId": "56051629",
        "volume": 7,
        "price": 3221.73,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3221.73,
        "doubleCheck": true
    },
    {
        "dataID": "116617",
        "id": "53088231",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:44",
        "brokerTime": "2025-05-14 14:58:45",
        "commission": -49,
        "swap": 0,
        "profit": -112,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051630",
        "positionId": "56051629",
        "volume": 7,
        "price": 3221.89,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -161,
        "priceIn": 3221.73,
        "doubleCheck": true
    },
    {
        "dataID": "116618",
        "id": "53088233",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:45",
        "brokerTime": "2025-05-14 14:58:45",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051632",
        "positionId": "56051632",
        "volume": 7,
        "price": 3221.66,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3221.66,
        "doubleCheck": true
    },
    {
        "dataID": "116619",
        "id": "53088235",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:45",
        "brokerTime": "2025-05-14 14:58:46",
        "commission": -49,
        "swap": 0,
        "profit": -168,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051634",
        "positionId": "56051632",
        "volume": 7,
        "price": 3221.9,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -217,
        "priceIn": 3221.66,
        "doubleCheck": true
    },
    {
        "dataID": "116620",
        "id": "53088236",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:46",
        "brokerTime": "2025-05-14 14:58:46",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051635",
        "positionId": "56051635",
        "volume": 7,
        "price": 3221.68,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3221.68,
        "doubleCheck": true
    },
    {
        "dataID": "116621",
        "id": "53088237",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:46",
        "brokerTime": "2025-05-14 14:58:47",
        "commission": -49,
        "swap": 0,
        "profit": -63,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051636",
        "positionId": "56051635",
        "volume": 7,
        "price": 3221.77,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -112,
        "priceIn": 3221.68,
        "doubleCheck": true
    },
    {
        "dataID": "116622",
        "id": "53088238",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:47",
        "brokerTime": "2025-05-14 14:58:47",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051637",
        "positionId": "56051637",
        "volume": 7,
        "price": 3221.54,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3221.54,
        "doubleCheck": true
    },
    {
        "dataID": "116623",
        "id": "53088239",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:47",
        "brokerTime": "2025-05-14 14:58:48",
        "commission": -49,
        "swap": 0,
        "profit": -112,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051638",
        "positionId": "56051637",
        "volume": 7,
        "price": 3221.7,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -161,
        "priceIn": 3221.54,
        "doubleCheck": true
    },
    {
        "dataID": "116624",
        "id": "53088240",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:48",
        "brokerTime": "2025-05-14 14:58:48",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051639",
        "positionId": "56051639",
        "volume": 7,
        "price": 3221.51,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3221.51,
        "doubleCheck": true
    },
    {
        "dataID": "116625",
        "id": "53088241",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:48",
        "brokerTime": "2025-05-14 14:58:49",
        "commission": -49,
        "swap": 0,
        "profit": -147,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051640",
        "positionId": "56051639",
        "volume": 7,
        "price": 3221.72,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -196,
        "priceIn": 3221.51,
        "doubleCheck": true
    },
    {
        "dataID": "116626",
        "id": "53088242",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:49",
        "brokerTime": "2025-05-14 14:58:49",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051641",
        "positionId": "56051641",
        "volume": 7,
        "price": 3221.61,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3221.61,
        "doubleCheck": true
    },
    {
        "dataID": "116627",
        "id": "53088243",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:49",
        "brokerTime": "2025-05-14 14:58:49",
        "commission": -49,
        "swap": 0,
        "profit": -175,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051642",
        "positionId": "56051641",
        "volume": 7,
        "price": 3221.86,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -224,
        "priceIn": 3221.61,
        "doubleCheck": true
    },
    {
        "dataID": "116628",
        "id": "53088244",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:50",
        "brokerTime": "2025-05-14 14:58:50",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051643",
        "positionId": "56051643",
        "volume": 7,
        "price": 3221.64,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3221.64,
        "doubleCheck": true
    },
    {
        "dataID": "116629",
        "id": "53088245",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:50",
        "brokerTime": "2025-05-14 14:58:50",
        "commission": -49,
        "swap": 0,
        "profit": -154,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051644",
        "positionId": "56051643",
        "volume": 7,
        "price": 3221.86,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -203,
        "priceIn": 3221.64,
        "doubleCheck": true
    },
    {
        "dataID": "116630",
        "id": "53088246",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:51",
        "brokerTime": "2025-05-14 14:58:51",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051645",
        "positionId": "56051645",
        "volume": 7,
        "price": 3221.78,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3221.78,
        "doubleCheck": true
    },
    {
        "dataID": "116631",
        "id": "53088247",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:51",
        "brokerTime": "2025-05-14 14:58:52",
        "commission": -49,
        "swap": 0,
        "profit": -175,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051646",
        "positionId": "56051645",
        "volume": 7,
        "price": 3222.03,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -224,
        "priceIn": 3221.78,
        "doubleCheck": true
    },
    {
        "dataID": "116632",
        "id": "53088248",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:52",
        "brokerTime": "2025-05-14 14:58:52",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051647",
        "positionId": "56051647",
        "volume": 7,
        "price": 3221.79,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3221.79,
        "doubleCheck": true
    },
    {
        "dataID": "116633",
        "id": "53088249",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:52",
        "brokerTime": "2025-05-14 14:58:52",
        "commission": -49,
        "swap": 0,
        "profit": -35,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051648",
        "positionId": "56051647",
        "volume": 7,
        "price": 3221.84,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -84,
        "priceIn": 3221.79,
        "doubleCheck": true
    },
    {
        "dataID": "116634",
        "id": "53088250",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:53",
        "brokerTime": "2025-05-14 14:58:53",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051649",
        "positionId": "56051649",
        "volume": 7,
        "price": 3221.43,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3221.43,
        "doubleCheck": true
    },
    {
        "dataID": "116635",
        "id": "53088251",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:53",
        "brokerTime": "2025-05-14 14:58:55",
        "commission": -49,
        "swap": 0,
        "profit": -196,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051650",
        "positionId": "56051649",
        "volume": 7,
        "price": 3221.71,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -245,
        "priceIn": 3221.43,
        "doubleCheck": true
    },
    {
        "dataID": "116636",
        "id": "53088252",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:55",
        "brokerTime": "2025-05-14 14:58:55",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051651",
        "positionId": "56051651",
        "volume": 7,
        "price": 3221.39,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3221.39,
        "doubleCheck": true
    },
    {
        "dataID": "116637",
        "id": "53088253",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:55",
        "brokerTime": "2025-05-14 14:58:56",
        "commission": -49,
        "swap": 0,
        "profit": -182,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051652",
        "positionId": "56051651",
        "volume": 7,
        "price": 3221.65,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -231,
        "priceIn": 3221.39,
        "doubleCheck": true
    },
    {
        "dataID": "116638",
        "id": "53088254",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:56",
        "brokerTime": "2025-05-14 14:58:56",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051653",
        "positionId": "56051653",
        "volume": 7,
        "price": 3221.46,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3221.46,
        "doubleCheck": true
    },
    {
        "dataID": "116639",
        "id": "53088255",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:56",
        "brokerTime": "2025-05-14 14:58:57",
        "commission": -49,
        "swap": 0,
        "profit": -273,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051654",
        "positionId": "56051653",
        "volume": 7,
        "price": 3221.85,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -322,
        "priceIn": 3221.46,
        "doubleCheck": true
    },
    {
        "dataID": "116640",
        "id": "53088256",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:57",
        "brokerTime": "2025-05-14 14:58:57",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051655",
        "positionId": "56051655",
        "volume": 7,
        "price": 3221.65,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3221.65,
        "doubleCheck": true
    },
    {
        "dataID": "116641",
        "id": "53088257",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:57",
        "brokerTime": "2025-05-14 14:58:58",
        "commission": -49,
        "swap": 0,
        "profit": -189,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051656",
        "positionId": "56051655",
        "volume": 7,
        "price": 3221.92,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -238,
        "priceIn": 3221.65,
        "doubleCheck": true
    },
    {
        "dataID": "116642",
        "id": "53088258",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:58",
        "brokerTime": "2025-05-14 14:58:58",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051657",
        "positionId": "56051657",
        "volume": 7,
        "price": 3221.74,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3221.74,
        "doubleCheck": true
    },
    {
        "dataID": "116643",
        "id": "53088260",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:58",
        "brokerTime": "2025-05-14 14:58:59",
        "commission": -49,
        "swap": 0,
        "profit": -119,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051659",
        "positionId": "56051657",
        "volume": 7,
        "price": 3221.91,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -168,
        "priceIn": 3221.74,
        "doubleCheck": true
    },
    {
        "dataID": "116644",
        "id": "53088261",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:59",
        "brokerTime": "2025-05-14 14:58:59",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051660",
        "positionId": "56051660",
        "volume": 7,
        "price": 3221.68,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3221.68,
        "doubleCheck": true
    },
    {
        "dataID": "116645",
        "id": "53088262",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:59",
        "brokerTime": "2025-05-14 14:59:00",
        "commission": -49,
        "swap": 0,
        "profit": -140,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051661",
        "positionId": "56051660",
        "volume": 7,
        "price": 3221.88,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -189,
        "priceIn": 3221.68,
        "doubleCheck": true
    },
    {
        "dataID": "116646",
        "id": "53088263",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:00",
        "brokerTime": "2025-05-14 14:59:00",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051662",
        "positionId": "56051662",
        "volume": 7,
        "price": 3221.66,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3221.66,
        "doubleCheck": true
    },
    {
        "dataID": "116647",
        "id": "53088277",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:00",
        "brokerTime": "2025-05-14 14:59:01",
        "commission": -49,
        "swap": 0,
        "profit": -126,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051677",
        "positionId": "56051662",
        "volume": 7,
        "price": 3221.84,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -175,
        "priceIn": 3221.66,
        "doubleCheck": true
    },
    {
        "dataID": "116648",
        "id": "53088280",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:01",
        "brokerTime": "2025-05-14 14:59:01",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051679",
        "positionId": "56051679",
        "volume": 7,
        "price": 3221.62,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3221.62,
        "doubleCheck": true
    },
    {
        "dataID": "116649",
        "id": "53088283",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:01",
        "brokerTime": "2025-05-14 14:59:01",
        "commission": -49,
        "swap": 0,
        "profit": -210,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051680",
        "positionId": "56051679",
        "volume": 7,
        "price": 3221.92,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -259,
        "priceIn": 3221.62,
        "doubleCheck": true
    },
    {
        "dataID": "116650",
        "id": "53088395",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:02",
        "brokerTime": "2025-05-14 14:59:02",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051745",
        "positionId": "56051745",
        "volume": 7,
        "price": 3221.63,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3221.63,
        "doubleCheck": true
    },
    {
        "dataID": "116651",
        "id": "53088413",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:02",
        "brokerTime": "2025-05-14 14:59:03",
        "commission": -49,
        "swap": 0,
        "profit": -126,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051755",
        "positionId": "56051745",
        "volume": 7,
        "price": 3221.81,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -175,
        "priceIn": 3221.63,
        "doubleCheck": true
    },
    {
        "dataID": "116652",
        "id": "53088415",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:03",
        "brokerTime": "2025-05-14 14:59:03",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051757",
        "positionId": "56051757",
        "volume": 7,
        "price": 3221.59,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3221.59,
        "doubleCheck": true
    },
    {
        "dataID": "116653",
        "id": "53088417",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:03",
        "brokerTime": "2025-05-14 14:59:04",
        "commission": -49,
        "swap": 0,
        "profit": -161,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051759",
        "positionId": "56051757",
        "volume": 7,
        "price": 3221.82,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -210,
        "priceIn": 3221.59,
        "doubleCheck": true
    },
    {
        "dataID": "116654",
        "id": "53088418",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:04",
        "brokerTime": "2025-05-14 14:59:04",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051760",
        "positionId": "56051760",
        "volume": 7,
        "price": 3221.59,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3221.59,
        "doubleCheck": true
    },
    {
        "dataID": "116655",
        "id": "53088419",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:04",
        "brokerTime": "2025-05-14 14:59:04",
        "commission": -49,
        "swap": 0,
        "profit": -7,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051761",
        "positionId": "56051760",
        "volume": 7,
        "price": 3221.6,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56,
        "priceIn": 3221.59,
        "doubleCheck": true
    },
    {
        "dataID": "116656",
        "id": "53088420",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:05",
        "brokerTime": "2025-05-14 14:59:05",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051762",
        "positionId": "56051762",
        "volume": 7,
        "price": 3221.41,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3221.41,
        "doubleCheck": true
    },
    {
        "dataID": "116657",
        "id": "53088421",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:05",
        "brokerTime": "2025-05-14 14:59:06",
        "commission": -49,
        "swap": 0,
        "profit": -140,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051763",
        "positionId": "56051762",
        "volume": 7,
        "price": 3221.61,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -189,
        "priceIn": 3221.41,
        "doubleCheck": true
    },
    {
        "dataID": "116658",
        "id": "53088422",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:06",
        "brokerTime": "2025-05-14 14:59:06",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051764",
        "positionId": "56051764",
        "volume": 7,
        "price": 3221.4,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3221.4,
        "doubleCheck": true
    },
    {
        "dataID": "116659",
        "id": "53088423",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:06",
        "brokerTime": "2025-05-14 14:59:07",
        "commission": -49,
        "swap": 0,
        "profit": -133,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051765",
        "positionId": "56051764",
        "volume": 7,
        "price": 3221.59,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -182,
        "priceIn": 3221.4,
        "doubleCheck": true
    },
    {
        "dataID": "116660",
        "id": "53088424",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:07",
        "brokerTime": "2025-05-14 14:59:07",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051766",
        "positionId": "56051766",
        "volume": 7,
        "price": 3221.49,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3221.49,
        "doubleCheck": true
    },
    {
        "dataID": "116661",
        "id": "53088425",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:07",
        "brokerTime": "2025-05-14 14:59:08",
        "commission": -49,
        "swap": 0,
        "profit": -196,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051767",
        "positionId": "56051766",
        "volume": 7,
        "price": 3221.77,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -245,
        "priceIn": 3221.49,
        "doubleCheck": true
    },
    {
        "dataID": "116662",
        "id": "53088426",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:09",
        "brokerTime": "2025-05-14 14:59:09",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051768",
        "positionId": "56051768",
        "volume": 7,
        "price": 3221.34,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3221.34,
        "doubleCheck": true
    },
    {
        "dataID": "116663",
        "id": "53088427",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:09",
        "brokerTime": "2025-05-14 14:59:09",
        "commission": -49,
        "swap": 0,
        "profit": -161,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051769",
        "positionId": "56051768",
        "volume": 7,
        "price": 3221.57,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -210,
        "priceIn": 3221.34,
        "doubleCheck": true
    },
    {
        "dataID": "116664",
        "id": "53088428",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:09",
        "brokerTime": "2025-05-14 14:59:09",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051770",
        "positionId": "56051770",
        "volume": 7,
        "price": 3221.37,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3221.37,
        "doubleCheck": true
    },
    {
        "dataID": "116665",
        "id": "53088429",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:09",
        "brokerTime": "2025-05-14 14:59:10",
        "commission": -49,
        "swap": 0,
        "profit": -364,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051771",
        "positionId": "56051770",
        "volume": 7,
        "price": 3221.89,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -413,
        "priceIn": 3221.37,
        "doubleCheck": true
    },
    {
        "dataID": "116666",
        "id": "53088430",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:11",
        "brokerTime": "2025-05-14 14:59:11",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051772",
        "positionId": "56051772",
        "volume": 7,
        "price": 3221.69,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3221.69,
        "doubleCheck": true
    },
    {
        "dataID": "116667",
        "id": "53088431",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:11",
        "brokerTime": "2025-05-14 14:59:11",
        "commission": -49,
        "swap": 0,
        "profit": -49,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051773",
        "positionId": "56051772",
        "volume": 7,
        "price": 3221.76,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -98,
        "priceIn": 3221.69,
        "doubleCheck": true
    },
    {
        "dataID": "116668",
        "id": "53088432",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:11",
        "brokerTime": "2025-05-14 14:59:11",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051774",
        "positionId": "56051774",
        "volume": 7,
        "price": 3221.53,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3221.53,
        "doubleCheck": true
    },
    {
        "dataID": "116669",
        "id": "53088433",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:11",
        "brokerTime": "2025-05-14 14:59:12",
        "commission": -49,
        "swap": 0,
        "profit": -63,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051775",
        "positionId": "56051774",
        "volume": 7,
        "price": 3221.62,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -112,
        "priceIn": 3221.53,
        "doubleCheck": true
    },
    {
        "dataID": "116670",
        "id": "53088434",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:12",
        "brokerTime": "2025-05-14 14:59:12",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051776",
        "positionId": "56051776",
        "volume": 7,
        "price": 3221.35,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3221.35,
        "doubleCheck": true
    },
    {
        "dataID": "116671",
        "id": "53088435",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:12",
        "brokerTime": "2025-05-14 14:59:12",
        "commission": -49,
        "swap": 0,
        "profit": -126,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051777",
        "positionId": "56051776",
        "volume": 7,
        "price": 3221.53,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -175,
        "priceIn": 3221.35,
        "doubleCheck": true
    },
    {
        "dataID": "116672",
        "id": "53088436",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:13",
        "brokerTime": "2025-05-14 14:59:13",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051778",
        "positionId": "56051778",
        "volume": 7,
        "price": 3221.39,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3221.39,
        "doubleCheck": true
    },
    {
        "dataID": "116673",
        "id": "53088437",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:13",
        "brokerTime": "2025-05-14 14:59:13",
        "commission": -49,
        "swap": 0,
        "profit": -91,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051779",
        "positionId": "56051778",
        "volume": 7,
        "price": 3221.52,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -140,
        "priceIn": 3221.39,
        "doubleCheck": true
    },
    {
        "dataID": "116674",
        "id": "53088439",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:14",
        "brokerTime": "2025-05-14 14:59:14",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051781",
        "positionId": "56051781",
        "volume": 7,
        "price": 3221.37,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3221.37,
        "doubleCheck": true
    },
    {
        "dataID": "116675",
        "id": "53088441",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:14",
        "brokerTime": "2025-05-14 14:59:15",
        "commission": -49,
        "swap": 0,
        "profit": -147,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051782",
        "positionId": "56051781",
        "volume": 7,
        "price": 3221.58,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -196,
        "priceIn": 3221.37,
        "doubleCheck": true
    },
    {
        "dataID": "116676",
        "id": "53088442",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:15",
        "brokerTime": "2025-05-14 14:59:15",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051783",
        "positionId": "56051783",
        "volume": 7,
        "price": 3221.44,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3221.44,
        "doubleCheck": true
    },
    {
        "dataID": "116677",
        "id": "53088443",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:15",
        "brokerTime": "2025-05-14 14:59:17",
        "commission": -49,
        "swap": 0,
        "profit": -133,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051784",
        "positionId": "56051783",
        "volume": 7,
        "price": 3221.63,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -182,
        "priceIn": 3221.44,
        "doubleCheck": true
    },
    {
        "dataID": "116678",
        "id": "53088444",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:17",
        "brokerTime": "2025-05-14 14:59:17",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051785",
        "positionId": "56051785",
        "volume": 7,
        "price": 3221.42,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3221.42,
        "doubleCheck": true
    },
    {
        "dataID": "116679",
        "id": "53088445",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:17",
        "brokerTime": "2025-05-14 14:59:18",
        "commission": -49,
        "swap": 0,
        "profit": -119,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051786",
        "positionId": "56051785",
        "volume": 7,
        "price": 3221.59,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -168,
        "priceIn": 3221.42,
        "doubleCheck": true
    },
    {
        "dataID": "116680",
        "id": "53088446",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:18",
        "brokerTime": "2025-05-14 14:59:18",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051787",
        "positionId": "56051787",
        "volume": 7,
        "price": 3221.45,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3221.45,
        "doubleCheck": true
    },
    {
        "dataID": "116681",
        "id": "53088447",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:18",
        "brokerTime": "2025-05-14 14:59:18",
        "commission": -49,
        "swap": 0,
        "profit": -91,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051788",
        "positionId": "56051787",
        "volume": 7,
        "price": 3221.58,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -140,
        "priceIn": 3221.45,
        "doubleCheck": true
    },
    {
        "dataID": "116682",
        "id": "53088448",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:19",
        "brokerTime": "2025-05-14 14:59:19",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051789",
        "positionId": "56051789",
        "volume": 7,
        "price": 3221.29,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3221.29,
        "doubleCheck": true
    },
    {
        "dataID": "116683",
        "id": "53088449",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:19",
        "brokerTime": "2025-05-14 14:59:20",
        "commission": -49,
        "swap": 0,
        "profit": -70,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051790",
        "positionId": "56051789",
        "volume": 7,
        "price": 3221.39,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -119,
        "priceIn": 3221.29,
        "doubleCheck": true
    },
    {
        "dataID": "116684",
        "id": "53088450",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:20",
        "brokerTime": "2025-05-14 14:59:20",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051791",
        "positionId": "56051791",
        "volume": 7,
        "price": 3221.41,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3221.41,
        "doubleCheck": true
    },
    {
        "dataID": "116685",
        "id": "53088451",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:20",
        "brokerTime": "2025-05-14 14:59:21",
        "commission": -49,
        "swap": 0,
        "profit": -63,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051792",
        "positionId": "56051791",
        "volume": 7,
        "price": 3221.5,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -112,
        "priceIn": 3221.41,
        "doubleCheck": true
    },
    {
        "dataID": "116686",
        "id": "53088452",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:21",
        "brokerTime": "2025-05-14 14:59:21",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051793",
        "positionId": "56051793",
        "volume": 7,
        "price": 3221.28,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3221.28,
        "doubleCheck": true
    },
    {
        "dataID": "116687",
        "id": "53088453",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:21",
        "brokerTime": "2025-05-14 14:59:21",
        "commission": -49,
        "swap": 0,
        "profit": -49,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051794",
        "positionId": "56051793",
        "volume": 7,
        "price": 3221.35,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -98,
        "priceIn": 3221.28,
        "doubleCheck": true
    },
    {
        "dataID": "116688",
        "id": "53088454",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:21",
        "brokerTime": "2025-05-14 14:59:21",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051795",
        "positionId": "56051795",
        "volume": 7,
        "price": 3221.18,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3221.18,
        "doubleCheck": true
    },
    {
        "dataID": "116689",
        "id": "53088455",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:21",
        "brokerTime": "2025-05-14 14:59:22",
        "commission": -49,
        "swap": 0,
        "profit": -140,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051796",
        "positionId": "56051795",
        "volume": 7,
        "price": 3221.38,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -189,
        "priceIn": 3221.18,
        "doubleCheck": true
    },
    {
        "dataID": "116690",
        "id": "53088456",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:22",
        "brokerTime": "2025-05-14 14:59:22",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051797",
        "positionId": "56051797",
        "volume": 7,
        "price": 3221.19,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3221.19,
        "doubleCheck": true
    },
    {
        "dataID": "116691",
        "id": "53088457",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:22",
        "brokerTime": "2025-05-14 14:59:23",
        "commission": -49,
        "swap": 0,
        "profit": -140,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051798",
        "positionId": "56051797",
        "volume": 7,
        "price": 3221.39,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -189,
        "priceIn": 3221.19,
        "doubleCheck": true
    },
    {
        "dataID": "116692",
        "id": "53088458",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:23",
        "brokerTime": "2025-05-14 14:59:23",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051799",
        "positionId": "56051799",
        "volume": 7,
        "price": 3221.11,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3221.11,
        "doubleCheck": true
    },
    {
        "dataID": "116693",
        "id": "53088459",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:23",
        "brokerTime": "2025-05-14 14:59:24",
        "commission": -49,
        "swap": 0,
        "profit": -77,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051800",
        "positionId": "56051799",
        "volume": 7,
        "price": 3221.22,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -126,
        "priceIn": 3221.11,
        "doubleCheck": true
    },
    {
        "dataID": "116694",
        "id": "53088460",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:24",
        "brokerTime": "2025-05-14 14:59:24",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051801",
        "positionId": "56051801",
        "volume": 7,
        "price": 3221.01,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3221.01,
        "doubleCheck": true
    },
    {
        "dataID": "116695",
        "id": "53088461",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:24",
        "brokerTime": "2025-05-14 14:59:25",
        "commission": -49,
        "swap": 0,
        "profit": -98,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051802",
        "positionId": "56051801",
        "volume": 7,
        "price": 3221.15,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -147,
        "priceIn": 3221.01,
        "doubleCheck": true
    },
    {
        "dataID": "116696",
        "id": "53088462",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:25",
        "brokerTime": "2025-05-14 14:59:25",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051803",
        "positionId": "56051803",
        "volume": 7,
        "price": 3220.94,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3220.94,
        "doubleCheck": true
    },
    {
        "dataID": "116697",
        "id": "53088463",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:25",
        "brokerTime": "2025-05-14 14:59:25",
        "commission": -49,
        "swap": 0,
        "profit": 77,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051804",
        "positionId": "56051803",
        "volume": 7,
        "price": 3220.83,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 28,
        "priceIn": 3220.94,
        "doubleCheck": true
    },
    {
        "dataID": "116698",
        "id": "53088465",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:26",
        "brokerTime": "2025-05-14 14:59:26",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051806",
        "positionId": "56051806",
        "volume": 7,
        "price": 3220.77,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3220.77,
        "doubleCheck": true
    },
    {
        "dataID": "116699",
        "id": "53088466",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:26",
        "brokerTime": "2025-05-14 14:59:26",
        "commission": -49,
        "swap": 0,
        "profit": -273,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051807",
        "positionId": "56051806",
        "volume": 7,
        "price": 3221.16,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -322,
        "priceIn": 3220.77,
        "doubleCheck": true
    },
    {
        "dataID": "116700",
        "id": "53088467",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:26",
        "brokerTime": "2025-05-14 14:59:26",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051808",
        "positionId": "56051808",
        "volume": 7,
        "price": 3220.97,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3220.97,
        "doubleCheck": true
    },
    {
        "dataID": "116701",
        "id": "53088468",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:26",
        "brokerTime": "2025-05-14 14:59:27",
        "commission": -49,
        "swap": 0,
        "profit": -112,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051809",
        "positionId": "56051808",
        "volume": 7,
        "price": 3221.13,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -161,
        "priceIn": 3220.97,
        "doubleCheck": true
    },
    {
        "dataID": "116702",
        "id": "53088469",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:27",
        "brokerTime": "2025-05-14 14:59:27",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051810",
        "positionId": "56051810",
        "volume": 7,
        "price": 3220.95,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3220.95,
        "doubleCheck": true
    },
    {
        "dataID": "116703",
        "id": "53088470",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:27",
        "brokerTime": "2025-05-14 14:59:28",
        "commission": -49,
        "swap": 0,
        "profit": -133,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051811",
        "positionId": "56051810",
        "volume": 7,
        "price": 3221.14,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -182,
        "priceIn": 3220.95,
        "doubleCheck": true
    },
    {
        "dataID": "116704",
        "id": "53088471",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:28",
        "brokerTime": "2025-05-14 14:59:28",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051812",
        "positionId": "56051812",
        "volume": 7,
        "price": 3220.95,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3220.95,
        "doubleCheck": true
    },
    {
        "dataID": "116705",
        "id": "53088472",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:28",
        "brokerTime": "2025-05-14 14:59:29",
        "commission": -49,
        "swap": 0,
        "profit": -112,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051813",
        "positionId": "56051812",
        "volume": 7,
        "price": 3221.11,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -161,
        "priceIn": 3220.95,
        "doubleCheck": true
    },
    {
        "dataID": "116706",
        "id": "53088474",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:29",
        "brokerTime": "2025-05-14 14:59:29",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051815",
        "positionId": "56051815",
        "volume": 7,
        "price": 3220.86,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3220.86,
        "doubleCheck": true
    },
    {
        "dataID": "116707",
        "id": "53088475",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:29",
        "brokerTime": "2025-05-14 14:59:30",
        "commission": -49,
        "swap": 0,
        "profit": -105,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051816",
        "positionId": "56051815",
        "volume": 7,
        "price": 3221.01,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -154,
        "priceIn": 3220.86,
        "doubleCheck": true
    },
    {
        "dataID": "116708",
        "id": "53088476",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:30",
        "brokerTime": "2025-05-14 14:59:30",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051817",
        "positionId": "56051817",
        "volume": 7,
        "price": 3220.85,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3220.85,
        "doubleCheck": true
    },
    {
        "dataID": "116709",
        "id": "53088477",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:30",
        "brokerTime": "2025-05-14 14:59:31",
        "commission": -49,
        "swap": 0,
        "profit": -154,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051818",
        "positionId": "56051817",
        "volume": 7,
        "price": 3221.07,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -203,
        "priceIn": 3220.85,
        "doubleCheck": true
    },
    {
        "dataID": "116710",
        "id": "53088479",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:31",
        "brokerTime": "2025-05-14 14:59:31",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051820",
        "positionId": "56051820",
        "volume": 7,
        "price": 3220.88,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3220.88,
        "doubleCheck": true
    },
    {
        "dataID": "116711",
        "id": "53088480",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:31",
        "brokerTime": "2025-05-14 14:59:31",
        "commission": -49,
        "swap": 0,
        "profit": -112,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051821",
        "positionId": "56051820",
        "volume": 7,
        "price": 3221.04,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -161,
        "priceIn": 3220.88,
        "doubleCheck": true
    },
    {
        "dataID": "116712",
        "id": "53088482",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:32",
        "brokerTime": "2025-05-14 14:59:32",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051823",
        "positionId": "56051823",
        "volume": 7,
        "price": 3220.85,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3220.85,
        "doubleCheck": true
    },
    {
        "dataID": "116713",
        "id": "53088485",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:32",
        "brokerTime": "2025-05-14 14:59:33",
        "commission": -49,
        "swap": 0,
        "profit": -70,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051826",
        "positionId": "56051823",
        "volume": 7,
        "price": 3220.95,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -119,
        "priceIn": 3220.85,
        "doubleCheck": true
    },
    {
        "dataID": "116714",
        "id": "53088486",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:33",
        "brokerTime": "2025-05-14 14:59:33",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051827",
        "positionId": "56051827",
        "volume": 7,
        "price": 3220.69,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3220.69,
        "doubleCheck": true
    },
    {
        "dataID": "116715",
        "id": "53088487",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:33",
        "brokerTime": "2025-05-14 14:59:34",
        "commission": -49,
        "swap": 0,
        "profit": -147,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051828",
        "positionId": "56051827",
        "volume": 7,
        "price": 3220.9,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -196,
        "priceIn": 3220.69,
        "doubleCheck": true
    },
    {
        "dataID": "116716",
        "id": "53088488",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:35",
        "brokerTime": "2025-05-14 14:59:35",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051829",
        "positionId": "56051829",
        "volume": 7,
        "price": 3220.89,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3220.89,
        "doubleCheck": true
    },
    {
        "dataID": "116717",
        "id": "53088489",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:35",
        "brokerTime": "2025-05-14 14:59:35",
        "commission": -49,
        "swap": 0,
        "profit": -14,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051830",
        "positionId": "56051829",
        "volume": 7,
        "price": 3220.91,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -63,
        "priceIn": 3220.89,
        "doubleCheck": true
    },
    {
        "dataID": "116718",
        "id": "53088490",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:36",
        "brokerTime": "2025-05-14 14:59:36",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051831",
        "positionId": "56051831",
        "volume": 7,
        "price": 3220.67,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3220.67,
        "doubleCheck": true
    },
    {
        "dataID": "116719",
        "id": "53088491",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:36",
        "brokerTime": "2025-05-14 14:59:36",
        "commission": -49,
        "swap": 0,
        "profit": -98,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051832",
        "positionId": "56051831",
        "volume": 7,
        "price": 3220.81,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -147,
        "priceIn": 3220.67,
        "doubleCheck": true
    },
    {
        "dataID": "116720",
        "id": "53088492",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:37",
        "brokerTime": "2025-05-14 14:59:37",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051833",
        "positionId": "56051833",
        "volume": 7,
        "price": 3220.6,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3220.6,
        "doubleCheck": true
    },
    {
        "dataID": "116721",
        "id": "53088493",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:37",
        "brokerTime": "2025-05-14 14:59:38",
        "commission": -49,
        "swap": 0,
        "profit": -196,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051834",
        "positionId": "56051833",
        "volume": 7,
        "price": 3220.88,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -245,
        "priceIn": 3220.6,
        "doubleCheck": true
    },
    {
        "dataID": "116722",
        "id": "53088494",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:38",
        "brokerTime": "2025-05-14 14:59:38",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051835",
        "positionId": "56051835",
        "volume": 7,
        "price": 3220.79,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3220.79,
        "doubleCheck": true
    },
    {
        "dataID": "116723",
        "id": "53088495",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:38",
        "brokerTime": "2025-05-14 14:59:39",
        "commission": -49,
        "swap": 0,
        "profit": -133,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051836",
        "positionId": "56051835",
        "volume": 7,
        "price": 3220.98,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -182,
        "priceIn": 3220.79,
        "doubleCheck": true
    },
    {
        "dataID": "116724",
        "id": "53088496",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:39",
        "brokerTime": "2025-05-14 14:59:39",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051837",
        "positionId": "56051837",
        "volume": 7,
        "price": 3220.92,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3220.92,
        "doubleCheck": true
    },
    {
        "dataID": "116725",
        "id": "53088497",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:39",
        "brokerTime": "2025-05-14 14:59:40",
        "commission": -49,
        "swap": 0,
        "profit": -175,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051838",
        "positionId": "56051837",
        "volume": 7,
        "price": 3221.17,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -224,
        "priceIn": 3220.92,
        "doubleCheck": true
    },
    {
        "dataID": "116726",
        "id": "53088498",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:40",
        "brokerTime": "2025-05-14 14:59:40",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051839",
        "positionId": "56051839",
        "volume": 7,
        "price": 3220.84,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3220.84,
        "doubleCheck": true
    },
    {
        "dataID": "116727",
        "id": "53088499",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:40",
        "brokerTime": "2025-05-14 14:59:41",
        "commission": -49,
        "swap": 0,
        "profit": -98,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051840",
        "positionId": "56051839",
        "volume": 7,
        "price": 3220.98,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -147,
        "priceIn": 3220.84,
        "doubleCheck": true
    },
    {
        "dataID": "116728",
        "id": "53088500",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:41",
        "brokerTime": "2025-05-14 14:59:41",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051841",
        "positionId": "56051841",
        "volume": 7,
        "price": 3220.78,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3220.78,
        "doubleCheck": true
    },
    {
        "dataID": "116729",
        "id": "53088501",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:41",
        "brokerTime": "2025-05-14 14:59:42",
        "commission": -49,
        "swap": 0,
        "profit": -91,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051842",
        "positionId": "56051841",
        "volume": 7,
        "price": 3220.91,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -140,
        "priceIn": 3220.78,
        "doubleCheck": true
    },
    {
        "dataID": "116730",
        "id": "53088502",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:42",
        "brokerTime": "2025-05-14 14:59:42",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051843",
        "positionId": "56051843",
        "volume": 7,
        "price": 3220.8,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3220.8,
        "doubleCheck": true
    },
    {
        "dataID": "116731",
        "id": "53088503",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:42",
        "brokerTime": "2025-05-14 14:59:43",
        "commission": -49,
        "swap": 0,
        "profit": -161,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051844",
        "positionId": "56051843",
        "volume": 7,
        "price": 3221.03,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -210,
        "priceIn": 3220.8,
        "doubleCheck": true
    },
    {
        "dataID": "116732",
        "id": "53088504",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:43",
        "brokerTime": "2025-05-14 14:59:43",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051845",
        "positionId": "56051845",
        "volume": 7,
        "price": 3220.73,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3220.73,
        "doubleCheck": true
    },
    {
        "dataID": "116733",
        "id": "53088505",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:43",
        "brokerTime": "2025-05-14 14:59:44",
        "commission": -49,
        "swap": 0,
        "profit": -77,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051846",
        "positionId": "56051845",
        "volume": 7,
        "price": 3220.84,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -126,
        "priceIn": 3220.73,
        "doubleCheck": true
    },
    {
        "dataID": "116734",
        "id": "53088506",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:44",
        "brokerTime": "2025-05-14 14:59:44",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051847",
        "positionId": "56051847",
        "volume": 7,
        "price": 3220.61,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3220.61,
        "doubleCheck": true
    },
    {
        "dataID": "116735",
        "id": "53088507",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:44",
        "brokerTime": "2025-05-14 14:59:44",
        "commission": -49,
        "swap": 0,
        "profit": -196,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051848",
        "positionId": "56051847",
        "volume": 7,
        "price": 3220.89,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -245,
        "priceIn": 3220.61,
        "doubleCheck": true
    },
    {
        "dataID": "116736",
        "id": "53088508",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:45",
        "brokerTime": "2025-05-14 14:59:45",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051849",
        "positionId": "56051849",
        "volume": 7,
        "price": 3220.79,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3220.79,
        "doubleCheck": true
    },
    {
        "dataID": "116737",
        "id": "53088509",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:45",
        "brokerTime": "2025-05-14 14:59:45",
        "commission": -49,
        "swap": 0,
        "profit": -175,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051850",
        "positionId": "56051849",
        "volume": 7,
        "price": 3221.04,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -224,
        "priceIn": 3220.79,
        "doubleCheck": true
    },
    {
        "dataID": "116738",
        "id": "53088511",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:46",
        "brokerTime": "2025-05-14 14:59:46",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051852",
        "positionId": "56051852",
        "volume": 7,
        "price": 3220.81,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3220.81,
        "doubleCheck": true
    },
    {
        "dataID": "116739",
        "id": "53088512",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:46",
        "brokerTime": "2025-05-14 14:59:46",
        "commission": -49,
        "swap": 0,
        "profit": -112,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051853",
        "positionId": "56051852",
        "volume": 7,
        "price": 3220.97,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -161,
        "priceIn": 3220.81,
        "doubleCheck": true
    },
    {
        "dataID": "116740",
        "id": "53088514",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:46",
        "brokerTime": "2025-05-14 14:59:46",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051855",
        "positionId": "56051855",
        "volume": 7,
        "price": 3220.84,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3220.84,
        "doubleCheck": true
    },
    {
        "dataID": "116741",
        "id": "53088516",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:46",
        "brokerTime": "2025-05-14 14:59:48",
        "commission": -49,
        "swap": 0,
        "profit": -77,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051857",
        "positionId": "56051855",
        "volume": 7,
        "price": 3220.95,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -126,
        "priceIn": 3220.84,
        "doubleCheck": true
    },
    {
        "dataID": "116742",
        "id": "53088518",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:48",
        "brokerTime": "2025-05-14 14:59:48",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051859",
        "positionId": "56051859",
        "volume": 7,
        "price": 3220.72,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3220.72,
        "doubleCheck": true
    },
    {
        "dataID": "116743",
        "id": "53088519",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:48",
        "brokerTime": "2025-05-14 14:59:48",
        "commission": -49,
        "swap": 0,
        "profit": -196,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051860",
        "positionId": "56051859",
        "volume": 7,
        "price": 3221,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -245,
        "priceIn": 3220.72,
        "doubleCheck": true
    },
    {
        "dataID": "116744",
        "id": "53088520",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:49",
        "brokerTime": "2025-05-14 14:59:49",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051861",
        "positionId": "56051861",
        "volume": 7,
        "price": 3220.76,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3220.76,
        "doubleCheck": true
    },
    {
        "dataID": "116745",
        "id": "53088522",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:49",
        "brokerTime": "2025-05-14 14:59:49",
        "commission": -49,
        "swap": 0,
        "profit": 28,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051863",
        "positionId": "56051861",
        "volume": 7,
        "price": 3220.72,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -21,
        "priceIn": 3220.76,
        "doubleCheck": true
    },
    {
        "dataID": "116746",
        "id": "53088523",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:50",
        "brokerTime": "2025-05-14 14:59:50",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051864",
        "positionId": "56051864",
        "volume": 7,
        "price": 3220.57,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3220.57,
        "doubleCheck": true
    },
    {
        "dataID": "116747",
        "id": "53088524",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:50",
        "brokerTime": "2025-05-14 14:59:50",
        "commission": -49,
        "swap": 0,
        "profit": -252,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051865",
        "positionId": "56051864",
        "volume": 7,
        "price": 3220.93,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -301,
        "priceIn": 3220.57,
        "doubleCheck": true
    },
    {
        "dataID": "116748",
        "id": "53088525",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:51",
        "brokerTime": "2025-05-14 14:59:51",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051866",
        "positionId": "56051866",
        "volume": 7,
        "price": 3220.64,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3220.64,
        "doubleCheck": true
    },
    {
        "dataID": "116749",
        "id": "53088526",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:51",
        "brokerTime": "2025-05-14 14:59:51",
        "commission": -49,
        "swap": 0,
        "profit": -168,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051867",
        "positionId": "56051866",
        "volume": 7,
        "price": 3220.88,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -217,
        "priceIn": 3220.64,
        "doubleCheck": true
    },
    {
        "dataID": "116750",
        "id": "53088527",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:52",
        "brokerTime": "2025-05-14 14:59:52",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051868",
        "positionId": "56051868",
        "volume": 7,
        "price": 3220.6,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3220.6,
        "doubleCheck": true
    },
    {
        "dataID": "116751",
        "id": "53088528",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:52",
        "brokerTime": "2025-05-14 14:59:52",
        "commission": -49,
        "swap": 0,
        "profit": -77,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051869",
        "positionId": "56051868",
        "volume": 7,
        "price": 3220.71,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -126,
        "priceIn": 3220.6,
        "doubleCheck": true
    },
    {
        "dataID": "116752",
        "id": "53088529",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:52",
        "brokerTime": "2025-05-14 14:59:52",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051870",
        "positionId": "56051870",
        "volume": 7,
        "price": 3220.5,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3220.5,
        "doubleCheck": true
    },
    {
        "dataID": "116753",
        "id": "53088530",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:52",
        "brokerTime": "2025-05-14 14:59:53",
        "commission": -49,
        "swap": 0,
        "profit": -84,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051871",
        "positionId": "56051870",
        "volume": 7,
        "price": 3220.62,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -133,
        "priceIn": 3220.5,
        "doubleCheck": true
    },
    {
        "dataID": "116754",
        "id": "53088531",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:53",
        "brokerTime": "2025-05-14 14:59:53",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051872",
        "positionId": "56051872",
        "volume": 7,
        "price": 3220.45,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3220.45,
        "doubleCheck": true
    },
    {
        "dataID": "116755",
        "id": "53088532",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:53",
        "brokerTime": "2025-05-14 14:59:54",
        "commission": -49,
        "swap": 0,
        "profit": -112,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051873",
        "positionId": "56051872",
        "volume": 7,
        "price": 3220.61,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -161,
        "priceIn": 3220.45,
        "doubleCheck": true
    },
    {
        "dataID": "116756",
        "id": "53088533",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:55",
        "brokerTime": "2025-05-14 14:59:55",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051874",
        "positionId": "56051874",
        "volume": 7,
        "price": 3220.46,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3220.46,
        "doubleCheck": true
    },
    {
        "dataID": "116757",
        "id": "53088534",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:55",
        "brokerTime": "2025-05-14 14:59:55",
        "commission": -49,
        "swap": 0,
        "profit": -287,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051875",
        "positionId": "56051874",
        "volume": 7,
        "price": 3220.87,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -336,
        "priceIn": 3220.46,
        "doubleCheck": true
    },
    {
        "dataID": "116758",
        "id": "53088535",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:55",
        "brokerTime": "2025-05-14 14:59:55",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051876",
        "positionId": "56051876",
        "volume": 7,
        "price": 3220.75,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3220.75,
        "doubleCheck": true
    },
    {
        "dataID": "116759",
        "id": "53088536",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:55",
        "brokerTime": "2025-05-14 14:59:56",
        "commission": -49,
        "swap": 0,
        "profit": -35,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051877",
        "positionId": "56051876",
        "volume": 7,
        "price": 3220.8,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -84,
        "priceIn": 3220.75,
        "doubleCheck": true
    },
    {
        "dataID": "116760",
        "id": "53088537",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:56",
        "brokerTime": "2025-05-14 14:59:56",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051878",
        "positionId": "56051878",
        "volume": 7,
        "price": 3220.48,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3220.48,
        "doubleCheck": true
    },
    {
        "dataID": "116761",
        "id": "53088538",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:56",
        "brokerTime": "2025-05-14 14:59:57",
        "commission": -49,
        "swap": 0,
        "profit": -70,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051879",
        "positionId": "56051878",
        "volume": 7,
        "price": 3220.58,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -119,
        "priceIn": 3220.48,
        "doubleCheck": true
    },
    {
        "dataID": "116762",
        "id": "53088539",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:57",
        "brokerTime": "2025-05-14 14:59:57",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051880",
        "positionId": "56051880",
        "volume": 7,
        "price": 3220.09,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3220.09,
        "doubleCheck": true
    },
    {
        "dataID": "116763",
        "id": "53088542",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:57",
        "brokerTime": "2025-05-14 14:59:57",
        "commission": -49,
        "swap": 0,
        "profit": -91,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051883",
        "positionId": "56051880",
        "volume": 7,
        "price": 3220.22,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -140,
        "priceIn": 3220.09,
        "doubleCheck": true
    },
    {
        "dataID": "116764",
        "id": "53088546",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:58",
        "brokerTime": "2025-05-14 14:59:58",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051886",
        "positionId": "56051886",
        "volume": 7,
        "price": 3220.02,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3220.02,
        "doubleCheck": true
    },
    {
        "dataID": "116765",
        "id": "53088547",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:58",
        "brokerTime": "2025-05-14 14:59:58",
        "commission": -49,
        "swap": 0,
        "profit": -154,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051887",
        "positionId": "56051886",
        "volume": 7,
        "price": 3220.24,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -203,
        "priceIn": 3220.02,
        "doubleCheck": true
    },
    {
        "dataID": "116766",
        "id": "53088548",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:59",
        "brokerTime": "2025-05-14 14:59:59",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051888",
        "positionId": "56051888",
        "volume": 7,
        "price": 3220.09,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3220.09,
        "doubleCheck": true
    },
    {
        "dataID": "116767",
        "id": "53088550",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:59",
        "brokerTime": "2025-05-14 15:00:00",
        "commission": -49,
        "swap": 0,
        "profit": -140,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051890",
        "positionId": "56051888",
        "volume": 7,
        "price": 3220.29,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -189,
        "priceIn": 3220.09,
        "doubleCheck": true
    },
    {
        "dataID": "116768",
        "id": "53088551",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:00",
        "brokerTime": "2025-05-14 15:00:00",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051891",
        "positionId": "56051891",
        "volume": 7,
        "price": 3220.07,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3220.07,
        "doubleCheck": true
    },
    {
        "dataID": "116769",
        "id": "53088588",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:00",
        "brokerTime": "2025-05-14 15:00:01",
        "commission": -49,
        "swap": 0,
        "profit": -525,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051929",
        "positionId": "56051891",
        "volume": 7,
        "price": 3220.82,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -574,
        "priceIn": 3220.07,
        "doubleCheck": true
    },
    {
        "dataID": "116770",
        "id": "53088591",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:01",
        "brokerTime": "2025-05-14 15:00:01",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56051934",
        "positionId": "56051934",
        "volume": 7,
        "price": 3220.87,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3220.87,
        "doubleCheck": true
    },
    {
        "dataID": "116771",
        "id": "53088750",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:01",
        "brokerTime": "2025-05-14 15:00:01",
        "commission": -49,
        "swap": 0,
        "profit": -98,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052118",
        "positionId": "56051934",
        "volume": 7,
        "price": 3221.01,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -147,
        "priceIn": 3220.87,
        "doubleCheck": true
    },
    {
        "dataID": "116772",
        "id": "53088836",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:02",
        "brokerTime": "2025-05-14 15:00:02",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052161",
        "positionId": "56052161",
        "volume": 7,
        "price": 3220.49,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3220.49,
        "doubleCheck": true
    },
    {
        "dataID": "116773",
        "id": "53089341",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:02",
        "brokerTime": "2025-05-14 15:00:04",
        "commission": -49,
        "swap": 0,
        "profit": 280,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052630",
        "positionId": "56052161",
        "volume": 7,
        "price": 3220.09,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 231,
        "priceIn": 3220.49,
        "doubleCheck": true
    },
    {
        "dataID": "116774",
        "id": "53089451",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:05",
        "brokerTime": "2025-05-14 15:00:05",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052721",
        "positionId": "56052721",
        "volume": 7,
        "price": 3220.07,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3220.07,
        "doubleCheck": true
    },
    {
        "dataID": "116775",
        "id": "53089459",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:05",
        "brokerTime": "2025-05-14 15:00:06",
        "commission": -49,
        "swap": 0,
        "profit": -147,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052725",
        "positionId": "56052721",
        "volume": 7,
        "price": 3220.28,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -196,
        "priceIn": 3220.07,
        "doubleCheck": true
    },
    {
        "dataID": "116776",
        "id": "53089460",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:37:23",
        "brokerTime": "2025-05-14 15:00:06",
        "commission": -0.7,
        "swap": 0,
        "profit": 142.6,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052728",
        "positionId": "56048550",
        "volume": 0.1,
        "price": 3220.28,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "RR",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 141.9,
        "priceIn": 3234.54,
        "doubleCheck": true
    },
    {
        "dataID": "116777",
        "id": "53089465",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:13",
        "brokerTime": "2025-05-14 15:00:13",
        "commission": -0.7,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052731",
        "positionId": "56052731",
        "volume": 0.1,
        "price": 3220.49,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "RR",
        "comment": "RR",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.7,
        "priceIn": 3220.49,
        "doubleCheck": true
    },
    {
        "dataID": "116778",
        "id": "53089467",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:13",
        "brokerTime": "2025-05-14 15:00:13",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052732",
        "positionId": "56052732",
        "volume": 7,
        "price": 3220.8,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3220.8,
        "doubleCheck": true
    },
    {
        "dataID": "116779",
        "id": "53089468",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:13",
        "brokerTime": "2025-05-14 15:00:14",
        "commission": -49,
        "swap": 0,
        "profit": -35,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052733",
        "positionId": "56052732",
        "volume": 7,
        "price": 3220.85,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -84,
        "priceIn": 3220.8,
        "doubleCheck": true
    },
    {
        "dataID": "116780",
        "id": "53089469",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:15",
        "brokerTime": "2025-05-14 15:00:15",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052734",
        "positionId": "56052734",
        "volume": 7,
        "price": 3220.62,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3220.62,
        "doubleCheck": true
    },
    {
        "dataID": "116781",
        "id": "53089470",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:15",
        "brokerTime": "2025-05-14 15:00:15",
        "commission": -49,
        "swap": 0,
        "profit": -28,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052735",
        "positionId": "56052734",
        "volume": 7,
        "price": 3220.66,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -77,
        "priceIn": 3220.62,
        "doubleCheck": true
    },
    {
        "dataID": "116782",
        "id": "53089471",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:16",
        "brokerTime": "2025-05-14 15:00:16",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052736",
        "positionId": "56052736",
        "volume": 7,
        "price": 3220.63,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3220.63,
        "doubleCheck": true
    },
    {
        "dataID": "116783",
        "id": "53089472",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:16",
        "brokerTime": "2025-05-14 15:00:16",
        "commission": -49,
        "swap": 0,
        "profit": -105,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052737",
        "positionId": "56052736",
        "volume": 7,
        "price": 3220.78,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -154,
        "priceIn": 3220.63,
        "doubleCheck": true
    },
    {
        "dataID": "116784",
        "id": "53089473",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:17",
        "brokerTime": "2025-05-14 15:00:17",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052738",
        "positionId": "56052738",
        "volume": 7,
        "price": 3220.72,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3220.72,
        "doubleCheck": true
    },
    {
        "dataID": "116785",
        "id": "53089474",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:17",
        "brokerTime": "2025-05-14 15:00:18",
        "commission": -49,
        "swap": 0,
        "profit": -105,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052739",
        "positionId": "56052738",
        "volume": 7,
        "price": 3220.87,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -154,
        "priceIn": 3220.72,
        "doubleCheck": true
    },
    {
        "dataID": "116786",
        "id": "53089475",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:18",
        "brokerTime": "2025-05-14 15:00:18",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052740",
        "positionId": "56052740",
        "volume": 7,
        "price": 3220.68,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3220.68,
        "doubleCheck": true
    },
    {
        "dataID": "116787",
        "id": "53089476",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:18",
        "brokerTime": "2025-05-14 15:00:20",
        "commission": -49,
        "swap": 0,
        "profit": -91,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052741",
        "positionId": "56052740",
        "volume": 7,
        "price": 3220.81,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -140,
        "priceIn": 3220.68,
        "doubleCheck": true
    },
    {
        "dataID": "116788",
        "id": "53089477",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:20",
        "brokerTime": "2025-05-14 15:00:20",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052742",
        "positionId": "56052742",
        "volume": 7,
        "price": 3220.36,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3220.36,
        "doubleCheck": true
    },
    {
        "dataID": "116789",
        "id": "53089478",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:20",
        "brokerTime": "2025-05-14 15:00:20",
        "commission": -49,
        "swap": 0,
        "profit": -301,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052743",
        "positionId": "56052742",
        "volume": 7,
        "price": 3220.79,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -350,
        "priceIn": 3220.36,
        "doubleCheck": true
    },
    {
        "dataID": "116790",
        "id": "53089479",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:21",
        "brokerTime": "2025-05-14 15:00:21",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052744",
        "positionId": "56052744",
        "volume": 7,
        "price": 3220.58,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3220.58,
        "doubleCheck": true
    },
    {
        "dataID": "116791",
        "id": "53089480",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:21",
        "brokerTime": "2025-05-14 15:00:21",
        "commission": -49,
        "swap": 0,
        "profit": -70,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052745",
        "positionId": "56052744",
        "volume": 7,
        "price": 3220.68,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -119,
        "priceIn": 3220.58,
        "doubleCheck": true
    },
    {
        "dataID": "116792",
        "id": "53089481",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:22",
        "brokerTime": "2025-05-14 15:00:22",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052746",
        "positionId": "56052746",
        "volume": 7,
        "price": 3220.4,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3220.4,
        "doubleCheck": true
    },
    {
        "dataID": "116793",
        "id": "53089482",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:22",
        "brokerTime": "2025-05-14 15:00:23",
        "commission": -49,
        "swap": 0,
        "profit": -56,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052747",
        "positionId": "56052746",
        "volume": 7,
        "price": 3220.48,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -105,
        "priceIn": 3220.4,
        "doubleCheck": true
    },
    {
        "dataID": "116794",
        "id": "53089483",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:24",
        "brokerTime": "2025-05-14 15:00:24",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052748",
        "positionId": "56052748",
        "volume": 7,
        "price": 3219.89,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3219.89,
        "doubleCheck": true
    },
    {
        "dataID": "116795",
        "id": "53089484",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:24",
        "brokerTime": "2025-05-14 15:00:24",
        "commission": -49,
        "swap": 0,
        "profit": -84,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052749",
        "positionId": "56052748",
        "volume": 7,
        "price": 3220.01,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -133,
        "priceIn": 3219.89,
        "doubleCheck": true
    },
    {
        "dataID": "116796",
        "id": "53089485",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:25",
        "brokerTime": "2025-05-14 15:00:25",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052750",
        "positionId": "56052750",
        "volume": 7,
        "price": 3220.02,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3220.02,
        "doubleCheck": true
    },
    {
        "dataID": "116797",
        "id": "53089486",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:25",
        "brokerTime": "2025-05-14 15:00:25",
        "commission": -49,
        "swap": 0,
        "profit": -14,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052751",
        "positionId": "56052750",
        "volume": 7,
        "price": 3220.04,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -63,
        "priceIn": 3220.02,
        "doubleCheck": true
    },
    {
        "dataID": "116798",
        "id": "53089494",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:26",
        "brokerTime": "2025-05-14 15:00:26",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052755",
        "positionId": "56052755",
        "volume": 7,
        "price": 3219.4,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3219.4,
        "doubleCheck": true
    },
    {
        "dataID": "116799",
        "id": "53089497",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:26",
        "brokerTime": "2025-05-14 15:00:26",
        "commission": -49,
        "swap": 0,
        "profit": -287,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052756",
        "positionId": "56052755",
        "volume": 7,
        "price": 3219.81,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -336,
        "priceIn": 3219.4,
        "doubleCheck": true
    },
    {
        "dataID": "116800",
        "id": "53089498",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:27",
        "brokerTime": "2025-05-14 15:00:27",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052757",
        "positionId": "56052757",
        "volume": 7,
        "price": 3219.58,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3219.58,
        "doubleCheck": true
    },
    {
        "dataID": "116801",
        "id": "53089500",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:27",
        "brokerTime": "2025-05-14 15:00:27",
        "commission": -49,
        "swap": 0,
        "profit": -63,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052759",
        "positionId": "56052757",
        "volume": 7,
        "price": 3219.67,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -112,
        "priceIn": 3219.58,
        "doubleCheck": true
    },
    {
        "dataID": "116802",
        "id": "53089501",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:28",
        "brokerTime": "2025-05-14 15:00:28",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052760",
        "positionId": "56052760",
        "volume": 7,
        "price": 3219.45,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3219.45,
        "doubleCheck": true
    },
    {
        "dataID": "116803",
        "id": "53089504",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:28",
        "brokerTime": "2025-05-14 15:00:28",
        "commission": -49,
        "swap": 0,
        "profit": -301,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052763",
        "positionId": "56052760",
        "volume": 7,
        "price": 3219.88,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -350,
        "priceIn": 3219.45,
        "doubleCheck": true
    },
    {
        "dataID": "116804",
        "id": "53089506",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:29",
        "brokerTime": "2025-05-14 15:00:29",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052764",
        "positionId": "56052764",
        "volume": 7,
        "price": 3219.68,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3219.68,
        "doubleCheck": true
    },
    {
        "dataID": "116805",
        "id": "53089507",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:29",
        "brokerTime": "2025-05-14 15:00:29",
        "commission": -49,
        "swap": 0,
        "profit": -301,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052765",
        "positionId": "56052764",
        "volume": 7,
        "price": 3220.11,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -350,
        "priceIn": 3219.68,
        "doubleCheck": true
    },
    {
        "dataID": "116806",
        "id": "53089510",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:30",
        "brokerTime": "2025-05-14 15:00:30",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052768",
        "positionId": "56052768",
        "volume": 7,
        "price": 3219.97,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3219.97,
        "doubleCheck": true
    },
    {
        "dataID": "116807",
        "id": "53089511",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:30",
        "brokerTime": "2025-05-14 15:00:30",
        "commission": -49,
        "swap": 0,
        "profit": -98,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052769",
        "positionId": "56052768",
        "volume": 7,
        "price": 3220.11,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -147,
        "priceIn": 3219.97,
        "doubleCheck": true
    },
    {
        "dataID": "116808",
        "id": "53089512",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:31",
        "brokerTime": "2025-05-14 15:00:31",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052770",
        "positionId": "56052770",
        "volume": 7,
        "price": 3219.94,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3219.94,
        "doubleCheck": true
    },
    {
        "dataID": "116809",
        "id": "53089514",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:31",
        "brokerTime": "2025-05-14 15:00:31",
        "commission": -49,
        "swap": 0,
        "profit": -140,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052772",
        "positionId": "56052770",
        "volume": 7,
        "price": 3220.14,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -189,
        "priceIn": 3219.94,
        "doubleCheck": true
    },
    {
        "dataID": "116810",
        "id": "53089516",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:32",
        "brokerTime": "2025-05-14 15:00:32",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052773",
        "positionId": "56052773",
        "volume": 7,
        "price": 3220.04,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3220.04,
        "doubleCheck": true
    },
    {
        "dataID": "116811",
        "id": "53089517",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:32",
        "brokerTime": "2025-05-14 15:00:32",
        "commission": -49,
        "swap": 0,
        "profit": -168,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052774",
        "positionId": "56052773",
        "volume": 7,
        "price": 3220.28,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -217,
        "priceIn": 3220.04,
        "doubleCheck": true
    },
    {
        "dataID": "116812",
        "id": "53089518",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:33",
        "brokerTime": "2025-05-14 15:00:33",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052775",
        "positionId": "56052775",
        "volume": 7,
        "price": 3219.95,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3219.95,
        "doubleCheck": true
    },
    {
        "dataID": "116813",
        "id": "53089519",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:33",
        "brokerTime": "2025-05-14 15:00:33",
        "commission": -49,
        "swap": 0,
        "profit": -42,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052776",
        "positionId": "56052775",
        "volume": 7,
        "price": 3220.01,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -91,
        "priceIn": 3219.95,
        "doubleCheck": true
    },
    {
        "dataID": "116814",
        "id": "53089520",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:34",
        "brokerTime": "2025-05-14 15:00:34",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052777",
        "positionId": "56052777",
        "volume": 7,
        "price": 3219.93,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3219.93,
        "doubleCheck": true
    },
    {
        "dataID": "116815",
        "id": "53089521",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:34",
        "brokerTime": "2025-05-14 15:00:34",
        "commission": -49,
        "swap": 0,
        "profit": -91,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052778",
        "positionId": "56052777",
        "volume": 7,
        "price": 3220.06,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -140,
        "priceIn": 3219.93,
        "doubleCheck": true
    },
    {
        "dataID": "116816",
        "id": "53089522",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:34",
        "brokerTime": "2025-05-14 15:00:34",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052779",
        "positionId": "56052779",
        "volume": 7,
        "price": 3219.87,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3219.87,
        "doubleCheck": true
    },
    {
        "dataID": "116817",
        "id": "53089523",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:34",
        "brokerTime": "2025-05-14 15:00:35",
        "commission": -49,
        "swap": 0,
        "profit": -119,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052780",
        "positionId": "56052779",
        "volume": 7,
        "price": 3220.04,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -168,
        "priceIn": 3219.87,
        "doubleCheck": true
    },
    {
        "dataID": "116818",
        "id": "53089524",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:35",
        "brokerTime": "2025-05-14 15:00:35",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052781",
        "positionId": "56052781",
        "volume": 7,
        "price": 3219.9,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3219.9,
        "doubleCheck": true
    },
    {
        "dataID": "116819",
        "id": "53089525",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:35",
        "brokerTime": "2025-05-14 15:00:36",
        "commission": -49,
        "swap": 0,
        "profit": -133,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052782",
        "positionId": "56052781",
        "volume": 7,
        "price": 3220.09,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -182,
        "priceIn": 3219.9,
        "doubleCheck": true
    },
    {
        "dataID": "116820",
        "id": "53089526",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:36",
        "brokerTime": "2025-05-14 15:00:36",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052784",
        "positionId": "56052784",
        "volume": 7,
        "price": 3219.73,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3219.73,
        "doubleCheck": true
    },
    {
        "dataID": "116821",
        "id": "53089529",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:36",
        "brokerTime": "2025-05-14 15:00:36",
        "commission": -49,
        "swap": 0,
        "profit": -133,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052785",
        "positionId": "56052784",
        "volume": 7,
        "price": 3219.92,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -182,
        "priceIn": 3219.73,
        "doubleCheck": true
    },
    {
        "dataID": "116822",
        "id": "53089530",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:37",
        "brokerTime": "2025-05-14 15:00:37",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052790",
        "positionId": "56052790",
        "volume": 7,
        "price": 3219.28,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3219.28,
        "doubleCheck": true
    },
    {
        "dataID": "116823",
        "id": "53089539",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:37",
        "brokerTime": "2025-05-14 15:00:38",
        "commission": -49,
        "swap": 0,
        "profit": -7,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052795",
        "positionId": "56052790",
        "volume": 7,
        "price": 3219.29,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56,
        "priceIn": 3219.28,
        "doubleCheck": true
    },
    {
        "dataID": "116824",
        "id": "53089540",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:38",
        "brokerTime": "2025-05-14 15:00:38",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052796",
        "positionId": "56052796",
        "volume": 7,
        "price": 3219.08,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3219.08,
        "doubleCheck": true
    },
    {
        "dataID": "116825",
        "id": "53089543",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:38",
        "brokerTime": "2025-05-14 15:00:39",
        "commission": -49,
        "swap": 0,
        "profit": -329,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052799",
        "positionId": "56052796",
        "volume": 7,
        "price": 3219.55,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -378,
        "priceIn": 3219.08,
        "doubleCheck": true
    },
    {
        "dataID": "116826",
        "id": "53089545",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:39",
        "brokerTime": "2025-05-14 15:00:39",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052813",
        "positionId": "56052813",
        "volume": 7,
        "price": 3219.61,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3219.61,
        "doubleCheck": true
    },
    {
        "dataID": "116827",
        "id": "53089576",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:39",
        "brokerTime": "2025-05-14 15:00:40",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052820",
        "positionId": "56052813",
        "volume": 7,
        "price": 3219.61,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3219.61,
        "doubleCheck": true
    },
    {
        "dataID": "116828",
        "id": "53089577",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:41",
        "brokerTime": "2025-05-14 15:00:41",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052821",
        "positionId": "56052821",
        "volume": 7,
        "price": 3219.28,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3219.28,
        "doubleCheck": true
    },
    {
        "dataID": "116829",
        "id": "53089578",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:41",
        "brokerTime": "2025-05-14 15:00:41",
        "commission": -49,
        "swap": 0,
        "profit": -154,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052822",
        "positionId": "56052821",
        "volume": 7,
        "price": 3219.5,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -203,
        "priceIn": 3219.28,
        "doubleCheck": true
    },
    {
        "dataID": "116830",
        "id": "53089579",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:41",
        "brokerTime": "2025-05-14 15:00:41",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052823",
        "positionId": "56052823",
        "volume": 7,
        "price": 3219.28,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3219.28,
        "doubleCheck": true
    },
    {
        "dataID": "116831",
        "id": "53089580",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:41",
        "brokerTime": "2025-05-14 15:00:42",
        "commission": -49,
        "swap": 0,
        "profit": -98,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052824",
        "positionId": "56052823",
        "volume": 7,
        "price": 3219.42,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -147,
        "priceIn": 3219.28,
        "doubleCheck": true
    },
    {
        "dataID": "116832",
        "id": "53089582",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:42",
        "brokerTime": "2025-05-14 15:00:42",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052826",
        "positionId": "56052826",
        "volume": 7,
        "price": 3219.22,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3219.22,
        "doubleCheck": true
    },
    {
        "dataID": "116833",
        "id": "53089585",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:42",
        "brokerTime": "2025-05-14 15:00:43",
        "commission": -49,
        "swap": 0,
        "profit": -35,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052829",
        "positionId": "56052826",
        "volume": 7,
        "price": 3219.27,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -84,
        "priceIn": 3219.22,
        "doubleCheck": true
    },
    {
        "dataID": "116834",
        "id": "53089586",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:44",
        "brokerTime": "2025-05-14 15:00:44",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052830",
        "positionId": "56052830",
        "volume": 7,
        "price": 3219.29,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3219.29,
        "doubleCheck": true
    },
    {
        "dataID": "116835",
        "id": "53089588",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:44",
        "brokerTime": "2025-05-14 15:00:44",
        "commission": -49,
        "swap": 0,
        "profit": -147,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052832",
        "positionId": "56052830",
        "volume": 7,
        "price": 3219.5,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -196,
        "priceIn": 3219.29,
        "doubleCheck": true
    },
    {
        "dataID": "116836",
        "id": "53089590",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:44",
        "brokerTime": "2025-05-14 15:00:44",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052833",
        "positionId": "56052833",
        "volume": 7,
        "price": 3219.34,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3219.34,
        "doubleCheck": true
    },
    {
        "dataID": "116837",
        "id": "53089591",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:44",
        "brokerTime": "2025-05-14 15:00:45",
        "commission": -49,
        "swap": 0,
        "profit": -112,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052834",
        "positionId": "56052833",
        "volume": 7,
        "price": 3219.5,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -161,
        "priceIn": 3219.34,
        "doubleCheck": true
    },
    {
        "dataID": "116838",
        "id": "53089592",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:45",
        "brokerTime": "2025-05-14 15:00:45",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052835",
        "positionId": "56052835",
        "volume": 7,
        "price": 3219.32,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3219.32,
        "doubleCheck": true
    },
    {
        "dataID": "116839",
        "id": "53089593",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:45",
        "brokerTime": "2025-05-14 15:00:46",
        "commission": -49,
        "swap": 0,
        "profit": 14,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052836",
        "positionId": "56052835",
        "volume": 7,
        "price": 3219.3,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -35,
        "priceIn": 3219.32,
        "doubleCheck": true
    },
    {
        "dataID": "119655",
        "id": "53089594",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:46",
        "brokerTime": "2025-05-14 15:00:46",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052837",
        "positionId": "56052837",
        "volume": 7,
        "price": 3219.04,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3219.04,
        "doubleCheck": true
    },
    {
        "dataID": "116840",
        "id": "53089595",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:46",
        "brokerTime": "2025-05-14 15:00:47",
        "commission": -49,
        "swap": 0,
        "profit": -343,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052838",
        "positionId": "56052837",
        "volume": 7,
        "price": 3219.53,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -392,
        "priceIn": 3219.04,
        "doubleCheck": true
    },
    {
        "dataID": "116841",
        "id": "53089596",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:47",
        "brokerTime": "2025-05-14 15:00:47",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052839",
        "positionId": "56052839",
        "volume": 7,
        "price": 3219.41,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3219.41,
        "doubleCheck": true
    },
    {
        "dataID": "116842",
        "id": "53089597",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:47",
        "brokerTime": "2025-05-14 15:00:48",
        "commission": -49,
        "swap": 0,
        "profit": -77,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052840",
        "positionId": "56052839",
        "volume": 7,
        "price": 3219.52,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -126,
        "priceIn": 3219.41,
        "doubleCheck": true
    },
    {
        "dataID": "116843",
        "id": "53089598",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:48",
        "brokerTime": "2025-05-14 15:00:48",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052841",
        "positionId": "56052841",
        "volume": 7,
        "price": 3219.32,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3219.32,
        "doubleCheck": true
    },
    {
        "dataID": "116844",
        "id": "53089599",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:48",
        "brokerTime": "2025-05-14 15:00:48",
        "commission": -49,
        "swap": 0,
        "profit": -224,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052842",
        "positionId": "56052841",
        "volume": 7,
        "price": 3219.64,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -273,
        "priceIn": 3219.32,
        "doubleCheck": true
    },
    {
        "dataID": "116845",
        "id": "53089601",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:49",
        "brokerTime": "2025-05-14 15:00:49",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052844",
        "positionId": "56052844",
        "volume": 7,
        "price": 3219.37,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3219.37,
        "doubleCheck": true
    },
    {
        "dataID": "116846",
        "id": "53089603",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:49",
        "brokerTime": "2025-05-14 15:00:50",
        "commission": -49,
        "swap": 0,
        "profit": -126,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052845",
        "positionId": "56052844",
        "volume": 7,
        "price": 3219.55,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -175,
        "priceIn": 3219.37,
        "doubleCheck": true
    },
    {
        "dataID": "116847",
        "id": "53089604",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:50",
        "brokerTime": "2025-05-14 15:00:50",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052846",
        "positionId": "56052846",
        "volume": 7,
        "price": 3219.44,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3219.44,
        "doubleCheck": true
    },
    {
        "dataID": "116848",
        "id": "53089605",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:50",
        "brokerTime": "2025-05-14 15:00:51",
        "commission": -49,
        "swap": 0,
        "profit": -133,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052847",
        "positionId": "56052846",
        "volume": 7,
        "price": 3219.63,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -182,
        "priceIn": 3219.44,
        "doubleCheck": true
    },
    {
        "dataID": "116849",
        "id": "53089606",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:52",
        "brokerTime": "2025-05-14 15:00:52",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052848",
        "positionId": "56052848",
        "volume": 7,
        "price": 3219.21,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3219.21,
        "doubleCheck": true
    },
    {
        "dataID": "116850",
        "id": "53089607",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:52",
        "brokerTime": "2025-05-14 15:00:52",
        "commission": -49,
        "swap": 0,
        "profit": -77,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052849",
        "positionId": "56052848",
        "volume": 7,
        "price": 3219.32,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -126,
        "priceIn": 3219.21,
        "doubleCheck": true
    },
    {
        "dataID": "116851",
        "id": "53089608",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:52",
        "brokerTime": "2025-05-14 15:00:52",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052850",
        "positionId": "56052850",
        "volume": 7,
        "price": 3219.16,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3219.16,
        "doubleCheck": true
    },
    {
        "dataID": "116852",
        "id": "53089609",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:52",
        "brokerTime": "2025-05-14 15:00:53",
        "commission": -49,
        "swap": 0,
        "profit": -112,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052851",
        "positionId": "56052850",
        "volume": 7,
        "price": 3219.32,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -161,
        "priceIn": 3219.16,
        "doubleCheck": true
    },
    {
        "dataID": "116853",
        "id": "53089610",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:53",
        "brokerTime": "2025-05-14 15:00:53",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052852",
        "positionId": "56052852",
        "volume": 7,
        "price": 3219.14,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3219.14,
        "doubleCheck": true
    },
    {
        "dataID": "116854",
        "id": "53089611",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:53",
        "brokerTime": "2025-05-14 15:00:53",
        "commission": -49,
        "swap": 0,
        "profit": -259,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052853",
        "positionId": "56052852",
        "volume": 7,
        "price": 3219.51,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -308,
        "priceIn": 3219.14,
        "doubleCheck": true
    },
    {
        "dataID": "116855",
        "id": "53089612",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:54",
        "brokerTime": "2025-05-14 15:00:54",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052854",
        "positionId": "56052854",
        "volume": 7,
        "price": 3219.27,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3219.27,
        "doubleCheck": true
    },
    {
        "dataID": "116856",
        "id": "53089613",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:54",
        "brokerTime": "2025-05-14 15:00:54",
        "commission": -49,
        "swap": 0,
        "profit": -161,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052855",
        "positionId": "56052854",
        "volume": 7,
        "price": 3219.5,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -210,
        "priceIn": 3219.27,
        "doubleCheck": true
    },
    {
        "dataID": "116857",
        "id": "53089614",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:55",
        "brokerTime": "2025-05-14 15:00:55",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052856",
        "positionId": "56052856",
        "volume": 7,
        "price": 3219.32,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3219.32,
        "doubleCheck": true
    },
    {
        "dataID": "116858",
        "id": "53089615",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:55",
        "brokerTime": "2025-05-14 15:00:56",
        "commission": -49,
        "swap": 0,
        "profit": -245,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052857",
        "positionId": "56052856",
        "volume": 7,
        "price": 3219.67,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -294,
        "priceIn": 3219.32,
        "doubleCheck": true
    },
    {
        "dataID": "116859",
        "id": "53089616",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:56",
        "brokerTime": "2025-05-14 15:00:56",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052858",
        "positionId": "56052858",
        "volume": 7,
        "price": 3219.47,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3219.47,
        "doubleCheck": true
    },
    {
        "dataID": "116860",
        "id": "53089617",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:56",
        "brokerTime": "2025-05-14 15:00:57",
        "commission": -49,
        "swap": 0,
        "profit": -140,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052859",
        "positionId": "56052858",
        "volume": 7,
        "price": 3219.67,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -189,
        "priceIn": 3219.47,
        "doubleCheck": true
    },
    {
        "dataID": "116861",
        "id": "53089618",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:58",
        "brokerTime": "2025-05-14 15:00:58",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052860",
        "positionId": "56052860",
        "volume": 7,
        "price": 3219.29,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3219.29,
        "doubleCheck": true
    },
    {
        "dataID": "116862",
        "id": "53089619",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:58",
        "brokerTime": "2025-05-14 15:00:58",
        "commission": -49,
        "swap": 0,
        "profit": -63,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052861",
        "positionId": "56052860",
        "volume": 7,
        "price": 3219.38,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -112,
        "priceIn": 3219.29,
        "doubleCheck": true
    },
    {
        "dataID": "116863",
        "id": "53089620",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:59",
        "brokerTime": "2025-05-14 15:00:59",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052862",
        "positionId": "56052862",
        "volume": 7,
        "price": 3219.27,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3219.27,
        "doubleCheck": true
    },
    {
        "dataID": "116864",
        "id": "53089621",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:59",
        "brokerTime": "2025-05-14 15:00:59",
        "commission": -49,
        "swap": 0,
        "profit": -147,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052863",
        "positionId": "56052862",
        "volume": 7,
        "price": 3219.48,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -196,
        "priceIn": 3219.27,
        "doubleCheck": true
    },
    {
        "dataID": "116865",
        "id": "53089622",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:00",
        "brokerTime": "2025-05-14 15:01:00",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052864",
        "positionId": "56052864",
        "volume": 7,
        "price": 3219.32,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3219.32,
        "doubleCheck": true
    },
    {
        "dataID": "116866",
        "id": "53089625",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:00",
        "brokerTime": "2025-05-14 15:01:01",
        "commission": -49,
        "swap": 0,
        "profit": -147,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052867",
        "positionId": "56052864",
        "volume": 7,
        "price": 3219.53,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -196,
        "priceIn": 3219.32,
        "doubleCheck": true
    },
    {
        "dataID": "116867",
        "id": "53089626",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:01",
        "brokerTime": "2025-05-14 15:01:01",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052868",
        "positionId": "56052868",
        "volume": 7,
        "price": 3219.37,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3219.37,
        "doubleCheck": true
    },
    {
        "dataID": "116868",
        "id": "53089627",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:01",
        "brokerTime": "2025-05-14 15:01:01",
        "commission": -49,
        "swap": 0,
        "profit": -126,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052869",
        "positionId": "56052868",
        "volume": 7,
        "price": 3219.55,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -175,
        "priceIn": 3219.37,
        "doubleCheck": true
    },
    {
        "dataID": "116869",
        "id": "53089628",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:02",
        "brokerTime": "2025-05-14 15:01:02",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052870",
        "positionId": "56052870",
        "volume": 7,
        "price": 3219.25,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3219.25,
        "doubleCheck": true
    },
    {
        "dataID": "116870",
        "id": "53089632",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:02",
        "brokerTime": "2025-05-14 15:01:02",
        "commission": -49,
        "swap": 0,
        "profit": -126,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052875",
        "positionId": "56052870",
        "volume": 7,
        "price": 3219.43,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -175,
        "priceIn": 3219.25,
        "doubleCheck": true
    },
    {
        "dataID": "116871",
        "id": "53089658",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:03",
        "brokerTime": "2025-05-14 15:01:03",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052897",
        "positionId": "56052897",
        "volume": 7,
        "price": 3219.24,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3219.24,
        "doubleCheck": true
    },
    {
        "dataID": "116872",
        "id": "53089682",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:03",
        "brokerTime": "2025-05-14 15:01:04",
        "commission": -49,
        "swap": 0,
        "profit": -28,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052908",
        "positionId": "56052897",
        "volume": 7,
        "price": 3219.28,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -77,
        "priceIn": 3219.24,
        "doubleCheck": true
    },
    {
        "dataID": "116873",
        "id": "53089684",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:04",
        "brokerTime": "2025-05-14 15:01:04",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052910",
        "positionId": "56052910",
        "volume": 7,
        "price": 3219.02,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3219.02,
        "doubleCheck": true
    },
    {
        "dataID": "116874",
        "id": "53089685",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:04",
        "brokerTime": "2025-05-14 15:01:05",
        "commission": -49,
        "swap": 0,
        "profit": -182,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052911",
        "positionId": "56052910",
        "volume": 7,
        "price": 3219.28,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -231,
        "priceIn": 3219.02,
        "doubleCheck": true
    },
    {
        "dataID": "116875",
        "id": "53089693",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:06",
        "brokerTime": "2025-05-14 15:01:06",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052916",
        "positionId": "56052916",
        "volume": 7,
        "price": 3219.07,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3219.07,
        "doubleCheck": true
    },
    {
        "dataID": "116876",
        "id": "53089694",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:06",
        "brokerTime": "2025-05-14 15:01:06",
        "commission": -49,
        "swap": 0,
        "profit": -175,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052917",
        "positionId": "56052916",
        "volume": 7,
        "price": 3219.32,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -224,
        "priceIn": 3219.07,
        "doubleCheck": true
    },
    {
        "dataID": "116877",
        "id": "53089695",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:07",
        "brokerTime": "2025-05-14 15:01:07",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052918",
        "positionId": "56052918",
        "volume": 7,
        "price": 3219.16,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3219.16,
        "doubleCheck": true
    },
    {
        "dataID": "116878",
        "id": "53089699",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:07",
        "brokerTime": "2025-05-14 15:01:07",
        "commission": -49,
        "swap": 0,
        "profit": 189,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052923",
        "positionId": "56052918",
        "volume": 7,
        "price": 3218.89,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 140,
        "priceIn": 3219.16,
        "doubleCheck": true
    },
    {
        "dataID": "116879",
        "id": "53089703",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:08",
        "brokerTime": "2025-05-14 15:01:08",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052927",
        "positionId": "56052927",
        "volume": 7,
        "price": 3218.63,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49,
        "priceIn": 3218.63,
        "doubleCheck": true
    },
    {
        "dataID": "116880",
        "id": "53089705",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:08",
        "brokerTime": "2025-05-14 15:01:08",
        "commission": -49,
        "swap": 0,
        "profit": -126,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052928",
        "positionId": "56052927",
        "volume": 7,
        "price": 3218.81,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -175,
        "priceIn": 3218.63,
        "doubleCheck": true
    },
    {
        "dataID": "116881",
        "id": "53089706",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 15:01:08",
        "brokerTime": "2025-05-14 15:01:08",
        "commission": -8.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052929",
        "positionId": "56052929",
        "volume": 1.28,
        "price": 3218.71,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3318.71,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -8.96,
        "priceIn": 3218.71,
        "doubleCheck": true
    },
    {
        "dataID": "116882",
        "id": "53089708",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:09",
        "brokerTime": "2025-05-14 15:01:09",
        "commission": -59.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052931",
        "positionId": "56052931",
        "volume": 8.54,
        "price": 3218.47,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -59.78,
        "priceIn": 3218.47,
        "doubleCheck": true
    },
    {
        "dataID": "116883",
        "id": "53089709",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:09",
        "brokerTime": "2025-05-14 15:01:10",
        "commission": -59.78,
        "swap": 0,
        "profit": -187.88,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052932",
        "positionId": "56052931",
        "volume": 8.54,
        "price": 3218.69,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -247.66,
        "priceIn": 3218.47,
        "doubleCheck": true
    },
    {
        "dataID": "116884",
        "id": "53089710",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:10",
        "brokerTime": "2025-05-14 15:01:10",
        "commission": -59.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052933",
        "positionId": "56052933",
        "volume": 8.54,
        "price": 3218.61,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -59.78,
        "priceIn": 3218.61,
        "doubleCheck": true
    },
    {
        "dataID": "116885",
        "id": "53089711",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:10",
        "brokerTime": "2025-05-14 15:01:11",
        "commission": -59.78,
        "swap": 0,
        "profit": -111.02,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052934",
        "positionId": "56052933",
        "volume": 8.54,
        "price": 3218.74,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -170.8,
        "priceIn": 3218.61,
        "doubleCheck": true
    },
    {
        "dataID": "116886",
        "id": "53089712",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:11",
        "brokerTime": "2025-05-14 15:01:11",
        "commission": -59.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052935",
        "positionId": "56052935",
        "volume": 8.54,
        "price": 3218.52,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -59.78,
        "priceIn": 3218.52,
        "doubleCheck": true
    },
    {
        "dataID": "116887",
        "id": "53089713",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:11",
        "brokerTime": "2025-05-14 15:01:12",
        "commission": -59.78,
        "swap": 0,
        "profit": -196.42,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052936",
        "positionId": "56052935",
        "volume": 8.54,
        "price": 3218.75,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -256.2,
        "priceIn": 3218.52,
        "doubleCheck": true
    },
    {
        "dataID": "116888",
        "id": "53089715",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:13",
        "brokerTime": "2025-05-14 15:01:13",
        "commission": -59.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052938",
        "positionId": "56052938",
        "volume": 8.54,
        "price": 3218.47,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -59.78,
        "priceIn": 3218.47,
        "doubleCheck": true
    },
    {
        "dataID": "116889",
        "id": "53089716",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:13",
        "brokerTime": "2025-05-14 15:01:13",
        "commission": -59.78,
        "swap": 0,
        "profit": -204.96,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052939",
        "positionId": "56052938",
        "volume": 8.54,
        "price": 3218.71,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -264.74,
        "priceIn": 3218.47,
        "doubleCheck": true
    },
    {
        "dataID": "116890",
        "id": "53089717",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:13",
        "brokerTime": "2025-05-14 15:01:13",
        "commission": -59.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052940",
        "positionId": "56052940",
        "volume": 8.54,
        "price": 3218.46,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -59.78,
        "priceIn": 3218.46,
        "doubleCheck": true
    },
    {
        "dataID": "116891",
        "id": "53089718",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:13",
        "brokerTime": "2025-05-14 15:01:14",
        "commission": -59.78,
        "swap": 0,
        "profit": -170.8,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052941",
        "positionId": "56052940",
        "volume": 8.54,
        "price": 3218.66,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -230.58,
        "priceIn": 3218.46,
        "doubleCheck": true
    },
    {
        "dataID": "116892",
        "id": "53089719",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:14",
        "brokerTime": "2025-05-14 15:01:14",
        "commission": -59.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052942",
        "positionId": "56052942",
        "volume": 8.54,
        "price": 3218.55,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -59.78,
        "priceIn": 3218.55,
        "doubleCheck": true
    },
    {
        "dataID": "116893",
        "id": "53089720",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:14",
        "brokerTime": "2025-05-14 15:01:15",
        "commission": -59.78,
        "swap": 0,
        "profit": -247.66,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052943",
        "positionId": "56052942",
        "volume": 8.54,
        "price": 3218.84,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -307.44,
        "priceIn": 3218.55,
        "doubleCheck": true
    },
    {
        "dataID": "116894",
        "id": "53089721",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:15",
        "brokerTime": "2025-05-14 15:01:15",
        "commission": -59.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052944",
        "positionId": "56052944",
        "volume": 8.54,
        "price": 3218.58,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -59.78,
        "priceIn": 3218.58,
        "doubleCheck": true
    },
    {
        "dataID": "116895",
        "id": "53089722",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:15",
        "brokerTime": "2025-05-14 15:01:16",
        "commission": -59.78,
        "swap": 0,
        "profit": -162.26,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052945",
        "positionId": "56052944",
        "volume": 8.54,
        "price": 3218.77,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -222.04,
        "priceIn": 3218.58,
        "doubleCheck": true
    },
    {
        "dataID": "116896",
        "id": "53089724",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:17",
        "brokerTime": "2025-05-14 15:01:17",
        "commission": -59.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052947",
        "positionId": "56052947",
        "volume": 8.54,
        "price": 3218.52,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -59.78,
        "priceIn": 3218.52,
        "doubleCheck": true
    },
    {
        "dataID": "116897",
        "id": "53089725",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:17",
        "brokerTime": "2025-05-14 15:01:17",
        "commission": -59.78,
        "swap": 0,
        "profit": -350.14,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052948",
        "positionId": "56052947",
        "volume": 8.54,
        "price": 3218.93,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -409.91999999999996,
        "priceIn": 3218.52,
        "doubleCheck": true
    },
    {
        "dataID": "116898",
        "id": "53089727",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:18",
        "brokerTime": "2025-05-14 15:01:18",
        "commission": -59.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052950",
        "positionId": "56052950",
        "volume": 8.54,
        "price": 3218.68,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -59.78,
        "priceIn": 3218.68,
        "doubleCheck": true
    },
    {
        "dataID": "116899",
        "id": "53089728",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:18",
        "brokerTime": "2025-05-14 15:01:19",
        "commission": -59.78,
        "swap": 0,
        "profit": -162.26,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052951",
        "positionId": "56052950",
        "volume": 8.54,
        "price": 3218.87,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -222.04,
        "priceIn": 3218.68,
        "doubleCheck": true
    },
    {
        "dataID": "116900",
        "id": "53089729",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:19",
        "brokerTime": "2025-05-14 15:01:19",
        "commission": -59.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052952",
        "positionId": "56052952",
        "volume": 8.54,
        "price": 3218.45,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -59.78,
        "priceIn": 3218.45,
        "doubleCheck": true
    },
    {
        "dataID": "116901",
        "id": "53089730",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:19",
        "brokerTime": "2025-05-14 15:01:19",
        "commission": -59.78,
        "swap": 0,
        "profit": -93.94,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052953",
        "positionId": "56052952",
        "volume": 8.54,
        "price": 3218.56,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -153.72,
        "priceIn": 3218.45,
        "doubleCheck": true
    },
    {
        "dataID": "116902",
        "id": "53089732",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:19",
        "brokerTime": "2025-05-14 15:01:19",
        "commission": -59.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052955",
        "positionId": "56052955",
        "volume": 8.54,
        "price": 3218.37,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -59.78,
        "priceIn": 3218.37,
        "doubleCheck": true
    },
    {
        "dataID": "116903",
        "id": "53089733",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:19",
        "brokerTime": "2025-05-14 15:01:20",
        "commission": -59.78,
        "swap": 0,
        "profit": -59.78,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052956",
        "positionId": "56052955",
        "volume": 8.54,
        "price": 3218.44,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -119.56,
        "priceIn": 3218.37,
        "doubleCheck": true
    },
    {
        "dataID": "116904",
        "id": "53089734",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:20",
        "brokerTime": "2025-05-14 15:01:20",
        "commission": -59.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052957",
        "positionId": "56052957",
        "volume": 8.54,
        "price": 3218.29,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -59.78,
        "priceIn": 3218.29,
        "doubleCheck": true
    },
    {
        "dataID": "116905",
        "id": "53089735",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:20",
        "brokerTime": "2025-05-14 15:01:21",
        "commission": -59.78,
        "swap": 0,
        "profit": -93.94,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052958",
        "positionId": "56052957",
        "volume": 8.54,
        "price": 3218.4,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -153.72,
        "priceIn": 3218.29,
        "doubleCheck": true
    },
    {
        "dataID": "116906",
        "id": "53089738",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:21",
        "brokerTime": "2025-05-14 15:01:21",
        "commission": -59.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052962",
        "positionId": "56052962",
        "volume": 8.54,
        "price": 3218.1,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -59.78,
        "priceIn": 3218.1,
        "doubleCheck": true
    },
    {
        "dataID": "116907",
        "id": "53089749",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:21",
        "brokerTime": "2025-05-14 15:01:22",
        "commission": -59.78,
        "swap": 0,
        "profit": -247.66,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052973",
        "positionId": "56052962",
        "volume": 8.54,
        "price": 3218.39,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -307.44,
        "priceIn": 3218.1,
        "doubleCheck": true
    },
    {
        "dataID": "116908",
        "id": "53089752",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:22",
        "brokerTime": "2025-05-14 15:01:22",
        "commission": -59.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052974",
        "positionId": "56052974",
        "volume": 8.54,
        "price": 3218.35,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -59.78,
        "priceIn": 3218.35,
        "doubleCheck": true
    },
    {
        "dataID": "116909",
        "id": "53089755",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:22",
        "brokerTime": "2025-05-14 15:01:22",
        "commission": -59.78,
        "swap": 0,
        "profit": -264.74,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052976",
        "positionId": "56052974",
        "volume": 8.54,
        "price": 3218.66,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -324.52,
        "priceIn": 3218.35,
        "doubleCheck": true
    },
    {
        "dataID": "116910",
        "id": "53089756",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:23",
        "brokerTime": "2025-05-14 15:01:23",
        "commission": -59.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052977",
        "positionId": "56052977",
        "volume": 8.54,
        "price": 3218.5,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -59.78,
        "priceIn": 3218.5,
        "doubleCheck": true
    },
    {
        "dataID": "116911",
        "id": "53089757",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:23",
        "brokerTime": "2025-05-14 15:01:23",
        "commission": -59.78,
        "swap": 0,
        "profit": -247.66,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052978",
        "positionId": "56052977",
        "volume": 8.54,
        "price": 3218.79,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -307.44,
        "priceIn": 3218.5,
        "doubleCheck": true
    },
    {
        "dataID": "116912",
        "id": "53089758",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:23",
        "brokerTime": "2025-05-14 15:01:23",
        "commission": -59.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052979",
        "positionId": "56052979",
        "volume": 8.54,
        "price": 3218.68,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -59.78,
        "priceIn": 3218.68,
        "doubleCheck": true
    },
    {
        "dataID": "116913",
        "id": "53089759",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:23",
        "brokerTime": "2025-05-14 15:01:24",
        "commission": -59.78,
        "swap": 0,
        "profit": -204.96,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052980",
        "positionId": "56052979",
        "volume": 8.54,
        "price": 3218.92,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -264.74,
        "priceIn": 3218.68,
        "doubleCheck": true
    },
    {
        "dataID": "116914",
        "id": "53089760",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:24",
        "brokerTime": "2025-05-14 15:01:24",
        "commission": -59.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052981",
        "positionId": "56052981",
        "volume": 8.54,
        "price": 3218.99,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -59.78,
        "priceIn": 3218.99,
        "doubleCheck": true
    },
    {
        "dataID": "116915",
        "id": "53089761",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:24",
        "brokerTime": "2025-05-14 15:01:25",
        "commission": -59.78,
        "swap": 0,
        "profit": -153.72,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052982",
        "positionId": "56052981",
        "volume": 8.54,
        "price": 3219.17,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -213.5,
        "priceIn": 3218.99,
        "doubleCheck": true
    },
    {
        "dataID": "116916",
        "id": "53089762",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:25",
        "brokerTime": "2025-05-14 15:01:25",
        "commission": -59.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052983",
        "positionId": "56052983",
        "volume": 8.54,
        "price": 3218.98,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -59.78,
        "priceIn": 3218.98,
        "doubleCheck": true
    },
    {
        "dataID": "116917",
        "id": "53089763",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:25",
        "brokerTime": "2025-05-14 15:01:26",
        "commission": -59.78,
        "swap": 0,
        "profit": -25.62,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052984",
        "positionId": "56052983",
        "volume": 8.54,
        "price": 3219.01,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -85.4,
        "priceIn": 3218.98,
        "doubleCheck": true
    },
    {
        "dataID": "116918",
        "id": "53089765",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:26",
        "brokerTime": "2025-05-14 15:01:26",
        "commission": -59.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052986",
        "positionId": "56052986",
        "volume": 8.54,
        "price": 3218.85,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -59.78,
        "priceIn": 3218.85,
        "doubleCheck": true
    },
    {
        "dataID": "116919",
        "id": "53089766",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:26",
        "brokerTime": "2025-05-14 15:01:27",
        "commission": -59.78,
        "swap": 0,
        "profit": -153.72,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052987",
        "positionId": "56052986",
        "volume": 8.54,
        "price": 3219.03,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -213.5,
        "priceIn": 3218.85,
        "doubleCheck": true
    },
    {
        "dataID": "116920",
        "id": "53089767",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:27",
        "brokerTime": "2025-05-14 15:01:27",
        "commission": -59.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052988",
        "positionId": "56052988",
        "volume": 8.54,
        "price": 3218.81,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -59.78,
        "priceIn": 3218.81,
        "doubleCheck": true
    },
    {
        "dataID": "116921",
        "id": "53089768",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:27",
        "brokerTime": "2025-05-14 15:01:28",
        "commission": -59.78,
        "swap": 0,
        "profit": -179.34,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052989",
        "positionId": "56052988",
        "volume": 8.54,
        "price": 3219.02,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -239.12,
        "priceIn": 3218.81,
        "doubleCheck": true
    },
    {
        "dataID": "116922",
        "id": "53089769",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:28",
        "brokerTime": "2025-05-14 15:01:28",
        "commission": -59.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052990",
        "positionId": "56052990",
        "volume": 8.54,
        "price": 3218.95,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -59.78,
        "priceIn": 3218.95,
        "doubleCheck": true
    },
    {
        "dataID": "116923",
        "id": "53089770",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:28",
        "brokerTime": "2025-05-14 15:01:29",
        "commission": -59.78,
        "swap": 0,
        "profit": -162.26,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052991",
        "positionId": "56052990",
        "volume": 8.54,
        "price": 3219.14,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -222.04,
        "priceIn": 3218.95,
        "doubleCheck": true
    },
    {
        "dataID": "116924",
        "id": "53089771",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:29",
        "brokerTime": "2025-05-14 15:01:29",
        "commission": -59.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052992",
        "positionId": "56052992",
        "volume": 8.54,
        "price": 3219,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -59.78,
        "priceIn": 3219,
        "doubleCheck": true
    },
    {
        "dataID": "116925",
        "id": "53089772",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:29",
        "brokerTime": "2025-05-14 15:01:30",
        "commission": -59.78,
        "swap": 0,
        "profit": -119.56,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052993",
        "positionId": "56052992",
        "volume": 8.54,
        "price": 3219.14,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -179.34,
        "priceIn": 3219,
        "doubleCheck": true
    },
    {
        "dataID": "116926",
        "id": "53089775",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:30",
        "brokerTime": "2025-05-14 15:01:30",
        "commission": -59.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052995",
        "positionId": "56052995",
        "volume": 8.54,
        "price": 3218.9,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -59.78,
        "priceIn": 3218.9,
        "doubleCheck": true
    },
    {
        "dataID": "116927",
        "id": "53089776",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:30",
        "brokerTime": "2025-05-14 15:01:31",
        "commission": -59.78,
        "swap": 0,
        "profit": -111.02,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052996",
        "positionId": "56052995",
        "volume": 8.54,
        "price": 3219.03,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -170.8,
        "priceIn": 3218.9,
        "doubleCheck": true
    },
    {
        "dataID": "116928",
        "id": "53089777",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:31",
        "brokerTime": "2025-05-14 15:01:31",
        "commission": -59.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052997",
        "positionId": "56052997",
        "volume": 8.54,
        "price": 3218.83,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -59.78,
        "priceIn": 3218.83,
        "doubleCheck": true
    },
    {
        "dataID": "116929",
        "id": "53089778",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:31",
        "brokerTime": "2025-05-14 15:01:32",
        "commission": -59.78,
        "swap": 0,
        "profit": -145.18,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052998",
        "positionId": "56052997",
        "volume": 8.54,
        "price": 3219,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -204.96,
        "priceIn": 3218.83,
        "doubleCheck": true
    },
    {
        "dataID": "116930",
        "id": "53089779",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:33",
        "brokerTime": "2025-05-14 15:01:33",
        "commission": -59.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56052999",
        "positionId": "56052999",
        "volume": 8.54,
        "price": 3218.88,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -59.78,
        "priceIn": 3218.88,
        "doubleCheck": true
    },
    {
        "dataID": "116931",
        "id": "53089780",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:33",
        "brokerTime": "2025-05-14 15:01:33",
        "commission": -59.78,
        "swap": 0,
        "profit": -42.7,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053000",
        "positionId": "56052999",
        "volume": 8.54,
        "price": 3218.93,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -102.48,
        "priceIn": 3218.88,
        "doubleCheck": true
    },
    {
        "dataID": "116932",
        "id": "53089781",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:34",
        "brokerTime": "2025-05-14 15:01:34",
        "commission": -59.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053001",
        "positionId": "56053001",
        "volume": 8.54,
        "price": 3218.78,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -59.78,
        "priceIn": 3218.78,
        "doubleCheck": true
    },
    {
        "dataID": "116933",
        "id": "53089782",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:34",
        "brokerTime": "2025-05-14 15:01:34",
        "commission": -59.78,
        "swap": 0,
        "profit": -162.26,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053002",
        "positionId": "56053001",
        "volume": 8.54,
        "price": 3218.97,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -222.04,
        "priceIn": 3218.78,
        "doubleCheck": true
    },
    {
        "dataID": "116934",
        "id": "53089783",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:35",
        "brokerTime": "2025-05-14 15:01:35",
        "commission": -59.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053003",
        "positionId": "56053003",
        "volume": 8.54,
        "price": 3218.82,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -59.78,
        "priceIn": 3218.82,
        "doubleCheck": true
    },
    {
        "dataID": "116935",
        "id": "53089784",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:35",
        "brokerTime": "2025-05-14 15:01:36",
        "commission": -59.78,
        "swap": 0,
        "profit": -213.5,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053004",
        "positionId": "56053003",
        "volume": 8.54,
        "price": 3219.07,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -273.28,
        "priceIn": 3218.82,
        "doubleCheck": true
    },
    {
        "dataID": "116936",
        "id": "53089785",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:36",
        "brokerTime": "2025-05-14 15:01:36",
        "commission": -59.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053005",
        "positionId": "56053005",
        "volume": 8.54,
        "price": 3218.87,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -59.78,
        "priceIn": 3218.87,
        "doubleCheck": true
    },
    {
        "dataID": "116937",
        "id": "53089786",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:36",
        "brokerTime": "2025-05-14 15:01:37",
        "commission": -59.78,
        "swap": 0,
        "profit": -170.8,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053006",
        "positionId": "56053005",
        "volume": 8.54,
        "price": 3219.07,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -230.58,
        "priceIn": 3218.87,
        "doubleCheck": true
    },
    {
        "dataID": "116938",
        "id": "53089787",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:37",
        "brokerTime": "2025-05-14 15:01:37",
        "commission": -59.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053007",
        "positionId": "56053007",
        "volume": 8.54,
        "price": 3218.86,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -59.78,
        "priceIn": 3218.86,
        "doubleCheck": true
    },
    {
        "dataID": "116939",
        "id": "53089790",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:37",
        "brokerTime": "2025-05-14 15:01:38",
        "commission": -59.78,
        "swap": 0,
        "profit": 119.56,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053009",
        "positionId": "56053007",
        "volume": 8.54,
        "price": 3218.72,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 59.78,
        "priceIn": 3218.86,
        "doubleCheck": true
    },
    {
        "dataID": "116940",
        "id": "53089792",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:39",
        "brokerTime": "2025-05-14 15:01:39",
        "commission": -59.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053011",
        "positionId": "56053011",
        "volume": 8.54,
        "price": 3218.55,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -59.78,
        "priceIn": 3218.55,
        "doubleCheck": true
    },
    {
        "dataID": "116941",
        "id": "53089794",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:39",
        "brokerTime": "2025-05-14 15:01:39",
        "commission": -59.78,
        "swap": 0,
        "profit": -162.26,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053012",
        "positionId": "56053011",
        "volume": 8.54,
        "price": 3218.74,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -222.04,
        "priceIn": 3218.55,
        "doubleCheck": true
    },
    {
        "dataID": "116942",
        "id": "53089795",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:39",
        "brokerTime": "2025-05-14 15:01:39",
        "commission": -59.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053013",
        "positionId": "56053013",
        "volume": 8.54,
        "price": 3218.6,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -59.78,
        "priceIn": 3218.6,
        "doubleCheck": true
    },
    {
        "dataID": "116943",
        "id": "53089796",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:39",
        "brokerTime": "2025-05-14 15:01:40",
        "commission": -59.78,
        "swap": 0,
        "profit": -128.1,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053014",
        "positionId": "56053013",
        "volume": 8.54,
        "price": 3218.75,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -187.88,
        "priceIn": 3218.6,
        "doubleCheck": true
    },
    {
        "dataID": "116944",
        "id": "53089797",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:40",
        "brokerTime": "2025-05-14 15:01:40",
        "commission": -59.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053015",
        "positionId": "56053015",
        "volume": 8.54,
        "price": 3218.56,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -59.78,
        "priceIn": 3218.56,
        "doubleCheck": true
    },
    {
        "dataID": "116945",
        "id": "53089798",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:40",
        "brokerTime": "2025-05-14 15:01:41",
        "commission": -59.78,
        "swap": 0,
        "profit": -34.16,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053016",
        "positionId": "56053015",
        "volume": 8.54,
        "price": 3218.6,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -93.94,
        "priceIn": 3218.56,
        "doubleCheck": true
    },
    {
        "dataID": "116946",
        "id": "53089799",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:41",
        "brokerTime": "2025-05-14 15:01:41",
        "commission": -59.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053017",
        "positionId": "56053017",
        "volume": 8.54,
        "price": 3218.48,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -59.78,
        "priceIn": 3218.48,
        "doubleCheck": true
    },
    {
        "dataID": "116947",
        "id": "53089800",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:41",
        "brokerTime": "2025-05-14 15:01:42",
        "commission": -59.78,
        "swap": 0,
        "profit": -136.64,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053018",
        "positionId": "56053017",
        "volume": 8.54,
        "price": 3218.64,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -196.42,
        "priceIn": 3218.48,
        "doubleCheck": true
    },
    {
        "dataID": "116948",
        "id": "53089801",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:42",
        "brokerTime": "2025-05-14 15:01:42",
        "commission": -59.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053019",
        "positionId": "56053019",
        "volume": 8.54,
        "price": 3218.44,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -59.78,
        "priceIn": 3218.44,
        "doubleCheck": true
    },
    {
        "dataID": "116949",
        "id": "53089802",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:42",
        "brokerTime": "2025-05-14 15:01:42",
        "commission": -59.78,
        "swap": 0,
        "profit": -179.34,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053020",
        "positionId": "56053019",
        "volume": 8.54,
        "price": 3218.65,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -239.12,
        "priceIn": 3218.44,
        "doubleCheck": true
    },
    {
        "dataID": "116950",
        "id": "53089803",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:43",
        "brokerTime": "2025-05-14 15:01:43",
        "commission": -59.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053021",
        "positionId": "56053021",
        "volume": 8.54,
        "price": 3218.5,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -59.78,
        "priceIn": 3218.5,
        "doubleCheck": true
    },
    {
        "dataID": "116951",
        "id": "53089804",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:43",
        "brokerTime": "2025-05-14 15:01:43",
        "commission": -59.78,
        "swap": 0,
        "profit": 85.4,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053022",
        "positionId": "56053021",
        "volume": 8.54,
        "price": 3218.4,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 25.620000000000005,
        "priceIn": 3218.5,
        "doubleCheck": true
    },
    {
        "dataID": "116952",
        "id": "53089805",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:44",
        "brokerTime": "2025-05-14 15:01:44",
        "commission": -59.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053023",
        "positionId": "56053023",
        "volume": 8.54,
        "price": 3218.28,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -59.78,
        "priceIn": 3218.28,
        "doubleCheck": true
    },
    {
        "dataID": "116953",
        "id": "53089806",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:44",
        "brokerTime": "2025-05-14 15:01:44",
        "commission": -59.78,
        "swap": 0,
        "profit": -170.8,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053024",
        "positionId": "56053023",
        "volume": 8.54,
        "price": 3218.48,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -230.58,
        "priceIn": 3218.28,
        "doubleCheck": true
    },
    {
        "dataID": "116954",
        "id": "53089807",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:45",
        "brokerTime": "2025-05-14 15:01:45",
        "commission": -59.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053025",
        "positionId": "56053025",
        "volume": 8.54,
        "price": 3218.3,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -59.78,
        "priceIn": 3218.3,
        "doubleCheck": true
    },
    {
        "dataID": "116955",
        "id": "53089815",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:45",
        "brokerTime": "2025-05-14 15:01:46",
        "commission": -59.78,
        "swap": 0,
        "profit": -119.56,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053032",
        "positionId": "56053025",
        "volume": 8.54,
        "price": 3218.44,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -179.34,
        "priceIn": 3218.3,
        "doubleCheck": true
    },
    {
        "dataID": "116956",
        "id": "53089821",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:47",
        "brokerTime": "2025-05-14 15:01:47",
        "commission": -59.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053033",
        "positionId": "56053033",
        "volume": 8.54,
        "price": 3218.34,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -59.78,
        "priceIn": 3218.34,
        "doubleCheck": true
    },
    {
        "dataID": "116957",
        "id": "53089822",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:47",
        "brokerTime": "2025-05-14 15:01:47",
        "commission": -59.78,
        "swap": 0,
        "profit": -136.64,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053034",
        "positionId": "56053033",
        "volume": 8.54,
        "price": 3218.5,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -196.42,
        "priceIn": 3218.34,
        "doubleCheck": true
    },
    {
        "dataID": "116958",
        "id": "53089823",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:48",
        "brokerTime": "2025-05-14 15:01:48",
        "commission": -59.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053035",
        "positionId": "56053035",
        "volume": 8.54,
        "price": 3218.28,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -59.78,
        "priceIn": 3218.28,
        "doubleCheck": true
    },
    {
        "dataID": "116959",
        "id": "53089824",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:48",
        "brokerTime": "2025-05-14 15:01:48",
        "commission": -59.78,
        "swap": 0,
        "profit": -85.4,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053036",
        "positionId": "56053035",
        "volume": 8.54,
        "price": 3218.38,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -145.18,
        "priceIn": 3218.28,
        "doubleCheck": true
    },
    {
        "dataID": "116960",
        "id": "53089825",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:49",
        "brokerTime": "2025-05-14 15:01:49",
        "commission": -59.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053037",
        "positionId": "56053037",
        "volume": 8.54,
        "price": 3218.23,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -59.78,
        "priceIn": 3218.23,
        "doubleCheck": true
    },
    {
        "dataID": "116961",
        "id": "53089826",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:49",
        "brokerTime": "2025-05-14 15:01:49",
        "commission": -59.78,
        "swap": 0,
        "profit": -162.26,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053038",
        "positionId": "56053037",
        "volume": 8.54,
        "price": 3218.42,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -222.04,
        "priceIn": 3218.23,
        "doubleCheck": true
    },
    {
        "dataID": "116962",
        "id": "53089827",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:50",
        "brokerTime": "2025-05-14 15:01:50",
        "commission": -59.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053039",
        "positionId": "56053039",
        "volume": 8.54,
        "price": 3218.52,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -59.78,
        "priceIn": 3218.52,
        "doubleCheck": true
    },
    {
        "dataID": "116963",
        "id": "53089828",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:50",
        "brokerTime": "2025-05-14 15:01:51",
        "commission": -59.78,
        "swap": 0,
        "profit": -179.34,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053040",
        "positionId": "56053039",
        "volume": 8.54,
        "price": 3218.73,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -239.12,
        "priceIn": 3218.52,
        "doubleCheck": true
    },
    {
        "dataID": "116964",
        "id": "53089829",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:51",
        "brokerTime": "2025-05-14 15:01:51",
        "commission": -59.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053041",
        "positionId": "56053041",
        "volume": 8.54,
        "price": 3218.52,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -59.78,
        "priceIn": 3218.52,
        "doubleCheck": true
    },
    {
        "dataID": "116965",
        "id": "53089830",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:51",
        "brokerTime": "2025-05-14 15:01:51",
        "commission": -59.78,
        "swap": 0,
        "profit": -239.12,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053042",
        "positionId": "56053041",
        "volume": 8.54,
        "price": 3218.8,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -298.9,
        "priceIn": 3218.52,
        "doubleCheck": true
    },
    {
        "dataID": "116966",
        "id": "53089831",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:52",
        "brokerTime": "2025-05-14 15:01:52",
        "commission": -59.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053043",
        "positionId": "56053043",
        "volume": 8.54,
        "price": 3218.68,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -59.78,
        "priceIn": 3218.68,
        "doubleCheck": true
    },
    {
        "dataID": "116967",
        "id": "53089832",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:52",
        "brokerTime": "2025-05-14 15:01:52",
        "commission": -59.78,
        "swap": 0,
        "profit": -162.26,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053044",
        "positionId": "56053043",
        "volume": 8.54,
        "price": 3218.87,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -222.04,
        "priceIn": 3218.68,
        "doubleCheck": true
    },
    {
        "dataID": "116968",
        "id": "53089833",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:52",
        "brokerTime": "2025-05-14 15:01:52",
        "commission": -59.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053045",
        "positionId": "56053045",
        "volume": 8.54,
        "price": 3218.67,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -59.78,
        "priceIn": 3218.67,
        "doubleCheck": true
    },
    {
        "dataID": "116969",
        "id": "53089834",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:52",
        "brokerTime": "2025-05-14 15:01:53",
        "commission": -59.78,
        "swap": 0,
        "profit": -162.26,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053046",
        "positionId": "56053045",
        "volume": 8.54,
        "price": 3218.86,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -222.04,
        "priceIn": 3218.67,
        "doubleCheck": true
    },
    {
        "dataID": "116970",
        "id": "53089835",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:53",
        "brokerTime": "2025-05-14 15:01:53",
        "commission": -59.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053047",
        "positionId": "56053047",
        "volume": 8.54,
        "price": 3218.57,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -59.78,
        "priceIn": 3218.57,
        "doubleCheck": true
    },
    {
        "dataID": "116971",
        "id": "53089842",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:53",
        "brokerTime": "2025-05-14 15:01:54",
        "commission": -59.78,
        "swap": 0,
        "profit": -162.26,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053054",
        "positionId": "56053047",
        "volume": 8.54,
        "price": 3218.76,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -222.04,
        "priceIn": 3218.57,
        "doubleCheck": true
    },
    {
        "dataID": "116972",
        "id": "53089843",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:55",
        "brokerTime": "2025-05-14 15:01:55",
        "commission": -59.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053055",
        "positionId": "56053055",
        "volume": 8.54,
        "price": 3218.65,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -59.78,
        "priceIn": 3218.65,
        "doubleCheck": true
    },
    {
        "dataID": "116973",
        "id": "53089844",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:55",
        "brokerTime": "2025-05-14 15:01:55",
        "commission": -59.78,
        "swap": 0,
        "profit": -153.72,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053056",
        "positionId": "56053055",
        "volume": 8.54,
        "price": 3218.83,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -213.5,
        "priceIn": 3218.65,
        "doubleCheck": true
    },
    {
        "dataID": "116974",
        "id": "53089845",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:55",
        "brokerTime": "2025-05-14 15:01:55",
        "commission": -59.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053057",
        "positionId": "56053057",
        "volume": 8.54,
        "price": 3218.66,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -59.78,
        "priceIn": 3218.66,
        "doubleCheck": true
    },
    {
        "dataID": "116975",
        "id": "53089864",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:55",
        "brokerTime": "2025-05-14 15:01:56",
        "commission": -59.78,
        "swap": 0,
        "profit": -247.66,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053075",
        "positionId": "56053057",
        "volume": 8.54,
        "price": 3218.95,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -307.44,
        "priceIn": 3218.66,
        "doubleCheck": true
    },
    {
        "dataID": "116976",
        "id": "53089865",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:56",
        "brokerTime": "2025-05-14 15:01:56",
        "commission": -59.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053076",
        "positionId": "56053076",
        "volume": 8.54,
        "price": 3218.72,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -59.78,
        "priceIn": 3218.72,
        "doubleCheck": true
    },
    {
        "dataID": "116977",
        "id": "53089866",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:56",
        "brokerTime": "2025-05-14 15:01:57",
        "commission": -59.78,
        "swap": 0,
        "profit": -128.1,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053077",
        "positionId": "56053076",
        "volume": 8.54,
        "price": 3218.87,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -187.88,
        "priceIn": 3218.72,
        "doubleCheck": true
    },
    {
        "dataID": "116978",
        "id": "53089867",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:57",
        "brokerTime": "2025-05-14 15:01:57",
        "commission": -59.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053078",
        "positionId": "56053078",
        "volume": 8.54,
        "price": 3218.8,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -59.78,
        "priceIn": 3218.8,
        "doubleCheck": true
    },
    {
        "dataID": "116979",
        "id": "53089868",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:57",
        "brokerTime": "2025-05-14 15:01:58",
        "commission": -59.78,
        "swap": 0,
        "profit": -145.18,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053079",
        "positionId": "56053078",
        "volume": 8.54,
        "price": 3218.97,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -204.96,
        "priceIn": 3218.8,
        "doubleCheck": true
    },
    {
        "dataID": "116980",
        "id": "53089869",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:58",
        "brokerTime": "2025-05-14 15:01:58",
        "commission": -59.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053080",
        "positionId": "56053080",
        "volume": 8.54,
        "price": 3218.68,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -59.78,
        "priceIn": 3218.68,
        "doubleCheck": true
    },
    {
        "dataID": "116981",
        "id": "53089870",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:58",
        "brokerTime": "2025-05-14 15:01:58",
        "commission": -59.78,
        "swap": 0,
        "profit": -222.04,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053081",
        "positionId": "56053080",
        "volume": 8.54,
        "price": 3218.94,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -281.82,
        "priceIn": 3218.68,
        "doubleCheck": true
    },
    {
        "dataID": "116982",
        "id": "53089871",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:59",
        "brokerTime": "2025-05-14 15:01:59",
        "commission": -59.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053082",
        "positionId": "56053082",
        "volume": 8.54,
        "price": 3218.27,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -59.78,
        "priceIn": 3218.27,
        "doubleCheck": true
    },
    {
        "dataID": "116983",
        "id": "53089872",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:59",
        "brokerTime": "2025-05-14 15:01:59",
        "commission": -59.78,
        "swap": 0,
        "profit": -68.32,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053083",
        "positionId": "56053082",
        "volume": 8.54,
        "price": 3218.35,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -128.1,
        "priceIn": 3218.27,
        "doubleCheck": true
    },
    {
        "dataID": "116984",
        "id": "53089873",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:59",
        "brokerTime": "2025-05-14 15:01:59",
        "commission": -59.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053084",
        "positionId": "56053084",
        "volume": 8.54,
        "price": 3218.08,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -59.78,
        "priceIn": 3218.08,
        "doubleCheck": true
    },
    {
        "dataID": "116985",
        "id": "53089876",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:59",
        "brokerTime": "2025-05-14 15:02:00",
        "commission": -59.78,
        "swap": 0,
        "profit": -187.88,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053087",
        "positionId": "56053084",
        "volume": 8.54,
        "price": 3218.3,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -247.66,
        "priceIn": 3218.08,
        "doubleCheck": true
    },
    {
        "dataID": "116986",
        "id": "53089879",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:00",
        "brokerTime": "2025-05-14 15:02:00",
        "commission": -59.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053090",
        "positionId": "56053090",
        "volume": 8.54,
        "price": 3218.08,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -59.78,
        "priceIn": 3218.08,
        "doubleCheck": true
    },
    {
        "dataID": "116987",
        "id": "53089880",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:00",
        "brokerTime": "2025-05-14 15:02:01",
        "commission": -59.78,
        "swap": 0,
        "profit": -170.8,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053091",
        "positionId": "56053090",
        "volume": 8.54,
        "price": 3218.28,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -230.58,
        "priceIn": 3218.08,
        "doubleCheck": true
    },
    {
        "dataID": "116988",
        "id": "53089881",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:01",
        "brokerTime": "2025-05-14 15:02:01",
        "commission": -59.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053092",
        "positionId": "56053092",
        "volume": 8.54,
        "price": 3218.1,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -59.78,
        "priceIn": 3218.1,
        "doubleCheck": true
    },
    {
        "dataID": "116989",
        "id": "53089931",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:01",
        "brokerTime": "2025-05-14 15:02:02",
        "commission": -59.78,
        "swap": 0,
        "profit": 1366.4,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053139",
        "positionId": "56053092",
        "volume": 8.54,
        "price": 3216.5,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 1306.6200000000001,
        "priceIn": 3218.1,
        "doubleCheck": true
    },
    {
        "dataID": "116990",
        "id": "53090022",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:03",
        "brokerTime": "2025-05-14 15:02:03",
        "commission": -59.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053208",
        "positionId": "56053208",
        "volume": 8.54,
        "price": 3216.43,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -59.78,
        "priceIn": 3216.43,
        "doubleCheck": true
    },
    {
        "dataID": "116991",
        "id": "53090031",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:03",
        "brokerTime": "2025-05-14 15:02:04",
        "commission": -59.78,
        "swap": 0,
        "profit": -239.12,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053212",
        "positionId": "56053208",
        "volume": 8.54,
        "price": 3216.71,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -298.9,
        "priceIn": 3216.43,
        "doubleCheck": true
    },
    {
        "dataID": "116992",
        "id": "53090032",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:13",
        "brokerTime": "2025-05-14 15:02:04",
        "commission": -0.7,
        "swap": 0,
        "profit": 37.8,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053213",
        "positionId": "56052731",
        "volume": 0.1,
        "price": 3216.71,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "RR",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 37.099999999999994,
        "priceIn": 3220.49,
        "doubleCheck": true
    },
    {
        "dataID": "116993",
        "id": "53090243",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:11",
        "brokerTime": "2025-05-14 15:02:11",
        "commission": -0.7,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053393",
        "positionId": "56053393",
        "volume": 0.1,
        "price": 3216.71,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "RR",
        "comment": "RR",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.7,
        "priceIn": 3216.71,
        "doubleCheck": true
    },
    {
        "dataID": "116994",
        "id": "53090244",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:11",
        "brokerTime": "2025-05-14 15:02:11",
        "commission": -59.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053394",
        "positionId": "56053394",
        "volume": 8.54,
        "price": 3216.71,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -59.78,
        "priceIn": 3216.71,
        "doubleCheck": true
    },
    {
        "dataID": "116995",
        "id": "53090245",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:11",
        "brokerTime": "2025-05-14 15:02:12",
        "commission": -59.78,
        "swap": 0,
        "profit": 213.5,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053395",
        "positionId": "56053394",
        "volume": 8.54,
        "price": 3216.46,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 153.72,
        "priceIn": 3216.71,
        "doubleCheck": true
    },
    {
        "dataID": "116996",
        "id": "53090246",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:12",
        "brokerTime": "2025-05-14 15:02:12",
        "commission": -59.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053396",
        "positionId": "56053396",
        "volume": 8.54,
        "price": 3216.06,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -59.78,
        "priceIn": 3216.06,
        "doubleCheck": true
    },
    {
        "dataID": "116997",
        "id": "53090249",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:12",
        "brokerTime": "2025-05-14 15:02:13",
        "commission": -59.78,
        "swap": 0,
        "profit": -187.88,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053399",
        "positionId": "56053396",
        "volume": 8.54,
        "price": 3216.28,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -247.66,
        "priceIn": 3216.06,
        "doubleCheck": true
    },
    {
        "dataID": "116998",
        "id": "53090251",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:13",
        "brokerTime": "2025-05-14 15:02:13",
        "commission": -59.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053402",
        "positionId": "56053402",
        "volume": 8.54,
        "price": 3216.05,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -59.78,
        "priceIn": 3216.05,
        "doubleCheck": true
    },
    {
        "dataID": "116999",
        "id": "53090254",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:13",
        "brokerTime": "2025-05-14 15:02:13",
        "commission": -59.78,
        "swap": 0,
        "profit": -239.12,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053404",
        "positionId": "56053402",
        "volume": 8.54,
        "price": 3216.33,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -298.9,
        "priceIn": 3216.05,
        "doubleCheck": true
    },
    {
        "dataID": "117000",
        "id": "53090255",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:14",
        "brokerTime": "2025-05-14 15:02:14",
        "commission": -59.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053405",
        "positionId": "56053405",
        "volume": 8.54,
        "price": 3216.22,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -59.78,
        "priceIn": 3216.22,
        "doubleCheck": true
    },
    {
        "dataID": "117001",
        "id": "53090256",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:14",
        "brokerTime": "2025-05-14 15:02:14",
        "commission": -59.78,
        "swap": 0,
        "profit": -187.88,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053406",
        "positionId": "56053405",
        "volume": 8.54,
        "price": 3216.44,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -247.66,
        "priceIn": 3216.22,
        "doubleCheck": true
    },
    {
        "dataID": "117002",
        "id": "53090257",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:14",
        "brokerTime": "2025-05-14 15:02:14",
        "commission": -59.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053407",
        "positionId": "56053407",
        "volume": 8.54,
        "price": 3216.24,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -59.78,
        "priceIn": 3216.24,
        "doubleCheck": true
    },
    {
        "dataID": "117003",
        "id": "53090259",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:14",
        "brokerTime": "2025-05-14 15:02:15",
        "commission": -59.78,
        "swap": 0,
        "profit": -222.04,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053409",
        "positionId": "56053407",
        "volume": 8.54,
        "price": 3216.5,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -281.82,
        "priceIn": 3216.24,
        "doubleCheck": true
    },
    {
        "dataID": "117004",
        "id": "53090260",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:15",
        "brokerTime": "2025-05-14 15:02:15",
        "commission": -59.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053410",
        "positionId": "56053410",
        "volume": 8.54,
        "price": 3216.31,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -59.78,
        "priceIn": 3216.31,
        "doubleCheck": true
    },
    {
        "dataID": "117005",
        "id": "53090262",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:15",
        "brokerTime": "2025-05-14 15:02:15",
        "commission": -59.78,
        "swap": 0,
        "profit": -230.58,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053412",
        "positionId": "56053410",
        "volume": 8.54,
        "price": 3216.58,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -290.36,
        "priceIn": 3216.31,
        "doubleCheck": true
    },
    {
        "dataID": "117006",
        "id": "53090264",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:15",
        "brokerTime": "2025-05-14 15:02:15",
        "commission": -59.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053414",
        "positionId": "56053414",
        "volume": 8.54,
        "price": 3216.53,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -59.78,
        "priceIn": 3216.53,
        "doubleCheck": true
    },
    {
        "dataID": "117007",
        "id": "53090265",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:15",
        "brokerTime": "2025-05-14 15:02:16",
        "commission": -59.78,
        "swap": 0,
        "profit": -136.64,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053415",
        "positionId": "56053414",
        "volume": 8.54,
        "price": 3216.69,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -196.42,
        "priceIn": 3216.53,
        "doubleCheck": true
    },
    {
        "dataID": "117008",
        "id": "53090266",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:16",
        "brokerTime": "2025-05-14 15:02:16",
        "commission": -59.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053416",
        "positionId": "56053416",
        "volume": 8.54,
        "price": 3216.45,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -59.78,
        "priceIn": 3216.45,
        "doubleCheck": true
    },
    {
        "dataID": "117009",
        "id": "53090267",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:16",
        "brokerTime": "2025-05-14 15:02:16",
        "commission": -59.78,
        "swap": 0,
        "profit": -42.7,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053417",
        "positionId": "56053416",
        "volume": 8.54,
        "price": 3216.5,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -102.48,
        "priceIn": 3216.45,
        "doubleCheck": true
    },
    {
        "dataID": "117010",
        "id": "53090268",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:17",
        "brokerTime": "2025-05-14 15:02:17",
        "commission": -59.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053418",
        "positionId": "56053418",
        "volume": 8.54,
        "price": 3216.38,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -59.78,
        "priceIn": 3216.38,
        "doubleCheck": true
    },
    {
        "dataID": "117011",
        "id": "53090269",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:17",
        "brokerTime": "2025-05-14 15:02:18",
        "commission": -59.78,
        "swap": 0,
        "profit": -367.22,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053419",
        "positionId": "56053418",
        "volume": 8.54,
        "price": 3216.81,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -427,
        "priceIn": 3216.38,
        "doubleCheck": true
    },
    {
        "dataID": "117012",
        "id": "53090270",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:18",
        "brokerTime": "2025-05-14 15:02:18",
        "commission": -59.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053420",
        "positionId": "56053420",
        "volume": 8.54,
        "price": 3217.26,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -59.78,
        "priceIn": 3217.26,
        "doubleCheck": true
    },
    {
        "dataID": "117013",
        "id": "53090272",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:18",
        "brokerTime": "2025-05-14 15:02:19",
        "commission": -59.78,
        "swap": 0,
        "profit": -162.26,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053422",
        "positionId": "56053420",
        "volume": 8.54,
        "price": 3217.45,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -222.04,
        "priceIn": 3217.26,
        "doubleCheck": true
    },
    {
        "dataID": "117014",
        "id": "53090273",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:19",
        "brokerTime": "2025-05-14 15:02:19",
        "commission": -59.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053423",
        "positionId": "56053423",
        "volume": 8.54,
        "price": 3217.46,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -59.78,
        "priceIn": 3217.46,
        "doubleCheck": true
    },
    {
        "dataID": "117015",
        "id": "53090274",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:19",
        "brokerTime": "2025-05-14 15:02:20",
        "commission": -59.78,
        "swap": 0,
        "profit": -128.1,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053424",
        "positionId": "56053423",
        "volume": 8.54,
        "price": 3217.61,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -187.88,
        "priceIn": 3217.46,
        "doubleCheck": true
    },
    {
        "dataID": "117016",
        "id": "53090275",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:20",
        "brokerTime": "2025-05-14 15:02:20",
        "commission": -59.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053425",
        "positionId": "56053425",
        "volume": 8.54,
        "price": 3217.33,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -59.78,
        "priceIn": 3217.33,
        "doubleCheck": true
    },
    {
        "dataID": "117017",
        "id": "53090276",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:20",
        "brokerTime": "2025-05-14 15:02:21",
        "commission": -59.78,
        "swap": 0,
        "profit": -153.72,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053426",
        "positionId": "56053425",
        "volume": 8.54,
        "price": 3217.51,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -213.5,
        "priceIn": 3217.33,
        "doubleCheck": true
    },
    {
        "dataID": "117018",
        "id": "53090277",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:21",
        "brokerTime": "2025-05-14 15:02:21",
        "commission": -59.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053427",
        "positionId": "56053427",
        "volume": 8.54,
        "price": 3217.5,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -59.78,
        "priceIn": 3217.5,
        "doubleCheck": true
    },
    {
        "dataID": "117019",
        "id": "53090278",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:21",
        "brokerTime": "2025-05-14 15:02:21",
        "commission": -59.78,
        "swap": 0,
        "profit": -256.2,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053428",
        "positionId": "56053427",
        "volume": 8.54,
        "price": 3217.8,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -315.98,
        "priceIn": 3217.5,
        "doubleCheck": true
    },
    {
        "dataID": "117020",
        "id": "53090279",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:22",
        "brokerTime": "2025-05-14 15:02:22",
        "commission": -59.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053429",
        "positionId": "56053429",
        "volume": 8.54,
        "price": 3217.64,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -59.78,
        "priceIn": 3217.64,
        "doubleCheck": true
    },
    {
        "dataID": "117021",
        "id": "53090280",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:22",
        "brokerTime": "2025-05-14 15:02:22",
        "commission": -59.78,
        "swap": 0,
        "profit": -76.86,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053430",
        "positionId": "56053429",
        "volume": 8.54,
        "price": 3217.73,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -136.64,
        "priceIn": 3217.64,
        "doubleCheck": true
    },
    {
        "dataID": "117022",
        "id": "53090281",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:23",
        "brokerTime": "2025-05-14 15:02:23",
        "commission": -59.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053431",
        "positionId": "56053431",
        "volume": 8.54,
        "price": 3217.57,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -59.78,
        "priceIn": 3217.57,
        "doubleCheck": true
    },
    {
        "dataID": "117023",
        "id": "53090282",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:23",
        "brokerTime": "2025-05-14 15:02:24",
        "commission": -59.78,
        "swap": 0,
        "profit": -230.58,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053432",
        "positionId": "56053431",
        "volume": 8.54,
        "price": 3217.84,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -290.36,
        "priceIn": 3217.57,
        "doubleCheck": true
    },
    {
        "dataID": "117024",
        "id": "53090283",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:24",
        "brokerTime": "2025-05-14 15:02:24",
        "commission": -59.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053433",
        "positionId": "56053433",
        "volume": 8.54,
        "price": 3217.63,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -59.78,
        "priceIn": 3217.63,
        "doubleCheck": true
    },
    {
        "dataID": "117025",
        "id": "53090284",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:24",
        "brokerTime": "2025-05-14 15:02:24",
        "commission": -59.78,
        "swap": 0,
        "profit": -111.02,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053434",
        "positionId": "56053433",
        "volume": 8.54,
        "price": 3217.76,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -170.8,
        "priceIn": 3217.63,
        "doubleCheck": true
    },
    {
        "dataID": "117026",
        "id": "53090285",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:25",
        "brokerTime": "2025-05-14 15:02:25",
        "commission": -59.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053435",
        "positionId": "56053435",
        "volume": 8.54,
        "price": 3217.64,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -59.78,
        "priceIn": 3217.64,
        "doubleCheck": true
    },
    {
        "dataID": "117027",
        "id": "53090286",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:25",
        "brokerTime": "2025-05-14 15:02:26",
        "commission": -59.78,
        "swap": 0,
        "profit": -555.1,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053436",
        "positionId": "56053435",
        "volume": 8.54,
        "price": 3218.29,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -614.88,
        "priceIn": 3217.64,
        "doubleCheck": true
    },
    {
        "dataID": "117028",
        "id": "53090287",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:26",
        "brokerTime": "2025-05-14 15:02:26",
        "commission": -0.84,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053437",
        "positionId": "56053437",
        "volume": 0.12,
        "price": 3218.07,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3118.07,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.84,
        "priceIn": 3218.07,
        "doubleCheck": true
    },
    {
        "dataID": "117029",
        "id": "53090288",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:26",
        "brokerTime": "2025-05-14 15:02:26",
        "commission": -58.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053438",
        "positionId": "56053438",
        "volume": 8.42,
        "price": 3218.08,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -58.94,
        "priceIn": 3218.08,
        "doubleCheck": true
    },
    {
        "dataID": "117030",
        "id": "53090289",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:26",
        "brokerTime": "2025-05-14 15:02:26",
        "commission": -58.94,
        "swap": 0,
        "profit": -210.5,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053439",
        "positionId": "56053438",
        "volume": 8.42,
        "price": 3218.33,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -269.44,
        "priceIn": 3218.08,
        "doubleCheck": true
    },
    {
        "dataID": "117031",
        "id": "53090291",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:27",
        "brokerTime": "2025-05-14 15:02:27",
        "commission": -58.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053441",
        "positionId": "56053441",
        "volume": 8.42,
        "price": 3218.1,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -58.94,
        "priceIn": 3218.1,
        "doubleCheck": true
    },
    {
        "dataID": "117032",
        "id": "53090292",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:27",
        "brokerTime": "2025-05-14 15:02:27",
        "commission": -58.94,
        "swap": 0,
        "profit": -328.38,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053442",
        "positionId": "56053441",
        "volume": 8.42,
        "price": 3218.49,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -387.32,
        "priceIn": 3218.1,
        "doubleCheck": true
    },
    {
        "dataID": "117033",
        "id": "53090293",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:27",
        "brokerTime": "2025-05-14 15:02:27",
        "commission": -58.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053443",
        "positionId": "56053443",
        "volume": 8.42,
        "price": 3218.3,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -58.94,
        "priceIn": 3218.3,
        "doubleCheck": true
    },
    {
        "dataID": "117034",
        "id": "53090298",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:27",
        "brokerTime": "2025-05-14 15:02:28",
        "commission": -58.94,
        "swap": 0,
        "profit": -210.5,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053448",
        "positionId": "56053443",
        "volume": 8.42,
        "price": 3218.55,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -269.44,
        "priceIn": 3218.3,
        "doubleCheck": true
    },
    {
        "dataID": "117035",
        "id": "53090299",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:28",
        "brokerTime": "2025-05-14 15:02:28",
        "commission": -58.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053449",
        "positionId": "56053449",
        "volume": 8.42,
        "price": 3218.28,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -58.94,
        "priceIn": 3218.28,
        "doubleCheck": true
    },
    {
        "dataID": "117036",
        "id": "53090300",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:28",
        "brokerTime": "2025-05-14 15:02:29",
        "commission": -58.94,
        "swap": 0,
        "profit": 227.34,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053450",
        "positionId": "56053449",
        "volume": 8.42,
        "price": 3218.01,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 168.4,
        "priceIn": 3218.28,
        "doubleCheck": true
    },
    {
        "dataID": "117037",
        "id": "53090302",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:29",
        "brokerTime": "2025-05-14 15:02:29",
        "commission": -58.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053452",
        "positionId": "56053452",
        "volume": 8.42,
        "price": 3217.72,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -58.94,
        "priceIn": 3217.72,
        "doubleCheck": true
    },
    {
        "dataID": "117038",
        "id": "53090303",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:29",
        "brokerTime": "2025-05-14 15:02:29",
        "commission": -58.94,
        "swap": 0,
        "profit": -202.08,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053453",
        "positionId": "56053452",
        "volume": 8.42,
        "price": 3217.96,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -261.02,
        "priceIn": 3217.72,
        "doubleCheck": true
    },
    {
        "dataID": "117039",
        "id": "53090304",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:30",
        "brokerTime": "2025-05-14 15:02:30",
        "commission": -58.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053454",
        "positionId": "56053454",
        "volume": 8.42,
        "price": 3217.74,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -58.94,
        "priceIn": 3217.74,
        "doubleCheck": true
    },
    {
        "dataID": "117040",
        "id": "53090305",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:30",
        "brokerTime": "2025-05-14 15:02:30",
        "commission": -58.94,
        "swap": 0,
        "profit": -235.76,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053455",
        "positionId": "56053454",
        "volume": 8.42,
        "price": 3218.02,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -294.7,
        "priceIn": 3217.74,
        "doubleCheck": true
    },
    {
        "dataID": "117041",
        "id": "53090306",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:31",
        "brokerTime": "2025-05-14 15:02:31",
        "commission": -58.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053456",
        "positionId": "56053456",
        "volume": 8.42,
        "price": 3217.91,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -58.94,
        "priceIn": 3217.91,
        "doubleCheck": true
    },
    {
        "dataID": "117042",
        "id": "53090307",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:31",
        "brokerTime": "2025-05-14 15:02:31",
        "commission": -58.94,
        "swap": 0,
        "profit": -25.26,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053457",
        "positionId": "56053456",
        "volume": 8.42,
        "price": 3217.94,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -84.2,
        "priceIn": 3217.91,
        "doubleCheck": true
    },
    {
        "dataID": "117043",
        "id": "53090308",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:32",
        "brokerTime": "2025-05-14 15:02:32",
        "commission": -58.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053458",
        "positionId": "56053458",
        "volume": 8.42,
        "price": 3217.86,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -58.94,
        "priceIn": 3217.86,
        "doubleCheck": true
    },
    {
        "dataID": "117044",
        "id": "53090309",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:32",
        "brokerTime": "2025-05-14 15:02:32",
        "commission": -58.94,
        "swap": 0,
        "profit": -176.82,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053459",
        "positionId": "56053458",
        "volume": 8.42,
        "price": 3218.07,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -235.76,
        "priceIn": 3217.86,
        "doubleCheck": true
    },
    {
        "dataID": "117045",
        "id": "53090310",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:32",
        "brokerTime": "2025-05-14 15:02:32",
        "commission": -58.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053460",
        "positionId": "56053460",
        "volume": 8.42,
        "price": 3217.89,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -58.94,
        "priceIn": 3217.89,
        "doubleCheck": true
    },
    {
        "dataID": "117046",
        "id": "53090311",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:32",
        "brokerTime": "2025-05-14 15:02:32",
        "commission": -58.94,
        "swap": 0,
        "profit": -244.18,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053461",
        "positionId": "56053460",
        "volume": 8.42,
        "price": 3218.18,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -303.12,
        "priceIn": 3217.89,
        "doubleCheck": true
    },
    {
        "dataID": "117047",
        "id": "53090312",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:33",
        "brokerTime": "2025-05-14 15:02:33",
        "commission": -58.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053462",
        "positionId": "56053462",
        "volume": 8.42,
        "price": 3217.98,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -58.94,
        "priceIn": 3217.98,
        "doubleCheck": true
    },
    {
        "dataID": "117048",
        "id": "53090313",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:33",
        "brokerTime": "2025-05-14 15:02:34",
        "commission": -58.94,
        "swap": 0,
        "profit": -151.56,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053463",
        "positionId": "56053462",
        "volume": 8.42,
        "price": 3218.16,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -210.5,
        "priceIn": 3217.98,
        "doubleCheck": true
    },
    {
        "dataID": "117049",
        "id": "53090314",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:34",
        "brokerTime": "2025-05-14 15:02:34",
        "commission": -58.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053464",
        "positionId": "56053464",
        "volume": 8.42,
        "price": 3217.85,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -58.94,
        "priceIn": 3217.85,
        "doubleCheck": true
    },
    {
        "dataID": "117050",
        "id": "53090318",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:34",
        "brokerTime": "2025-05-14 15:02:35",
        "commission": -58.94,
        "swap": 0,
        "profit": -151.56,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053468",
        "positionId": "56053464",
        "volume": 8.42,
        "price": 3218.03,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -210.5,
        "priceIn": 3217.85,
        "doubleCheck": true
    },
    {
        "dataID": "117051",
        "id": "53090319",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:35",
        "brokerTime": "2025-05-14 15:02:35",
        "commission": -58.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053469",
        "positionId": "56053469",
        "volume": 8.42,
        "price": 3217.79,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -58.94,
        "priceIn": 3217.79,
        "doubleCheck": true
    },
    {
        "dataID": "117052",
        "id": "53090320",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:35",
        "brokerTime": "2025-05-14 15:02:35",
        "commission": -58.94,
        "swap": 0,
        "profit": -353.64,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053470",
        "positionId": "56053469",
        "volume": 8.42,
        "price": 3218.21,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -412.58,
        "priceIn": 3217.79,
        "doubleCheck": true
    },
    {
        "dataID": "117053",
        "id": "53090321",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:35",
        "brokerTime": "2025-05-14 15:02:35",
        "commission": -58.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053471",
        "positionId": "56053471",
        "volume": 8.42,
        "price": 3217.98,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -58.94,
        "priceIn": 3217.98,
        "doubleCheck": true
    },
    {
        "dataID": "117054",
        "id": "53090323",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:35",
        "brokerTime": "2025-05-14 15:02:36",
        "commission": -58.94,
        "swap": 0,
        "profit": -143.14,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053473",
        "positionId": "56053471",
        "volume": 8.42,
        "price": 3218.15,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -202.07999999999998,
        "priceIn": 3217.98,
        "doubleCheck": true
    },
    {
        "dataID": "117055",
        "id": "53090324",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:37",
        "brokerTime": "2025-05-14 15:02:37",
        "commission": -58.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053474",
        "positionId": "56053474",
        "volume": 8.42,
        "price": 3217.98,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -58.94,
        "priceIn": 3217.98,
        "doubleCheck": true
    },
    {
        "dataID": "117056",
        "id": "53090325",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:37",
        "brokerTime": "2025-05-14 15:02:37",
        "commission": -58.94,
        "swap": 0,
        "profit": -185.24,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053475",
        "positionId": "56053474",
        "volume": 8.42,
        "price": 3218.2,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -244.18,
        "priceIn": 3217.98,
        "doubleCheck": true
    },
    {
        "dataID": "117057",
        "id": "53090326",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:38",
        "brokerTime": "2025-05-14 15:02:38",
        "commission": -58.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053476",
        "positionId": "56053476",
        "volume": 8.42,
        "price": 3218.04,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -58.94,
        "priceIn": 3218.04,
        "doubleCheck": true
    },
    {
        "dataID": "117058",
        "id": "53090327",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:38",
        "brokerTime": "2025-05-14 15:02:38",
        "commission": -58.94,
        "swap": 0,
        "profit": -202.08,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053477",
        "positionId": "56053476",
        "volume": 8.42,
        "price": 3218.28,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -261.02,
        "priceIn": 3218.04,
        "doubleCheck": true
    },
    {
        "dataID": "117059",
        "id": "53090328",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:39",
        "brokerTime": "2025-05-14 15:02:39",
        "commission": -58.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053478",
        "positionId": "56053478",
        "volume": 8.42,
        "price": 3218.07,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -58.94,
        "priceIn": 3218.07,
        "doubleCheck": true
    },
    {
        "dataID": "117060",
        "id": "53090329",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:39",
        "brokerTime": "2025-05-14 15:02:39",
        "commission": -58.94,
        "swap": 0,
        "profit": -134.72,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053479",
        "positionId": "56053478",
        "volume": 8.42,
        "price": 3218.23,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -193.66,
        "priceIn": 3218.07,
        "doubleCheck": true
    },
    {
        "dataID": "117061",
        "id": "53090330",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:40",
        "brokerTime": "2025-05-14 15:02:40",
        "commission": -58.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053480",
        "positionId": "56053480",
        "volume": 8.42,
        "price": 3218.06,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -58.94,
        "priceIn": 3218.06,
        "doubleCheck": true
    },
    {
        "dataID": "117062",
        "id": "53090331",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:40",
        "brokerTime": "2025-05-14 15:02:40",
        "commission": -58.94,
        "swap": 0,
        "profit": -143.14,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053481",
        "positionId": "56053480",
        "volume": 8.42,
        "price": 3218.23,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -202.07999999999998,
        "priceIn": 3218.06,
        "doubleCheck": true
    },
    {
        "dataID": "117063",
        "id": "53090333",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:40",
        "brokerTime": "2025-05-14 15:02:40",
        "commission": -58.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053483",
        "positionId": "56053483",
        "volume": 8.42,
        "price": 3218.07,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -58.94,
        "priceIn": 3218.07,
        "doubleCheck": true
    },
    {
        "dataID": "117064",
        "id": "53090335",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:40",
        "brokerTime": "2025-05-14 15:02:41",
        "commission": -58.94,
        "swap": 0,
        "profit": -134.72,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053484",
        "positionId": "56053483",
        "volume": 8.42,
        "price": 3218.23,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -193.66,
        "priceIn": 3218.07,
        "doubleCheck": true
    },
    {
        "dataID": "117065",
        "id": "53090336",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:41",
        "brokerTime": "2025-05-14 15:02:41",
        "commission": -58.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053485",
        "positionId": "56053485",
        "volume": 8.42,
        "price": 3217.93,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -58.94,
        "priceIn": 3217.93,
        "doubleCheck": true
    },
    {
        "dataID": "117066",
        "id": "53090356",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:41",
        "brokerTime": "2025-05-14 15:02:42",
        "commission": -58.94,
        "swap": 0,
        "profit": -185.24,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053505",
        "positionId": "56053485",
        "volume": 8.42,
        "price": 3218.15,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -244.18,
        "priceIn": 3217.93,
        "doubleCheck": true
    },
    {
        "dataID": "117067",
        "id": "53090369",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:42",
        "brokerTime": "2025-05-14 15:02:42",
        "commission": -58.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053506",
        "positionId": "56053506",
        "volume": 8.42,
        "price": 3218.03,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -58.94,
        "priceIn": 3218.03,
        "doubleCheck": true
    },
    {
        "dataID": "117068",
        "id": "53090371",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:42",
        "brokerTime": "2025-05-14 15:02:43",
        "commission": -58.94,
        "swap": 0,
        "profit": -774.64,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053509",
        "positionId": "56053506",
        "volume": 8.42,
        "price": 3218.95,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -833.5799999999999,
        "priceIn": 3218.03,
        "doubleCheck": true
    },
    {
        "dataID": "117069",
        "id": "53090375",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:43",
        "brokerTime": "2025-05-14 15:02:43",
        "commission": -58.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053510",
        "positionId": "56053510",
        "volume": 8.42,
        "price": 3218.81,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -58.94,
        "priceIn": 3218.81,
        "doubleCheck": true
    },
    {
        "dataID": "117070",
        "id": "53090377",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:43",
        "brokerTime": "2025-05-14 15:02:44",
        "commission": -58.94,
        "swap": 0,
        "profit": -286.28,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053512",
        "positionId": "56053510",
        "volume": 8.42,
        "price": 3219.15,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -345.21999999999997,
        "priceIn": 3218.81,
        "doubleCheck": true
    },
    {
        "dataID": "117071",
        "id": "53090378",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:44",
        "brokerTime": "2025-05-14 15:02:44",
        "commission": -58.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053513",
        "positionId": "56053513",
        "volume": 8.42,
        "price": 3218.92,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -58.94,
        "priceIn": 3218.92,
        "doubleCheck": true
    },
    {
        "dataID": "117072",
        "id": "53090379",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:44",
        "brokerTime": "2025-05-14 15:02:45",
        "commission": -58.94,
        "swap": 0,
        "profit": -261.02,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053514",
        "positionId": "56053513",
        "volume": 8.42,
        "price": 3219.23,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -319.96,
        "priceIn": 3218.92,
        "doubleCheck": true
    },
    {
        "dataID": "117073",
        "id": "53090381",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:45",
        "brokerTime": "2025-05-14 15:02:45",
        "commission": -58.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053516",
        "positionId": "56053516",
        "volume": 8.42,
        "price": 3219.1,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -58.94,
        "priceIn": 3219.1,
        "doubleCheck": true
    },
    {
        "dataID": "117074",
        "id": "53090382",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:45",
        "brokerTime": "2025-05-14 15:02:46",
        "commission": -58.94,
        "swap": 0,
        "profit": -345.22,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053517",
        "positionId": "56053516",
        "volume": 8.42,
        "price": 3219.51,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -404.16,
        "priceIn": 3219.1,
        "doubleCheck": true
    },
    {
        "dataID": "117075",
        "id": "53090384",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:46",
        "brokerTime": "2025-05-14 15:02:46",
        "commission": -58.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053519",
        "positionId": "56053519",
        "volume": 8.42,
        "price": 3219.7,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -58.94,
        "priceIn": 3219.7,
        "doubleCheck": true
    },
    {
        "dataID": "117076",
        "id": "53090385",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:46",
        "brokerTime": "2025-05-14 15:02:46",
        "commission": -58.94,
        "swap": 0,
        "profit": -269.44,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053520",
        "positionId": "56053519",
        "volume": 8.42,
        "price": 3220.02,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -328.38,
        "priceIn": 3219.7,
        "doubleCheck": true
    },
    {
        "dataID": "117077",
        "id": "53090386",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:47",
        "brokerTime": "2025-05-14 15:02:47",
        "commission": -58.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053521",
        "positionId": "56053521",
        "volume": 8.42,
        "price": 3219.89,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -58.94,
        "priceIn": 3219.89,
        "doubleCheck": true
    },
    {
        "dataID": "117078",
        "id": "53090387",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:47",
        "brokerTime": "2025-05-14 15:02:48",
        "commission": -58.94,
        "swap": 0,
        "profit": -446.26,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053522",
        "positionId": "56053521",
        "volume": 8.42,
        "price": 3220.42,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -505.2,
        "priceIn": 3219.89,
        "doubleCheck": true
    },
    {
        "dataID": "117079",
        "id": "53090388",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:48",
        "brokerTime": "2025-05-14 15:02:48",
        "commission": -58.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053523",
        "positionId": "56053523",
        "volume": 8.42,
        "price": 3220.18,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -58.94,
        "priceIn": 3220.18,
        "doubleCheck": true
    },
    {
        "dataID": "117080",
        "id": "53090389",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:48",
        "brokerTime": "2025-05-14 15:02:49",
        "commission": -58.94,
        "swap": 0,
        "profit": -277.86,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053524",
        "positionId": "56053523",
        "volume": 8.42,
        "price": 3220.51,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -336.8,
        "priceIn": 3220.18,
        "doubleCheck": true
    },
    {
        "dataID": "117081",
        "id": "53090390",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:49",
        "brokerTime": "2025-05-14 15:02:49",
        "commission": -58.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053525",
        "positionId": "56053525",
        "volume": 8.42,
        "price": 3220.24,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -58.94,
        "priceIn": 3220.24,
        "doubleCheck": true
    },
    {
        "dataID": "117082",
        "id": "53090391",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:49",
        "brokerTime": "2025-05-14 15:02:49",
        "commission": -58.94,
        "swap": 0,
        "profit": -33.68,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053526",
        "positionId": "56053525",
        "volume": 8.42,
        "price": 3220.28,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -92.62,
        "priceIn": 3220.24,
        "doubleCheck": true
    },
    {
        "dataID": "117083",
        "id": "53090392",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:50",
        "brokerTime": "2025-05-14 15:02:50",
        "commission": -58.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053527",
        "positionId": "56053527",
        "volume": 8.42,
        "price": 3220.08,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -58.94,
        "priceIn": 3220.08,
        "doubleCheck": true
    },
    {
        "dataID": "117084",
        "id": "53090393",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:50",
        "brokerTime": "2025-05-14 15:02:50",
        "commission": -58.94,
        "swap": 0,
        "profit": -193.66,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053528",
        "positionId": "56053527",
        "volume": 8.42,
        "price": 3220.31,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -252.6,
        "priceIn": 3220.08,
        "doubleCheck": true
    },
    {
        "dataID": "117085",
        "id": "53090394",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:51",
        "brokerTime": "2025-05-14 15:02:51",
        "commission": -58.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053529",
        "positionId": "56053529",
        "volume": 8.42,
        "price": 3220.09,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -58.94,
        "priceIn": 3220.09,
        "doubleCheck": true
    },
    {
        "dataID": "117086",
        "id": "53090395",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:51",
        "brokerTime": "2025-05-14 15:02:51",
        "commission": -58.94,
        "swap": 0,
        "profit": -159.98,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053530",
        "positionId": "56053529",
        "volume": 8.42,
        "price": 3220.28,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -218.92,
        "priceIn": 3220.09,
        "doubleCheck": true
    },
    {
        "dataID": "117087",
        "id": "53090396",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:52",
        "brokerTime": "2025-05-14 15:02:52",
        "commission": -58.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053531",
        "positionId": "56053531",
        "volume": 8.42,
        "price": 3220.14,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -58.94,
        "priceIn": 3220.14,
        "doubleCheck": true
    },
    {
        "dataID": "117088",
        "id": "53090397",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:52",
        "brokerTime": "2025-05-14 15:02:52",
        "commission": -58.94,
        "swap": 0,
        "profit": -117.88,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053532",
        "positionId": "56053531",
        "volume": 8.42,
        "price": 3220.28,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -176.82,
        "priceIn": 3220.14,
        "doubleCheck": true
    },
    {
        "dataID": "117089",
        "id": "53090398",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:53",
        "brokerTime": "2025-05-14 15:02:53",
        "commission": -58.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053533",
        "positionId": "56053533",
        "volume": 8.42,
        "price": 3220.38,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -58.94,
        "priceIn": 3220.38,
        "doubleCheck": true
    },
    {
        "dataID": "117090",
        "id": "53090399",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:53",
        "brokerTime": "2025-05-14 15:02:53",
        "commission": -58.94,
        "swap": 0,
        "profit": -67.36,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053534",
        "positionId": "56053533",
        "volume": 8.42,
        "price": 3220.46,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -126.3,
        "priceIn": 3220.38,
        "doubleCheck": true
    },
    {
        "dataID": "117091",
        "id": "53090400",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:53",
        "brokerTime": "2025-05-14 15:02:53",
        "commission": -58.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053535",
        "positionId": "56053535",
        "volume": 8.42,
        "price": 3220.33,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -58.94,
        "priceIn": 3220.33,
        "doubleCheck": true
    },
    {
        "dataID": "117092",
        "id": "53090401",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:53",
        "brokerTime": "2025-05-14 15:02:54",
        "commission": -58.94,
        "swap": 0,
        "profit": -185.24,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053536",
        "positionId": "56053535",
        "volume": 8.42,
        "price": 3220.55,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -244.18,
        "priceIn": 3220.33,
        "doubleCheck": true
    },
    {
        "dataID": "117093",
        "id": "53090402",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:54",
        "brokerTime": "2025-05-14 15:02:54",
        "commission": -58.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053537",
        "positionId": "56053537",
        "volume": 8.42,
        "price": 3220.63,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -58.94,
        "priceIn": 3220.63,
        "doubleCheck": true
    },
    {
        "dataID": "117094",
        "id": "53090403",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:54",
        "brokerTime": "2025-05-14 15:02:54",
        "commission": -58.94,
        "swap": 0,
        "profit": -294.7,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053538",
        "positionId": "56053537",
        "volume": 8.42,
        "price": 3220.98,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -353.64,
        "priceIn": 3220.63,
        "doubleCheck": true
    },
    {
        "dataID": "117096",
        "id": "53090405",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:55",
        "brokerTime": "2025-05-14 15:02:55",
        "commission": -58.94,
        "swap": 0,
        "profit": -202.08,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053540",
        "positionId": "56053539",
        "volume": 8.42,
        "price": 3220.97,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -261.02,
        "priceIn": 3220.73,
        "doubleCheck": true
    },
    {
        "dataID": "117095",
        "id": "53090404",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:55",
        "brokerTime": "2025-05-14 15:02:55",
        "commission": -58.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053539",
        "positionId": "56053539",
        "volume": 8.42,
        "price": 3220.73,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -58.94,
        "priceIn": 3220.73,
        "doubleCheck": true
    },
    {
        "dataID": "117097",
        "id": "53090406",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:56",
        "brokerTime": "2025-05-14 15:02:56",
        "commission": -58.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053541",
        "positionId": "56053541",
        "volume": 8.42,
        "price": 3220.74,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -58.94,
        "priceIn": 3220.74,
        "doubleCheck": true
    },
    {
        "dataID": "117098",
        "id": "53090407",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:56",
        "brokerTime": "2025-05-14 15:02:56",
        "commission": -58.94,
        "swap": 0,
        "profit": -328.38,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053542",
        "positionId": "56053541",
        "volume": 8.42,
        "price": 3221.13,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -387.32,
        "priceIn": 3220.74,
        "doubleCheck": true
    },
    {
        "dataID": "117099",
        "id": "53090409",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:57",
        "brokerTime": "2025-05-14 15:02:57",
        "commission": -58.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053544",
        "positionId": "56053544",
        "volume": 8.42,
        "price": 3220.83,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -58.94,
        "priceIn": 3220.83,
        "doubleCheck": true
    },
    {
        "dataID": "117100",
        "id": "53090410",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:57",
        "brokerTime": "2025-05-14 15:02:57",
        "commission": -58.94,
        "swap": 0,
        "profit": -168.4,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053545",
        "positionId": "56053544",
        "volume": 8.42,
        "price": 3221.03,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -227.34,
        "priceIn": 3220.83,
        "doubleCheck": true
    },
    {
        "dataID": "117101",
        "id": "53090411",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:58",
        "brokerTime": "2025-05-14 15:02:58",
        "commission": -58.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053546",
        "positionId": "56053546",
        "volume": 8.42,
        "price": 3220.82,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -58.94,
        "priceIn": 3220.82,
        "doubleCheck": true
    },
    {
        "dataID": "117102",
        "id": "53090412",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:58",
        "brokerTime": "2025-05-14 15:02:58",
        "commission": -58.94,
        "swap": 0,
        "profit": -277.86,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053547",
        "positionId": "56053546",
        "volume": 8.42,
        "price": 3221.15,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -336.8,
        "priceIn": 3220.82,
        "doubleCheck": true
    },
    {
        "dataID": "117103",
        "id": "53090413",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:59",
        "brokerTime": "2025-05-14 15:02:59",
        "commission": -58.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053548",
        "positionId": "56053548",
        "volume": 8.42,
        "price": 3220.93,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -58.94,
        "priceIn": 3220.93,
        "doubleCheck": true
    },
    {
        "dataID": "117104",
        "id": "53090414",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:59",
        "brokerTime": "2025-05-14 15:03:00",
        "commission": -58.94,
        "swap": 0,
        "profit": -117.88,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053549",
        "positionId": "56053548",
        "volume": 8.42,
        "price": 3221.07,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -176.82,
        "priceIn": 3220.93,
        "doubleCheck": true
    },
    {
        "dataID": "117105",
        "id": "53090415",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:00",
        "brokerTime": "2025-05-14 15:03:00",
        "commission": -58.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053550",
        "positionId": "56053550",
        "volume": 8.42,
        "price": 3220.84,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -58.94,
        "priceIn": 3220.84,
        "doubleCheck": true
    },
    {
        "dataID": "117106",
        "id": "53090418",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:00",
        "brokerTime": "2025-05-14 15:03:00",
        "commission": -58.94,
        "swap": 0,
        "profit": -269.44,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053552",
        "positionId": "56053550",
        "volume": 8.42,
        "price": 3221.16,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -328.38,
        "priceIn": 3220.84,
        "doubleCheck": true
    },
    {
        "dataID": "117107",
        "id": "53090419",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:00",
        "brokerTime": "2025-05-14 15:03:00",
        "commission": -0.98,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053553",
        "positionId": "56053553",
        "volume": 0.14,
        "price": 3220.94,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3120.94,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.98,
        "priceIn": 3220.94,
        "doubleCheck": true
    },
    {
        "dataID": "117108",
        "id": "53090420",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:01",
        "brokerTime": "2025-05-14 15:03:01",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053554",
        "positionId": "56053554",
        "volume": 8.28,
        "price": 3220.93,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3220.93,
        "doubleCheck": true
    },
    {
        "dataID": "117109",
        "id": "53090421",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:01",
        "brokerTime": "2025-05-14 15:03:01",
        "commission": -57.96,
        "swap": 0,
        "profit": -57.96,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053555",
        "positionId": "56053554",
        "volume": 8.28,
        "price": 3221,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -115.92,
        "priceIn": 3220.93,
        "doubleCheck": true
    },
    {
        "dataID": "117110",
        "id": "53090425",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:02",
        "brokerTime": "2025-05-14 15:03:02",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053559",
        "positionId": "56053559",
        "volume": 8.28,
        "price": 3221.03,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3221.03,
        "doubleCheck": true
    },
    {
        "dataID": "117111",
        "id": "53090427",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:02",
        "brokerTime": "2025-05-14 15:03:03",
        "commission": -57.96,
        "swap": 0,
        "profit": -339.48,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053561",
        "positionId": "56053559",
        "volume": 8.28,
        "price": 3221.44,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -397.44,
        "priceIn": 3221.03,
        "doubleCheck": true
    },
    {
        "dataID": "117112",
        "id": "53090436",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:03",
        "brokerTime": "2025-05-14 15:03:03",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053567",
        "positionId": "56053567",
        "volume": 8.28,
        "price": 3221.38,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3221.38,
        "doubleCheck": true
    },
    {
        "dataID": "117113",
        "id": "53090444",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:03",
        "brokerTime": "2025-05-14 15:03:04",
        "commission": -57.96,
        "swap": 0,
        "profit": -149.04,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053577",
        "positionId": "56053567",
        "volume": 8.28,
        "price": 3221.56,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -207,
        "priceIn": 3221.38,
        "doubleCheck": true
    },
    {
        "dataID": "117114",
        "id": "53090476",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:04",
        "brokerTime": "2025-05-14 15:03:04",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053601",
        "positionId": "56053601",
        "volume": 8.28,
        "price": 3221.23,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3221.23,
        "doubleCheck": true
    },
    {
        "dataID": "117115",
        "id": "53090498",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:04",
        "brokerTime": "2025-05-14 15:03:05",
        "commission": -57.96,
        "swap": 0,
        "profit": -182.16,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053615",
        "positionId": "56053601",
        "volume": 8.28,
        "price": 3221.45,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -240.12,
        "priceIn": 3221.23,
        "doubleCheck": true
    },
    {
        "dataID": "117116",
        "id": "53090503",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:05",
        "brokerTime": "2025-05-14 15:03:05",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053618",
        "positionId": "56053618",
        "volume": 8.28,
        "price": 3221.13,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3221.13,
        "doubleCheck": true
    },
    {
        "dataID": "117117",
        "id": "53090504",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:05",
        "brokerTime": "2025-05-14 15:03:06",
        "commission": -57.96,
        "swap": 0,
        "profit": -182.16,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053619",
        "positionId": "56053618",
        "volume": 8.28,
        "price": 3221.35,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -240.12,
        "priceIn": 3221.13,
        "doubleCheck": true
    },
    {
        "dataID": "117118",
        "id": "53090506",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:06",
        "brokerTime": "2025-05-14 15:03:06",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053621",
        "positionId": "56053621",
        "volume": 8.28,
        "price": 3221.16,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3221.16,
        "doubleCheck": true
    },
    {
        "dataID": "117119",
        "id": "53090507",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:06",
        "brokerTime": "2025-05-14 15:03:07",
        "commission": -57.96,
        "swap": 0,
        "profit": -306.36,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053622",
        "positionId": "56053621",
        "volume": 8.28,
        "price": 3221.53,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -364.32,
        "priceIn": 3221.16,
        "doubleCheck": true
    },
    {
        "dataID": "117120",
        "id": "53090508",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:07",
        "brokerTime": "2025-05-14 15:03:07",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053623",
        "positionId": "56053623",
        "volume": 8.28,
        "price": 3220.88,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3220.88,
        "doubleCheck": true
    },
    {
        "dataID": "117121",
        "id": "53090509",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:07",
        "brokerTime": "2025-05-14 15:03:08",
        "commission": -57.96,
        "swap": 0,
        "profit": -149.04,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053624",
        "positionId": "56053623",
        "volume": 8.28,
        "price": 3221.06,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -207,
        "priceIn": 3220.88,
        "doubleCheck": true
    },
    {
        "dataID": "117122",
        "id": "53090511",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:08",
        "brokerTime": "2025-05-14 15:03:08",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053626",
        "positionId": "56053626",
        "volume": 8.28,
        "price": 3220.76,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3220.76,
        "doubleCheck": true
    },
    {
        "dataID": "117123",
        "id": "53090512",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:08",
        "brokerTime": "2025-05-14 15:03:08",
        "commission": -57.96,
        "swap": 0,
        "profit": -215.28,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053627",
        "positionId": "56053626",
        "volume": 8.28,
        "price": 3221.02,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -273.24,
        "priceIn": 3220.76,
        "doubleCheck": true
    },
    {
        "dataID": "117124",
        "id": "53090513",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:09",
        "brokerTime": "2025-05-14 15:03:09",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053628",
        "positionId": "56053628",
        "volume": 8.28,
        "price": 3220.97,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3220.97,
        "doubleCheck": true
    },
    {
        "dataID": "117125",
        "id": "53090514",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:09",
        "brokerTime": "2025-05-14 15:03:09",
        "commission": -57.96,
        "swap": 0,
        "profit": -190.44,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053629",
        "positionId": "56053628",
        "volume": 8.28,
        "price": 3221.2,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -248.4,
        "priceIn": 3220.97,
        "doubleCheck": true
    },
    {
        "dataID": "117126",
        "id": "53090515",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:09",
        "brokerTime": "2025-05-14 15:03:09",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053630",
        "positionId": "56053630",
        "volume": 8.28,
        "price": 3220.99,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3220.99,
        "doubleCheck": true
    },
    {
        "dataID": "117127",
        "id": "53090516",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:09",
        "brokerTime": "2025-05-14 15:03:10",
        "commission": -57.96,
        "swap": 0,
        "profit": -157.32,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053631",
        "positionId": "56053630",
        "volume": 8.28,
        "price": 3221.18,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -215.28,
        "priceIn": 3220.99,
        "doubleCheck": true
    },
    {
        "dataID": "117128",
        "id": "53090517",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:10",
        "brokerTime": "2025-05-14 15:03:10",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053632",
        "positionId": "56053632",
        "volume": 8.28,
        "price": 3220.95,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3220.95,
        "doubleCheck": true
    },
    {
        "dataID": "117129",
        "id": "53090518",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:10",
        "brokerTime": "2025-05-14 15:03:10",
        "commission": -57.96,
        "swap": 0,
        "profit": -198.72,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053633",
        "positionId": "56053632",
        "volume": 8.28,
        "price": 3221.19,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -256.68,
        "priceIn": 3220.95,
        "doubleCheck": true
    },
    {
        "dataID": "117130",
        "id": "53090519",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:11",
        "brokerTime": "2025-05-14 15:03:11",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053634",
        "positionId": "56053634",
        "volume": 8.28,
        "price": 3221.02,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3221.02,
        "doubleCheck": true
    },
    {
        "dataID": "117131",
        "id": "53090520",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:11",
        "brokerTime": "2025-05-14 15:03:12",
        "commission": -57.96,
        "swap": 0,
        "profit": -298.08,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053635",
        "positionId": "56053634",
        "volume": 8.28,
        "price": 3221.38,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -356.03999999999996,
        "priceIn": 3221.02,
        "doubleCheck": true
    },
    {
        "dataID": "117132",
        "id": "53090521",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:12",
        "brokerTime": "2025-05-14 15:03:12",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053636",
        "positionId": "56053636",
        "volume": 8.28,
        "price": 3221.15,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3221.15,
        "doubleCheck": true
    },
    {
        "dataID": "117133",
        "id": "53090522",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:12",
        "brokerTime": "2025-05-14 15:03:12",
        "commission": -57.96,
        "swap": 0,
        "profit": -173.88,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053637",
        "positionId": "56053636",
        "volume": 8.28,
        "price": 3221.36,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -231.84,
        "priceIn": 3221.15,
        "doubleCheck": true
    },
    {
        "dataID": "117134",
        "id": "53090523",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:13",
        "brokerTime": "2025-05-14 15:03:13",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053638",
        "positionId": "56053638",
        "volume": 8.28,
        "price": 3221.19,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3221.19,
        "doubleCheck": true
    },
    {
        "dataID": "117135",
        "id": "53090525",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:13",
        "brokerTime": "2025-05-14 15:03:13",
        "commission": -57.96,
        "swap": 0,
        "profit": -16.56,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053640",
        "positionId": "56053638",
        "volume": 8.28,
        "price": 3221.21,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -74.52,
        "priceIn": 3221.19,
        "doubleCheck": true
    },
    {
        "dataID": "117136",
        "id": "53090526",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:14",
        "brokerTime": "2025-05-14 15:03:14",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053641",
        "positionId": "56053641",
        "volume": 8.28,
        "price": 3221.02,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3221.02,
        "doubleCheck": true
    },
    {
        "dataID": "117137",
        "id": "53090527",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:14",
        "brokerTime": "2025-05-14 15:03:14",
        "commission": -57.96,
        "swap": 0,
        "profit": -74.52,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053642",
        "positionId": "56053641",
        "volume": 8.28,
        "price": 3221.11,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -132.48,
        "priceIn": 3221.02,
        "doubleCheck": true
    },
    {
        "dataID": "117138",
        "id": "53090528",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:15",
        "brokerTime": "2025-05-14 15:03:15",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053643",
        "positionId": "56053643",
        "volume": 8.28,
        "price": 3220.88,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3220.88,
        "doubleCheck": true
    },
    {
        "dataID": "117139",
        "id": "53090529",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:15",
        "brokerTime": "2025-05-14 15:03:15",
        "commission": -57.96,
        "swap": 0,
        "profit": -165.6,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053644",
        "positionId": "56053643",
        "volume": 8.28,
        "price": 3221.08,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -223.56,
        "priceIn": 3220.88,
        "doubleCheck": true
    },
    {
        "dataID": "117140",
        "id": "53090530",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:16",
        "brokerTime": "2025-05-14 15:03:16",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053645",
        "positionId": "56053645",
        "volume": 8.28,
        "price": 3221.07,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3221.07,
        "doubleCheck": true
    },
    {
        "dataID": "117141",
        "id": "53090531",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:16",
        "brokerTime": "2025-05-14 15:03:16",
        "commission": -57.96,
        "swap": 0,
        "profit": -165.6,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053646",
        "positionId": "56053645",
        "volume": 8.28,
        "price": 3221.27,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -223.56,
        "priceIn": 3221.07,
        "doubleCheck": true
    },
    {
        "dataID": "117142",
        "id": "53090532",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:16",
        "brokerTime": "2025-05-14 15:03:16",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053647",
        "positionId": "56053647",
        "volume": 8.28,
        "price": 3221.17,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3221.17,
        "doubleCheck": true
    },
    {
        "dataID": "117143",
        "id": "53090533",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:16",
        "brokerTime": "2025-05-14 15:03:17",
        "commission": -57.96,
        "swap": 0,
        "profit": -165.6,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053648",
        "positionId": "56053647",
        "volume": 8.28,
        "price": 3221.37,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -223.56,
        "priceIn": 3221.17,
        "doubleCheck": true
    },
    {
        "dataID": "117144",
        "id": "53090535",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:17",
        "brokerTime": "2025-05-14 15:03:17",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053650",
        "positionId": "56053650",
        "volume": 8.28,
        "price": 3221.18,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3221.18,
        "doubleCheck": true
    },
    {
        "dataID": "117145",
        "id": "53090536",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:17",
        "brokerTime": "2025-05-14 15:03:18",
        "commission": -57.96,
        "swap": 0,
        "profit": -99.36,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053651",
        "positionId": "56053650",
        "volume": 8.28,
        "price": 3221.3,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -157.32,
        "priceIn": 3221.18,
        "doubleCheck": true
    },
    {
        "dataID": "117146",
        "id": "53090537",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:19",
        "brokerTime": "2025-05-14 15:03:19",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053652",
        "positionId": "56053652",
        "volume": 8.28,
        "price": 3221.08,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3221.08,
        "doubleCheck": true
    },
    {
        "dataID": "117147",
        "id": "53090538",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:19",
        "brokerTime": "2025-05-14 15:03:19",
        "commission": -57.96,
        "swap": 0,
        "profit": -480.24,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053653",
        "positionId": "56053652",
        "volume": 8.28,
        "price": 3221.66,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -538.2,
        "priceIn": 3221.08,
        "doubleCheck": true
    },
    {
        "dataID": "117148",
        "id": "53090539",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:20",
        "brokerTime": "2025-05-14 15:03:20",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053654",
        "positionId": "56053654",
        "volume": 8.28,
        "price": 3221.43,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3221.43,
        "doubleCheck": true
    },
    {
        "dataID": "117149",
        "id": "53090540",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:20",
        "brokerTime": "2025-05-14 15:03:20",
        "commission": -57.96,
        "swap": 0,
        "profit": -223.56,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053655",
        "positionId": "56053654",
        "volume": 8.28,
        "price": 3221.7,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -281.52,
        "priceIn": 3221.43,
        "doubleCheck": true
    },
    {
        "dataID": "117150",
        "id": "53090541",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:21",
        "brokerTime": "2025-05-14 15:03:21",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053656",
        "positionId": "56053656",
        "volume": 8.28,
        "price": 3221.16,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3221.16,
        "doubleCheck": true
    },
    {
        "dataID": "117151",
        "id": "53090542",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:21",
        "brokerTime": "2025-05-14 15:03:22",
        "commission": -57.96,
        "swap": 0,
        "profit": -273.24,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053657",
        "positionId": "56053656",
        "volume": 8.28,
        "price": 3221.49,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -331.2,
        "priceIn": 3221.16,
        "doubleCheck": true
    },
    {
        "dataID": "117152",
        "id": "53090543",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:22",
        "brokerTime": "2025-05-14 15:03:22",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053658",
        "positionId": "56053658",
        "volume": 8.28,
        "price": 3221.31,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3221.31,
        "doubleCheck": true
    },
    {
        "dataID": "117153",
        "id": "53090546",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:22",
        "brokerTime": "2025-05-14 15:03:23",
        "commission": -57.96,
        "swap": 0,
        "profit": -231.84,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053660",
        "positionId": "56053658",
        "volume": 8.28,
        "price": 3221.59,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -289.8,
        "priceIn": 3221.31,
        "doubleCheck": true
    },
    {
        "dataID": "117154",
        "id": "53090547",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:23",
        "brokerTime": "2025-05-14 15:03:23",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053661",
        "positionId": "56053661",
        "volume": 8.28,
        "price": 3221.4,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3221.4,
        "doubleCheck": true
    },
    {
        "dataID": "117155",
        "id": "53090564",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:23",
        "brokerTime": "2025-05-14 15:03:32",
        "commission": -57.96,
        "swap": 0,
        "profit": -554.76,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053678",
        "positionId": "56053661",
        "volume": 8.28,
        "price": 3222.07,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -612.72,
        "priceIn": 3221.4,
        "doubleCheck": true
    },
    {
        "dataID": "117156",
        "id": "53090565",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:32",
        "brokerTime": "2025-05-14 15:03:32",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053679",
        "positionId": "56053679",
        "volume": 8.28,
        "price": 3221.83,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3221.83,
        "doubleCheck": true
    },
    {
        "dataID": "117157",
        "id": "53090566",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:32",
        "brokerTime": "2025-05-14 15:03:33",
        "commission": -57.96,
        "swap": 0,
        "profit": -16.56,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053680",
        "positionId": "56053679",
        "volume": 8.28,
        "price": 3221.85,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -74.52,
        "priceIn": 3221.83,
        "doubleCheck": true
    },
    {
        "dataID": "117158",
        "id": "53090567",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:33",
        "brokerTime": "2025-05-14 15:03:33",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053681",
        "positionId": "56053681",
        "volume": 8.28,
        "price": 3221.69,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3221.69,
        "doubleCheck": true
    },
    {
        "dataID": "117159",
        "id": "53090568",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:33",
        "brokerTime": "2025-05-14 15:03:34",
        "commission": -57.96,
        "swap": 0,
        "profit": -140.76,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053682",
        "positionId": "56053681",
        "volume": 8.28,
        "price": 3221.86,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -198.72,
        "priceIn": 3221.69,
        "doubleCheck": true
    },
    {
        "dataID": "117160",
        "id": "53090569",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:34",
        "brokerTime": "2025-05-14 15:03:34",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053683",
        "positionId": "56053683",
        "volume": 8.28,
        "price": 3221.61,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3221.61,
        "doubleCheck": true
    },
    {
        "dataID": "117161",
        "id": "53090570",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:34",
        "brokerTime": "2025-05-14 15:03:35",
        "commission": -57.96,
        "swap": 0,
        "profit": -207,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053684",
        "positionId": "56053683",
        "volume": 8.28,
        "price": 3221.86,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -264.96,
        "priceIn": 3221.61,
        "doubleCheck": true
    },
    {
        "dataID": "117162",
        "id": "53090571",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:36",
        "brokerTime": "2025-05-14 15:03:36",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053685",
        "positionId": "56053685",
        "volume": 8.28,
        "price": 3221.56,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3221.56,
        "doubleCheck": true
    },
    {
        "dataID": "117163",
        "id": "53090572",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:36",
        "brokerTime": "2025-05-14 15:03:36",
        "commission": -57.96,
        "swap": 0,
        "profit": -107.64,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053686",
        "positionId": "56053685",
        "volume": 8.28,
        "price": 3221.69,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -165.6,
        "priceIn": 3221.56,
        "doubleCheck": true
    },
    {
        "dataID": "117164",
        "id": "53090573",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:36",
        "brokerTime": "2025-05-14 15:03:36",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053687",
        "positionId": "56053687",
        "volume": 8.28,
        "price": 3221.48,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3221.48,
        "doubleCheck": true
    },
    {
        "dataID": "117165",
        "id": "53090574",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:36",
        "brokerTime": "2025-05-14 15:03:37",
        "commission": -57.96,
        "swap": 0,
        "profit": -165.6,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053688",
        "positionId": "56053687",
        "volume": 8.28,
        "price": 3221.68,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -223.56,
        "priceIn": 3221.48,
        "doubleCheck": true
    },
    {
        "dataID": "117166",
        "id": "53090576",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:37",
        "brokerTime": "2025-05-14 15:03:37",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053694",
        "positionId": "56053694",
        "volume": 8.28,
        "price": 3221.46,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3221.46,
        "doubleCheck": true
    },
    {
        "dataID": "117167",
        "id": "53090584",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:37",
        "brokerTime": "2025-05-14 15:03:37",
        "commission": -57.96,
        "swap": 0,
        "profit": -207,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053697",
        "positionId": "56053694",
        "volume": 8.28,
        "price": 3221.71,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -264.96,
        "priceIn": 3221.46,
        "doubleCheck": true
    },
    {
        "dataID": "117168",
        "id": "53090588",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:38",
        "brokerTime": "2025-05-14 15:03:38",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053701",
        "positionId": "56053701",
        "volume": 8.28,
        "price": 3221.51,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3221.51,
        "doubleCheck": true
    },
    {
        "dataID": "117169",
        "id": "53090589",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:38",
        "brokerTime": "2025-05-14 15:03:38",
        "commission": -57.96,
        "swap": 0,
        "profit": -190.44,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053702",
        "positionId": "56053701",
        "volume": 8.28,
        "price": 3221.74,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -248.4,
        "priceIn": 3221.51,
        "doubleCheck": true
    },
    {
        "dataID": "117170",
        "id": "53090591",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:38",
        "brokerTime": "2025-05-14 15:03:38",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053704",
        "positionId": "56053704",
        "volume": 8.28,
        "price": 3221.54,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3221.54,
        "doubleCheck": true
    },
    {
        "dataID": "117171",
        "id": "53090592",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:38",
        "brokerTime": "2025-05-14 15:03:39",
        "commission": -57.96,
        "swap": 0,
        "profit": -405.72,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053705",
        "positionId": "56053704",
        "volume": 8.28,
        "price": 3222.03,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -463.68,
        "priceIn": 3221.54,
        "doubleCheck": true
    },
    {
        "dataID": "117172",
        "id": "53090593",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:39",
        "brokerTime": "2025-05-14 15:03:39",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053706",
        "positionId": "56053706",
        "volume": 8.28,
        "price": 3221.84,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3221.84,
        "doubleCheck": true
    },
    {
        "dataID": "117173",
        "id": "53090594",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:39",
        "brokerTime": "2025-05-14 15:03:40",
        "commission": -57.96,
        "swap": 0,
        "profit": -165.6,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053707",
        "positionId": "56053706",
        "volume": 8.28,
        "price": 3222.04,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -223.56,
        "priceIn": 3221.84,
        "doubleCheck": true
    },
    {
        "dataID": "117174",
        "id": "53090595",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:40",
        "brokerTime": "2025-05-14 15:03:40",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053708",
        "positionId": "56053708",
        "volume": 8.28,
        "price": 3221.78,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3221.78,
        "doubleCheck": true
    },
    {
        "dataID": "117175",
        "id": "53090597",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:40",
        "brokerTime": "2025-05-14 15:03:41",
        "commission": -57.96,
        "swap": 0,
        "profit": -140.76,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053710",
        "positionId": "56053708",
        "volume": 8.28,
        "price": 3221.95,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -198.72,
        "priceIn": 3221.78,
        "doubleCheck": true
    },
    {
        "dataID": "117176",
        "id": "53090598",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:41",
        "brokerTime": "2025-05-14 15:03:41",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053711",
        "positionId": "56053711",
        "volume": 8.28,
        "price": 3221.72,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3221.72,
        "doubleCheck": true
    },
    {
        "dataID": "117177",
        "id": "53090599",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:41",
        "brokerTime": "2025-05-14 15:03:42",
        "commission": -57.96,
        "swap": 0,
        "profit": -57.96,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053712",
        "positionId": "56053711",
        "volume": 8.28,
        "price": 3221.79,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -115.92,
        "priceIn": 3221.72,
        "doubleCheck": true
    },
    {
        "dataID": "117178",
        "id": "53090600",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:42",
        "brokerTime": "2025-05-14 15:03:42",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053713",
        "positionId": "56053713",
        "volume": 8.28,
        "price": 3221.71,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3221.71,
        "doubleCheck": true
    },
    {
        "dataID": "117179",
        "id": "53090601",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:42",
        "brokerTime": "2025-05-14 15:03:42",
        "commission": -57.96,
        "swap": 0,
        "profit": 33.12,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053714",
        "positionId": "56053713",
        "volume": 8.28,
        "price": 3221.67,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -24.840000000000003,
        "priceIn": 3221.71,
        "doubleCheck": true
    },
    {
        "dataID": "117180",
        "id": "53090602",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:43",
        "brokerTime": "2025-05-14 15:03:43",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053715",
        "positionId": "56053715",
        "volume": 8.28,
        "price": 3221.51,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3221.51,
        "doubleCheck": true
    },
    {
        "dataID": "117181",
        "id": "53090603",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:43",
        "brokerTime": "2025-05-14 15:03:43",
        "commission": -57.96,
        "swap": 0,
        "profit": -107.64,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053716",
        "positionId": "56053715",
        "volume": 8.28,
        "price": 3221.64,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -165.6,
        "priceIn": 3221.51,
        "doubleCheck": true
    },
    {
        "dataID": "117182",
        "id": "53090638",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:44",
        "brokerTime": "2025-05-14 15:03:44",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053751",
        "positionId": "56053751",
        "volume": 8.28,
        "price": 3221.4,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3221.4,
        "doubleCheck": true
    },
    {
        "dataID": "117183",
        "id": "53090645",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:44",
        "brokerTime": "2025-05-14 15:03:44",
        "commission": -57.96,
        "swap": 0,
        "profit": -165.6,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053752",
        "positionId": "56053751",
        "volume": 8.28,
        "price": 3221.6,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -223.56,
        "priceIn": 3221.4,
        "doubleCheck": true
    },
    {
        "dataID": "117184",
        "id": "53090646",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:44",
        "brokerTime": "2025-05-14 15:03:44",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053753",
        "positionId": "56053753",
        "volume": 8.28,
        "price": 3221.48,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3221.48,
        "doubleCheck": true
    },
    {
        "dataID": "117185",
        "id": "53090647",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:44",
        "brokerTime": "2025-05-14 15:03:45",
        "commission": -57.96,
        "swap": 0,
        "profit": -331.2,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053754",
        "positionId": "56053753",
        "volume": 8.28,
        "price": 3221.88,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -389.15999999999997,
        "priceIn": 3221.48,
        "doubleCheck": true
    },
    {
        "dataID": "117186",
        "id": "53090648",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:45",
        "brokerTime": "2025-05-14 15:03:45",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053755",
        "positionId": "56053755",
        "volume": 8.28,
        "price": 3221.66,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3221.66,
        "doubleCheck": true
    },
    {
        "dataID": "117187",
        "id": "53090649",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:45",
        "brokerTime": "2025-05-14 15:03:46",
        "commission": -57.96,
        "swap": 0,
        "profit": -157.32,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053756",
        "positionId": "56053755",
        "volume": 8.28,
        "price": 3221.85,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -215.28,
        "priceIn": 3221.66,
        "doubleCheck": true
    },
    {
        "dataID": "117188",
        "id": "53090650",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:46",
        "brokerTime": "2025-05-14 15:03:46",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053757",
        "positionId": "56053757",
        "volume": 8.28,
        "price": 3221.66,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3221.66,
        "doubleCheck": true
    },
    {
        "dataID": "117189",
        "id": "53090652",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:46",
        "brokerTime": "2025-05-14 15:03:46",
        "commission": -57.96,
        "swap": 0,
        "profit": -132.48,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053759",
        "positionId": "56053757",
        "volume": 8.28,
        "price": 3221.82,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -190.44,
        "priceIn": 3221.66,
        "doubleCheck": true
    },
    {
        "dataID": "117190",
        "id": "53090653",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:47",
        "brokerTime": "2025-05-14 15:03:47",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053760",
        "positionId": "56053760",
        "volume": 8.28,
        "price": 3221.73,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3221.73,
        "doubleCheck": true
    },
    {
        "dataID": "117191",
        "id": "53090655",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:47",
        "brokerTime": "2025-05-14 15:03:47",
        "commission": -57.96,
        "swap": 0,
        "profit": -157.32,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053762",
        "positionId": "56053760",
        "volume": 8.28,
        "price": 3221.92,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -215.28,
        "priceIn": 3221.73,
        "doubleCheck": true
    },
    {
        "dataID": "117192",
        "id": "53090657",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:48",
        "brokerTime": "2025-05-14 15:03:48",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053764",
        "positionId": "56053764",
        "volume": 8.28,
        "price": 3221.66,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3221.66,
        "doubleCheck": true
    },
    {
        "dataID": "117193",
        "id": "53090675",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:48",
        "brokerTime": "2025-05-14 15:03:49",
        "commission": -57.96,
        "swap": 0,
        "profit": -157.32,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053782",
        "positionId": "56053764",
        "volume": 8.28,
        "price": 3221.85,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -215.28,
        "priceIn": 3221.66,
        "doubleCheck": true
    },
    {
        "dataID": "117194",
        "id": "53090678",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:49",
        "brokerTime": "2025-05-14 15:03:49",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053784",
        "positionId": "56053784",
        "volume": 8.28,
        "price": 3221.66,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3221.66,
        "doubleCheck": true
    },
    {
        "dataID": "117195",
        "id": "53090680",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:49",
        "brokerTime": "2025-05-14 15:03:49",
        "commission": -57.96,
        "swap": 0,
        "profit": -215.28,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053786",
        "positionId": "56053784",
        "volume": 8.28,
        "price": 3221.92,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -273.24,
        "priceIn": 3221.66,
        "doubleCheck": true
    },
    {
        "dataID": "117196",
        "id": "53090681",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:50",
        "brokerTime": "2025-05-14 15:03:50",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053787",
        "positionId": "56053787",
        "volume": 8.28,
        "price": 3221.41,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3221.41,
        "doubleCheck": true
    },
    {
        "dataID": "117197",
        "id": "53090682",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:50",
        "brokerTime": "2025-05-14 15:03:50",
        "commission": -57.96,
        "swap": 0,
        "profit": -140.76,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053788",
        "positionId": "56053787",
        "volume": 8.28,
        "price": 3221.58,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -198.72,
        "priceIn": 3221.41,
        "doubleCheck": true
    },
    {
        "dataID": "117198",
        "id": "53090683",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:51",
        "brokerTime": "2025-05-14 15:03:51",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053789",
        "positionId": "56053789",
        "volume": 8.28,
        "price": 3221.39,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3221.39,
        "doubleCheck": true
    },
    {
        "dataID": "117199",
        "id": "53090684",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:51",
        "brokerTime": "2025-05-14 15:03:52",
        "commission": -57.96,
        "swap": 0,
        "profit": -173.88,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053790",
        "positionId": "56053789",
        "volume": 8.28,
        "price": 3221.6,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -231.84,
        "priceIn": 3221.39,
        "doubleCheck": true
    },
    {
        "dataID": "117200",
        "id": "53090685",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:52",
        "brokerTime": "2025-05-14 15:03:52",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053791",
        "positionId": "56053791",
        "volume": 8.28,
        "price": 3221.33,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3221.33,
        "doubleCheck": true
    },
    {
        "dataID": "117201",
        "id": "53090686",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:52",
        "brokerTime": "2025-05-14 15:03:53",
        "commission": -57.96,
        "swap": 0,
        "profit": -231.84,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053792",
        "positionId": "56053791",
        "volume": 8.28,
        "price": 3221.61,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -289.8,
        "priceIn": 3221.33,
        "doubleCheck": true
    },
    {
        "dataID": "117202",
        "id": "53090687",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:53",
        "brokerTime": "2025-05-14 15:03:53",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053793",
        "positionId": "56053793",
        "volume": 8.28,
        "price": 3221.37,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3221.37,
        "doubleCheck": true
    },
    {
        "dataID": "117203",
        "id": "53090688",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:53",
        "brokerTime": "2025-05-14 15:03:54",
        "commission": -57.96,
        "swap": 0,
        "profit": -140.76,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053794",
        "positionId": "56053793",
        "volume": 8.28,
        "price": 3221.54,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -198.72,
        "priceIn": 3221.37,
        "doubleCheck": true
    },
    {
        "dataID": "117204",
        "id": "53090689",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:54",
        "brokerTime": "2025-05-14 15:03:54",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053795",
        "positionId": "56053795",
        "volume": 8.28,
        "price": 3221.33,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3221.33,
        "doubleCheck": true
    },
    {
        "dataID": "117205",
        "id": "53090690",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:54",
        "brokerTime": "2025-05-14 15:03:55",
        "commission": -57.96,
        "swap": 0,
        "profit": -173.88,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053796",
        "positionId": "56053795",
        "volume": 8.28,
        "price": 3221.54,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -231.84,
        "priceIn": 3221.33,
        "doubleCheck": true
    },
    {
        "dataID": "117206",
        "id": "53090691",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:55",
        "brokerTime": "2025-05-14 15:03:55",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053797",
        "positionId": "56053797",
        "volume": 8.28,
        "price": 3221.33,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3221.33,
        "doubleCheck": true
    },
    {
        "dataID": "117207",
        "id": "53090693",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:55",
        "brokerTime": "2025-05-14 15:03:56",
        "commission": -57.96,
        "swap": 0,
        "profit": -397.44,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053799",
        "positionId": "56053797",
        "volume": 8.28,
        "price": 3221.81,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -455.4,
        "priceIn": 3221.33,
        "doubleCheck": true
    },
    {
        "dataID": "117208",
        "id": "53090694",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:56",
        "brokerTime": "2025-05-14 15:03:56",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053800",
        "positionId": "56053800",
        "volume": 8.28,
        "price": 3221.7,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3221.7,
        "doubleCheck": true
    },
    {
        "dataID": "117209",
        "id": "53090695",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:56",
        "brokerTime": "2025-05-14 15:03:57",
        "commission": -57.96,
        "swap": 0,
        "profit": -182.16,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053801",
        "positionId": "56053800",
        "volume": 8.28,
        "price": 3221.92,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -240.12,
        "priceIn": 3221.7,
        "doubleCheck": true
    },
    {
        "dataID": "117210",
        "id": "53090696",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:57",
        "brokerTime": "2025-05-14 15:03:57",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053802",
        "positionId": "56053802",
        "volume": 8.28,
        "price": 3221.7,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3221.7,
        "doubleCheck": true
    },
    {
        "dataID": "117211",
        "id": "53090697",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:57",
        "brokerTime": "2025-05-14 15:03:58",
        "commission": -57.96,
        "swap": 0,
        "profit": 124.2,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053803",
        "positionId": "56053802",
        "volume": 8.28,
        "price": 3221.55,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 66.24000000000001,
        "priceIn": 3221.7,
        "doubleCheck": true
    },
    {
        "dataID": "117212",
        "id": "53090698",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:58",
        "brokerTime": "2025-05-14 15:03:58",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053804",
        "positionId": "56053804",
        "volume": 8.28,
        "price": 3221.6,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3221.6,
        "doubleCheck": true
    },
    {
        "dataID": "117213",
        "id": "53090699",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:58",
        "brokerTime": "2025-05-14 15:03:59",
        "commission": -57.96,
        "swap": 0,
        "profit": -107.64,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053805",
        "positionId": "56053804",
        "volume": 8.28,
        "price": 3221.73,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -165.6,
        "priceIn": 3221.6,
        "doubleCheck": true
    },
    {
        "dataID": "117214",
        "id": "53090700",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:00",
        "brokerTime": "2025-05-14 15:04:00",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053806",
        "positionId": "56053806",
        "volume": 8.28,
        "price": 3221.57,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3221.57,
        "doubleCheck": true
    },
    {
        "dataID": "117215",
        "id": "53090703",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:00",
        "brokerTime": "2025-05-14 15:04:01",
        "commission": -57.96,
        "swap": 0,
        "profit": -41.4,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053809",
        "positionId": "56053806",
        "volume": 8.28,
        "price": 3221.62,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -99.36,
        "priceIn": 3221.57,
        "doubleCheck": true
    },
    {
        "dataID": "117216",
        "id": "53090705",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:01",
        "brokerTime": "2025-05-14 15:04:01",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053811",
        "positionId": "56053811",
        "volume": 8.28,
        "price": 3221.44,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3221.44,
        "doubleCheck": true
    },
    {
        "dataID": "117217",
        "id": "53090706",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:01",
        "brokerTime": "2025-05-14 15:04:01",
        "commission": -57.96,
        "swap": 0,
        "profit": -149.04,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053812",
        "positionId": "56053811",
        "volume": 8.28,
        "price": 3221.62,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -207,
        "priceIn": 3221.44,
        "doubleCheck": true
    },
    {
        "dataID": "117218",
        "id": "53090707",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:02",
        "brokerTime": "2025-05-14 15:04:02",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053813",
        "positionId": "56053813",
        "volume": 8.28,
        "price": 3221.52,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3221.52,
        "doubleCheck": true
    },
    {
        "dataID": "117219",
        "id": "53090709",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:02",
        "brokerTime": "2025-05-14 15:04:02",
        "commission": -57.96,
        "swap": 0,
        "profit": -223.56,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053818",
        "positionId": "56053813",
        "volume": 8.28,
        "price": 3221.79,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -281.52,
        "priceIn": 3221.52,
        "doubleCheck": true
    },
    {
        "dataID": "117220",
        "id": "53090734",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:02",
        "brokerTime": "2025-05-14 15:04:02",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053840",
        "positionId": "56053840",
        "volume": 8.28,
        "price": 3221.61,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3221.61,
        "doubleCheck": true
    },
    {
        "dataID": "117221",
        "id": "53090764",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:02",
        "brokerTime": "2025-05-14 15:04:03",
        "commission": -57.96,
        "swap": 0,
        "profit": -273.24,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053853",
        "positionId": "56053840",
        "volume": 8.28,
        "price": 3221.94,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -331.2,
        "priceIn": 3221.61,
        "doubleCheck": true
    },
    {
        "dataID": "117222",
        "id": "53090772",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:04",
        "brokerTime": "2025-05-14 15:04:04",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053859",
        "positionId": "56053859",
        "volume": 8.28,
        "price": 3221.84,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3221.84,
        "doubleCheck": true
    },
    {
        "dataID": "117223",
        "id": "53090775",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:04",
        "brokerTime": "2025-05-14 15:04:04",
        "commission": -57.96,
        "swap": 0,
        "profit": -99.36,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053862",
        "positionId": "56053859",
        "volume": 8.28,
        "price": 3221.96,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -157.32,
        "priceIn": 3221.84,
        "doubleCheck": true
    },
    {
        "dataID": "117224",
        "id": "53090777",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:05",
        "brokerTime": "2025-05-14 15:04:05",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053864",
        "positionId": "56053864",
        "volume": 8.28,
        "price": 3221.9,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3221.9,
        "doubleCheck": true
    },
    {
        "dataID": "117225",
        "id": "53090779",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:05",
        "brokerTime": "2025-05-14 15:04:05",
        "commission": -57.96,
        "swap": 0,
        "profit": -140.76,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053867",
        "positionId": "56053864",
        "volume": 8.28,
        "price": 3222.07,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -198.72,
        "priceIn": 3221.9,
        "doubleCheck": true
    },
    {
        "dataID": "117226",
        "id": "53090782",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:05",
        "brokerTime": "2025-05-14 15:04:05",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053868",
        "positionId": "56053868",
        "volume": 8.28,
        "price": 3221.89,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3221.89,
        "doubleCheck": true
    },
    {
        "dataID": "117227",
        "id": "53090783",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:05",
        "brokerTime": "2025-05-14 15:04:06",
        "commission": -57.96,
        "swap": 0,
        "profit": -24.84,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053869",
        "positionId": "56053868",
        "volume": 8.28,
        "price": 3221.92,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -82.8,
        "priceIn": 3221.89,
        "doubleCheck": true
    },
    {
        "dataID": "117228",
        "id": "53090784",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:06",
        "brokerTime": "2025-05-14 15:04:06",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053870",
        "positionId": "56053870",
        "volume": 8.28,
        "price": 3221.72,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3221.72,
        "doubleCheck": true
    },
    {
        "dataID": "117229",
        "id": "53090785",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:06",
        "brokerTime": "2025-05-14 15:04:07",
        "commission": -57.96,
        "swap": 0,
        "profit": -173.88,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053871",
        "positionId": "56053870",
        "volume": 8.28,
        "price": 3221.93,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -231.84,
        "priceIn": 3221.72,
        "doubleCheck": true
    },
    {
        "dataID": "117230",
        "id": "53090786",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:08",
        "brokerTime": "2025-05-14 15:04:08",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053872",
        "positionId": "56053872",
        "volume": 8.28,
        "price": 3221.78,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3221.78,
        "doubleCheck": true
    },
    {
        "dataID": "117231",
        "id": "53090787",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:08",
        "brokerTime": "2025-05-14 15:04:08",
        "commission": -57.96,
        "swap": 0,
        "profit": -107.64,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053873",
        "positionId": "56053872",
        "volume": 8.28,
        "price": 3221.91,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -165.6,
        "priceIn": 3221.78,
        "doubleCheck": true
    },
    {
        "dataID": "117232",
        "id": "53090788",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:09",
        "brokerTime": "2025-05-14 15:04:09",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053874",
        "positionId": "56053874",
        "volume": 8.28,
        "price": 3221.53,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3221.53,
        "doubleCheck": true
    },
    {
        "dataID": "117233",
        "id": "53090789",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:09",
        "brokerTime": "2025-05-14 15:04:09",
        "commission": -57.96,
        "swap": 0,
        "profit": -264.96,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053875",
        "positionId": "56053874",
        "volume": 8.28,
        "price": 3221.85,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -322.91999999999996,
        "priceIn": 3221.53,
        "doubleCheck": true
    },
    {
        "dataID": "117234",
        "id": "53090790",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:09",
        "brokerTime": "2025-05-14 15:04:09",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053876",
        "positionId": "56053876",
        "volume": 8.28,
        "price": 3221.64,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3221.64,
        "doubleCheck": true
    },
    {
        "dataID": "117235",
        "id": "53090791",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:09",
        "brokerTime": "2025-05-14 15:04:10",
        "commission": -57.96,
        "swap": 0,
        "profit": -149.04,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053877",
        "positionId": "56053876",
        "volume": 8.28,
        "price": 3221.82,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -207,
        "priceIn": 3221.64,
        "doubleCheck": true
    },
    {
        "dataID": "117236",
        "id": "53090792",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:10",
        "brokerTime": "2025-05-14 15:04:10",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053880",
        "positionId": "56053880",
        "volume": 8.28,
        "price": 3221.63,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3221.63,
        "doubleCheck": true
    },
    {
        "dataID": "117237",
        "id": "53090794",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:10",
        "brokerTime": "2025-05-14 15:04:11",
        "commission": -57.96,
        "swap": 0,
        "profit": -165.6,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053881",
        "positionId": "56053880",
        "volume": 8.28,
        "price": 3221.83,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -223.56,
        "priceIn": 3221.63,
        "doubleCheck": true
    },
    {
        "dataID": "117238",
        "id": "53090795",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:11",
        "brokerTime": "2025-05-14 15:04:11",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053882",
        "positionId": "56053882",
        "volume": 8.28,
        "price": 3221.65,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3221.65,
        "doubleCheck": true
    },
    {
        "dataID": "117239",
        "id": "53090796",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:11",
        "brokerTime": "2025-05-14 15:04:12",
        "commission": -57.96,
        "swap": 0,
        "profit": -240.12,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053883",
        "positionId": "56053882",
        "volume": 8.28,
        "price": 3221.94,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -298.08,
        "priceIn": 3221.65,
        "doubleCheck": true
    },
    {
        "dataID": "117240",
        "id": "53090797",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:13",
        "brokerTime": "2025-05-14 15:04:13",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053884",
        "positionId": "56053884",
        "volume": 8.28,
        "price": 3221.74,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3221.74,
        "doubleCheck": true
    },
    {
        "dataID": "117241",
        "id": "53090799",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:13",
        "brokerTime": "2025-05-14 15:04:14",
        "commission": -57.96,
        "swap": 0,
        "profit": -149.04,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053886",
        "positionId": "56053884",
        "volume": 8.28,
        "price": 3221.92,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -207,
        "priceIn": 3221.74,
        "doubleCheck": true
    },
    {
        "dataID": "117242",
        "id": "53090802",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:14",
        "brokerTime": "2025-05-14 15:04:14",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053889",
        "positionId": "56053889",
        "volume": 8.28,
        "price": 3221.69,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3221.69,
        "doubleCheck": true
    },
    {
        "dataID": "117243",
        "id": "53090807",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:14",
        "brokerTime": "2025-05-14 15:04:14",
        "commission": -57.96,
        "swap": 0,
        "profit": -314.64,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053894",
        "positionId": "56053889",
        "volume": 8.28,
        "price": 3222.07,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -372.59999999999997,
        "priceIn": 3221.69,
        "doubleCheck": true
    },
    {
        "dataID": "117244",
        "id": "53090808",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:15",
        "brokerTime": "2025-05-14 15:04:15",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053895",
        "positionId": "56053895",
        "volume": 8.28,
        "price": 3221.84,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3221.84,
        "doubleCheck": true
    },
    {
        "dataID": "117245",
        "id": "53090809",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:15",
        "brokerTime": "2025-05-14 15:04:15",
        "commission": -57.96,
        "swap": 0,
        "profit": -157.32,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053896",
        "positionId": "56053895",
        "volume": 8.28,
        "price": 3222.03,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -215.28,
        "priceIn": 3221.84,
        "doubleCheck": true
    },
    {
        "dataID": "117246",
        "id": "53090810",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:16",
        "brokerTime": "2025-05-14 15:04:16",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053897",
        "positionId": "56053897",
        "volume": 8.28,
        "price": 3221.84,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3221.84,
        "doubleCheck": true
    },
    {
        "dataID": "117247",
        "id": "53090811",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:16",
        "brokerTime": "2025-05-14 15:04:17",
        "commission": -57.96,
        "swap": 0,
        "profit": -115.92,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053898",
        "positionId": "56053897",
        "volume": 8.28,
        "price": 3221.98,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -173.88,
        "priceIn": 3221.84,
        "doubleCheck": true
    },
    {
        "dataID": "117248",
        "id": "53090812",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:17",
        "brokerTime": "2025-05-14 15:04:17",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053899",
        "positionId": "56053899",
        "volume": 8.28,
        "price": 3221.67,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3221.67,
        "doubleCheck": true
    },
    {
        "dataID": "117249",
        "id": "53090815",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:17",
        "brokerTime": "2025-05-14 15:04:17",
        "commission": -57.96,
        "swap": 0,
        "profit": -157.32,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053901",
        "positionId": "56053899",
        "volume": 8.28,
        "price": 3221.86,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -215.28,
        "priceIn": 3221.67,
        "doubleCheck": true
    },
    {
        "dataID": "117250",
        "id": "53090816",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:18",
        "brokerTime": "2025-05-14 15:04:18",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053902",
        "positionId": "56053902",
        "volume": 8.28,
        "price": 3221.65,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3221.65,
        "doubleCheck": true
    },
    {
        "dataID": "117251",
        "id": "53090817",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:18",
        "brokerTime": "2025-05-14 15:04:19",
        "commission": -57.96,
        "swap": 0,
        "profit": -165.6,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053903",
        "positionId": "56053902",
        "volume": 8.28,
        "price": 3221.85,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -223.56,
        "priceIn": 3221.65,
        "doubleCheck": true
    },
    {
        "dataID": "117252",
        "id": "53090818",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:19",
        "brokerTime": "2025-05-14 15:04:19",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053904",
        "positionId": "56053904",
        "volume": 8.28,
        "price": 3221.71,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3221.71,
        "doubleCheck": true
    },
    {
        "dataID": "117253",
        "id": "53090819",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:19",
        "brokerTime": "2025-05-14 15:04:20",
        "commission": -57.96,
        "swap": 0,
        "profit": -115.92,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053905",
        "positionId": "56053904",
        "volume": 8.28,
        "price": 3221.85,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -173.88,
        "priceIn": 3221.71,
        "doubleCheck": true
    },
    {
        "dataID": "117254",
        "id": "53090820",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:21",
        "brokerTime": "2025-05-14 15:04:21",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053906",
        "positionId": "56053906",
        "volume": 8.28,
        "price": 3221.67,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3221.67,
        "doubleCheck": true
    },
    {
        "dataID": "117255",
        "id": "53090821",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:21",
        "brokerTime": "2025-05-14 15:04:21",
        "commission": -57.96,
        "swap": 0,
        "profit": -140.76,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053907",
        "positionId": "56053906",
        "volume": 8.28,
        "price": 3221.84,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -198.72,
        "priceIn": 3221.67,
        "doubleCheck": true
    },
    {
        "dataID": "117256",
        "id": "53090822",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:22",
        "brokerTime": "2025-05-14 15:04:22",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053908",
        "positionId": "56053908",
        "volume": 8.28,
        "price": 3221.72,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3221.72,
        "doubleCheck": true
    },
    {
        "dataID": "117257",
        "id": "53090823",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:22",
        "brokerTime": "2025-05-14 15:04:22",
        "commission": -57.96,
        "swap": 0,
        "profit": -91.08,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053909",
        "positionId": "56053908",
        "volume": 8.28,
        "price": 3221.83,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -149.04,
        "priceIn": 3221.72,
        "doubleCheck": true
    },
    {
        "dataID": "117258",
        "id": "53090825",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:23",
        "brokerTime": "2025-05-14 15:04:23",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053911",
        "positionId": "56053911",
        "volume": 8.28,
        "price": 3221.63,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3221.63,
        "doubleCheck": true
    },
    {
        "dataID": "117259",
        "id": "53090826",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:23",
        "brokerTime": "2025-05-14 15:04:23",
        "commission": -57.96,
        "swap": 0,
        "profit": -264.96,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053912",
        "positionId": "56053911",
        "volume": 8.28,
        "price": 3221.95,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -322.91999999999996,
        "priceIn": 3221.63,
        "doubleCheck": true
    },
    {
        "dataID": "117260",
        "id": "53090827",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:23",
        "brokerTime": "2025-05-14 15:04:23",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053913",
        "positionId": "56053913",
        "volume": 8.28,
        "price": 3221.77,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3221.77,
        "doubleCheck": true
    },
    {
        "dataID": "117261",
        "id": "53090830",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:23",
        "brokerTime": "2025-05-14 15:04:25",
        "commission": -57.96,
        "swap": 0,
        "profit": -115.92,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053915",
        "positionId": "56053913",
        "volume": 8.28,
        "price": 3221.91,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -173.88,
        "priceIn": 3221.77,
        "doubleCheck": true
    },
    {
        "dataID": "117262",
        "id": "53090831",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:25",
        "brokerTime": "2025-05-14 15:04:25",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053916",
        "positionId": "56053916",
        "volume": 8.28,
        "price": 3221.77,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3221.77,
        "doubleCheck": true
    },
    {
        "dataID": "117263",
        "id": "53090832",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:25",
        "brokerTime": "2025-05-14 15:04:26",
        "commission": -57.96,
        "swap": 0,
        "profit": -49.68,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053917",
        "positionId": "56053916",
        "volume": 8.28,
        "price": 3221.83,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -107.64,
        "priceIn": 3221.77,
        "doubleCheck": true
    },
    {
        "dataID": "117264",
        "id": "53090833",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:26",
        "brokerTime": "2025-05-14 15:04:26",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053918",
        "positionId": "56053918",
        "volume": 8.28,
        "price": 3221.62,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3221.62,
        "doubleCheck": true
    },
    {
        "dataID": "117265",
        "id": "53090834",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:26",
        "brokerTime": "2025-05-14 15:04:26",
        "commission": -57.96,
        "swap": 0,
        "profit": -140.76,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053919",
        "positionId": "56053918",
        "volume": 8.28,
        "price": 3221.79,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -198.72,
        "priceIn": 3221.62,
        "doubleCheck": true
    },
    {
        "dataID": "117266",
        "id": "53090835",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:27",
        "brokerTime": "2025-05-14 15:04:27",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053920",
        "positionId": "56053920",
        "volume": 8.28,
        "price": 3221.61,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3221.61,
        "doubleCheck": true
    },
    {
        "dataID": "117267",
        "id": "53090837",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:27",
        "brokerTime": "2025-05-14 15:04:27",
        "commission": -57.96,
        "swap": 0,
        "profit": -190.44,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053922",
        "positionId": "56053920",
        "volume": 8.28,
        "price": 3221.84,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -248.4,
        "priceIn": 3221.61,
        "doubleCheck": true
    },
    {
        "dataID": "117268",
        "id": "53090838",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:28",
        "brokerTime": "2025-05-14 15:04:28",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053923",
        "positionId": "56053923",
        "volume": 8.28,
        "price": 3221.67,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3221.67,
        "doubleCheck": true
    },
    {
        "dataID": "117269",
        "id": "53090839",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:28",
        "brokerTime": "2025-05-14 15:04:29",
        "commission": -57.96,
        "swap": 0,
        "profit": -223.56,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053924",
        "positionId": "56053923",
        "volume": 8.28,
        "price": 3221.94,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -281.52,
        "priceIn": 3221.67,
        "doubleCheck": true
    },
    {
        "dataID": "117270",
        "id": "53090840",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:30",
        "brokerTime": "2025-05-14 15:04:30",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053925",
        "positionId": "56053925",
        "volume": 8.28,
        "price": 3221.78,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3221.78,
        "doubleCheck": true
    },
    {
        "dataID": "117271",
        "id": "53090841",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:30",
        "brokerTime": "2025-05-14 15:04:30",
        "commission": -57.96,
        "swap": 0,
        "profit": -132.48,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053926",
        "positionId": "56053925",
        "volume": 8.28,
        "price": 3221.94,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -190.44,
        "priceIn": 3221.78,
        "doubleCheck": true
    },
    {
        "dataID": "117272",
        "id": "53090842",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:30",
        "brokerTime": "2025-05-14 15:04:30",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053927",
        "positionId": "56053927",
        "volume": 8.28,
        "price": 3221.74,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3221.74,
        "doubleCheck": true
    },
    {
        "dataID": "117273",
        "id": "53090843",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:30",
        "brokerTime": "2025-05-14 15:04:31",
        "commission": -57.96,
        "swap": 0,
        "profit": -132.48,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053928",
        "positionId": "56053927",
        "volume": 8.28,
        "price": 3221.9,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -190.44,
        "priceIn": 3221.74,
        "doubleCheck": true
    },
    {
        "dataID": "117274",
        "id": "53090844",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:31",
        "brokerTime": "2025-05-14 15:04:31",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053929",
        "positionId": "56053929",
        "volume": 8.28,
        "price": 3221.73,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3221.73,
        "doubleCheck": true
    },
    {
        "dataID": "117275",
        "id": "53090845",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:31",
        "brokerTime": "2025-05-14 15:04:32",
        "commission": -57.96,
        "swap": 0,
        "profit": -74.52,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053930",
        "positionId": "56053929",
        "volume": 8.28,
        "price": 3221.82,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -132.48,
        "priceIn": 3221.73,
        "doubleCheck": true
    },
    {
        "dataID": "117276",
        "id": "53090846",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:32",
        "brokerTime": "2025-05-14 15:04:32",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053931",
        "positionId": "56053931",
        "volume": 8.28,
        "price": 3221.64,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3221.64,
        "doubleCheck": true
    },
    {
        "dataID": "117277",
        "id": "53090847",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:32",
        "brokerTime": "2025-05-14 15:04:33",
        "commission": -57.96,
        "swap": 0,
        "profit": -107.64,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053932",
        "positionId": "56053931",
        "volume": 8.28,
        "price": 3221.77,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -165.6,
        "priceIn": 3221.64,
        "doubleCheck": true
    },
    {
        "dataID": "117278",
        "id": "53090849",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:35",
        "brokerTime": "2025-05-14 15:04:35",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053934",
        "positionId": "56053934",
        "volume": 8.28,
        "price": 3221.76,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3221.76,
        "doubleCheck": true
    },
    {
        "dataID": "117279",
        "id": "53090850",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:35",
        "brokerTime": "2025-05-14 15:04:35",
        "commission": -57.96,
        "swap": 0,
        "profit": -157.32,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053935",
        "positionId": "56053934",
        "volume": 8.28,
        "price": 3221.95,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -215.28,
        "priceIn": 3221.76,
        "doubleCheck": true
    },
    {
        "dataID": "117280",
        "id": "53090851",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:35",
        "brokerTime": "2025-05-14 15:04:35",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053936",
        "positionId": "56053936",
        "volume": 8.28,
        "price": 3221.69,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3221.69,
        "doubleCheck": true
    },
    {
        "dataID": "117281",
        "id": "53090852",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:35",
        "brokerTime": "2025-05-14 15:04:35",
        "commission": -57.96,
        "swap": 0,
        "profit": -140.76,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053937",
        "positionId": "56053936",
        "volume": 8.28,
        "price": 3221.86,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -198.72,
        "priceIn": 3221.69,
        "doubleCheck": true
    },
    {
        "dataID": "117282",
        "id": "53090853",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:36",
        "brokerTime": "2025-05-14 15:04:36",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053938",
        "positionId": "56053938",
        "volume": 8.28,
        "price": 3221.68,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3221.68,
        "doubleCheck": true
    },
    {
        "dataID": "117283",
        "id": "53090854",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:36",
        "brokerTime": "2025-05-14 15:04:37",
        "commission": -57.96,
        "swap": 0,
        "profit": 57.96,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053939",
        "positionId": "56053938",
        "volume": 8.28,
        "price": 3221.61,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 0,
        "priceIn": 3221.68,
        "doubleCheck": true
    },
    {
        "dataID": "117284",
        "id": "53090855",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:37",
        "brokerTime": "2025-05-14 15:04:37",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053940",
        "positionId": "56053940",
        "volume": 8.28,
        "price": 3221.48,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3221.48,
        "doubleCheck": true
    },
    {
        "dataID": "117285",
        "id": "53090856",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:37",
        "brokerTime": "2025-05-14 15:04:38",
        "commission": -57.96,
        "swap": 0,
        "profit": -190.44,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053941",
        "positionId": "56053940",
        "volume": 8.28,
        "price": 3221.71,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -248.4,
        "priceIn": 3221.48,
        "doubleCheck": true
    },
    {
        "dataID": "117286",
        "id": "53090857",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:38",
        "brokerTime": "2025-05-14 15:04:38",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053942",
        "positionId": "56053942",
        "volume": 8.28,
        "price": 3221.56,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3221.56,
        "doubleCheck": true
    },
    {
        "dataID": "117287",
        "id": "53090859",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:38",
        "brokerTime": "2025-05-14 15:04:38",
        "commission": -57.96,
        "swap": 0,
        "profit": -107.64,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053944",
        "positionId": "56053942",
        "volume": 8.28,
        "price": 3221.69,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -165.6,
        "priceIn": 3221.56,
        "doubleCheck": true
    },
    {
        "dataID": "117288",
        "id": "53090866",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:40",
        "brokerTime": "2025-05-14 15:04:40",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053951",
        "positionId": "56053951",
        "volume": 8.28,
        "price": 3221.5,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3221.5,
        "doubleCheck": true
    },
    {
        "dataID": "117289",
        "id": "53090869",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:40",
        "brokerTime": "2025-05-14 15:04:41",
        "commission": -57.96,
        "swap": 0,
        "profit": -149.04,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053954",
        "positionId": "56053951",
        "volume": 8.28,
        "price": 3221.68,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -207,
        "priceIn": 3221.5,
        "doubleCheck": true
    },
    {
        "dataID": "117290",
        "id": "53090870",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:41",
        "brokerTime": "2025-05-14 15:04:41",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053955",
        "positionId": "56053955",
        "volume": 8.28,
        "price": 3221.51,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3221.51,
        "doubleCheck": true
    },
    {
        "dataID": "117291",
        "id": "53090872",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:41",
        "brokerTime": "2025-05-14 15:04:41",
        "commission": -57.96,
        "swap": 0,
        "profit": -149.04,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053957",
        "positionId": "56053955",
        "volume": 8.28,
        "price": 3221.69,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -207,
        "priceIn": 3221.51,
        "doubleCheck": true
    },
    {
        "dataID": "117292",
        "id": "53090874",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:42",
        "brokerTime": "2025-05-14 15:04:42",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053959",
        "positionId": "56053959",
        "volume": 8.28,
        "price": 3221.49,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3221.49,
        "doubleCheck": true
    },
    {
        "dataID": "117293",
        "id": "53090875",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:42",
        "brokerTime": "2025-05-14 15:04:42",
        "commission": -57.96,
        "swap": 0,
        "profit": -157.32,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053960",
        "positionId": "56053959",
        "volume": 8.28,
        "price": 3221.68,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -215.28,
        "priceIn": 3221.49,
        "doubleCheck": true
    },
    {
        "dataID": "117294",
        "id": "53090876",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:43",
        "brokerTime": "2025-05-14 15:04:43",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053961",
        "positionId": "56053961",
        "volume": 8.28,
        "price": 3221.5,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3221.5,
        "doubleCheck": true
    },
    {
        "dataID": "117295",
        "id": "53090877",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:43",
        "brokerTime": "2025-05-14 15:04:43",
        "commission": -57.96,
        "swap": 0,
        "profit": -132.48,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053962",
        "positionId": "56053961",
        "volume": 8.28,
        "price": 3221.66,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -190.44,
        "priceIn": 3221.5,
        "doubleCheck": true
    },
    {
        "dataID": "117296",
        "id": "53090878",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:43",
        "brokerTime": "2025-05-14 15:04:43",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053963",
        "positionId": "56053963",
        "volume": 8.28,
        "price": 3221.4,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3221.4,
        "doubleCheck": true
    },
    {
        "dataID": "117297",
        "id": "53090879",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:43",
        "brokerTime": "2025-05-14 15:04:44",
        "commission": -57.96,
        "swap": 0,
        "profit": -182.16,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053964",
        "positionId": "56053963",
        "volume": 8.28,
        "price": 3221.62,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -240.12,
        "priceIn": 3221.4,
        "doubleCheck": true
    },
    {
        "dataID": "117298",
        "id": "53090880",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:44",
        "brokerTime": "2025-05-14 15:04:44",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053965",
        "positionId": "56053965",
        "volume": 8.28,
        "price": 3221.42,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3221.42,
        "doubleCheck": true
    },
    {
        "dataID": "117299",
        "id": "53090881",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:44",
        "brokerTime": "2025-05-14 15:04:45",
        "commission": -57.96,
        "swap": 0,
        "profit": -165.6,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053966",
        "positionId": "56053965",
        "volume": 8.28,
        "price": 3221.62,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -223.56,
        "priceIn": 3221.42,
        "doubleCheck": true
    },
    {
        "dataID": "117300",
        "id": "53090882",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:45",
        "brokerTime": "2025-05-14 15:04:45",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053967",
        "positionId": "56053967",
        "volume": 8.28,
        "price": 3221.46,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3221.46,
        "doubleCheck": true
    },
    {
        "dataID": "117301",
        "id": "53090883",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:45",
        "brokerTime": "2025-05-14 15:04:46",
        "commission": -57.96,
        "swap": 0,
        "profit": -140.76,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053968",
        "positionId": "56053967",
        "volume": 8.28,
        "price": 3221.63,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -198.72,
        "priceIn": 3221.46,
        "doubleCheck": true
    },
    {
        "dataID": "117302",
        "id": "53090884",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:47",
        "brokerTime": "2025-05-14 15:04:47",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053969",
        "positionId": "56053969",
        "volume": 8.28,
        "price": 3221.43,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3221.43,
        "doubleCheck": true
    },
    {
        "dataID": "117303",
        "id": "53090885",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:47",
        "brokerTime": "2025-05-14 15:04:47",
        "commission": -57.96,
        "swap": 0,
        "profit": -140.76,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053970",
        "positionId": "56053969",
        "volume": 8.28,
        "price": 3221.6,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -198.72,
        "priceIn": 3221.43,
        "doubleCheck": true
    },
    {
        "dataID": "117304",
        "id": "53090886",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:48",
        "brokerTime": "2025-05-14 15:04:48",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053971",
        "positionId": "56053971",
        "volume": 8.28,
        "price": 3221.44,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3221.44,
        "doubleCheck": true
    },
    {
        "dataID": "117305",
        "id": "53090887",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:48",
        "brokerTime": "2025-05-14 15:04:49",
        "commission": -57.96,
        "swap": 0,
        "profit": -99.36,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053972",
        "positionId": "56053971",
        "volume": 8.28,
        "price": 3221.56,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -157.32,
        "priceIn": 3221.44,
        "doubleCheck": true
    },
    {
        "dataID": "117306",
        "id": "53090888",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:49",
        "brokerTime": "2025-05-14 15:04:49",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053973",
        "positionId": "56053973",
        "volume": 8.28,
        "price": 3221.4,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3221.4,
        "doubleCheck": true
    },
    {
        "dataID": "117307",
        "id": "53090891",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:49",
        "brokerTime": "2025-05-14 15:04:50",
        "commission": -57.96,
        "swap": 0,
        "profit": -149.04,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053976",
        "positionId": "56053973",
        "volume": 8.28,
        "price": 3221.58,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -207,
        "priceIn": 3221.4,
        "doubleCheck": true
    },
    {
        "dataID": "117308",
        "id": "53090892",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:50",
        "brokerTime": "2025-05-14 15:04:50",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053977",
        "positionId": "56053977",
        "volume": 8.28,
        "price": 3221.39,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3221.39,
        "doubleCheck": true
    },
    {
        "dataID": "117309",
        "id": "53090893",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:50",
        "brokerTime": "2025-05-14 15:04:51",
        "commission": -57.96,
        "swap": 0,
        "profit": -223.56,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053978",
        "positionId": "56053977",
        "volume": 8.28,
        "price": 3221.66,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -281.52,
        "priceIn": 3221.39,
        "doubleCheck": true
    },
    {
        "dataID": "117310",
        "id": "53090894",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:51",
        "brokerTime": "2025-05-14 15:04:51",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053979",
        "positionId": "56053979",
        "volume": 8.28,
        "price": 3221.46,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3221.46,
        "doubleCheck": true
    },
    {
        "dataID": "117311",
        "id": "53090897",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:51",
        "brokerTime": "2025-05-14 15:04:52",
        "commission": -57.96,
        "swap": 0,
        "profit": -99.36,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053982",
        "positionId": "56053979",
        "volume": 8.28,
        "price": 3221.58,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -157.32,
        "priceIn": 3221.46,
        "doubleCheck": true
    },
    {
        "dataID": "117312",
        "id": "53090898",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:53",
        "brokerTime": "2025-05-14 15:04:53",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053983",
        "positionId": "56053983",
        "volume": 8.28,
        "price": 3221.41,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3221.41,
        "doubleCheck": true
    },
    {
        "dataID": "117313",
        "id": "53090899",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:53",
        "brokerTime": "2025-05-14 15:04:54",
        "commission": -57.96,
        "swap": 0,
        "profit": -99.36,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053984",
        "positionId": "56053983",
        "volume": 8.28,
        "price": 3221.53,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -157.32,
        "priceIn": 3221.41,
        "doubleCheck": true
    },
    {
        "dataID": "117314",
        "id": "53090900",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:54",
        "brokerTime": "2025-05-14 15:04:54",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053985",
        "positionId": "56053985",
        "volume": 8.28,
        "price": 3221.37,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3221.37,
        "doubleCheck": true
    },
    {
        "dataID": "117315",
        "id": "53090902",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:54",
        "brokerTime": "2025-05-14 15:04:55",
        "commission": -57.96,
        "swap": 0,
        "profit": 41.4,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053987",
        "positionId": "56053985",
        "volume": 8.28,
        "price": 3221.32,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -16.560000000000002,
        "priceIn": 3221.37,
        "doubleCheck": true
    },
    {
        "dataID": "117316",
        "id": "53090903",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:56",
        "brokerTime": "2025-05-14 15:04:56",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053988",
        "positionId": "56053988",
        "volume": 8.28,
        "price": 3220.66,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3220.66,
        "doubleCheck": true
    },
    {
        "dataID": "117317",
        "id": "53090904",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:56",
        "brokerTime": "2025-05-14 15:04:56",
        "commission": -57.96,
        "swap": 0,
        "profit": -107.64,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053989",
        "positionId": "56053988",
        "volume": 8.28,
        "price": 3220.79,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -165.6,
        "priceIn": 3220.66,
        "doubleCheck": true
    },
    {
        "dataID": "117318",
        "id": "53090907",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:56",
        "brokerTime": "2025-05-14 15:04:56",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053992",
        "positionId": "56053992",
        "volume": 8.28,
        "price": 3220.54,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3220.54,
        "doubleCheck": true
    },
    {
        "dataID": "117319",
        "id": "53090908",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:56",
        "brokerTime": "2025-05-14 15:04:57",
        "commission": -57.96,
        "swap": 0,
        "profit": -82.8,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053993",
        "positionId": "56053992",
        "volume": 8.28,
        "price": 3220.64,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -140.76,
        "priceIn": 3220.54,
        "doubleCheck": true
    },
    {
        "dataID": "117320",
        "id": "53090909",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:57",
        "brokerTime": "2025-05-14 15:04:57",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053994",
        "positionId": "56053994",
        "volume": 8.28,
        "price": 3220.46,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3220.46,
        "doubleCheck": true
    },
    {
        "dataID": "117321",
        "id": "53090910",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:57",
        "brokerTime": "2025-05-14 15:04:58",
        "commission": -57.96,
        "swap": 0,
        "profit": -314.64,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053995",
        "positionId": "56053994",
        "volume": 8.28,
        "price": 3220.84,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -372.59999999999997,
        "priceIn": 3220.46,
        "doubleCheck": true
    },
    {
        "dataID": "117322",
        "id": "53090911",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:58",
        "brokerTime": "2025-05-14 15:04:58",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053996",
        "positionId": "56053996",
        "volume": 8.28,
        "price": 3220.66,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3220.66,
        "doubleCheck": true
    },
    {
        "dataID": "117323",
        "id": "53090912",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:58",
        "brokerTime": "2025-05-14 15:04:59",
        "commission": -57.96,
        "swap": 0,
        "profit": -289.8,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053997",
        "positionId": "56053996",
        "volume": 8.28,
        "price": 3221.01,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -347.76,
        "priceIn": 3220.66,
        "doubleCheck": true
    },
    {
        "dataID": "117324",
        "id": "53090913",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:59",
        "brokerTime": "2025-05-14 15:04:59",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56053998",
        "positionId": "56053998",
        "volume": 8.28,
        "price": 3220.82,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3220.82,
        "doubleCheck": true
    },
    {
        "dataID": "117325",
        "id": "53090918",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:59",
        "brokerTime": "2025-05-14 15:04:59",
        "commission": -57.96,
        "swap": 0,
        "profit": -165.6,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054003",
        "positionId": "56053998",
        "volume": 8.28,
        "price": 3221.02,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -223.56,
        "priceIn": 3220.82,
        "doubleCheck": true
    },
    {
        "dataID": "117326",
        "id": "53090919",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:00",
        "brokerTime": "2025-05-14 15:05:00",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054004",
        "positionId": "56054004",
        "volume": 8.28,
        "price": 3220.86,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3220.86,
        "doubleCheck": true
    },
    {
        "dataID": "117327",
        "id": "53090921",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:00",
        "brokerTime": "2025-05-14 15:05:00",
        "commission": -57.96,
        "swap": 0,
        "profit": -231.84,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054007",
        "positionId": "56054004",
        "volume": 8.28,
        "price": 3221.14,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -289.8,
        "priceIn": 3220.86,
        "doubleCheck": true
    },
    {
        "dataID": "117328",
        "id": "53090925",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:01",
        "brokerTime": "2025-05-14 15:05:01",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054010",
        "positionId": "56054010",
        "volume": 8.28,
        "price": 3220.88,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3220.88,
        "doubleCheck": true
    },
    {
        "dataID": "117329",
        "id": "53090926",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:01",
        "brokerTime": "2025-05-14 15:05:01",
        "commission": -57.96,
        "swap": 0,
        "profit": -231.84,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054011",
        "positionId": "56054010",
        "volume": 8.28,
        "price": 3221.16,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -289.8,
        "priceIn": 3220.88,
        "doubleCheck": true
    },
    {
        "dataID": "117330",
        "id": "53090927",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:02",
        "brokerTime": "2025-05-14 15:05:02",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054012",
        "positionId": "56054012",
        "volume": 8.28,
        "price": 3220.97,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3220.97,
        "doubleCheck": true
    },
    {
        "dataID": "117331",
        "id": "53090928",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:02",
        "brokerTime": "2025-05-14 15:05:03",
        "commission": -57.96,
        "swap": 0,
        "profit": -165.6,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054014",
        "positionId": "56054012",
        "volume": 8.28,
        "price": 3221.17,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -223.56,
        "priceIn": 3220.97,
        "doubleCheck": true
    },
    {
        "dataID": "117332",
        "id": "53090929",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:03",
        "brokerTime": "2025-05-14 15:05:03",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054015",
        "positionId": "56054015",
        "volume": 8.28,
        "price": 3221.17,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3221.17,
        "doubleCheck": true
    },
    {
        "dataID": "117333",
        "id": "53090930",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:03",
        "brokerTime": "2025-05-14 15:05:04",
        "commission": -57.96,
        "swap": 0,
        "profit": -223.56,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054016",
        "positionId": "56054015",
        "volume": 8.28,
        "price": 3221.44,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -281.52,
        "priceIn": 3221.17,
        "doubleCheck": true
    },
    {
        "dataID": "117334",
        "id": "53090931",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:04",
        "brokerTime": "2025-05-14 15:05:04",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054017",
        "positionId": "56054017",
        "volume": 8.28,
        "price": 3221.23,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3221.23,
        "doubleCheck": true
    },
    {
        "dataID": "117335",
        "id": "53090932",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:04",
        "brokerTime": "2025-05-14 15:05:04",
        "commission": -57.96,
        "swap": 0,
        "profit": -182.16,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054018",
        "positionId": "56054017",
        "volume": 8.28,
        "price": 3221.45,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -240.12,
        "priceIn": 3221.23,
        "doubleCheck": true
    },
    {
        "dataID": "117336",
        "id": "53090934",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:05",
        "brokerTime": "2025-05-14 15:05:05",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054020",
        "positionId": "56054020",
        "volume": 8.28,
        "price": 3221.25,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3221.25,
        "doubleCheck": true
    },
    {
        "dataID": "117337",
        "id": "53090935",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:05",
        "brokerTime": "2025-05-14 15:05:05",
        "commission": -57.96,
        "swap": 0,
        "profit": -99.36,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054021",
        "positionId": "56054020",
        "volume": 8.28,
        "price": 3221.37,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -157.32,
        "priceIn": 3221.25,
        "doubleCheck": true
    },
    {
        "dataID": "117338",
        "id": "53090936",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:06",
        "brokerTime": "2025-05-14 15:05:06",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054022",
        "positionId": "56054022",
        "volume": 8.28,
        "price": 3221.3,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3221.3,
        "doubleCheck": true
    },
    {
        "dataID": "117339",
        "id": "53090937",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:06",
        "brokerTime": "2025-05-14 15:05:06",
        "commission": -57.96,
        "swap": 0,
        "profit": -140.76,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054023",
        "positionId": "56054022",
        "volume": 8.28,
        "price": 3221.47,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -198.72,
        "priceIn": 3221.3,
        "doubleCheck": true
    },
    {
        "dataID": "117340",
        "id": "53090940",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:06",
        "brokerTime": "2025-05-14 15:05:06",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054026",
        "positionId": "56054026",
        "volume": 8.28,
        "price": 3221.34,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3221.34,
        "doubleCheck": true
    },
    {
        "dataID": "117341",
        "id": "53090941",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:06",
        "brokerTime": "2025-05-14 15:05:07",
        "commission": -57.96,
        "swap": 0,
        "profit": -91.08,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054027",
        "positionId": "56054026",
        "volume": 8.28,
        "price": 3221.45,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -149.04,
        "priceIn": 3221.34,
        "doubleCheck": true
    },
    {
        "dataID": "117342",
        "id": "53090942",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:07",
        "brokerTime": "2025-05-14 15:05:07",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054028",
        "positionId": "56054028",
        "volume": 8.28,
        "price": 3221.16,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3221.16,
        "doubleCheck": true
    },
    {
        "dataID": "117343",
        "id": "53090943",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:07",
        "brokerTime": "2025-05-14 15:05:08",
        "commission": -57.96,
        "swap": 0,
        "profit": -33.12,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054029",
        "positionId": "56054028",
        "volume": 8.28,
        "price": 3221.2,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -91.08,
        "priceIn": 3221.16,
        "doubleCheck": true
    },
    {
        "dataID": "117344",
        "id": "53090944",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:08",
        "brokerTime": "2025-05-14 15:05:08",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054030",
        "positionId": "56054030",
        "volume": 8.28,
        "price": 3220.99,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3220.99,
        "doubleCheck": true
    },
    {
        "dataID": "117345",
        "id": "53090945",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:08",
        "brokerTime": "2025-05-14 15:05:09",
        "commission": -57.96,
        "swap": 0,
        "profit": -182.16,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054031",
        "positionId": "56054030",
        "volume": 8.28,
        "price": 3221.21,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -240.12,
        "priceIn": 3220.99,
        "doubleCheck": true
    },
    {
        "dataID": "117346",
        "id": "53090946",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:09",
        "brokerTime": "2025-05-14 15:05:09",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054032",
        "positionId": "56054032",
        "volume": 8.28,
        "price": 3220.87,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3220.87,
        "doubleCheck": true
    },
    {
        "dataID": "117347",
        "id": "53090947",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:09",
        "brokerTime": "2025-05-14 15:05:10",
        "commission": -57.96,
        "swap": 0,
        "profit": -99.36,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054033",
        "positionId": "56054032",
        "volume": 8.28,
        "price": 3220.99,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -157.32,
        "priceIn": 3220.87,
        "doubleCheck": true
    },
    {
        "dataID": "117348",
        "id": "53090948",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:11",
        "brokerTime": "2025-05-14 15:05:11",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054034",
        "positionId": "56054034",
        "volume": 8.28,
        "price": 3220.79,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3220.79,
        "doubleCheck": true
    },
    {
        "dataID": "117349",
        "id": "53090949",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:11",
        "brokerTime": "2025-05-14 15:05:12",
        "commission": -57.96,
        "swap": 0,
        "profit": -140.76,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054035",
        "positionId": "56054034",
        "volume": 8.28,
        "price": 3220.96,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -198.72,
        "priceIn": 3220.79,
        "doubleCheck": true
    },
    {
        "dataID": "117350",
        "id": "53090950",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:13",
        "brokerTime": "2025-05-14 15:05:13",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054036",
        "positionId": "56054036",
        "volume": 8.28,
        "price": 3221.2,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3221.2,
        "doubleCheck": true
    },
    {
        "dataID": "117351",
        "id": "53090951",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:13",
        "brokerTime": "2025-05-14 15:05:13",
        "commission": -57.96,
        "swap": 0,
        "profit": -66.24,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054037",
        "positionId": "56054036",
        "volume": 8.28,
        "price": 3221.28,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -124.19999999999999,
        "priceIn": 3221.2,
        "doubleCheck": true
    },
    {
        "dataID": "117352",
        "id": "53090952",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:14",
        "brokerTime": "2025-05-14 15:05:14",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054038",
        "positionId": "56054038",
        "volume": 8.28,
        "price": 3220.81,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3220.81,
        "doubleCheck": true
    },
    {
        "dataID": "117353",
        "id": "53090953",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:14",
        "brokerTime": "2025-05-14 15:05:14",
        "commission": -57.96,
        "swap": 0,
        "profit": -157.32,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054039",
        "positionId": "56054038",
        "volume": 8.28,
        "price": 3221,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -215.28,
        "priceIn": 3220.81,
        "doubleCheck": true
    },
    {
        "dataID": "117354",
        "id": "53090954",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:15",
        "brokerTime": "2025-05-14 15:05:15",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054040",
        "positionId": "56054040",
        "volume": 8.28,
        "price": 3220.79,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3220.79,
        "doubleCheck": true
    },
    {
        "dataID": "117355",
        "id": "53090955",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:15",
        "brokerTime": "2025-05-14 15:05:15",
        "commission": -57.96,
        "swap": 0,
        "profit": 356.04,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054041",
        "positionId": "56054040",
        "volume": 8.28,
        "price": 3220.36,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 298.08000000000004,
        "priceIn": 3220.79,
        "doubleCheck": true
    },
    {
        "dataID": "117356",
        "id": "53090956",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:15",
        "brokerTime": "2025-05-14 15:05:15",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054042",
        "positionId": "56054042",
        "volume": 8.28,
        "price": 3219.99,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3219.99,
        "doubleCheck": true
    },
    {
        "dataID": "117357",
        "id": "53090957",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:15",
        "brokerTime": "2025-05-14 15:05:16",
        "commission": -57.96,
        "swap": 0,
        "profit": -165.6,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054043",
        "positionId": "56054042",
        "volume": 8.28,
        "price": 3220.19,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -223.56,
        "priceIn": 3219.99,
        "doubleCheck": true
    },
    {
        "dataID": "117358",
        "id": "53090959",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:16",
        "brokerTime": "2025-05-14 15:05:16",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054045",
        "positionId": "56054045",
        "volume": 8.28,
        "price": 3220.17,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3220.17,
        "doubleCheck": true
    },
    {
        "dataID": "117359",
        "id": "53090960",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:16",
        "brokerTime": "2025-05-14 15:05:17",
        "commission": -57.96,
        "swap": 0,
        "profit": -587.88,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054046",
        "positionId": "56054045",
        "volume": 8.28,
        "price": 3220.88,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -645.84,
        "priceIn": 3220.17,
        "doubleCheck": true
    },
    {
        "dataID": "117360",
        "id": "53090961",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:18",
        "brokerTime": "2025-05-14 15:05:18",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054047",
        "positionId": "56054047",
        "volume": 8.28,
        "price": 3220.7,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3220.7,
        "doubleCheck": true
    },
    {
        "dataID": "117361",
        "id": "53090962",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:18",
        "brokerTime": "2025-05-14 15:05:19",
        "commission": -57.96,
        "swap": 0,
        "profit": -49.68,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054048",
        "positionId": "56054047",
        "volume": 8.28,
        "price": 3220.76,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -107.64,
        "priceIn": 3220.7,
        "doubleCheck": true
    },
    {
        "dataID": "117362",
        "id": "53090963",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:19",
        "brokerTime": "2025-05-14 15:05:19",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054049",
        "positionId": "56054049",
        "volume": 8.28,
        "price": 3220.55,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3220.55,
        "doubleCheck": true
    },
    {
        "dataID": "117363",
        "id": "53090964",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:19",
        "brokerTime": "2025-05-14 15:05:20",
        "commission": -57.96,
        "swap": 0,
        "profit": -115.92,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054050",
        "positionId": "56054049",
        "volume": 8.28,
        "price": 3220.69,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -173.88,
        "priceIn": 3220.55,
        "doubleCheck": true
    },
    {
        "dataID": "117364",
        "id": "53090965",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:20",
        "brokerTime": "2025-05-14 15:05:20",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054051",
        "positionId": "56054051",
        "volume": 8.28,
        "price": 3220.53,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3220.53,
        "doubleCheck": true
    },
    {
        "dataID": "117365",
        "id": "53090966",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:20",
        "brokerTime": "2025-05-14 15:05:21",
        "commission": -57.96,
        "swap": 0,
        "profit": -223.56,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054052",
        "positionId": "56054051",
        "volume": 8.28,
        "price": 3220.8,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -281.52,
        "priceIn": 3220.53,
        "doubleCheck": true
    },
    {
        "dataID": "117366",
        "id": "53090967",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:21",
        "brokerTime": "2025-05-14 15:05:21",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054053",
        "positionId": "56054053",
        "volume": 8.28,
        "price": 3220.54,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3220.54,
        "doubleCheck": true
    },
    {
        "dataID": "117367",
        "id": "53090968",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:21",
        "brokerTime": "2025-05-14 15:05:21",
        "commission": -57.96,
        "swap": 0,
        "profit": -173.88,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054054",
        "positionId": "56054053",
        "volume": 8.28,
        "price": 3220.75,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -231.84,
        "priceIn": 3220.54,
        "doubleCheck": true
    },
    {
        "dataID": "117368",
        "id": "53090969",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:22",
        "brokerTime": "2025-05-14 15:05:22",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054055",
        "positionId": "56054055",
        "volume": 8.28,
        "price": 3220.57,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3220.57,
        "doubleCheck": true
    },
    {
        "dataID": "117369",
        "id": "53090970",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:22",
        "brokerTime": "2025-05-14 15:05:22",
        "commission": -57.96,
        "swap": 0,
        "profit": -149.04,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054056",
        "positionId": "56054055",
        "volume": 8.28,
        "price": 3220.75,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -207,
        "priceIn": 3220.57,
        "doubleCheck": true
    },
    {
        "dataID": "117370",
        "id": "53090971",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:23",
        "brokerTime": "2025-05-14 15:05:23",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054057",
        "positionId": "56054057",
        "volume": 8.28,
        "price": 3220.58,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3220.58,
        "doubleCheck": true
    },
    {
        "dataID": "117371",
        "id": "53090972",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:23",
        "brokerTime": "2025-05-14 15:05:23",
        "commission": -57.96,
        "swap": 0,
        "profit": -198.72,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054058",
        "positionId": "56054057",
        "volume": 8.28,
        "price": 3220.82,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -256.68,
        "priceIn": 3220.58,
        "doubleCheck": true
    },
    {
        "dataID": "117372",
        "id": "53090973",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:24",
        "brokerTime": "2025-05-14 15:05:24",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054059",
        "positionId": "56054059",
        "volume": 8.28,
        "price": 3220.64,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3220.64,
        "doubleCheck": true
    },
    {
        "dataID": "117373",
        "id": "53090974",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:24",
        "brokerTime": "2025-05-14 15:05:25",
        "commission": -57.96,
        "swap": 0,
        "profit": -49.68,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054060",
        "positionId": "56054059",
        "volume": 8.28,
        "price": 3220.7,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -107.64,
        "priceIn": 3220.64,
        "doubleCheck": true
    },
    {
        "dataID": "117374",
        "id": "53090975",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:25",
        "brokerTime": "2025-05-14 15:05:25",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054061",
        "positionId": "56054061",
        "volume": 8.28,
        "price": 3220.57,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3220.57,
        "doubleCheck": true
    },
    {
        "dataID": "117375",
        "id": "53090976",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:25",
        "brokerTime": "2025-05-14 15:05:26",
        "commission": -57.96,
        "swap": 0,
        "profit": -223.56,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054062",
        "positionId": "56054061",
        "volume": 8.28,
        "price": 3220.84,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -281.52,
        "priceIn": 3220.57,
        "doubleCheck": true
    },
    {
        "dataID": "117376",
        "id": "53090977",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:26",
        "brokerTime": "2025-05-14 15:05:26",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054063",
        "positionId": "56054063",
        "volume": 8.28,
        "price": 3220.67,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3220.67,
        "doubleCheck": true
    },
    {
        "dataID": "117377",
        "id": "53090978",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:26",
        "brokerTime": "2025-05-14 15:05:26",
        "commission": -57.96,
        "swap": 0,
        "profit": -132.48,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054064",
        "positionId": "56054063",
        "volume": 8.28,
        "price": 3220.83,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -190.44,
        "priceIn": 3220.67,
        "doubleCheck": true
    },
    {
        "dataID": "117378",
        "id": "53090979",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:27",
        "brokerTime": "2025-05-14 15:05:27",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054065",
        "positionId": "56054065",
        "volume": 8.28,
        "price": 3220.65,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3220.65,
        "doubleCheck": true
    },
    {
        "dataID": "117379",
        "id": "53090980",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:27",
        "brokerTime": "2025-05-14 15:05:28",
        "commission": -57.96,
        "swap": 0,
        "profit": -49.68,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054066",
        "positionId": "56054065",
        "volume": 8.28,
        "price": 3220.71,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -107.64,
        "priceIn": 3220.65,
        "doubleCheck": true
    },
    {
        "dataID": "117380",
        "id": "53090981",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:28",
        "brokerTime": "2025-05-14 15:05:28",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054067",
        "positionId": "56054067",
        "volume": 8.28,
        "price": 3220.51,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3220.51,
        "doubleCheck": true
    },
    {
        "dataID": "117381",
        "id": "53090982",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:28",
        "brokerTime": "2025-05-14 15:05:28",
        "commission": -57.96,
        "swap": 0,
        "profit": -124.2,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054068",
        "positionId": "56054067",
        "volume": 8.28,
        "price": 3220.66,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -182.16,
        "priceIn": 3220.51,
        "doubleCheck": true
    },
    {
        "dataID": "117382",
        "id": "53090983",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:29",
        "brokerTime": "2025-05-14 15:05:29",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054069",
        "positionId": "56054069",
        "volume": 8.28,
        "price": 3220.45,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3220.45,
        "doubleCheck": true
    },
    {
        "dataID": "117383",
        "id": "53090984",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:29",
        "brokerTime": "2025-05-14 15:05:30",
        "commission": -57.96,
        "swap": 0,
        "profit": -182.16,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054070",
        "positionId": "56054069",
        "volume": 8.28,
        "price": 3220.67,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -240.12,
        "priceIn": 3220.45,
        "doubleCheck": true
    },
    {
        "dataID": "117384",
        "id": "53090985",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:30",
        "brokerTime": "2025-05-14 15:05:30",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054071",
        "positionId": "56054071",
        "volume": 8.28,
        "price": 3220.45,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3220.45,
        "doubleCheck": true
    },
    {
        "dataID": "117385",
        "id": "53090986",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:30",
        "brokerTime": "2025-05-14 15:05:31",
        "commission": -57.96,
        "swap": 0,
        "profit": 298.08,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054072",
        "positionId": "56054071",
        "volume": 8.28,
        "price": 3220.09,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 240.11999999999998,
        "priceIn": 3220.45,
        "doubleCheck": true
    },
    {
        "dataID": "117386",
        "id": "53090987",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:32",
        "brokerTime": "2025-05-14 15:05:32",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054073",
        "positionId": "56054073",
        "volume": 8.28,
        "price": 3219.83,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3219.83,
        "doubleCheck": true
    },
    {
        "dataID": "117387",
        "id": "53090988",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:32",
        "brokerTime": "2025-05-14 15:05:32",
        "commission": -57.96,
        "swap": 0,
        "profit": -149.04,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054074",
        "positionId": "56054073",
        "volume": 8.28,
        "price": 3220.01,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -207,
        "priceIn": 3219.83,
        "doubleCheck": true
    },
    {
        "dataID": "117388",
        "id": "53090991",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:33",
        "brokerTime": "2025-05-14 15:05:33",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054077",
        "positionId": "56054077",
        "volume": 8.28,
        "price": 3219.65,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3219.65,
        "doubleCheck": true
    },
    {
        "dataID": "117389",
        "id": "53090992",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:33",
        "brokerTime": "2025-05-14 15:05:33",
        "commission": -57.96,
        "swap": 0,
        "profit": -173.88,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054078",
        "positionId": "56054077",
        "volume": 8.28,
        "price": 3219.86,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -231.84,
        "priceIn": 3219.65,
        "doubleCheck": true
    },
    {
        "dataID": "117390",
        "id": "53090993",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:33",
        "brokerTime": "2025-05-14 15:05:33",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054079",
        "positionId": "56054079",
        "volume": 8.28,
        "price": 3219.66,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3219.66,
        "doubleCheck": true
    },
    {
        "dataID": "117391",
        "id": "53090995",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:33",
        "brokerTime": "2025-05-14 15:05:34",
        "commission": -57.96,
        "swap": 0,
        "profit": -149.04,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054081",
        "positionId": "56054079",
        "volume": 8.28,
        "price": 3219.84,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -207,
        "priceIn": 3219.66,
        "doubleCheck": true
    },
    {
        "dataID": "117392",
        "id": "53090996",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:34",
        "brokerTime": "2025-05-14 15:05:34",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054083",
        "positionId": "56054083",
        "volume": 8.28,
        "price": 3219.66,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3219.66,
        "doubleCheck": true
    },
    {
        "dataID": "117393",
        "id": "53090999",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:34",
        "brokerTime": "2025-05-14 15:05:35",
        "commission": -57.96,
        "swap": 0,
        "profit": -157.32,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054085",
        "positionId": "56054083",
        "volume": 8.28,
        "price": 3219.85,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -215.28,
        "priceIn": 3219.66,
        "doubleCheck": true
    },
    {
        "dataID": "117394",
        "id": "53091002",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:35",
        "brokerTime": "2025-05-14 15:05:35",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054088",
        "positionId": "56054088",
        "volume": 8.28,
        "price": 3219.55,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3219.55,
        "doubleCheck": true
    },
    {
        "dataID": "117395",
        "id": "53091004",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:35",
        "brokerTime": "2025-05-14 15:05:36",
        "commission": -57.96,
        "swap": 0,
        "profit": -248.4,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054089",
        "positionId": "56054088",
        "volume": 8.28,
        "price": 3219.85,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -306.36,
        "priceIn": 3219.55,
        "doubleCheck": true
    },
    {
        "dataID": "117396",
        "id": "53091005",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:36",
        "brokerTime": "2025-05-14 15:05:36",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054090",
        "positionId": "56054090",
        "volume": 8.28,
        "price": 3219.55,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3219.55,
        "doubleCheck": true
    },
    {
        "dataID": "117397",
        "id": "53091006",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:36",
        "brokerTime": "2025-05-14 15:05:37",
        "commission": -57.96,
        "swap": 0,
        "profit": -231.84,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054091",
        "positionId": "56054090",
        "volume": 8.28,
        "price": 3219.83,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -289.8,
        "priceIn": 3219.55,
        "doubleCheck": true
    },
    {
        "dataID": "117398",
        "id": "53091007",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:37",
        "brokerTime": "2025-05-14 15:05:37",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054092",
        "positionId": "56054092",
        "volume": 8.28,
        "price": 3219.63,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3219.63,
        "doubleCheck": true
    },
    {
        "dataID": "117399",
        "id": "53091008",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:37",
        "brokerTime": "2025-05-14 15:05:37",
        "commission": -57.96,
        "swap": 0,
        "profit": -107.64,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054093",
        "positionId": "56054092",
        "volume": 8.28,
        "price": 3219.76,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -165.6,
        "priceIn": 3219.63,
        "doubleCheck": true
    },
    {
        "dataID": "117400",
        "id": "53091009",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:38",
        "brokerTime": "2025-05-14 15:05:38",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054094",
        "positionId": "56054094",
        "volume": 8.28,
        "price": 3219.53,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3219.53,
        "doubleCheck": true
    },
    {
        "dataID": "117401",
        "id": "53091010",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:38",
        "brokerTime": "2025-05-14 15:05:39",
        "commission": -57.96,
        "swap": 0,
        "profit": -248.4,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054095",
        "positionId": "56054094",
        "volume": 8.28,
        "price": 3219.83,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -306.36,
        "priceIn": 3219.53,
        "doubleCheck": true
    },
    {
        "dataID": "117402",
        "id": "53091012",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:39",
        "brokerTime": "2025-05-14 15:05:39",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054097",
        "positionId": "56054097",
        "volume": 8.28,
        "price": 3219.84,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3219.84,
        "doubleCheck": true
    },
    {
        "dataID": "117403",
        "id": "53091014",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:39",
        "brokerTime": "2025-05-14 15:05:40",
        "commission": -57.96,
        "swap": 0,
        "profit": -115.92,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054099",
        "positionId": "56054097",
        "volume": 8.28,
        "price": 3219.98,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -173.88,
        "priceIn": 3219.84,
        "doubleCheck": true
    },
    {
        "dataID": "117404",
        "id": "53091016",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:40",
        "brokerTime": "2025-05-14 15:05:40",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054101",
        "positionId": "56054101",
        "volume": 8.28,
        "price": 3220.08,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3220.08,
        "doubleCheck": true
    },
    {
        "dataID": "117405",
        "id": "53091017",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:40",
        "brokerTime": "2025-05-14 15:05:41",
        "commission": -57.96,
        "swap": 0,
        "profit": -132.48,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054102",
        "positionId": "56054101",
        "volume": 8.28,
        "price": 3220.24,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -190.44,
        "priceIn": 3220.08,
        "doubleCheck": true
    },
    {
        "dataID": "117406",
        "id": "53091019",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:41",
        "brokerTime": "2025-05-14 15:05:41",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054104",
        "positionId": "56054104",
        "volume": 8.28,
        "price": 3220.17,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3220.17,
        "doubleCheck": true
    },
    {
        "dataID": "117407",
        "id": "53091020",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:41",
        "brokerTime": "2025-05-14 15:05:41",
        "commission": -57.96,
        "swap": 0,
        "profit": -99.36,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054105",
        "positionId": "56054104",
        "volume": 8.28,
        "price": 3220.29,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -157.32,
        "priceIn": 3220.17,
        "doubleCheck": true
    },
    {
        "dataID": "117408",
        "id": "53091021",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:42",
        "brokerTime": "2025-05-14 15:05:42",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054106",
        "positionId": "56054106",
        "volume": 8.28,
        "price": 3220.08,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3220.08,
        "doubleCheck": true
    },
    {
        "dataID": "117409",
        "id": "53091022",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:42",
        "brokerTime": "2025-05-14 15:05:42",
        "commission": -57.96,
        "swap": 0,
        "profit": -149.04,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054107",
        "positionId": "56054106",
        "volume": 8.28,
        "price": 3220.26,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -207,
        "priceIn": 3220.08,
        "doubleCheck": true
    },
    {
        "dataID": "117410",
        "id": "53091023",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:43",
        "brokerTime": "2025-05-14 15:05:43",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054108",
        "positionId": "56054108",
        "volume": 8.28,
        "price": 3220.6,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3220.6,
        "doubleCheck": true
    },
    {
        "dataID": "117411",
        "id": "53091024",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:43",
        "brokerTime": "2025-05-14 15:05:43",
        "commission": -57.96,
        "swap": 0,
        "profit": -140.76,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054109",
        "positionId": "56054108",
        "volume": 8.28,
        "price": 3220.77,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -198.72,
        "priceIn": 3220.6,
        "doubleCheck": true
    },
    {
        "dataID": "117412",
        "id": "53091025",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 14:35:43",
        "brokerTime": "2025-05-14 15:05:44",
        "commission": -16.8,
        "swap": 0,
        "profit": -3703.03,
        "symbol": "XAUEUR.PRO",
        "magic": "0",
        "orderId": "56054110",
        "positionId": "56048374",
        "volume": 2.4,
        "price": 2870.02,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -3719.8300000000004,
        "priceIn": 2883.77,
        "doubleCheck": true,
        "isShow": false,
        "collapseIndex": "0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30",
        "tProfit": -3868.76,
        "tnProfit": -3903.06,
        "tVolume": 4.8999999999999995,
        "tTrades": 4
    },
    {
        "dataID": "117413",
        "id": "53091026",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:44",
        "brokerTime": "2025-05-14 15:05:44",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054111",
        "positionId": "56054111",
        "volume": 8.28,
        "price": 3220.58,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3220.58,
        "doubleCheck": true
    },
    {
        "dataID": "117414",
        "id": "53091027",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:44",
        "brokerTime": "2025-05-14 15:05:44",
        "commission": -57.96,
        "swap": 0,
        "profit": -173.88,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054112",
        "positionId": "56054111",
        "volume": 8.28,
        "price": 3220.79,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -231.84,
        "priceIn": 3220.58,
        "doubleCheck": true
    },
    {
        "dataID": "117415",
        "id": "53091028",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 15:05:44",
        "brokerTime": "2025-05-14 15:05:44",
        "commission": -0.84,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUEUR.PRO",
        "magic": "0",
        "orderId": "56054113",
        "positionId": "56054113",
        "volume": 0.12,
        "price": 2870.25,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2970.25,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.84,
        "priceIn": 2870.25,
        "doubleCheck": true
    },
    {
        "dataID": "117416",
        "id": "53091029",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 15:05:44",
        "brokerTime": "2025-05-14 15:05:44",
        "commission": -15.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUEUR.PRO",
        "magic": "0",
        "orderId": "56054114",
        "positionId": "56054114",
        "volume": 2.28,
        "price": 2870.2,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -15.96,
        "priceIn": 2870.2,
        "doubleCheck": true
    },
    {
        "dataID": "117417",
        "id": "53091030",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:45",
        "brokerTime": "2025-05-14 15:05:45",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054115",
        "positionId": "56054115",
        "volume": 8.28,
        "price": 3220.56,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3220.56,
        "doubleCheck": true
    },
    {
        "dataID": "117418",
        "id": "53091031",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 15:05:44",
        "brokerTime": "2025-05-14 15:05:45",
        "commission": -15.96,
        "swap": 0,
        "profit": -43.49,
        "symbol": "XAUEUR.PRO",
        "magic": "0",
        "orderId": "56054116",
        "positionId": "56054114",
        "volume": 2.28,
        "price": 2870.03,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -59.45,
        "priceIn": 2870.2,
        "doubleCheck": true
    },
    {
        "dataID": "117419",
        "id": "53091032",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 15:05:44",
        "brokerTime": "2025-05-14 15:05:45",
        "commission": -0.84,
        "swap": 0,
        "profit": -2.96,
        "symbol": "XAUEUR.PRO",
        "magic": "0",
        "orderId": "56054117",
        "positionId": "56054113",
        "volume": 0.12,
        "price": 2870.03,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2970.03,
        "brokerComment": "",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -3.8,
        "priceIn": 2870.25,
        "doubleCheck": true
    },
    {
        "dataID": "117420",
        "id": "53091033",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:27:25",
        "brokerTime": "2025-05-14 15:05:45",
        "commission": -3.01,
        "swap": 0,
        "profit": 776.38,
        "symbol": "XAUEUR.PRO",
        "magic": "0",
        "orderId": "56054118",
        "positionId": "56048276",
        "volume": 0.43,
        "price": 2870.25,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2786.59,
        "brokerComment": "",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 773.37,
        "priceIn": 2886.34,
        "doubleCheck": true,
        "isShow": false,
        "collapseIndex": "0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32",
        "tProfit": 2932.43,
        "tnProfit": 2907.02,
        "tVolume": 3.630000000000001,
        "tTrades": 14
    },
    {
        "dataID": "117421",
        "id": "53091034",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:17:17",
        "brokerTime": "2025-05-14 15:05:45",
        "commission": -2.52,
        "swap": 0,
        "profit": 609.19,
        "symbol": "XAUEUR.PRO",
        "magic": "0",
        "orderId": "56054119",
        "positionId": "56034354",
        "volume": 0.36,
        "price": 2870.25,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2786.59,
        "brokerComment": "",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 606.6700000000001,
        "priceIn": 2885.33,
        "doubleCheck": true
    },
    {
        "dataID": "117422",
        "id": "53091035",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:15:56",
        "brokerTime": "2025-05-14 15:05:45",
        "commission": -2.1,
        "swap": 0,
        "profit": 472.31,
        "symbol": "XAUEUR.PRO",
        "magic": "0",
        "orderId": "56054120",
        "positionId": "56033307",
        "volume": 0.3,
        "price": 2870.22,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2786.59,
        "brokerComment": "",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 470.21,
        "priceIn": 2884.25,
        "doubleCheck": true
    },
    {
        "dataID": "117423",
        "id": "53091036",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:13:35",
        "brokerTime": "2025-05-14 15:05:45",
        "commission": -1.75,
        "swap": 0,
        "profit": 363.01,
        "symbol": "XAUEUR.PRO",
        "magic": "0",
        "orderId": "56054121",
        "positionId": "56032846",
        "volume": 0.25,
        "price": 2870.22,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2786.59,
        "brokerComment": "",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 361.26,
        "priceIn": 2883.16,
        "doubleCheck": true
    },
    {
        "dataID": "117424",
        "id": "53091037",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:09:11",
        "brokerTime": "2025-05-14 15:05:45",
        "commission": -1.47,
        "swap": 0,
        "profit": 281.13,
        "symbol": "XAUEUR.PRO",
        "magic": "0",
        "orderId": "56054122",
        "positionId": "56032160",
        "volume": 0.21,
        "price": 2870.22,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2786.59,
        "brokerComment": "",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 279.65999999999997,
        "priceIn": 2882.15,
        "doubleCheck": true
    },
    {
        "dataID": "117425",
        "id": "53091038",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 14:02:40",
        "brokerTime": "2025-05-14 15:05:45",
        "commission": -0.7,
        "swap": 0,
        "profit": -119.28,
        "symbol": "XAUEUR.PRO",
        "magic": "0",
        "orderId": "56054123",
        "positionId": "56031516",
        "volume": 0.1,
        "price": 2870.01,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2970.03,
        "brokerComment": "",
        "comment": "RR",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -119.98,
        "priceIn": 2880.64,
        "doubleCheck": true
    },
    {
        "dataID": "117426",
        "id": "53091039",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 13:59:29",
        "brokerTime": "2025-05-14 15:05:45",
        "commission": -1.19,
        "swap": 0,
        "profit": 210.03,
        "symbol": "XAUEUR.PRO",
        "magic": "0",
        "orderId": "56054124",
        "positionId": "56030546",
        "volume": 0.17,
        "price": 2870.08,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2786.59,
        "brokerComment": "",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 208.84,
        "priceIn": 2881.09,
        "doubleCheck": true
    },
    {
        "dataID": "117427",
        "id": "53091040",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 13:57:59",
        "brokerTime": "2025-05-14 15:05:45",
        "commission": -0.98,
        "swap": 0,
        "profit": 156.79,
        "symbol": "XAUEUR.PRO",
        "magic": "0",
        "orderId": "56054125",
        "positionId": "56030517",
        "volume": 0.14,
        "price": 2870.08,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2786.59,
        "brokerComment": "",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 155.81,
        "priceIn": 2880.06,
        "doubleCheck": true
    },
    {
        "dataID": "117428",
        "id": "53091041",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 13:39:36",
        "brokerTime": "2025-05-14 15:05:45",
        "commission": -0.84,
        "swap": 0,
        "profit": 120.11,
        "symbol": "XAUEUR.PRO",
        "magic": "0",
        "orderId": "56054126",
        "positionId": "56029504",
        "volume": 0.12,
        "price": 2870.08,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2786.59,
        "brokerComment": "",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 119.27,
        "priceIn": 2879,
        "doubleCheck": true
    },
    {
        "dataID": "117429",
        "id": "53091042",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 13:20:35",
        "brokerTime": "2025-05-14 15:05:45",
        "commission": -0.7,
        "swap": 0,
        "profit": 88.65,
        "symbol": "XAUEUR.PRO",
        "magic": "0",
        "orderId": "56054127",
        "positionId": "56028231",
        "volume": 0.1,
        "price": 2870.08,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2786.59,
        "brokerComment": "",
        "comment": "Sell Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 87.95,
        "priceIn": 2877.98,
        "doubleCheck": true
    },
    {
        "dataID": "117430",
        "id": "53091043",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:45",
        "brokerTime": "2025-05-14 15:05:46",
        "commission": -57.96,
        "swap": 0,
        "profit": -33.12,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054128",
        "positionId": "56054115",
        "volume": 8.28,
        "price": 3220.6,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -91.08,
        "priceIn": 3220.56,
        "doubleCheck": true
    },
    {
        "dataID": "117431",
        "id": "53091044",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:46",
        "brokerTime": "2025-05-14 15:05:46",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054129",
        "positionId": "56054129",
        "volume": 8.28,
        "price": 3220.45,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3220.45,
        "doubleCheck": true
    },
    {
        "dataID": "117432",
        "id": "53091045",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:46",
        "brokerTime": "2025-05-14 15:05:47",
        "commission": -57.96,
        "swap": 0,
        "profit": -281.52,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054130",
        "positionId": "56054129",
        "volume": 8.28,
        "price": 3220.79,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -339.47999999999996,
        "priceIn": 3220.45,
        "doubleCheck": true
    },
    {
        "dataID": "117433",
        "id": "53091046",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:48",
        "brokerTime": "2025-05-14 15:05:48",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054131",
        "positionId": "56054131",
        "volume": 8.28,
        "price": 3220.62,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3220.62,
        "doubleCheck": true
    },
    {
        "dataID": "117434",
        "id": "53091047",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:48",
        "brokerTime": "2025-05-14 15:05:48",
        "commission": -57.96,
        "swap": 0,
        "profit": -115.92,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054132",
        "positionId": "56054131",
        "volume": 8.28,
        "price": 3220.76,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -173.88,
        "priceIn": 3220.62,
        "doubleCheck": true
    },
    {
        "dataID": "117435",
        "id": "53091048",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:49",
        "brokerTime": "2025-05-14 15:05:49",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054133",
        "positionId": "56054133",
        "volume": 8.28,
        "price": 3220.86,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3220.86,
        "doubleCheck": true
    },
    {
        "dataID": "117436",
        "id": "53091050",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:49",
        "brokerTime": "2025-05-14 15:05:49",
        "commission": -57.96,
        "swap": 0,
        "profit": -240.12,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054135",
        "positionId": "56054133",
        "volume": 8.28,
        "price": 3221.15,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -298.08,
        "priceIn": 3220.86,
        "doubleCheck": true
    },
    {
        "dataID": "117437",
        "id": "53091051",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:49",
        "brokerTime": "2025-05-14 15:05:49",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054136",
        "positionId": "56054136",
        "volume": 8.28,
        "price": 3220.94,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3220.94,
        "doubleCheck": true
    },
    {
        "dataID": "117438",
        "id": "53091052",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:49",
        "brokerTime": "2025-05-14 15:05:50",
        "commission": -57.96,
        "swap": 0,
        "profit": -149.04,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054137",
        "positionId": "56054136",
        "volume": 8.28,
        "price": 3221.12,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -207,
        "priceIn": 3220.94,
        "doubleCheck": true
    },
    {
        "dataID": "117439",
        "id": "53091053",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:51",
        "brokerTime": "2025-05-14 15:05:51",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054138",
        "positionId": "56054138",
        "volume": 8.28,
        "price": 3220.91,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3220.91,
        "doubleCheck": true
    },
    {
        "dataID": "117440",
        "id": "53091056",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:51",
        "brokerTime": "2025-05-14 15:05:51",
        "commission": -57.96,
        "swap": 0,
        "profit": -132.48,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054139",
        "positionId": "56054138",
        "volume": 8.28,
        "price": 3221.07,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -190.44,
        "priceIn": 3220.91,
        "doubleCheck": true
    },
    {
        "dataID": "117441",
        "id": "53091059",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:52",
        "brokerTime": "2025-05-14 15:05:52",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054141",
        "positionId": "56054141",
        "volume": 8.28,
        "price": 3220.86,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3220.86,
        "doubleCheck": true
    },
    {
        "dataID": "117442",
        "id": "53091060",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:52",
        "brokerTime": "2025-05-14 15:05:52",
        "commission": -0.7,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUEUR.PRO",
        "magic": "0",
        "orderId": "56054142",
        "positionId": "56054142",
        "volume": 0.1,
        "price": 2870.67,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "RR",
        "comment": "RR",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.7,
        "priceIn": 2870.67,
        "doubleCheck": true
    },
    {
        "dataID": "117443",
        "id": "53091061",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 15:05:52",
        "brokerTime": "2025-05-14 15:05:52",
        "commission": -0.7,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUEUR.PRO",
        "magic": "0",
        "orderId": "56054143",
        "positionId": "56054143",
        "volume": 0.1,
        "price": 2870.88,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "RR",
        "comment": "RR",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.7,
        "priceIn": 2870.88,
        "doubleCheck": true
    },
    {
        "dataID": "117444",
        "id": "53091062",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:52",
        "brokerTime": "2025-05-14 15:05:53",
        "commission": -57.96,
        "swap": 0,
        "profit": -74.52,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054144",
        "positionId": "56054141",
        "volume": 8.28,
        "price": 3220.95,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -132.48,
        "priceIn": 3220.86,
        "doubleCheck": true
    },
    {
        "dataID": "117445",
        "id": "53091063",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:52",
        "brokerTime": "2025-05-14 15:05:53",
        "commission": -0.7,
        "swap": 0,
        "profit": -1.68,
        "symbol": "XAUEUR.PRO",
        "magic": "0",
        "orderId": "56054145",
        "positionId": "56054142",
        "volume": 0.1,
        "price": 2870.82,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "RR",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -2.38,
        "priceIn": 2870.67,
        "doubleCheck": true
    },
    {
        "dataID": "117446",
        "id": "53091064",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:54",
        "brokerTime": "2025-05-14 15:05:54",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054146",
        "positionId": "56054146",
        "volume": 8.28,
        "price": 3220.77,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3220.77,
        "doubleCheck": true
    },
    {
        "dataID": "117447",
        "id": "53091065",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:54",
        "brokerTime": "2025-05-14 15:05:54",
        "commission": -57.96,
        "swap": 0,
        "profit": -207,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054147",
        "positionId": "56054146",
        "volume": 8.28,
        "price": 3221.02,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -264.96,
        "priceIn": 3220.77,
        "doubleCheck": true
    },
    {
        "dataID": "117448",
        "id": "53091066",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:55",
        "brokerTime": "2025-05-14 15:05:55",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054148",
        "positionId": "56054148",
        "volume": 8.28,
        "price": 3220.81,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3220.81,
        "doubleCheck": true
    },
    {
        "dataID": "117449",
        "id": "53091067",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:55",
        "brokerTime": "2025-05-14 15:05:55",
        "commission": -57.96,
        "swap": 0,
        "profit": -132.48,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054149",
        "positionId": "56054148",
        "volume": 8.28,
        "price": 3220.97,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -190.44,
        "priceIn": 3220.81,
        "doubleCheck": true
    },
    {
        "dataID": "117450",
        "id": "53091068",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:55",
        "brokerTime": "2025-05-14 15:05:55",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054150",
        "positionId": "56054150",
        "volume": 8.28,
        "price": 3220.8,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3220.8,
        "doubleCheck": true
    },
    {
        "dataID": "117451",
        "id": "53091069",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:55",
        "brokerTime": "2025-05-14 15:05:56",
        "commission": -57.96,
        "swap": 0,
        "profit": -223.56,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054151",
        "positionId": "56054150",
        "volume": 8.28,
        "price": 3221.07,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -281.52,
        "priceIn": 3220.8,
        "doubleCheck": true
    },
    {
        "dataID": "117452",
        "id": "53091071",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:56",
        "brokerTime": "2025-05-14 15:05:56",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054152",
        "positionId": "56054152",
        "volume": 8.28,
        "price": 3220.79,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3220.79,
        "doubleCheck": true
    },
    {
        "dataID": "117453",
        "id": "53091072",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:56",
        "brokerTime": "2025-05-14 15:05:56",
        "commission": -57.96,
        "swap": 0,
        "profit": -49.68,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054153",
        "positionId": "56054152",
        "volume": 8.28,
        "price": 3220.85,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -107.64,
        "priceIn": 3220.79,
        "doubleCheck": true
    },
    {
        "dataID": "117454",
        "id": "53091073",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:57",
        "brokerTime": "2025-05-14 15:05:57",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054154",
        "positionId": "56054154",
        "volume": 8.28,
        "price": 3220.76,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3220.76,
        "doubleCheck": true
    },
    {
        "dataID": "117455",
        "id": "53091074",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:57",
        "brokerTime": "2025-05-14 15:05:57",
        "commission": -57.96,
        "swap": 0,
        "profit": -82.8,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054155",
        "positionId": "56054154",
        "volume": 8.28,
        "price": 3220.86,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -140.76,
        "priceIn": 3220.76,
        "doubleCheck": true
    },
    {
        "dataID": "117456",
        "id": "53091075",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:58",
        "brokerTime": "2025-05-14 15:05:58",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054156",
        "positionId": "56054156",
        "volume": 8.28,
        "price": 3220.6,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3220.6,
        "doubleCheck": true
    },
    {
        "dataID": "117457",
        "id": "53091076",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:58",
        "brokerTime": "2025-05-14 15:05:58",
        "commission": -57.96,
        "swap": 0,
        "profit": -223.56,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054157",
        "positionId": "56054156",
        "volume": 8.28,
        "price": 3220.87,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -281.52,
        "priceIn": 3220.6,
        "doubleCheck": true
    },
    {
        "dataID": "117458",
        "id": "53091077",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:59",
        "brokerTime": "2025-05-14 15:05:59",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054158",
        "positionId": "56054158",
        "volume": 8.28,
        "price": 3220.74,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3220.74,
        "doubleCheck": true
    },
    {
        "dataID": "117459",
        "id": "53091078",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:59",
        "brokerTime": "2025-05-14 15:05:59",
        "commission": -0.7,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUEUR.PRO",
        "magic": "0",
        "orderId": "56054159",
        "positionId": "56054159",
        "volume": 0.1,
        "price": 2870.69,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "RR",
        "comment": "RR",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.7,
        "priceIn": 2870.69,
        "doubleCheck": true
    },
    {
        "dataID": "117460",
        "id": "53091079",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:59",
        "brokerTime": "2025-05-14 15:06:00",
        "commission": -57.96,
        "swap": 0,
        "profit": -149.04,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054160",
        "positionId": "56054158",
        "volume": 8.28,
        "price": 3220.92,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -207,
        "priceIn": 3220.74,
        "doubleCheck": true
    },
    {
        "dataID": "117461",
        "id": "53091080",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:01",
        "brokerTime": "2025-05-14 15:06:01",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054161",
        "positionId": "56054161",
        "volume": 8.28,
        "price": 3220.75,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3220.75,
        "doubleCheck": true
    },
    {
        "dataID": "117462",
        "id": "53091084",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:01",
        "brokerTime": "2025-05-14 15:06:01",
        "commission": -57.96,
        "swap": 0,
        "profit": 339.48,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054165",
        "positionId": "56054161",
        "volume": 8.28,
        "price": 3220.34,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 281.52000000000004,
        "priceIn": 3220.75,
        "doubleCheck": true
    },
    {
        "dataID": "117463",
        "id": "53091085",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:01",
        "brokerTime": "2025-05-14 15:06:01",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054166",
        "positionId": "56054166",
        "volume": 8.28,
        "price": 3220.17,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3220.17,
        "doubleCheck": true
    },
    {
        "dataID": "117464",
        "id": "53091086",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:01",
        "brokerTime": "2025-05-14 15:06:02",
        "commission": -57.96,
        "swap": 0,
        "profit": -149.04,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054167",
        "positionId": "56054166",
        "volume": 8.28,
        "price": 3220.35,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -207,
        "priceIn": 3220.17,
        "doubleCheck": true
    },
    {
        "dataID": "117465",
        "id": "53091087",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:03",
        "brokerTime": "2025-05-14 15:06:03",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054168",
        "positionId": "56054168",
        "volume": 8.28,
        "price": 3220.18,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3220.18,
        "doubleCheck": true
    },
    {
        "dataID": "117466",
        "id": "53091088",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:03",
        "brokerTime": "2025-05-14 15:06:03",
        "commission": -57.96,
        "swap": 0,
        "profit": -149.04,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054169",
        "positionId": "56054168",
        "volume": 8.28,
        "price": 3220.36,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -207,
        "priceIn": 3220.18,
        "doubleCheck": true
    },
    {
        "dataID": "117467",
        "id": "53091089",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:04",
        "brokerTime": "2025-05-14 15:06:04",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054170",
        "positionId": "56054170",
        "volume": 8.28,
        "price": 3220.48,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3220.48,
        "doubleCheck": true
    },
    {
        "dataID": "117468",
        "id": "53091091",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:04",
        "brokerTime": "2025-05-14 15:06:04",
        "commission": -57.96,
        "swap": 0,
        "profit": -190.44,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054172",
        "positionId": "56054170",
        "volume": 8.28,
        "price": 3220.71,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -248.4,
        "priceIn": 3220.48,
        "doubleCheck": true
    },
    {
        "dataID": "117469",
        "id": "53091092",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:04",
        "brokerTime": "2025-05-14 15:06:04",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054173",
        "positionId": "56054173",
        "volume": 8.28,
        "price": 3220.53,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3220.53,
        "doubleCheck": true
    },
    {
        "dataID": "117470",
        "id": "53091093",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:04",
        "brokerTime": "2025-05-14 15:06:05",
        "commission": -57.96,
        "swap": 0,
        "profit": -99.36,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054174",
        "positionId": "56054173",
        "volume": 8.28,
        "price": 3220.65,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -157.32,
        "priceIn": 3220.53,
        "doubleCheck": true
    },
    {
        "dataID": "117471",
        "id": "53091094",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:05",
        "brokerTime": "2025-05-14 15:06:05",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054175",
        "positionId": "56054175",
        "volume": 8.28,
        "price": 3220.75,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3220.75,
        "doubleCheck": true
    },
    {
        "dataID": "117472",
        "id": "53091095",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:05",
        "brokerTime": "2025-05-14 15:06:05",
        "commission": -57.96,
        "swap": 0,
        "profit": -149.04,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054176",
        "positionId": "56054175",
        "volume": 8.28,
        "price": 3220.93,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -207,
        "priceIn": 3220.75,
        "doubleCheck": true
    },
    {
        "dataID": "117473",
        "id": "53091096",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:06",
        "brokerTime": "2025-05-14 15:06:06",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054177",
        "positionId": "56054177",
        "volume": 8.28,
        "price": 3220.7,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3220.7,
        "doubleCheck": true
    },
    {
        "dataID": "117474",
        "id": "53091097",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:06",
        "brokerTime": "2025-05-14 15:06:06",
        "commission": -57.96,
        "swap": 0,
        "profit": -157.32,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054178",
        "positionId": "56054177",
        "volume": 8.28,
        "price": 3220.89,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -215.28,
        "priceIn": 3220.7,
        "doubleCheck": true
    },
    {
        "dataID": "117475",
        "id": "53091099",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:07",
        "brokerTime": "2025-05-14 15:06:07",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054179",
        "positionId": "56054179",
        "volume": 8.28,
        "price": 3220.8,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3220.8,
        "doubleCheck": true
    },
    {
        "dataID": "117476",
        "id": "53091100",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:07",
        "brokerTime": "2025-05-14 15:06:08",
        "commission": -57.96,
        "swap": 0,
        "profit": -264.96,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054180",
        "positionId": "56054179",
        "volume": 8.28,
        "price": 3221.12,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -322.91999999999996,
        "priceIn": 3220.8,
        "doubleCheck": true
    },
    {
        "dataID": "117477",
        "id": "53091101",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:08",
        "brokerTime": "2025-05-14 15:06:08",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054181",
        "positionId": "56054181",
        "volume": 8.28,
        "price": 3220.8,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3220.8,
        "doubleCheck": true
    },
    {
        "dataID": "117478",
        "id": "53091102",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:08",
        "brokerTime": "2025-05-14 15:06:09",
        "commission": -57.96,
        "swap": 0,
        "profit": -24.84,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054182",
        "positionId": "56054181",
        "volume": 8.28,
        "price": 3220.83,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -82.8,
        "priceIn": 3220.8,
        "doubleCheck": true
    },
    {
        "dataID": "117479",
        "id": "53091103",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:09",
        "brokerTime": "2025-05-14 15:06:09",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054183",
        "positionId": "56054183",
        "volume": 8.28,
        "price": 3220.63,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3220.63,
        "doubleCheck": true
    },
    {
        "dataID": "117480",
        "id": "53091104",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:09",
        "brokerTime": "2025-05-14 15:06:10",
        "commission": -57.96,
        "swap": 0,
        "profit": -207,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054184",
        "positionId": "56054183",
        "volume": 8.28,
        "price": 3220.88,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -264.96,
        "priceIn": 3220.63,
        "doubleCheck": true
    },
    {
        "dataID": "117481",
        "id": "53091105",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:10",
        "brokerTime": "2025-05-14 15:06:10",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054185",
        "positionId": "56054185",
        "volume": 8.28,
        "price": 3220.69,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3220.69,
        "doubleCheck": true
    },
    {
        "dataID": "117482",
        "id": "53091106",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:10",
        "brokerTime": "2025-05-14 15:06:11",
        "commission": -57.96,
        "swap": 0,
        "profit": -124.2,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054186",
        "positionId": "56054185",
        "volume": 8.28,
        "price": 3220.84,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -182.16,
        "priceIn": 3220.69,
        "doubleCheck": true
    },
    {
        "dataID": "117483",
        "id": "53091107",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:11",
        "brokerTime": "2025-05-14 15:06:11",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054187",
        "positionId": "56054187",
        "volume": 8.28,
        "price": 3220.7,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3220.7,
        "doubleCheck": true
    },
    {
        "dataID": "117484",
        "id": "53091110",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:11",
        "brokerTime": "2025-05-14 15:06:11",
        "commission": -57.96,
        "swap": 0,
        "profit": -298.08,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054189",
        "positionId": "56054187",
        "volume": 8.28,
        "price": 3221.06,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -356.03999999999996,
        "priceIn": 3220.7,
        "doubleCheck": true
    },
    {
        "dataID": "117485",
        "id": "53091111",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:12",
        "brokerTime": "2025-05-14 15:06:12",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054190",
        "positionId": "56054190",
        "volume": 8.28,
        "price": 3221.31,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3221.31,
        "doubleCheck": true
    },
    {
        "dataID": "117486",
        "id": "53091112",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:12",
        "brokerTime": "2025-05-14 15:06:13",
        "commission": -57.96,
        "swap": 0,
        "profit": -314.64,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054191",
        "positionId": "56054190",
        "volume": 8.28,
        "price": 3221.69,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -372.59999999999997,
        "priceIn": 3221.31,
        "doubleCheck": true
    },
    {
        "dataID": "117487",
        "id": "53091113",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:14",
        "brokerTime": "2025-05-14 15:06:14",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054192",
        "positionId": "56054192",
        "volume": 8.28,
        "price": 3221.47,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3221.47,
        "doubleCheck": true
    },
    {
        "dataID": "117488",
        "id": "53091114",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:14",
        "brokerTime": "2025-05-14 15:06:15",
        "commission": -57.96,
        "swap": 0,
        "profit": -157.32,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054193",
        "positionId": "56054192",
        "volume": 8.28,
        "price": 3221.66,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -215.28,
        "priceIn": 3221.47,
        "doubleCheck": true
    },
    {
        "dataID": "117489",
        "id": "53091115",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:16",
        "brokerTime": "2025-05-14 15:06:16",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054194",
        "positionId": "56054194",
        "volume": 8.28,
        "price": 3221.6,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3221.6,
        "doubleCheck": true
    },
    {
        "dataID": "117490",
        "id": "53091116",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:16",
        "brokerTime": "2025-05-14 15:06:16",
        "commission": -57.96,
        "swap": 0,
        "profit": -215.28,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054195",
        "positionId": "56054194",
        "volume": 8.28,
        "price": 3221.86,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -273.24,
        "priceIn": 3221.6,
        "doubleCheck": true
    },
    {
        "dataID": "117491",
        "id": "53091121",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:17",
        "brokerTime": "2025-05-14 15:06:17",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054200",
        "positionId": "56054200",
        "volume": 8.28,
        "price": 3221.65,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3221.65,
        "doubleCheck": true
    },
    {
        "dataID": "117492",
        "id": "53091123",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:17",
        "brokerTime": "2025-05-14 15:06:18",
        "commission": -57.96,
        "swap": 0,
        "profit": -91.08,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054202",
        "positionId": "56054200",
        "volume": 8.28,
        "price": 3221.76,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -149.04,
        "priceIn": 3221.65,
        "doubleCheck": true
    },
    {
        "dataID": "117493",
        "id": "53091124",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:18",
        "brokerTime": "2025-05-14 15:06:18",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054203",
        "positionId": "56054203",
        "volume": 8.28,
        "price": 3221.59,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3221.59,
        "doubleCheck": true
    },
    {
        "dataID": "117494",
        "id": "53091125",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:18",
        "brokerTime": "2025-05-14 15:06:18",
        "commission": -57.96,
        "swap": 0,
        "profit": 49.68,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054204",
        "positionId": "56054203",
        "volume": 8.28,
        "price": 3221.53,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -8.280000000000001,
        "priceIn": 3221.59,
        "doubleCheck": true
    },
    {
        "dataID": "117495",
        "id": "53091127",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:19",
        "brokerTime": "2025-05-14 15:06:19",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054205",
        "positionId": "56054205",
        "volume": 8.28,
        "price": 3221.45,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3221.45,
        "doubleCheck": true
    },
    {
        "dataID": "117496",
        "id": "53091129",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:19",
        "brokerTime": "2025-05-14 15:06:20",
        "commission": -57.96,
        "swap": 0,
        "profit": -74.52,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054207",
        "positionId": "56054205",
        "volume": 8.28,
        "price": 3221.54,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -132.48,
        "priceIn": 3221.45,
        "doubleCheck": true
    },
    {
        "dataID": "117497",
        "id": "53091130",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:20",
        "brokerTime": "2025-05-14 15:06:20",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054208",
        "positionId": "56054208",
        "volume": 8.28,
        "price": 3221.35,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3221.35,
        "doubleCheck": true
    },
    {
        "dataID": "117498",
        "id": "53091132",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:20",
        "brokerTime": "2025-05-14 15:06:21",
        "commission": -57.96,
        "swap": 0,
        "profit": -41.4,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054210",
        "positionId": "56054208",
        "volume": 8.28,
        "price": 3221.4,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -99.36,
        "priceIn": 3221.35,
        "doubleCheck": true
    },
    {
        "dataID": "117499",
        "id": "53091133",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:21",
        "brokerTime": "2025-05-14 15:06:21",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054211",
        "positionId": "56054211",
        "volume": 8.28,
        "price": 3221.24,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3221.24,
        "doubleCheck": true
    },
    {
        "dataID": "117500",
        "id": "53091134",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:21",
        "brokerTime": "2025-05-14 15:06:21",
        "commission": -57.96,
        "swap": 0,
        "profit": 356.04,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054212",
        "positionId": "56054211",
        "volume": 8.28,
        "price": 3220.81,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 298.08000000000004,
        "priceIn": 3221.24,
        "doubleCheck": true
    },
    {
        "dataID": "117501",
        "id": "53091135",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:21",
        "brokerTime": "2025-05-14 15:06:21",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054213",
        "positionId": "56054213",
        "volume": 8.28,
        "price": 3220.62,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3220.62,
        "doubleCheck": true
    },
    {
        "dataID": "117502",
        "id": "53091136",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:21",
        "brokerTime": "2025-05-14 15:06:22",
        "commission": -57.96,
        "swap": 0,
        "profit": -372.6,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054214",
        "positionId": "56054213",
        "volume": 8.28,
        "price": 3221.07,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -430.56,
        "priceIn": 3220.62,
        "doubleCheck": true
    },
    {
        "dataID": "117503",
        "id": "53091137",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:23",
        "brokerTime": "2025-05-14 15:06:23",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054215",
        "positionId": "56054215",
        "volume": 8.28,
        "price": 3221.07,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3221.07,
        "doubleCheck": true
    },
    {
        "dataID": "117504",
        "id": "53091138",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:23",
        "brokerTime": "2025-05-14 15:06:23",
        "commission": -57.96,
        "swap": 0,
        "profit": -281.52,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054216",
        "positionId": "56054215",
        "volume": 8.28,
        "price": 3221.41,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -339.47999999999996,
        "priceIn": 3221.07,
        "doubleCheck": true
    },
    {
        "dataID": "117505",
        "id": "53091139",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:24",
        "brokerTime": "2025-05-14 15:06:24",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054217",
        "positionId": "56054217",
        "volume": 8.28,
        "price": 3221.21,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3221.21,
        "doubleCheck": true
    },
    {
        "dataID": "117506",
        "id": "53091140",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:24",
        "brokerTime": "2025-05-14 15:06:24",
        "commission": -57.96,
        "swap": 0,
        "profit": -115.92,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054218",
        "positionId": "56054217",
        "volume": 8.28,
        "price": 3221.35,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -173.88,
        "priceIn": 3221.21,
        "doubleCheck": true
    },
    {
        "dataID": "117507",
        "id": "53091141",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:24",
        "brokerTime": "2025-05-14 15:06:24",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054219",
        "positionId": "56054219",
        "volume": 8.28,
        "price": 3220.93,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3220.93,
        "doubleCheck": true
    },
    {
        "dataID": "117508",
        "id": "53091142",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:24",
        "brokerTime": "2025-05-14 15:06:25",
        "commission": -57.96,
        "swap": 0,
        "profit": -74.52,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054220",
        "positionId": "56054219",
        "volume": 8.28,
        "price": 3221.02,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -132.48,
        "priceIn": 3220.93,
        "doubleCheck": true
    },
    {
        "dataID": "117509",
        "id": "53091143",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:25",
        "brokerTime": "2025-05-14 15:06:25",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054221",
        "positionId": "56054221",
        "volume": 8.28,
        "price": 3220.84,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3220.84,
        "doubleCheck": true
    },
    {
        "dataID": "117510",
        "id": "53091145",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:25",
        "brokerTime": "2025-05-14 15:06:26",
        "commission": -57.96,
        "swap": 0,
        "profit": -24.84,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054223",
        "positionId": "56054221",
        "volume": 8.28,
        "price": 3220.87,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -82.8,
        "priceIn": 3220.84,
        "doubleCheck": true
    },
    {
        "dataID": "117511",
        "id": "53091146",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:27",
        "brokerTime": "2025-05-14 15:06:27",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054224",
        "positionId": "56054224",
        "volume": 8.28,
        "price": 3220.71,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3220.71,
        "doubleCheck": true
    },
    {
        "dataID": "117512",
        "id": "53091147",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:27",
        "brokerTime": "2025-05-14 15:06:28",
        "commission": -57.96,
        "swap": 0,
        "profit": -331.2,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054225",
        "positionId": "56054224",
        "volume": 8.28,
        "price": 3221.11,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -389.15999999999997,
        "priceIn": 3220.71,
        "doubleCheck": true
    },
    {
        "dataID": "117513",
        "id": "53091148",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:28",
        "brokerTime": "2025-05-14 15:06:28",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054226",
        "positionId": "56054226",
        "volume": 8.28,
        "price": 3220.9,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3220.9,
        "doubleCheck": true
    },
    {
        "dataID": "117514",
        "id": "53091149",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:28",
        "brokerTime": "2025-05-14 15:06:29",
        "commission": -57.96,
        "swap": 0,
        "profit": -124.2,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054227",
        "positionId": "56054226",
        "volume": 8.28,
        "price": 3221.05,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -182.16,
        "priceIn": 3220.9,
        "doubleCheck": true
    },
    {
        "dataID": "117515",
        "id": "53091150",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:29",
        "brokerTime": "2025-05-14 15:06:29",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054228",
        "positionId": "56054228",
        "volume": 8.28,
        "price": 3220.91,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3220.91,
        "doubleCheck": true
    },
    {
        "dataID": "117516",
        "id": "53091151",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:29",
        "brokerTime": "2025-05-14 15:06:30",
        "commission": -57.96,
        "swap": 0,
        "profit": -198.72,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054229",
        "positionId": "56054228",
        "volume": 8.28,
        "price": 3221.15,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -256.68,
        "priceIn": 3220.91,
        "doubleCheck": true
    },
    {
        "dataID": "117517",
        "id": "53091152",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:30",
        "brokerTime": "2025-05-14 15:06:30",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054230",
        "positionId": "56054230",
        "volume": 8.28,
        "price": 3220.95,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3220.95,
        "doubleCheck": true
    },
    {
        "dataID": "117518",
        "id": "53091154",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:30",
        "brokerTime": "2025-05-14 15:06:30",
        "commission": -57.96,
        "swap": 0,
        "profit": -157.32,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054232",
        "positionId": "56054230",
        "volume": 8.28,
        "price": 3221.14,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -215.28,
        "priceIn": 3220.95,
        "doubleCheck": true
    },
    {
        "dataID": "117519",
        "id": "53091155",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:31",
        "brokerTime": "2025-05-14 15:06:31",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054233",
        "positionId": "56054233",
        "volume": 8.28,
        "price": 3221.3,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3221.3,
        "doubleCheck": true
    },
    {
        "dataID": "117520",
        "id": "53091156",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:31",
        "brokerTime": "2025-05-14 15:06:31",
        "commission": -57.96,
        "swap": 0,
        "profit": -157.32,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054234",
        "positionId": "56054233",
        "volume": 8.28,
        "price": 3221.49,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -215.28,
        "priceIn": 3221.3,
        "doubleCheck": true
    },
    {
        "dataID": "117521",
        "id": "53091157",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:32",
        "brokerTime": "2025-05-14 15:06:32",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054235",
        "positionId": "56054235",
        "volume": 8.28,
        "price": 3221.3,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3221.3,
        "doubleCheck": true
    },
    {
        "dataID": "117522",
        "id": "53091161",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:32",
        "brokerTime": "2025-05-14 15:06:33",
        "commission": -57.96,
        "swap": 0,
        "profit": -165.6,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054239",
        "positionId": "56054235",
        "volume": 8.28,
        "price": 3221.5,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -223.56,
        "priceIn": 3221.3,
        "doubleCheck": true
    },
    {
        "dataID": "117523",
        "id": "53091162",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:33",
        "brokerTime": "2025-05-14 15:06:33",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054240",
        "positionId": "56054240",
        "volume": 8.28,
        "price": 3221.3,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3221.3,
        "doubleCheck": true
    },
    {
        "dataID": "117524",
        "id": "53091163",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:33",
        "brokerTime": "2025-05-14 15:06:34",
        "commission": -57.96,
        "swap": 0,
        "profit": -173.88,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054241",
        "positionId": "56054240",
        "volume": 8.28,
        "price": 3221.51,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -231.84,
        "priceIn": 3221.3,
        "doubleCheck": true
    },
    {
        "dataID": "117525",
        "id": "53091164",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:34",
        "brokerTime": "2025-05-14 15:06:34",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054242",
        "positionId": "56054242",
        "volume": 8.28,
        "price": 3221.33,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3221.33,
        "doubleCheck": true
    },
    {
        "dataID": "117526",
        "id": "53091165",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:34",
        "brokerTime": "2025-05-14 15:06:35",
        "commission": -57.96,
        "swap": 0,
        "profit": -207,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054243",
        "positionId": "56054242",
        "volume": 8.28,
        "price": 3221.58,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -264.96,
        "priceIn": 3221.33,
        "doubleCheck": true
    },
    {
        "dataID": "117527",
        "id": "53091166",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:35",
        "brokerTime": "2025-05-14 15:06:35",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054244",
        "positionId": "56054244",
        "volume": 8.28,
        "price": 3221.53,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3221.53,
        "doubleCheck": true
    },
    {
        "dataID": "117528",
        "id": "53091167",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:35",
        "brokerTime": "2025-05-14 15:06:36",
        "commission": -57.96,
        "swap": 0,
        "profit": -190.44,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054245",
        "positionId": "56054244",
        "volume": 8.28,
        "price": 3221.76,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -248.4,
        "priceIn": 3221.53,
        "doubleCheck": true
    },
    {
        "dataID": "117529",
        "id": "53091168",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:36",
        "brokerTime": "2025-05-14 15:06:36",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054246",
        "positionId": "56054246",
        "volume": 8.28,
        "price": 3221.6,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3221.6,
        "doubleCheck": true
    },
    {
        "dataID": "117530",
        "id": "53091169",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:36",
        "brokerTime": "2025-05-14 15:06:36",
        "commission": -57.96,
        "swap": 0,
        "profit": -149.04,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054247",
        "positionId": "56054246",
        "volume": 8.28,
        "price": 3221.78,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -207,
        "priceIn": 3221.6,
        "doubleCheck": true
    },
    {
        "dataID": "117531",
        "id": "53091170",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:37",
        "brokerTime": "2025-05-14 15:06:37",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054248",
        "positionId": "56054248",
        "volume": 8.28,
        "price": 3221.42,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3221.42,
        "doubleCheck": true
    },
    {
        "dataID": "117532",
        "id": "53091171",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:37",
        "brokerTime": "2025-05-14 15:06:38",
        "commission": -57.96,
        "swap": 0,
        "profit": -215.28,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054249",
        "positionId": "56054248",
        "volume": 8.28,
        "price": 3221.68,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -273.24,
        "priceIn": 3221.42,
        "doubleCheck": true
    },
    {
        "dataID": "117533",
        "id": "53091172",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:39",
        "brokerTime": "2025-05-14 15:06:39",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054250",
        "positionId": "56054250",
        "volume": 8.28,
        "price": 3221.55,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3221.55,
        "doubleCheck": true
    },
    {
        "dataID": "117534",
        "id": "53091173",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:39",
        "brokerTime": "2025-05-14 15:06:39",
        "commission": -57.96,
        "swap": 0,
        "profit": -331.2,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054251",
        "positionId": "56054250",
        "volume": 8.28,
        "price": 3221.95,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -389.15999999999997,
        "priceIn": 3221.55,
        "doubleCheck": true
    },
    {
        "dataID": "117535",
        "id": "53091174",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:40",
        "brokerTime": "2025-05-14 15:06:40",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054252",
        "positionId": "56054252",
        "volume": 8.28,
        "price": 3221.74,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3221.74,
        "doubleCheck": true
    },
    {
        "dataID": "117536",
        "id": "53091176",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:40",
        "brokerTime": "2025-05-14 15:06:41",
        "commission": -57.96,
        "swap": 0,
        "profit": -165.6,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054254",
        "positionId": "56054252",
        "volume": 8.28,
        "price": 3221.94,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -223.56,
        "priceIn": 3221.74,
        "doubleCheck": true
    },
    {
        "dataID": "117537",
        "id": "53091177",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:41",
        "brokerTime": "2025-05-14 15:06:41",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054255",
        "positionId": "56054255",
        "volume": 8.28,
        "price": 3221.62,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3221.62,
        "doubleCheck": true
    },
    {
        "dataID": "117538",
        "id": "53091178",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:41",
        "brokerTime": "2025-05-14 15:06:42",
        "commission": -57.96,
        "swap": 0,
        "profit": -157.32,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054256",
        "positionId": "56054255",
        "volume": 8.28,
        "price": 3221.81,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -215.28,
        "priceIn": 3221.62,
        "doubleCheck": true
    },
    {
        "dataID": "117539",
        "id": "53091179",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:43",
        "brokerTime": "2025-05-14 15:06:43",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054257",
        "positionId": "56054257",
        "volume": 8.28,
        "price": 3221.64,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3221.64,
        "doubleCheck": true
    },
    {
        "dataID": "117540",
        "id": "53091180",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:43",
        "brokerTime": "2025-05-14 15:06:43",
        "commission": -57.96,
        "swap": 0,
        "profit": -124.2,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054258",
        "positionId": "56054257",
        "volume": 8.28,
        "price": 3221.79,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -182.16,
        "priceIn": 3221.64,
        "doubleCheck": true
    },
    {
        "dataID": "117541",
        "id": "53091181",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:43",
        "brokerTime": "2025-05-14 15:06:43",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054259",
        "positionId": "56054259",
        "volume": 8.28,
        "price": 3221.58,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3221.58,
        "doubleCheck": true
    },
    {
        "dataID": "117542",
        "id": "53091182",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:43",
        "brokerTime": "2025-05-14 15:06:44",
        "commission": -57.96,
        "swap": 0,
        "profit": -182.16,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054260",
        "positionId": "56054259",
        "volume": 8.28,
        "price": 3221.8,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -240.12,
        "priceIn": 3221.58,
        "doubleCheck": true
    },
    {
        "dataID": "117543",
        "id": "53091183",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:44",
        "brokerTime": "2025-05-14 15:06:44",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054261",
        "positionId": "56054261",
        "volume": 8.28,
        "price": 3221.69,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3221.69,
        "doubleCheck": true
    },
    {
        "dataID": "117544",
        "id": "53091184",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:44",
        "brokerTime": "2025-05-14 15:06:45",
        "commission": -57.96,
        "swap": 0,
        "profit": -207,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054262",
        "positionId": "56054261",
        "volume": 8.28,
        "price": 3221.94,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -264.96,
        "priceIn": 3221.69,
        "doubleCheck": true
    },
    {
        "dataID": "117545",
        "id": "53091185",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:46",
        "brokerTime": "2025-05-14 15:06:46",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054263",
        "positionId": "56054263",
        "volume": 8.28,
        "price": 3221.79,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3221.79,
        "doubleCheck": true
    },
    {
        "dataID": "117546",
        "id": "53091186",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:46",
        "brokerTime": "2025-05-14 15:06:46",
        "commission": -57.96,
        "swap": 0,
        "profit": 66.24,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054264",
        "positionId": "56054263",
        "volume": 8.28,
        "price": 3221.71,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 8.279999999999994,
        "priceIn": 3221.79,
        "doubleCheck": true
    },
    {
        "dataID": "117547",
        "id": "53091187",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:47",
        "brokerTime": "2025-05-14 15:06:47",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054266",
        "positionId": "56054266",
        "volume": 8.28,
        "price": 3221.65,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3221.65,
        "doubleCheck": true
    },
    {
        "dataID": "117548",
        "id": "53091188",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:47",
        "brokerTime": "2025-05-14 15:06:47",
        "commission": -57.96,
        "swap": 0,
        "profit": 57.96,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054267",
        "positionId": "56054266",
        "volume": 8.28,
        "price": 3221.58,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 0,
        "priceIn": 3221.65,
        "doubleCheck": true
    },
    {
        "dataID": "117549",
        "id": "53091189",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:48",
        "brokerTime": "2025-05-14 15:06:48",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054268",
        "positionId": "56054268",
        "volume": 8.28,
        "price": 3221.49,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3221.49,
        "doubleCheck": true
    },
    {
        "dataID": "117550",
        "id": "53091190",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:48",
        "brokerTime": "2025-05-14 15:06:50",
        "commission": -57.96,
        "swap": 0,
        "profit": -66.24,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054269",
        "positionId": "56054268",
        "volume": 8.28,
        "price": 3221.57,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -124.19999999999999,
        "priceIn": 3221.49,
        "doubleCheck": true
    },
    {
        "dataID": "117551",
        "id": "53091191",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:50",
        "brokerTime": "2025-05-14 15:06:50",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054270",
        "positionId": "56054270",
        "volume": 8.28,
        "price": 3221.38,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3221.38,
        "doubleCheck": true
    },
    {
        "dataID": "117552",
        "id": "53091192",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:50",
        "brokerTime": "2025-05-14 15:06:51",
        "commission": -57.96,
        "swap": 0,
        "profit": -273.24,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054271",
        "positionId": "56054270",
        "volume": 8.28,
        "price": 3221.71,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -331.2,
        "priceIn": 3221.38,
        "doubleCheck": true
    },
    {
        "dataID": "117553",
        "id": "53091193",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:51",
        "brokerTime": "2025-05-14 15:06:51",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054272",
        "positionId": "56054272",
        "volume": 8.28,
        "price": 3221.54,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3221.54,
        "doubleCheck": true
    },
    {
        "dataID": "117554",
        "id": "53091194",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:51",
        "brokerTime": "2025-05-14 15:06:51",
        "commission": -57.96,
        "swap": 0,
        "profit": -157.32,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054273",
        "positionId": "56054272",
        "volume": 8.28,
        "price": 3221.73,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -215.28,
        "priceIn": 3221.54,
        "doubleCheck": true
    },
    {
        "dataID": "117555",
        "id": "53091195",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:52",
        "brokerTime": "2025-05-14 15:06:52",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054274",
        "positionId": "56054274",
        "volume": 8.28,
        "price": 3221.52,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3221.52,
        "doubleCheck": true
    },
    {
        "dataID": "117556",
        "id": "53091196",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:52",
        "brokerTime": "2025-05-14 15:06:53",
        "commission": -57.96,
        "swap": 0,
        "profit": -165.6,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054275",
        "positionId": "56054274",
        "volume": 8.28,
        "price": 3221.72,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -223.56,
        "priceIn": 3221.52,
        "doubleCheck": true
    },
    {
        "dataID": "117557",
        "id": "53091197",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:53",
        "brokerTime": "2025-05-14 15:06:53",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054276",
        "positionId": "56054276",
        "volume": 8.28,
        "price": 3221.64,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3221.64,
        "doubleCheck": true
    },
    {
        "dataID": "117558",
        "id": "53091198",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:53",
        "brokerTime": "2025-05-14 15:06:54",
        "commission": -57.96,
        "swap": 0,
        "profit": -140.76,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054277",
        "positionId": "56054276",
        "volume": 8.28,
        "price": 3221.81,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -198.72,
        "priceIn": 3221.64,
        "doubleCheck": true
    },
    {
        "dataID": "117559",
        "id": "53091199",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:54",
        "brokerTime": "2025-05-14 15:06:54",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054278",
        "positionId": "56054278",
        "volume": 8.28,
        "price": 3221.64,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3221.64,
        "doubleCheck": true
    },
    {
        "dataID": "117560",
        "id": "53091200",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:54",
        "brokerTime": "2025-05-14 15:06:55",
        "commission": -57.96,
        "swap": 0,
        "profit": -248.4,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054279",
        "positionId": "56054278",
        "volume": 8.28,
        "price": 3221.94,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -306.36,
        "priceIn": 3221.64,
        "doubleCheck": true
    },
    {
        "dataID": "117561",
        "id": "53091201",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:55",
        "brokerTime": "2025-05-14 15:06:55",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054280",
        "positionId": "56054280",
        "volume": 8.28,
        "price": 3221.79,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -57.96,
        "priceIn": 3221.79,
        "doubleCheck": true
    },
    {
        "dataID": "117562",
        "id": "53091204",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:56",
        "brokerTime": "2025-05-14 15:06:56",
        "commission": -0.84,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUEUR.PRO",
        "magic": "0",
        "orderId": "56054281",
        "positionId": "56054281",
        "volume": 0.12,
        "price": 2871.8,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2771.8,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.84,
        "priceIn": 2871.8,
        "doubleCheck": true
    },
    {
        "dataID": "117563",
        "id": "53091205",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:55",
        "brokerTime": "2025-05-14 15:06:56",
        "commission": -57.96,
        "swap": 0,
        "profit": -637.56,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054282",
        "positionId": "56054280",
        "volume": 8.28,
        "price": 3222.56,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -695.52,
        "priceIn": 3221.79,
        "doubleCheck": true
    },
    {
        "dataID": "117564",
        "id": "53091206",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:56",
        "brokerTime": "2025-05-14 15:06:56",
        "commission": -1.19,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054283",
        "positionId": "56054283",
        "volume": 0.17,
        "price": 3222.38,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3122.38,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -1.19,
        "priceIn": 3222.38,
        "doubleCheck": true
    },
    {
        "dataID": "117565",
        "id": "53091207",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:56",
        "brokerTime": "2025-05-14 15:06:56",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054284",
        "positionId": "56054284",
        "volume": 8.11,
        "price": 3222.48,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3222.48,
        "doubleCheck": true
    },
    {
        "dataID": "117566",
        "id": "53091209",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:56",
        "brokerTime": "2025-05-14 15:06:57",
        "commission": -56.77,
        "swap": 0,
        "profit": -129.76,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054286",
        "positionId": "56054284",
        "volume": 8.11,
        "price": 3222.64,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -186.53,
        "priceIn": 3222.48,
        "doubleCheck": true
    },
    {
        "dataID": "117567",
        "id": "53091211",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:57",
        "brokerTime": "2025-05-14 15:06:57",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054287",
        "positionId": "56054287",
        "volume": 8.11,
        "price": 3222.42,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3222.42,
        "doubleCheck": true
    },
    {
        "dataID": "117568",
        "id": "53091212",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:57",
        "brokerTime": "2025-05-14 15:06:58",
        "commission": -56.77,
        "swap": 0,
        "profit": -194.64,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054288",
        "positionId": "56054287",
        "volume": 8.11,
        "price": 3222.66,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -251.41,
        "priceIn": 3222.42,
        "doubleCheck": true
    },
    {
        "dataID": "117569",
        "id": "53091213",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:59",
        "brokerTime": "2025-05-14 15:06:59",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054289",
        "positionId": "56054289",
        "volume": 8.11,
        "price": 3222.47,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3222.47,
        "doubleCheck": true
    },
    {
        "dataID": "117570",
        "id": "53091214",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:59",
        "brokerTime": "2025-05-14 15:06:59",
        "commission": -56.77,
        "swap": 0,
        "profit": 72.99,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054290",
        "positionId": "56054289",
        "volume": 8.11,
        "price": 3222.38,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 16.21999999999999,
        "priceIn": 3222.47,
        "doubleCheck": true
    },
    {
        "dataID": "117571",
        "id": "53091215",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:59",
        "brokerTime": "2025-05-14 15:06:59",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054291",
        "positionId": "56054291",
        "volume": 8.11,
        "price": 3222.21,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3222.21,
        "doubleCheck": true
    },
    {
        "dataID": "117572",
        "id": "53091216",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:59",
        "brokerTime": "2025-05-14 15:07:00",
        "commission": -56.77,
        "swap": 0,
        "profit": -275.74,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054292",
        "positionId": "56054291",
        "volume": 8.11,
        "price": 3222.55,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -332.51,
        "priceIn": 3222.21,
        "doubleCheck": true
    },
    {
        "dataID": "117573",
        "id": "53091218",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:01",
        "brokerTime": "2025-05-14 15:07:01",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054294",
        "positionId": "56054294",
        "volume": 8.11,
        "price": 3222.38,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3222.38,
        "doubleCheck": true
    },
    {
        "dataID": "117574",
        "id": "53091220",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:01",
        "brokerTime": "2025-05-14 15:07:01",
        "commission": -56.77,
        "swap": 0,
        "profit": -218.97,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054295",
        "positionId": "56054294",
        "volume": 8.11,
        "price": 3222.65,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -275.74,
        "priceIn": 3222.38,
        "doubleCheck": true
    },
    {
        "dataID": "117575",
        "id": "53091222",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:02",
        "brokerTime": "2025-05-14 15:07:02",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054297",
        "positionId": "56054297",
        "volume": 8.11,
        "price": 3222.41,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3222.41,
        "doubleCheck": true
    },
    {
        "dataID": "117576",
        "id": "53091223",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:02",
        "brokerTime": "2025-05-14 15:07:03",
        "commission": -56.77,
        "swap": 0,
        "profit": -16.22,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054298",
        "positionId": "56054297",
        "volume": 8.11,
        "price": 3222.43,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -72.99000000000001,
        "priceIn": 3222.41,
        "doubleCheck": true
    },
    {
        "dataID": "117577",
        "id": "53091224",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:03",
        "brokerTime": "2025-05-14 15:07:03",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054299",
        "positionId": "56054299",
        "volume": 8.11,
        "price": 3221.93,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3221.93,
        "doubleCheck": true
    },
    {
        "dataID": "117578",
        "id": "53091225",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:03",
        "brokerTime": "2025-05-14 15:07:04",
        "commission": -56.77,
        "swap": 0,
        "profit": 162.2,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054300",
        "positionId": "56054299",
        "volume": 8.11,
        "price": 3221.73,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 105.42999999999998,
        "priceIn": 3221.93,
        "doubleCheck": true
    },
    {
        "dataID": "117579",
        "id": "53091226",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:04",
        "brokerTime": "2025-05-14 15:07:04",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054301",
        "positionId": "56054301",
        "volume": 8.11,
        "price": 3221.59,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3221.59,
        "doubleCheck": true
    },
    {
        "dataID": "117580",
        "id": "53091227",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:04",
        "brokerTime": "2025-05-14 15:07:05",
        "commission": -56.77,
        "swap": 0,
        "profit": -113.54,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054302",
        "positionId": "56054301",
        "volume": 8.11,
        "price": 3221.73,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -170.31,
        "priceIn": 3221.59,
        "doubleCheck": true
    },
    {
        "dataID": "117581",
        "id": "53091228",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:05",
        "brokerTime": "2025-05-14 15:07:05",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054303",
        "positionId": "56054303",
        "volume": 8.11,
        "price": 3221.58,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3221.58,
        "doubleCheck": true
    },
    {
        "dataID": "117582",
        "id": "53091229",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:05",
        "brokerTime": "2025-05-14 15:07:06",
        "commission": -56.77,
        "swap": 0,
        "profit": -243.3,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054304",
        "positionId": "56054303",
        "volume": 8.11,
        "price": 3221.88,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -300.07,
        "priceIn": 3221.58,
        "doubleCheck": true
    },
    {
        "dataID": "117583",
        "id": "53091230",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:06",
        "brokerTime": "2025-05-14 15:07:06",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054305",
        "positionId": "56054305",
        "volume": 8.11,
        "price": 3221.51,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3221.51,
        "doubleCheck": true
    },
    {
        "dataID": "117584",
        "id": "53091231",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:06",
        "brokerTime": "2025-05-14 15:07:07",
        "commission": -56.77,
        "swap": 0,
        "profit": -64.88,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054306",
        "positionId": "56054305",
        "volume": 8.11,
        "price": 3221.59,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -121.65,
        "priceIn": 3221.51,
        "doubleCheck": true
    },
    {
        "dataID": "117585",
        "id": "53091232",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:07",
        "brokerTime": "2025-05-14 15:07:07",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054307",
        "positionId": "56054307",
        "volume": 8.11,
        "price": 3221.41,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3221.41,
        "doubleCheck": true
    },
    {
        "dataID": "117586",
        "id": "53091233",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:07",
        "brokerTime": "2025-05-14 15:07:08",
        "commission": -56.77,
        "swap": 0,
        "profit": -162.2,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054308",
        "positionId": "56054307",
        "volume": 8.11,
        "price": 3221.61,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -218.97,
        "priceIn": 3221.41,
        "doubleCheck": true
    },
    {
        "dataID": "117587",
        "id": "53091234",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:09",
        "brokerTime": "2025-05-14 15:07:09",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054309",
        "positionId": "56054309",
        "volume": 8.11,
        "price": 3221.31,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3221.31,
        "doubleCheck": true
    },
    {
        "dataID": "117588",
        "id": "53091235",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:09",
        "brokerTime": "2025-05-14 15:07:09",
        "commission": -56.77,
        "swap": 0,
        "profit": -162.2,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054310",
        "positionId": "56054309",
        "volume": 8.11,
        "price": 3221.51,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -218.97,
        "priceIn": 3221.31,
        "doubleCheck": true
    },
    {
        "dataID": "117589",
        "id": "53091236",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:09",
        "brokerTime": "2025-05-14 15:07:09",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054311",
        "positionId": "56054311",
        "volume": 8.11,
        "price": 3221.31,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3221.31,
        "doubleCheck": true
    },
    {
        "dataID": "117590",
        "id": "53091237",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:09",
        "brokerTime": "2025-05-14 15:07:10",
        "commission": -56.77,
        "swap": 0,
        "profit": -162.2,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054312",
        "positionId": "56054311",
        "volume": 8.11,
        "price": 3221.51,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -218.97,
        "priceIn": 3221.31,
        "doubleCheck": true
    },
    {
        "dataID": "117591",
        "id": "53091238",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:10",
        "brokerTime": "2025-05-14 15:07:10",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054313",
        "positionId": "56054313",
        "volume": 8.11,
        "price": 3221.33,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3221.33,
        "doubleCheck": true
    },
    {
        "dataID": "117592",
        "id": "53091239",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:10",
        "brokerTime": "2025-05-14 15:07:11",
        "commission": -56.77,
        "swap": 0,
        "profit": -308.18,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054314",
        "positionId": "56054313",
        "volume": 8.11,
        "price": 3221.71,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -364.95,
        "priceIn": 3221.33,
        "doubleCheck": true
    },
    {
        "dataID": "117593",
        "id": "53091240",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:12",
        "brokerTime": "2025-05-14 15:07:12",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054315",
        "positionId": "56054315",
        "volume": 8.11,
        "price": 3221.51,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3221.51,
        "doubleCheck": true
    },
    {
        "dataID": "117594",
        "id": "53091241",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:12",
        "brokerTime": "2025-05-14 15:07:12",
        "commission": -56.77,
        "swap": 0,
        "profit": -154.09,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054316",
        "positionId": "56054315",
        "volume": 8.11,
        "price": 3221.7,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -210.86,
        "priceIn": 3221.51,
        "doubleCheck": true
    },
    {
        "dataID": "117595",
        "id": "53091242",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:12",
        "brokerTime": "2025-05-14 15:07:12",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054317",
        "positionId": "56054317",
        "volume": 8.11,
        "price": 3221.53,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3221.53,
        "doubleCheck": true
    },
    {
        "dataID": "117596",
        "id": "53091244",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:12",
        "brokerTime": "2025-05-14 15:07:12",
        "commission": -56.77,
        "swap": 0,
        "profit": -48.66,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054319",
        "positionId": "56054317",
        "volume": 8.11,
        "price": 3221.59,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -105.43,
        "priceIn": 3221.53,
        "doubleCheck": true
    },
    {
        "dataID": "117597",
        "id": "53091245",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:13",
        "brokerTime": "2025-05-14 15:07:13",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054320",
        "positionId": "56054320",
        "volume": 8.11,
        "price": 3221.36,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3221.36,
        "doubleCheck": true
    },
    {
        "dataID": "117598",
        "id": "53091246",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:13",
        "brokerTime": "2025-05-14 15:07:14",
        "commission": -56.77,
        "swap": 0,
        "profit": -332.51,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054321",
        "positionId": "56054320",
        "volume": 8.11,
        "price": 3221.77,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -389.28,
        "priceIn": 3221.36,
        "doubleCheck": true
    },
    {
        "dataID": "117599",
        "id": "53091247",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:14",
        "brokerTime": "2025-05-14 15:07:14",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054322",
        "positionId": "56054322",
        "volume": 8.11,
        "price": 3221.45,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3221.45,
        "doubleCheck": true
    },
    {
        "dataID": "117600",
        "id": "53091248",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:14",
        "brokerTime": "2025-05-14 15:07:14",
        "commission": -56.77,
        "swap": 0,
        "profit": -154.09,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054323",
        "positionId": "56054322",
        "volume": 8.11,
        "price": 3221.64,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -210.86,
        "priceIn": 3221.45,
        "doubleCheck": true
    },
    {
        "dataID": "117601",
        "id": "53091249",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:15",
        "brokerTime": "2025-05-14 15:07:15",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054324",
        "positionId": "56054324",
        "volume": 8.11,
        "price": 3221.56,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3221.56,
        "doubleCheck": true
    },
    {
        "dataID": "117602",
        "id": "53091250",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:15",
        "brokerTime": "2025-05-14 15:07:16",
        "commission": -56.77,
        "swap": 0,
        "profit": -113.54,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054325",
        "positionId": "56054324",
        "volume": 8.11,
        "price": 3221.7,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -170.31,
        "priceIn": 3221.56,
        "doubleCheck": true
    },
    {
        "dataID": "117603",
        "id": "53091251",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:16",
        "brokerTime": "2025-05-14 15:07:16",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054326",
        "positionId": "56054326",
        "volume": 8.11,
        "price": 3221.56,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3221.56,
        "doubleCheck": true
    },
    {
        "dataID": "117604",
        "id": "53091252",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:16",
        "brokerTime": "2025-05-14 15:07:17",
        "commission": -56.77,
        "swap": 0,
        "profit": -137.87,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054327",
        "positionId": "56054326",
        "volume": 8.11,
        "price": 3221.73,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -194.64000000000001,
        "priceIn": 3221.56,
        "doubleCheck": true
    },
    {
        "dataID": "117605",
        "id": "53091253",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:17",
        "brokerTime": "2025-05-14 15:07:17",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054328",
        "positionId": "56054328",
        "volume": 8.11,
        "price": 3221.56,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3221.56,
        "doubleCheck": true
    },
    {
        "dataID": "117606",
        "id": "53091254",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:17",
        "brokerTime": "2025-05-14 15:07:18",
        "commission": -56.77,
        "swap": 0,
        "profit": -154.09,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054329",
        "positionId": "56054328",
        "volume": 8.11,
        "price": 3221.75,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -210.86,
        "priceIn": 3221.56,
        "doubleCheck": true
    },
    {
        "dataID": "117607",
        "id": "53091255",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:18",
        "brokerTime": "2025-05-14 15:07:18",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054330",
        "positionId": "56054330",
        "volume": 8.11,
        "price": 3221.58,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3221.58,
        "doubleCheck": true
    },
    {
        "dataID": "117608",
        "id": "53091256",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:18",
        "brokerTime": "2025-05-14 15:07:18",
        "commission": -56.77,
        "swap": 0,
        "profit": -162.2,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054331",
        "positionId": "56054330",
        "volume": 8.11,
        "price": 3221.78,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -218.97,
        "priceIn": 3221.58,
        "doubleCheck": true
    },
    {
        "dataID": "117609",
        "id": "53091257",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:19",
        "brokerTime": "2025-05-14 15:07:19",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054332",
        "positionId": "56054332",
        "volume": 8.11,
        "price": 3221.56,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3221.56,
        "doubleCheck": true
    },
    {
        "dataID": "117610",
        "id": "53091258",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:19",
        "brokerTime": "2025-05-14 15:07:20",
        "commission": -56.77,
        "swap": 0,
        "profit": -113.54,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054334",
        "positionId": "56054332",
        "volume": 8.11,
        "price": 3221.7,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -170.31,
        "priceIn": 3221.56,
        "doubleCheck": true
    },
    {
        "dataID": "117611",
        "id": "53091259",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:22",
        "brokerTime": "2025-05-14 15:07:22",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054335",
        "positionId": "56054335",
        "volume": 8.11,
        "price": 3221.56,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3221.56,
        "doubleCheck": true
    },
    {
        "dataID": "117612",
        "id": "53091260",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:22",
        "brokerTime": "2025-05-14 15:07:23",
        "commission": -56.77,
        "swap": 0,
        "profit": -154.09,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054336",
        "positionId": "56054335",
        "volume": 8.11,
        "price": 3221.75,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -210.86,
        "priceIn": 3221.56,
        "doubleCheck": true
    },
    {
        "dataID": "117613",
        "id": "53091261",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:24",
        "brokerTime": "2025-05-14 15:07:24",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054337",
        "positionId": "56054337",
        "volume": 8.11,
        "price": 3221.62,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3221.62,
        "doubleCheck": true
    },
    {
        "dataID": "117614",
        "id": "53091262",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:24",
        "brokerTime": "2025-05-14 15:07:25",
        "commission": -56.77,
        "swap": 0,
        "profit": -251.41,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054338",
        "positionId": "56054337",
        "volume": 8.11,
        "price": 3221.93,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -308.18,
        "priceIn": 3221.62,
        "doubleCheck": true
    },
    {
        "dataID": "117615",
        "id": "53091263",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:25",
        "brokerTime": "2025-05-14 15:07:25",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054339",
        "positionId": "56054339",
        "volume": 8.11,
        "price": 3221.7,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3221.7,
        "doubleCheck": true
    },
    {
        "dataID": "117616",
        "id": "53091264",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:25",
        "brokerTime": "2025-05-14 15:07:26",
        "commission": -56.77,
        "swap": 0,
        "profit": -178.42,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054340",
        "positionId": "56054339",
        "volume": 8.11,
        "price": 3221.92,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -235.19,
        "priceIn": 3221.7,
        "doubleCheck": true
    },
    {
        "dataID": "117617",
        "id": "53091265",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:26",
        "brokerTime": "2025-05-14 15:07:26",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054341",
        "positionId": "56054341",
        "volume": 8.11,
        "price": 3221.76,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3221.76,
        "doubleCheck": true
    },
    {
        "dataID": "117618",
        "id": "53091266",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:26",
        "brokerTime": "2025-05-14 15:07:26",
        "commission": -56.77,
        "swap": 0,
        "profit": -32.44,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054342",
        "positionId": "56054341",
        "volume": 8.11,
        "price": 3221.8,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -89.21000000000001,
        "priceIn": 3221.76,
        "doubleCheck": true
    },
    {
        "dataID": "117619",
        "id": "53091267",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:27",
        "brokerTime": "2025-05-14 15:07:27",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054343",
        "positionId": "56054343",
        "volume": 8.11,
        "price": 3221.7,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3221.7,
        "doubleCheck": true
    },
    {
        "dataID": "117620",
        "id": "53091268",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:27",
        "brokerTime": "2025-05-14 15:07:27",
        "commission": -56.77,
        "swap": 0,
        "profit": -227.08,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054344",
        "positionId": "56054343",
        "volume": 8.11,
        "price": 3221.98,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -283.85,
        "priceIn": 3221.7,
        "doubleCheck": true
    },
    {
        "dataID": "117621",
        "id": "53091269",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:27",
        "brokerTime": "2025-05-14 15:07:27",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054345",
        "positionId": "56054345",
        "volume": 8.11,
        "price": 3221.84,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3221.84,
        "doubleCheck": true
    },
    {
        "dataID": "117622",
        "id": "53091270",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:27",
        "brokerTime": "2025-05-14 15:07:28",
        "commission": -56.77,
        "swap": 0,
        "profit": -81.1,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054346",
        "positionId": "56054345",
        "volume": 8.11,
        "price": 3221.94,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -137.87,
        "priceIn": 3221.84,
        "doubleCheck": true
    },
    {
        "dataID": "117623",
        "id": "53091271",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:28",
        "brokerTime": "2025-05-14 15:07:28",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054347",
        "positionId": "56054347",
        "volume": 8.11,
        "price": 3221.8,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3221.8,
        "doubleCheck": true
    },
    {
        "dataID": "117624",
        "id": "53091272",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:28",
        "brokerTime": "2025-05-14 15:07:29",
        "commission": -56.77,
        "swap": 0,
        "profit": -137.87,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054348",
        "positionId": "56054347",
        "volume": 8.11,
        "price": 3221.97,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -194.64000000000001,
        "priceIn": 3221.8,
        "doubleCheck": true
    },
    {
        "dataID": "117625",
        "id": "53091273",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:30",
        "brokerTime": "2025-05-14 15:07:30",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054349",
        "positionId": "56054349",
        "volume": 8.11,
        "price": 3221.49,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3221.49,
        "doubleCheck": true
    },
    {
        "dataID": "117626",
        "id": "53091274",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:30",
        "brokerTime": "2025-05-14 15:07:30",
        "commission": -56.77,
        "swap": 0,
        "profit": -8.11,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054350",
        "positionId": "56054349",
        "volume": 8.11,
        "price": 3221.5,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -64.88,
        "priceIn": 3221.49,
        "doubleCheck": true
    },
    {
        "dataID": "117627",
        "id": "53091275",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:30",
        "brokerTime": "2025-05-14 15:07:30",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054351",
        "positionId": "56054351",
        "volume": 8.11,
        "price": 3221.43,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3221.43,
        "doubleCheck": true
    },
    {
        "dataID": "117628",
        "id": "53091276",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:30",
        "brokerTime": "2025-05-14 15:07:31",
        "commission": -56.77,
        "swap": 0,
        "profit": -202.75,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054352",
        "positionId": "56054351",
        "volume": 8.11,
        "price": 3221.68,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -259.52,
        "priceIn": 3221.43,
        "doubleCheck": true
    },
    {
        "dataID": "117629",
        "id": "53091277",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:31",
        "brokerTime": "2025-05-14 15:07:31",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054353",
        "positionId": "56054353",
        "volume": 8.11,
        "price": 3221.45,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3221.45,
        "doubleCheck": true
    },
    {
        "dataID": "117630",
        "id": "53091278",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:31",
        "brokerTime": "2025-05-14 15:07:31",
        "commission": -56.77,
        "swap": 0,
        "profit": -178.42,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054354",
        "positionId": "56054353",
        "volume": 8.11,
        "price": 3221.67,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -235.19,
        "priceIn": 3221.45,
        "doubleCheck": true
    },
    {
        "dataID": "117631",
        "id": "53091280",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:33",
        "brokerTime": "2025-05-14 15:07:33",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054356",
        "positionId": "56054356",
        "volume": 8.11,
        "price": 3221.51,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3221.51,
        "doubleCheck": true
    },
    {
        "dataID": "117632",
        "id": "53091281",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:33",
        "brokerTime": "2025-05-14 15:07:34",
        "commission": -56.77,
        "swap": 0,
        "profit": -186.53,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054357",
        "positionId": "56054356",
        "volume": 8.11,
        "price": 3221.74,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -243.3,
        "priceIn": 3221.51,
        "doubleCheck": true
    },
    {
        "dataID": "117633",
        "id": "53091282",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:34",
        "brokerTime": "2025-05-14 15:07:34",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054358",
        "positionId": "56054358",
        "volume": 8.11,
        "price": 3221.58,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3221.58,
        "doubleCheck": true
    },
    {
        "dataID": "117634",
        "id": "53091283",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:34",
        "brokerTime": "2025-05-14 15:07:34",
        "commission": -56.77,
        "swap": 0,
        "profit": -186.53,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054359",
        "positionId": "56054358",
        "volume": 8.11,
        "price": 3221.81,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -243.3,
        "priceIn": 3221.58,
        "doubleCheck": true
    },
    {
        "dataID": "117635",
        "id": "53091284",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:35",
        "brokerTime": "2025-05-14 15:07:35",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054360",
        "positionId": "56054360",
        "volume": 8.11,
        "price": 3221.49,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3221.49,
        "doubleCheck": true
    },
    {
        "dataID": "117636",
        "id": "53091285",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:35",
        "brokerTime": "2025-05-14 15:07:35",
        "commission": -56.77,
        "swap": 0,
        "profit": -56.77,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054361",
        "positionId": "56054360",
        "volume": 8.11,
        "price": 3221.56,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -113.54,
        "priceIn": 3221.49,
        "doubleCheck": true
    },
    {
        "dataID": "117637",
        "id": "53091286",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:36",
        "brokerTime": "2025-05-14 15:07:36",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054362",
        "positionId": "56054362",
        "volume": 8.11,
        "price": 3221.5,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3221.5,
        "doubleCheck": true
    },
    {
        "dataID": "117638",
        "id": "53091287",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:36",
        "brokerTime": "2025-05-14 15:07:36",
        "commission": -56.77,
        "swap": 0,
        "profit": -89.21,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054363",
        "positionId": "56054362",
        "volume": 8.11,
        "price": 3221.61,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -145.98,
        "priceIn": 3221.5,
        "doubleCheck": true
    },
    {
        "dataID": "117639",
        "id": "53091288",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:36",
        "brokerTime": "2025-05-14 15:07:36",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054364",
        "positionId": "56054364",
        "volume": 8.11,
        "price": 3221.42,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3221.42,
        "doubleCheck": true
    },
    {
        "dataID": "117640",
        "id": "53091289",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:36",
        "brokerTime": "2025-05-14 15:07:37",
        "commission": -56.77,
        "swap": 0,
        "profit": -186.53,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054365",
        "positionId": "56054364",
        "volume": 8.11,
        "price": 3221.65,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -243.3,
        "priceIn": 3221.42,
        "doubleCheck": true
    },
    {
        "dataID": "117641",
        "id": "53091290",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:37",
        "brokerTime": "2025-05-14 15:07:37",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054366",
        "positionId": "56054366",
        "volume": 8.11,
        "price": 3221.52,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3221.52,
        "doubleCheck": true
    },
    {
        "dataID": "117642",
        "id": "53091291",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:37",
        "brokerTime": "2025-05-14 15:07:38",
        "commission": -56.77,
        "swap": 0,
        "profit": -129.76,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054367",
        "positionId": "56054366",
        "volume": 8.11,
        "price": 3221.68,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -186.53,
        "priceIn": 3221.52,
        "doubleCheck": true
    },
    {
        "dataID": "117643",
        "id": "53091292",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:38",
        "brokerTime": "2025-05-14 15:07:38",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054368",
        "positionId": "56054368",
        "volume": 8.11,
        "price": 3221.42,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3221.42,
        "doubleCheck": true
    },
    {
        "dataID": "117644",
        "id": "53091293",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:38",
        "brokerTime": "2025-05-14 15:07:39",
        "commission": -56.77,
        "swap": 0,
        "profit": -137.87,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054369",
        "positionId": "56054368",
        "volume": 8.11,
        "price": 3221.59,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -194.64000000000001,
        "priceIn": 3221.42,
        "doubleCheck": true
    },
    {
        "dataID": "117645",
        "id": "53091294",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:39",
        "brokerTime": "2025-05-14 15:07:39",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054370",
        "positionId": "56054370",
        "volume": 8.11,
        "price": 3221.5,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3221.5,
        "doubleCheck": true
    },
    {
        "dataID": "117646",
        "id": "53091295",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:39",
        "brokerTime": "2025-05-14 15:07:40",
        "commission": -56.77,
        "swap": 0,
        "profit": -64.88,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054371",
        "positionId": "56054370",
        "volume": 8.11,
        "price": 3221.58,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -121.65,
        "priceIn": 3221.5,
        "doubleCheck": true
    },
    {
        "dataID": "117647",
        "id": "53091296",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:40",
        "brokerTime": "2025-05-14 15:07:40",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054372",
        "positionId": "56054372",
        "volume": 8.11,
        "price": 3220.98,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3220.98,
        "doubleCheck": true
    },
    {
        "dataID": "117648",
        "id": "53091297",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:40",
        "brokerTime": "2025-05-14 15:07:41",
        "commission": -56.77,
        "swap": 0,
        "profit": -121.65,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054373",
        "positionId": "56054372",
        "volume": 8.11,
        "price": 3221.13,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -178.42000000000002,
        "priceIn": 3220.98,
        "doubleCheck": true
    },
    {
        "dataID": "117649",
        "id": "53091300",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:41",
        "brokerTime": "2025-05-14 15:07:41",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054375",
        "positionId": "56054375",
        "volume": 8.11,
        "price": 3220.97,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3220.97,
        "doubleCheck": true
    },
    {
        "dataID": "117650",
        "id": "53091301",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:41",
        "brokerTime": "2025-05-14 15:07:42",
        "commission": -56.77,
        "swap": 0,
        "profit": -162.2,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054376",
        "positionId": "56054375",
        "volume": 8.11,
        "price": 3221.17,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -218.97,
        "priceIn": 3220.97,
        "doubleCheck": true
    },
    {
        "dataID": "117651",
        "id": "53091302",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:42",
        "brokerTime": "2025-05-14 15:07:42",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054377",
        "positionId": "56054377",
        "volume": 8.11,
        "price": 3221.13,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3221.13,
        "doubleCheck": true
    },
    {
        "dataID": "117652",
        "id": "53091303",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:42",
        "brokerTime": "2025-05-14 15:07:43",
        "commission": -56.77,
        "swap": 0,
        "profit": -170.31,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054378",
        "positionId": "56054377",
        "volume": 8.11,
        "price": 3221.34,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -227.08,
        "priceIn": 3221.13,
        "doubleCheck": true
    },
    {
        "dataID": "117653",
        "id": "53091304",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:44",
        "brokerTime": "2025-05-14 15:07:44",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054379",
        "positionId": "56054379",
        "volume": 8.11,
        "price": 3221.17,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3221.17,
        "doubleCheck": true
    },
    {
        "dataID": "117654",
        "id": "53091305",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:44",
        "brokerTime": "2025-05-14 15:07:45",
        "commission": -56.77,
        "swap": 0,
        "profit": -259.52,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054380",
        "positionId": "56054379",
        "volume": 8.11,
        "price": 3221.49,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -316.28999999999996,
        "priceIn": 3221.17,
        "doubleCheck": true
    },
    {
        "dataID": "117655",
        "id": "53091306",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:46",
        "brokerTime": "2025-05-14 15:07:46",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054381",
        "positionId": "56054381",
        "volume": 8.11,
        "price": 3221.16,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3221.16,
        "doubleCheck": true
    },
    {
        "dataID": "117656",
        "id": "53091307",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:46",
        "brokerTime": "2025-05-14 15:07:46",
        "commission": -56.77,
        "swap": 0,
        "profit": -178.42,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054382",
        "positionId": "56054381",
        "volume": 8.11,
        "price": 3221.38,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -235.19,
        "priceIn": 3221.16,
        "doubleCheck": true
    },
    {
        "dataID": "117657",
        "id": "53091308",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:47",
        "brokerTime": "2025-05-14 15:07:47",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054383",
        "positionId": "56054383",
        "volume": 8.11,
        "price": 3221.18,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3221.18,
        "doubleCheck": true
    },
    {
        "dataID": "117658",
        "id": "53091309",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:47",
        "brokerTime": "2025-05-14 15:07:47",
        "commission": -56.77,
        "swap": 0,
        "profit": -178.42,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054384",
        "positionId": "56054383",
        "volume": 8.11,
        "price": 3221.4,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -235.19,
        "priceIn": 3221.18,
        "doubleCheck": true
    },
    {
        "dataID": "117659",
        "id": "53091310",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:47",
        "brokerTime": "2025-05-14 15:07:47",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054385",
        "positionId": "56054385",
        "volume": 8.11,
        "price": 3221.15,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3221.15,
        "doubleCheck": true
    },
    {
        "dataID": "117660",
        "id": "53091311",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:47",
        "brokerTime": "2025-05-14 15:07:48",
        "commission": -56.77,
        "swap": 0,
        "profit": -210.86,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054386",
        "positionId": "56054385",
        "volume": 8.11,
        "price": 3221.41,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -267.63,
        "priceIn": 3221.15,
        "doubleCheck": true
    },
    {
        "dataID": "117661",
        "id": "53091312",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:48",
        "brokerTime": "2025-05-14 15:07:48",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054387",
        "positionId": "56054387",
        "volume": 8.11,
        "price": 3221.15,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3221.15,
        "doubleCheck": true
    },
    {
        "dataID": "117662",
        "id": "53091313",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:48",
        "brokerTime": "2025-05-14 15:07:48",
        "commission": -56.77,
        "swap": 0,
        "profit": -145.98,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054388",
        "positionId": "56054387",
        "volume": 8.11,
        "price": 3221.33,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -202.75,
        "priceIn": 3221.15,
        "doubleCheck": true
    },
    {
        "dataID": "117663",
        "id": "53091314",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:49",
        "brokerTime": "2025-05-14 15:07:49",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054389",
        "positionId": "56054389",
        "volume": 8.11,
        "price": 3221.21,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3221.21,
        "doubleCheck": true
    },
    {
        "dataID": "117664",
        "id": "53091315",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:49",
        "brokerTime": "2025-05-14 15:07:49",
        "commission": -56.77,
        "swap": 0,
        "profit": 40.55,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054390",
        "positionId": "56054389",
        "volume": 8.11,
        "price": 3221.16,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -16.220000000000006,
        "priceIn": 3221.21,
        "doubleCheck": true
    },
    {
        "dataID": "117665",
        "id": "53091316",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:49",
        "brokerTime": "2025-05-14 15:07:49",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054391",
        "positionId": "56054391",
        "volume": 8.11,
        "price": 3220.98,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3220.98,
        "doubleCheck": true
    },
    {
        "dataID": "117666",
        "id": "53091317",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:49",
        "brokerTime": "2025-05-14 15:07:50",
        "commission": -56.77,
        "swap": 0,
        "profit": -121.65,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054392",
        "positionId": "56054391",
        "volume": 8.11,
        "price": 3221.13,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -178.42000000000002,
        "priceIn": 3220.98,
        "doubleCheck": true
    },
    {
        "dataID": "117667",
        "id": "53091320",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:50",
        "brokerTime": "2025-05-14 15:07:50",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054395",
        "positionId": "56054395",
        "volume": 8.11,
        "price": 3220.94,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3220.94,
        "doubleCheck": true
    },
    {
        "dataID": "117668",
        "id": "53091321",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:50",
        "brokerTime": "2025-05-14 15:07:51",
        "commission": -56.77,
        "swap": 0,
        "profit": -154.09,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054396",
        "positionId": "56054395",
        "volume": 8.11,
        "price": 3221.13,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -210.86,
        "priceIn": 3220.94,
        "doubleCheck": true
    },
    {
        "dataID": "117669",
        "id": "53091322",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:51",
        "brokerTime": "2025-05-14 15:07:51",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054397",
        "positionId": "56054397",
        "volume": 8.11,
        "price": 3220.95,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3220.95,
        "doubleCheck": true
    },
    {
        "dataID": "117670",
        "id": "53091323",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:51",
        "brokerTime": "2025-05-14 15:07:52",
        "commission": -56.77,
        "swap": 0,
        "profit": -154.09,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054398",
        "positionId": "56054397",
        "volume": 8.11,
        "price": 3221.14,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -210.86,
        "priceIn": 3220.95,
        "doubleCheck": true
    },
    {
        "dataID": "117671",
        "id": "53091324",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:52",
        "brokerTime": "2025-05-14 15:07:52",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054399",
        "positionId": "56054399",
        "volume": 8.11,
        "price": 3221.03,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3221.03,
        "doubleCheck": true
    },
    {
        "dataID": "117672",
        "id": "53091325",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:52",
        "brokerTime": "2025-05-14 15:07:53",
        "commission": -56.77,
        "swap": 0,
        "profit": -121.65,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054400",
        "positionId": "56054399",
        "volume": 8.11,
        "price": 3221.18,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -178.42000000000002,
        "priceIn": 3221.03,
        "doubleCheck": true
    },
    {
        "dataID": "117673",
        "id": "53091326",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:53",
        "brokerTime": "2025-05-14 15:07:53",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054401",
        "positionId": "56054401",
        "volume": 8.11,
        "price": 3221,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3221,
        "doubleCheck": true
    },
    {
        "dataID": "117674",
        "id": "53091327",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:53",
        "brokerTime": "2025-05-14 15:07:54",
        "commission": -56.77,
        "swap": 0,
        "profit": -210.86,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054402",
        "positionId": "56054401",
        "volume": 8.11,
        "price": 3221.26,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -267.63,
        "priceIn": 3221,
        "doubleCheck": true
    },
    {
        "dataID": "117675",
        "id": "53091328",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:55",
        "brokerTime": "2025-05-14 15:07:55",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054403",
        "positionId": "56054403",
        "volume": 8.11,
        "price": 3221.1,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3221.1,
        "doubleCheck": true
    },
    {
        "dataID": "117676",
        "id": "53091329",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:55",
        "brokerTime": "2025-05-14 15:07:55",
        "commission": -56.77,
        "swap": 0,
        "profit": -121.65,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054404",
        "positionId": "56054403",
        "volume": 8.11,
        "price": 3221.25,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -178.42000000000002,
        "priceIn": 3221.1,
        "doubleCheck": true
    },
    {
        "dataID": "117677",
        "id": "53091330",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:55",
        "brokerTime": "2025-05-14 15:07:55",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054405",
        "positionId": "56054405",
        "volume": 8.11,
        "price": 3221.04,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3221.04,
        "doubleCheck": true
    },
    {
        "dataID": "117678",
        "id": "53091331",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:55",
        "brokerTime": "2025-05-14 15:07:56",
        "commission": -56.77,
        "swap": 0,
        "profit": -97.32,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054406",
        "positionId": "56054405",
        "volume": 8.11,
        "price": 3221.16,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -154.09,
        "priceIn": 3221.04,
        "doubleCheck": true
    },
    {
        "dataID": "117679",
        "id": "53091332",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:56",
        "brokerTime": "2025-05-14 15:07:56",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054407",
        "positionId": "56054407",
        "volume": 8.11,
        "price": 3221.01,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3221.01,
        "doubleCheck": true
    },
    {
        "dataID": "117680",
        "id": "53091333",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:56",
        "brokerTime": "2025-05-14 15:07:57",
        "commission": -56.77,
        "swap": 0,
        "profit": -145.98,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054408",
        "positionId": "56054407",
        "volume": 8.11,
        "price": 3221.19,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -202.75,
        "priceIn": 3221.01,
        "doubleCheck": true
    },
    {
        "dataID": "117681",
        "id": "53091334",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:57",
        "brokerTime": "2025-05-14 15:07:57",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054409",
        "positionId": "56054409",
        "volume": 8.11,
        "price": 3220.96,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3220.96,
        "doubleCheck": true
    },
    {
        "dataID": "117682",
        "id": "53091335",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:57",
        "brokerTime": "2025-05-14 15:07:58",
        "commission": -56.77,
        "swap": 0,
        "profit": -145.98,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054410",
        "positionId": "56054409",
        "volume": 8.11,
        "price": 3221.14,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -202.75,
        "priceIn": 3220.96,
        "doubleCheck": true
    },
    {
        "dataID": "117683",
        "id": "53091336",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:59",
        "brokerTime": "2025-05-14 15:07:59",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054411",
        "positionId": "56054411",
        "volume": 8.11,
        "price": 3220.95,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3220.95,
        "doubleCheck": true
    },
    {
        "dataID": "117684",
        "id": "53091337",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:59",
        "brokerTime": "2025-05-14 15:07:59",
        "commission": -56.77,
        "swap": 0,
        "profit": -129.76,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054412",
        "positionId": "56054411",
        "volume": 8.11,
        "price": 3221.11,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -186.53,
        "priceIn": 3220.95,
        "doubleCheck": true
    },
    {
        "dataID": "117685",
        "id": "53091338",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:00",
        "brokerTime": "2025-05-14 15:08:00",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054414",
        "positionId": "56054414",
        "volume": 8.11,
        "price": 3220.94,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3220.94,
        "doubleCheck": true
    },
    {
        "dataID": "117686",
        "id": "53091339",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:00",
        "brokerTime": "2025-05-14 15:08:01",
        "commission": -56.77,
        "swap": 0,
        "profit": -283.85,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054415",
        "positionId": "56054414",
        "volume": 8.11,
        "price": 3221.29,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -340.62,
        "priceIn": 3220.94,
        "doubleCheck": true
    },
    {
        "dataID": "117687",
        "id": "53091340",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:01",
        "brokerTime": "2025-05-14 15:08:01",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054416",
        "positionId": "56054416",
        "volume": 8.11,
        "price": 3220.91,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3220.91,
        "doubleCheck": true
    },
    {
        "dataID": "117688",
        "id": "53091341",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:01",
        "brokerTime": "2025-05-14 15:08:02",
        "commission": -56.77,
        "swap": 0,
        "profit": -121.65,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054417",
        "positionId": "56054416",
        "volume": 8.11,
        "price": 3221.06,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -178.42000000000002,
        "priceIn": 3220.91,
        "doubleCheck": true
    },
    {
        "dataID": "117689",
        "id": "53091342",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:03",
        "brokerTime": "2025-05-14 15:08:03",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054418",
        "positionId": "56054418",
        "volume": 8.11,
        "price": 3221.35,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3221.35,
        "doubleCheck": true
    },
    {
        "dataID": "117690",
        "id": "53091343",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:03",
        "brokerTime": "2025-05-14 15:08:04",
        "commission": -56.77,
        "swap": 0,
        "profit": 105.43,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054419",
        "positionId": "56054418",
        "volume": 8.11,
        "price": 3221.22,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 48.660000000000004,
        "priceIn": 3221.35,
        "doubleCheck": true
    },
    {
        "dataID": "117691",
        "id": "53091344",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:04",
        "brokerTime": "2025-05-14 15:08:04",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054420",
        "positionId": "56054420",
        "volume": 8.11,
        "price": 3221.08,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3221.08,
        "doubleCheck": true
    },
    {
        "dataID": "117692",
        "id": "53091345",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:04",
        "brokerTime": "2025-05-14 15:08:05",
        "commission": -56.77,
        "swap": 0,
        "profit": -48.66,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054421",
        "positionId": "56054420",
        "volume": 8.11,
        "price": 3221.14,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -105.43,
        "priceIn": 3221.08,
        "doubleCheck": true
    },
    {
        "dataID": "117693",
        "id": "53091346",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:05",
        "brokerTime": "2025-05-14 15:08:05",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054422",
        "positionId": "56054422",
        "volume": 8.11,
        "price": 3220.97,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3220.97,
        "doubleCheck": true
    },
    {
        "dataID": "117694",
        "id": "53091347",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:05",
        "brokerTime": "2025-05-14 15:08:05",
        "commission": -56.77,
        "swap": 0,
        "profit": -48.66,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054423",
        "positionId": "56054422",
        "volume": 8.11,
        "price": 3221.03,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -105.43,
        "priceIn": 3220.97,
        "doubleCheck": true
    },
    {
        "dataID": "117695",
        "id": "53091348",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:06",
        "brokerTime": "2025-05-14 15:08:06",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054424",
        "positionId": "56054424",
        "volume": 8.11,
        "price": 3220.84,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3220.84,
        "doubleCheck": true
    },
    {
        "dataID": "117696",
        "id": "53091349",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:06",
        "brokerTime": "2025-05-14 15:08:07",
        "commission": -56.77,
        "swap": 0,
        "profit": -145.98,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054425",
        "positionId": "56054424",
        "volume": 8.11,
        "price": 3221.02,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -202.75,
        "priceIn": 3220.84,
        "doubleCheck": true
    },
    {
        "dataID": "117697",
        "id": "53091350",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:07",
        "brokerTime": "2025-05-14 15:08:07",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054426",
        "positionId": "56054426",
        "volume": 8.11,
        "price": 3220.92,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3220.92,
        "doubleCheck": true
    },
    {
        "dataID": "117698",
        "id": "53091351",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:07",
        "brokerTime": "2025-05-14 15:08:07",
        "commission": -56.77,
        "swap": 0,
        "profit": -129.76,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054427",
        "positionId": "56054426",
        "volume": 8.11,
        "price": 3221.08,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -186.53,
        "priceIn": 3220.92,
        "doubleCheck": true
    },
    {
        "dataID": "117699",
        "id": "53091352",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:08",
        "brokerTime": "2025-05-14 15:08:08",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054428",
        "positionId": "56054428",
        "volume": 8.11,
        "price": 3221.09,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3221.09,
        "doubleCheck": true
    },
    {
        "dataID": "117700",
        "id": "53091353",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:08",
        "brokerTime": "2025-05-14 15:08:08",
        "commission": -56.77,
        "swap": 0,
        "profit": -145.98,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054429",
        "positionId": "56054428",
        "volume": 8.11,
        "price": 3221.27,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -202.75,
        "priceIn": 3221.09,
        "doubleCheck": true
    },
    {
        "dataID": "117701",
        "id": "53091354",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:09",
        "brokerTime": "2025-05-14 15:08:09",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054430",
        "positionId": "56054430",
        "volume": 8.11,
        "price": 3221.13,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3221.13,
        "doubleCheck": true
    },
    {
        "dataID": "117702",
        "id": "53091355",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:09",
        "brokerTime": "2025-05-14 15:08:09",
        "commission": -56.77,
        "swap": 0,
        "profit": -194.64,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054431",
        "positionId": "56054430",
        "volume": 8.11,
        "price": 3221.37,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -251.41,
        "priceIn": 3221.13,
        "doubleCheck": true
    },
    {
        "dataID": "117703",
        "id": "53091356",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:09",
        "brokerTime": "2025-05-14 15:08:09",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054432",
        "positionId": "56054432",
        "volume": 8.11,
        "price": 3221.27,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3221.27,
        "doubleCheck": true
    },
    {
        "dataID": "117704",
        "id": "53091357",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:09",
        "brokerTime": "2025-05-14 15:08:09",
        "commission": -56.77,
        "swap": 0,
        "profit": -275.74,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054433",
        "positionId": "56054432",
        "volume": 8.11,
        "price": 3221.61,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -332.51,
        "priceIn": 3221.27,
        "doubleCheck": true
    },
    {
        "dataID": "117705",
        "id": "53091358",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:10",
        "brokerTime": "2025-05-14 15:08:10",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054434",
        "positionId": "56054434",
        "volume": 8.11,
        "price": 3221.46,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3221.46,
        "doubleCheck": true
    },
    {
        "dataID": "117706",
        "id": "53091359",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:10",
        "brokerTime": "2025-05-14 15:08:10",
        "commission": -56.77,
        "swap": 0,
        "profit": -194.64,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054435",
        "positionId": "56054434",
        "volume": 8.11,
        "price": 3221.7,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -251.41,
        "priceIn": 3221.46,
        "doubleCheck": true
    },
    {
        "dataID": "117707",
        "id": "53091360",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:11",
        "brokerTime": "2025-05-14 15:08:11",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054436",
        "positionId": "56054436",
        "volume": 8.11,
        "price": 3221.62,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3221.62,
        "doubleCheck": true
    },
    {
        "dataID": "117708",
        "id": "53091361",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:11",
        "brokerTime": "2025-05-14 15:08:12",
        "commission": -56.77,
        "swap": 0,
        "profit": -145.98,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054437",
        "positionId": "56054436",
        "volume": 8.11,
        "price": 3221.8,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -202.75,
        "priceIn": 3221.62,
        "doubleCheck": true
    },
    {
        "dataID": "117709",
        "id": "53091363",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:13",
        "brokerTime": "2025-05-14 15:08:13",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054439",
        "positionId": "56054439",
        "volume": 8.11,
        "price": 3221.58,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3221.58,
        "doubleCheck": true
    },
    {
        "dataID": "117710",
        "id": "53091364",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:13",
        "brokerTime": "2025-05-14 15:08:14",
        "commission": -56.77,
        "swap": 0,
        "profit": -170.31,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054440",
        "positionId": "56054439",
        "volume": 8.11,
        "price": 3221.79,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -227.08,
        "priceIn": 3221.58,
        "doubleCheck": true
    },
    {
        "dataID": "117711",
        "id": "53091365",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:14",
        "brokerTime": "2025-05-14 15:08:14",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054441",
        "positionId": "56054441",
        "volume": 8.11,
        "price": 3221.65,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3221.65,
        "doubleCheck": true
    },
    {
        "dataID": "117712",
        "id": "53091366",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:14",
        "brokerTime": "2025-05-14 15:08:14",
        "commission": -56.77,
        "swap": 0,
        "profit": -170.31,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054442",
        "positionId": "56054441",
        "volume": 8.11,
        "price": 3221.86,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -227.08,
        "priceIn": 3221.65,
        "doubleCheck": true
    },
    {
        "dataID": "117713",
        "id": "53091367",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:15",
        "brokerTime": "2025-05-14 15:08:15",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054443",
        "positionId": "56054443",
        "volume": 8.11,
        "price": 3221.63,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3221.63,
        "doubleCheck": true
    },
    {
        "dataID": "117714",
        "id": "53091368",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:15",
        "brokerTime": "2025-05-14 15:08:16",
        "commission": -56.77,
        "swap": 0,
        "profit": -40.55,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054444",
        "positionId": "56054443",
        "volume": 8.11,
        "price": 3221.68,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -97.32,
        "priceIn": 3221.63,
        "doubleCheck": true
    },
    {
        "dataID": "117715",
        "id": "53091369",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:16",
        "brokerTime": "2025-05-14 15:08:16",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054445",
        "positionId": "56054445",
        "volume": 8.11,
        "price": 3221.57,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3221.57,
        "doubleCheck": true
    },
    {
        "dataID": "117716",
        "id": "53091370",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:16",
        "brokerTime": "2025-05-14 15:08:17",
        "commission": -56.77,
        "swap": 0,
        "profit": -105.43,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054446",
        "positionId": "56054445",
        "volume": 8.11,
        "price": 3221.7,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -162.20000000000002,
        "priceIn": 3221.57,
        "doubleCheck": true
    },
    {
        "dataID": "117717",
        "id": "53091371",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:17",
        "brokerTime": "2025-05-14 15:08:17",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054447",
        "positionId": "56054447",
        "volume": 8.11,
        "price": 3221.57,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3221.57,
        "doubleCheck": true
    },
    {
        "dataID": "117718",
        "id": "53091372",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:17",
        "brokerTime": "2025-05-14 15:08:18",
        "commission": -56.77,
        "swap": 0,
        "profit": -267.63,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054449",
        "positionId": "56054447",
        "volume": 8.11,
        "price": 3221.9,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -324.4,
        "priceIn": 3221.57,
        "doubleCheck": true
    },
    {
        "dataID": "117719",
        "id": "53091374",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:18",
        "brokerTime": "2025-05-14 15:08:18",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054450",
        "positionId": "56054450",
        "volume": 8.11,
        "price": 3221.64,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3221.64,
        "doubleCheck": true
    },
    {
        "dataID": "117720",
        "id": "53091375",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:18",
        "brokerTime": "2025-05-14 15:08:19",
        "commission": -56.77,
        "swap": 0,
        "profit": -137.87,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054451",
        "positionId": "56054450",
        "volume": 8.11,
        "price": 3221.81,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -194.64000000000001,
        "priceIn": 3221.64,
        "doubleCheck": true
    },
    {
        "dataID": "117721",
        "id": "53091376",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:20",
        "brokerTime": "2025-05-14 15:08:20",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054452",
        "positionId": "56054452",
        "volume": 8.11,
        "price": 3221.62,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3221.62,
        "doubleCheck": true
    },
    {
        "dataID": "117722",
        "id": "53091377",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:20",
        "brokerTime": "2025-05-14 15:08:21",
        "commission": -56.77,
        "swap": 0,
        "profit": -162.2,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054453",
        "positionId": "56054452",
        "volume": 8.11,
        "price": 3221.82,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -218.97,
        "priceIn": 3221.62,
        "doubleCheck": true
    },
    {
        "dataID": "117723",
        "id": "53091378",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:21",
        "brokerTime": "2025-05-14 15:08:21",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054454",
        "positionId": "56054454",
        "volume": 8.11,
        "price": 3221.64,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3221.64,
        "doubleCheck": true
    },
    {
        "dataID": "117724",
        "id": "53091379",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:21",
        "brokerTime": "2025-05-14 15:08:21",
        "commission": -56.77,
        "swap": 0,
        "profit": -121.65,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054455",
        "positionId": "56054454",
        "volume": 8.11,
        "price": 3221.79,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -178.42000000000002,
        "priceIn": 3221.64,
        "doubleCheck": true
    },
    {
        "dataID": "117725",
        "id": "53091380",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:22",
        "brokerTime": "2025-05-14 15:08:22",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054456",
        "positionId": "56054456",
        "volume": 8.11,
        "price": 3221.98,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3221.98,
        "doubleCheck": true
    },
    {
        "dataID": "117726",
        "id": "53091381",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:22",
        "brokerTime": "2025-05-14 15:08:22",
        "commission": -56.77,
        "swap": 0,
        "profit": -24.33,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054457",
        "positionId": "56054456",
        "volume": 8.11,
        "price": 3222.01,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -81.1,
        "priceIn": 3221.98,
        "doubleCheck": true
    },
    {
        "dataID": "117727",
        "id": "53091382",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:22",
        "brokerTime": "2025-05-14 15:08:22",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054458",
        "positionId": "56054458",
        "volume": 8.11,
        "price": 3221.86,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3221.86,
        "doubleCheck": true
    },
    {
        "dataID": "117728",
        "id": "53091383",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:22",
        "brokerTime": "2025-05-14 15:08:23",
        "commission": -56.77,
        "swap": 0,
        "profit": -243.3,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054459",
        "positionId": "56054458",
        "volume": 8.11,
        "price": 3222.16,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -300.07,
        "priceIn": 3221.86,
        "doubleCheck": true
    },
    {
        "dataID": "117729",
        "id": "53091384",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:23",
        "brokerTime": "2025-05-14 15:08:23",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054460",
        "positionId": "56054460",
        "volume": 8.11,
        "price": 3221.92,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3221.92,
        "doubleCheck": true
    },
    {
        "dataID": "117730",
        "id": "53091385",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:23",
        "brokerTime": "2025-05-14 15:08:24",
        "commission": -56.77,
        "swap": 0,
        "profit": -105.43,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054461",
        "positionId": "56054460",
        "volume": 8.11,
        "price": 3222.05,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -162.20000000000002,
        "priceIn": 3221.92,
        "doubleCheck": true
    },
    {
        "dataID": "117731",
        "id": "53091386",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:25",
        "brokerTime": "2025-05-14 15:08:25",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054462",
        "positionId": "56054462",
        "volume": 8.11,
        "price": 3221.94,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3221.94,
        "doubleCheck": true
    },
    {
        "dataID": "117732",
        "id": "53091387",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:25",
        "brokerTime": "2025-05-14 15:08:25",
        "commission": -56.77,
        "swap": 0,
        "profit": -105.43,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054463",
        "positionId": "56054462",
        "volume": 8.11,
        "price": 3222.07,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -162.20000000000002,
        "priceIn": 3221.94,
        "doubleCheck": true
    },
    {
        "dataID": "117733",
        "id": "53091388",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:27",
        "brokerTime": "2025-05-14 15:08:27",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054464",
        "positionId": "56054464",
        "volume": 8.11,
        "price": 3221.81,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3221.81,
        "doubleCheck": true
    },
    {
        "dataID": "117734",
        "id": "53091389",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:27",
        "brokerTime": "2025-05-14 15:08:28",
        "commission": -56.77,
        "swap": 0,
        "profit": -170.31,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054465",
        "positionId": "56054464",
        "volume": 8.11,
        "price": 3222.02,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -227.08,
        "priceIn": 3221.81,
        "doubleCheck": true
    },
    {
        "dataID": "117735",
        "id": "53091390",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:29",
        "brokerTime": "2025-05-14 15:08:29",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054466",
        "positionId": "56054466",
        "volume": 8.11,
        "price": 3221.8,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3221.8,
        "doubleCheck": true
    },
    {
        "dataID": "117736",
        "id": "53091391",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:29",
        "brokerTime": "2025-05-14 15:08:29",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054467",
        "positionId": "56054466",
        "volume": 8.11,
        "price": 3221.8,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3221.8,
        "doubleCheck": true
    },
    {
        "dataID": "117737",
        "id": "53091392",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:29",
        "brokerTime": "2025-05-14 15:08:29",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054468",
        "positionId": "56054468",
        "volume": 8.11,
        "price": 3221.63,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3221.63,
        "doubleCheck": true
    },
    {
        "dataID": "117738",
        "id": "53091393",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:29",
        "brokerTime": "2025-05-14 15:08:30",
        "commission": -56.77,
        "swap": 0,
        "profit": -145.98,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054469",
        "positionId": "56054468",
        "volume": 8.11,
        "price": 3221.81,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -202.75,
        "priceIn": 3221.63,
        "doubleCheck": true
    },
    {
        "dataID": "117739",
        "id": "53091394",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:30",
        "brokerTime": "2025-05-14 15:08:30",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054470",
        "positionId": "56054470",
        "volume": 8.11,
        "price": 3221.67,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3221.67,
        "doubleCheck": true
    },
    {
        "dataID": "117740",
        "id": "53091395",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:30",
        "brokerTime": "2025-05-14 15:08:30",
        "commission": -56.77,
        "swap": 0,
        "profit": -56.77,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054471",
        "positionId": "56054470",
        "volume": 8.11,
        "price": 3221.74,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -113.54,
        "priceIn": 3221.67,
        "doubleCheck": true
    },
    {
        "dataID": "117741",
        "id": "53091396",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:31",
        "brokerTime": "2025-05-14 15:08:31",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054472",
        "positionId": "56054472",
        "volume": 8.11,
        "price": 3221.57,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3221.57,
        "doubleCheck": true
    },
    {
        "dataID": "117742",
        "id": "53091397",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:31",
        "brokerTime": "2025-05-14 15:08:31",
        "commission": -56.77,
        "swap": 0,
        "profit": -129.76,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054473",
        "positionId": "56054472",
        "volume": 8.11,
        "price": 3221.73,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -186.53,
        "priceIn": 3221.57,
        "doubleCheck": true
    },
    {
        "dataID": "117743",
        "id": "53091398",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:32",
        "brokerTime": "2025-05-14 15:08:32",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054474",
        "positionId": "56054474",
        "volume": 8.11,
        "price": 3221.61,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3221.61,
        "doubleCheck": true
    },
    {
        "dataID": "117744",
        "id": "53091399",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:32",
        "brokerTime": "2025-05-14 15:08:33",
        "commission": -56.77,
        "swap": 0,
        "profit": -535.26,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054475",
        "positionId": "56054474",
        "volume": 8.11,
        "price": 3222.27,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -592.03,
        "priceIn": 3221.61,
        "doubleCheck": true
    },
    {
        "dataID": "117745",
        "id": "53091400",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:33",
        "brokerTime": "2025-05-14 15:08:33",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054476",
        "positionId": "56054476",
        "volume": 8.11,
        "price": 3222.02,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3222.02,
        "doubleCheck": true
    },
    {
        "dataID": "117746",
        "id": "53091401",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:33",
        "brokerTime": "2025-05-14 15:08:33",
        "commission": -56.77,
        "swap": 0,
        "profit": -129.76,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054477",
        "positionId": "56054476",
        "volume": 8.11,
        "price": 3222.18,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -186.53,
        "priceIn": 3222.02,
        "doubleCheck": true
    },
    {
        "dataID": "117747",
        "id": "53091402",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:34",
        "brokerTime": "2025-05-14 15:08:34",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054478",
        "positionId": "56054478",
        "volume": 8.11,
        "price": 3222.01,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3222.01,
        "doubleCheck": true
    },
    {
        "dataID": "117748",
        "id": "53091403",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:34",
        "brokerTime": "2025-05-14 15:08:36",
        "commission": -56.77,
        "swap": 0,
        "profit": -145.98,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054479",
        "positionId": "56054478",
        "volume": 8.11,
        "price": 3222.19,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -202.75,
        "priceIn": 3222.01,
        "doubleCheck": true
    },
    {
        "dataID": "117749",
        "id": "53091404",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:36",
        "brokerTime": "2025-05-14 15:08:36",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054480",
        "positionId": "56054480",
        "volume": 8.11,
        "price": 3222.04,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3222.04,
        "doubleCheck": true
    },
    {
        "dataID": "117750",
        "id": "53091411",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:36",
        "brokerTime": "2025-05-14 15:08:37",
        "commission": -56.77,
        "swap": 0,
        "profit": -81.1,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054487",
        "positionId": "56054480",
        "volume": 8.11,
        "price": 3222.14,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -137.87,
        "priceIn": 3222.04,
        "doubleCheck": true
    },
    {
        "dataID": "117751",
        "id": "53091412",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:37",
        "brokerTime": "2025-05-14 15:08:37",
        "commission": -0.98,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUEUR.PRO",
        "magic": "0",
        "orderId": "56054488",
        "positionId": "56054488",
        "volume": 0.14,
        "price": 2872.81,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2772.81,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.98,
        "priceIn": 2872.81,
        "doubleCheck": true
    },
    {
        "dataID": "117752",
        "id": "53091413",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:37",
        "brokerTime": "2025-05-14 15:08:37",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054489",
        "positionId": "56054489",
        "volume": 8.11,
        "price": 3221.92,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3221.92,
        "doubleCheck": true
    },
    {
        "dataID": "117753",
        "id": "53091414",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:37",
        "brokerTime": "2025-05-14 15:08:38",
        "commission": -56.77,
        "swap": 0,
        "profit": -121.65,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054490",
        "positionId": "56054489",
        "volume": 8.11,
        "price": 3222.07,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -178.42000000000002,
        "priceIn": 3221.92,
        "doubleCheck": true
    },
    {
        "dataID": "117754",
        "id": "53091581",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:39",
        "brokerTime": "2025-05-14 15:08:39",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054672",
        "positionId": "56054672",
        "volume": 8.11,
        "price": 3221.83,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3221.83,
        "doubleCheck": true
    },
    {
        "dataID": "117755",
        "id": "53091672",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:39",
        "brokerTime": "2025-05-14 15:08:40",
        "commission": -56.77,
        "swap": 0,
        "profit": -137.87,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054673",
        "positionId": "56054672",
        "volume": 8.11,
        "price": 3222,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -194.64000000000001,
        "priceIn": 3221.83,
        "doubleCheck": true
    },
    {
        "dataID": "117756",
        "id": "53091673",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:41",
        "brokerTime": "2025-05-14 15:08:41",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054674",
        "positionId": "56054674",
        "volume": 8.11,
        "price": 3221.52,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3221.52,
        "doubleCheck": true
    },
    {
        "dataID": "117757",
        "id": "53091674",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:41",
        "brokerTime": "2025-05-14 15:08:42",
        "commission": -56.77,
        "swap": 0,
        "profit": -64.88,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054675",
        "positionId": "56054674",
        "volume": 8.11,
        "price": 3221.6,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -121.65,
        "priceIn": 3221.52,
        "doubleCheck": true
    },
    {
        "dataID": "117758",
        "id": "53091675",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:42",
        "brokerTime": "2025-05-14 15:08:42",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054676",
        "positionId": "56054676",
        "volume": 8.11,
        "price": 3221.47,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3221.47,
        "doubleCheck": true
    },
    {
        "dataID": "117759",
        "id": "53091676",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:42",
        "brokerTime": "2025-05-14 15:08:43",
        "commission": -56.77,
        "swap": 0,
        "profit": -8.11,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054677",
        "positionId": "56054676",
        "volume": 8.11,
        "price": 3221.48,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -64.88,
        "priceIn": 3221.47,
        "doubleCheck": true
    },
    {
        "dataID": "117760",
        "id": "53091677",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:43",
        "brokerTime": "2025-05-14 15:08:43",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054678",
        "positionId": "56054678",
        "volume": 8.11,
        "price": 3221.15,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3221.15,
        "doubleCheck": true
    },
    {
        "dataID": "117761",
        "id": "53091678",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:43",
        "brokerTime": "2025-05-14 15:08:44",
        "commission": -56.77,
        "swap": 0,
        "profit": -291.96,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054679",
        "positionId": "56054678",
        "volume": 8.11,
        "price": 3221.51,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -348.72999999999996,
        "priceIn": 3221.15,
        "doubleCheck": true
    },
    {
        "dataID": "117762",
        "id": "53091679",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:44",
        "brokerTime": "2025-05-14 15:08:44",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054680",
        "positionId": "56054680",
        "volume": 8.11,
        "price": 3221.57,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3221.57,
        "doubleCheck": true
    },
    {
        "dataID": "117763",
        "id": "53091686",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:44",
        "brokerTime": "2025-05-14 15:08:45",
        "commission": -56.77,
        "swap": 0,
        "profit": 316.29,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054687",
        "positionId": "56054680",
        "volume": 8.11,
        "price": 3221.18,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 259.52000000000004,
        "priceIn": 3221.57,
        "doubleCheck": true
    },
    {
        "dataID": "117764",
        "id": "53091687",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:46",
        "brokerTime": "2025-05-14 15:08:46",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054688",
        "positionId": "56054688",
        "volume": 8.11,
        "price": 3221,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3221,
        "doubleCheck": true
    },
    {
        "dataID": "117765",
        "id": "53091688",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:46",
        "brokerTime": "2025-05-14 15:08:46",
        "commission": -56.77,
        "swap": 0,
        "profit": -170.31,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054689",
        "positionId": "56054688",
        "volume": 8.11,
        "price": 3221.21,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -227.08,
        "priceIn": 3221,
        "doubleCheck": true
    },
    {
        "dataID": "117766",
        "id": "53091689",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:47",
        "brokerTime": "2025-05-14 15:08:47",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054690",
        "positionId": "56054690",
        "volume": 8.11,
        "price": 3220.99,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3220.99,
        "doubleCheck": true
    },
    {
        "dataID": "117767",
        "id": "53091690",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:47",
        "brokerTime": "2025-05-14 15:08:47",
        "commission": -56.77,
        "swap": 0,
        "profit": -218.97,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054691",
        "positionId": "56054690",
        "volume": 8.11,
        "price": 3221.26,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -275.74,
        "priceIn": 3220.99,
        "doubleCheck": true
    },
    {
        "dataID": "117768",
        "id": "53091691",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:47",
        "brokerTime": "2025-05-14 15:08:47",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054692",
        "positionId": "56054692",
        "volume": 8.11,
        "price": 3221,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3221,
        "doubleCheck": true
    },
    {
        "dataID": "117769",
        "id": "53091692",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:47",
        "brokerTime": "2025-05-14 15:08:48",
        "commission": -56.77,
        "swap": 0,
        "profit": -56.77,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054693",
        "positionId": "56054692",
        "volume": 8.11,
        "price": 3221.07,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -113.54,
        "priceIn": 3221,
        "doubleCheck": true
    },
    {
        "dataID": "117770",
        "id": "53091693",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:48",
        "brokerTime": "2025-05-14 15:08:48",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054694",
        "positionId": "56054694",
        "volume": 8.11,
        "price": 3220.91,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3220.91,
        "doubleCheck": true
    },
    {
        "dataID": "117771",
        "id": "53091694",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:48",
        "brokerTime": "2025-05-14 15:08:49",
        "commission": -56.77,
        "swap": 0,
        "profit": -113.54,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054695",
        "positionId": "56054694",
        "volume": 8.11,
        "price": 3221.05,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -170.31,
        "priceIn": 3220.91,
        "doubleCheck": true
    },
    {
        "dataID": "117772",
        "id": "53091695",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:49",
        "brokerTime": "2025-05-14 15:08:49",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054696",
        "positionId": "56054696",
        "volume": 8.11,
        "price": 3220.94,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3220.94,
        "doubleCheck": true
    },
    {
        "dataID": "117773",
        "id": "53091696",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:49",
        "brokerTime": "2025-05-14 15:08:49",
        "commission": -56.77,
        "swap": 0,
        "profit": -40.55,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054697",
        "positionId": "56054696",
        "volume": 8.11,
        "price": 3220.99,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -97.32,
        "priceIn": 3220.94,
        "doubleCheck": true
    },
    {
        "dataID": "117774",
        "id": "53091697",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:51",
        "brokerTime": "2025-05-14 15:08:51",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054698",
        "positionId": "56054698",
        "volume": 8.11,
        "price": 3220.91,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3220.91,
        "doubleCheck": true
    },
    {
        "dataID": "117775",
        "id": "53091698",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:51",
        "brokerTime": "2025-05-14 15:08:51",
        "commission": -56.77,
        "swap": 0,
        "profit": -32.44,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054699",
        "positionId": "56054698",
        "volume": 8.11,
        "price": 3220.95,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -89.21000000000001,
        "priceIn": 3220.91,
        "doubleCheck": true
    },
    {
        "dataID": "117776",
        "id": "53091699",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:52",
        "brokerTime": "2025-05-14 15:08:52",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054700",
        "positionId": "56054700",
        "volume": 8.11,
        "price": 3220.77,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3220.77,
        "doubleCheck": true
    },
    {
        "dataID": "117777",
        "id": "53091700",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:52",
        "brokerTime": "2025-05-14 15:08:53",
        "commission": -56.77,
        "swap": 0,
        "profit": -145.98,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054701",
        "positionId": "56054700",
        "volume": 8.11,
        "price": 3220.95,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -202.75,
        "priceIn": 3220.77,
        "doubleCheck": true
    },
    {
        "dataID": "117778",
        "id": "53091701",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:53",
        "brokerTime": "2025-05-14 15:08:53",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054702",
        "positionId": "56054702",
        "volume": 8.11,
        "price": 3220.77,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3220.77,
        "doubleCheck": true
    },
    {
        "dataID": "117779",
        "id": "53091702",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:53",
        "brokerTime": "2025-05-14 15:08:53",
        "commission": -56.77,
        "swap": 0,
        "profit": -137.87,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054703",
        "positionId": "56054702",
        "volume": 8.11,
        "price": 3220.94,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -194.64000000000001,
        "priceIn": 3220.77,
        "doubleCheck": true
    },
    {
        "dataID": "117780",
        "id": "53091703",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:54",
        "brokerTime": "2025-05-14 15:08:54",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054724",
        "positionId": "56054724",
        "volume": 8.11,
        "price": 3220.72,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3220.72,
        "doubleCheck": true
    },
    {
        "dataID": "117781",
        "id": "53091744",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:54",
        "brokerTime": "2025-05-14 15:08:55",
        "commission": -56.77,
        "swap": 0,
        "profit": -24.33,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054725",
        "positionId": "56054724",
        "volume": 8.11,
        "price": 3220.75,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -81.1,
        "priceIn": 3220.72,
        "doubleCheck": true
    },
    {
        "dataID": "117782",
        "id": "53091745",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:55",
        "brokerTime": "2025-05-14 15:08:55",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054726",
        "positionId": "56054726",
        "volume": 8.11,
        "price": 3220.54,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3220.54,
        "doubleCheck": true
    },
    {
        "dataID": "117783",
        "id": "53091747",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:55",
        "brokerTime": "2025-05-14 15:08:56",
        "commission": -56.77,
        "swap": 0,
        "profit": 64.88,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054729",
        "positionId": "56054726",
        "volume": 8.11,
        "price": 3220.46,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 8.109999999999992,
        "priceIn": 3220.54,
        "doubleCheck": true
    },
    {
        "dataID": "117784",
        "id": "53091749",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:56",
        "brokerTime": "2025-05-14 15:08:56",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054730",
        "positionId": "56054730",
        "volume": 8.11,
        "price": 3220.01,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3220.01,
        "doubleCheck": true
    },
    {
        "dataID": "117785",
        "id": "53091753",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:56",
        "brokerTime": "2025-05-14 15:08:57",
        "commission": -56.77,
        "swap": 0,
        "profit": -113.54,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054733",
        "positionId": "56054730",
        "volume": 8.11,
        "price": 3220.15,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -170.31,
        "priceIn": 3220.01,
        "doubleCheck": true
    },
    {
        "dataID": "117786",
        "id": "53091758",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:57",
        "brokerTime": "2025-05-14 15:08:57",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054737",
        "positionId": "56054737",
        "volume": 8.11,
        "price": 3219.94,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3219.94,
        "doubleCheck": true
    },
    {
        "dataID": "117787",
        "id": "53091992",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:57",
        "brokerTime": "2025-05-14 15:08:58",
        "commission": -56.77,
        "swap": 0,
        "profit": -170.31,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56054952",
        "positionId": "56054737",
        "volume": 8.11,
        "price": 3220.15,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -227.08,
        "priceIn": 3219.94,
        "doubleCheck": true
    },
    {
        "dataID": "117788",
        "id": "53092049",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:58",
        "brokerTime": "2025-05-14 15:08:58",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055015",
        "positionId": "56055015",
        "volume": 8.11,
        "price": 3219.97,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3219.97,
        "doubleCheck": true
    },
    {
        "dataID": "117789",
        "id": "53092359",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:58",
        "brokerTime": "2025-05-14 15:09:00",
        "commission": -56.77,
        "swap": 0,
        "profit": -154.09,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055287",
        "positionId": "56055015",
        "volume": 8.11,
        "price": 3220.16,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -210.86,
        "priceIn": 3219.97,
        "doubleCheck": true
    },
    {
        "dataID": "117790",
        "id": "53092363",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:01",
        "brokerTime": "2025-05-14 15:09:01",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055291",
        "positionId": "56055291",
        "volume": 8.11,
        "price": 3219.95,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3219.95,
        "doubleCheck": true
    },
    {
        "dataID": "117791",
        "id": "53092365",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:01",
        "brokerTime": "2025-05-14 15:09:01",
        "commission": -56.77,
        "swap": 0,
        "profit": -89.21,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055292",
        "positionId": "56055291",
        "volume": 8.11,
        "price": 3220.06,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -145.98,
        "priceIn": 3219.95,
        "doubleCheck": true
    },
    {
        "dataID": "117792",
        "id": "53092407",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:02",
        "brokerTime": "2025-05-14 15:09:02",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055321",
        "positionId": "56055321",
        "volume": 8.11,
        "price": 3219.92,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3219.92,
        "doubleCheck": true
    },
    {
        "dataID": "117793",
        "id": "53092514",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:02",
        "brokerTime": "2025-05-14 15:09:02",
        "commission": -56.77,
        "swap": 0,
        "profit": -178.42,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055381",
        "positionId": "56055321",
        "volume": 8.11,
        "price": 3220.14,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -235.19,
        "priceIn": 3219.92,
        "doubleCheck": true
    },
    {
        "dataID": "117794",
        "id": "53092541",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:03",
        "brokerTime": "2025-05-14 15:09:03",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055411",
        "positionId": "56055411",
        "volume": 8.11,
        "price": 3220.02,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3220.02,
        "doubleCheck": true
    },
    {
        "dataID": "117795",
        "id": "53092680",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:03",
        "brokerTime": "2025-05-14 15:09:03",
        "commission": -56.77,
        "swap": 0,
        "profit": -137.87,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055513",
        "positionId": "56055411",
        "volume": 8.11,
        "price": 3220.19,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -194.64000000000001,
        "priceIn": 3220.02,
        "doubleCheck": true
    },
    {
        "dataID": "117796",
        "id": "53092754",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:04",
        "brokerTime": "2025-05-14 15:09:04",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055542",
        "positionId": "56055542",
        "volume": 8.11,
        "price": 3219.95,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3219.95,
        "doubleCheck": true
    },
    {
        "dataID": "117797",
        "id": "53092768",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:04",
        "brokerTime": "2025-05-14 15:09:06",
        "commission": -56.77,
        "swap": 0,
        "profit": -40.55,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055551",
        "positionId": "56055542",
        "volume": 8.11,
        "price": 3220,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -97.32,
        "priceIn": 3219.95,
        "doubleCheck": true
    },
    {
        "dataID": "117798",
        "id": "53092849",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:06",
        "brokerTime": "2025-05-14 15:09:06",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055632",
        "positionId": "56055632",
        "volume": 8.11,
        "price": 3219.71,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3219.71,
        "doubleCheck": true
    },
    {
        "dataID": "117799",
        "id": "53092852",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:06",
        "brokerTime": "2025-05-14 15:09:07",
        "commission": -56.77,
        "swap": 0,
        "profit": -145.98,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055633",
        "positionId": "56055632",
        "volume": 8.11,
        "price": 3219.89,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -202.75,
        "priceIn": 3219.71,
        "doubleCheck": true
    },
    {
        "dataID": "117800",
        "id": "53092855",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:07",
        "brokerTime": "2025-05-14 15:09:07",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055635",
        "positionId": "56055635",
        "volume": 8.11,
        "price": 3219.85,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3219.85,
        "doubleCheck": true
    },
    {
        "dataID": "117801",
        "id": "53092856",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:07",
        "brokerTime": "2025-05-14 15:09:08",
        "commission": -56.77,
        "swap": 0,
        "profit": -308.18,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055636",
        "positionId": "56055635",
        "volume": 8.11,
        "price": 3220.23,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -364.95,
        "priceIn": 3219.85,
        "doubleCheck": true
    },
    {
        "dataID": "117802",
        "id": "53092858",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:08",
        "brokerTime": "2025-05-14 15:09:08",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055638",
        "positionId": "56055638",
        "volume": 8.11,
        "price": 3220.1,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3220.1,
        "doubleCheck": true
    },
    {
        "dataID": "117803",
        "id": "53092859",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:08",
        "brokerTime": "2025-05-14 15:09:09",
        "commission": -56.77,
        "swap": 0,
        "profit": -397.39,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055639",
        "positionId": "56055638",
        "volume": 8.11,
        "price": 3220.59,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -454.15999999999997,
        "priceIn": 3220.1,
        "doubleCheck": true
    },
    {
        "dataID": "117804",
        "id": "53092860",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:10",
        "brokerTime": "2025-05-14 15:09:10",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055640",
        "positionId": "56055640",
        "volume": 8.11,
        "price": 3220.41,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3220.41,
        "doubleCheck": true
    },
    {
        "dataID": "117805",
        "id": "53092861",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:10",
        "brokerTime": "2025-05-14 15:09:10",
        "commission": -56.77,
        "swap": 0,
        "profit": -154.09,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055641",
        "positionId": "56055640",
        "volume": 8.11,
        "price": 3220.6,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -210.86,
        "priceIn": 3220.41,
        "doubleCheck": true
    },
    {
        "dataID": "117806",
        "id": "53092862",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:11",
        "brokerTime": "2025-05-14 15:09:11",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055642",
        "positionId": "56055642",
        "volume": 8.11,
        "price": 3220.23,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3220.23,
        "doubleCheck": true
    },
    {
        "dataID": "117807",
        "id": "53092880",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:11",
        "brokerTime": "2025-05-14 15:09:11",
        "commission": -56.77,
        "swap": 0,
        "profit": -170.31,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055659",
        "positionId": "56055642",
        "volume": 8.11,
        "price": 3220.44,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -227.08,
        "priceIn": 3220.23,
        "doubleCheck": true
    },
    {
        "dataID": "117808",
        "id": "53092881",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:12",
        "brokerTime": "2025-05-14 15:09:12",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055660",
        "positionId": "56055660",
        "volume": 8.11,
        "price": 3220.35,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3220.35,
        "doubleCheck": true
    },
    {
        "dataID": "117809",
        "id": "53092882",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:12",
        "brokerTime": "2025-05-14 15:09:12",
        "commission": -56.77,
        "swap": 0,
        "profit": -162.2,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055661",
        "positionId": "56055660",
        "volume": 8.11,
        "price": 3220.55,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -218.97,
        "priceIn": 3220.35,
        "doubleCheck": true
    },
    {
        "dataID": "117810",
        "id": "53092883",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:13",
        "brokerTime": "2025-05-14 15:09:13",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055662",
        "positionId": "56055662",
        "volume": 8.11,
        "price": 3220.32,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3220.32,
        "doubleCheck": true
    },
    {
        "dataID": "117811",
        "id": "53092884",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:13",
        "brokerTime": "2025-05-14 15:09:13",
        "commission": -56.77,
        "swap": 0,
        "profit": -389.28,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055663",
        "positionId": "56055662",
        "volume": 8.11,
        "price": 3220.8,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -446.04999999999995,
        "priceIn": 3220.32,
        "doubleCheck": true
    },
    {
        "dataID": "117812",
        "id": "53092885",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:14",
        "brokerTime": "2025-05-14 15:09:14",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055664",
        "positionId": "56055664",
        "volume": 8.11,
        "price": 3220.61,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3220.61,
        "doubleCheck": true
    },
    {
        "dataID": "117813",
        "id": "53092886",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:14",
        "brokerTime": "2025-05-14 15:09:14",
        "commission": -56.77,
        "swap": 0,
        "profit": -56.77,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055665",
        "positionId": "56055664",
        "volume": 8.11,
        "price": 3220.68,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -113.54,
        "priceIn": 3220.61,
        "doubleCheck": true
    },
    {
        "dataID": "117814",
        "id": "53092887",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:15",
        "brokerTime": "2025-05-14 15:09:15",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055666",
        "positionId": "56055666",
        "volume": 8.11,
        "price": 3220.73,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3220.73,
        "doubleCheck": true
    },
    {
        "dataID": "117815",
        "id": "53092888",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:15",
        "brokerTime": "2025-05-14 15:09:15",
        "commission": -56.77,
        "swap": 0,
        "profit": -81.1,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055667",
        "positionId": "56055666",
        "volume": 8.11,
        "price": 3220.83,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -137.87,
        "priceIn": 3220.73,
        "doubleCheck": true
    },
    {
        "dataID": "117816",
        "id": "53092890",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:16",
        "brokerTime": "2025-05-14 15:09:16",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055669",
        "positionId": "56055669",
        "volume": 8.11,
        "price": 3220.73,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3220.73,
        "doubleCheck": true
    },
    {
        "dataID": "117817",
        "id": "53092891",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:16",
        "brokerTime": "2025-05-14 15:09:16",
        "commission": -56.77,
        "swap": 0,
        "profit": -105.43,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055670",
        "positionId": "56055669",
        "volume": 8.11,
        "price": 3220.86,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -162.20000000000002,
        "priceIn": 3220.73,
        "doubleCheck": true
    },
    {
        "dataID": "117818",
        "id": "53092892",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:17",
        "brokerTime": "2025-05-14 15:09:17",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055671",
        "positionId": "56055671",
        "volume": 8.11,
        "price": 3220.7,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3220.7,
        "doubleCheck": true
    },
    {
        "dataID": "117819",
        "id": "53092893",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:17",
        "brokerTime": "2025-05-14 15:09:17",
        "commission": -56.77,
        "swap": 0,
        "profit": -97.32,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055672",
        "positionId": "56055671",
        "volume": 8.11,
        "price": 3220.82,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -154.09,
        "priceIn": 3220.7,
        "doubleCheck": true
    },
    {
        "dataID": "117820",
        "id": "53092894",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:17",
        "brokerTime": "2025-05-14 15:09:17",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055673",
        "positionId": "56055673",
        "volume": 8.11,
        "price": 3220.69,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3220.69,
        "doubleCheck": true
    },
    {
        "dataID": "117821",
        "id": "53092895",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:17",
        "brokerTime": "2025-05-14 15:09:18",
        "commission": -56.77,
        "swap": 0,
        "profit": -332.51,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055674",
        "positionId": "56055673",
        "volume": 8.11,
        "price": 3221.1,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -389.28,
        "priceIn": 3220.69,
        "doubleCheck": true
    },
    {
        "dataID": "117822",
        "id": "53092896",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:18",
        "brokerTime": "2025-05-14 15:09:18",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055675",
        "positionId": "56055675",
        "volume": 8.11,
        "price": 3220.95,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3220.95,
        "doubleCheck": true
    },
    {
        "dataID": "117823",
        "id": "53092897",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:18",
        "brokerTime": "2025-05-14 15:09:19",
        "commission": -56.77,
        "swap": 0,
        "profit": -105.43,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055676",
        "positionId": "56055675",
        "volume": 8.11,
        "price": 3221.08,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -162.20000000000002,
        "priceIn": 3220.95,
        "doubleCheck": true
    },
    {
        "dataID": "117824",
        "id": "53092898",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:19",
        "brokerTime": "2025-05-14 15:09:19",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055677",
        "positionId": "56055677",
        "volume": 8.11,
        "price": 3220.83,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3220.83,
        "doubleCheck": true
    },
    {
        "dataID": "117825",
        "id": "53092899",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:19",
        "brokerTime": "2025-05-14 15:09:20",
        "commission": -56.77,
        "swap": 0,
        "profit": -194.64,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055678",
        "positionId": "56055677",
        "volume": 8.11,
        "price": 3221.07,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -251.41,
        "priceIn": 3220.83,
        "doubleCheck": true
    },
    {
        "dataID": "117826",
        "id": "53092900",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:20",
        "brokerTime": "2025-05-14 15:09:20",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055679",
        "positionId": "56055679",
        "volume": 8.11,
        "price": 3220.89,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3220.89,
        "doubleCheck": true
    },
    {
        "dataID": "117827",
        "id": "53092901",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:20",
        "brokerTime": "2025-05-14 15:09:20",
        "commission": -56.77,
        "swap": 0,
        "profit": -129.76,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055680",
        "positionId": "56055679",
        "volume": 8.11,
        "price": 3221.05,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -186.53,
        "priceIn": 3220.89,
        "doubleCheck": true
    },
    {
        "dataID": "117828",
        "id": "53092902",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:21",
        "brokerTime": "2025-05-14 15:09:21",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055681",
        "positionId": "56055681",
        "volume": 8.11,
        "price": 3220.8,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3220.8,
        "doubleCheck": true
    },
    {
        "dataID": "117829",
        "id": "53092903",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:21",
        "brokerTime": "2025-05-14 15:09:22",
        "commission": -56.77,
        "swap": 0,
        "profit": -113.54,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055682",
        "positionId": "56055681",
        "volume": 8.11,
        "price": 3220.94,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -170.31,
        "priceIn": 3220.8,
        "doubleCheck": true
    },
    {
        "dataID": "117830",
        "id": "53092904",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:22",
        "brokerTime": "2025-05-14 15:09:22",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055683",
        "positionId": "56055683",
        "volume": 8.11,
        "price": 3220.83,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3220.83,
        "doubleCheck": true
    },
    {
        "dataID": "117831",
        "id": "53092905",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:22",
        "brokerTime": "2025-05-14 15:09:23",
        "commission": -56.77,
        "swap": 0,
        "profit": -97.32,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055684",
        "positionId": "56055683",
        "volume": 8.11,
        "price": 3220.95,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -154.09,
        "priceIn": 3220.83,
        "doubleCheck": true
    },
    {
        "dataID": "117832",
        "id": "53092906",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:24",
        "brokerTime": "2025-05-14 15:09:24",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055685",
        "positionId": "56055685",
        "volume": 8.11,
        "price": 3220.8,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3220.8,
        "doubleCheck": true
    },
    {
        "dataID": "117833",
        "id": "53092907",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:24",
        "brokerTime": "2025-05-14 15:09:24",
        "commission": -56.77,
        "swap": 0,
        "profit": -259.52,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055686",
        "positionId": "56055685",
        "volume": 8.11,
        "price": 3221.12,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -316.28999999999996,
        "priceIn": 3220.8,
        "doubleCheck": true
    },
    {
        "dataID": "117834",
        "id": "53092908",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:25",
        "brokerTime": "2025-05-14 15:09:25",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055687",
        "positionId": "56055687",
        "volume": 8.11,
        "price": 3220.95,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3220.95,
        "doubleCheck": true
    },
    {
        "dataID": "117835",
        "id": "53092909",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:25",
        "brokerTime": "2025-05-14 15:09:25",
        "commission": -56.77,
        "swap": 0,
        "profit": -56.77,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055688",
        "positionId": "56055687",
        "volume": 8.11,
        "price": 3221.02,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -113.54,
        "priceIn": 3220.95,
        "doubleCheck": true
    },
    {
        "dataID": "117836",
        "id": "53092910",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:25",
        "brokerTime": "2025-05-14 15:09:25",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055689",
        "positionId": "56055689",
        "volume": 8.11,
        "price": 3220.86,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3220.86,
        "doubleCheck": true
    },
    {
        "dataID": "117837",
        "id": "53092911",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:25",
        "brokerTime": "2025-05-14 15:09:26",
        "commission": -56.77,
        "swap": 0,
        "profit": -324.4,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055690",
        "positionId": "56055689",
        "volume": 8.11,
        "price": 3221.26,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -381.16999999999996,
        "priceIn": 3220.86,
        "doubleCheck": true
    },
    {
        "dataID": "117838",
        "id": "53092912",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:26",
        "brokerTime": "2025-05-14 15:09:26",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055691",
        "positionId": "56055691",
        "volume": 8.11,
        "price": 3221.08,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3221.08,
        "doubleCheck": true
    },
    {
        "dataID": "117839",
        "id": "53092913",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:26",
        "brokerTime": "2025-05-14 15:09:27",
        "commission": -56.77,
        "swap": 0,
        "profit": -129.76,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055692",
        "positionId": "56055691",
        "volume": 8.11,
        "price": 3221.24,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -186.53,
        "priceIn": 3221.08,
        "doubleCheck": true
    },
    {
        "dataID": "117840",
        "id": "53092914",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:27",
        "brokerTime": "2025-05-14 15:09:27",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055693",
        "positionId": "56055693",
        "volume": 8.11,
        "price": 3220.99,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3220.99,
        "doubleCheck": true
    },
    {
        "dataID": "117841",
        "id": "53092915",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:27",
        "brokerTime": "2025-05-14 15:09:28",
        "commission": -56.77,
        "swap": 0,
        "profit": -97.32,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055694",
        "positionId": "56055693",
        "volume": 8.11,
        "price": 3221.11,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -154.09,
        "priceIn": 3220.99,
        "doubleCheck": true
    },
    {
        "dataID": "117842",
        "id": "53092916",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:28",
        "brokerTime": "2025-05-14 15:09:28",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055695",
        "positionId": "56055695",
        "volume": 8.11,
        "price": 3220.98,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3220.98,
        "doubleCheck": true
    },
    {
        "dataID": "117843",
        "id": "53092917",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:28",
        "brokerTime": "2025-05-14 15:09:28",
        "commission": -56.77,
        "swap": 0,
        "profit": -8.11,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055696",
        "positionId": "56055695",
        "volume": 8.11,
        "price": 3220.99,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -64.88,
        "priceIn": 3220.98,
        "doubleCheck": true
    },
    {
        "dataID": "117844",
        "id": "53092918",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:29",
        "brokerTime": "2025-05-14 15:09:29",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055697",
        "positionId": "56055697",
        "volume": 8.11,
        "price": 3220.83,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3220.83,
        "doubleCheck": true
    },
    {
        "dataID": "117845",
        "id": "53092919",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:29",
        "brokerTime": "2025-05-14 15:09:30",
        "commission": -56.77,
        "swap": 0,
        "profit": -121.65,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055698",
        "positionId": "56055697",
        "volume": 8.11,
        "price": 3220.98,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -178.42000000000002,
        "priceIn": 3220.83,
        "doubleCheck": true
    },
    {
        "dataID": "117846",
        "id": "53092920",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:30",
        "brokerTime": "2025-05-14 15:09:30",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055699",
        "positionId": "56055699",
        "volume": 8.11,
        "price": 3220.83,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3220.83,
        "doubleCheck": true
    },
    {
        "dataID": "117847",
        "id": "53092921",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:30",
        "brokerTime": "2025-05-14 15:09:30",
        "commission": -56.77,
        "swap": 0,
        "profit": -121.65,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055700",
        "positionId": "56055699",
        "volume": 8.11,
        "price": 3220.98,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -178.42000000000002,
        "priceIn": 3220.83,
        "doubleCheck": true
    },
    {
        "dataID": "117848",
        "id": "53092922",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:30",
        "brokerTime": "2025-05-14 15:09:30",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055701",
        "positionId": "56055701",
        "volume": 8.11,
        "price": 3220.88,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3220.88,
        "doubleCheck": true
    },
    {
        "dataID": "117849",
        "id": "53092923",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:30",
        "brokerTime": "2025-05-14 15:09:31",
        "commission": -56.77,
        "swap": 0,
        "profit": -283.85,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055702",
        "positionId": "56055701",
        "volume": 8.11,
        "price": 3221.23,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -340.62,
        "priceIn": 3220.88,
        "doubleCheck": true
    },
    {
        "dataID": "117850",
        "id": "53092924",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:31",
        "brokerTime": "2025-05-14 15:09:31",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055703",
        "positionId": "56055703",
        "volume": 8.11,
        "price": 3220.93,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3220.93,
        "doubleCheck": true
    },
    {
        "dataID": "117851",
        "id": "53092925",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:31",
        "brokerTime": "2025-05-14 15:09:32",
        "commission": -56.77,
        "swap": 0,
        "profit": -162.2,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055704",
        "positionId": "56055703",
        "volume": 8.11,
        "price": 3221.13,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -218.97,
        "priceIn": 3220.93,
        "doubleCheck": true
    },
    {
        "dataID": "117852",
        "id": "53092926",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:32",
        "brokerTime": "2025-05-14 15:09:32",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055705",
        "positionId": "56055705",
        "volume": 8.11,
        "price": 3220.72,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3220.72,
        "doubleCheck": true
    },
    {
        "dataID": "117853",
        "id": "53092927",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:32",
        "brokerTime": "2025-05-14 15:09:33",
        "commission": -56.77,
        "swap": 0,
        "profit": -129.76,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055706",
        "positionId": "56055705",
        "volume": 8.11,
        "price": 3220.88,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -186.53,
        "priceIn": 3220.72,
        "doubleCheck": true
    },
    {
        "dataID": "117854",
        "id": "53092928",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:33",
        "brokerTime": "2025-05-14 15:09:33",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055707",
        "positionId": "56055707",
        "volume": 8.11,
        "price": 3220.72,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3220.72,
        "doubleCheck": true
    },
    {
        "dataID": "117855",
        "id": "53092930",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:33",
        "brokerTime": "2025-05-14 15:09:34",
        "commission": -56.77,
        "swap": 0,
        "profit": -267.63,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055710",
        "positionId": "56055707",
        "volume": 8.11,
        "price": 3221.05,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -324.4,
        "priceIn": 3220.72,
        "doubleCheck": true
    },
    {
        "dataID": "117856",
        "id": "53092931",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:34",
        "brokerTime": "2025-05-14 15:09:34",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055711",
        "positionId": "56055711",
        "volume": 8.11,
        "price": 3221.06,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3221.06,
        "doubleCheck": true
    },
    {
        "dataID": "117857",
        "id": "53092932",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:34",
        "brokerTime": "2025-05-14 15:09:35",
        "commission": -56.77,
        "swap": 0,
        "profit": -121.65,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055712",
        "positionId": "56055711",
        "volume": 8.11,
        "price": 3221.21,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -178.42000000000002,
        "priceIn": 3221.06,
        "doubleCheck": true
    },
    {
        "dataID": "117858",
        "id": "53092933",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:35",
        "brokerTime": "2025-05-14 15:09:35",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055713",
        "positionId": "56055713",
        "volume": 8.11,
        "price": 3220.96,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3220.96,
        "doubleCheck": true
    },
    {
        "dataID": "117859",
        "id": "53092934",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:35",
        "brokerTime": "2025-05-14 15:09:36",
        "commission": -56.77,
        "swap": 0,
        "profit": -210.86,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055714",
        "positionId": "56055713",
        "volume": 8.11,
        "price": 3221.22,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -267.63,
        "priceIn": 3220.96,
        "doubleCheck": true
    },
    {
        "dataID": "117860",
        "id": "53092935",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:37",
        "brokerTime": "2025-05-14 15:09:37",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055715",
        "positionId": "56055715",
        "volume": 8.11,
        "price": 3221.08,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3221.08,
        "doubleCheck": true
    },
    {
        "dataID": "117861",
        "id": "53092936",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:37",
        "brokerTime": "2025-05-14 15:09:37",
        "commission": -56.77,
        "swap": 0,
        "profit": -72.99,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055716",
        "positionId": "56055715",
        "volume": 8.11,
        "price": 3221.17,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -129.76,
        "priceIn": 3221.08,
        "doubleCheck": true
    },
    {
        "dataID": "117862",
        "id": "53092937",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:37",
        "brokerTime": "2025-05-14 15:09:37",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055717",
        "positionId": "56055717",
        "volume": 8.11,
        "price": 3220.99,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3220.99,
        "doubleCheck": true
    },
    {
        "dataID": "117863",
        "id": "53092938",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:37",
        "brokerTime": "2025-05-14 15:09:38",
        "commission": -56.77,
        "swap": 0,
        "profit": -72.99,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055718",
        "positionId": "56055717",
        "volume": 8.11,
        "price": 3221.08,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -129.76,
        "priceIn": 3220.99,
        "doubleCheck": true
    },
    {
        "dataID": "117864",
        "id": "53092939",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:38",
        "brokerTime": "2025-05-14 15:09:38",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055719",
        "positionId": "56055719",
        "volume": 8.11,
        "price": 3220.8,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3220.8,
        "doubleCheck": true
    },
    {
        "dataID": "117865",
        "id": "53092940",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:38",
        "brokerTime": "2025-05-14 15:09:39",
        "commission": -56.77,
        "swap": 0,
        "profit": -170.31,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055720",
        "positionId": "56055719",
        "volume": 8.11,
        "price": 3221.01,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -227.08,
        "priceIn": 3220.8,
        "doubleCheck": true
    },
    {
        "dataID": "117866",
        "id": "53092941",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:39",
        "brokerTime": "2025-05-14 15:09:39",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055721",
        "positionId": "56055721",
        "volume": 8.11,
        "price": 3220.84,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3220.84,
        "doubleCheck": true
    },
    {
        "dataID": "117867",
        "id": "53092943",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:39",
        "brokerTime": "2025-05-14 15:09:40",
        "commission": -56.77,
        "swap": 0,
        "profit": 89.21,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055723",
        "positionId": "56055721",
        "volume": 8.11,
        "price": 3220.73,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 32.43999999999999,
        "priceIn": 3220.84,
        "doubleCheck": true
    },
    {
        "dataID": "117868",
        "id": "53092944",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:40",
        "brokerTime": "2025-05-14 15:09:40",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055724",
        "positionId": "56055724",
        "volume": 8.11,
        "price": 3220.58,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3220.58,
        "doubleCheck": true
    },
    {
        "dataID": "117869",
        "id": "53092945",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:40",
        "brokerTime": "2025-05-14 15:09:40",
        "commission": -56.77,
        "swap": 0,
        "profit": -154.09,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055725",
        "positionId": "56055724",
        "volume": 8.11,
        "price": 3220.77,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -210.86,
        "priceIn": 3220.58,
        "doubleCheck": true
    },
    {
        "dataID": "117870",
        "id": "53092947",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:41",
        "brokerTime": "2025-05-14 15:09:41",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055727",
        "positionId": "56055727",
        "volume": 8.11,
        "price": 3220.6,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3220.6,
        "doubleCheck": true
    },
    {
        "dataID": "117871",
        "id": "53092949",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:41",
        "brokerTime": "2025-05-14 15:09:42",
        "commission": -56.77,
        "swap": 0,
        "profit": -32.44,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055729",
        "positionId": "56055727",
        "volume": 8.11,
        "price": 3220.64,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -89.21000000000001,
        "priceIn": 3220.6,
        "doubleCheck": true
    },
    {
        "dataID": "117872",
        "id": "53092950",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:42",
        "brokerTime": "2025-05-14 15:09:42",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055730",
        "positionId": "56055730",
        "volume": 8.11,
        "price": 3220.4,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3220.4,
        "doubleCheck": true
    },
    {
        "dataID": "117873",
        "id": "53092952",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:42",
        "brokerTime": "2025-05-14 15:09:43",
        "commission": -56.77,
        "swap": 0,
        "profit": -218.97,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055732",
        "positionId": "56055730",
        "volume": 8.11,
        "price": 3220.67,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -275.74,
        "priceIn": 3220.4,
        "doubleCheck": true
    },
    {
        "dataID": "117874",
        "id": "53092953",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:44",
        "brokerTime": "2025-05-14 15:09:44",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055733",
        "positionId": "56055733",
        "volume": 8.11,
        "price": 3220.59,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3220.59,
        "doubleCheck": true
    },
    {
        "dataID": "117875",
        "id": "53092954",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:44",
        "brokerTime": "2025-05-14 15:09:45",
        "commission": -56.77,
        "swap": 0,
        "profit": -340.62,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055734",
        "positionId": "56055733",
        "volume": 8.11,
        "price": 3221.01,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -397.39,
        "priceIn": 3220.59,
        "doubleCheck": true
    },
    {
        "dataID": "117876",
        "id": "53092955",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:45",
        "brokerTime": "2025-05-14 15:09:45",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055735",
        "positionId": "56055735",
        "volume": 8.11,
        "price": 3220.86,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3220.86,
        "doubleCheck": true
    },
    {
        "dataID": "117877",
        "id": "53092957",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:45",
        "brokerTime": "2025-05-14 15:09:46",
        "commission": -56.77,
        "swap": 0,
        "profit": 32.44,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055737",
        "positionId": "56055735",
        "volume": 8.11,
        "price": 3220.82,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -24.330000000000005,
        "priceIn": 3220.86,
        "doubleCheck": true
    },
    {
        "dataID": "117878",
        "id": "53092958",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:46",
        "brokerTime": "2025-05-14 15:09:46",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055738",
        "positionId": "56055738",
        "volume": 8.11,
        "price": 3220.6,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3220.6,
        "doubleCheck": true
    },
    {
        "dataID": "117879",
        "id": "53092959",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:46",
        "brokerTime": "2025-05-14 15:09:48",
        "commission": -56.77,
        "swap": 0,
        "profit": -105.43,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055739",
        "positionId": "56055738",
        "volume": 8.11,
        "price": 3220.73,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -162.20000000000002,
        "priceIn": 3220.6,
        "doubleCheck": true
    },
    {
        "dataID": "117880",
        "id": "53092960",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:48",
        "brokerTime": "2025-05-14 15:09:48",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055740",
        "positionId": "56055740",
        "volume": 8.11,
        "price": 3220.51,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3220.51,
        "doubleCheck": true
    },
    {
        "dataID": "117881",
        "id": "53092961",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:48",
        "brokerTime": "2025-05-14 15:09:50",
        "commission": -56.77,
        "swap": 0,
        "profit": -170.31,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055741",
        "positionId": "56055740",
        "volume": 8.11,
        "price": 3220.72,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -227.08,
        "priceIn": 3220.51,
        "doubleCheck": true
    },
    {
        "dataID": "117882",
        "id": "53092962",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:50",
        "brokerTime": "2025-05-14 15:09:50",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055742",
        "positionId": "56055742",
        "volume": 8.11,
        "price": 3220.51,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3220.51,
        "doubleCheck": true
    },
    {
        "dataID": "117883",
        "id": "53092963",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:50",
        "brokerTime": "2025-05-14 15:09:51",
        "commission": -56.77,
        "swap": 0,
        "profit": -105.43,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055743",
        "positionId": "56055742",
        "volume": 8.11,
        "price": 3220.64,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -162.20000000000002,
        "priceIn": 3220.51,
        "doubleCheck": true
    },
    {
        "dataID": "117884",
        "id": "53092964",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:51",
        "brokerTime": "2025-05-14 15:09:51",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055744",
        "positionId": "56055744",
        "volume": 8.11,
        "price": 3220.42,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3220.42,
        "doubleCheck": true
    },
    {
        "dataID": "117885",
        "id": "53092965",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:51",
        "brokerTime": "2025-05-14 15:09:51",
        "commission": -56.77,
        "swap": 0,
        "profit": -129.76,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055745",
        "positionId": "56055744",
        "volume": 8.11,
        "price": 3220.58,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -186.53,
        "priceIn": 3220.42,
        "doubleCheck": true
    },
    {
        "dataID": "117886",
        "id": "53092966",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:52",
        "brokerTime": "2025-05-14 15:09:52",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055746",
        "positionId": "56055746",
        "volume": 8.11,
        "price": 3220.41,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3220.41,
        "doubleCheck": true
    },
    {
        "dataID": "117887",
        "id": "53092967",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:52",
        "brokerTime": "2025-05-14 15:09:52",
        "commission": -56.77,
        "swap": 0,
        "profit": -162.2,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055747",
        "positionId": "56055746",
        "volume": 8.11,
        "price": 3220.61,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -218.97,
        "priceIn": 3220.41,
        "doubleCheck": true
    },
    {
        "dataID": "117888",
        "id": "53092968",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:52",
        "brokerTime": "2025-05-14 15:09:52",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055748",
        "positionId": "56055748",
        "volume": 8.11,
        "price": 3220.36,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3220.36,
        "doubleCheck": true
    },
    {
        "dataID": "117889",
        "id": "53092969",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:52",
        "brokerTime": "2025-05-14 15:09:53",
        "commission": -56.77,
        "swap": 0,
        "profit": -137.87,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055749",
        "positionId": "56055748",
        "volume": 8.11,
        "price": 3220.53,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -194.64000000000001,
        "priceIn": 3220.36,
        "doubleCheck": true
    },
    {
        "dataID": "117890",
        "id": "53092970",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:53",
        "brokerTime": "2025-05-14 15:09:53",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055750",
        "positionId": "56055750",
        "volume": 8.11,
        "price": 3220.43,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3220.43,
        "doubleCheck": true
    },
    {
        "dataID": "117891",
        "id": "53092971",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:53",
        "brokerTime": "2025-05-14 15:09:54",
        "commission": -56.77,
        "swap": 0,
        "profit": -137.87,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055751",
        "positionId": "56055750",
        "volume": 8.11,
        "price": 3220.6,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -194.64000000000001,
        "priceIn": 3220.43,
        "doubleCheck": true
    },
    {
        "dataID": "117892",
        "id": "53092972",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:56",
        "brokerTime": "2025-05-14 15:09:56",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055752",
        "positionId": "56055752",
        "volume": 8.11,
        "price": 3220.33,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3220.33,
        "doubleCheck": true
    },
    {
        "dataID": "117893",
        "id": "53092973",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:56",
        "brokerTime": "2025-05-14 15:09:57",
        "commission": -56.77,
        "swap": 0,
        "profit": -129.76,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055753",
        "positionId": "56055752",
        "volume": 8.11,
        "price": 3220.49,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -186.53,
        "priceIn": 3220.33,
        "doubleCheck": true
    },
    {
        "dataID": "117894",
        "id": "53092974",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:57",
        "brokerTime": "2025-05-14 15:09:57",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055754",
        "positionId": "56055754",
        "volume": 8.11,
        "price": 3220.52,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3220.52,
        "doubleCheck": true
    },
    {
        "dataID": "117895",
        "id": "53092975",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:57",
        "brokerTime": "2025-05-14 15:09:58",
        "commission": -56.77,
        "swap": 0,
        "profit": -170.31,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055755",
        "positionId": "56055754",
        "volume": 8.11,
        "price": 3220.73,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -227.08,
        "priceIn": 3220.52,
        "doubleCheck": true
    },
    {
        "dataID": "117896",
        "id": "53092976",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:59",
        "brokerTime": "2025-05-14 15:09:59",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055756",
        "positionId": "56055756",
        "volume": 8.11,
        "price": 3220.64,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3220.64,
        "doubleCheck": true
    },
    {
        "dataID": "117897",
        "id": "53092978",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:59",
        "brokerTime": "2025-05-14 15:09:59",
        "commission": -56.77,
        "swap": 0,
        "profit": -275.74,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055758",
        "positionId": "56055756",
        "volume": 8.11,
        "price": 3220.98,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -332.51,
        "priceIn": 3220.64,
        "doubleCheck": true
    },
    {
        "dataID": "117898",
        "id": "53092979",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:00",
        "brokerTime": "2025-05-14 15:10:00",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055759",
        "positionId": "56055759",
        "volume": 8.11,
        "price": 3220.67,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3220.67,
        "doubleCheck": true
    },
    {
        "dataID": "117899",
        "id": "53092983",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:00",
        "brokerTime": "2025-05-14 15:10:01",
        "commission": -56.77,
        "swap": 0,
        "profit": -89.21,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055763",
        "positionId": "56055759",
        "volume": 8.11,
        "price": 3220.78,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -145.98,
        "priceIn": 3220.67,
        "doubleCheck": true
    },
    {
        "dataID": "117900",
        "id": "53092984",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:01",
        "brokerTime": "2025-05-14 15:10:01",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055764",
        "positionId": "56055764",
        "volume": 8.11,
        "price": 3220.51,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3220.51,
        "doubleCheck": true
    },
    {
        "dataID": "117901",
        "id": "53092985",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:01",
        "brokerTime": "2025-05-14 15:10:02",
        "commission": -56.77,
        "swap": 0,
        "profit": -170.31,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055765",
        "positionId": "56055764",
        "volume": 8.11,
        "price": 3220.72,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -227.08,
        "priceIn": 3220.51,
        "doubleCheck": true
    },
    {
        "dataID": "117902",
        "id": "53092988",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:03",
        "brokerTime": "2025-05-14 15:10:03",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055770",
        "positionId": "56055770",
        "volume": 8.11,
        "price": 3220.44,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3220.44,
        "doubleCheck": true
    },
    {
        "dataID": "117903",
        "id": "53093057",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:03",
        "brokerTime": "2025-05-14 15:10:04",
        "commission": -56.77,
        "swap": 0,
        "profit": -113.54,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055843",
        "positionId": "56055770",
        "volume": 8.11,
        "price": 3220.58,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -170.31,
        "priceIn": 3220.44,
        "doubleCheck": true
    },
    {
        "dataID": "117904",
        "id": "53093115",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:04",
        "brokerTime": "2025-05-14 15:10:04",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055865",
        "positionId": "56055865",
        "volume": 8.11,
        "price": 3220.44,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3220.44,
        "doubleCheck": true
    },
    {
        "dataID": "117905",
        "id": "53093193",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:04",
        "brokerTime": "2025-05-14 15:10:05",
        "commission": -56.77,
        "swap": 0,
        "profit": -121.65,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055905",
        "positionId": "56055865",
        "volume": 8.11,
        "price": 3220.59,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -178.42000000000002,
        "priceIn": 3220.44,
        "doubleCheck": true
    },
    {
        "dataID": "117906",
        "id": "53093195",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:06",
        "brokerTime": "2025-05-14 15:10:06",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055907",
        "positionId": "56055907",
        "volume": 8.11,
        "price": 3220.33,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3220.33,
        "doubleCheck": true
    },
    {
        "dataID": "117907",
        "id": "53093197",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:06",
        "brokerTime": "2025-05-14 15:10:09",
        "commission": -56.77,
        "swap": 0,
        "profit": -81.1,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055909",
        "positionId": "56055907",
        "volume": 8.11,
        "price": 3220.43,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -137.87,
        "priceIn": 3220.33,
        "doubleCheck": true
    },
    {
        "dataID": "117908",
        "id": "53093199",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:09",
        "brokerTime": "2025-05-14 15:10:09",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055911",
        "positionId": "56055911",
        "volume": 8.11,
        "price": 3220.23,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3220.23,
        "doubleCheck": true
    },
    {
        "dataID": "117909",
        "id": "53093200",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:09",
        "brokerTime": "2025-05-14 15:10:10",
        "commission": -56.77,
        "swap": 0,
        "profit": -97.32,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055912",
        "positionId": "56055911",
        "volume": 8.11,
        "price": 3220.35,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -154.09,
        "priceIn": 3220.23,
        "doubleCheck": true
    },
    {
        "dataID": "117910",
        "id": "53093201",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:11",
        "brokerTime": "2025-05-14 15:10:11",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055913",
        "positionId": "56055913",
        "volume": 8.11,
        "price": 3220.13,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3220.13,
        "doubleCheck": true
    },
    {
        "dataID": "117911",
        "id": "53093202",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:11",
        "brokerTime": "2025-05-14 15:10:11",
        "commission": -56.77,
        "swap": 0,
        "profit": -129.76,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055914",
        "positionId": "56055913",
        "volume": 8.11,
        "price": 3220.29,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -186.53,
        "priceIn": 3220.13,
        "doubleCheck": true
    },
    {
        "dataID": "117912",
        "id": "53093203",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:11",
        "brokerTime": "2025-05-14 15:10:11",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055915",
        "positionId": "56055915",
        "volume": 8.11,
        "price": 3220.12,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3220.12,
        "doubleCheck": true
    },
    {
        "dataID": "117913",
        "id": "53093206",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:11",
        "brokerTime": "2025-05-14 15:10:12",
        "commission": -56.77,
        "swap": 0,
        "profit": -129.76,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055917",
        "positionId": "56055915",
        "volume": 8.11,
        "price": 3220.28,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -186.53,
        "priceIn": 3220.12,
        "doubleCheck": true
    },
    {
        "dataID": "117914",
        "id": "53093207",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:12",
        "brokerTime": "2025-05-14 15:10:12",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055918",
        "positionId": "56055918",
        "volume": 8.11,
        "price": 3220.04,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3220.04,
        "doubleCheck": true
    },
    {
        "dataID": "117915",
        "id": "53093208",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:12",
        "brokerTime": "2025-05-14 15:10:14",
        "commission": -56.77,
        "swap": 0,
        "profit": -129.76,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055919",
        "positionId": "56055918",
        "volume": 8.11,
        "price": 3220.2,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -186.53,
        "priceIn": 3220.04,
        "doubleCheck": true
    },
    {
        "dataID": "117916",
        "id": "53093210",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:15",
        "brokerTime": "2025-05-14 15:10:15",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055921",
        "positionId": "56055921",
        "volume": 8.11,
        "price": 3220.33,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3220.33,
        "doubleCheck": true
    },
    {
        "dataID": "117917",
        "id": "53093211",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:15",
        "brokerTime": "2025-05-14 15:10:15",
        "commission": -56.77,
        "swap": 0,
        "profit": -121.65,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055922",
        "positionId": "56055921",
        "volume": 8.11,
        "price": 3220.48,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -178.42000000000002,
        "priceIn": 3220.33,
        "doubleCheck": true
    },
    {
        "dataID": "117918",
        "id": "53093212",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:16",
        "brokerTime": "2025-05-14 15:10:16",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055923",
        "positionId": "56055923",
        "volume": 8.11,
        "price": 3220.33,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3220.33,
        "doubleCheck": true
    },
    {
        "dataID": "117919",
        "id": "53093213",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:16",
        "brokerTime": "2025-05-14 15:10:16",
        "commission": -56.77,
        "swap": 0,
        "profit": -154.09,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055924",
        "positionId": "56055923",
        "volume": 8.11,
        "price": 3220.52,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -210.86,
        "priceIn": 3220.33,
        "doubleCheck": true
    },
    {
        "dataID": "117920",
        "id": "53093214",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:17",
        "brokerTime": "2025-05-14 15:10:17",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055925",
        "positionId": "56055925",
        "volume": 8.11,
        "price": 3220.53,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3220.53,
        "doubleCheck": true
    },
    {
        "dataID": "117921",
        "id": "53093215",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:17",
        "brokerTime": "2025-05-14 15:10:17",
        "commission": -56.77,
        "swap": 0,
        "profit": -162.2,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055926",
        "positionId": "56055925",
        "volume": 8.11,
        "price": 3220.73,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -218.97,
        "priceIn": 3220.53,
        "doubleCheck": true
    },
    {
        "dataID": "117922",
        "id": "53093216",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:18",
        "brokerTime": "2025-05-14 15:10:18",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055927",
        "positionId": "56055927",
        "volume": 8.11,
        "price": 3220.92,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3220.92,
        "doubleCheck": true
    },
    {
        "dataID": "117923",
        "id": "53093217",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:18",
        "brokerTime": "2025-05-14 15:10:19",
        "commission": -56.77,
        "swap": 0,
        "profit": -251.41,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055928",
        "positionId": "56055927",
        "volume": 8.11,
        "price": 3221.23,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -308.18,
        "priceIn": 3220.92,
        "doubleCheck": true
    },
    {
        "dataID": "117924",
        "id": "53093218",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:19",
        "brokerTime": "2025-05-14 15:10:19",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055929",
        "positionId": "56055929",
        "volume": 8.11,
        "price": 3221.08,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3221.08,
        "doubleCheck": true
    },
    {
        "dataID": "117925",
        "id": "53093219",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:19",
        "brokerTime": "2025-05-14 15:10:19",
        "commission": -56.77,
        "swap": 0,
        "profit": -121.65,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055930",
        "positionId": "56055929",
        "volume": 8.11,
        "price": 3221.23,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -178.42000000000002,
        "priceIn": 3221.08,
        "doubleCheck": true
    },
    {
        "dataID": "117926",
        "id": "53093220",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:20",
        "brokerTime": "2025-05-14 15:10:20",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055931",
        "positionId": "56055931",
        "volume": 8.11,
        "price": 3221.09,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3221.09,
        "doubleCheck": true
    },
    {
        "dataID": "117927",
        "id": "53093221",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:20",
        "brokerTime": "2025-05-14 15:10:20",
        "commission": -56.77,
        "swap": 0,
        "profit": -186.53,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055932",
        "positionId": "56055931",
        "volume": 8.11,
        "price": 3221.32,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -243.3,
        "priceIn": 3221.09,
        "doubleCheck": true
    },
    {
        "dataID": "117928",
        "id": "53093222",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:21",
        "brokerTime": "2025-05-14 15:10:21",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055933",
        "positionId": "56055933",
        "volume": 8.11,
        "price": 3221.19,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3221.19,
        "doubleCheck": true
    },
    {
        "dataID": "117929",
        "id": "53093223",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:21",
        "brokerTime": "2025-05-14 15:10:21",
        "commission": -56.77,
        "swap": 0,
        "profit": -145.98,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055934",
        "positionId": "56055933",
        "volume": 8.11,
        "price": 3221.37,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -202.75,
        "priceIn": 3221.19,
        "doubleCheck": true
    },
    {
        "dataID": "117930",
        "id": "53093224",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:21",
        "brokerTime": "2025-05-14 15:10:21",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055935",
        "positionId": "56055935",
        "volume": 8.11,
        "price": 3221.08,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3221.08,
        "doubleCheck": true
    },
    {
        "dataID": "117931",
        "id": "53093225",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:21",
        "brokerTime": "2025-05-14 15:10:23",
        "commission": -56.77,
        "swap": 0,
        "profit": -275.74,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055936",
        "positionId": "56055935",
        "volume": 8.11,
        "price": 3221.42,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -332.51,
        "priceIn": 3221.08,
        "doubleCheck": true
    },
    {
        "dataID": "117932",
        "id": "53093227",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:23",
        "brokerTime": "2025-05-14 15:10:23",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055938",
        "positionId": "56055938",
        "volume": 8.11,
        "price": 3221.1,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3221.1,
        "doubleCheck": true
    },
    {
        "dataID": "117933",
        "id": "53093228",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:23",
        "brokerTime": "2025-05-14 15:10:24",
        "commission": -56.77,
        "swap": 0,
        "profit": -218.97,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055939",
        "positionId": "56055938",
        "volume": 8.11,
        "price": 3221.37,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -275.74,
        "priceIn": 3221.1,
        "doubleCheck": true
    },
    {
        "dataID": "117934",
        "id": "53093229",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:24",
        "brokerTime": "2025-05-14 15:10:24",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055940",
        "positionId": "56055940",
        "volume": 8.11,
        "price": 3221.2,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3221.2,
        "doubleCheck": true
    },
    {
        "dataID": "117935",
        "id": "53093230",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:24",
        "brokerTime": "2025-05-14 15:10:25",
        "commission": -56.77,
        "swap": 0,
        "profit": -137.87,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055941",
        "positionId": "56055940",
        "volume": 8.11,
        "price": 3221.37,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -194.64000000000001,
        "priceIn": 3221.2,
        "doubleCheck": true
    },
    {
        "dataID": "117936",
        "id": "53093231",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:25",
        "brokerTime": "2025-05-14 15:10:25",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055942",
        "positionId": "56055942",
        "volume": 8.11,
        "price": 3221.16,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3221.16,
        "doubleCheck": true
    },
    {
        "dataID": "117937",
        "id": "53093232",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:25",
        "brokerTime": "2025-05-14 15:10:26",
        "commission": -56.77,
        "swap": 0,
        "profit": -154.09,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055943",
        "positionId": "56055942",
        "volume": 8.11,
        "price": 3221.35,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -210.86,
        "priceIn": 3221.16,
        "doubleCheck": true
    },
    {
        "dataID": "117938",
        "id": "53093233",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:26",
        "brokerTime": "2025-05-14 15:10:26",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055944",
        "positionId": "56055944",
        "volume": 8.11,
        "price": 3221.17,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3221.17,
        "doubleCheck": true
    },
    {
        "dataID": "117939",
        "id": "53093234",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:26",
        "brokerTime": "2025-05-14 15:10:28",
        "commission": -56.77,
        "swap": 0,
        "profit": -145.98,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055945",
        "positionId": "56055944",
        "volume": 8.11,
        "price": 3221.35,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -202.75,
        "priceIn": 3221.17,
        "doubleCheck": true
    },
    {
        "dataID": "117940",
        "id": "53093235",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:28",
        "brokerTime": "2025-05-14 15:10:28",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055946",
        "positionId": "56055946",
        "volume": 8.11,
        "price": 3221.06,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3221.06,
        "doubleCheck": true
    },
    {
        "dataID": "117941",
        "id": "53093236",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:28",
        "brokerTime": "2025-05-14 15:10:28",
        "commission": -56.77,
        "swap": 0,
        "profit": -121.65,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055947",
        "positionId": "56055946",
        "volume": 8.11,
        "price": 3221.21,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -178.42000000000002,
        "priceIn": 3221.06,
        "doubleCheck": true
    },
    {
        "dataID": "117942",
        "id": "53093237",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:29",
        "brokerTime": "2025-05-14 15:10:29",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055949",
        "positionId": "56055949",
        "volume": 8.11,
        "price": 3220.97,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3220.97,
        "doubleCheck": true
    },
    {
        "dataID": "117943",
        "id": "53093238",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:29",
        "brokerTime": "2025-05-14 15:10:30",
        "commission": -56.77,
        "swap": 0,
        "profit": -16.22,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055950",
        "positionId": "56055949",
        "volume": 8.11,
        "price": 3220.99,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -72.99000000000001,
        "priceIn": 3220.97,
        "doubleCheck": true
    },
    {
        "dataID": "117944",
        "id": "53093239",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:30",
        "brokerTime": "2025-05-14 15:10:30",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055951",
        "positionId": "56055951",
        "volume": 8.11,
        "price": 3220.84,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3220.84,
        "doubleCheck": true
    },
    {
        "dataID": "117945",
        "id": "53093240",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:30",
        "brokerTime": "2025-05-14 15:10:31",
        "commission": -56.77,
        "swap": 0,
        "profit": -105.43,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055952",
        "positionId": "56055951",
        "volume": 8.11,
        "price": 3220.97,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -162.20000000000002,
        "priceIn": 3220.84,
        "doubleCheck": true
    },
    {
        "dataID": "117946",
        "id": "53093241",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:31",
        "brokerTime": "2025-05-14 15:10:31",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055953",
        "positionId": "56055953",
        "volume": 8.11,
        "price": 3220.83,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3220.83,
        "doubleCheck": true
    },
    {
        "dataID": "117947",
        "id": "53093242",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:31",
        "brokerTime": "2025-05-14 15:10:32",
        "commission": -56.77,
        "swap": 0,
        "profit": -218.97,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055954",
        "positionId": "56055953",
        "volume": 8.11,
        "price": 3221.1,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -275.74,
        "priceIn": 3220.83,
        "doubleCheck": true
    },
    {
        "dataID": "117948",
        "id": "53093243",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:34",
        "brokerTime": "2025-05-14 15:10:34",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055955",
        "positionId": "56055955",
        "volume": 8.11,
        "price": 3220.93,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3220.93,
        "doubleCheck": true
    },
    {
        "dataID": "117949",
        "id": "53093244",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:34",
        "brokerTime": "2025-05-14 15:10:34",
        "commission": -56.77,
        "swap": 0,
        "profit": -137.87,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055956",
        "positionId": "56055955",
        "volume": 8.11,
        "price": 3221.1,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -194.64000000000001,
        "priceIn": 3220.93,
        "doubleCheck": true
    },
    {
        "dataID": "117950",
        "id": "53093246",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:35",
        "brokerTime": "2025-05-14 15:10:35",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055958",
        "positionId": "56055958",
        "volume": 8.11,
        "price": 3220.92,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3220.92,
        "doubleCheck": true
    },
    {
        "dataID": "117951",
        "id": "53093247",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:35",
        "brokerTime": "2025-05-14 15:10:36",
        "commission": -56.77,
        "swap": 0,
        "profit": -48.66,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055959",
        "positionId": "56055958",
        "volume": 8.11,
        "price": 3220.98,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -105.43,
        "priceIn": 3220.92,
        "doubleCheck": true
    },
    {
        "dataID": "117952",
        "id": "53093248",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:37",
        "brokerTime": "2025-05-14 15:10:37",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055960",
        "positionId": "56055960",
        "volume": 8.11,
        "price": 3220.92,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3220.92,
        "doubleCheck": true
    },
    {
        "dataID": "117953",
        "id": "53093249",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:37",
        "brokerTime": "2025-05-14 15:10:37",
        "commission": -56.77,
        "swap": 0,
        "profit": -162.2,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055961",
        "positionId": "56055960",
        "volume": 8.11,
        "price": 3221.12,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -218.97,
        "priceIn": 3220.92,
        "doubleCheck": true
    },
    {
        "dataID": "117954",
        "id": "53093250",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:37",
        "brokerTime": "2025-05-14 15:10:37",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055962",
        "positionId": "56055962",
        "volume": 8.11,
        "price": 3220.92,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3220.92,
        "doubleCheck": true
    },
    {
        "dataID": "117955",
        "id": "53093251",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:37",
        "brokerTime": "2025-05-14 15:10:38",
        "commission": -56.77,
        "swap": 0,
        "profit": -186.53,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055963",
        "positionId": "56055962",
        "volume": 8.11,
        "price": 3221.15,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -243.3,
        "priceIn": 3220.92,
        "doubleCheck": true
    },
    {
        "dataID": "117956",
        "id": "53093252",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:38",
        "brokerTime": "2025-05-14 15:10:38",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055964",
        "positionId": "56055964",
        "volume": 8.11,
        "price": 3220.97,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3220.97,
        "doubleCheck": true
    },
    {
        "dataID": "117957",
        "id": "53093253",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:38",
        "brokerTime": "2025-05-14 15:10:40",
        "commission": -56.77,
        "swap": 0,
        "profit": -129.76,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055965",
        "positionId": "56055964",
        "volume": 8.11,
        "price": 3221.13,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -186.53,
        "priceIn": 3220.97,
        "doubleCheck": true
    },
    {
        "dataID": "117958",
        "id": "53093254",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:40",
        "brokerTime": "2025-05-14 15:10:40",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055966",
        "positionId": "56055966",
        "volume": 8.11,
        "price": 3221.41,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3221.41,
        "doubleCheck": true
    },
    {
        "dataID": "117959",
        "id": "53093255",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:40",
        "brokerTime": "2025-05-14 15:10:41",
        "commission": -56.77,
        "swap": 0,
        "profit": 567.7,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055967",
        "positionId": "56055966",
        "volume": 8.11,
        "price": 3220.71,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 510.93000000000006,
        "priceIn": 3221.41,
        "doubleCheck": true
    },
    {
        "dataID": "117960",
        "id": "53093256",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:41",
        "brokerTime": "2025-05-14 15:10:41",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055968",
        "positionId": "56055968",
        "volume": 8.11,
        "price": 3220.6,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3220.6,
        "doubleCheck": true
    },
    {
        "dataID": "117961",
        "id": "53093257",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:41",
        "brokerTime": "2025-05-14 15:10:42",
        "commission": -56.77,
        "swap": 0,
        "profit": -64.88,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055969",
        "positionId": "56055968",
        "volume": 8.11,
        "price": 3220.68,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -121.65,
        "priceIn": 3220.6,
        "doubleCheck": true
    },
    {
        "dataID": "117962",
        "id": "53093258",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:42",
        "brokerTime": "2025-05-14 15:10:42",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055970",
        "positionId": "56055970",
        "volume": 8.11,
        "price": 3220.72,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3220.72,
        "doubleCheck": true
    },
    {
        "dataID": "117963",
        "id": "53093259",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:42",
        "brokerTime": "2025-05-14 15:10:44",
        "commission": -56.77,
        "swap": 0,
        "profit": 8.11,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055971",
        "positionId": "56055970",
        "volume": 8.11,
        "price": 3220.71,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -48.660000000000004,
        "priceIn": 3220.72,
        "doubleCheck": true
    },
    {
        "dataID": "117964",
        "id": "53093260",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:44",
        "brokerTime": "2025-05-14 15:10:44",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055972",
        "positionId": "56055972",
        "volume": 8.11,
        "price": 3220.52,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3220.52,
        "doubleCheck": true
    },
    {
        "dataID": "117965",
        "id": "53093261",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:44",
        "brokerTime": "2025-05-14 15:10:46",
        "commission": -56.77,
        "swap": 0,
        "profit": 40.55,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055973",
        "positionId": "56055972",
        "volume": 8.11,
        "price": 3220.47,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -16.220000000000006,
        "priceIn": 3220.52,
        "doubleCheck": true
    },
    {
        "dataID": "117966",
        "id": "53093262",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:46",
        "brokerTime": "2025-05-14 15:10:46",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055974",
        "positionId": "56055974",
        "volume": 8.11,
        "price": 3220.3,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3220.3,
        "doubleCheck": true
    },
    {
        "dataID": "117967",
        "id": "53093263",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:46",
        "brokerTime": "2025-05-14 15:10:47",
        "commission": -56.77,
        "swap": 0,
        "profit": 113.54,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055975",
        "positionId": "56055974",
        "volume": 8.11,
        "price": 3220.16,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 56.77,
        "priceIn": 3220.3,
        "doubleCheck": true
    },
    {
        "dataID": "117968",
        "id": "53093264",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:47",
        "brokerTime": "2025-05-14 15:10:47",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055976",
        "positionId": "56055976",
        "volume": 8.11,
        "price": 3220.17,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3220.17,
        "doubleCheck": true
    },
    {
        "dataID": "117969",
        "id": "53093266",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:47",
        "brokerTime": "2025-05-14 15:10:48",
        "commission": -56.77,
        "swap": 0,
        "profit": -121.65,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055978",
        "positionId": "56055976",
        "volume": 8.11,
        "price": 3220.32,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -178.42000000000002,
        "priceIn": 3220.17,
        "doubleCheck": true
    },
    {
        "dataID": "117970",
        "id": "53093267",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:48",
        "brokerTime": "2025-05-14 15:10:48",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055979",
        "positionId": "56055979",
        "volume": 8.11,
        "price": 3220.08,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3220.08,
        "doubleCheck": true
    },
    {
        "dataID": "117971",
        "id": "53093268",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:48",
        "brokerTime": "2025-05-14 15:10:48",
        "commission": -56.77,
        "swap": 0,
        "profit": -170.31,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055981",
        "positionId": "56055979",
        "volume": 8.11,
        "price": 3220.29,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -227.08,
        "priceIn": 3220.08,
        "doubleCheck": true
    },
    {
        "dataID": "117972",
        "id": "53093269",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:49",
        "brokerTime": "2025-05-14 15:10:49",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055982",
        "positionId": "56055982",
        "volume": 8.11,
        "price": 3220.07,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3220.07,
        "doubleCheck": true
    },
    {
        "dataID": "117973",
        "id": "53093270",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:49",
        "brokerTime": "2025-05-14 15:10:49",
        "commission": -56.77,
        "swap": 0,
        "profit": -210.86,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055983",
        "positionId": "56055982",
        "volume": 8.11,
        "price": 3220.33,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -267.63,
        "priceIn": 3220.07,
        "doubleCheck": true
    },
    {
        "dataID": "117974",
        "id": "53093271",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:50",
        "brokerTime": "2025-05-14 15:10:50",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055984",
        "positionId": "56055984",
        "volume": 8.11,
        "price": 3220.21,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3220.21,
        "doubleCheck": true
    },
    {
        "dataID": "117975",
        "id": "53093272",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:50",
        "brokerTime": "2025-05-14 15:10:51",
        "commission": -56.77,
        "swap": 0,
        "profit": 24.33,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055985",
        "positionId": "56055984",
        "volume": 8.11,
        "price": 3220.18,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -32.440000000000005,
        "priceIn": 3220.21,
        "doubleCheck": true
    },
    {
        "dataID": "117976",
        "id": "53093273",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:51",
        "brokerTime": "2025-05-14 15:10:51",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055986",
        "positionId": "56055986",
        "volume": 8.11,
        "price": 3220.15,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3220.15,
        "doubleCheck": true
    },
    {
        "dataID": "117977",
        "id": "53093274",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:51",
        "brokerTime": "2025-05-14 15:10:52",
        "commission": -56.77,
        "swap": 0,
        "profit": -81.1,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055987",
        "positionId": "56055986",
        "volume": 8.11,
        "price": 3220.25,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -137.87,
        "priceIn": 3220.15,
        "doubleCheck": true
    },
    {
        "dataID": "117978",
        "id": "53093275",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:52",
        "brokerTime": "2025-05-14 15:10:52",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055988",
        "positionId": "56055988",
        "volume": 8.11,
        "price": 3219.98,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3219.98,
        "doubleCheck": true
    },
    {
        "dataID": "117979",
        "id": "53093276",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:52",
        "brokerTime": "2025-05-14 15:10:53",
        "commission": -56.77,
        "swap": 0,
        "profit": -89.21,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055989",
        "positionId": "56055988",
        "volume": 8.11,
        "price": 3220.09,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -145.98,
        "priceIn": 3219.98,
        "doubleCheck": true
    },
    {
        "dataID": "117980",
        "id": "53093278",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:55",
        "brokerTime": "2025-05-14 15:10:55",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055991",
        "positionId": "56055991",
        "volume": 8.11,
        "price": 3219.94,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3219.94,
        "doubleCheck": true
    },
    {
        "dataID": "117981",
        "id": "53093279",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:55",
        "brokerTime": "2025-05-14 15:10:57",
        "commission": -56.77,
        "swap": 0,
        "profit": -40.55,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055992",
        "positionId": "56055991",
        "volume": 8.11,
        "price": 3219.99,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -97.32,
        "priceIn": 3219.94,
        "doubleCheck": true
    },
    {
        "dataID": "117982",
        "id": "53093286",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:57",
        "brokerTime": "2025-05-14 15:10:57",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56055999",
        "positionId": "56055999",
        "volume": 8.11,
        "price": 3219.66,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3219.66,
        "doubleCheck": true
    },
    {
        "dataID": "117983",
        "id": "53093289",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:57",
        "brokerTime": "2025-05-14 15:10:58",
        "commission": -56.77,
        "swap": 0,
        "profit": -105.43,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056002",
        "positionId": "56055999",
        "volume": 8.11,
        "price": 3219.79,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -162.20000000000002,
        "priceIn": 3219.66,
        "doubleCheck": true
    },
    {
        "dataID": "117984",
        "id": "53093293",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:59",
        "brokerTime": "2025-05-14 15:10:59",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056006",
        "positionId": "56056006",
        "volume": 8.11,
        "price": 3219.62,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3219.62,
        "doubleCheck": true
    },
    {
        "dataID": "117985",
        "id": "53093296",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:59",
        "brokerTime": "2025-05-14 15:10:59",
        "commission": -56.77,
        "swap": 0,
        "profit": -64.88,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056009",
        "positionId": "56056006",
        "volume": 8.11,
        "price": 3219.7,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -121.65,
        "priceIn": 3219.62,
        "doubleCheck": true
    },
    {
        "dataID": "117986",
        "id": "53093297",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:00",
        "brokerTime": "2025-05-14 15:11:00",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056010",
        "positionId": "56056010",
        "volume": 8.11,
        "price": 3219.63,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3219.63,
        "doubleCheck": true
    },
    {
        "dataID": "117987",
        "id": "53093312",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:00",
        "brokerTime": "2025-05-14 15:11:00",
        "commission": -56.77,
        "swap": 0,
        "profit": -129.76,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056026",
        "positionId": "56056010",
        "volume": 8.11,
        "price": 3219.79,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -186.53,
        "priceIn": 3219.63,
        "doubleCheck": true
    },
    {
        "dataID": "117988",
        "id": "53093317",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:01",
        "brokerTime": "2025-05-14 15:11:01",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056029",
        "positionId": "56056029",
        "volume": 8.11,
        "price": 3219.71,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3219.71,
        "doubleCheck": true
    },
    {
        "dataID": "117989",
        "id": "53093320",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:01",
        "brokerTime": "2025-05-14 15:11:01",
        "commission": -56.77,
        "swap": 0,
        "profit": -218.97,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056033",
        "positionId": "56056029",
        "volume": 8.11,
        "price": 3219.98,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -275.74,
        "priceIn": 3219.71,
        "doubleCheck": true
    },
    {
        "dataID": "117990",
        "id": "53093324",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:02",
        "brokerTime": "2025-05-14 15:11:02",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056036",
        "positionId": "56056036",
        "volume": 8.11,
        "price": 3219.67,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3219.67,
        "doubleCheck": true
    },
    {
        "dataID": "117991",
        "id": "53093454",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:02",
        "brokerTime": "2025-05-14 15:11:02",
        "commission": -56.77,
        "swap": 0,
        "profit": -162.2,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056109",
        "positionId": "56056036",
        "volume": 8.11,
        "price": 3219.87,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -218.97,
        "priceIn": 3219.67,
        "doubleCheck": true
    },
    {
        "dataID": "117992",
        "id": "53093493",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:03",
        "brokerTime": "2025-05-14 15:11:03",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056159",
        "positionId": "56056159",
        "volume": 8.11,
        "price": 3219.72,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3219.72,
        "doubleCheck": true
    },
    {
        "dataID": "117993",
        "id": "53093623",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:03",
        "brokerTime": "2025-05-14 15:11:03",
        "commission": -56.77,
        "swap": 0,
        "profit": -81.1,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056231",
        "positionId": "56056159",
        "volume": 8.11,
        "price": 3219.82,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -137.87,
        "priceIn": 3219.72,
        "doubleCheck": true
    },
    {
        "dataID": "117994",
        "id": "53093653",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:04",
        "brokerTime": "2025-05-14 15:11:04",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056244",
        "positionId": "56056244",
        "volume": 8.11,
        "price": 3219.68,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3219.68,
        "doubleCheck": true
    },
    {
        "dataID": "117995",
        "id": "53093662",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:04",
        "brokerTime": "2025-05-14 15:11:04",
        "commission": -56.77,
        "swap": 0,
        "profit": -145.98,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056250",
        "positionId": "56056244",
        "volume": 8.11,
        "price": 3219.86,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -202.75,
        "priceIn": 3219.68,
        "doubleCheck": true
    },
    {
        "dataID": "117996",
        "id": "53093664",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:05",
        "brokerTime": "2025-05-14 15:11:05",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056253",
        "positionId": "56056253",
        "volume": 8.11,
        "price": 3219.68,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3219.68,
        "doubleCheck": true
    },
    {
        "dataID": "117997",
        "id": "53093668",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:05",
        "brokerTime": "2025-05-14 15:11:05",
        "commission": -56.77,
        "swap": 0,
        "profit": -137.87,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056254",
        "positionId": "56056253",
        "volume": 8.11,
        "price": 3219.85,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -194.64000000000001,
        "priceIn": 3219.68,
        "doubleCheck": true
    },
    {
        "dataID": "117998",
        "id": "53093669",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:05",
        "brokerTime": "2025-05-14 15:11:05",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056255",
        "positionId": "56056255",
        "volume": 8.11,
        "price": 3219.71,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3219.71,
        "doubleCheck": true
    },
    {
        "dataID": "117999",
        "id": "53093670",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:05",
        "brokerTime": "2025-05-14 15:11:06",
        "commission": -56.77,
        "swap": 0,
        "profit": -194.64,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056256",
        "positionId": "56056255",
        "volume": 8.11,
        "price": 3219.95,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -251.41,
        "priceIn": 3219.71,
        "doubleCheck": true
    },
    {
        "dataID": "118000",
        "id": "53093671",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:06",
        "brokerTime": "2025-05-14 15:11:06",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056257",
        "positionId": "56056257",
        "volume": 8.11,
        "price": 3219.74,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3219.74,
        "doubleCheck": true
    },
    {
        "dataID": "118001",
        "id": "53093672",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:06",
        "brokerTime": "2025-05-14 15:11:08",
        "commission": -56.77,
        "swap": 0,
        "profit": -227.08,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056258",
        "positionId": "56056257",
        "volume": 8.11,
        "price": 3220.02,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -283.85,
        "priceIn": 3219.74,
        "doubleCheck": true
    },
    {
        "dataID": "118002",
        "id": "53093673",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:08",
        "brokerTime": "2025-05-14 15:11:08",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056259",
        "positionId": "56056259",
        "volume": 8.11,
        "price": 3219.8,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3219.8,
        "doubleCheck": true
    },
    {
        "dataID": "118003",
        "id": "53093674",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:08",
        "brokerTime": "2025-05-14 15:11:08",
        "commission": -56.77,
        "swap": 0,
        "profit": -113.54,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056260",
        "positionId": "56056259",
        "volume": 8.11,
        "price": 3219.94,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -170.31,
        "priceIn": 3219.8,
        "doubleCheck": true
    },
    {
        "dataID": "118004",
        "id": "53093675",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:09",
        "brokerTime": "2025-05-14 15:11:09",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056261",
        "positionId": "56056261",
        "volume": 8.11,
        "price": 3219.79,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3219.79,
        "doubleCheck": true
    },
    {
        "dataID": "118005",
        "id": "53093677",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:09",
        "brokerTime": "2025-05-14 15:11:10",
        "commission": -56.77,
        "swap": 0,
        "profit": -8.11,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056263",
        "positionId": "56056261",
        "volume": 8.11,
        "price": 3219.8,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -64.88,
        "priceIn": 3219.79,
        "doubleCheck": true
    },
    {
        "dataID": "118006",
        "id": "53093678",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:11",
        "brokerTime": "2025-05-14 15:11:11",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056265",
        "positionId": "56056265",
        "volume": 8.11,
        "price": 3219.84,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3219.84,
        "doubleCheck": true
    },
    {
        "dataID": "118007",
        "id": "53093679",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:11",
        "brokerTime": "2025-05-14 15:11:11",
        "commission": -56.77,
        "swap": 0,
        "profit": 97.32,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056266",
        "positionId": "56056265",
        "volume": 8.11,
        "price": 3219.72,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 40.54999999999999,
        "priceIn": 3219.84,
        "doubleCheck": true
    },
    {
        "dataID": "118008",
        "id": "53093680",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:11",
        "brokerTime": "2025-05-14 15:11:11",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056267",
        "positionId": "56056267",
        "volume": 8.11,
        "price": 3219.6,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3219.6,
        "doubleCheck": true
    },
    {
        "dataID": "118009",
        "id": "53093681",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:11",
        "brokerTime": "2025-05-14 15:11:12",
        "commission": -56.77,
        "swap": 0,
        "profit": -89.21,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056268",
        "positionId": "56056267",
        "volume": 8.11,
        "price": 3219.71,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -145.98,
        "priceIn": 3219.6,
        "doubleCheck": true
    },
    {
        "dataID": "118010",
        "id": "53093683",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:13",
        "brokerTime": "2025-05-14 15:11:13",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056270",
        "positionId": "56056270",
        "volume": 8.11,
        "price": 3219.56,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3219.56,
        "doubleCheck": true
    },
    {
        "dataID": "118011",
        "id": "53093684",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:13",
        "brokerTime": "2025-05-14 15:11:13",
        "commission": -56.77,
        "swap": 0,
        "profit": -129.76,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056271",
        "positionId": "56056270",
        "volume": 8.11,
        "price": 3219.72,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -186.53,
        "priceIn": 3219.56,
        "doubleCheck": true
    },
    {
        "dataID": "118012",
        "id": "53093685",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:14",
        "brokerTime": "2025-05-14 15:11:14",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056272",
        "positionId": "56056272",
        "volume": 8.11,
        "price": 3219.55,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3219.55,
        "doubleCheck": true
    },
    {
        "dataID": "118013",
        "id": "53093688",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:14",
        "brokerTime": "2025-05-14 15:11:15",
        "commission": -56.77,
        "swap": 0,
        "profit": 48.66,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056275",
        "positionId": "56056272",
        "volume": 8.11,
        "price": 3219.49,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -8.110000000000007,
        "priceIn": 3219.55,
        "doubleCheck": true
    },
    {
        "dataID": "118014",
        "id": "53093689",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:15",
        "brokerTime": "2025-05-14 15:11:15",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056276",
        "positionId": "56056276",
        "volume": 8.11,
        "price": 3219.23,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3219.23,
        "doubleCheck": true
    },
    {
        "dataID": "118015",
        "id": "53093691",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:15",
        "brokerTime": "2025-05-14 15:11:15",
        "commission": -56.77,
        "swap": 0,
        "profit": -56.77,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056278",
        "positionId": "56056276",
        "volume": 8.11,
        "price": 3219.3,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -113.54,
        "priceIn": 3219.23,
        "doubleCheck": true
    },
    {
        "dataID": "118016",
        "id": "53093692",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:16",
        "brokerTime": "2025-05-14 15:11:16",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056279",
        "positionId": "56056279",
        "volume": 8.11,
        "price": 3219.21,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3219.21,
        "doubleCheck": true
    },
    {
        "dataID": "118017",
        "id": "53093693",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:16",
        "brokerTime": "2025-05-14 15:11:17",
        "commission": -56.77,
        "swap": 0,
        "profit": -137.87,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056280",
        "positionId": "56056279",
        "volume": 8.11,
        "price": 3219.38,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -194.64000000000001,
        "priceIn": 3219.21,
        "doubleCheck": true
    },
    {
        "dataID": "118018",
        "id": "53093694",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:17",
        "brokerTime": "2025-05-14 15:11:17",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056281",
        "positionId": "56056281",
        "volume": 8.11,
        "price": 3219.23,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3219.23,
        "doubleCheck": true
    },
    {
        "dataID": "118019",
        "id": "53093695",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:17",
        "brokerTime": "2025-05-14 15:11:18",
        "commission": -56.77,
        "swap": 0,
        "profit": -283.85,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056282",
        "positionId": "56056281",
        "volume": 8.11,
        "price": 3219.58,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -340.62,
        "priceIn": 3219.23,
        "doubleCheck": true
    },
    {
        "dataID": "118020",
        "id": "53093696",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:19",
        "brokerTime": "2025-05-14 15:11:19",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056283",
        "positionId": "56056283",
        "volume": 8.11,
        "price": 3219.45,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3219.45,
        "doubleCheck": true
    },
    {
        "dataID": "118021",
        "id": "53093697",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:19",
        "brokerTime": "2025-05-14 15:11:19",
        "commission": -56.77,
        "swap": 0,
        "profit": -170.31,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056284",
        "positionId": "56056283",
        "volume": 8.11,
        "price": 3219.66,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -227.08,
        "priceIn": 3219.45,
        "doubleCheck": true
    },
    {
        "dataID": "118022",
        "id": "53093698",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:19",
        "brokerTime": "2025-05-14 15:11:19",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056285",
        "positionId": "56056285",
        "volume": 8.11,
        "price": 3219.46,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3219.46,
        "doubleCheck": true
    },
    {
        "dataID": "118023",
        "id": "53093699",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:19",
        "brokerTime": "2025-05-14 15:11:20",
        "commission": -56.77,
        "swap": 0,
        "profit": -81.1,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056286",
        "positionId": "56056285",
        "volume": 8.11,
        "price": 3219.56,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -137.87,
        "priceIn": 3219.46,
        "doubleCheck": true
    },
    {
        "dataID": "118024",
        "id": "53093702",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:20",
        "brokerTime": "2025-05-14 15:11:20",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056288",
        "positionId": "56056288",
        "volume": 8.11,
        "price": 3219.41,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3219.41,
        "doubleCheck": true
    },
    {
        "dataID": "118025",
        "id": "53093705",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:20",
        "brokerTime": "2025-05-14 15:11:21",
        "commission": -56.77,
        "swap": 0,
        "profit": -267.63,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056291",
        "positionId": "56056288",
        "volume": 8.11,
        "price": 3219.74,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -324.4,
        "priceIn": 3219.41,
        "doubleCheck": true
    },
    {
        "dataID": "118026",
        "id": "53093706",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:21",
        "brokerTime": "2025-05-14 15:11:21",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056292",
        "positionId": "56056292",
        "volume": 8.11,
        "price": 3219.55,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3219.55,
        "doubleCheck": true
    },
    {
        "dataID": "118027",
        "id": "53093707",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:21",
        "brokerTime": "2025-05-14 15:11:21",
        "commission": -56.77,
        "swap": 0,
        "profit": -202.75,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056293",
        "positionId": "56056292",
        "volume": 8.11,
        "price": 3219.8,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -259.52,
        "priceIn": 3219.55,
        "doubleCheck": true
    },
    {
        "dataID": "118028",
        "id": "53093708",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:22",
        "brokerTime": "2025-05-14 15:11:22",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056294",
        "positionId": "56056294",
        "volume": 8.11,
        "price": 3219.44,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3219.44,
        "doubleCheck": true
    },
    {
        "dataID": "118029",
        "id": "53093710",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:22",
        "brokerTime": "2025-05-14 15:11:23",
        "commission": -56.77,
        "swap": 0,
        "profit": -145.98,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056296",
        "positionId": "56056294",
        "volume": 8.11,
        "price": 3219.62,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -202.75,
        "priceIn": 3219.44,
        "doubleCheck": true
    },
    {
        "dataID": "118030",
        "id": "53093714",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:23",
        "brokerTime": "2025-05-14 15:11:23",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056301",
        "positionId": "56056301",
        "volume": 8.11,
        "price": 3219.35,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3219.35,
        "doubleCheck": true
    },
    {
        "dataID": "118031",
        "id": "53093716",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:23",
        "brokerTime": "2025-05-14 15:11:23",
        "commission": -56.77,
        "swap": 0,
        "profit": 105.43,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056302",
        "positionId": "56056301",
        "volume": 8.11,
        "price": 3219.22,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 48.660000000000004,
        "priceIn": 3219.35,
        "doubleCheck": true
    },
    {
        "dataID": "118032",
        "id": "53093717",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:25",
        "brokerTime": "2025-05-14 15:11:25",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056303",
        "positionId": "56056303",
        "volume": 8.11,
        "price": 3219.13,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3219.13,
        "doubleCheck": true
    },
    {
        "dataID": "118033",
        "id": "53093718",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:25",
        "brokerTime": "2025-05-14 15:11:25",
        "commission": -56.77,
        "swap": 0,
        "profit": -97.32,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056304",
        "positionId": "56056303",
        "volume": 8.11,
        "price": 3219.25,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -154.09,
        "priceIn": 3219.13,
        "doubleCheck": true
    },
    {
        "dataID": "118034",
        "id": "53093719",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:25",
        "brokerTime": "2025-05-14 15:11:25",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056305",
        "positionId": "56056305",
        "volume": 8.11,
        "price": 3219.13,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3219.13,
        "doubleCheck": true
    },
    {
        "dataID": "118035",
        "id": "53093722",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:25",
        "brokerTime": "2025-05-14 15:11:27",
        "commission": -56.77,
        "swap": 0,
        "profit": -218.97,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056308",
        "positionId": "56056305",
        "volume": 8.11,
        "price": 3219.4,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -275.74,
        "priceIn": 3219.13,
        "doubleCheck": true
    },
    {
        "dataID": "118036",
        "id": "53093723",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:28",
        "brokerTime": "2025-05-14 15:11:28",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056309",
        "positionId": "56056309",
        "volume": 8.11,
        "price": 3219.2,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3219.2,
        "doubleCheck": true
    },
    {
        "dataID": "118037",
        "id": "53093726",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:28",
        "brokerTime": "2025-05-14 15:11:28",
        "commission": -56.77,
        "swap": 0,
        "profit": -129.76,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056312",
        "positionId": "56056309",
        "volume": 8.11,
        "price": 3219.36,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -186.53,
        "priceIn": 3219.2,
        "doubleCheck": true
    },
    {
        "dataID": "118038",
        "id": "53093727",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:28",
        "brokerTime": "2025-05-14 15:11:28",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056313",
        "positionId": "56056313",
        "volume": 8.11,
        "price": 3219.24,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3219.24,
        "doubleCheck": true
    },
    {
        "dataID": "118039",
        "id": "53093728",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:28",
        "brokerTime": "2025-05-14 15:11:29",
        "commission": -56.77,
        "swap": 0,
        "profit": -89.21,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056314",
        "positionId": "56056313",
        "volume": 8.11,
        "price": 3219.35,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -145.98,
        "priceIn": 3219.24,
        "doubleCheck": true
    },
    {
        "dataID": "118040",
        "id": "53093729",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:30",
        "brokerTime": "2025-05-14 15:11:30",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056315",
        "positionId": "56056315",
        "volume": 8.11,
        "price": 3219.44,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3219.44,
        "doubleCheck": true
    },
    {
        "dataID": "118041",
        "id": "53093730",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:30",
        "brokerTime": "2025-05-14 15:11:32",
        "commission": -56.77,
        "swap": 0,
        "profit": -81.1,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056316",
        "positionId": "56056315",
        "volume": 8.11,
        "price": 3219.54,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -137.87,
        "priceIn": 3219.44,
        "doubleCheck": true
    },
    {
        "dataID": "118042",
        "id": "53093731",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:32",
        "brokerTime": "2025-05-14 15:11:32",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056317",
        "positionId": "56056317",
        "volume": 8.11,
        "price": 3219.39,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3219.39,
        "doubleCheck": true
    },
    {
        "dataID": "118043",
        "id": "53093732",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:32",
        "brokerTime": "2025-05-14 15:11:33",
        "commission": -56.77,
        "swap": 0,
        "profit": -210.86,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056318",
        "positionId": "56056317",
        "volume": 8.11,
        "price": 3219.65,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -267.63,
        "priceIn": 3219.39,
        "doubleCheck": true
    },
    {
        "dataID": "118044",
        "id": "53093733",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:33",
        "brokerTime": "2025-05-14 15:11:33",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056319",
        "positionId": "56056319",
        "volume": 8.11,
        "price": 3219.51,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3219.51,
        "doubleCheck": true
    },
    {
        "dataID": "118045",
        "id": "53093734",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:33",
        "brokerTime": "2025-05-14 15:11:34",
        "commission": -56.77,
        "swap": 0,
        "profit": -121.65,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056320",
        "positionId": "56056319",
        "volume": 8.11,
        "price": 3219.66,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -178.42000000000002,
        "priceIn": 3219.51,
        "doubleCheck": true
    },
    {
        "dataID": "118046",
        "id": "53093736",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:34",
        "brokerTime": "2025-05-14 15:11:34",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056322",
        "positionId": "56056322",
        "volume": 8.11,
        "price": 3219.49,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3219.49,
        "doubleCheck": true
    },
    {
        "dataID": "118047",
        "id": "53093737",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:34",
        "brokerTime": "2025-05-14 15:11:35",
        "commission": -56.77,
        "swap": 0,
        "profit": -137.87,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056323",
        "positionId": "56056322",
        "volume": 8.11,
        "price": 3219.66,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -194.64000000000001,
        "priceIn": 3219.49,
        "doubleCheck": true
    },
    {
        "dataID": "118048",
        "id": "53093738",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:35",
        "brokerTime": "2025-05-14 15:11:35",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056324",
        "positionId": "56056324",
        "volume": 8.11,
        "price": 3219.88,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3219.88,
        "doubleCheck": true
    },
    {
        "dataID": "118049",
        "id": "53093740",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:35",
        "brokerTime": "2025-05-14 15:11:37",
        "commission": -56.77,
        "swap": 0,
        "profit": -324.4,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056326",
        "positionId": "56056324",
        "volume": 8.11,
        "price": 3220.28,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -381.16999999999996,
        "priceIn": 3219.88,
        "doubleCheck": true
    },
    {
        "dataID": "118050",
        "id": "53093741",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:38",
        "brokerTime": "2025-05-14 15:11:38",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056327",
        "positionId": "56056327",
        "volume": 8.11,
        "price": 3220.14,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3220.14,
        "doubleCheck": true
    },
    {
        "dataID": "118051",
        "id": "53093742",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:38",
        "brokerTime": "2025-05-14 15:11:38",
        "commission": -56.77,
        "swap": 0,
        "profit": -105.43,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056328",
        "positionId": "56056327",
        "volume": 8.11,
        "price": 3220.27,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -162.20000000000002,
        "priceIn": 3220.14,
        "doubleCheck": true
    },
    {
        "dataID": "118052",
        "id": "53093743",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:38",
        "brokerTime": "2025-05-14 15:11:38",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056329",
        "positionId": "56056329",
        "volume": 8.11,
        "price": 3220.1,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3220.1,
        "doubleCheck": true
    },
    {
        "dataID": "118053",
        "id": "53093744",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:38",
        "brokerTime": "2025-05-14 15:11:39",
        "commission": -56.77,
        "swap": 0,
        "profit": -129.76,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056331",
        "positionId": "56056329",
        "volume": 8.11,
        "price": 3220.26,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -186.53,
        "priceIn": 3220.1,
        "doubleCheck": true
    },
    {
        "dataID": "118054",
        "id": "53093746",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:39",
        "brokerTime": "2025-05-14 15:11:39",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056332",
        "positionId": "56056332",
        "volume": 8.11,
        "price": 3220.09,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3220.09,
        "doubleCheck": true
    },
    {
        "dataID": "118055",
        "id": "53093747",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:39",
        "brokerTime": "2025-05-14 15:11:40",
        "commission": -56.77,
        "swap": 0,
        "profit": -145.98,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056333",
        "positionId": "56056332",
        "volume": 8.11,
        "price": 3220.27,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -202.75,
        "priceIn": 3220.09,
        "doubleCheck": true
    },
    {
        "dataID": "118056",
        "id": "53093749",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:40",
        "brokerTime": "2025-05-14 15:11:40",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056335",
        "positionId": "56056335",
        "volume": 8.11,
        "price": 3220.16,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3220.16,
        "doubleCheck": true
    },
    {
        "dataID": "118057",
        "id": "53093751",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:40",
        "brokerTime": "2025-05-14 15:11:41",
        "commission": -56.77,
        "swap": 0,
        "profit": -89.21,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056337",
        "positionId": "56056335",
        "volume": 8.11,
        "price": 3220.27,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -145.98,
        "priceIn": 3220.16,
        "doubleCheck": true
    },
    {
        "dataID": "118058",
        "id": "53093752",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:41",
        "brokerTime": "2025-05-14 15:11:41",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056338",
        "positionId": "56056338",
        "volume": 8.11,
        "price": 3220.09,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3220.09,
        "doubleCheck": true
    },
    {
        "dataID": "118059",
        "id": "53093753",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:41",
        "brokerTime": "2025-05-14 15:11:42",
        "commission": -56.77,
        "swap": 0,
        "profit": -97.32,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056339",
        "positionId": "56056338",
        "volume": 8.11,
        "price": 3220.21,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -154.09,
        "priceIn": 3220.09,
        "doubleCheck": true
    },
    {
        "dataID": "118060",
        "id": "53093754",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:43",
        "brokerTime": "2025-05-14 15:11:43",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056340",
        "positionId": "56056340",
        "volume": 8.11,
        "price": 3219.87,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3219.87,
        "doubleCheck": true
    },
    {
        "dataID": "118061",
        "id": "53093756",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:43",
        "brokerTime": "2025-05-14 15:11:44",
        "commission": -56.77,
        "swap": 0,
        "profit": -145.98,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056342",
        "positionId": "56056340",
        "volume": 8.11,
        "price": 3220.05,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -202.75,
        "priceIn": 3219.87,
        "doubleCheck": true
    },
    {
        "dataID": "118062",
        "id": "53093757",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:44",
        "brokerTime": "2025-05-14 15:11:44",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056343",
        "positionId": "56056343",
        "volume": 8.11,
        "price": 3219.77,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3219.77,
        "doubleCheck": true
    },
    {
        "dataID": "118063",
        "id": "53093758",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:44",
        "brokerTime": "2025-05-14 15:11:45",
        "commission": -56.77,
        "swap": 0,
        "profit": -462.27,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056344",
        "positionId": "56056343",
        "volume": 8.11,
        "price": 3220.34,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -519.04,
        "priceIn": 3219.77,
        "doubleCheck": true
    },
    {
        "dataID": "118064",
        "id": "53093759",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:45",
        "brokerTime": "2025-05-14 15:11:45",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056345",
        "positionId": "56056345",
        "volume": 8.11,
        "price": 3220.17,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3220.17,
        "doubleCheck": true
    },
    {
        "dataID": "118065",
        "id": "53093760",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:45",
        "brokerTime": "2025-05-14 15:11:47",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056346",
        "positionId": "56056345",
        "volume": 8.11,
        "price": 3220.17,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3220.17,
        "doubleCheck": true
    },
    {
        "dataID": "118066",
        "id": "53093761",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:47",
        "brokerTime": "2025-05-14 15:11:47",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056347",
        "positionId": "56056347",
        "volume": 8.11,
        "price": 3220,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3220,
        "doubleCheck": true
    },
    {
        "dataID": "118067",
        "id": "53093762",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:47",
        "brokerTime": "2025-05-14 15:11:47",
        "commission": -56.77,
        "swap": 0,
        "profit": -129.76,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056348",
        "positionId": "56056347",
        "volume": 8.11,
        "price": 3220.16,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -186.53,
        "priceIn": 3220,
        "doubleCheck": true
    },
    {
        "dataID": "118068",
        "id": "53093763",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:47",
        "brokerTime": "2025-05-14 15:11:47",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056349",
        "positionId": "56056349",
        "volume": 8.11,
        "price": 3219.95,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3219.95,
        "doubleCheck": true
    },
    {
        "dataID": "118069",
        "id": "53093764",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:47",
        "brokerTime": "2025-05-14 15:11:48",
        "commission": -56.77,
        "swap": 0,
        "profit": -113.54,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056350",
        "positionId": "56056349",
        "volume": 8.11,
        "price": 3220.09,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -170.31,
        "priceIn": 3219.95,
        "doubleCheck": true
    },
    {
        "dataID": "118070",
        "id": "53093765",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:48",
        "brokerTime": "2025-05-14 15:11:48",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056351",
        "positionId": "56056351",
        "volume": 8.11,
        "price": 3219.93,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3219.93,
        "doubleCheck": true
    },
    {
        "dataID": "118071",
        "id": "53093766",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:48",
        "brokerTime": "2025-05-14 15:11:49",
        "commission": -56.77,
        "swap": 0,
        "profit": -129.76,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056352",
        "positionId": "56056351",
        "volume": 8.11,
        "price": 3220.09,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -186.53,
        "priceIn": 3219.93,
        "doubleCheck": true
    },
    {
        "dataID": "118072",
        "id": "53093767",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:49",
        "brokerTime": "2025-05-14 15:11:49",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056353",
        "positionId": "56056353",
        "volume": 8.11,
        "price": 3219.97,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3219.97,
        "doubleCheck": true
    },
    {
        "dataID": "118073",
        "id": "53093768",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:49",
        "brokerTime": "2025-05-14 15:11:50",
        "commission": -56.77,
        "swap": 0,
        "profit": -137.87,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056354",
        "positionId": "56056353",
        "volume": 8.11,
        "price": 3220.14,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -194.64000000000001,
        "priceIn": 3219.97,
        "doubleCheck": true
    },
    {
        "dataID": "118074",
        "id": "53093769",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:50",
        "brokerTime": "2025-05-14 15:11:50",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056355",
        "positionId": "56056355",
        "volume": 8.11,
        "price": 3219.97,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3219.97,
        "doubleCheck": true
    },
    {
        "dataID": "118075",
        "id": "53093770",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:50",
        "brokerTime": "2025-05-14 15:11:50",
        "commission": -56.77,
        "swap": 0,
        "profit": -40.55,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056356",
        "positionId": "56056355",
        "volume": 8.11,
        "price": 3220.02,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -97.32,
        "priceIn": 3219.97,
        "doubleCheck": true
    },
    {
        "dataID": "118076",
        "id": "53093771",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:51",
        "brokerTime": "2025-05-14 15:11:51",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056357",
        "positionId": "56056357",
        "volume": 8.11,
        "price": 3219.95,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3219.95,
        "doubleCheck": true
    },
    {
        "dataID": "118077",
        "id": "53093772",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:51",
        "brokerTime": "2025-05-14 15:11:51",
        "commission": -56.77,
        "swap": 0,
        "profit": -162.2,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056358",
        "positionId": "56056357",
        "volume": 8.11,
        "price": 3220.15,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -218.97,
        "priceIn": 3219.95,
        "doubleCheck": true
    },
    {
        "dataID": "118078",
        "id": "53093774",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:52",
        "brokerTime": "2025-05-14 15:11:52",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056360",
        "positionId": "56056360",
        "volume": 8.11,
        "price": 3219.93,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3219.93,
        "doubleCheck": true
    },
    {
        "dataID": "118079",
        "id": "53093775",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:52",
        "brokerTime": "2025-05-14 15:11:52",
        "commission": -56.77,
        "swap": 0,
        "profit": -145.98,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056361",
        "positionId": "56056360",
        "volume": 8.11,
        "price": 3220.11,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -202.75,
        "priceIn": 3219.93,
        "doubleCheck": true
    },
    {
        "dataID": "118080",
        "id": "53093776",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:52",
        "brokerTime": "2025-05-14 15:11:52",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056362",
        "positionId": "56056362",
        "volume": 8.11,
        "price": 3219.91,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3219.91,
        "doubleCheck": true
    },
    {
        "dataID": "118081",
        "id": "53093777",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:52",
        "brokerTime": "2025-05-14 15:11:54",
        "commission": -56.77,
        "swap": 0,
        "profit": -170.31,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056363",
        "positionId": "56056362",
        "volume": 8.11,
        "price": 3220.12,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -227.08,
        "priceIn": 3219.91,
        "doubleCheck": true
    },
    {
        "dataID": "118082",
        "id": "53093778",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:54",
        "brokerTime": "2025-05-14 15:11:54",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056364",
        "positionId": "56056364",
        "volume": 8.11,
        "price": 3219.95,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3219.95,
        "doubleCheck": true
    },
    {
        "dataID": "118083",
        "id": "53093779",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:54",
        "brokerTime": "2025-05-14 15:11:54",
        "commission": -56.77,
        "swap": 0,
        "profit": -251.41,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056365",
        "positionId": "56056364",
        "volume": 8.11,
        "price": 3220.26,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -308.18,
        "priceIn": 3219.95,
        "doubleCheck": true
    },
    {
        "dataID": "118084",
        "id": "53093782",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:56",
        "brokerTime": "2025-05-14 15:11:56",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056367",
        "positionId": "56056367",
        "volume": 8.11,
        "price": 3219.85,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3219.85,
        "doubleCheck": true
    },
    {
        "dataID": "118085",
        "id": "53093783",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:56",
        "brokerTime": "2025-05-14 15:11:56",
        "commission": -56.77,
        "swap": 0,
        "profit": -145.98,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056368",
        "positionId": "56056367",
        "volume": 8.11,
        "price": 3220.03,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -202.75,
        "priceIn": 3219.85,
        "doubleCheck": true
    },
    {
        "dataID": "118086",
        "id": "53093784",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:56",
        "brokerTime": "2025-05-14 15:11:56",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056369",
        "positionId": "56056369",
        "volume": 8.11,
        "price": 3219.88,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3219.88,
        "doubleCheck": true
    },
    {
        "dataID": "118087",
        "id": "53093786",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:56",
        "brokerTime": "2025-05-14 15:11:58",
        "commission": -56.77,
        "swap": 0,
        "profit": -129.76,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056371",
        "positionId": "56056369",
        "volume": 8.11,
        "price": 3220.04,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -186.53,
        "priceIn": 3219.88,
        "doubleCheck": true
    },
    {
        "dataID": "118088",
        "id": "53093787",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:59",
        "brokerTime": "2025-05-14 15:11:59",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056372",
        "positionId": "56056372",
        "volume": 8.11,
        "price": 3219.97,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3219.97,
        "doubleCheck": true
    },
    {
        "dataID": "118089",
        "id": "53093788",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:59",
        "brokerTime": "2025-05-14 15:12:00",
        "commission": -56.77,
        "swap": 0,
        "profit": -145.98,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056373",
        "positionId": "56056372",
        "volume": 8.11,
        "price": 3220.15,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -202.75,
        "priceIn": 3219.97,
        "doubleCheck": true
    },
    {
        "dataID": "118090",
        "id": "53093790",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:02",
        "brokerTime": "2025-05-14 15:12:02",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056376",
        "positionId": "56056376",
        "volume": 8.11,
        "price": 3219.98,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3219.98,
        "doubleCheck": true
    },
    {
        "dataID": "118091",
        "id": "53093791",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:02",
        "brokerTime": "2025-05-14 15:12:02",
        "commission": -56.77,
        "swap": 0,
        "profit": -56.77,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056377",
        "positionId": "56056376",
        "volume": 8.11,
        "price": 3220.05,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -113.54,
        "priceIn": 3219.98,
        "doubleCheck": true
    },
    {
        "dataID": "118092",
        "id": "53093792",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:03",
        "brokerTime": "2025-05-14 15:12:03",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056378",
        "positionId": "56056378",
        "volume": 8.11,
        "price": 3219.87,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3219.87,
        "doubleCheck": true
    },
    {
        "dataID": "118093",
        "id": "53093793",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:03",
        "brokerTime": "2025-05-14 15:12:04",
        "commission": -56.77,
        "swap": 0,
        "profit": -137.87,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056379",
        "positionId": "56056378",
        "volume": 8.11,
        "price": 3220.04,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -194.64000000000001,
        "priceIn": 3219.87,
        "doubleCheck": true
    },
    {
        "dataID": "118094",
        "id": "53093794",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:04",
        "brokerTime": "2025-05-14 15:12:04",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056380",
        "positionId": "56056380",
        "volume": 8.11,
        "price": 3219.58,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3219.58,
        "doubleCheck": true
    },
    {
        "dataID": "118095",
        "id": "53093795",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:04",
        "brokerTime": "2025-05-14 15:12:05",
        "commission": -56.77,
        "swap": 0,
        "profit": -64.88,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056381",
        "positionId": "56056380",
        "volume": 8.11,
        "price": 3219.66,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -121.65,
        "priceIn": 3219.58,
        "doubleCheck": true
    },
    {
        "dataID": "118096",
        "id": "53093796",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:05",
        "brokerTime": "2025-05-14 15:12:05",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056382",
        "positionId": "56056382",
        "volume": 8.11,
        "price": 3219.51,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3219.51,
        "doubleCheck": true
    },
    {
        "dataID": "118097",
        "id": "53093797",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:05",
        "brokerTime": "2025-05-14 15:12:05",
        "commission": -56.77,
        "swap": 0,
        "profit": -235.19,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056383",
        "positionId": "56056382",
        "volume": 8.11,
        "price": 3219.8,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -291.96,
        "priceIn": 3219.51,
        "doubleCheck": true
    },
    {
        "dataID": "118098",
        "id": "53093798",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:06",
        "brokerTime": "2025-05-14 15:12:06",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056384",
        "positionId": "56056384",
        "volume": 8.11,
        "price": 3219.62,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3219.62,
        "doubleCheck": true
    },
    {
        "dataID": "118099",
        "id": "53093841",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:06",
        "brokerTime": "2025-05-14 15:12:07",
        "commission": -56.77,
        "swap": 0,
        "profit": -186.53,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056601",
        "positionId": "56056384",
        "volume": 8.11,
        "price": 3219.85,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -243.3,
        "priceIn": 3219.62,
        "doubleCheck": true
    },
    {
        "dataID": "118100",
        "id": "53094035",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:07",
        "brokerTime": "2025-05-14 15:12:07",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056605",
        "positionId": "56056605",
        "volume": 8.11,
        "price": 3219.74,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3219.74,
        "doubleCheck": true
    },
    {
        "dataID": "118101",
        "id": "53094046",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:07",
        "brokerTime": "2025-05-14 15:12:07",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056611",
        "positionId": "56056605",
        "volume": 8.11,
        "price": 3219.74,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3219.74,
        "doubleCheck": true
    },
    {
        "dataID": "118102",
        "id": "53094105",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:08",
        "brokerTime": "2025-05-14 15:12:08",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056661",
        "positionId": "56056661",
        "volume": 8.11,
        "price": 3219.41,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3219.41,
        "doubleCheck": true
    },
    {
        "dataID": "118103",
        "id": "53094108",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:08",
        "brokerTime": "2025-05-14 15:12:09",
        "commission": -56.77,
        "swap": 0,
        "profit": -40.55,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056664",
        "positionId": "56056661",
        "volume": 8.11,
        "price": 3219.46,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -97.32,
        "priceIn": 3219.41,
        "doubleCheck": true
    },
    {
        "dataID": "118104",
        "id": "53094109",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:09",
        "brokerTime": "2025-05-14 15:12:09",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056665",
        "positionId": "56056665",
        "volume": 8.11,
        "price": 3219.31,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3219.31,
        "doubleCheck": true
    },
    {
        "dataID": "118105",
        "id": "53094110",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:09",
        "brokerTime": "2025-05-14 15:12:09",
        "commission": -56.77,
        "swap": 0,
        "profit": -89.21,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056666",
        "positionId": "56056665",
        "volume": 8.11,
        "price": 3219.42,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -145.98,
        "priceIn": 3219.31,
        "doubleCheck": true
    },
    {
        "dataID": "118106",
        "id": "53094111",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:10",
        "brokerTime": "2025-05-14 15:12:10",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056667",
        "positionId": "56056667",
        "volume": 8.11,
        "price": 3219.24,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3219.24,
        "doubleCheck": true
    },
    {
        "dataID": "118107",
        "id": "53094112",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:10",
        "brokerTime": "2025-05-14 15:12:10",
        "commission": -56.77,
        "swap": 0,
        "profit": -154.09,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056668",
        "positionId": "56056667",
        "volume": 8.11,
        "price": 3219.43,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -210.86,
        "priceIn": 3219.24,
        "doubleCheck": true
    },
    {
        "dataID": "118108",
        "id": "53094113",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:11",
        "brokerTime": "2025-05-14 15:12:11",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056669",
        "positionId": "56056669",
        "volume": 8.11,
        "price": 3219.24,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3219.24,
        "doubleCheck": true
    },
    {
        "dataID": "118109",
        "id": "53094115",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:11",
        "brokerTime": "2025-05-14 15:12:12",
        "commission": -56.77,
        "swap": 0,
        "profit": -24.33,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056672",
        "positionId": "56056669",
        "volume": 8.11,
        "price": 3219.27,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -81.1,
        "priceIn": 3219.24,
        "doubleCheck": true
    },
    {
        "dataID": "118110",
        "id": "53094116",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:13",
        "brokerTime": "2025-05-14 15:12:13",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056673",
        "positionId": "56056673",
        "volume": 8.11,
        "price": 3218.99,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3218.99,
        "doubleCheck": true
    },
    {
        "dataID": "118111",
        "id": "53094117",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:13",
        "brokerTime": "2025-05-14 15:12:13",
        "commission": -56.77,
        "swap": 0,
        "profit": -186.53,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056674",
        "positionId": "56056673",
        "volume": 8.11,
        "price": 3219.22,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -243.3,
        "priceIn": 3218.99,
        "doubleCheck": true
    },
    {
        "dataID": "118112",
        "id": "53094118",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:14",
        "brokerTime": "2025-05-14 15:12:14",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056675",
        "positionId": "56056675",
        "volume": 8.11,
        "price": 3218.99,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3218.99,
        "doubleCheck": true
    },
    {
        "dataID": "118113",
        "id": "53094120",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:14",
        "brokerTime": "2025-05-14 15:12:15",
        "commission": -56.77,
        "swap": 0,
        "profit": 48.66,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056677",
        "positionId": "56056675",
        "volume": 8.11,
        "price": 3218.93,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -8.110000000000007,
        "priceIn": 3218.99,
        "doubleCheck": true
    },
    {
        "dataID": "118114",
        "id": "53094125",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:16",
        "brokerTime": "2025-05-14 15:12:16",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056680",
        "positionId": "56056680",
        "volume": 8.11,
        "price": 3218.69,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3218.69,
        "doubleCheck": true
    },
    {
        "dataID": "118115",
        "id": "53094127",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:16",
        "brokerTime": "2025-05-14 15:12:16",
        "commission": -56.77,
        "swap": 0,
        "profit": -129.76,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056681",
        "positionId": "56056680",
        "volume": 8.11,
        "price": 3218.85,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -186.53,
        "priceIn": 3218.69,
        "doubleCheck": true
    },
    {
        "dataID": "118116",
        "id": "53094128",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:16",
        "brokerTime": "2025-05-14 15:12:16",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056682",
        "positionId": "56056682",
        "volume": 8.11,
        "price": 3218.71,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3218.71,
        "doubleCheck": true
    },
    {
        "dataID": "118117",
        "id": "53094131",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:16",
        "brokerTime": "2025-05-14 15:12:17",
        "commission": -56.77,
        "swap": 0,
        "profit": -170.31,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056684",
        "positionId": "56056682",
        "volume": 8.11,
        "price": 3218.92,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -227.08,
        "priceIn": 3218.71,
        "doubleCheck": true
    },
    {
        "dataID": "118118",
        "id": "53094132",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:17",
        "brokerTime": "2025-05-14 15:12:17",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056685",
        "positionId": "56056685",
        "volume": 8.11,
        "price": 3218.44,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3218.44,
        "doubleCheck": true
    },
    {
        "dataID": "118119",
        "id": "53094134",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:17",
        "brokerTime": "2025-05-14 15:12:17",
        "commission": -56.77,
        "swap": 0,
        "profit": -267.63,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056686",
        "positionId": "56056685",
        "volume": 8.11,
        "price": 3218.77,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -324.4,
        "priceIn": 3218.44,
        "doubleCheck": true
    },
    {
        "dataID": "118120",
        "id": "53094135",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:18",
        "brokerTime": "2025-05-14 15:12:18",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056687",
        "positionId": "56056687",
        "volume": 8.11,
        "price": 3218.68,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3218.68,
        "doubleCheck": true
    },
    {
        "dataID": "118121",
        "id": "53094136",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:18",
        "brokerTime": "2025-05-14 15:12:18",
        "commission": -56.77,
        "swap": 0,
        "profit": -81.1,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056688",
        "positionId": "56056687",
        "volume": 8.11,
        "price": 3218.78,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -137.87,
        "priceIn": 3218.68,
        "doubleCheck": true
    },
    {
        "dataID": "118122",
        "id": "53094137",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:18",
        "brokerTime": "2025-05-14 15:12:18",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056689",
        "positionId": "56056689",
        "volume": 8.11,
        "price": 3218.59,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3218.59,
        "doubleCheck": true
    },
    {
        "dataID": "118123",
        "id": "53094142",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:18",
        "brokerTime": "2025-05-14 15:12:19",
        "commission": -56.77,
        "swap": 0,
        "profit": -97.32,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056693",
        "positionId": "56056689",
        "volume": 8.11,
        "price": 3218.71,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -154.09,
        "priceIn": 3218.59,
        "doubleCheck": true
    },
    {
        "dataID": "118124",
        "id": "53094143",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:19",
        "brokerTime": "2025-05-14 15:12:19",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056694",
        "positionId": "56056694",
        "volume": 8.11,
        "price": 3218.52,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3218.52,
        "doubleCheck": true
    },
    {
        "dataID": "118125",
        "id": "53094146",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:19",
        "brokerTime": "2025-05-14 15:12:19",
        "commission": -56.77,
        "swap": 0,
        "profit": -202.75,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056695",
        "positionId": "56056694",
        "volume": 8.11,
        "price": 3218.77,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -259.52,
        "priceIn": 3218.52,
        "doubleCheck": true
    },
    {
        "dataID": "118126",
        "id": "53094147",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:20",
        "brokerTime": "2025-05-14 15:12:20",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056696",
        "positionId": "56056696",
        "volume": 8.11,
        "price": 3218.56,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3218.56,
        "doubleCheck": true
    },
    {
        "dataID": "118127",
        "id": "53094148",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:20",
        "brokerTime": "2025-05-14 15:12:20",
        "commission": -56.77,
        "swap": 0,
        "profit": -129.76,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056697",
        "positionId": "56056696",
        "volume": 8.11,
        "price": 3218.72,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -186.53,
        "priceIn": 3218.56,
        "doubleCheck": true
    },
    {
        "dataID": "118128",
        "id": "53094149",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:20",
        "brokerTime": "2025-05-14 15:12:20",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056698",
        "positionId": "56056698",
        "volume": 8.11,
        "price": 3218.59,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3218.59,
        "doubleCheck": true
    },
    {
        "dataID": "118129",
        "id": "53094150",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:20",
        "brokerTime": "2025-05-14 15:12:21",
        "commission": -56.77,
        "swap": 0,
        "profit": 64.88,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056699",
        "positionId": "56056698",
        "volume": 8.11,
        "price": 3218.51,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 8.109999999999992,
        "priceIn": 3218.59,
        "doubleCheck": true
    },
    {
        "dataID": "118130",
        "id": "53094152",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:22",
        "brokerTime": "2025-05-14 15:12:22",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056701",
        "positionId": "56056701",
        "volume": 8.11,
        "price": 3218.42,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3218.42,
        "doubleCheck": true
    },
    {
        "dataID": "118131",
        "id": "53094153",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:22",
        "brokerTime": "2025-05-14 15:12:22",
        "commission": -56.77,
        "swap": 0,
        "profit": -316.29,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056702",
        "positionId": "56056701",
        "volume": 8.11,
        "price": 3218.81,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -373.06,
        "priceIn": 3218.42,
        "doubleCheck": true
    },
    {
        "dataID": "118132",
        "id": "53094154",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:22",
        "brokerTime": "2025-05-14 15:12:22",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056703",
        "positionId": "56056703",
        "volume": 8.11,
        "price": 3218.61,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3218.61,
        "doubleCheck": true
    },
    {
        "dataID": "118133",
        "id": "53094156",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:22",
        "brokerTime": "2025-05-14 15:12:24",
        "commission": -56.77,
        "swap": 0,
        "profit": -162.2,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056706",
        "positionId": "56056703",
        "volume": 8.11,
        "price": 3218.81,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -218.97,
        "priceIn": 3218.61,
        "doubleCheck": true
    },
    {
        "dataID": "118134",
        "id": "53094158",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:24",
        "brokerTime": "2025-05-14 15:12:24",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056707",
        "positionId": "56056707",
        "volume": 8.11,
        "price": 3218.65,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3218.65,
        "doubleCheck": true
    },
    {
        "dataID": "118135",
        "id": "53094159",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:24",
        "brokerTime": "2025-05-14 15:12:25",
        "commission": -56.77,
        "swap": 0,
        "profit": -97.32,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056708",
        "positionId": "56056707",
        "volume": 8.11,
        "price": 3218.77,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -154.09,
        "priceIn": 3218.65,
        "doubleCheck": true
    },
    {
        "dataID": "118136",
        "id": "53094160",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:26",
        "brokerTime": "2025-05-14 15:12:26",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056709",
        "positionId": "56056709",
        "volume": 8.11,
        "price": 3218.56,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3218.56,
        "doubleCheck": true
    },
    {
        "dataID": "118137",
        "id": "53094161",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:26",
        "brokerTime": "2025-05-14 15:12:26",
        "commission": -56.77,
        "swap": 0,
        "profit": -373.06,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056710",
        "positionId": "56056709",
        "volume": 8.11,
        "price": 3219.02,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -429.83,
        "priceIn": 3218.56,
        "doubleCheck": true
    },
    {
        "dataID": "118138",
        "id": "53094162",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:26",
        "brokerTime": "2025-05-14 15:12:26",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056711",
        "positionId": "56056711",
        "volume": 8.11,
        "price": 3219.09,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3219.09,
        "doubleCheck": true
    },
    {
        "dataID": "118139",
        "id": "53094164",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:26",
        "brokerTime": "2025-05-14 15:12:27",
        "commission": -56.77,
        "swap": 0,
        "profit": -145.98,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056713",
        "positionId": "56056711",
        "volume": 8.11,
        "price": 3219.27,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -202.75,
        "priceIn": 3219.09,
        "doubleCheck": true
    },
    {
        "dataID": "118140",
        "id": "53094166",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:27",
        "brokerTime": "2025-05-14 15:12:27",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056714",
        "positionId": "56056714",
        "volume": 8.11,
        "price": 3219.1,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3219.1,
        "doubleCheck": true
    },
    {
        "dataID": "118141",
        "id": "53094167",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:27",
        "brokerTime": "2025-05-14 15:12:28",
        "commission": -56.77,
        "swap": 0,
        "profit": -129.76,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056715",
        "positionId": "56056714",
        "volume": 8.11,
        "price": 3219.26,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -186.53,
        "priceIn": 3219.1,
        "doubleCheck": true
    },
    {
        "dataID": "118142",
        "id": "53094168",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:29",
        "brokerTime": "2025-05-14 15:12:29",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056716",
        "positionId": "56056716",
        "volume": 8.11,
        "price": 3219.15,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3219.15,
        "doubleCheck": true
    },
    {
        "dataID": "118143",
        "id": "53094169",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:29",
        "brokerTime": "2025-05-14 15:12:29",
        "commission": -56.77,
        "swap": 0,
        "profit": -137.87,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056717",
        "positionId": "56056716",
        "volume": 8.11,
        "price": 3219.32,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -194.64000000000001,
        "priceIn": 3219.15,
        "doubleCheck": true
    },
    {
        "dataID": "118144",
        "id": "53094170",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:29",
        "brokerTime": "2025-05-14 15:12:29",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056718",
        "positionId": "56056718",
        "volume": 8.11,
        "price": 3219.12,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3219.12,
        "doubleCheck": true
    },
    {
        "dataID": "118145",
        "id": "53094171",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:29",
        "brokerTime": "2025-05-14 15:12:30",
        "commission": -56.77,
        "swap": 0,
        "profit": -308.18,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056719",
        "positionId": "56056718",
        "volume": 8.11,
        "price": 3219.5,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -364.95,
        "priceIn": 3219.12,
        "doubleCheck": true
    },
    {
        "dataID": "118146",
        "id": "53094172",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:30",
        "brokerTime": "2025-05-14 15:12:30",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056720",
        "positionId": "56056720",
        "volume": 8.11,
        "price": 3219.33,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3219.33,
        "doubleCheck": true
    },
    {
        "dataID": "118147",
        "id": "53094173",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:30",
        "brokerTime": "2025-05-14 15:12:31",
        "commission": -56.77,
        "swap": 0,
        "profit": -129.76,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056721",
        "positionId": "56056720",
        "volume": 8.11,
        "price": 3219.49,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -186.53,
        "priceIn": 3219.33,
        "doubleCheck": true
    },
    {
        "dataID": "118148",
        "id": "53094174",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:32",
        "brokerTime": "2025-05-14 15:12:32",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056722",
        "positionId": "56056722",
        "volume": 8.11,
        "price": 3219.34,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3219.34,
        "doubleCheck": true
    },
    {
        "dataID": "118149",
        "id": "53094175",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:32",
        "brokerTime": "2025-05-14 15:12:33",
        "commission": -56.77,
        "swap": 0,
        "profit": -105.43,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056723",
        "positionId": "56056722",
        "volume": 8.11,
        "price": 3219.47,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -162.20000000000002,
        "priceIn": 3219.34,
        "doubleCheck": true
    },
    {
        "dataID": "118150",
        "id": "53094176",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:33",
        "brokerTime": "2025-05-14 15:12:33",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056724",
        "positionId": "56056724",
        "volume": 8.11,
        "price": 3219.29,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3219.29,
        "doubleCheck": true
    },
    {
        "dataID": "118151",
        "id": "53094177",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:33",
        "brokerTime": "2025-05-14 15:12:34",
        "commission": -56.77,
        "swap": 0,
        "profit": -97.32,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056725",
        "positionId": "56056724",
        "volume": 8.11,
        "price": 3219.41,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -154.09,
        "priceIn": 3219.29,
        "doubleCheck": true
    },
    {
        "dataID": "118152",
        "id": "53094178",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:34",
        "brokerTime": "2025-05-14 15:12:34",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056726",
        "positionId": "56056726",
        "volume": 8.11,
        "price": 3219.23,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3219.23,
        "doubleCheck": true
    },
    {
        "dataID": "118153",
        "id": "53094179",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:34",
        "brokerTime": "2025-05-14 15:12:34",
        "commission": -56.77,
        "swap": 0,
        "profit": 8.11,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056727",
        "positionId": "56056726",
        "volume": 8.11,
        "price": 3219.22,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -48.660000000000004,
        "priceIn": 3219.23,
        "doubleCheck": true
    },
    {
        "dataID": "118154",
        "id": "53094180",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:35",
        "brokerTime": "2025-05-14 15:12:35",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056728",
        "positionId": "56056728",
        "volume": 8.11,
        "price": 3219.09,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3219.09,
        "doubleCheck": true
    },
    {
        "dataID": "118155",
        "id": "53094182",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:35",
        "brokerTime": "2025-05-14 15:12:36",
        "commission": -56.77,
        "swap": 0,
        "profit": -129.76,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056730",
        "positionId": "56056728",
        "volume": 8.11,
        "price": 3219.25,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -186.53,
        "priceIn": 3219.09,
        "doubleCheck": true
    },
    {
        "dataID": "118156",
        "id": "53094183",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:37",
        "brokerTime": "2025-05-14 15:12:37",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056731",
        "positionId": "56056731",
        "volume": 8.11,
        "price": 3219.05,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3219.05,
        "doubleCheck": true
    },
    {
        "dataID": "118157",
        "id": "53094184",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:37",
        "brokerTime": "2025-05-14 15:12:37",
        "commission": -56.77,
        "swap": 0,
        "profit": -202.75,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056732",
        "positionId": "56056731",
        "volume": 8.11,
        "price": 3219.3,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -259.52,
        "priceIn": 3219.05,
        "doubleCheck": true
    },
    {
        "dataID": "118158",
        "id": "53094185",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:38",
        "brokerTime": "2025-05-14 15:12:38",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056733",
        "positionId": "56056733",
        "volume": 8.11,
        "price": 3219.33,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3219.33,
        "doubleCheck": true
    },
    {
        "dataID": "118159",
        "id": "53094186",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:38",
        "brokerTime": "2025-05-14 15:12:38",
        "commission": -56.77,
        "swap": 0,
        "profit": -186.53,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056734",
        "positionId": "56056733",
        "volume": 8.11,
        "price": 3219.56,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -243.3,
        "priceIn": 3219.33,
        "doubleCheck": true
    },
    {
        "dataID": "118160",
        "id": "53094187",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:38",
        "brokerTime": "2025-05-14 15:12:38",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056735",
        "positionId": "56056735",
        "volume": 8.11,
        "price": 3219.34,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3219.34,
        "doubleCheck": true
    },
    {
        "dataID": "118161",
        "id": "53094188",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:38",
        "brokerTime": "2025-05-14 15:12:39",
        "commission": -56.77,
        "swap": 0,
        "profit": -170.31,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056736",
        "positionId": "56056735",
        "volume": 8.11,
        "price": 3219.55,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -227.08,
        "priceIn": 3219.34,
        "doubleCheck": true
    },
    {
        "dataID": "118162",
        "id": "53094189",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:40",
        "brokerTime": "2025-05-14 15:12:40",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056737",
        "positionId": "56056737",
        "volume": 8.11,
        "price": 3219.34,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3219.34,
        "doubleCheck": true
    },
    {
        "dataID": "118163",
        "id": "53094190",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:40",
        "brokerTime": "2025-05-14 15:12:40",
        "commission": -56.77,
        "swap": 0,
        "profit": -364.95,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056738",
        "positionId": "56056737",
        "volume": 8.11,
        "price": 3219.79,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -421.71999999999997,
        "priceIn": 3219.34,
        "doubleCheck": true
    },
    {
        "dataID": "118164",
        "id": "53094191",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:41",
        "brokerTime": "2025-05-14 15:12:41",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056739",
        "positionId": "56056739",
        "volume": 8.11,
        "price": 3219.58,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3219.58,
        "doubleCheck": true
    },
    {
        "dataID": "118165",
        "id": "53094192",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:41",
        "brokerTime": "2025-05-14 15:12:41",
        "commission": -56.77,
        "swap": 0,
        "profit": -113.54,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056740",
        "positionId": "56056739",
        "volume": 8.11,
        "price": 3219.72,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -170.31,
        "priceIn": 3219.58,
        "doubleCheck": true
    },
    {
        "dataID": "118166",
        "id": "53094193",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:42",
        "brokerTime": "2025-05-14 15:12:42",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056741",
        "positionId": "56056741",
        "volume": 8.11,
        "price": 3219.53,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3219.53,
        "doubleCheck": true
    },
    {
        "dataID": "118167",
        "id": "53094194",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:42",
        "brokerTime": "2025-05-14 15:12:43",
        "commission": -56.77,
        "swap": 0,
        "profit": -56.77,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056742",
        "positionId": "56056741",
        "volume": 8.11,
        "price": 3219.6,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -113.54,
        "priceIn": 3219.53,
        "doubleCheck": true
    },
    {
        "dataID": "118168",
        "id": "53094195",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:43",
        "brokerTime": "2025-05-14 15:12:43",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056743",
        "positionId": "56056743",
        "volume": 8.11,
        "price": 3219.42,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3219.42,
        "doubleCheck": true
    },
    {
        "dataID": "118169",
        "id": "53094196",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:43",
        "brokerTime": "2025-05-14 15:12:45",
        "commission": -56.77,
        "swap": 0,
        "profit": -145.98,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056744",
        "positionId": "56056743",
        "volume": 8.11,
        "price": 3219.6,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -202.75,
        "priceIn": 3219.42,
        "doubleCheck": true
    },
    {
        "dataID": "118170",
        "id": "53094197",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:46",
        "brokerTime": "2025-05-14 15:12:46",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056745",
        "positionId": "56056745",
        "volume": 8.11,
        "price": 3219.47,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3219.47,
        "doubleCheck": true
    },
    {
        "dataID": "118171",
        "id": "53094198",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:46",
        "brokerTime": "2025-05-14 15:12:48",
        "commission": -56.77,
        "swap": 0,
        "profit": -113.54,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056746",
        "positionId": "56056745",
        "volume": 8.11,
        "price": 3219.61,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -170.31,
        "priceIn": 3219.47,
        "doubleCheck": true
    },
    {
        "dataID": "118172",
        "id": "53094199",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:48",
        "brokerTime": "2025-05-14 15:12:48",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056747",
        "positionId": "56056747",
        "volume": 8.11,
        "price": 3219.43,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3219.43,
        "doubleCheck": true
    },
    {
        "dataID": "118173",
        "id": "53094200",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:48",
        "brokerTime": "2025-05-14 15:12:49",
        "commission": -56.77,
        "swap": 0,
        "profit": -56.77,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056748",
        "positionId": "56056747",
        "volume": 8.11,
        "price": 3219.5,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -113.54,
        "priceIn": 3219.43,
        "doubleCheck": true
    },
    {
        "dataID": "118174",
        "id": "53094201",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:49",
        "brokerTime": "2025-05-14 15:12:49",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056749",
        "positionId": "56056749",
        "volume": 8.11,
        "price": 3219.11,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3219.11,
        "doubleCheck": true
    },
    {
        "dataID": "118175",
        "id": "53094202",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:49",
        "brokerTime": "2025-05-14 15:12:50",
        "commission": -56.77,
        "swap": 0,
        "profit": -154.09,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056750",
        "positionId": "56056749",
        "volume": 8.11,
        "price": 3219.3,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -210.86,
        "priceIn": 3219.11,
        "doubleCheck": true
    },
    {
        "dataID": "118176",
        "id": "53094203",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:50",
        "brokerTime": "2025-05-14 15:12:50",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056751",
        "positionId": "56056751",
        "volume": 8.11,
        "price": 3219.16,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3219.16,
        "doubleCheck": true
    },
    {
        "dataID": "118177",
        "id": "53094204",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:50",
        "brokerTime": "2025-05-14 15:12:51",
        "commission": -56.77,
        "swap": 0,
        "profit": -178.42,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056752",
        "positionId": "56056751",
        "volume": 8.11,
        "price": 3219.38,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -235.19,
        "priceIn": 3219.16,
        "doubleCheck": true
    },
    {
        "dataID": "118178",
        "id": "53094205",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:51",
        "brokerTime": "2025-05-14 15:12:51",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056753",
        "positionId": "56056753",
        "volume": 8.11,
        "price": 3219.22,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3219.22,
        "doubleCheck": true
    },
    {
        "dataID": "118179",
        "id": "53094207",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:51",
        "brokerTime": "2025-05-14 15:12:52",
        "commission": -56.77,
        "swap": 0,
        "profit": -137.87,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056755",
        "positionId": "56056753",
        "volume": 8.11,
        "price": 3219.39,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -194.64000000000001,
        "priceIn": 3219.22,
        "doubleCheck": true
    },
    {
        "dataID": "118180",
        "id": "53094209",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:53",
        "brokerTime": "2025-05-14 15:12:53",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056757",
        "positionId": "56056757",
        "volume": 8.11,
        "price": 3219.07,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3219.07,
        "doubleCheck": true
    },
    {
        "dataID": "118181",
        "id": "53094210",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:53",
        "brokerTime": "2025-05-14 15:12:53",
        "commission": -56.77,
        "swap": 0,
        "profit": -105.43,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056758",
        "positionId": "56056757",
        "volume": 8.11,
        "price": 3219.2,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -162.20000000000002,
        "priceIn": 3219.07,
        "doubleCheck": true
    },
    {
        "dataID": "118182",
        "id": "53094211",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:54",
        "brokerTime": "2025-05-14 15:12:54",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056759",
        "positionId": "56056759",
        "volume": 8.11,
        "price": 3219.02,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3219.02,
        "doubleCheck": true
    },
    {
        "dataID": "118183",
        "id": "53094212",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:54",
        "brokerTime": "2025-05-14 15:12:54",
        "commission": -56.77,
        "swap": 0,
        "profit": -145.98,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056760",
        "positionId": "56056759",
        "volume": 8.11,
        "price": 3219.2,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -202.75,
        "priceIn": 3219.02,
        "doubleCheck": true
    },
    {
        "dataID": "118184",
        "id": "53094213",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:54",
        "brokerTime": "2025-05-14 15:12:54",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056761",
        "positionId": "56056761",
        "volume": 8.11,
        "price": 3219.07,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3219.07,
        "doubleCheck": true
    },
    {
        "dataID": "118185",
        "id": "53094214",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:54",
        "brokerTime": "2025-05-14 15:12:56",
        "commission": -56.77,
        "swap": 0,
        "profit": -121.65,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056762",
        "positionId": "56056761",
        "volume": 8.11,
        "price": 3219.22,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -178.42000000000002,
        "priceIn": 3219.07,
        "doubleCheck": true
    },
    {
        "dataID": "118186",
        "id": "53094220",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:59",
        "brokerTime": "2025-05-14 15:12:59",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056768",
        "positionId": "56056768",
        "volume": 8.11,
        "price": 3219.09,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3219.09,
        "doubleCheck": true
    },
    {
        "dataID": "118187",
        "id": "53094223",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:59",
        "brokerTime": "2025-05-14 15:13:00",
        "commission": -56.77,
        "swap": 0,
        "profit": -81.1,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056771",
        "positionId": "56056768",
        "volume": 8.11,
        "price": 3219.19,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -137.87,
        "priceIn": 3219.09,
        "doubleCheck": true
    },
    {
        "dataID": "118188",
        "id": "53094224",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:00",
        "brokerTime": "2025-05-14 15:13:00",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056772",
        "positionId": "56056772",
        "volume": 8.11,
        "price": 3218.79,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3218.79,
        "doubleCheck": true
    },
    {
        "dataID": "118189",
        "id": "53094225",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:00",
        "brokerTime": "2025-05-14 15:13:01",
        "commission": -56.77,
        "swap": 0,
        "profit": 97.32,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056773",
        "positionId": "56056772",
        "volume": 8.11,
        "price": 3218.67,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 40.54999999999999,
        "priceIn": 3218.79,
        "doubleCheck": true
    },
    {
        "dataID": "118190",
        "id": "53094227",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:02",
        "brokerTime": "2025-05-14 15:13:02",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056775",
        "positionId": "56056775",
        "volume": 8.11,
        "price": 3218.36,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3218.36,
        "doubleCheck": true
    },
    {
        "dataID": "118191",
        "id": "53094228",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:02",
        "brokerTime": "2025-05-14 15:13:03",
        "commission": -56.77,
        "swap": 0,
        "profit": -243.3,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056776",
        "positionId": "56056775",
        "volume": 8.11,
        "price": 3218.66,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -300.07,
        "priceIn": 3218.36,
        "doubleCheck": true
    },
    {
        "dataID": "118192",
        "id": "53094229",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:03",
        "brokerTime": "2025-05-14 15:13:03",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056777",
        "positionId": "56056777",
        "volume": 8.11,
        "price": 3218.44,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3218.44,
        "doubleCheck": true
    },
    {
        "dataID": "118193",
        "id": "53094231",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:03",
        "brokerTime": "2025-05-14 15:13:03",
        "commission": -56.77,
        "swap": 0,
        "profit": 56.77,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056779",
        "positionId": "56056777",
        "volume": 8.11,
        "price": 3218.37,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 0,
        "priceIn": 3218.44,
        "doubleCheck": true
    },
    {
        "dataID": "118194",
        "id": "53094233",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:03",
        "brokerTime": "2025-05-14 15:13:03",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056781",
        "positionId": "56056781",
        "volume": 8.11,
        "price": 3218.01,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3218.01,
        "doubleCheck": true
    },
    {
        "dataID": "118195",
        "id": "53094234",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:03",
        "brokerTime": "2025-05-14 15:13:04",
        "commission": -56.77,
        "swap": 0,
        "profit": -137.87,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056783",
        "positionId": "56056781",
        "volume": 8.11,
        "price": 3218.18,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -194.64000000000001,
        "priceIn": 3218.01,
        "doubleCheck": true
    },
    {
        "dataID": "118196",
        "id": "53094235",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:04",
        "brokerTime": "2025-05-14 15:13:04",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056784",
        "positionId": "56056784",
        "volume": 8.11,
        "price": 3218.01,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3218.01,
        "doubleCheck": true
    },
    {
        "dataID": "118197",
        "id": "53094238",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:04",
        "brokerTime": "2025-05-14 15:13:05",
        "commission": -56.77,
        "swap": 0,
        "profit": -32.44,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056787",
        "positionId": "56056784",
        "volume": 8.11,
        "price": 3218.05,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -89.21000000000001,
        "priceIn": 3218.01,
        "doubleCheck": true
    },
    {
        "dataID": "118198",
        "id": "53094242",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:05",
        "brokerTime": "2025-05-14 15:13:05",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056790",
        "positionId": "56056790",
        "volume": 8.11,
        "price": 3217.77,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3217.77,
        "doubleCheck": true
    },
    {
        "dataID": "118199",
        "id": "53094246",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:05",
        "brokerTime": "2025-05-14 15:13:06",
        "commission": -56.77,
        "swap": 0,
        "profit": -105.43,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056792",
        "positionId": "56056790",
        "volume": 8.11,
        "price": 3217.9,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -162.20000000000002,
        "priceIn": 3217.77,
        "doubleCheck": true
    },
    {
        "dataID": "118200",
        "id": "53094248",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:06",
        "brokerTime": "2025-05-14 15:13:06",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056795",
        "positionId": "56056795",
        "volume": 8.11,
        "price": 3217.81,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3217.81,
        "doubleCheck": true
    },
    {
        "dataID": "118201",
        "id": "53094251",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:06",
        "brokerTime": "2025-05-14 15:13:07",
        "commission": -56.77,
        "swap": 0,
        "profit": -154.09,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056796",
        "positionId": "56056795",
        "volume": 8.11,
        "price": 3218,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -210.86,
        "priceIn": 3217.81,
        "doubleCheck": true
    },
    {
        "dataID": "118202",
        "id": "53094253",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:07",
        "brokerTime": "2025-05-14 15:13:07",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056798",
        "positionId": "56056798",
        "volume": 8.11,
        "price": 3217.84,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3217.84,
        "doubleCheck": true
    },
    {
        "dataID": "118203",
        "id": "53094254",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:07",
        "brokerTime": "2025-05-14 15:13:07",
        "commission": -56.77,
        "swap": 0,
        "profit": -129.76,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056799",
        "positionId": "56056798",
        "volume": 8.11,
        "price": 3218,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -186.53,
        "priceIn": 3217.84,
        "doubleCheck": true
    },
    {
        "dataID": "118204",
        "id": "53094255",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:08",
        "brokerTime": "2025-05-14 15:13:08",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056800",
        "positionId": "56056800",
        "volume": 8.11,
        "price": 3217.84,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3217.84,
        "doubleCheck": true
    },
    {
        "dataID": "118205",
        "id": "53094256",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:08",
        "brokerTime": "2025-05-14 15:13:08",
        "commission": -56.77,
        "swap": 0,
        "profit": -218.97,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056801",
        "positionId": "56056800",
        "volume": 8.11,
        "price": 3218.11,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -275.74,
        "priceIn": 3217.84,
        "doubleCheck": true
    },
    {
        "dataID": "118206",
        "id": "53094257",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:08",
        "brokerTime": "2025-05-14 15:13:08",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056802",
        "positionId": "56056802",
        "volume": 8.11,
        "price": 3217.87,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3217.87,
        "doubleCheck": true
    },
    {
        "dataID": "118207",
        "id": "53094258",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:08",
        "brokerTime": "2025-05-14 15:13:09",
        "commission": -56.77,
        "swap": 0,
        "profit": -129.76,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056803",
        "positionId": "56056802",
        "volume": 8.11,
        "price": 3218.03,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -186.53,
        "priceIn": 3217.87,
        "doubleCheck": true
    },
    {
        "dataID": "118208",
        "id": "53094259",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:09",
        "brokerTime": "2025-05-14 15:13:09",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056804",
        "positionId": "56056804",
        "volume": 8.11,
        "price": 3217.66,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3217.66,
        "doubleCheck": true
    },
    {
        "dataID": "118209",
        "id": "53094260",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 15:13:10",
        "brokerTime": "2025-05-14 15:13:10",
        "commission": -0.84,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUEUR.PRO",
        "magic": "0",
        "orderId": "56056805",
        "positionId": "56056805",
        "volume": 0.12,
        "price": 2869.79,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2969.79,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.84,
        "priceIn": 2869.79,
        "doubleCheck": true
    },
    {
        "dataID": "118210",
        "id": "53094261",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:09",
        "brokerTime": "2025-05-14 15:13:10",
        "commission": -56.77,
        "swap": 0,
        "profit": -145.98,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056806",
        "positionId": "56056804",
        "volume": 8.11,
        "price": 3217.84,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -202.75,
        "priceIn": 3217.66,
        "doubleCheck": true
    },
    {
        "dataID": "118211",
        "id": "53094263",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:11",
        "brokerTime": "2025-05-14 15:13:11",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056808",
        "positionId": "56056808",
        "volume": 8.11,
        "price": 3217.51,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3217.51,
        "doubleCheck": true
    },
    {
        "dataID": "118212",
        "id": "53094266",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:11",
        "brokerTime": "2025-05-14 15:13:12",
        "commission": -56.77,
        "swap": 0,
        "profit": 210.86,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056811",
        "positionId": "56056808",
        "volume": 8.11,
        "price": 3217.25,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 154.09,
        "priceIn": 3217.51,
        "doubleCheck": true
    },
    {
        "dataID": "118213",
        "id": "53094268",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:12",
        "brokerTime": "2025-05-14 15:13:12",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056813",
        "positionId": "56056813",
        "volume": 8.11,
        "price": 3217.02,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3217.02,
        "doubleCheck": true
    },
    {
        "dataID": "118214",
        "id": "53094270",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:12",
        "brokerTime": "2025-05-14 15:13:12",
        "commission": -56.77,
        "swap": 0,
        "profit": -154.09,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056814",
        "positionId": "56056813",
        "volume": 8.11,
        "price": 3217.21,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -210.86,
        "priceIn": 3217.02,
        "doubleCheck": true
    },
    {
        "dataID": "118215",
        "id": "53094272",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:13",
        "brokerTime": "2025-05-14 15:13:13",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056816",
        "positionId": "56056816",
        "volume": 8.11,
        "price": 3217.02,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3217.02,
        "doubleCheck": true
    },
    {
        "dataID": "118216",
        "id": "53094276",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:13",
        "brokerTime": "2025-05-14 15:13:13",
        "commission": -56.77,
        "swap": 0,
        "profit": 348.73,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056820",
        "positionId": "56056816",
        "volume": 8.11,
        "price": 3216.59,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 291.96000000000004,
        "priceIn": 3217.02,
        "doubleCheck": true
    },
    {
        "dataID": "118217",
        "id": "53094285",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:14",
        "brokerTime": "2025-05-14 15:13:14",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056823",
        "positionId": "56056823",
        "volume": 8.11,
        "price": 3215.86,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3215.86,
        "doubleCheck": true
    },
    {
        "dataID": "118218",
        "id": "53094359",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:14",
        "brokerTime": "2025-05-14 15:13:14",
        "commission": -56.77,
        "swap": 0,
        "profit": -72.99,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056895",
        "positionId": "56056823",
        "volume": 8.11,
        "price": 3215.95,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -129.76,
        "priceIn": 3215.86,
        "doubleCheck": true
    },
    {
        "dataID": "118219",
        "id": "53094380",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:15",
        "brokerTime": "2025-05-14 15:13:15",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056904",
        "positionId": "56056904",
        "volume": 8.11,
        "price": 3215.58,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3215.58,
        "doubleCheck": true
    },
    {
        "dataID": "118220",
        "id": "53094384",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:15",
        "brokerTime": "2025-05-14 15:13:15",
        "commission": -56.77,
        "swap": 0,
        "profit": -202.75,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056907",
        "positionId": "56056904",
        "volume": 8.11,
        "price": 3215.83,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -259.52,
        "priceIn": 3215.58,
        "doubleCheck": true
    },
    {
        "dataID": "118221",
        "id": "53094387",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:15",
        "brokerTime": "2025-05-14 15:13:15",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056908",
        "positionId": "56056908",
        "volume": 8.11,
        "price": 3215.73,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3215.73,
        "doubleCheck": true
    },
    {
        "dataID": "118222",
        "id": "53094388",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:15",
        "brokerTime": "2025-05-14 15:13:16",
        "commission": -56.77,
        "swap": 0,
        "profit": -137.87,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56056909",
        "positionId": "56056908",
        "volume": 8.11,
        "price": 3215.9,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -194.64000000000001,
        "priceIn": 3215.73,
        "doubleCheck": true
    },
    {
        "dataID": "118223",
        "id": "53094601",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:16",
        "brokerTime": "2025-05-14 15:13:16",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56057124",
        "positionId": "56057124",
        "volume": 8.11,
        "price": 3215.55,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.77,
        "priceIn": 3215.55,
        "doubleCheck": true
    },
    {
        "dataID": "118224",
        "id": "53094653",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:16",
        "brokerTime": "2025-05-14 15:13:17",
        "commission": -56.77,
        "swap": 0,
        "profit": 308.18,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56057150",
        "positionId": "56057124",
        "volume": 8.11,
        "price": 3215.17,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 251.41,
        "priceIn": 3215.55,
        "doubleCheck": true
    },
    {
        "dataID": "118225",
        "id": "53094654",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 15:13:17",
        "brokerTime": "2025-05-14 15:13:17",
        "commission": -10.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56057151",
        "positionId": "56057151",
        "volume": 1.54,
        "price": 3215.18,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3315.18,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -10.78,
        "priceIn": 3215.18,
        "doubleCheck": true
    },
    {
        "dataID": "118226",
        "id": "53094669",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:18",
        "brokerTime": "2025-05-14 15:13:18",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56057173",
        "positionId": "56057173",
        "volume": 9.96,
        "price": 3215.36,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3215.36,
        "doubleCheck": true
    },
    {
        "dataID": "118227",
        "id": "53094709",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:18",
        "brokerTime": "2025-05-14 15:13:19",
        "commission": -69.72,
        "swap": 0,
        "profit": -109.56,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56057194",
        "positionId": "56057173",
        "volume": 9.96,
        "price": 3215.47,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -179.28,
        "priceIn": 3215.36,
        "doubleCheck": true
    },
    {
        "dataID": "118228",
        "id": "53094741",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:19",
        "brokerTime": "2025-05-14 15:13:19",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56057209",
        "positionId": "56057209",
        "volume": 9.96,
        "price": 3215.15,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3215.15,
        "doubleCheck": true
    },
    {
        "dataID": "118229",
        "id": "53094762",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:19",
        "brokerTime": "2025-05-14 15:13:19",
        "commission": -69.72,
        "swap": 0,
        "profit": -129.48,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56057233",
        "positionId": "56057209",
        "volume": 9.96,
        "price": 3215.28,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -199.2,
        "priceIn": 3215.15,
        "doubleCheck": true
    },
    {
        "dataID": "118230",
        "id": "53094835",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:20",
        "brokerTime": "2025-05-14 15:13:20",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56057277",
        "positionId": "56057277",
        "volume": 9.96,
        "price": 3215.06,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3215.06,
        "doubleCheck": true
    },
    {
        "dataID": "118231",
        "id": "53094875",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:20",
        "brokerTime": "2025-05-14 15:13:20",
        "commission": -69.72,
        "swap": 0,
        "profit": -179.28,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56057297",
        "positionId": "56057277",
        "volume": 9.96,
        "price": 3215.24,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -249,
        "priceIn": 3215.06,
        "doubleCheck": true
    },
    {
        "dataID": "118232",
        "id": "53094907",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:21",
        "brokerTime": "2025-05-14 15:13:21",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56057310",
        "positionId": "56057310",
        "volume": 9.96,
        "price": 3215.08,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3215.08,
        "doubleCheck": true
    },
    {
        "dataID": "118233",
        "id": "53094956",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:21",
        "brokerTime": "2025-05-14 15:13:21",
        "commission": -69.72,
        "swap": 0,
        "profit": -179.28,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56057342",
        "positionId": "56057310",
        "volume": 9.96,
        "price": 3215.26,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -249,
        "priceIn": 3215.08,
        "doubleCheck": true
    },
    {
        "dataID": "118234",
        "id": "53094982",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:21",
        "brokerTime": "2025-05-14 15:13:21",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56057355",
        "positionId": "56057355",
        "volume": 9.96,
        "price": 3215.07,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3215.07,
        "doubleCheck": true
    },
    {
        "dataID": "118235",
        "id": "53095021",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:21",
        "brokerTime": "2025-05-14 15:13:22",
        "commission": -69.72,
        "swap": 0,
        "profit": -488.04,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56057377",
        "positionId": "56057355",
        "volume": 9.96,
        "price": 3215.56,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -557.76,
        "priceIn": 3215.07,
        "doubleCheck": true
    },
    {
        "dataID": "118236",
        "id": "53095050",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:22",
        "brokerTime": "2025-05-14 15:13:22",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56057409",
        "positionId": "56057409",
        "volume": 9.96,
        "price": 3215.23,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3215.23,
        "doubleCheck": true
    },
    {
        "dataID": "118237",
        "id": "53095164",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:22",
        "brokerTime": "2025-05-14 15:13:23",
        "commission": -69.72,
        "swap": 0,
        "profit": 9.96,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56057469",
        "positionId": "56057409",
        "volume": 9.96,
        "price": 3215.22,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -59.76,
        "priceIn": 3215.23,
        "doubleCheck": true
    },
    {
        "dataID": "118238",
        "id": "53095172",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:23",
        "brokerTime": "2025-05-14 15:13:23",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56057479",
        "positionId": "56057479",
        "volume": 9.96,
        "price": 3214.99,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3214.99,
        "doubleCheck": true
    },
    {
        "dataID": "118239",
        "id": "53095227",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:23",
        "brokerTime": "2025-05-14 15:13:24",
        "commission": -69.72,
        "swap": 0,
        "profit": -189.24,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56057509",
        "positionId": "56057479",
        "volume": 9.96,
        "price": 3215.18,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -258.96000000000004,
        "priceIn": 3214.99,
        "doubleCheck": true
    },
    {
        "dataID": "118240",
        "id": "53095248",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:24",
        "brokerTime": "2025-05-14 15:13:24",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56057526",
        "positionId": "56057526",
        "volume": 9.96,
        "price": 3214.95,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3214.95,
        "doubleCheck": true
    },
    {
        "dataID": "118241",
        "id": "53095292",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:24",
        "brokerTime": "2025-05-14 15:13:24",
        "commission": -69.72,
        "swap": 0,
        "profit": -229.08,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56057551",
        "positionId": "56057526",
        "volume": 9.96,
        "price": 3215.18,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -298.8,
        "priceIn": 3214.95,
        "doubleCheck": true
    },
    {
        "dataID": "118242",
        "id": "53095319",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:25",
        "brokerTime": "2025-05-14 15:13:25",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56057567",
        "positionId": "56057567",
        "volume": 9.96,
        "price": 3215,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3215,
        "doubleCheck": true
    },
    {
        "dataID": "118243",
        "id": "53095366",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:25",
        "brokerTime": "2025-05-14 15:13:25",
        "commission": -69.72,
        "swap": 0,
        "profit": -209.16,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56057590",
        "positionId": "56057567",
        "volume": 9.96,
        "price": 3215.21,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -278.88,
        "priceIn": 3215,
        "doubleCheck": true
    },
    {
        "dataID": "118244",
        "id": "53095400",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:25",
        "brokerTime": "2025-05-14 15:13:25",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56057612",
        "positionId": "56057612",
        "volume": 9.96,
        "price": 3214.43,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3214.43,
        "doubleCheck": true
    },
    {
        "dataID": "118245",
        "id": "53095481",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:25",
        "brokerTime": "2025-05-14 15:13:26",
        "commission": -69.72,
        "swap": 0,
        "profit": -159.36,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56057680",
        "positionId": "56057612",
        "volume": 9.96,
        "price": 3214.59,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -229.08,
        "priceIn": 3214.43,
        "doubleCheck": true
    },
    {
        "dataID": "118246",
        "id": "53095524",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:26",
        "brokerTime": "2025-05-14 15:13:26",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56057697",
        "positionId": "56057697",
        "volume": 9.96,
        "price": 3214.37,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3214.37,
        "doubleCheck": true
    },
    {
        "dataID": "118247",
        "id": "53095551",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:26",
        "brokerTime": "2025-05-14 15:13:27",
        "commission": -69.72,
        "swap": 0,
        "profit": 59.76,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56057715",
        "positionId": "56057697",
        "volume": 9.96,
        "price": 3214.31,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -9.96,
        "priceIn": 3214.37,
        "doubleCheck": true
    },
    {
        "dataID": "118248",
        "id": "53095602",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:27",
        "brokerTime": "2025-05-14 15:13:27",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56057740",
        "positionId": "56057740",
        "volume": 9.96,
        "price": 3214.18,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3214.18,
        "doubleCheck": true
    },
    {
        "dataID": "118249",
        "id": "53095641",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:27",
        "brokerTime": "2025-05-14 15:13:27",
        "commission": -69.72,
        "swap": 0,
        "profit": -229.08,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56057778",
        "positionId": "56057740",
        "volume": 9.96,
        "price": 3214.41,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -298.8,
        "priceIn": 3214.18,
        "doubleCheck": true
    },
    {
        "dataID": "118250",
        "id": "53095672",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:27",
        "brokerTime": "2025-05-14 15:13:27",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56057785",
        "positionId": "56057785",
        "volume": 9.96,
        "price": 3214.15,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3214.15,
        "doubleCheck": true
    },
    {
        "dataID": "118251",
        "id": "53095722",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:27",
        "brokerTime": "2025-05-14 15:13:28",
        "commission": -69.72,
        "swap": 0,
        "profit": -318.72,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56057820",
        "positionId": "56057785",
        "volume": 9.96,
        "price": 3214.47,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -388.44000000000005,
        "priceIn": 3214.15,
        "doubleCheck": true
    },
    {
        "dataID": "118252",
        "id": "53095734",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:28",
        "brokerTime": "2025-05-14 15:13:28",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56057827",
        "positionId": "56057827",
        "volume": 9.96,
        "price": 3214.26,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3214.26,
        "doubleCheck": true
    },
    {
        "dataID": "118253",
        "id": "53095795",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:28",
        "brokerTime": "2025-05-14 15:13:28",
        "commission": -69.72,
        "swap": 0,
        "profit": 378.48,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56057872",
        "positionId": "56057827",
        "volume": 9.96,
        "price": 3213.88,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 308.76,
        "priceIn": 3214.26,
        "doubleCheck": true
    },
    {
        "dataID": "118254",
        "id": "53095920",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:29",
        "brokerTime": "2025-05-14 15:13:29",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56057934",
        "positionId": "56057934",
        "volume": 9.96,
        "price": 3213.45,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3213.45,
        "doubleCheck": true
    },
    {
        "dataID": "118255",
        "id": "53096020",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:29",
        "brokerTime": "2025-05-14 15:13:30",
        "commission": -69.72,
        "swap": 0,
        "profit": -39.84,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56058000",
        "positionId": "56057934",
        "volume": 9.96,
        "price": 3213.49,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -109.56,
        "priceIn": 3213.45,
        "doubleCheck": true
    },
    {
        "dataID": "118256",
        "id": "53096086",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:30",
        "brokerTime": "2025-05-14 15:13:30",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56058059",
        "positionId": "56058059",
        "volume": 9.96,
        "price": 3213.22,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3213.22,
        "doubleCheck": true
    },
    {
        "dataID": "118257",
        "id": "53096176",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:30",
        "brokerTime": "2025-05-14 15:13:30",
        "commission": -69.72,
        "swap": 0,
        "profit": -209.16,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56058084",
        "positionId": "56058059",
        "volume": 9.96,
        "price": 3213.43,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -278.88,
        "priceIn": 3213.22,
        "doubleCheck": true
    },
    {
        "dataID": "118258",
        "id": "53096192",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:31",
        "brokerTime": "2025-05-14 15:13:31",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56058097",
        "positionId": "56058097",
        "volume": 9.96,
        "price": 3213.26,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3213.26,
        "doubleCheck": true
    },
    {
        "dataID": "118259",
        "id": "53096256",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:31",
        "brokerTime": "2025-05-14 15:13:31",
        "commission": -69.72,
        "swap": 0,
        "profit": -398.4,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56058161",
        "positionId": "56058097",
        "volume": 9.96,
        "price": 3213.66,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -468.12,
        "priceIn": 3213.26,
        "doubleCheck": true
    },
    {
        "dataID": "118260",
        "id": "53096352",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:31",
        "brokerTime": "2025-05-14 15:13:31",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56058226",
        "positionId": "56058226",
        "volume": 9.96,
        "price": 3213.51,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3213.51,
        "doubleCheck": true
    },
    {
        "dataID": "118261",
        "id": "53096459",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:31",
        "brokerTime": "2025-05-14 15:13:32",
        "commission": -69.72,
        "swap": 0,
        "profit": -537.84,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56058254",
        "positionId": "56058226",
        "volume": 9.96,
        "price": 3214.05,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -607.5600000000001,
        "priceIn": 3213.51,
        "doubleCheck": true
    },
    {
        "dataID": "118262",
        "id": "53096541",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:32",
        "brokerTime": "2025-05-14 15:13:32",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56058311",
        "positionId": "56058311",
        "volume": 9.96,
        "price": 3213.89,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3213.89,
        "doubleCheck": true
    },
    {
        "dataID": "118263",
        "id": "53096669",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:32",
        "brokerTime": "2025-05-14 15:13:32",
        "commission": -69.72,
        "swap": 0,
        "profit": -378.48,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56058381",
        "positionId": "56058311",
        "volume": 9.96,
        "price": 3214.27,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -448.20000000000005,
        "priceIn": 3213.89,
        "doubleCheck": true
    },
    {
        "dataID": "118264",
        "id": "53096734",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:33",
        "brokerTime": "2025-05-14 15:13:33",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56058418",
        "positionId": "56058418",
        "volume": 9.96,
        "price": 3214.07,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3214.07,
        "doubleCheck": true
    },
    {
        "dataID": "118265",
        "id": "53096856",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:33",
        "brokerTime": "2025-05-14 15:13:33",
        "commission": -69.72,
        "swap": 0,
        "profit": -99.6,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56058504",
        "positionId": "56058418",
        "volume": 9.96,
        "price": 3214.17,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -169.32,
        "priceIn": 3214.07,
        "doubleCheck": true
    },
    {
        "dataID": "118266",
        "id": "53096971",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:33",
        "brokerTime": "2025-05-14 15:13:33",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56058551",
        "positionId": "56058551",
        "volume": 9.96,
        "price": 3213.98,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3213.98,
        "doubleCheck": true
    },
    {
        "dataID": "118267",
        "id": "53097093",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:33",
        "brokerTime": "2025-05-14 15:13:34",
        "commission": -69.72,
        "swap": 0,
        "profit": -79.68,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56058634",
        "positionId": "56058551",
        "volume": 9.96,
        "price": 3214.06,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -149.4,
        "priceIn": 3213.98,
        "doubleCheck": true
    },
    {
        "dataID": "118268",
        "id": "53097157",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:34",
        "brokerTime": "2025-05-14 15:13:34",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56058688",
        "positionId": "56058688",
        "volume": 9.96,
        "price": 3214.02,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3214.02,
        "doubleCheck": true
    },
    {
        "dataID": "118269",
        "id": "53097354",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:34",
        "brokerTime": "2025-05-14 15:13:35",
        "commission": -69.72,
        "swap": 0,
        "profit": -438.24,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56058762",
        "positionId": "56058688",
        "volume": 9.96,
        "price": 3214.46,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -507.96000000000004,
        "priceIn": 3214.02,
        "doubleCheck": true
    },
    {
        "dataID": "118270",
        "id": "53097385",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:37",
        "brokerTime": "2025-05-14 15:13:35",
        "commission": -0.98,
        "swap": 0,
        "profit": 85.85,
        "symbol": "XAUEUR.PRO",
        "magic": "0",
        "orderId": "56058788",
        "positionId": "56054488",
        "volume": 0.14,
        "price": 2867.34,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2773.01,
        "brokerComment": "",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 84.86999999999999,
        "priceIn": 2872.81,
        "doubleCheck": true
    },
    {
        "dataID": "118271",
        "id": "53097386",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:56",
        "brokerTime": "2025-05-14 15:13:35",
        "commission": -0.84,
        "swap": 0,
        "profit": 60,
        "symbol": "XAUEUR.PRO",
        "magic": "0",
        "orderId": "56058791",
        "positionId": "56054281",
        "volume": 0.12,
        "price": 2867.34,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2773.02,
        "brokerComment": "",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 59.16,
        "priceIn": 2871.8,
        "doubleCheck": true
    },
    {
        "dataID": "118272",
        "id": "53097413",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:59",
        "brokerTime": "2025-05-14 15:13:35",
        "commission": -0.7,
        "swap": 0,
        "profit": 34.64,
        "symbol": "XAUEUR.PRO",
        "magic": "0",
        "orderId": "56058793",
        "positionId": "56054159",
        "volume": 0.1,
        "price": 2867.6,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2773.02,
        "brokerComment": "",
        "comment": "RR",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 33.94,
        "priceIn": 2870.69,
        "doubleCheck": true
    },
    {
        "dataID": "118273",
        "id": "53097428",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:36",
        "brokerTime": "2025-05-14 15:13:36",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56058815",
        "positionId": "56058815",
        "volume": 9.96,
        "price": 3214.53,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3214.53,
        "doubleCheck": true
    },
    {
        "dataID": "118274",
        "id": "53097486",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:36",
        "brokerTime": "2025-05-14 15:13:36",
        "commission": -69.72,
        "swap": 0,
        "profit": -219.12,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56058855",
        "positionId": "56058815",
        "volume": 9.96,
        "price": 3214.75,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -288.84000000000003,
        "priceIn": 3214.53,
        "doubleCheck": true
    },
    {
        "dataID": "118275",
        "id": "53097559",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:36",
        "brokerTime": "2025-05-14 15:13:36",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56058883",
        "positionId": "56058883",
        "volume": 9.96,
        "price": 3214.43,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3214.43,
        "doubleCheck": true
    },
    {
        "dataID": "118276",
        "id": "53097646",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:36",
        "brokerTime": "2025-05-14 15:13:37",
        "commission": -69.72,
        "swap": 0,
        "profit": -249,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56058960",
        "positionId": "56058883",
        "volume": 9.96,
        "price": 3214.68,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -318.72,
        "priceIn": 3214.43,
        "doubleCheck": true
    },
    {
        "dataID": "118277",
        "id": "53097750",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:37",
        "brokerTime": "2025-05-14 15:13:37",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56059002",
        "positionId": "56059002",
        "volume": 9.96,
        "price": 3214.48,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3214.48,
        "doubleCheck": true
    },
    {
        "dataID": "118278",
        "id": "53097793",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:37",
        "brokerTime": "2025-05-14 15:13:37",
        "commission": -69.72,
        "swap": 0,
        "profit": -189.24,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56059023",
        "positionId": "56059002",
        "volume": 9.96,
        "price": 3214.67,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -258.96000000000004,
        "priceIn": 3214.48,
        "doubleCheck": true
    },
    {
        "dataID": "118279",
        "id": "53097833",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:38",
        "brokerTime": "2025-05-14 15:13:38",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56059089",
        "positionId": "56059089",
        "volume": 9.96,
        "price": 3214.5,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3214.5,
        "doubleCheck": true
    },
    {
        "dataID": "118280",
        "id": "53097997",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:38",
        "brokerTime": "2025-05-14 15:13:38",
        "commission": -69.72,
        "swap": 0,
        "profit": -258.96,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56059167",
        "positionId": "56059089",
        "volume": 9.96,
        "price": 3214.76,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -328.67999999999995,
        "priceIn": 3214.5,
        "doubleCheck": true
    },
    {
        "dataID": "118281",
        "id": "53098086",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:38",
        "brokerTime": "2025-05-14 15:13:38",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56059201",
        "positionId": "56059201",
        "volume": 9.96,
        "price": 3214.51,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3214.51,
        "doubleCheck": true
    },
    {
        "dataID": "118282",
        "id": "53098199",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:38",
        "brokerTime": "2025-05-14 15:13:39",
        "commission": -69.72,
        "swap": 0,
        "profit": -268.92,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56059275",
        "positionId": "56059201",
        "volume": 9.96,
        "price": 3214.78,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -338.64,
        "priceIn": 3214.51,
        "doubleCheck": true
    },
    {
        "dataID": "118283",
        "id": "53098303",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:39",
        "brokerTime": "2025-05-14 15:13:39",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56059327",
        "positionId": "56059327",
        "volume": 9.96,
        "price": 3214.54,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3214.54,
        "doubleCheck": true
    },
    {
        "dataID": "118284",
        "id": "53098459",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:39",
        "brokerTime": "2025-05-14 15:13:40",
        "commission": -69.72,
        "swap": 0,
        "profit": -229.08,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56059421",
        "positionId": "56059327",
        "volume": 9.96,
        "price": 3214.77,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -298.8,
        "priceIn": 3214.54,
        "doubleCheck": true
    },
    {
        "dataID": "118285",
        "id": "53098583",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:40",
        "brokerTime": "2025-05-14 15:13:40",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56059485",
        "positionId": "56059485",
        "volume": 9.96,
        "price": 3214.62,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3214.62,
        "doubleCheck": true
    },
    {
        "dataID": "118286",
        "id": "53098771",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:40",
        "brokerTime": "2025-05-14 15:13:40",
        "commission": -69.72,
        "swap": 0,
        "profit": -59.76,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56059594",
        "positionId": "56059485",
        "volume": 9.96,
        "price": 3214.68,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -129.48,
        "priceIn": 3214.62,
        "doubleCheck": true
    },
    {
        "dataID": "118287",
        "id": "53098843",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:41",
        "brokerTime": "2025-05-14 15:13:41",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56059633",
        "positionId": "56059633",
        "volume": 9.96,
        "price": 3214.34,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3214.34,
        "doubleCheck": true
    },
    {
        "dataID": "118288",
        "id": "53099060",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:41",
        "brokerTime": "2025-05-14 15:13:41",
        "commission": -69.72,
        "swap": 0,
        "profit": -179.28,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56059759",
        "positionId": "56059633",
        "volume": 9.96,
        "price": 3214.52,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -249,
        "priceIn": 3214.34,
        "doubleCheck": true
    },
    {
        "dataID": "118289",
        "id": "53099110",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:41",
        "brokerTime": "2025-05-14 15:13:41",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56059802",
        "positionId": "56059802",
        "volume": 9.96,
        "price": 3214.31,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3214.31,
        "doubleCheck": true
    },
    {
        "dataID": "118290",
        "id": "53099239",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:41",
        "brokerTime": "2025-05-14 15:13:42",
        "commission": -69.72,
        "swap": 0,
        "profit": -49.8,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56059889",
        "positionId": "56059802",
        "volume": 9.96,
        "price": 3214.36,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -119.52,
        "priceIn": 3214.31,
        "doubleCheck": true
    },
    {
        "dataID": "118291",
        "id": "53099384",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:42",
        "brokerTime": "2025-05-14 15:13:42",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56059971",
        "positionId": "56059971",
        "volume": 9.96,
        "price": 3214.13,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3214.13,
        "doubleCheck": true
    },
    {
        "dataID": "118292",
        "id": "53099481",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:42",
        "brokerTime": "2025-05-14 15:13:42",
        "commission": -0.7,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUEUR.PRO",
        "magic": "0",
        "orderId": "56059993",
        "positionId": "56059993",
        "volume": 0.1,
        "price": 2867.11,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "RR",
        "comment": "RR",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.7,
        "priceIn": 2867.11,
        "doubleCheck": true
    },
    {
        "dataID": "118293",
        "id": "53099535",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:42",
        "brokerTime": "2025-05-14 15:13:42",
        "commission": -69.72,
        "swap": 0,
        "profit": -617.52,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56060046",
        "positionId": "56059971",
        "volume": 9.96,
        "price": 3214.75,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -687.24,
        "priceIn": 3214.13,
        "doubleCheck": true
    },
    {
        "dataID": "118294",
        "id": "53099633",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:43",
        "brokerTime": "2025-05-14 15:13:43",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56060092",
        "positionId": "56060092",
        "volume": 9.96,
        "price": 3214.41,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3214.41,
        "doubleCheck": true
    },
    {
        "dataID": "118295",
        "id": "53099811",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:43",
        "brokerTime": "2025-05-14 15:13:43",
        "commission": -69.72,
        "swap": 0,
        "profit": -129.48,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56060199",
        "positionId": "56060092",
        "volume": 9.96,
        "price": 3214.54,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -199.2,
        "priceIn": 3214.41,
        "doubleCheck": true
    },
    {
        "dataID": "118296",
        "id": "53100062",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:44",
        "brokerTime": "2025-05-14 15:13:44",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56060330",
        "positionId": "56060330",
        "volume": 9.96,
        "price": 3214.31,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3214.31,
        "doubleCheck": true
    },
    {
        "dataID": "118297",
        "id": "53100265",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:44",
        "brokerTime": "2025-05-14 15:13:44",
        "commission": -69.72,
        "swap": 0,
        "profit": -19.92,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56060454",
        "positionId": "56060330",
        "volume": 9.96,
        "price": 3214.33,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -89.64,
        "priceIn": 3214.31,
        "doubleCheck": true
    },
    {
        "dataID": "118298",
        "id": "53100285",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:44",
        "brokerTime": "2025-05-14 15:13:44",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56060481",
        "positionId": "56060481",
        "volume": 9.96,
        "price": 3214.08,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3214.08,
        "doubleCheck": true
    },
    {
        "dataID": "118299",
        "id": "53100451",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:44",
        "brokerTime": "2025-05-14 15:13:45",
        "commission": -69.72,
        "swap": 0,
        "profit": -229.08,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56060603",
        "positionId": "56060481",
        "volume": 9.96,
        "price": 3214.31,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -298.8,
        "priceIn": 3214.08,
        "doubleCheck": true
    },
    {
        "dataID": "118300",
        "id": "53100662",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:45",
        "brokerTime": "2025-05-14 15:13:45",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56060711",
        "positionId": "56060711",
        "volume": 9.96,
        "price": 3214.11,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3214.11,
        "doubleCheck": true
    },
    {
        "dataID": "118301",
        "id": "53100790",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:45",
        "brokerTime": "2025-05-14 15:13:46",
        "commission": -69.72,
        "swap": 0,
        "profit": -199.2,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56060774",
        "positionId": "56060711",
        "volume": 9.96,
        "price": 3214.31,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -268.91999999999996,
        "priceIn": 3214.11,
        "doubleCheck": true
    },
    {
        "dataID": "118302",
        "id": "53100992",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:46",
        "brokerTime": "2025-05-14 15:13:46",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56060915",
        "positionId": "56060915",
        "volume": 9.96,
        "price": 3214.1,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3214.1,
        "doubleCheck": true
    },
    {
        "dataID": "118303",
        "id": "53101305",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:46",
        "brokerTime": "2025-05-14 15:13:47",
        "commission": -69.72,
        "swap": 0,
        "profit": -278.88,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56061096",
        "positionId": "56060915",
        "volume": 9.96,
        "price": 3214.38,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -348.6,
        "priceIn": 3214.1,
        "doubleCheck": true
    },
    {
        "dataID": "118304",
        "id": "53101490",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:47",
        "brokerTime": "2025-05-14 15:13:47",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56061219",
        "positionId": "56061219",
        "volume": 9.96,
        "price": 3214.58,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3214.58,
        "doubleCheck": true
    },
    {
        "dataID": "118305",
        "id": "53101740",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:47",
        "brokerTime": "2025-05-14 15:13:48",
        "commission": -69.72,
        "swap": 0,
        "profit": -249,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56061291",
        "positionId": "56061219",
        "volume": 9.96,
        "price": 3214.83,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -318.72,
        "priceIn": 3214.58,
        "doubleCheck": true
    },
    {
        "dataID": "118306",
        "id": "53101804",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:48",
        "brokerTime": "2025-05-14 15:13:48",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56061347",
        "positionId": "56061347",
        "volume": 9.96,
        "price": 3214.7,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3214.7,
        "doubleCheck": true
    },
    {
        "dataID": "118307",
        "id": "53102064",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:48",
        "brokerTime": "2025-05-14 15:13:49",
        "commission": -69.72,
        "swap": 0,
        "profit": -597.6,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56061480",
        "positionId": "56061347",
        "volume": 9.96,
        "price": 3215.3,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -667.32,
        "priceIn": 3214.7,
        "doubleCheck": true
    },
    {
        "dataID": "118308",
        "id": "53102335",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:49",
        "brokerTime": "2025-05-14 15:13:49",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56061634",
        "positionId": "56061634",
        "volume": 9.96,
        "price": 3215.04,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3215.04,
        "doubleCheck": true
    },
    {
        "dataID": "118309",
        "id": "53102663",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:49",
        "brokerTime": "2025-05-14 15:13:50",
        "commission": -69.72,
        "swap": 0,
        "profit": -139.44,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56061915",
        "positionId": "56061634",
        "volume": 9.96,
        "price": 3215.18,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -209.16,
        "priceIn": 3215.04,
        "doubleCheck": true
    },
    {
        "dataID": "118310",
        "id": "53102866",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:51",
        "brokerTime": "2025-05-14 15:13:51",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56061974",
        "positionId": "56061974",
        "volume": 9.96,
        "price": 3215.01,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3215.01,
        "doubleCheck": true
    },
    {
        "dataID": "118311",
        "id": "53103122",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:51",
        "brokerTime": "2025-05-14 15:13:51",
        "commission": -69.72,
        "swap": 0,
        "profit": 9.96,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56062150",
        "positionId": "56061974",
        "volume": 9.96,
        "price": 3215,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -59.76,
        "priceIn": 3215.01,
        "doubleCheck": true
    },
    {
        "dataID": "118312",
        "id": "53103332",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:51",
        "brokerTime": "2025-05-14 15:13:51",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56062230",
        "positionId": "56062230",
        "volume": 9.96,
        "price": 3214.64,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3214.64,
        "doubleCheck": true
    },
    {
        "dataID": "118313",
        "id": "53103656",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:51",
        "brokerTime": "2025-05-14 15:13:52",
        "commission": -69.72,
        "swap": 0,
        "profit": -59.76,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56062405",
        "positionId": "56062230",
        "volume": 9.96,
        "price": 3214.7,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -129.48,
        "priceIn": 3214.64,
        "doubleCheck": true
    },
    {
        "dataID": "118314",
        "id": "53103781",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:52",
        "brokerTime": "2025-05-14 15:13:52",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56062503",
        "positionId": "56062503",
        "volume": 9.96,
        "price": 3214.43,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3214.43,
        "doubleCheck": true
    },
    {
        "dataID": "118315",
        "id": "53104003",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:52",
        "brokerTime": "2025-05-14 15:13:53",
        "commission": -69.72,
        "swap": 0,
        "profit": -219.12,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56062608",
        "positionId": "56062503",
        "volume": 9.96,
        "price": 3214.65,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -288.84000000000003,
        "priceIn": 3214.43,
        "doubleCheck": true
    },
    {
        "dataID": "118316",
        "id": "53104144",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:53",
        "brokerTime": "2025-05-14 15:13:53",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56062687",
        "positionId": "56062687",
        "volume": 9.96,
        "price": 3214.36,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3214.36,
        "doubleCheck": true
    },
    {
        "dataID": "118317",
        "id": "53104403",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:53",
        "brokerTime": "2025-05-14 15:13:53",
        "commission": -69.72,
        "swap": 0,
        "profit": -239.04,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56062836",
        "positionId": "56062687",
        "volume": 9.96,
        "price": 3214.6,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -308.76,
        "priceIn": 3214.36,
        "doubleCheck": true
    },
    {
        "dataID": "118318",
        "id": "53104589",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:54",
        "brokerTime": "2025-05-14 15:13:54",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56062941",
        "positionId": "56062941",
        "volume": 9.96,
        "price": 3214.51,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3214.51,
        "doubleCheck": true
    },
    {
        "dataID": "118319",
        "id": "53105074",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:54",
        "brokerTime": "2025-05-14 15:13:54",
        "commission": -69.72,
        "swap": 0,
        "profit": -239.04,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56063178",
        "positionId": "56062941",
        "volume": 9.96,
        "price": 3214.75,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -308.76,
        "priceIn": 3214.51,
        "doubleCheck": true
    },
    {
        "dataID": "118320",
        "id": "53105253",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:55",
        "brokerTime": "2025-05-14 15:13:55",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56063313",
        "positionId": "56063313",
        "volume": 9.96,
        "price": 3214.56,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3214.56,
        "doubleCheck": true
    },
    {
        "dataID": "118321",
        "id": "53105598",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:55",
        "brokerTime": "2025-05-14 15:13:55",
        "commission": -69.72,
        "swap": 0,
        "profit": -219.12,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56063472",
        "positionId": "56063313",
        "volume": 9.96,
        "price": 3214.78,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -288.84000000000003,
        "priceIn": 3214.56,
        "doubleCheck": true
    },
    {
        "dataID": "118322",
        "id": "53105743",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:55",
        "brokerTime": "2025-05-14 15:13:55",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56063530",
        "positionId": "56063530",
        "volume": 9.96,
        "price": 3214.56,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3214.56,
        "doubleCheck": true
    },
    {
        "dataID": "118323",
        "id": "53105823",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:55",
        "brokerTime": "2025-05-14 15:13:56",
        "commission": -69.72,
        "swap": 0,
        "profit": 209.16,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56063622",
        "positionId": "56063530",
        "volume": 9.96,
        "price": 3214.35,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 139.44,
        "priceIn": 3214.56,
        "doubleCheck": true
    },
    {
        "dataID": "118324",
        "id": "53106095",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:56",
        "brokerTime": "2025-05-14 15:13:56",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56063808",
        "positionId": "56063808",
        "volume": 9.96,
        "price": 3214.27,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3214.27,
        "doubleCheck": true
    },
    {
        "dataID": "118325",
        "id": "53106397",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:56",
        "brokerTime": "2025-05-14 15:13:57",
        "commission": -69.72,
        "swap": 0,
        "profit": -209.16,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56063965",
        "positionId": "56063808",
        "volume": 9.96,
        "price": 3214.48,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -278.88,
        "priceIn": 3214.27,
        "doubleCheck": true
    },
    {
        "dataID": "118326",
        "id": "53106639",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:57",
        "brokerTime": "2025-05-14 15:13:57",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56064089",
        "positionId": "56064089",
        "volume": 9.96,
        "price": 3214.23,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3214.23,
        "doubleCheck": true
    },
    {
        "dataID": "118327",
        "id": "53106845",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:57",
        "brokerTime": "2025-05-14 15:13:57",
        "commission": -69.72,
        "swap": 0,
        "profit": -209.16,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56064173",
        "positionId": "56064089",
        "volume": 9.96,
        "price": 3214.44,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -278.88,
        "priceIn": 3214.23,
        "doubleCheck": true
    },
    {
        "dataID": "118328",
        "id": "53107041",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:58",
        "brokerTime": "2025-05-14 15:13:58",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56064311",
        "positionId": "56064311",
        "volume": 9.96,
        "price": 3214.43,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3214.43,
        "doubleCheck": true
    },
    {
        "dataID": "118329",
        "id": "53107327",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:58",
        "brokerTime": "2025-05-14 15:13:58",
        "commission": -69.72,
        "swap": 0,
        "profit": -189.24,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56064454",
        "positionId": "56064311",
        "volume": 9.96,
        "price": 3214.62,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -258.96000000000004,
        "priceIn": 3214.43,
        "doubleCheck": true
    },
    {
        "dataID": "118330",
        "id": "53107424",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:58",
        "brokerTime": "2025-05-14 15:13:58",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56064549",
        "positionId": "56064549",
        "volume": 9.96,
        "price": 3214.4,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3214.4,
        "doubleCheck": true
    },
    {
        "dataID": "118331",
        "id": "53107855",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:58",
        "brokerTime": "2025-05-14 15:13:59",
        "commission": -69.72,
        "swap": 0,
        "profit": -159.36,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56064732",
        "positionId": "56064549",
        "volume": 9.96,
        "price": 3214.56,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -229.08,
        "priceIn": 3214.4,
        "doubleCheck": true
    },
    {
        "dataID": "118332",
        "id": "53108184",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:59",
        "brokerTime": "2025-05-14 15:13:59",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56064935",
        "positionId": "56064935",
        "volume": 9.96,
        "price": 3214.29,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3214.29,
        "doubleCheck": true
    },
    {
        "dataID": "118333",
        "id": "53108389",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:59",
        "brokerTime": "2025-05-14 15:13:59",
        "commission": -69.72,
        "swap": 0,
        "profit": -258.96,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56065036",
        "positionId": "56064935",
        "volume": 9.96,
        "price": 3214.55,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -328.67999999999995,
        "priceIn": 3214.29,
        "doubleCheck": true
    },
    {
        "dataID": "118334",
        "id": "53108469",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:00",
        "brokerTime": "2025-05-14 15:14:00",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56065118",
        "positionId": "56065118",
        "volume": 9.96,
        "price": 3214.56,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3214.56,
        "doubleCheck": true
    },
    {
        "dataID": "118335",
        "id": "53108699",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:00",
        "brokerTime": "2025-05-14 15:14:00",
        "commission": -69.72,
        "swap": 0,
        "profit": -308.76,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56065217",
        "positionId": "56065118",
        "volume": 9.96,
        "price": 3214.87,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -378.48,
        "priceIn": 3214.56,
        "doubleCheck": true
    },
    {
        "dataID": "118336",
        "id": "53108800",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:00",
        "brokerTime": "2025-05-14 15:14:00",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56065306",
        "positionId": "56065306",
        "volume": 9.96,
        "price": 3214.51,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3214.51,
        "doubleCheck": true
    },
    {
        "dataID": "118337",
        "id": "53108919",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 15:14:00",
        "brokerTime": "2025-05-14 15:14:00",
        "commission": -0.98,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUEUR.PRO",
        "magic": "0",
        "orderId": "56065325",
        "positionId": "56065325",
        "volume": 0.14,
        "price": 2867.15,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2967.15,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.98,
        "priceIn": 2867.15,
        "doubleCheck": true
    },
    {
        "dataID": "118338",
        "id": "53109121",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:00",
        "brokerTime": "2025-05-14 15:14:01",
        "commission": -69.72,
        "swap": 0,
        "profit": -298.8,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56065473",
        "positionId": "56065306",
        "volume": 9.96,
        "price": 3214.81,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -368.52,
        "priceIn": 3214.51,
        "doubleCheck": true
    },
    {
        "dataID": "118339",
        "id": "53109408",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:01",
        "brokerTime": "2025-05-14 15:14:01",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56065598",
        "positionId": "56065598",
        "volume": 9.96,
        "price": 3214.43,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3214.43,
        "doubleCheck": true
    },
    {
        "dataID": "118340",
        "id": "53109730",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:01",
        "brokerTime": "2025-05-14 15:14:02",
        "commission": -69.72,
        "swap": 0,
        "profit": 69.72,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56065852",
        "positionId": "56065598",
        "volume": 9.96,
        "price": 3214.36,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 0,
        "priceIn": 3214.43,
        "doubleCheck": true
    },
    {
        "dataID": "118341",
        "id": "53109923",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:02",
        "brokerTime": "2025-05-14 15:14:02",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56065892",
        "positionId": "56065892",
        "volume": 9.96,
        "price": 3214.17,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3214.17,
        "doubleCheck": true
    },
    {
        "dataID": "118342",
        "id": "53110131",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:02",
        "brokerTime": "2025-05-14 15:14:03",
        "commission": -69.72,
        "swap": 0,
        "profit": -179.28,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56066030",
        "positionId": "56065892",
        "volume": 9.96,
        "price": 3214.35,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -249,
        "priceIn": 3214.17,
        "doubleCheck": true
    },
    {
        "dataID": "118343",
        "id": "53110225",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:03",
        "brokerTime": "2025-05-14 15:14:03",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56066113",
        "positionId": "56066113",
        "volume": 9.96,
        "price": 3214.18,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3214.18,
        "doubleCheck": true
    },
    {
        "dataID": "118344",
        "id": "53110444",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:03",
        "brokerTime": "2025-05-14 15:14:03",
        "commission": -69.72,
        "swap": 0,
        "profit": -109.56,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56066201",
        "positionId": "56066113",
        "volume": 9.96,
        "price": 3214.29,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -179.28,
        "priceIn": 3214.18,
        "doubleCheck": true
    },
    {
        "dataID": "118345",
        "id": "53110619",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:04",
        "brokerTime": "2025-05-14 15:14:04",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56066308",
        "positionId": "56066308",
        "volume": 9.96,
        "price": 3213.98,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3213.98,
        "doubleCheck": true
    },
    {
        "dataID": "118346",
        "id": "53111247",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:04",
        "brokerTime": "2025-05-14 15:14:04",
        "commission": -69.72,
        "swap": 0,
        "profit": -109.56,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56066647",
        "positionId": "56066308",
        "volume": 9.96,
        "price": 3214.09,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -179.28,
        "priceIn": 3213.98,
        "doubleCheck": true
    },
    {
        "dataID": "118347",
        "id": "53111403",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:05",
        "brokerTime": "2025-05-14 15:14:05",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56066727",
        "positionId": "56066727",
        "volume": 9.96,
        "price": 3213.85,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3213.85,
        "doubleCheck": true
    },
    {
        "dataID": "118348",
        "id": "53111493",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:05",
        "brokerTime": "2025-05-14 15:14:05",
        "commission": -69.72,
        "swap": 0,
        "profit": -199.2,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56066825",
        "positionId": "56066727",
        "volume": 9.96,
        "price": 3214.05,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -268.91999999999996,
        "priceIn": 3213.85,
        "doubleCheck": true
    },
    {
        "dataID": "118349",
        "id": "53111630",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:05",
        "brokerTime": "2025-05-14 15:14:05",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56066858",
        "positionId": "56066858",
        "volume": 9.96,
        "price": 3214.15,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3214.15,
        "doubleCheck": true
    },
    {
        "dataID": "118350",
        "id": "53111781",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:05",
        "brokerTime": "2025-05-14 15:14:06",
        "commission": -69.72,
        "swap": 0,
        "profit": -149.4,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56066937",
        "positionId": "56066858",
        "volume": 9.96,
        "price": 3214.3,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -219.12,
        "priceIn": 3214.15,
        "doubleCheck": true
    },
    {
        "dataID": "118351",
        "id": "53111798",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:06",
        "brokerTime": "2025-05-14 15:14:06",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56066956",
        "positionId": "56066956",
        "volume": 9.96,
        "price": 3214.09,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3214.09,
        "doubleCheck": true
    },
    {
        "dataID": "118352",
        "id": "53111859",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:06",
        "brokerTime": "2025-05-14 15:14:06",
        "commission": -69.72,
        "swap": 0,
        "profit": -59.76,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56066984",
        "positionId": "56066956",
        "volume": 9.96,
        "price": 3214.15,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -129.48,
        "priceIn": 3214.09,
        "doubleCheck": true
    },
    {
        "dataID": "118353",
        "id": "53111924",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:07",
        "brokerTime": "2025-05-14 15:14:07",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56067045",
        "positionId": "56067045",
        "volume": 9.96,
        "price": 3214.07,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3214.07,
        "doubleCheck": true
    },
    {
        "dataID": "118354",
        "id": "53112136",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:07",
        "brokerTime": "2025-05-14 15:14:07",
        "commission": -69.72,
        "swap": 0,
        "profit": -129.48,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56067131",
        "positionId": "56067045",
        "volume": 9.96,
        "price": 3214.2,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -199.2,
        "priceIn": 3214.07,
        "doubleCheck": true
    },
    {
        "dataID": "118355",
        "id": "53112250",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:08",
        "brokerTime": "2025-05-14 15:14:08",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56067247",
        "positionId": "56067247",
        "volume": 9.96,
        "price": 3213.85,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3213.85,
        "doubleCheck": true
    },
    {
        "dataID": "118356",
        "id": "53112444",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:08",
        "brokerTime": "2025-05-14 15:14:08",
        "commission": -69.72,
        "swap": 0,
        "profit": -179.28,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56067347",
        "positionId": "56067247",
        "volume": 9.96,
        "price": 3214.03,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -249,
        "priceIn": 3213.85,
        "doubleCheck": true
    },
    {
        "dataID": "118357",
        "id": "53112720",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:09",
        "brokerTime": "2025-05-14 15:14:09",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56067479",
        "positionId": "56067479",
        "volume": 9.96,
        "price": 3213.77,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3213.77,
        "doubleCheck": true
    },
    {
        "dataID": "118358",
        "id": "53113049",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:09",
        "brokerTime": "2025-05-14 15:14:09",
        "commission": -69.72,
        "swap": 0,
        "profit": -209.16,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56067675",
        "positionId": "56067479",
        "volume": 9.96,
        "price": 3213.98,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -278.88,
        "priceIn": 3213.77,
        "doubleCheck": true
    },
    {
        "dataID": "118359",
        "id": "53113417",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:10",
        "brokerTime": "2025-05-14 15:14:10",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56067845",
        "positionId": "56067845",
        "volume": 9.96,
        "price": 3213.43,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3213.43,
        "doubleCheck": true
    },
    {
        "dataID": "118360",
        "id": "53113437",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:10",
        "brokerTime": "2025-05-14 15:14:11",
        "commission": -69.72,
        "swap": 0,
        "profit": -79.68,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56067868",
        "positionId": "56067845",
        "volume": 9.96,
        "price": 3213.51,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -149.4,
        "priceIn": 3213.43,
        "doubleCheck": true
    },
    {
        "dataID": "118361",
        "id": "53113475",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:11",
        "brokerTime": "2025-05-14 15:14:11",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56067879",
        "positionId": "56067879",
        "volume": 9.96,
        "price": 3213.15,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3213.15,
        "doubleCheck": true
    },
    {
        "dataID": "118362",
        "id": "53113479",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:11",
        "brokerTime": "2025-05-14 15:14:11",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56067884",
        "positionId": "56067879",
        "volume": 9.96,
        "price": 3213.15,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3213.15,
        "doubleCheck": true
    },
    {
        "dataID": "118363",
        "id": "53113495",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:12",
        "brokerTime": "2025-05-14 15:14:12",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56067894",
        "positionId": "56067894",
        "volume": 9.96,
        "price": 3213.23,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3213.23,
        "doubleCheck": true
    },
    {
        "dataID": "118364",
        "id": "53113500",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:12",
        "brokerTime": "2025-05-14 15:14:12",
        "commission": -69.72,
        "swap": 0,
        "profit": -298.8,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56067896",
        "positionId": "56067894",
        "volume": 9.96,
        "price": 3213.53,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -368.52,
        "priceIn": 3213.23,
        "doubleCheck": true
    },
    {
        "dataID": "118365",
        "id": "53113503",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:13",
        "brokerTime": "2025-05-14 15:14:13",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56067899",
        "positionId": "56067899",
        "volume": 9.96,
        "price": 3213.31,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3213.31,
        "doubleCheck": true
    },
    {
        "dataID": "118366",
        "id": "53113510",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:13",
        "brokerTime": "2025-05-14 15:14:13",
        "commission": -69.72,
        "swap": 0,
        "profit": 19.92,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56067904",
        "positionId": "56067899",
        "volume": 9.96,
        "price": 3213.29,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49.8,
        "priceIn": 3213.31,
        "doubleCheck": true
    },
    {
        "dataID": "118367",
        "id": "53113513",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:13",
        "brokerTime": "2025-05-14 15:14:13",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56067906",
        "positionId": "56067906",
        "volume": 9.96,
        "price": 3212.96,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3212.96,
        "doubleCheck": true
    },
    {
        "dataID": "118368",
        "id": "53113517",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:13",
        "brokerTime": "2025-05-14 15:14:14",
        "commission": -69.72,
        "swap": 0,
        "profit": -49.8,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56067910",
        "positionId": "56067906",
        "volume": 9.96,
        "price": 3213.01,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -119.52,
        "priceIn": 3212.96,
        "doubleCheck": true
    },
    {
        "dataID": "118369",
        "id": "53113522",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:14",
        "brokerTime": "2025-05-14 15:14:14",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56067914",
        "positionId": "56067914",
        "volume": 9.96,
        "price": 3212.77,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3212.77,
        "doubleCheck": true
    },
    {
        "dataID": "118370",
        "id": "53113524",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:14",
        "brokerTime": "2025-05-14 15:14:15",
        "commission": -69.72,
        "swap": 0,
        "profit": -537.84,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56067916",
        "positionId": "56067914",
        "volume": 9.96,
        "price": 3213.31,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -607.5600000000001,
        "priceIn": 3212.77,
        "doubleCheck": true
    },
    {
        "dataID": "118371",
        "id": "53113606",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:15",
        "brokerTime": "2025-05-14 15:14:15",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068127",
        "positionId": "56068127",
        "volume": 9.96,
        "price": 3213.26,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3213.26,
        "doubleCheck": true
    },
    {
        "dataID": "118372",
        "id": "53113762",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:15",
        "brokerTime": "2025-05-14 15:14:16",
        "commission": -69.72,
        "swap": 0,
        "profit": -229.08,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068133",
        "positionId": "56068127",
        "volume": 9.96,
        "price": 3213.49,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -298.8,
        "priceIn": 3213.26,
        "doubleCheck": true
    },
    {
        "dataID": "118373",
        "id": "53113766",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:16",
        "brokerTime": "2025-05-14 15:14:16",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068137",
        "positionId": "56068137",
        "volume": 9.96,
        "price": 3213.45,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3213.45,
        "doubleCheck": true
    },
    {
        "dataID": "118374",
        "id": "53113785",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:16",
        "brokerTime": "2025-05-14 15:14:16",
        "commission": -69.72,
        "swap": 0,
        "profit": -408.36,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068154",
        "positionId": "56068137",
        "volume": 9.96,
        "price": 3213.86,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -478.08000000000004,
        "priceIn": 3213.45,
        "doubleCheck": true
    },
    {
        "dataID": "118375",
        "id": "53113788",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:17",
        "brokerTime": "2025-05-14 15:14:17",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068156",
        "positionId": "56068156",
        "volume": 9.96,
        "price": 3213.66,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3213.66,
        "doubleCheck": true
    },
    {
        "dataID": "118376",
        "id": "53113789",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:17",
        "brokerTime": "2025-05-14 15:14:17",
        "commission": -69.72,
        "swap": 0,
        "profit": 239.04,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068157",
        "positionId": "56068156",
        "volume": 9.96,
        "price": 3213.42,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 169.32,
        "priceIn": 3213.66,
        "doubleCheck": true
    },
    {
        "dataID": "118377",
        "id": "53113790",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:18",
        "brokerTime": "2025-05-14 15:14:18",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068158",
        "positionId": "56068158",
        "volume": 9.96,
        "price": 3213.33,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3213.33,
        "doubleCheck": true
    },
    {
        "dataID": "118378",
        "id": "53113791",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:18",
        "brokerTime": "2025-05-14 15:14:18",
        "commission": -69.72,
        "swap": 0,
        "profit": -308.76,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068159",
        "positionId": "56068158",
        "volume": 9.96,
        "price": 3213.64,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -378.48,
        "priceIn": 3213.33,
        "doubleCheck": true
    },
    {
        "dataID": "118379",
        "id": "53113792",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:18",
        "brokerTime": "2025-05-14 15:14:18",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068160",
        "positionId": "56068160",
        "volume": 9.96,
        "price": 3213.52,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3213.52,
        "doubleCheck": true
    },
    {
        "dataID": "118380",
        "id": "53113793",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:18",
        "brokerTime": "2025-05-14 15:14:19",
        "commission": -69.72,
        "swap": 0,
        "profit": -139.44,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068161",
        "positionId": "56068160",
        "volume": 9.96,
        "price": 3213.66,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -209.16,
        "priceIn": 3213.52,
        "doubleCheck": true
    },
    {
        "dataID": "118381",
        "id": "53113794",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:19",
        "brokerTime": "2025-05-14 15:14:19",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068162",
        "positionId": "56068162",
        "volume": 9.96,
        "price": 3213.41,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3213.41,
        "doubleCheck": true
    },
    {
        "dataID": "118382",
        "id": "53113795",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:19",
        "brokerTime": "2025-05-14 15:14:19",
        "commission": -69.72,
        "swap": 0,
        "profit": -169.32,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068163",
        "positionId": "56068162",
        "volume": 9.96,
        "price": 3213.58,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -239.04,
        "priceIn": 3213.41,
        "doubleCheck": true
    },
    {
        "dataID": "118383",
        "id": "53113796",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:20",
        "brokerTime": "2025-05-14 15:14:20",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068164",
        "positionId": "56068164",
        "volume": 9.96,
        "price": 3213.44,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3213.44,
        "doubleCheck": true
    },
    {
        "dataID": "118384",
        "id": "53113797",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:20",
        "brokerTime": "2025-05-14 15:14:20",
        "commission": -69.72,
        "swap": 0,
        "profit": -388.44,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068165",
        "positionId": "56068164",
        "volume": 9.96,
        "price": 3213.83,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -458.15999999999997,
        "priceIn": 3213.44,
        "doubleCheck": true
    },
    {
        "dataID": "118385",
        "id": "53113798",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:21",
        "brokerTime": "2025-05-14 15:14:21",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068166",
        "positionId": "56068166",
        "volume": 9.96,
        "price": 3213.52,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3213.52,
        "doubleCheck": true
    },
    {
        "dataID": "118386",
        "id": "53113800",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:21",
        "brokerTime": "2025-05-14 15:14:21",
        "commission": -69.72,
        "swap": 0,
        "profit": -139.44,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068168",
        "positionId": "56068166",
        "volume": 9.96,
        "price": 3213.66,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -209.16,
        "priceIn": 3213.52,
        "doubleCheck": true
    },
    {
        "dataID": "118387",
        "id": "53113802",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:22",
        "brokerTime": "2025-05-14 15:14:22",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068170",
        "positionId": "56068170",
        "volume": 9.96,
        "price": 3213.53,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3213.53,
        "doubleCheck": true
    },
    {
        "dataID": "118388",
        "id": "53113804",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:22",
        "brokerTime": "2025-05-14 15:14:23",
        "commission": -69.72,
        "swap": 0,
        "profit": -169.32,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068172",
        "positionId": "56068170",
        "volume": 9.96,
        "price": 3213.7,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -239.04,
        "priceIn": 3213.53,
        "doubleCheck": true
    },
    {
        "dataID": "118389",
        "id": "53113805",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:23",
        "brokerTime": "2025-05-14 15:14:23",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068173",
        "positionId": "56068173",
        "volume": 9.96,
        "price": 3213.48,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3213.48,
        "doubleCheck": true
    },
    {
        "dataID": "118390",
        "id": "53113806",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:23",
        "brokerTime": "2025-05-14 15:14:24",
        "commission": -69.72,
        "swap": 0,
        "profit": -239.04,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068174",
        "positionId": "56068173",
        "volume": 9.96,
        "price": 3213.72,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -308.76,
        "priceIn": 3213.48,
        "doubleCheck": true
    },
    {
        "dataID": "118391",
        "id": "53113807",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:24",
        "brokerTime": "2025-05-14 15:14:24",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068175",
        "positionId": "56068175",
        "volume": 9.96,
        "price": 3213.48,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3213.48,
        "doubleCheck": true
    },
    {
        "dataID": "118392",
        "id": "53113808",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:24",
        "brokerTime": "2025-05-14 15:14:24",
        "commission": -69.72,
        "swap": 0,
        "profit": -239.04,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068176",
        "positionId": "56068175",
        "volume": 9.96,
        "price": 3213.72,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -308.76,
        "priceIn": 3213.48,
        "doubleCheck": true
    },
    {
        "dataID": "118393",
        "id": "53113809",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:25",
        "brokerTime": "2025-05-14 15:14:25",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068177",
        "positionId": "56068177",
        "volume": 9.96,
        "price": 3213.56,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3213.56,
        "doubleCheck": true
    },
    {
        "dataID": "118394",
        "id": "53113811",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:25",
        "brokerTime": "2025-05-14 15:14:25",
        "commission": -69.72,
        "swap": 0,
        "profit": -298.8,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068179",
        "positionId": "56068177",
        "volume": 9.96,
        "price": 3213.86,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -368.52,
        "priceIn": 3213.56,
        "doubleCheck": true
    },
    {
        "dataID": "118395",
        "id": "53113813",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:25",
        "brokerTime": "2025-05-14 15:14:25",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068181",
        "positionId": "56068181",
        "volume": 9.96,
        "price": 3213.62,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3213.62,
        "doubleCheck": true
    },
    {
        "dataID": "118396",
        "id": "53113819",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:25",
        "brokerTime": "2025-05-14 15:14:26",
        "commission": -69.72,
        "swap": 0,
        "profit": -139.44,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068186",
        "positionId": "56068181",
        "volume": 9.96,
        "price": 3213.76,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -209.16,
        "priceIn": 3213.62,
        "doubleCheck": true
    },
    {
        "dataID": "118397",
        "id": "53113821",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:27",
        "brokerTime": "2025-05-14 15:14:27",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068188",
        "positionId": "56068188",
        "volume": 9.96,
        "price": 3213.42,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3213.42,
        "doubleCheck": true
    },
    {
        "dataID": "118398",
        "id": "53113825",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:27",
        "brokerTime": "2025-05-14 15:14:27",
        "commission": -69.72,
        "swap": 0,
        "profit": -129.48,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068192",
        "positionId": "56068188",
        "volume": 9.96,
        "price": 3213.55,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -199.2,
        "priceIn": 3213.42,
        "doubleCheck": true
    },
    {
        "dataID": "118399",
        "id": "53113827",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:27",
        "brokerTime": "2025-05-14 15:14:27",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068194",
        "positionId": "56068194",
        "volume": 9.96,
        "price": 3213.17,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3213.17,
        "doubleCheck": true
    },
    {
        "dataID": "118400",
        "id": "53113829",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:27",
        "brokerTime": "2025-05-14 15:14:28",
        "commission": -69.72,
        "swap": 0,
        "profit": -258.96,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068197",
        "positionId": "56068194",
        "volume": 9.96,
        "price": 3213.43,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -328.67999999999995,
        "priceIn": 3213.17,
        "doubleCheck": true
    },
    {
        "dataID": "118401",
        "id": "53113832",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:28",
        "brokerTime": "2025-05-14 15:14:28",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068199",
        "positionId": "56068199",
        "volume": 9.96,
        "price": 3213.16,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3213.16,
        "doubleCheck": true
    },
    {
        "dataID": "118402",
        "id": "53113834",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:28",
        "brokerTime": "2025-05-14 15:14:29",
        "commission": -69.72,
        "swap": 0,
        "profit": -189.24,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068201",
        "positionId": "56068199",
        "volume": 9.96,
        "price": 3213.35,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -258.96000000000004,
        "priceIn": 3213.16,
        "doubleCheck": true
    },
    {
        "dataID": "118403",
        "id": "53113836",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:29",
        "brokerTime": "2025-05-14 15:14:29",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068203",
        "positionId": "56068203",
        "volume": 9.96,
        "price": 3213.23,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3213.23,
        "doubleCheck": true
    },
    {
        "dataID": "118404",
        "id": "53113840",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:29",
        "brokerTime": "2025-05-14 15:14:30",
        "commission": -69.72,
        "swap": 0,
        "profit": -717.12,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068207",
        "positionId": "56068203",
        "volume": 9.96,
        "price": 3213.95,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -786.84,
        "priceIn": 3213.23,
        "doubleCheck": true
    },
    {
        "dataID": "118405",
        "id": "53113841",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:30",
        "brokerTime": "2025-05-14 15:14:30",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068208",
        "positionId": "56068208",
        "volume": 9.96,
        "price": 3213.72,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3213.72,
        "doubleCheck": true
    },
    {
        "dataID": "118406",
        "id": "53113842",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:30",
        "brokerTime": "2025-05-14 15:14:30",
        "commission": -69.72,
        "swap": 0,
        "profit": -239.04,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068209",
        "positionId": "56068208",
        "volume": 9.96,
        "price": 3213.96,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -308.76,
        "priceIn": 3213.72,
        "doubleCheck": true
    },
    {
        "dataID": "118407",
        "id": "53113843",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:31",
        "brokerTime": "2025-05-14 15:14:31",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068210",
        "positionId": "56068210",
        "volume": 9.96,
        "price": 3214.04,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3214.04,
        "doubleCheck": true
    },
    {
        "dataID": "118408",
        "id": "53113844",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:31",
        "brokerTime": "2025-05-14 15:14:31",
        "commission": -69.72,
        "swap": 0,
        "profit": -328.68,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068211",
        "positionId": "56068210",
        "volume": 9.96,
        "price": 3214.37,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -398.4,
        "priceIn": 3214.04,
        "doubleCheck": true
    },
    {
        "dataID": "118409",
        "id": "53113845",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:31",
        "brokerTime": "2025-05-14 15:14:31",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068212",
        "positionId": "56068212",
        "volume": 9.96,
        "price": 3214.08,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3214.08,
        "doubleCheck": true
    },
    {
        "dataID": "118410",
        "id": "53113847",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:31",
        "brokerTime": "2025-05-14 15:14:32",
        "commission": -69.72,
        "swap": 0,
        "profit": -229.08,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068214",
        "positionId": "56068212",
        "volume": 9.96,
        "price": 3214.31,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -298.8,
        "priceIn": 3214.08,
        "doubleCheck": true
    },
    {
        "dataID": "118411",
        "id": "53113848",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:33",
        "brokerTime": "2025-05-14 15:14:33",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068215",
        "positionId": "56068215",
        "volume": 9.96,
        "price": 3214.08,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3214.08,
        "doubleCheck": true
    },
    {
        "dataID": "118412",
        "id": "53113849",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:33",
        "brokerTime": "2025-05-14 15:14:33",
        "commission": -69.72,
        "swap": 0,
        "profit": -169.32,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068216",
        "positionId": "56068215",
        "volume": 9.96,
        "price": 3214.25,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -239.04,
        "priceIn": 3214.08,
        "doubleCheck": true
    },
    {
        "dataID": "118413",
        "id": "53113850",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:33",
        "brokerTime": "2025-05-14 15:14:33",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068217",
        "positionId": "56068217",
        "volume": 9.96,
        "price": 3213.99,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3213.99,
        "doubleCheck": true
    },
    {
        "dataID": "118414",
        "id": "53113851",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:33",
        "brokerTime": "2025-05-14 15:14:34",
        "commission": -69.72,
        "swap": 0,
        "profit": -328.68,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068218",
        "positionId": "56068217",
        "volume": 9.96,
        "price": 3214.32,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -398.4,
        "priceIn": 3213.99,
        "doubleCheck": true
    },
    {
        "dataID": "118415",
        "id": "53113852",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:34",
        "brokerTime": "2025-05-14 15:14:34",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068219",
        "positionId": "56068219",
        "volume": 9.96,
        "price": 3214.15,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3214.15,
        "doubleCheck": true
    },
    {
        "dataID": "118416",
        "id": "53113853",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:34",
        "brokerTime": "2025-05-14 15:14:35",
        "commission": -69.72,
        "swap": 0,
        "profit": -69.72,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068220",
        "positionId": "56068219",
        "volume": 9.96,
        "price": 3214.22,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -139.44,
        "priceIn": 3214.15,
        "doubleCheck": true
    },
    {
        "dataID": "118417",
        "id": "53113854",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:35",
        "brokerTime": "2025-05-14 15:14:35",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068221",
        "positionId": "56068221",
        "volume": 9.96,
        "price": 3213.95,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3213.95,
        "doubleCheck": true
    },
    {
        "dataID": "118418",
        "id": "53113855",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:35",
        "brokerTime": "2025-05-14 15:14:36",
        "commission": -69.72,
        "swap": 0,
        "profit": -229.08,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068222",
        "positionId": "56068221",
        "volume": 9.96,
        "price": 3214.18,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -298.8,
        "priceIn": 3213.95,
        "doubleCheck": true
    },
    {
        "dataID": "118419",
        "id": "53113856",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:37",
        "brokerTime": "2025-05-14 15:14:37",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068223",
        "positionId": "56068223",
        "volume": 9.96,
        "price": 3213.85,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3213.85,
        "doubleCheck": true
    },
    {
        "dataID": "118420",
        "id": "53113857",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:37",
        "brokerTime": "2025-05-14 15:14:38",
        "commission": -69.72,
        "swap": 0,
        "profit": -199.2,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068224",
        "positionId": "56068223",
        "volume": 9.96,
        "price": 3214.05,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -268.91999999999996,
        "priceIn": 3213.85,
        "doubleCheck": true
    },
    {
        "dataID": "118421",
        "id": "53113858",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:38",
        "brokerTime": "2025-05-14 15:14:38",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068225",
        "positionId": "56068225",
        "volume": 9.96,
        "price": 3213.84,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3213.84,
        "doubleCheck": true
    },
    {
        "dataID": "118422",
        "id": "53113859",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:38",
        "brokerTime": "2025-05-14 15:14:38",
        "commission": -69.72,
        "swap": 0,
        "profit": -239.04,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068226",
        "positionId": "56068225",
        "volume": 9.96,
        "price": 3214.08,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -308.76,
        "priceIn": 3213.84,
        "doubleCheck": true
    },
    {
        "dataID": "118423",
        "id": "53113860",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:39",
        "brokerTime": "2025-05-14 15:14:39",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068227",
        "positionId": "56068227",
        "volume": 9.96,
        "price": 3213.85,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3213.85,
        "doubleCheck": true
    },
    {
        "dataID": "118424",
        "id": "53113861",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:39",
        "brokerTime": "2025-05-14 15:14:39",
        "commission": -69.72,
        "swap": 0,
        "profit": -268.92,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068228",
        "positionId": "56068227",
        "volume": 9.96,
        "price": 3214.12,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -338.64,
        "priceIn": 3213.85,
        "doubleCheck": true
    },
    {
        "dataID": "118425",
        "id": "53113862",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:40",
        "brokerTime": "2025-05-14 15:14:40",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068229",
        "positionId": "56068229",
        "volume": 9.96,
        "price": 3213.95,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3213.95,
        "doubleCheck": true
    },
    {
        "dataID": "118426",
        "id": "53113863",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:40",
        "brokerTime": "2025-05-14 15:14:40",
        "commission": -69.72,
        "swap": 0,
        "profit": -368.52,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068230",
        "positionId": "56068229",
        "volume": 9.96,
        "price": 3214.32,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -438.24,
        "priceIn": 3213.95,
        "doubleCheck": true
    },
    {
        "dataID": "118427",
        "id": "53113864",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:40",
        "brokerTime": "2025-05-14 15:14:40",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068231",
        "positionId": "56068231",
        "volume": 9.96,
        "price": 3214.41,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3214.41,
        "doubleCheck": true
    },
    {
        "dataID": "118428",
        "id": "53113865",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:40",
        "brokerTime": "2025-05-14 15:14:41",
        "commission": -69.72,
        "swap": 0,
        "profit": -179.28,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068232",
        "positionId": "56068231",
        "volume": 9.96,
        "price": 3214.59,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -249,
        "priceIn": 3214.41,
        "doubleCheck": true
    },
    {
        "dataID": "118429",
        "id": "53113866",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:42",
        "brokerTime": "2025-05-14 15:14:42",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068233",
        "positionId": "56068233",
        "volume": 9.96,
        "price": 3214.58,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3214.58,
        "doubleCheck": true
    },
    {
        "dataID": "118430",
        "id": "53113867",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:42",
        "brokerTime": "2025-05-14 15:14:42",
        "commission": -69.72,
        "swap": 0,
        "profit": -338.64,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068234",
        "positionId": "56068233",
        "volume": 9.96,
        "price": 3214.92,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -408.36,
        "priceIn": 3214.58,
        "doubleCheck": true
    },
    {
        "dataID": "118431",
        "id": "53113868",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:42",
        "brokerTime": "2025-05-14 15:14:42",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068235",
        "positionId": "56068235",
        "volume": 9.96,
        "price": 3214.78,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3214.78,
        "doubleCheck": true
    },
    {
        "dataID": "118432",
        "id": "53113869",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:42",
        "brokerTime": "2025-05-14 15:14:43",
        "commission": -69.72,
        "swap": 0,
        "profit": -139.44,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068236",
        "positionId": "56068235",
        "volume": 9.96,
        "price": 3214.92,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -209.16,
        "priceIn": 3214.78,
        "doubleCheck": true
    },
    {
        "dataID": "118433",
        "id": "53113870",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:43",
        "brokerTime": "2025-05-14 15:14:43",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068237",
        "positionId": "56068237",
        "volume": 9.96,
        "price": 3214.9,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3214.9,
        "doubleCheck": true
    },
    {
        "dataID": "118434",
        "id": "53113871",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:43",
        "brokerTime": "2025-05-14 15:14:44",
        "commission": -69.72,
        "swap": 0,
        "profit": -149.4,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068238",
        "positionId": "56068237",
        "volume": 9.96,
        "price": 3215.05,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -219.12,
        "priceIn": 3214.9,
        "doubleCheck": true
    },
    {
        "dataID": "118435",
        "id": "53113872",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:44",
        "brokerTime": "2025-05-14 15:14:44",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068239",
        "positionId": "56068239",
        "volume": 9.96,
        "price": 3214.81,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3214.81,
        "doubleCheck": true
    },
    {
        "dataID": "118436",
        "id": "53113873",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:44",
        "brokerTime": "2025-05-14 15:14:45",
        "commission": -69.72,
        "swap": 0,
        "profit": -298.8,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068240",
        "positionId": "56068239",
        "volume": 9.96,
        "price": 3215.11,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -368.52,
        "priceIn": 3214.81,
        "doubleCheck": true
    },
    {
        "dataID": "118437",
        "id": "53113874",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:46",
        "brokerTime": "2025-05-14 15:14:46",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068241",
        "positionId": "56068241",
        "volume": 9.96,
        "price": 3214.93,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3214.93,
        "doubleCheck": true
    },
    {
        "dataID": "118438",
        "id": "53113875",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:46",
        "brokerTime": "2025-05-14 15:14:46",
        "commission": -69.72,
        "swap": 0,
        "profit": -209.16,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068242",
        "positionId": "56068241",
        "volume": 9.96,
        "price": 3215.14,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -278.88,
        "priceIn": 3214.93,
        "doubleCheck": true
    },
    {
        "dataID": "118439",
        "id": "53113876",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:46",
        "brokerTime": "2025-05-14 15:14:46",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068243",
        "positionId": "56068243",
        "volume": 9.96,
        "price": 3214.88,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3214.88,
        "doubleCheck": true
    },
    {
        "dataID": "118440",
        "id": "53113877",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:46",
        "brokerTime": "2025-05-14 15:14:47",
        "commission": -69.72,
        "swap": 0,
        "profit": 169.32,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068244",
        "positionId": "56068243",
        "volume": 9.96,
        "price": 3214.71,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 99.6,
        "priceIn": 3214.88,
        "doubleCheck": true
    },
    {
        "dataID": "118441",
        "id": "53113878",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:47",
        "brokerTime": "2025-05-14 15:14:47",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068245",
        "positionId": "56068245",
        "volume": 9.96,
        "price": 3214.3,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3214.3,
        "doubleCheck": true
    },
    {
        "dataID": "118442",
        "id": "53113879",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:47",
        "brokerTime": "2025-05-14 15:14:48",
        "commission": -69.72,
        "swap": 0,
        "profit": -378.48,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068246",
        "positionId": "56068245",
        "volume": 9.96,
        "price": 3214.68,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -448.20000000000005,
        "priceIn": 3214.3,
        "doubleCheck": true
    },
    {
        "dataID": "118443",
        "id": "53113880",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:48",
        "brokerTime": "2025-05-14 15:14:48",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068247",
        "positionId": "56068247",
        "volume": 9.96,
        "price": 3214.47,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3214.47,
        "doubleCheck": true
    },
    {
        "dataID": "118444",
        "id": "53113881",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:48",
        "brokerTime": "2025-05-14 15:14:48",
        "commission": -69.72,
        "swap": 0,
        "profit": -159.36,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068248",
        "positionId": "56068247",
        "volume": 9.96,
        "price": 3214.63,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -229.08,
        "priceIn": 3214.47,
        "doubleCheck": true
    },
    {
        "dataID": "118445",
        "id": "53113882",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:49",
        "brokerTime": "2025-05-14 15:14:49",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068249",
        "positionId": "56068249",
        "volume": 9.96,
        "price": 3214.39,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3214.39,
        "doubleCheck": true
    },
    {
        "dataID": "118446",
        "id": "53113883",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:49",
        "brokerTime": "2025-05-14 15:14:49",
        "commission": -69.72,
        "swap": 0,
        "profit": -468.12,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068250",
        "positionId": "56068249",
        "volume": 9.96,
        "price": 3214.86,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -537.84,
        "priceIn": 3214.39,
        "doubleCheck": true
    },
    {
        "dataID": "118447",
        "id": "53113884",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:50",
        "brokerTime": "2025-05-14 15:14:50",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068251",
        "positionId": "56068251",
        "volume": 9.96,
        "price": 3214.59,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3214.59,
        "doubleCheck": true
    },
    {
        "dataID": "118448",
        "id": "53113885",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:50",
        "brokerTime": "2025-05-14 15:14:50",
        "commission": -69.72,
        "swap": 0,
        "profit": -219.12,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068252",
        "positionId": "56068251",
        "volume": 9.96,
        "price": 3214.81,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -288.84000000000003,
        "priceIn": 3214.59,
        "doubleCheck": true
    },
    {
        "dataID": "118449",
        "id": "53113886",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:51",
        "brokerTime": "2025-05-14 15:14:51",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068253",
        "positionId": "56068253",
        "volume": 9.96,
        "price": 3214.79,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3214.79,
        "doubleCheck": true
    },
    {
        "dataID": "118450",
        "id": "53113887",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:51",
        "brokerTime": "2025-05-14 15:14:51",
        "commission": -69.72,
        "swap": 0,
        "profit": -99.6,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068254",
        "positionId": "56068253",
        "volume": 9.96,
        "price": 3214.89,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -169.32,
        "priceIn": 3214.79,
        "doubleCheck": true
    },
    {
        "dataID": "118451",
        "id": "53113888",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:51",
        "brokerTime": "2025-05-14 15:14:51",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068255",
        "positionId": "56068255",
        "volume": 9.96,
        "price": 3214.68,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3214.68,
        "doubleCheck": true
    },
    {
        "dataID": "118452",
        "id": "53113889",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:51",
        "brokerTime": "2025-05-14 15:14:52",
        "commission": -69.72,
        "swap": 0,
        "profit": -79.68,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068256",
        "positionId": "56068255",
        "volume": 9.96,
        "price": 3214.76,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -149.4,
        "priceIn": 3214.68,
        "doubleCheck": true
    },
    {
        "dataID": "118453",
        "id": "53113890",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:52",
        "brokerTime": "2025-05-14 15:14:52",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068257",
        "positionId": "56068257",
        "volume": 9.96,
        "price": 3214.41,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3214.41,
        "doubleCheck": true
    },
    {
        "dataID": "118454",
        "id": "53113891",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:52",
        "brokerTime": "2025-05-14 15:14:53",
        "commission": -69.72,
        "swap": 0,
        "profit": -149.4,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068258",
        "positionId": "56068257",
        "volume": 9.96,
        "price": 3214.56,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -219.12,
        "priceIn": 3214.41,
        "doubleCheck": true
    },
    {
        "dataID": "118455",
        "id": "53113892",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:53",
        "brokerTime": "2025-05-14 15:14:53",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068259",
        "positionId": "56068259",
        "volume": 9.96,
        "price": 3214.46,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3214.46,
        "doubleCheck": true
    },
    {
        "dataID": "118456",
        "id": "53113893",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:53",
        "brokerTime": "2025-05-14 15:14:53",
        "commission": -69.72,
        "swap": 0,
        "profit": -69.72,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068260",
        "positionId": "56068259",
        "volume": 9.96,
        "price": 3214.53,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -139.44,
        "priceIn": 3214.46,
        "doubleCheck": true
    },
    {
        "dataID": "118457",
        "id": "53113894",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:53",
        "brokerTime": "2025-05-14 15:14:53",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068261",
        "positionId": "56068261",
        "volume": 9.96,
        "price": 3214.06,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3214.06,
        "doubleCheck": true
    },
    {
        "dataID": "118458",
        "id": "53113895",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:53",
        "brokerTime": "2025-05-14 15:14:54",
        "commission": -69.72,
        "swap": 0,
        "profit": 19.92,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068262",
        "positionId": "56068261",
        "volume": 9.96,
        "price": 3214.04,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -49.8,
        "priceIn": 3214.06,
        "doubleCheck": true
    },
    {
        "dataID": "118459",
        "id": "53113896",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:54",
        "brokerTime": "2025-05-14 15:14:54",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068263",
        "positionId": "56068263",
        "volume": 9.96,
        "price": 3214.08,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3214.08,
        "doubleCheck": true
    },
    {
        "dataID": "118460",
        "id": "53113897",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:54",
        "brokerTime": "2025-05-14 15:14:54",
        "commission": -69.72,
        "swap": 0,
        "profit": -39.84,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068264",
        "positionId": "56068263",
        "volume": 9.96,
        "price": 3214.12,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -109.56,
        "priceIn": 3214.08,
        "doubleCheck": true
    },
    {
        "dataID": "118461",
        "id": "53113898",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:55",
        "brokerTime": "2025-05-14 15:14:55",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068265",
        "positionId": "56068265",
        "volume": 9.96,
        "price": 3214.07,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3214.07,
        "doubleCheck": true
    },
    {
        "dataID": "118462",
        "id": "53113899",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:55",
        "brokerTime": "2025-05-14 15:14:55",
        "commission": -69.72,
        "swap": 0,
        "profit": -109.56,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068266",
        "positionId": "56068265",
        "volume": 9.96,
        "price": 3214.18,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -179.28,
        "priceIn": 3214.07,
        "doubleCheck": true
    },
    {
        "dataID": "118463",
        "id": "53113900",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:55",
        "brokerTime": "2025-05-14 15:14:55",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068267",
        "positionId": "56068267",
        "volume": 9.96,
        "price": 3213.97,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3213.97,
        "doubleCheck": true
    },
    {
        "dataID": "118464",
        "id": "53113901",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:55",
        "brokerTime": "2025-05-14 15:14:56",
        "commission": -69.72,
        "swap": 0,
        "profit": -99.6,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068268",
        "positionId": "56068267",
        "volume": 9.96,
        "price": 3214.07,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -169.32,
        "priceIn": 3213.97,
        "doubleCheck": true
    },
    {
        "dataID": "118465",
        "id": "53113902",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:56",
        "brokerTime": "2025-05-14 15:14:56",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068269",
        "positionId": "56068269",
        "volume": 9.96,
        "price": 3213.83,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3213.83,
        "doubleCheck": true
    },
    {
        "dataID": "118466",
        "id": "53113903",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:56",
        "brokerTime": "2025-05-14 15:14:57",
        "commission": -69.72,
        "swap": 0,
        "profit": -209.16,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068270",
        "positionId": "56068269",
        "volume": 9.96,
        "price": 3214.04,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -278.88,
        "priceIn": 3213.83,
        "doubleCheck": true
    },
    {
        "dataID": "118467",
        "id": "53113904",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:57",
        "brokerTime": "2025-05-14 15:14:57",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068271",
        "positionId": "56068271",
        "volume": 9.96,
        "price": 3213.38,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3213.38,
        "doubleCheck": true
    },
    {
        "dataID": "118468",
        "id": "53113905",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:57",
        "brokerTime": "2025-05-14 15:14:58",
        "commission": -69.72,
        "swap": 0,
        "profit": -179.28,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068272",
        "positionId": "56068271",
        "volume": 9.96,
        "price": 3213.56,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -249,
        "priceIn": 3213.38,
        "doubleCheck": true
    },
    {
        "dataID": "118469",
        "id": "53113906",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:58",
        "brokerTime": "2025-05-14 15:14:58",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068273",
        "positionId": "56068273",
        "volume": 9.96,
        "price": 3213.36,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3213.36,
        "doubleCheck": true
    },
    {
        "dataID": "118470",
        "id": "53113907",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:58",
        "brokerTime": "2025-05-14 15:14:59",
        "commission": -69.72,
        "swap": 0,
        "profit": -219.12,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068274",
        "positionId": "56068273",
        "volume": 9.96,
        "price": 3213.58,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -288.84000000000003,
        "priceIn": 3213.36,
        "doubleCheck": true
    },
    {
        "dataID": "118471",
        "id": "53113908",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:59",
        "brokerTime": "2025-05-14 15:14:59",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068275",
        "positionId": "56068275",
        "volume": 9.96,
        "price": 3213.43,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3213.43,
        "doubleCheck": true
    },
    {
        "dataID": "118472",
        "id": "53113909",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:59",
        "brokerTime": "2025-05-14 15:15:00",
        "commission": -69.72,
        "swap": 0,
        "profit": -209.16,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068276",
        "positionId": "56068275",
        "volume": 9.96,
        "price": 3213.64,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -278.88,
        "priceIn": 3213.43,
        "doubleCheck": true
    },
    {
        "dataID": "118473",
        "id": "53113910",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:00",
        "brokerTime": "2025-05-14 15:15:00",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068277",
        "positionId": "56068277",
        "volume": 9.96,
        "price": 3213.59,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3213.59,
        "doubleCheck": true
    },
    {
        "dataID": "118474",
        "id": "53113937",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 15:15:01",
        "brokerTime": "2025-05-14 15:15:01",
        "commission": -1.19,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUEUR.PRO",
        "magic": "0",
        "orderId": "56068304",
        "positionId": "56068304",
        "volume": 0.17,
        "price": 2865.96,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2966.07,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -1.19,
        "priceIn": 2865.96,
        "doubleCheck": true
    },
    {
        "dataID": "118475",
        "id": "53113938",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:00",
        "brokerTime": "2025-05-14 15:15:01",
        "commission": -69.72,
        "swap": 0,
        "profit": 219.12,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068305",
        "positionId": "56068277",
        "volume": 9.96,
        "price": 3213.37,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 149.4,
        "priceIn": 3213.59,
        "doubleCheck": true
    },
    {
        "dataID": "118476",
        "id": "53113945",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:02",
        "brokerTime": "2025-05-14 15:15:02",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068312",
        "positionId": "56068312",
        "volume": 9.96,
        "price": 3212.99,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3212.99,
        "doubleCheck": true
    },
    {
        "dataID": "118477",
        "id": "53113947",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:02",
        "brokerTime": "2025-05-14 15:15:04",
        "commission": -69.72,
        "swap": 0,
        "profit": -308.76,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068314",
        "positionId": "56068312",
        "volume": 9.96,
        "price": 3213.3,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -378.48,
        "priceIn": 3212.99,
        "doubleCheck": true
    },
    {
        "dataID": "118478",
        "id": "53113948",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:04",
        "brokerTime": "2025-05-14 15:15:04",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068315",
        "positionId": "56068315",
        "volume": 9.96,
        "price": 3212.98,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3212.98,
        "doubleCheck": true
    },
    {
        "dataID": "118479",
        "id": "53113952",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:04",
        "brokerTime": "2025-05-14 15:15:05",
        "commission": -69.72,
        "swap": 0,
        "profit": -209.16,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068319",
        "positionId": "56068315",
        "volume": 9.96,
        "price": 3213.19,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -278.88,
        "priceIn": 3212.98,
        "doubleCheck": true
    },
    {
        "dataID": "118480",
        "id": "53113953",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:06",
        "brokerTime": "2025-05-14 15:15:06",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068320",
        "positionId": "56068320",
        "volume": 9.96,
        "price": 3212.92,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3212.92,
        "doubleCheck": true
    },
    {
        "dataID": "118481",
        "id": "53113954",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:06",
        "brokerTime": "2025-05-14 15:15:06",
        "commission": -69.72,
        "swap": 0,
        "profit": -189.24,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068321",
        "positionId": "56068320",
        "volume": 9.96,
        "price": 3213.11,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -258.96000000000004,
        "priceIn": 3212.92,
        "doubleCheck": true
    },
    {
        "dataID": "118482",
        "id": "53113956",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:07",
        "brokerTime": "2025-05-14 15:15:07",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068324",
        "positionId": "56068324",
        "volume": 9.96,
        "price": 3212.98,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3212.98,
        "doubleCheck": true
    },
    {
        "dataID": "118483",
        "id": "53113960",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:07",
        "brokerTime": "2025-05-14 15:15:07",
        "commission": -69.72,
        "swap": 0,
        "profit": -766.92,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068326",
        "positionId": "56068324",
        "volume": 9.96,
        "price": 3213.75,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -836.64,
        "priceIn": 3212.98,
        "doubleCheck": true
    },
    {
        "dataID": "118484",
        "id": "53113962",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:08",
        "brokerTime": "2025-05-14 15:15:08",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068327",
        "positionId": "56068327",
        "volume": 9.96,
        "price": 3213.73,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3213.73,
        "doubleCheck": true
    },
    {
        "dataID": "118485",
        "id": "53113963",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:08",
        "brokerTime": "2025-05-14 15:15:09",
        "commission": -69.72,
        "swap": 0,
        "profit": -358.56,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068328",
        "positionId": "56068327",
        "volume": 9.96,
        "price": 3214.09,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -428.28,
        "priceIn": 3213.73,
        "doubleCheck": true
    },
    {
        "dataID": "118486",
        "id": "53113964",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:09",
        "brokerTime": "2025-05-14 15:15:09",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068329",
        "positionId": "56068329",
        "volume": 9.96,
        "price": 3213.87,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3213.87,
        "doubleCheck": true
    },
    {
        "dataID": "118487",
        "id": "53113965",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:09",
        "brokerTime": "2025-05-14 15:15:09",
        "commission": -69.72,
        "swap": 0,
        "profit": -597.6,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068330",
        "positionId": "56068329",
        "volume": 9.96,
        "price": 3214.47,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -667.32,
        "priceIn": 3213.87,
        "doubleCheck": true
    },
    {
        "dataID": "118488",
        "id": "53113966",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:10",
        "brokerTime": "2025-05-14 15:15:10",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068331",
        "positionId": "56068331",
        "volume": 9.96,
        "price": 3214.24,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3214.24,
        "doubleCheck": true
    },
    {
        "dataID": "118489",
        "id": "53113968",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:10",
        "brokerTime": "2025-05-14 15:15:10",
        "commission": -69.72,
        "swap": 0,
        "profit": 89.64,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068333",
        "positionId": "56068331",
        "volume": 9.96,
        "price": 3214.15,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 19.92,
        "priceIn": 3214.24,
        "doubleCheck": true
    },
    {
        "dataID": "118490",
        "id": "53113969",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:11",
        "brokerTime": "2025-05-14 15:15:11",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068334",
        "positionId": "56068334",
        "volume": 9.96,
        "price": 3214,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3214,
        "doubleCheck": true
    },
    {
        "dataID": "118491",
        "id": "53113970",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:11",
        "brokerTime": "2025-05-14 15:15:11",
        "commission": -69.72,
        "swap": 0,
        "profit": -159.36,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068335",
        "positionId": "56068334",
        "volume": 9.96,
        "price": 3214.16,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -229.08,
        "priceIn": 3214,
        "doubleCheck": true
    },
    {
        "dataID": "118492",
        "id": "53113971",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:11",
        "brokerTime": "2025-05-14 15:15:11",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068336",
        "positionId": "56068336",
        "volume": 9.96,
        "price": 3214.03,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3214.03,
        "doubleCheck": true
    },
    {
        "dataID": "118493",
        "id": "53113972",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:11",
        "brokerTime": "2025-05-14 15:15:12",
        "commission": -69.72,
        "swap": 0,
        "profit": -89.64,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068337",
        "positionId": "56068336",
        "volume": 9.96,
        "price": 3214.12,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -159.36,
        "priceIn": 3214.03,
        "doubleCheck": true
    },
    {
        "dataID": "118494",
        "id": "53113973",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:12",
        "brokerTime": "2025-05-14 15:15:12",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068338",
        "positionId": "56068338",
        "volume": 9.96,
        "price": 3213.87,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3213.87,
        "doubleCheck": true
    },
    {
        "dataID": "118495",
        "id": "53113975",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:12",
        "brokerTime": "2025-05-14 15:15:13",
        "commission": -69.72,
        "swap": 0,
        "profit": -229.08,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068340",
        "positionId": "56068338",
        "volume": 9.96,
        "price": 3214.1,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -298.8,
        "priceIn": 3213.87,
        "doubleCheck": true
    },
    {
        "dataID": "118496",
        "id": "53113976",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:13",
        "brokerTime": "2025-05-14 15:15:13",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068341",
        "positionId": "56068341",
        "volume": 9.96,
        "price": 3213.89,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3213.89,
        "doubleCheck": true
    },
    {
        "dataID": "118497",
        "id": "53113977",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:13",
        "brokerTime": "2025-05-14 15:15:13",
        "commission": -69.72,
        "swap": 0,
        "profit": -378.48,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068342",
        "positionId": "56068341",
        "volume": 9.96,
        "price": 3214.27,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -448.20000000000005,
        "priceIn": 3213.89,
        "doubleCheck": true
    },
    {
        "dataID": "118498",
        "id": "53113978",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:13",
        "brokerTime": "2025-05-14 15:15:13",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068343",
        "positionId": "56068343",
        "volume": 9.96,
        "price": 3214.04,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3214.04,
        "doubleCheck": true
    },
    {
        "dataID": "118499",
        "id": "53113979",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:13",
        "brokerTime": "2025-05-14 15:15:14",
        "commission": -69.72,
        "swap": 0,
        "profit": 49.8,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068344",
        "positionId": "56068343",
        "volume": 9.96,
        "price": 3213.99,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -19.92,
        "priceIn": 3214.04,
        "doubleCheck": true
    },
    {
        "dataID": "118500",
        "id": "53113980",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:14",
        "brokerTime": "2025-05-14 15:15:14",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068345",
        "positionId": "56068345",
        "volume": 9.96,
        "price": 3213.83,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3213.83,
        "doubleCheck": true
    },
    {
        "dataID": "118501",
        "id": "53113981",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:14",
        "brokerTime": "2025-05-14 15:15:15",
        "commission": -69.72,
        "swap": 0,
        "profit": -139.44,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068346",
        "positionId": "56068345",
        "volume": 9.96,
        "price": 3213.97,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -209.16,
        "priceIn": 3213.83,
        "doubleCheck": true
    },
    {
        "dataID": "118502",
        "id": "53113982",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:15",
        "brokerTime": "2025-05-14 15:15:15",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068347",
        "positionId": "56068347",
        "volume": 9.96,
        "price": 3213.76,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3213.76,
        "doubleCheck": true
    },
    {
        "dataID": "118503",
        "id": "53113983",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:15",
        "brokerTime": "2025-05-14 15:15:15",
        "commission": -69.72,
        "swap": 0,
        "profit": -149.4,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068348",
        "positionId": "56068347",
        "volume": 9.96,
        "price": 3213.91,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -219.12,
        "priceIn": 3213.76,
        "doubleCheck": true
    },
    {
        "dataID": "118504",
        "id": "53113984",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:16",
        "brokerTime": "2025-05-14 15:15:16",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068349",
        "positionId": "56068349",
        "volume": 9.96,
        "price": 3213.7,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3213.7,
        "doubleCheck": true
    },
    {
        "dataID": "118505",
        "id": "53113985",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:16",
        "brokerTime": "2025-05-14 15:15:17",
        "commission": -69.72,
        "swap": 0,
        "profit": -109.56,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068352",
        "positionId": "56068349",
        "volume": 9.96,
        "price": 3213.81,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -179.28,
        "priceIn": 3213.7,
        "doubleCheck": true
    },
    {
        "dataID": "118506",
        "id": "53113986",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:17",
        "brokerTime": "2025-05-14 15:15:17",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068353",
        "positionId": "56068353",
        "volume": 9.96,
        "price": 3213.33,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3213.33,
        "doubleCheck": true
    },
    {
        "dataID": "118507",
        "id": "53113987",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:17",
        "brokerTime": "2025-05-14 15:15:18",
        "commission": -69.72,
        "swap": 0,
        "profit": -517.92,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068354",
        "positionId": "56068353",
        "volume": 9.96,
        "price": 3213.85,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -587.64,
        "priceIn": 3213.33,
        "doubleCheck": true
    },
    {
        "dataID": "118508",
        "id": "53113988",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:18",
        "brokerTime": "2025-05-14 15:15:18",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068355",
        "positionId": "56068355",
        "volume": 9.96,
        "price": 3213.74,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3213.74,
        "doubleCheck": true
    },
    {
        "dataID": "118509",
        "id": "53113989",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:18",
        "brokerTime": "2025-05-14 15:15:19",
        "commission": -69.72,
        "swap": 0,
        "profit": -338.64,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068356",
        "positionId": "56068355",
        "volume": 9.96,
        "price": 3214.08,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -408.36,
        "priceIn": 3213.74,
        "doubleCheck": true
    },
    {
        "dataID": "118510",
        "id": "53113990",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:19",
        "brokerTime": "2025-05-14 15:15:19",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068357",
        "positionId": "56068357",
        "volume": 9.96,
        "price": 3213.67,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3213.67,
        "doubleCheck": true
    },
    {
        "dataID": "118511",
        "id": "53113991",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:19",
        "brokerTime": "2025-05-14 15:15:20",
        "commission": -69.72,
        "swap": 0,
        "profit": -49.8,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068358",
        "positionId": "56068357",
        "volume": 9.96,
        "price": 3213.72,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -119.52,
        "priceIn": 3213.67,
        "doubleCheck": true
    },
    {
        "dataID": "118512",
        "id": "53113992",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:20",
        "brokerTime": "2025-05-14 15:15:20",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068359",
        "positionId": "56068359",
        "volume": 9.96,
        "price": 3213.53,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3213.53,
        "doubleCheck": true
    },
    {
        "dataID": "118513",
        "id": "53113993",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:20",
        "brokerTime": "2025-05-14 15:15:21",
        "commission": -69.72,
        "swap": 0,
        "profit": -478.08,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068360",
        "positionId": "56068359",
        "volume": 9.96,
        "price": 3214.01,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -547.8,
        "priceIn": 3213.53,
        "doubleCheck": true
    },
    {
        "dataID": "118514",
        "id": "53113994",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:21",
        "brokerTime": "2025-05-14 15:15:21",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068361",
        "positionId": "56068361",
        "volume": 9.96,
        "price": 3213.98,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3213.98,
        "doubleCheck": true
    },
    {
        "dataID": "118515",
        "id": "53113995",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:21",
        "brokerTime": "2025-05-14 15:15:22",
        "commission": -69.72,
        "swap": 0,
        "profit": -488.04,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068362",
        "positionId": "56068361",
        "volume": 9.96,
        "price": 3214.47,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -557.76,
        "priceIn": 3213.98,
        "doubleCheck": true
    },
    {
        "dataID": "118516",
        "id": "53113996",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:22",
        "brokerTime": "2025-05-14 15:15:22",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068363",
        "positionId": "56068363",
        "volume": 9.96,
        "price": 3214.28,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3214.28,
        "doubleCheck": true
    },
    {
        "dataID": "118517",
        "id": "53113997",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:22",
        "brokerTime": "2025-05-14 15:15:23",
        "commission": -69.72,
        "swap": 0,
        "profit": -418.32,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068364",
        "positionId": "56068363",
        "volume": 9.96,
        "price": 3214.7,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -488.03999999999996,
        "priceIn": 3214.28,
        "doubleCheck": true
    },
    {
        "dataID": "118518",
        "id": "53113998",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:23",
        "brokerTime": "2025-05-14 15:15:23",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068365",
        "positionId": "56068365",
        "volume": 9.96,
        "price": 3214.56,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3214.56,
        "doubleCheck": true
    },
    {
        "dataID": "118519",
        "id": "53114000",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:23",
        "brokerTime": "2025-05-14 15:15:24",
        "commission": -69.72,
        "swap": 0,
        "profit": -468.12,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068367",
        "positionId": "56068365",
        "volume": 9.96,
        "price": 3215.03,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -537.84,
        "priceIn": 3214.56,
        "doubleCheck": true
    },
    {
        "dataID": "118520",
        "id": "53114001",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:24",
        "brokerTime": "2025-05-14 15:15:24",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068368",
        "positionId": "56068368",
        "volume": 9.96,
        "price": 3214.82,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3214.82,
        "doubleCheck": true
    },
    {
        "dataID": "118521",
        "id": "53114002",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:24",
        "brokerTime": "2025-05-14 15:15:24",
        "commission": -69.72,
        "swap": 0,
        "profit": -308.76,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068369",
        "positionId": "56068368",
        "volume": 9.96,
        "price": 3215.13,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -378.48,
        "priceIn": 3214.82,
        "doubleCheck": true
    },
    {
        "dataID": "118522",
        "id": "53114003",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:25",
        "brokerTime": "2025-05-14 15:15:25",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068370",
        "positionId": "56068370",
        "volume": 9.96,
        "price": 3214.66,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3214.66,
        "doubleCheck": true
    },
    {
        "dataID": "118523",
        "id": "53114004",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:25",
        "brokerTime": "2025-05-14 15:15:25",
        "commission": -69.72,
        "swap": 0,
        "profit": -388.44,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068371",
        "positionId": "56068370",
        "volume": 9.96,
        "price": 3215.05,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -458.15999999999997,
        "priceIn": 3214.66,
        "doubleCheck": true
    },
    {
        "dataID": "118524",
        "id": "53114005",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:25",
        "brokerTime": "2025-05-14 15:15:25",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068372",
        "positionId": "56068372",
        "volume": 9.96,
        "price": 3214.87,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3214.87,
        "doubleCheck": true
    },
    {
        "dataID": "118525",
        "id": "53114006",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:25",
        "brokerTime": "2025-05-14 15:15:26",
        "commission": -69.72,
        "swap": 0,
        "profit": -219.12,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068373",
        "positionId": "56068372",
        "volume": 9.96,
        "price": 3215.09,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -288.84000000000003,
        "priceIn": 3214.87,
        "doubleCheck": true
    },
    {
        "dataID": "118526",
        "id": "53114007",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:26",
        "brokerTime": "2025-05-14 15:15:26",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068374",
        "positionId": "56068374",
        "volume": 9.96,
        "price": 3214.87,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3214.87,
        "doubleCheck": true
    },
    {
        "dataID": "118527",
        "id": "53114009",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:26",
        "brokerTime": "2025-05-14 15:15:27",
        "commission": -69.72,
        "swap": 0,
        "profit": -488.04,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068376",
        "positionId": "56068374",
        "volume": 9.96,
        "price": 3215.36,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -557.76,
        "priceIn": 3214.87,
        "doubleCheck": true
    },
    {
        "dataID": "118528",
        "id": "53114010",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:27",
        "brokerTime": "2025-05-14 15:15:27",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068377",
        "positionId": "56068377",
        "volume": 9.96,
        "price": 3214.93,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3214.93,
        "doubleCheck": true
    },
    {
        "dataID": "118529",
        "id": "53114011",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:27",
        "brokerTime": "2025-05-14 15:15:28",
        "commission": -69.72,
        "swap": 0,
        "profit": -139.44,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068378",
        "positionId": "56068377",
        "volume": 9.96,
        "price": 3215.07,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -209.16,
        "priceIn": 3214.93,
        "doubleCheck": true
    },
    {
        "dataID": "118530",
        "id": "53114012",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:28",
        "brokerTime": "2025-05-14 15:15:28",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068380",
        "positionId": "56068380",
        "volume": 9.96,
        "price": 3214.81,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3214.81,
        "doubleCheck": true
    },
    {
        "dataID": "118531",
        "id": "53114014",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:28",
        "brokerTime": "2025-05-14 15:15:29",
        "commission": -69.72,
        "swap": 0,
        "profit": -149.4,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068381",
        "positionId": "56068380",
        "volume": 9.96,
        "price": 3214.96,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -219.12,
        "priceIn": 3214.81,
        "doubleCheck": true
    },
    {
        "dataID": "118532",
        "id": "53114015",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:29",
        "brokerTime": "2025-05-14 15:15:29",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068382",
        "positionId": "56068382",
        "volume": 9.96,
        "price": 3214.64,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3214.64,
        "doubleCheck": true
    },
    {
        "dataID": "118533",
        "id": "53114016",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:29",
        "brokerTime": "2025-05-14 15:15:29",
        "commission": -69.72,
        "swap": 0,
        "profit": -179.28,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068383",
        "positionId": "56068382",
        "volume": 9.96,
        "price": 3214.82,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -249,
        "priceIn": 3214.64,
        "doubleCheck": true
    },
    {
        "dataID": "118534",
        "id": "53114017",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:29",
        "brokerTime": "2025-05-14 15:15:29",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068384",
        "positionId": "56068384",
        "volume": 9.96,
        "price": 3214.61,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3214.61,
        "doubleCheck": true
    },
    {
        "dataID": "118535",
        "id": "53114018",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:29",
        "brokerTime": "2025-05-14 15:15:30",
        "commission": -69.72,
        "swap": 0,
        "profit": -308.76,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068385",
        "positionId": "56068384",
        "volume": 9.96,
        "price": 3214.92,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -378.48,
        "priceIn": 3214.61,
        "doubleCheck": true
    },
    {
        "dataID": "118536",
        "id": "53114019",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:30",
        "brokerTime": "2025-05-14 15:15:30",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068386",
        "positionId": "56068386",
        "volume": 9.96,
        "price": 3214.68,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3214.68,
        "doubleCheck": true
    },
    {
        "dataID": "118537",
        "id": "53114020",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:30",
        "brokerTime": "2025-05-14 15:15:30",
        "commission": -69.72,
        "swap": 0,
        "profit": -239.04,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068387",
        "positionId": "56068386",
        "volume": 9.96,
        "price": 3214.92,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -308.76,
        "priceIn": 3214.68,
        "doubleCheck": true
    },
    {
        "dataID": "118538",
        "id": "53114021",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:31",
        "brokerTime": "2025-05-14 15:15:31",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068388",
        "positionId": "56068388",
        "volume": 9.96,
        "price": 3214.71,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3214.71,
        "doubleCheck": true
    },
    {
        "dataID": "118539",
        "id": "53114022",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:31",
        "brokerTime": "2025-05-14 15:15:31",
        "commission": -69.72,
        "swap": 0,
        "profit": -189.24,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068389",
        "positionId": "56068388",
        "volume": 9.96,
        "price": 3214.9,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -258.96000000000004,
        "priceIn": 3214.71,
        "doubleCheck": true
    },
    {
        "dataID": "118540",
        "id": "53114023",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:31",
        "brokerTime": "2025-05-14 15:15:31",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068390",
        "positionId": "56068390",
        "volume": 9.96,
        "price": 3214.63,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3214.63,
        "doubleCheck": true
    },
    {
        "dataID": "118541",
        "id": "53114025",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:31",
        "brokerTime": "2025-05-14 15:15:33",
        "commission": -69.72,
        "swap": 0,
        "profit": -139.44,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068392",
        "positionId": "56068390",
        "volume": 9.96,
        "price": 3214.77,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -209.16,
        "priceIn": 3214.63,
        "doubleCheck": true
    },
    {
        "dataID": "118542",
        "id": "53114026",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:33",
        "brokerTime": "2025-05-14 15:15:33",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068393",
        "positionId": "56068393",
        "volume": 9.96,
        "price": 3214.56,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3214.56,
        "doubleCheck": true
    },
    {
        "dataID": "118543",
        "id": "53114027",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:33",
        "brokerTime": "2025-05-14 15:15:33",
        "commission": -69.72,
        "swap": 0,
        "profit": -79.68,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068394",
        "positionId": "56068393",
        "volume": 9.96,
        "price": 3214.64,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -149.4,
        "priceIn": 3214.56,
        "doubleCheck": true
    },
    {
        "dataID": "118544",
        "id": "53114029",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:34",
        "brokerTime": "2025-05-14 15:15:34",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068396",
        "positionId": "56068396",
        "volume": 9.96,
        "price": 3214.38,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3214.38,
        "doubleCheck": true
    },
    {
        "dataID": "118545",
        "id": "53114030",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:34",
        "brokerTime": "2025-05-14 15:15:34",
        "commission": -69.72,
        "swap": 0,
        "profit": -199.2,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068397",
        "positionId": "56068396",
        "volume": 9.96,
        "price": 3214.58,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -268.91999999999996,
        "priceIn": 3214.38,
        "doubleCheck": true
    },
    {
        "dataID": "118546",
        "id": "53114032",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:35",
        "brokerTime": "2025-05-14 15:15:35",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068399",
        "positionId": "56068399",
        "volume": 9.96,
        "price": 3214.45,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3214.45,
        "doubleCheck": true
    },
    {
        "dataID": "118547",
        "id": "53114033",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:35",
        "brokerTime": "2025-05-14 15:15:35",
        "commission": -69.72,
        "swap": 0,
        "profit": -318.72,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068400",
        "positionId": "56068399",
        "volume": 9.96,
        "price": 3214.77,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -388.44000000000005,
        "priceIn": 3214.45,
        "doubleCheck": true
    },
    {
        "dataID": "118548",
        "id": "53114035",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:36",
        "brokerTime": "2025-05-14 15:15:36",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068402",
        "positionId": "56068402",
        "volume": 9.96,
        "price": 3214.53,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3214.53,
        "doubleCheck": true
    },
    {
        "dataID": "118549",
        "id": "53114037",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:36",
        "brokerTime": "2025-05-14 15:15:36",
        "commission": -69.72,
        "swap": 0,
        "profit": -378.48,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068404",
        "positionId": "56068402",
        "volume": 9.96,
        "price": 3214.91,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -448.20000000000005,
        "priceIn": 3214.53,
        "doubleCheck": true
    },
    {
        "dataID": "118550",
        "id": "53114038",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:37",
        "brokerTime": "2025-05-14 15:15:37",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068405",
        "positionId": "56068405",
        "volume": 9.96,
        "price": 3214.64,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3214.64,
        "doubleCheck": true
    },
    {
        "dataID": "118551",
        "id": "53114040",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:37",
        "brokerTime": "2025-05-14 15:15:37",
        "commission": -69.72,
        "swap": 0,
        "profit": -298.8,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068407",
        "positionId": "56068405",
        "volume": 9.96,
        "price": 3214.94,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -368.52,
        "priceIn": 3214.64,
        "doubleCheck": true
    },
    {
        "dataID": "118552",
        "id": "53114042",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:39",
        "brokerTime": "2025-05-14 15:15:39",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068409",
        "positionId": "56068409",
        "volume": 9.96,
        "price": 3214.71,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3214.71,
        "doubleCheck": true
    },
    {
        "dataID": "118553",
        "id": "53114043",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:39",
        "brokerTime": "2025-05-14 15:15:40",
        "commission": -69.72,
        "swap": 0,
        "profit": -199.2,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068410",
        "positionId": "56068409",
        "volume": 9.96,
        "price": 3214.91,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -268.91999999999996,
        "priceIn": 3214.71,
        "doubleCheck": true
    },
    {
        "dataID": "118554",
        "id": "53114044",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:40",
        "brokerTime": "2025-05-14 15:15:40",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068411",
        "positionId": "56068411",
        "volume": 9.96,
        "price": 3214.56,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3214.56,
        "doubleCheck": true
    },
    {
        "dataID": "118555",
        "id": "53114045",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:40",
        "brokerTime": "2025-05-14 15:15:40",
        "commission": -69.72,
        "swap": 0,
        "profit": -368.52,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068412",
        "positionId": "56068411",
        "volume": 9.96,
        "price": 3214.93,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -438.24,
        "priceIn": 3214.56,
        "doubleCheck": true
    },
    {
        "dataID": "118556",
        "id": "53114046",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:41",
        "brokerTime": "2025-05-14 15:15:41",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068413",
        "positionId": "56068413",
        "volume": 9.96,
        "price": 3214.7,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3214.7,
        "doubleCheck": true
    },
    {
        "dataID": "118557",
        "id": "53114048",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:41",
        "brokerTime": "2025-05-14 15:15:42",
        "commission": -69.72,
        "swap": 0,
        "profit": -249,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068414",
        "positionId": "56068413",
        "volume": 9.96,
        "price": 3214.95,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -318.72,
        "priceIn": 3214.7,
        "doubleCheck": true
    },
    {
        "dataID": "118558",
        "id": "53114049",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:43",
        "brokerTime": "2025-05-14 15:15:43",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068415",
        "positionId": "56068415",
        "volume": 9.96,
        "price": 3214.83,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3214.83,
        "doubleCheck": true
    },
    {
        "dataID": "118559",
        "id": "53114050",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:43",
        "brokerTime": "2025-05-14 15:15:43",
        "commission": -69.72,
        "swap": 0,
        "profit": -189.24,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068416",
        "positionId": "56068415",
        "volume": 9.96,
        "price": 3215.02,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -258.96000000000004,
        "priceIn": 3214.83,
        "doubleCheck": true
    },
    {
        "dataID": "118560",
        "id": "53114051",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:43",
        "brokerTime": "2025-05-14 15:15:43",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068417",
        "positionId": "56068417",
        "volume": 9.96,
        "price": 3214.81,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3214.81,
        "doubleCheck": true
    },
    {
        "dataID": "118561",
        "id": "53114052",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:43",
        "brokerTime": "2025-05-14 15:15:44",
        "commission": -69.72,
        "swap": 0,
        "profit": -219.12,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068418",
        "positionId": "56068417",
        "volume": 9.96,
        "price": 3215.03,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -288.84000000000003,
        "priceIn": 3214.81,
        "doubleCheck": true
    },
    {
        "dataID": "118562",
        "id": "53114053",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:44",
        "brokerTime": "2025-05-14 15:15:44",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068419",
        "positionId": "56068419",
        "volume": 9.96,
        "price": 3214.82,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3214.82,
        "doubleCheck": true
    },
    {
        "dataID": "118563",
        "id": "53114055",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:44",
        "brokerTime": "2025-05-14 15:15:44",
        "commission": -69.72,
        "swap": 0,
        "profit": -109.56,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068421",
        "positionId": "56068419",
        "volume": 9.96,
        "price": 3214.93,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -179.28,
        "priceIn": 3214.82,
        "doubleCheck": true
    },
    {
        "dataID": "118564",
        "id": "53114056",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:45",
        "brokerTime": "2025-05-14 15:15:45",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068422",
        "positionId": "56068422",
        "volume": 9.96,
        "price": 3214.33,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3214.33,
        "doubleCheck": true
    },
    {
        "dataID": "118565",
        "id": "53114058",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:45",
        "brokerTime": "2025-05-14 15:15:46",
        "commission": -69.72,
        "swap": 0,
        "profit": -119.52,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068424",
        "positionId": "56068422",
        "volume": 9.96,
        "price": 3214.45,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -189.24,
        "priceIn": 3214.33,
        "doubleCheck": true
    },
    {
        "dataID": "118566",
        "id": "53114059",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:46",
        "brokerTime": "2025-05-14 15:15:46",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068425",
        "positionId": "56068425",
        "volume": 9.96,
        "price": 3214.32,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3214.32,
        "doubleCheck": true
    },
    {
        "dataID": "118567",
        "id": "53114060",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:46",
        "brokerTime": "2025-05-14 15:15:46",
        "commission": -69.72,
        "swap": 0,
        "profit": -209.16,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068426",
        "positionId": "56068425",
        "volume": 9.96,
        "price": 3214.53,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -278.88,
        "priceIn": 3214.32,
        "doubleCheck": true
    },
    {
        "dataID": "118568",
        "id": "53114061",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:47",
        "brokerTime": "2025-05-14 15:15:47",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068427",
        "positionId": "56068427",
        "volume": 9.96,
        "price": 3214.3,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3214.3,
        "doubleCheck": true
    },
    {
        "dataID": "118569",
        "id": "53114062",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:47",
        "brokerTime": "2025-05-14 15:15:47",
        "commission": -69.72,
        "swap": 0,
        "profit": -129.48,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068428",
        "positionId": "56068427",
        "volume": 9.96,
        "price": 3214.43,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -199.2,
        "priceIn": 3214.3,
        "doubleCheck": true
    },
    {
        "dataID": "118570",
        "id": "53114064",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:48",
        "brokerTime": "2025-05-14 15:15:48",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068430",
        "positionId": "56068430",
        "volume": 9.96,
        "price": 3214.09,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3214.09,
        "doubleCheck": true
    },
    {
        "dataID": "118571",
        "id": "53114065",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:48",
        "brokerTime": "2025-05-14 15:15:48",
        "commission": -69.72,
        "swap": 0,
        "profit": -278.88,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068431",
        "positionId": "56068430",
        "volume": 9.96,
        "price": 3214.37,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -348.6,
        "priceIn": 3214.09,
        "doubleCheck": true
    },
    {
        "dataID": "118572",
        "id": "53114066",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:49",
        "brokerTime": "2025-05-14 15:15:49",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068432",
        "positionId": "56068432",
        "volume": 9.96,
        "price": 3214.06,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3214.06,
        "doubleCheck": true
    },
    {
        "dataID": "118573",
        "id": "53114067",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:49",
        "brokerTime": "2025-05-14 15:15:50",
        "commission": -69.72,
        "swap": 0,
        "profit": -59.76,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068433",
        "positionId": "56068432",
        "volume": 9.96,
        "price": 3214.12,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -129.48,
        "priceIn": 3214.06,
        "doubleCheck": true
    },
    {
        "dataID": "118574",
        "id": "53114068",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:50",
        "brokerTime": "2025-05-14 15:15:50",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068434",
        "positionId": "56068434",
        "volume": 9.96,
        "price": 3213.85,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3213.85,
        "doubleCheck": true
    },
    {
        "dataID": "118575",
        "id": "53114069",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:50",
        "brokerTime": "2025-05-14 15:15:51",
        "commission": -69.72,
        "swap": 0,
        "profit": 99.6,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068435",
        "positionId": "56068434",
        "volume": 9.96,
        "price": 3213.75,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 29.879999999999995,
        "priceIn": 3213.85,
        "doubleCheck": true
    },
    {
        "dataID": "118576",
        "id": "53114070",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:51",
        "brokerTime": "2025-05-14 15:15:51",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068437",
        "positionId": "56068437",
        "volume": 9.96,
        "price": 3213.45,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3213.45,
        "doubleCheck": true
    },
    {
        "dataID": "118577",
        "id": "53114071",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:51",
        "brokerTime": "2025-05-14 15:15:52",
        "commission": -69.72,
        "swap": 0,
        "profit": -398.4,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068438",
        "positionId": "56068437",
        "volume": 9.96,
        "price": 3213.85,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -468.12,
        "priceIn": 3213.45,
        "doubleCheck": true
    },
    {
        "dataID": "118578",
        "id": "53114072",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:52",
        "brokerTime": "2025-05-14 15:15:52",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068439",
        "positionId": "56068439",
        "volume": 9.96,
        "price": 3213.63,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3213.63,
        "doubleCheck": true
    },
    {
        "dataID": "118579",
        "id": "53114074",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:52",
        "brokerTime": "2025-05-14 15:15:53",
        "commission": -69.72,
        "swap": 0,
        "profit": -428.28,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068441",
        "positionId": "56068439",
        "volume": 9.96,
        "price": 3214.06,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -498,
        "priceIn": 3213.63,
        "doubleCheck": true
    },
    {
        "dataID": "118580",
        "id": "53114075",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:53",
        "brokerTime": "2025-05-14 15:15:53",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068442",
        "positionId": "56068442",
        "volume": 9.96,
        "price": 3213.91,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3213.91,
        "doubleCheck": true
    },
    {
        "dataID": "118581",
        "id": "53114076",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:53",
        "brokerTime": "2025-05-14 15:15:53",
        "commission": -69.72,
        "swap": 0,
        "profit": -159.36,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068443",
        "positionId": "56068442",
        "volume": 9.96,
        "price": 3214.07,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -229.08,
        "priceIn": 3213.91,
        "doubleCheck": true
    },
    {
        "dataID": "118582",
        "id": "53114077",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:54",
        "brokerTime": "2025-05-14 15:15:54",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068444",
        "positionId": "56068444",
        "volume": 9.96,
        "price": 3213.91,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3213.91,
        "doubleCheck": true
    },
    {
        "dataID": "118583",
        "id": "53114078",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:54",
        "brokerTime": "2025-05-14 15:15:54",
        "commission": -69.72,
        "swap": 0,
        "profit": -159.36,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068445",
        "positionId": "56068444",
        "volume": 9.96,
        "price": 3214.07,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -229.08,
        "priceIn": 3213.91,
        "doubleCheck": true
    },
    {
        "dataID": "118584",
        "id": "53114079",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:55",
        "brokerTime": "2025-05-14 15:15:55",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068446",
        "positionId": "56068446",
        "volume": 9.96,
        "price": 3213.87,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3213.87,
        "doubleCheck": true
    },
    {
        "dataID": "118585",
        "id": "53114081",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:55",
        "brokerTime": "2025-05-14 15:15:56",
        "commission": -69.72,
        "swap": 0,
        "profit": -418.32,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068448",
        "positionId": "56068446",
        "volume": 9.96,
        "price": 3214.29,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -488.03999999999996,
        "priceIn": 3213.87,
        "doubleCheck": true
    },
    {
        "dataID": "118586",
        "id": "53114082",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:56",
        "brokerTime": "2025-05-14 15:15:56",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068449",
        "positionId": "56068449",
        "volume": 9.96,
        "price": 3214.15,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3214.15,
        "doubleCheck": true
    },
    {
        "dataID": "118587",
        "id": "53114083",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:56",
        "brokerTime": "2025-05-14 15:15:57",
        "commission": -69.72,
        "swap": 0,
        "profit": 89.64,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068450",
        "positionId": "56068449",
        "volume": 9.96,
        "price": 3214.06,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 19.92,
        "priceIn": 3214.15,
        "doubleCheck": true
    },
    {
        "dataID": "118588",
        "id": "53114084",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:57",
        "brokerTime": "2025-05-14 15:15:57",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068451",
        "positionId": "56068451",
        "volume": 9.96,
        "price": 3213.74,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3213.74,
        "doubleCheck": true
    },
    {
        "dataID": "118589",
        "id": "53114085",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:57",
        "brokerTime": "2025-05-14 15:15:58",
        "commission": -69.72,
        "swap": 0,
        "profit": -229.08,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068452",
        "positionId": "56068451",
        "volume": 9.96,
        "price": 3213.97,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -298.8,
        "priceIn": 3213.74,
        "doubleCheck": true
    },
    {
        "dataID": "118590",
        "id": "53114086",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:58",
        "brokerTime": "2025-05-14 15:15:58",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068453",
        "positionId": "56068453",
        "volume": 9.96,
        "price": 3213.77,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3213.77,
        "doubleCheck": true
    },
    {
        "dataID": "118591",
        "id": "53114087",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:58",
        "brokerTime": "2025-05-14 15:15:58",
        "commission": -69.72,
        "swap": 0,
        "profit": -119.52,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068454",
        "positionId": "56068453",
        "volume": 9.96,
        "price": 3213.89,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -189.24,
        "priceIn": 3213.77,
        "doubleCheck": true
    },
    {
        "dataID": "118592",
        "id": "53114088",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:59",
        "brokerTime": "2025-05-14 15:15:59",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068455",
        "positionId": "56068455",
        "volume": 9.96,
        "price": 3213.74,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3213.74,
        "doubleCheck": true
    },
    {
        "dataID": "118593",
        "id": "53114092",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:59",
        "brokerTime": "2025-05-14 15:15:59",
        "commission": -69.72,
        "swap": 0,
        "profit": -109.56,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068460",
        "positionId": "56068455",
        "volume": 9.96,
        "price": 3213.85,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -179.28,
        "priceIn": 3213.74,
        "doubleCheck": true
    },
    {
        "dataID": "118594",
        "id": "53114095",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:00",
        "brokerTime": "2025-05-14 15:16:00",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068462",
        "positionId": "56068462",
        "volume": 9.96,
        "price": 3213.76,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3213.76,
        "doubleCheck": true
    },
    {
        "dataID": "118595",
        "id": "53114098",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:00",
        "brokerTime": "2025-05-14 15:16:01",
        "commission": -69.72,
        "swap": 0,
        "profit": -328.68,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068465",
        "positionId": "56068462",
        "volume": 9.96,
        "price": 3214.09,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -398.4,
        "priceIn": 3213.76,
        "doubleCheck": true
    },
    {
        "dataID": "118596",
        "id": "53114099",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:01",
        "brokerTime": "2025-05-14 15:16:01",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068466",
        "positionId": "56068466",
        "volume": 9.96,
        "price": 3213.91,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3213.91,
        "doubleCheck": true
    },
    {
        "dataID": "118597",
        "id": "53114100",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:01",
        "brokerTime": "2025-05-14 15:16:02",
        "commission": -69.72,
        "swap": 0,
        "profit": -29.88,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068467",
        "positionId": "56068466",
        "volume": 9.96,
        "price": 3213.94,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -99.6,
        "priceIn": 3213.91,
        "doubleCheck": true
    },
    {
        "dataID": "118598",
        "id": "53114101",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:03",
        "brokerTime": "2025-05-14 15:16:03",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068468",
        "positionId": "56068468",
        "volume": 9.96,
        "price": 3213.71,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3213.71,
        "doubleCheck": true
    },
    {
        "dataID": "118599",
        "id": "53114102",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:03",
        "brokerTime": "2025-05-14 15:16:03",
        "commission": -69.72,
        "swap": 0,
        "profit": -298.8,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068469",
        "positionId": "56068468",
        "volume": 9.96,
        "price": 3214.01,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -368.52,
        "priceIn": 3213.71,
        "doubleCheck": true
    },
    {
        "dataID": "118600",
        "id": "53114104",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:04",
        "brokerTime": "2025-05-14 15:16:04",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068471",
        "positionId": "56068471",
        "volume": 9.96,
        "price": 3213.76,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3213.76,
        "doubleCheck": true
    },
    {
        "dataID": "118601",
        "id": "53114105",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:04",
        "brokerTime": "2025-05-14 15:16:04",
        "commission": -69.72,
        "swap": 0,
        "profit": 69.72,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068472",
        "positionId": "56068471",
        "volume": 9.96,
        "price": 3213.69,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 0,
        "priceIn": 3213.76,
        "doubleCheck": true
    },
    {
        "dataID": "118602",
        "id": "53114106",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:05",
        "brokerTime": "2025-05-14 15:16:05",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068473",
        "positionId": "56068473",
        "volume": 9.96,
        "price": 3213.52,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -69.72,
        "priceIn": 3213.52,
        "doubleCheck": true
    },
    {
        "dataID": "118603",
        "id": "53114107",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:05",
        "brokerTime": "2025-05-14 15:16:05",
        "commission": -69.72,
        "swap": 0,
        "profit": -29.88,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068474",
        "positionId": "56068473",
        "volume": 9.96,
        "price": 3213.55,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -99.6,
        "priceIn": 3213.52,
        "doubleCheck": true
    },
    {
        "dataID": "118604",
        "id": "53114108",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:56",
        "brokerTime": "2025-05-14 15:16:05",
        "commission": -1.19,
        "swap": 0,
        "profit": 151.81,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068475",
        "positionId": "56054283",
        "volume": 0.17,
        "price": 3213.45,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3122.56,
        "brokerComment": "",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 150.62,
        "priceIn": 3222.38,
        "doubleCheck": true
    },
    {
        "dataID": "118605",
        "id": "53114109",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:00",
        "brokerTime": "2025-05-14 15:16:05",
        "commission": -0.98,
        "swap": 0,
        "profit": 104.86,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068476",
        "positionId": "56053553",
        "volume": 0.14,
        "price": 3213.45,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3122.56,
        "brokerComment": "",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 103.88,
        "priceIn": 3220.94,
        "doubleCheck": true
    },
    {
        "dataID": "118606",
        "id": "53114110",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:26",
        "brokerTime": "2025-05-14 15:16:06",
        "commission": -0.84,
        "swap": 0,
        "profit": 55.44,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068477",
        "positionId": "56053437",
        "volume": 0.12,
        "price": 3213.45,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3122.56,
        "brokerComment": "",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 54.599999999999994,
        "priceIn": 3218.07,
        "doubleCheck": true
    },
    {
        "dataID": "118607",
        "id": "53114111",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:11",
        "brokerTime": "2025-05-14 15:16:06",
        "commission": -0.7,
        "swap": 0,
        "profit": 32.6,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068478",
        "positionId": "56053393",
        "volume": 0.1,
        "price": 3213.45,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3122.56,
        "brokerComment": "",
        "comment": "RR",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 31.900000000000002,
        "priceIn": 3216.71,
        "doubleCheck": true
    },
    {
        "dataID": "118608",
        "id": "53114118",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:12",
        "brokerTime": "2025-05-14 15:16:12",
        "commission": -0.7,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068484",
        "positionId": "56068484",
        "volume": 0.1,
        "price": 3211.89,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "RR",
        "comment": "RR",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.7,
        "priceIn": 3211.89,
        "doubleCheck": true
    },
    {
        "dataID": "118609",
        "id": "53114119",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 15:16:12",
        "brokerTime": "2025-05-14 15:16:12",
        "commission": -1.47,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUEUR.PRO",
        "magic": "0",
        "orderId": "56068485",
        "positionId": "56068485",
        "volume": 0.21,
        "price": 2864.7,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2964.7,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -1.47,
        "priceIn": 2864.7,
        "doubleCheck": true
    },
    {
        "dataID": "118610",
        "id": "53114146",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:13",
        "brokerTime": "2025-05-14 15:16:13",
        "commission": -72.73,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068503",
        "positionId": "56068503",
        "volume": 10.39,
        "price": 3212.17,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -72.73,
        "priceIn": 3212.17,
        "doubleCheck": true
    },
    {
        "dataID": "118611",
        "id": "53114148",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:13",
        "brokerTime": "2025-05-14 15:16:14",
        "commission": -72.73,
        "swap": 0,
        "profit": -166.24,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068508",
        "positionId": "56068503",
        "volume": 10.39,
        "price": 3212.33,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -238.97000000000003,
        "priceIn": 3212.17,
        "doubleCheck": true
    },
    {
        "dataID": "118612",
        "id": "53114159",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:14",
        "brokerTime": "2025-05-14 15:16:14",
        "commission": -72.73,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068511",
        "positionId": "56068511",
        "volume": 10.39,
        "price": 3212.27,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -72.73,
        "priceIn": 3212.27,
        "doubleCheck": true
    },
    {
        "dataID": "118613",
        "id": "53114162",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:14",
        "brokerTime": "2025-05-14 15:16:15",
        "commission": -72.73,
        "swap": 0,
        "profit": -259.75,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068514",
        "positionId": "56068511",
        "volume": 10.39,
        "price": 3212.52,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -332.48,
        "priceIn": 3212.27,
        "doubleCheck": true
    },
    {
        "dataID": "118614",
        "id": "53114163",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:15",
        "brokerTime": "2025-05-14 15:16:15",
        "commission": -72.73,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068515",
        "positionId": "56068515",
        "volume": 10.39,
        "price": 3212.26,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -72.73,
        "priceIn": 3212.26,
        "doubleCheck": true
    },
    {
        "dataID": "118615",
        "id": "53114165",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:15",
        "brokerTime": "2025-05-14 15:16:16",
        "commission": -72.73,
        "swap": 0,
        "profit": -332.48,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068517",
        "positionId": "56068515",
        "volume": 10.39,
        "price": 3212.58,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -405.21000000000004,
        "priceIn": 3212.26,
        "doubleCheck": true
    },
    {
        "dataID": "118616",
        "id": "53114166",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:16",
        "brokerTime": "2025-05-14 15:16:16",
        "commission": -72.73,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068518",
        "positionId": "56068518",
        "volume": 10.39,
        "price": 3212.32,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -72.73,
        "priceIn": 3212.32,
        "doubleCheck": true
    },
    {
        "dataID": "118617",
        "id": "53114167",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:16",
        "brokerTime": "2025-05-14 15:16:16",
        "commission": -72.73,
        "swap": 0,
        "profit": -51.95,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068519",
        "positionId": "56068518",
        "volume": 10.39,
        "price": 3212.37,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -124.68,
        "priceIn": 3212.32,
        "doubleCheck": true
    },
    {
        "dataID": "118618",
        "id": "53114168",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 15:16:16",
        "brokerTime": "2025-05-14 15:16:16",
        "commission": -12.95,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068520",
        "positionId": "56068520",
        "volume": 1.85,
        "price": 3212.08,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3312.17,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -12.95,
        "priceIn": 3212.08,
        "doubleCheck": true
    },
    {
        "dataID": "118619",
        "id": "53114169",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:17",
        "brokerTime": "2025-05-14 15:16:17",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068521",
        "positionId": "56068521",
        "volume": 12.61,
        "price": 3211.75,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.27,
        "priceIn": 3211.75,
        "doubleCheck": true
    },
    {
        "dataID": "118620",
        "id": "53114170",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:17",
        "brokerTime": "2025-05-14 15:16:18",
        "commission": -88.27,
        "swap": 0,
        "profit": -226.98,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068522",
        "positionId": "56068521",
        "volume": 12.61,
        "price": 3211.93,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -315.25,
        "priceIn": 3211.75,
        "doubleCheck": true
    },
    {
        "dataID": "118621",
        "id": "53114171",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:19",
        "brokerTime": "2025-05-14 15:16:19",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068523",
        "positionId": "56068523",
        "volume": 12.61,
        "price": 3211.62,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.27,
        "priceIn": 3211.62,
        "doubleCheck": true
    },
    {
        "dataID": "118622",
        "id": "53114172",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:19",
        "brokerTime": "2025-05-14 15:16:19",
        "commission": -88.27,
        "swap": 0,
        "profit": -365.69,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068524",
        "positionId": "56068523",
        "volume": 12.61,
        "price": 3211.91,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -453.96,
        "priceIn": 3211.62,
        "doubleCheck": true
    },
    {
        "dataID": "118623",
        "id": "53114173",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:20",
        "brokerTime": "2025-05-14 15:16:20",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068525",
        "positionId": "56068525",
        "volume": 12.61,
        "price": 3211.8,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.27,
        "priceIn": 3211.8,
        "doubleCheck": true
    },
    {
        "dataID": "118624",
        "id": "53114174",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:20",
        "brokerTime": "2025-05-14 15:16:20",
        "commission": -88.27,
        "swap": 0,
        "profit": -491.79,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068526",
        "positionId": "56068525",
        "volume": 12.61,
        "price": 3212.19,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -580.0600000000001,
        "priceIn": 3211.8,
        "doubleCheck": true
    },
    {
        "dataID": "118625",
        "id": "53114175",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:21",
        "brokerTime": "2025-05-14 15:16:21",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068527",
        "positionId": "56068527",
        "volume": 12.61,
        "price": 3211.93,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.27,
        "priceIn": 3211.93,
        "doubleCheck": true
    },
    {
        "dataID": "118626",
        "id": "53114176",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:21",
        "brokerTime": "2025-05-14 15:16:21",
        "commission": -88.27,
        "swap": 0,
        "profit": -214.37,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068528",
        "positionId": "56068527",
        "volume": 12.61,
        "price": 3212.1,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -302.64,
        "priceIn": 3211.93,
        "doubleCheck": true
    },
    {
        "dataID": "118627",
        "id": "53114177",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:21",
        "brokerTime": "2025-05-14 15:16:21",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068529",
        "positionId": "56068529",
        "volume": 12.61,
        "price": 3212.04,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.27,
        "priceIn": 3212.04,
        "doubleCheck": true
    },
    {
        "dataID": "118628",
        "id": "53114178",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:21",
        "brokerTime": "2025-05-14 15:16:22",
        "commission": -88.27,
        "swap": 0,
        "profit": -340.47,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068530",
        "positionId": "56068529",
        "volume": 12.61,
        "price": 3212.31,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -428.74,
        "priceIn": 3212.04,
        "doubleCheck": true
    },
    {
        "dataID": "118629",
        "id": "53114179",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:22",
        "brokerTime": "2025-05-14 15:16:22",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068531",
        "positionId": "56068531",
        "volume": 12.61,
        "price": 3212.13,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.27,
        "priceIn": 3212.13,
        "doubleCheck": true
    },
    {
        "dataID": "118630",
        "id": "53114180",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:22",
        "brokerTime": "2025-05-14 15:16:23",
        "commission": -88.27,
        "swap": 0,
        "profit": -327.86,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068533",
        "positionId": "56068531",
        "volume": 12.61,
        "price": 3212.39,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -416.13,
        "priceIn": 3212.13,
        "doubleCheck": true
    },
    {
        "dataID": "118631",
        "id": "53114181",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:23",
        "brokerTime": "2025-05-14 15:16:23",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068534",
        "positionId": "56068534",
        "volume": 12.61,
        "price": 3211.62,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.27,
        "priceIn": 3211.62,
        "doubleCheck": true
    },
    {
        "dataID": "118632",
        "id": "53114182",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:23",
        "brokerTime": "2025-05-14 15:16:23",
        "commission": -88.27,
        "swap": 0,
        "profit": -428.74,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068535",
        "positionId": "56068534",
        "volume": 12.61,
        "price": 3211.96,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -517.01,
        "priceIn": 3211.62,
        "doubleCheck": true
    },
    {
        "dataID": "118633",
        "id": "53114183",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:23",
        "brokerTime": "2025-05-14 15:16:23",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068536",
        "positionId": "56068536",
        "volume": 12.61,
        "price": 3211.76,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.27,
        "priceIn": 3211.76,
        "doubleCheck": true
    },
    {
        "dataID": "118634",
        "id": "53114184",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:23",
        "brokerTime": "2025-05-14 15:16:24",
        "commission": -88.27,
        "swap": 0,
        "profit": -428.74,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068537",
        "positionId": "56068536",
        "volume": 12.61,
        "price": 3212.1,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -517.01,
        "priceIn": 3211.76,
        "doubleCheck": true
    },
    {
        "dataID": "118635",
        "id": "53114185",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:25",
        "brokerTime": "2025-05-14 15:16:25",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068538",
        "positionId": "56068538",
        "volume": 12.61,
        "price": 3212.09,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.27,
        "priceIn": 3212.09,
        "doubleCheck": true
    },
    {
        "dataID": "118636",
        "id": "53114186",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:25",
        "brokerTime": "2025-05-14 15:16:25",
        "commission": -88.27,
        "swap": 0,
        "profit": 63.05,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068539",
        "positionId": "56068538",
        "volume": 12.61,
        "price": 3212.04,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -25.22,
        "priceIn": 3212.09,
        "doubleCheck": true
    },
    {
        "dataID": "118637",
        "id": "53114187",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:25",
        "brokerTime": "2025-05-14 15:16:25",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068540",
        "positionId": "56068540",
        "volume": 12.61,
        "price": 3211.82,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.27,
        "priceIn": 3211.82,
        "doubleCheck": true
    },
    {
        "dataID": "118638",
        "id": "53114188",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:25",
        "brokerTime": "2025-05-14 15:16:26",
        "commission": -88.27,
        "swap": 0,
        "profit": -63.05,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068541",
        "positionId": "56068540",
        "volume": 12.61,
        "price": 3211.87,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -151.32,
        "priceIn": 3211.82,
        "doubleCheck": true
    },
    {
        "dataID": "118639",
        "id": "53114189",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:26",
        "brokerTime": "2025-05-14 15:16:26",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068542",
        "positionId": "56068542",
        "volume": 12.61,
        "price": 3211.66,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.27,
        "priceIn": 3211.66,
        "doubleCheck": true
    },
    {
        "dataID": "118640",
        "id": "53114190",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:26",
        "brokerTime": "2025-05-14 15:16:27",
        "commission": -88.27,
        "swap": 0,
        "profit": -416.13,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068543",
        "positionId": "56068542",
        "volume": 12.61,
        "price": 3211.99,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -504.4,
        "priceIn": 3211.66,
        "doubleCheck": true
    },
    {
        "dataID": "118641",
        "id": "53114191",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:27",
        "brokerTime": "2025-05-14 15:16:27",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068544",
        "positionId": "56068544",
        "volume": 12.61,
        "price": 3211.76,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.27,
        "priceIn": 3211.76,
        "doubleCheck": true
    },
    {
        "dataID": "118642",
        "id": "53114192",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:27",
        "brokerTime": "2025-05-14 15:16:28",
        "commission": -88.27,
        "swap": 0,
        "profit": -163.93,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068545",
        "positionId": "56068544",
        "volume": 12.61,
        "price": 3211.89,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -252.2,
        "priceIn": 3211.76,
        "doubleCheck": true
    },
    {
        "dataID": "118643",
        "id": "53114202",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:29",
        "brokerTime": "2025-05-14 15:16:29",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068555",
        "positionId": "56068555",
        "volume": 12.61,
        "price": 3211.74,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.27,
        "priceIn": 3211.74,
        "doubleCheck": true
    },
    {
        "dataID": "118644",
        "id": "53114205",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:29",
        "brokerTime": "2025-05-14 15:16:29",
        "commission": -88.27,
        "swap": 0,
        "profit": -580.06,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068558",
        "positionId": "56068555",
        "volume": 12.61,
        "price": 3212.2,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -668.3299999999999,
        "priceIn": 3211.74,
        "doubleCheck": true
    },
    {
        "dataID": "118645",
        "id": "53114206",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:30",
        "brokerTime": "2025-05-14 15:16:30",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068559",
        "positionId": "56068559",
        "volume": 12.61,
        "price": 3212.62,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.27,
        "priceIn": 3212.62,
        "doubleCheck": true
    },
    {
        "dataID": "118646",
        "id": "53114207",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:30",
        "brokerTime": "2025-05-14 15:16:30",
        "commission": -88.27,
        "swap": 0,
        "profit": -176.54,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068560",
        "positionId": "56068559",
        "volume": 12.61,
        "price": 3212.76,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -264.81,
        "priceIn": 3212.62,
        "doubleCheck": true
    },
    {
        "dataID": "118647",
        "id": "53114208",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:30",
        "brokerTime": "2025-05-14 15:16:30",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068561",
        "positionId": "56068561",
        "volume": 12.61,
        "price": 3212.6,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.27,
        "priceIn": 3212.6,
        "doubleCheck": true
    },
    {
        "dataID": "118648",
        "id": "53114209",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:30",
        "brokerTime": "2025-05-14 15:16:32",
        "commission": -88.27,
        "swap": 0,
        "profit": -277.42,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068562",
        "positionId": "56068561",
        "volume": 12.61,
        "price": 3212.82,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -365.69,
        "priceIn": 3212.6,
        "doubleCheck": true
    },
    {
        "dataID": "118649",
        "id": "53114210",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:32",
        "brokerTime": "2025-05-14 15:16:32",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068563",
        "positionId": "56068563",
        "volume": 12.61,
        "price": 3212.49,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.27,
        "priceIn": 3212.49,
        "doubleCheck": true
    },
    {
        "dataID": "118650",
        "id": "53114211",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:32",
        "brokerTime": "2025-05-14 15:16:33",
        "commission": -88.27,
        "swap": 0,
        "profit": 201.76,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068564",
        "positionId": "56068563",
        "volume": 12.61,
        "price": 3212.33,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 113.49,
        "priceIn": 3212.49,
        "doubleCheck": true
    },
    {
        "dataID": "118651",
        "id": "53114212",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:33",
        "brokerTime": "2025-05-14 15:16:33",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068565",
        "positionId": "56068565",
        "volume": 12.61,
        "price": 3211.69,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.27,
        "priceIn": 3211.69,
        "doubleCheck": true
    },
    {
        "dataID": "118652",
        "id": "53114213",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:33",
        "brokerTime": "2025-05-14 15:16:34",
        "commission": -88.27,
        "swap": 0,
        "profit": -340.47,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068566",
        "positionId": "56068565",
        "volume": 12.61,
        "price": 3211.96,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -428.74,
        "priceIn": 3211.69,
        "doubleCheck": true
    },
    {
        "dataID": "118653",
        "id": "53114214",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:34",
        "brokerTime": "2025-05-14 15:16:34",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068567",
        "positionId": "56068567",
        "volume": 12.61,
        "price": 3211.74,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.27,
        "priceIn": 3211.74,
        "doubleCheck": true
    },
    {
        "dataID": "118654",
        "id": "53114216",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:34",
        "brokerTime": "2025-05-14 15:16:34",
        "commission": -88.27,
        "swap": 0,
        "profit": -327.86,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068569",
        "positionId": "56068567",
        "volume": 12.61,
        "price": 3212,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -416.13,
        "priceIn": 3211.74,
        "doubleCheck": true
    },
    {
        "dataID": "118655",
        "id": "53114217",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:35",
        "brokerTime": "2025-05-14 15:16:35",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068570",
        "positionId": "56068570",
        "volume": 12.61,
        "price": 3211.76,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.27,
        "priceIn": 3211.76,
        "doubleCheck": true
    },
    {
        "dataID": "118656",
        "id": "53114218",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:35",
        "brokerTime": "2025-05-14 15:16:35",
        "commission": -88.27,
        "swap": 0,
        "profit": -315.25,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068571",
        "positionId": "56068570",
        "volume": 12.61,
        "price": 3212.01,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -403.52,
        "priceIn": 3211.76,
        "doubleCheck": true
    },
    {
        "dataID": "118657",
        "id": "53114219",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:36",
        "brokerTime": "2025-05-14 15:16:36",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068572",
        "positionId": "56068572",
        "volume": 12.61,
        "price": 3211.89,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.27,
        "priceIn": 3211.89,
        "doubleCheck": true
    },
    {
        "dataID": "118658",
        "id": "53114220",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:36",
        "brokerTime": "2025-05-14 15:16:36",
        "commission": -88.27,
        "swap": 0,
        "profit": -201.76,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068573",
        "positionId": "56068572",
        "volume": 12.61,
        "price": 3212.05,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -290.03,
        "priceIn": 3211.89,
        "doubleCheck": true
    },
    {
        "dataID": "118659",
        "id": "53114221",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:37",
        "brokerTime": "2025-05-14 15:16:37",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068574",
        "positionId": "56068574",
        "volume": 12.61,
        "price": 3211.82,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.27,
        "priceIn": 3211.82,
        "doubleCheck": true
    },
    {
        "dataID": "118660",
        "id": "53114222",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:37",
        "brokerTime": "2025-05-14 15:16:37",
        "commission": -88.27,
        "swap": 0,
        "profit": -264.81,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068575",
        "positionId": "56068574",
        "volume": 12.61,
        "price": 3212.03,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -353.08,
        "priceIn": 3211.82,
        "doubleCheck": true
    },
    {
        "dataID": "118661",
        "id": "53114223",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:38",
        "brokerTime": "2025-05-14 15:16:38",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068576",
        "positionId": "56068576",
        "volume": 12.61,
        "price": 3211.9,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.27,
        "priceIn": 3211.9,
        "doubleCheck": true
    },
    {
        "dataID": "118662",
        "id": "53114224",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:38",
        "brokerTime": "2025-05-14 15:16:38",
        "commission": -88.27,
        "swap": 0,
        "profit": -277.42,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068577",
        "positionId": "56068576",
        "volume": 12.61,
        "price": 3212.12,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -365.69,
        "priceIn": 3211.9,
        "doubleCheck": true
    },
    {
        "dataID": "118663",
        "id": "53114225",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:39",
        "brokerTime": "2025-05-14 15:16:39",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068578",
        "positionId": "56068578",
        "volume": 12.61,
        "price": 3211.96,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.27,
        "priceIn": 3211.96,
        "doubleCheck": true
    },
    {
        "dataID": "118664",
        "id": "53114226",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:39",
        "brokerTime": "2025-05-14 15:16:39",
        "commission": -88.27,
        "swap": 0,
        "profit": -88.27,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068579",
        "positionId": "56068578",
        "volume": 12.61,
        "price": 3212.03,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -176.54,
        "priceIn": 3211.96,
        "doubleCheck": true
    },
    {
        "dataID": "118665",
        "id": "53114227",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:39",
        "brokerTime": "2025-05-14 15:16:39",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068580",
        "positionId": "56068580",
        "volume": 12.61,
        "price": 3211.84,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.27,
        "priceIn": 3211.84,
        "doubleCheck": true
    },
    {
        "dataID": "118666",
        "id": "53114228",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:39",
        "brokerTime": "2025-05-14 15:16:40",
        "commission": -88.27,
        "swap": 0,
        "profit": -126.1,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068581",
        "positionId": "56068580",
        "volume": 12.61,
        "price": 3211.94,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -214.37,
        "priceIn": 3211.84,
        "doubleCheck": true
    },
    {
        "dataID": "118667",
        "id": "53114231",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:40",
        "brokerTime": "2025-05-14 15:16:40",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068584",
        "positionId": "56068584",
        "volume": 12.61,
        "price": 3211.24,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.27,
        "priceIn": 3211.24,
        "doubleCheck": true
    },
    {
        "dataID": "118668",
        "id": "53114232",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:40",
        "brokerTime": "2025-05-14 15:16:41",
        "commission": -88.27,
        "swap": 0,
        "profit": -479.18,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068585",
        "positionId": "56068584",
        "volume": 12.61,
        "price": 3211.62,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -567.45,
        "priceIn": 3211.24,
        "doubleCheck": true
    },
    {
        "dataID": "118669",
        "id": "53114233",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:41",
        "brokerTime": "2025-05-14 15:16:41",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068586",
        "positionId": "56068586",
        "volume": 12.61,
        "price": 3211.29,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.27,
        "priceIn": 3211.29,
        "doubleCheck": true
    },
    {
        "dataID": "118670",
        "id": "53114234",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:41",
        "brokerTime": "2025-05-14 15:16:42",
        "commission": -88.27,
        "swap": 0,
        "profit": -428.74,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068587",
        "positionId": "56068586",
        "volume": 12.61,
        "price": 3211.63,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -517.01,
        "priceIn": 3211.29,
        "doubleCheck": true
    },
    {
        "dataID": "118671",
        "id": "53114236",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:42",
        "brokerTime": "2025-05-14 15:16:42",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068589",
        "positionId": "56068589",
        "volume": 12.61,
        "price": 3211.41,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.27,
        "priceIn": 3211.41,
        "doubleCheck": true
    },
    {
        "dataID": "118672",
        "id": "53114237",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:42",
        "brokerTime": "2025-05-14 15:16:43",
        "commission": -88.27,
        "swap": 0,
        "profit": -390.91,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068590",
        "positionId": "56068589",
        "volume": 12.61,
        "price": 3211.72,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -479.18,
        "priceIn": 3211.41,
        "doubleCheck": true
    },
    {
        "dataID": "118673",
        "id": "53114238",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:43",
        "brokerTime": "2025-05-14 15:16:43",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068591",
        "positionId": "56068591",
        "volume": 12.61,
        "price": 3211.49,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.27,
        "priceIn": 3211.49,
        "doubleCheck": true
    },
    {
        "dataID": "118674",
        "id": "53114239",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:43",
        "brokerTime": "2025-05-14 15:16:44",
        "commission": -88.27,
        "swap": 0,
        "profit": -138.71,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068592",
        "positionId": "56068591",
        "volume": 12.61,
        "price": 3211.6,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -226.98000000000002,
        "priceIn": 3211.49,
        "doubleCheck": true
    },
    {
        "dataID": "118675",
        "id": "53114240",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:45",
        "brokerTime": "2025-05-14 15:16:45",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068593",
        "positionId": "56068593",
        "volume": 12.61,
        "price": 3211.31,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.27,
        "priceIn": 3211.31,
        "doubleCheck": true
    },
    {
        "dataID": "118676",
        "id": "53114241",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:45",
        "brokerTime": "2025-05-14 15:16:45",
        "commission": -88.27,
        "swap": 0,
        "profit": -214.37,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068594",
        "positionId": "56068593",
        "volume": 12.61,
        "price": 3211.48,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -302.64,
        "priceIn": 3211.31,
        "doubleCheck": true
    },
    {
        "dataID": "118677",
        "id": "53114243",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:45",
        "brokerTime": "2025-05-14 15:16:45",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068596",
        "positionId": "56068596",
        "volume": 12.61,
        "price": 3211.02,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.27,
        "priceIn": 3211.02,
        "doubleCheck": true
    },
    {
        "dataID": "118678",
        "id": "53114245",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:45",
        "brokerTime": "2025-05-14 15:16:46",
        "commission": -88.27,
        "swap": 0,
        "profit": -252.2,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068598",
        "positionId": "56068596",
        "volume": 12.61,
        "price": 3211.22,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -340.46999999999997,
        "priceIn": 3211.02,
        "doubleCheck": true
    },
    {
        "dataID": "118679",
        "id": "53114251",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:46",
        "brokerTime": "2025-05-14 15:16:46",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068602",
        "positionId": "56068602",
        "volume": 12.61,
        "price": 3210.47,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.27,
        "priceIn": 3210.47,
        "doubleCheck": true
    },
    {
        "dataID": "118680",
        "id": "53114253",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:46",
        "brokerTime": "2025-05-14 15:16:47",
        "commission": -88.27,
        "swap": 0,
        "profit": -542.23,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068603",
        "positionId": "56068602",
        "volume": 12.61,
        "price": 3210.9,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -630.5,
        "priceIn": 3210.47,
        "doubleCheck": true
    },
    {
        "dataID": "118681",
        "id": "53114254",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:47",
        "brokerTime": "2025-05-14 15:16:47",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068604",
        "positionId": "56068604",
        "volume": 12.61,
        "price": 3210.69,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.27,
        "priceIn": 3210.69,
        "doubleCheck": true
    },
    {
        "dataID": "118682",
        "id": "53114255",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:47",
        "brokerTime": "2025-05-14 15:16:48",
        "commission": -88.27,
        "swap": 0,
        "profit": -453.96,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068605",
        "positionId": "56068604",
        "volume": 12.61,
        "price": 3211.05,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -542.23,
        "priceIn": 3210.69,
        "doubleCheck": true
    },
    {
        "dataID": "118683",
        "id": "53114256",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:48",
        "brokerTime": "2025-05-14 15:16:48",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068606",
        "positionId": "56068606",
        "volume": 12.61,
        "price": 3210.66,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.27,
        "priceIn": 3210.66,
        "doubleCheck": true
    },
    {
        "dataID": "118684",
        "id": "53114257",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:48",
        "brokerTime": "2025-05-14 15:16:49",
        "commission": -88.27,
        "swap": 0,
        "profit": -277.42,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068608",
        "positionId": "56068606",
        "volume": 12.61,
        "price": 3210.88,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -365.69,
        "priceIn": 3210.66,
        "doubleCheck": true
    },
    {
        "dataID": "118685",
        "id": "53114259",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:49",
        "brokerTime": "2025-05-14 15:16:49",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068609",
        "positionId": "56068609",
        "volume": 12.61,
        "price": 3210.75,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.27,
        "priceIn": 3210.75,
        "doubleCheck": true
    },
    {
        "dataID": "118686",
        "id": "53114260",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:49",
        "brokerTime": "2025-05-14 15:16:49",
        "commission": -88.27,
        "swap": 0,
        "profit": -517.01,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068610",
        "positionId": "56068609",
        "volume": 12.61,
        "price": 3211.16,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -605.28,
        "priceIn": 3210.75,
        "doubleCheck": true
    },
    {
        "dataID": "118687",
        "id": "53114261",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:50",
        "brokerTime": "2025-05-14 15:16:50",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068611",
        "positionId": "56068611",
        "volume": 12.61,
        "price": 3210.9,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.27,
        "priceIn": 3210.9,
        "doubleCheck": true
    },
    {
        "dataID": "118688",
        "id": "53114262",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:50",
        "brokerTime": "2025-05-14 15:16:50",
        "commission": -88.27,
        "swap": 0,
        "profit": 37.83,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068612",
        "positionId": "56068611",
        "volume": 12.61,
        "price": 3210.87,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -50.44,
        "priceIn": 3210.9,
        "doubleCheck": true
    },
    {
        "dataID": "118689",
        "id": "53114263",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:50",
        "brokerTime": "2025-05-14 15:16:50",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068613",
        "positionId": "56068613",
        "volume": 12.61,
        "price": 3210.58,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.27,
        "priceIn": 3210.58,
        "doubleCheck": true
    },
    {
        "dataID": "118690",
        "id": "53114265",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:50",
        "brokerTime": "2025-05-14 15:16:51",
        "commission": -88.27,
        "swap": 0,
        "profit": -63.05,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068615",
        "positionId": "56068613",
        "volume": 12.61,
        "price": 3210.63,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -151.32,
        "priceIn": 3210.58,
        "doubleCheck": true
    },
    {
        "dataID": "118691",
        "id": "53114489",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:52",
        "brokerTime": "2025-05-14 15:16:52",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068841",
        "positionId": "56068841",
        "volume": 12.61,
        "price": 3210.33,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.27,
        "priceIn": 3210.33,
        "doubleCheck": true
    },
    {
        "dataID": "118692",
        "id": "53114515",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:52",
        "brokerTime": "2025-05-14 15:16:52",
        "commission": -88.27,
        "swap": 0,
        "profit": -277.42,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068848",
        "positionId": "56068841",
        "volume": 12.61,
        "price": 3210.55,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -365.69,
        "priceIn": 3210.33,
        "doubleCheck": true
    },
    {
        "dataID": "118693",
        "id": "53114521",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:53",
        "brokerTime": "2025-05-14 15:16:53",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068849",
        "positionId": "56068849",
        "volume": 12.61,
        "price": 3210.42,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.27,
        "priceIn": 3210.42,
        "doubleCheck": true
    },
    {
        "dataID": "118694",
        "id": "53114522",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:53",
        "brokerTime": "2025-05-14 15:16:54",
        "commission": -88.27,
        "swap": 0,
        "profit": -517.01,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068850",
        "positionId": "56068849",
        "volume": 12.61,
        "price": 3210.83,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -605.28,
        "priceIn": 3210.42,
        "doubleCheck": true
    },
    {
        "dataID": "118695",
        "id": "53114525",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:54",
        "brokerTime": "2025-05-14 15:16:54",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068852",
        "positionId": "56068852",
        "volume": 12.61,
        "price": 3210.58,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.27,
        "priceIn": 3210.58,
        "doubleCheck": true
    },
    {
        "dataID": "118696",
        "id": "53114526",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:54",
        "brokerTime": "2025-05-14 15:16:54",
        "commission": -88.27,
        "swap": 0,
        "profit": -315.25,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068853",
        "positionId": "56068852",
        "volume": 12.61,
        "price": 3210.83,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -403.52,
        "priceIn": 3210.58,
        "doubleCheck": true
    },
    {
        "dataID": "118697",
        "id": "53114527",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:55",
        "brokerTime": "2025-05-14 15:16:55",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068854",
        "positionId": "56068854",
        "volume": 12.61,
        "price": 3210.29,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.27,
        "priceIn": 3210.29,
        "doubleCheck": true
    },
    {
        "dataID": "118698",
        "id": "53114528",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:55",
        "brokerTime": "2025-05-14 15:16:55",
        "commission": -88.27,
        "swap": 0,
        "profit": -226.98,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068855",
        "positionId": "56068854",
        "volume": 12.61,
        "price": 3210.47,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -315.25,
        "priceIn": 3210.29,
        "doubleCheck": true
    },
    {
        "dataID": "118699",
        "id": "53114529",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:55",
        "brokerTime": "2025-05-14 15:16:55",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068856",
        "positionId": "56068856",
        "volume": 12.61,
        "price": 3210.29,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.27,
        "priceIn": 3210.29,
        "doubleCheck": true
    },
    {
        "dataID": "118700",
        "id": "53114530",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:55",
        "brokerTime": "2025-05-14 15:16:56",
        "commission": -88.27,
        "swap": 0,
        "profit": -365.69,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068857",
        "positionId": "56068856",
        "volume": 12.61,
        "price": 3210.58,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -453.96,
        "priceIn": 3210.29,
        "doubleCheck": true
    },
    {
        "dataID": "118701",
        "id": "53114531",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:56",
        "brokerTime": "2025-05-14 15:16:56",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068858",
        "positionId": "56068858",
        "volume": 12.61,
        "price": 3210.34,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.27,
        "priceIn": 3210.34,
        "doubleCheck": true
    },
    {
        "dataID": "118702",
        "id": "53114534",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:56",
        "brokerTime": "2025-05-14 15:16:57",
        "commission": -88.27,
        "swap": 0,
        "profit": -290.03,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068860",
        "positionId": "56068858",
        "volume": 12.61,
        "price": 3210.57,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -378.29999999999995,
        "priceIn": 3210.34,
        "doubleCheck": true
    },
    {
        "dataID": "118703",
        "id": "53114535",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:57",
        "brokerTime": "2025-05-14 15:16:57",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068861",
        "positionId": "56068861",
        "volume": 12.61,
        "price": 3210.39,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.27,
        "priceIn": 3210.39,
        "doubleCheck": true
    },
    {
        "dataID": "118704",
        "id": "53114536",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:57",
        "brokerTime": "2025-05-14 15:16:58",
        "commission": -88.27,
        "swap": 0,
        "profit": -189.15,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068862",
        "positionId": "56068861",
        "volume": 12.61,
        "price": 3210.54,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -277.42,
        "priceIn": 3210.39,
        "doubleCheck": true
    },
    {
        "dataID": "118705",
        "id": "53114537",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:58",
        "brokerTime": "2025-05-14 15:16:58",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068863",
        "positionId": "56068863",
        "volume": 12.61,
        "price": 3210.43,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.27,
        "priceIn": 3210.43,
        "doubleCheck": true
    },
    {
        "dataID": "118706",
        "id": "53114538",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:58",
        "brokerTime": "2025-05-14 15:16:59",
        "commission": -88.27,
        "swap": 0,
        "profit": -554.84,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068864",
        "positionId": "56068863",
        "volume": 12.61,
        "price": 3210.87,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -643.11,
        "priceIn": 3210.43,
        "doubleCheck": true
    },
    {
        "dataID": "118707",
        "id": "53114541",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:00",
        "brokerTime": "2025-05-14 15:17:00",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068866",
        "positionId": "56068866",
        "volume": 12.61,
        "price": 3210.68,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.27,
        "priceIn": 3210.68,
        "doubleCheck": true
    },
    {
        "dataID": "118708",
        "id": "53114546",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 15:17:00",
        "brokerTime": "2025-05-14 15:17:00",
        "commission": -1.75,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUEUR.PRO",
        "magic": "0",
        "orderId": "56068871",
        "positionId": "56068871",
        "volume": 0.25,
        "price": 2863.53,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2963.53,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -1.75,
        "priceIn": 2863.53,
        "doubleCheck": true
    },
    {
        "dataID": "118709",
        "id": "53114547",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:00",
        "brokerTime": "2025-05-14 15:17:00",
        "commission": -88.27,
        "swap": 0,
        "profit": -504.4,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068872",
        "positionId": "56068866",
        "volume": 12.61,
        "price": 3211.08,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -592.67,
        "priceIn": 3210.68,
        "doubleCheck": true
    },
    {
        "dataID": "118710",
        "id": "53114549",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:01",
        "brokerTime": "2025-05-14 15:17:01",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068873",
        "positionId": "56068873",
        "volume": 12.61,
        "price": 3210.69,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.27,
        "priceIn": 3210.69,
        "doubleCheck": true
    },
    {
        "dataID": "118711",
        "id": "53114550",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:01",
        "brokerTime": "2025-05-14 15:17:01",
        "commission": -7.63,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUEUR.PRO",
        "magic": "0",
        "orderId": "56068874",
        "positionId": "56068874",
        "volume": 1.09,
        "price": 2863.2,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -7.63,
        "priceIn": 2863.2,
        "doubleCheck": true
    },
    {
        "dataID": "118712",
        "id": "53114554",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:01",
        "brokerTime": "2025-05-14 15:17:02",
        "commission": -88.27,
        "swap": 0,
        "profit": -277.42,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068879",
        "positionId": "56068873",
        "volume": 12.61,
        "price": 3210.91,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -365.69,
        "priceIn": 3210.69,
        "doubleCheck": true
    },
    {
        "dataID": "118713",
        "id": "53114556",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:03",
        "brokerTime": "2025-05-14 15:17:03",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068880",
        "positionId": "56068880",
        "volume": 12.61,
        "price": 3210.55,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.27,
        "priceIn": 3210.55,
        "doubleCheck": true
    },
    {
        "dataID": "118714",
        "id": "53114557",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:03",
        "brokerTime": "2025-05-14 15:17:03",
        "commission": -88.27,
        "swap": 0,
        "profit": -466.57,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068881",
        "positionId": "56068880",
        "volume": 12.61,
        "price": 3210.92,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -554.84,
        "priceIn": 3210.55,
        "doubleCheck": true
    },
    {
        "dataID": "118715",
        "id": "53114558",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:03",
        "brokerTime": "2025-05-14 15:17:03",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068882",
        "positionId": "56068882",
        "volume": 12.61,
        "price": 3210.9,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.27,
        "priceIn": 3210.9,
        "doubleCheck": true
    },
    {
        "dataID": "118716",
        "id": "53114559",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:03",
        "brokerTime": "2025-05-14 15:17:04",
        "commission": -88.27,
        "swap": 0,
        "profit": -390.91,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068883",
        "positionId": "56068882",
        "volume": 12.61,
        "price": 3211.21,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -479.18,
        "priceIn": 3210.9,
        "doubleCheck": true
    },
    {
        "dataID": "118717",
        "id": "53114560",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:04",
        "brokerTime": "2025-05-14 15:17:04",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068884",
        "positionId": "56068884",
        "volume": 12.61,
        "price": 3211.01,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.27,
        "priceIn": 3211.01,
        "doubleCheck": true
    },
    {
        "dataID": "118718",
        "id": "53114562",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:04",
        "brokerTime": "2025-05-14 15:17:04",
        "commission": -88.27,
        "swap": 0,
        "profit": -416.13,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068886",
        "positionId": "56068884",
        "volume": 12.61,
        "price": 3211.34,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -504.4,
        "priceIn": 3211.01,
        "doubleCheck": true
    },
    {
        "dataID": "118719",
        "id": "53114563",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:05",
        "brokerTime": "2025-05-14 15:17:05",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068887",
        "positionId": "56068887",
        "volume": 12.61,
        "price": 3211.14,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.27,
        "priceIn": 3211.14,
        "doubleCheck": true
    },
    {
        "dataID": "118720",
        "id": "53114566",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:05",
        "brokerTime": "2025-05-14 15:17:05",
        "commission": -88.27,
        "swap": 0,
        "profit": -353.08,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068890",
        "positionId": "56068887",
        "volume": 12.61,
        "price": 3211.42,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -441.34999999999997,
        "priceIn": 3211.14,
        "doubleCheck": true
    },
    {
        "dataID": "118721",
        "id": "53114567",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:06",
        "brokerTime": "2025-05-14 15:17:06",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068891",
        "positionId": "56068891",
        "volume": 12.61,
        "price": 3211.26,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.27,
        "priceIn": 3211.26,
        "doubleCheck": true
    },
    {
        "dataID": "118722",
        "id": "53114568",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:06",
        "brokerTime": "2025-05-14 15:17:06",
        "commission": -88.27,
        "swap": 0,
        "profit": -100.88,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068892",
        "positionId": "56068891",
        "volume": 12.61,
        "price": 3211.34,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -189.14999999999998,
        "priceIn": 3211.26,
        "doubleCheck": true
    },
    {
        "dataID": "118723",
        "id": "53114569",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:07",
        "brokerTime": "2025-05-14 15:17:07",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068893",
        "positionId": "56068893",
        "volume": 12.61,
        "price": 3211.17,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.27,
        "priceIn": 3211.17,
        "doubleCheck": true
    },
    {
        "dataID": "118724",
        "id": "53114570",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:07",
        "brokerTime": "2025-05-14 15:17:07",
        "commission": -88.27,
        "swap": 0,
        "profit": -327.86,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068894",
        "positionId": "56068893",
        "volume": 12.61,
        "price": 3211.43,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -416.13,
        "priceIn": 3211.17,
        "doubleCheck": true
    },
    {
        "dataID": "118725",
        "id": "53114571",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:08",
        "brokerTime": "2025-05-14 15:17:08",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068895",
        "positionId": "56068895",
        "volume": 12.61,
        "price": 3211.24,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.27,
        "priceIn": 3211.24,
        "doubleCheck": true
    },
    {
        "dataID": "118726",
        "id": "53114572",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:08",
        "brokerTime": "2025-05-14 15:17:08",
        "commission": -88.27,
        "swap": 0,
        "profit": 189.15,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068896",
        "positionId": "56068895",
        "volume": 12.61,
        "price": 3211.09,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 100.88000000000001,
        "priceIn": 3211.24,
        "doubleCheck": true
    },
    {
        "dataID": "118727",
        "id": "53114573",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:09",
        "brokerTime": "2025-05-14 15:17:09",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068897",
        "positionId": "56068897",
        "volume": 12.61,
        "price": 3210.84,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.27,
        "priceIn": 3210.84,
        "doubleCheck": true
    },
    {
        "dataID": "118728",
        "id": "53114574",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:09",
        "brokerTime": "2025-05-14 15:17:09",
        "commission": -88.27,
        "swap": 0,
        "profit": -201.76,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068898",
        "positionId": "56068897",
        "volume": 12.61,
        "price": 3211,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -290.03,
        "priceIn": 3210.84,
        "doubleCheck": true
    },
    {
        "dataID": "118729",
        "id": "53114575",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:09",
        "brokerTime": "2025-05-14 15:17:09",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068899",
        "positionId": "56068899",
        "volume": 12.61,
        "price": 3210.89,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.27,
        "priceIn": 3210.89,
        "doubleCheck": true
    },
    {
        "dataID": "118730",
        "id": "53114576",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:09",
        "brokerTime": "2025-05-14 15:17:10",
        "commission": -88.27,
        "swap": 0,
        "profit": -416.13,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068900",
        "positionId": "56068899",
        "volume": 12.61,
        "price": 3211.22,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -504.4,
        "priceIn": 3210.89,
        "doubleCheck": true
    },
    {
        "dataID": "118731",
        "id": "53114577",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:10",
        "brokerTime": "2025-05-14 15:17:10",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068901",
        "positionId": "56068901",
        "volume": 12.61,
        "price": 3210.91,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.27,
        "priceIn": 3210.91,
        "doubleCheck": true
    },
    {
        "dataID": "118732",
        "id": "53114578",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:10",
        "brokerTime": "2025-05-14 15:17:11",
        "commission": -88.27,
        "swap": 0,
        "profit": -390.91,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068902",
        "positionId": "56068901",
        "volume": 12.61,
        "price": 3211.22,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -479.18,
        "priceIn": 3210.91,
        "doubleCheck": true
    },
    {
        "dataID": "118733",
        "id": "53114579",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:12",
        "brokerTime": "2025-05-14 15:17:12",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068903",
        "positionId": "56068903",
        "volume": 12.61,
        "price": 3210.61,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.27,
        "priceIn": 3210.61,
        "doubleCheck": true
    },
    {
        "dataID": "118734",
        "id": "53114580",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:12",
        "brokerTime": "2025-05-14 15:17:12",
        "commission": -88.27,
        "swap": 0,
        "profit": -290.03,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068904",
        "positionId": "56068903",
        "volume": 12.61,
        "price": 3210.84,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -378.29999999999995,
        "priceIn": 3210.61,
        "doubleCheck": true
    },
    {
        "dataID": "118735",
        "id": "53114582",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:12",
        "brokerTime": "2025-05-14 15:17:12",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068906",
        "positionId": "56068906",
        "volume": 12.61,
        "price": 3210.64,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.27,
        "priceIn": 3210.64,
        "doubleCheck": true
    },
    {
        "dataID": "118736",
        "id": "53114583",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:12",
        "brokerTime": "2025-05-14 15:17:13",
        "commission": -88.27,
        "swap": 0,
        "profit": -138.71,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068907",
        "positionId": "56068906",
        "volume": 12.61,
        "price": 3210.75,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -226.98000000000002,
        "priceIn": 3210.64,
        "doubleCheck": true
    },
    {
        "dataID": "118737",
        "id": "53114584",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:13",
        "brokerTime": "2025-05-14 15:17:13",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068908",
        "positionId": "56068908",
        "volume": 12.61,
        "price": 3210.57,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.27,
        "priceIn": 3210.57,
        "doubleCheck": true
    },
    {
        "dataID": "118738",
        "id": "53114585",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:13",
        "brokerTime": "2025-05-14 15:17:14",
        "commission": -88.27,
        "swap": 0,
        "profit": -277.42,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068909",
        "positionId": "56068908",
        "volume": 12.61,
        "price": 3210.79,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -365.69,
        "priceIn": 3210.57,
        "doubleCheck": true
    },
    {
        "dataID": "118739",
        "id": "53114586",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:14",
        "brokerTime": "2025-05-14 15:17:14",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068910",
        "positionId": "56068910",
        "volume": 12.61,
        "price": 3210.48,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.27,
        "priceIn": 3210.48,
        "doubleCheck": true
    },
    {
        "dataID": "118740",
        "id": "53114587",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:14",
        "brokerTime": "2025-05-14 15:17:15",
        "commission": -88.27,
        "swap": 0,
        "profit": -290.03,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068911",
        "positionId": "56068910",
        "volume": 12.61,
        "price": 3210.71,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -378.29999999999995,
        "priceIn": 3210.48,
        "doubleCheck": true
    },
    {
        "dataID": "118741",
        "id": "53114588",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:15",
        "brokerTime": "2025-05-14 15:17:15",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068912",
        "positionId": "56068912",
        "volume": 12.61,
        "price": 3210.57,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.27,
        "priceIn": 3210.57,
        "doubleCheck": true
    },
    {
        "dataID": "118742",
        "id": "53114589",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:15",
        "brokerTime": "2025-05-14 15:17:16",
        "commission": -88.27,
        "swap": 0,
        "profit": -252.2,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068913",
        "positionId": "56068912",
        "volume": 12.61,
        "price": 3210.77,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -340.46999999999997,
        "priceIn": 3210.57,
        "doubleCheck": true
    },
    {
        "dataID": "118743",
        "id": "53114590",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:17",
        "brokerTime": "2025-05-14 15:17:17",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068914",
        "positionId": "56068914",
        "volume": 12.61,
        "price": 3210.66,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.27,
        "priceIn": 3210.66,
        "doubleCheck": true
    },
    {
        "dataID": "118744",
        "id": "53114591",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:17",
        "brokerTime": "2025-05-14 15:17:17",
        "commission": -88.27,
        "swap": 0,
        "profit": -226.98,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068915",
        "positionId": "56068914",
        "volume": 12.61,
        "price": 3210.84,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -315.25,
        "priceIn": 3210.66,
        "doubleCheck": true
    },
    {
        "dataID": "118745",
        "id": "53114592",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:17",
        "brokerTime": "2025-05-14 15:17:17",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068916",
        "positionId": "56068916",
        "volume": 12.61,
        "price": 3210.63,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.27,
        "priceIn": 3210.63,
        "doubleCheck": true
    },
    {
        "dataID": "118746",
        "id": "53114593",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:17",
        "brokerTime": "2025-05-14 15:17:18",
        "commission": -88.27,
        "swap": 0,
        "profit": -315.25,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068917",
        "positionId": "56068916",
        "volume": 12.61,
        "price": 3210.88,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -403.52,
        "priceIn": 3210.63,
        "doubleCheck": true
    },
    {
        "dataID": "118747",
        "id": "53114594",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:18",
        "brokerTime": "2025-05-14 15:17:18",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068918",
        "positionId": "56068918",
        "volume": 12.61,
        "price": 3210.58,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.27,
        "priceIn": 3210.58,
        "doubleCheck": true
    },
    {
        "dataID": "118748",
        "id": "53114595",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:18",
        "brokerTime": "2025-05-14 15:17:19",
        "commission": -88.27,
        "swap": 0,
        "profit": -340.47,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068919",
        "positionId": "56068918",
        "volume": 12.61,
        "price": 3210.85,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -428.74,
        "priceIn": 3210.58,
        "doubleCheck": true
    },
    {
        "dataID": "118749",
        "id": "53114597",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:19",
        "brokerTime": "2025-05-14 15:17:19",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068921",
        "positionId": "56068921",
        "volume": 12.61,
        "price": 3210.57,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.27,
        "priceIn": 3210.57,
        "doubleCheck": true
    },
    {
        "dataID": "118750",
        "id": "53114598",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:19",
        "brokerTime": "2025-05-14 15:17:19",
        "commission": -88.27,
        "swap": 0,
        "profit": -163.93,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068922",
        "positionId": "56068921",
        "volume": 12.61,
        "price": 3210.7,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -252.2,
        "priceIn": 3210.57,
        "doubleCheck": true
    },
    {
        "dataID": "118751",
        "id": "53114599",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:20",
        "brokerTime": "2025-05-14 15:17:20",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068923",
        "positionId": "56068923",
        "volume": 12.61,
        "price": 3210.61,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.27,
        "priceIn": 3210.61,
        "doubleCheck": true
    },
    {
        "dataID": "118752",
        "id": "53114601",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:20",
        "brokerTime": "2025-05-14 15:17:20",
        "commission": -88.27,
        "swap": 0,
        "profit": -113.49,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068925",
        "positionId": "56068923",
        "volume": 12.61,
        "price": 3210.7,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -201.76,
        "priceIn": 3210.61,
        "doubleCheck": true
    },
    {
        "dataID": "118753",
        "id": "53114602",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:21",
        "brokerTime": "2025-05-14 15:17:21",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068926",
        "positionId": "56068926",
        "volume": 12.61,
        "price": 3210.56,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.27,
        "priceIn": 3210.56,
        "doubleCheck": true
    },
    {
        "dataID": "118754",
        "id": "53114603",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:21",
        "brokerTime": "2025-05-14 15:17:21",
        "commission": -88.27,
        "swap": 0,
        "profit": -340.47,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068927",
        "positionId": "56068926",
        "volume": 12.61,
        "price": 3210.83,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -428.74,
        "priceIn": 3210.56,
        "doubleCheck": true
    },
    {
        "dataID": "118755",
        "id": "53114604",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:21",
        "brokerTime": "2025-05-14 15:17:21",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068928",
        "positionId": "56068928",
        "volume": 12.61,
        "price": 3210.63,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.27,
        "priceIn": 3210.63,
        "doubleCheck": true
    },
    {
        "dataID": "118756",
        "id": "53114605",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:21",
        "brokerTime": "2025-05-14 15:17:22",
        "commission": -88.27,
        "swap": 0,
        "profit": -264.81,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068929",
        "positionId": "56068928",
        "volume": 12.61,
        "price": 3210.84,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -353.08,
        "priceIn": 3210.63,
        "doubleCheck": true
    },
    {
        "dataID": "118757",
        "id": "53114606",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:22",
        "brokerTime": "2025-05-14 15:17:22",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068930",
        "positionId": "56068930",
        "volume": 12.61,
        "price": 3210.76,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.27,
        "priceIn": 3210.76,
        "doubleCheck": true
    },
    {
        "dataID": "118758",
        "id": "53114607",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:22",
        "brokerTime": "2025-05-14 15:17:23",
        "commission": -88.27,
        "swap": 0,
        "profit": -315.25,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068931",
        "positionId": "56068930",
        "volume": 12.61,
        "price": 3211.01,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -403.52,
        "priceIn": 3210.76,
        "doubleCheck": true
    },
    {
        "dataID": "118759",
        "id": "53114608",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:23",
        "brokerTime": "2025-05-14 15:17:23",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068932",
        "positionId": "56068932",
        "volume": 12.61,
        "price": 3210.78,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.27,
        "priceIn": 3210.78,
        "doubleCheck": true
    },
    {
        "dataID": "118760",
        "id": "53114609",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:23",
        "brokerTime": "2025-05-14 15:17:23",
        "commission": -88.27,
        "swap": 0,
        "profit": -226.98,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068933",
        "positionId": "56068932",
        "volume": 12.61,
        "price": 3210.96,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -315.25,
        "priceIn": 3210.78,
        "doubleCheck": true
    },
    {
        "dataID": "118761",
        "id": "53114610",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:24",
        "brokerTime": "2025-05-14 15:17:24",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068934",
        "positionId": "56068934",
        "volume": 12.61,
        "price": 3210.76,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.27,
        "priceIn": 3210.76,
        "doubleCheck": true
    },
    {
        "dataID": "118762",
        "id": "53114611",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:24",
        "brokerTime": "2025-05-14 15:17:24",
        "commission": -88.27,
        "swap": 0,
        "profit": -365.69,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068935",
        "positionId": "56068934",
        "volume": 12.61,
        "price": 3211.05,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -453.96,
        "priceIn": 3210.76,
        "doubleCheck": true
    },
    {
        "dataID": "118763",
        "id": "53114612",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:25",
        "brokerTime": "2025-05-14 15:17:25",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068936",
        "positionId": "56068936",
        "volume": 12.61,
        "price": 3210.82,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.27,
        "priceIn": 3210.82,
        "doubleCheck": true
    },
    {
        "dataID": "118764",
        "id": "53114613",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:25",
        "brokerTime": "2025-05-14 15:17:25",
        "commission": -88.27,
        "swap": 0,
        "profit": -264.81,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068937",
        "positionId": "56068936",
        "volume": 12.61,
        "price": 3211.03,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -353.08,
        "priceIn": 3210.82,
        "doubleCheck": true
    },
    {
        "dataID": "118765",
        "id": "53114614",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:25",
        "brokerTime": "2025-05-14 15:17:25",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068938",
        "positionId": "56068938",
        "volume": 12.61,
        "price": 3210.82,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.27,
        "priceIn": 3210.82,
        "doubleCheck": true
    },
    {
        "dataID": "118766",
        "id": "53114615",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:25",
        "brokerTime": "2025-05-14 15:17:26",
        "commission": -88.27,
        "swap": 0,
        "profit": -100.88,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068939",
        "positionId": "56068938",
        "volume": 12.61,
        "price": 3210.9,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -189.14999999999998,
        "priceIn": 3210.82,
        "doubleCheck": true
    },
    {
        "dataID": "118767",
        "id": "53114616",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:26",
        "brokerTime": "2025-05-14 15:17:26",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068940",
        "positionId": "56068940",
        "volume": 12.61,
        "price": 3210.65,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.27,
        "priceIn": 3210.65,
        "doubleCheck": true
    },
    {
        "dataID": "118768",
        "id": "53114617",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:26",
        "brokerTime": "2025-05-14 15:17:27",
        "commission": -88.27,
        "swap": 0,
        "profit": -353.08,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068941",
        "positionId": "56068940",
        "volume": 12.61,
        "price": 3210.93,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -441.34999999999997,
        "priceIn": 3210.65,
        "doubleCheck": true
    },
    {
        "dataID": "118769",
        "id": "53114620",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:27",
        "brokerTime": "2025-05-14 15:17:27",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068944",
        "positionId": "56068944",
        "volume": 12.61,
        "price": 3210.72,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.27,
        "priceIn": 3210.72,
        "doubleCheck": true
    },
    {
        "dataID": "118770",
        "id": "53114621",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:27",
        "brokerTime": "2025-05-14 15:17:28",
        "commission": -88.27,
        "swap": 0,
        "profit": -201.76,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068945",
        "positionId": "56068944",
        "volume": 12.61,
        "price": 3210.88,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -290.03,
        "priceIn": 3210.72,
        "doubleCheck": true
    },
    {
        "dataID": "118771",
        "id": "53114622",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:28",
        "brokerTime": "2025-05-14 15:17:28",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068946",
        "positionId": "56068946",
        "volume": 12.61,
        "price": 3210.66,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.27,
        "priceIn": 3210.66,
        "doubleCheck": true
    },
    {
        "dataID": "118772",
        "id": "53114623",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:28",
        "brokerTime": "2025-05-14 15:17:29",
        "commission": -88.27,
        "swap": 0,
        "profit": -37.83,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068947",
        "positionId": "56068946",
        "volume": 12.61,
        "price": 3210.69,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -126.1,
        "priceIn": 3210.66,
        "doubleCheck": true
    },
    {
        "dataID": "118773",
        "id": "53114624",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:29",
        "brokerTime": "2025-05-14 15:17:29",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068948",
        "positionId": "56068948",
        "volume": 12.61,
        "price": 3210.45,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.27,
        "priceIn": 3210.45,
        "doubleCheck": true
    },
    {
        "dataID": "118774",
        "id": "53114625",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:29",
        "brokerTime": "2025-05-14 15:17:30",
        "commission": -88.27,
        "swap": 0,
        "profit": -252.2,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068949",
        "positionId": "56068948",
        "volume": 12.61,
        "price": 3210.65,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -340.46999999999997,
        "priceIn": 3210.45,
        "doubleCheck": true
    },
    {
        "dataID": "118775",
        "id": "53114626",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:30",
        "brokerTime": "2025-05-14 15:17:30",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068950",
        "positionId": "56068950",
        "volume": 12.61,
        "price": 3210.36,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.27,
        "priceIn": 3210.36,
        "doubleCheck": true
    },
    {
        "dataID": "118776",
        "id": "53114627",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:30",
        "brokerTime": "2025-05-14 15:17:31",
        "commission": -88.27,
        "swap": 0,
        "profit": -390.91,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068951",
        "positionId": "56068950",
        "volume": 12.61,
        "price": 3210.67,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -479.18,
        "priceIn": 3210.36,
        "doubleCheck": true
    },
    {
        "dataID": "118777",
        "id": "53114628",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:31",
        "brokerTime": "2025-05-14 15:17:31",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068952",
        "positionId": "56068952",
        "volume": 12.61,
        "price": 3210.32,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.27,
        "priceIn": 3210.32,
        "doubleCheck": true
    },
    {
        "dataID": "118778",
        "id": "53114629",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:31",
        "brokerTime": "2025-05-14 15:17:32",
        "commission": -88.27,
        "swap": 0,
        "profit": -416.13,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068953",
        "positionId": "56068952",
        "volume": 12.61,
        "price": 3210.65,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -504.4,
        "priceIn": 3210.32,
        "doubleCheck": true
    },
    {
        "dataID": "118779",
        "id": "53114630",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:32",
        "brokerTime": "2025-05-14 15:17:32",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068954",
        "positionId": "56068954",
        "volume": 12.61,
        "price": 3210.45,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.27,
        "priceIn": 3210.45,
        "doubleCheck": true
    },
    {
        "dataID": "118780",
        "id": "53114631",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:32",
        "brokerTime": "2025-05-14 15:17:33",
        "commission": -88.27,
        "swap": 0,
        "profit": -113.49,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068955",
        "positionId": "56068954",
        "volume": 12.61,
        "price": 3210.54,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -201.76,
        "priceIn": 3210.45,
        "doubleCheck": true
    },
    {
        "dataID": "118781",
        "id": "53114632",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:33",
        "brokerTime": "2025-05-14 15:17:33",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068956",
        "positionId": "56068956",
        "volume": 12.61,
        "price": 3210.36,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.27,
        "priceIn": 3210.36,
        "doubleCheck": true
    },
    {
        "dataID": "118782",
        "id": "53114633",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:33",
        "brokerTime": "2025-05-14 15:17:33",
        "commission": -88.27,
        "swap": 0,
        "profit": -390.91,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068957",
        "positionId": "56068956",
        "volume": 12.61,
        "price": 3210.67,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -479.18,
        "priceIn": 3210.36,
        "doubleCheck": true
    },
    {
        "dataID": "118783",
        "id": "53114634",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:34",
        "brokerTime": "2025-05-14 15:17:34",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068958",
        "positionId": "56068958",
        "volume": 12.61,
        "price": 3210.61,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.27,
        "priceIn": 3210.61,
        "doubleCheck": true
    },
    {
        "dataID": "118784",
        "id": "53114635",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:34",
        "brokerTime": "2025-05-14 15:17:34",
        "commission": -88.27,
        "swap": 0,
        "profit": -264.81,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068959",
        "positionId": "56068958",
        "volume": 12.61,
        "price": 3210.82,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -353.08,
        "priceIn": 3210.61,
        "doubleCheck": true
    },
    {
        "dataID": "118785",
        "id": "53114636",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:34",
        "brokerTime": "2025-05-14 15:17:34",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068960",
        "positionId": "56068960",
        "volume": 12.61,
        "price": 3210.79,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.27,
        "priceIn": 3210.79,
        "doubleCheck": true
    },
    {
        "dataID": "118786",
        "id": "53114637",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:34",
        "brokerTime": "2025-05-14 15:17:35",
        "commission": -88.27,
        "swap": 0,
        "profit": -290.03,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068961",
        "positionId": "56068960",
        "volume": 12.61,
        "price": 3211.02,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -378.29999999999995,
        "priceIn": 3210.79,
        "doubleCheck": true
    },
    {
        "dataID": "118787",
        "id": "53114638",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:35",
        "brokerTime": "2025-05-14 15:17:35",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068962",
        "positionId": "56068962",
        "volume": 12.61,
        "price": 3211.02,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.27,
        "priceIn": 3211.02,
        "doubleCheck": true
    },
    {
        "dataID": "118788",
        "id": "53114639",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:35",
        "brokerTime": "2025-05-14 15:17:35",
        "commission": -88.27,
        "swap": 0,
        "profit": -239.59,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068963",
        "positionId": "56068962",
        "volume": 12.61,
        "price": 3211.21,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -327.86,
        "priceIn": 3211.02,
        "doubleCheck": true
    },
    {
        "dataID": "118789",
        "id": "53114640",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:36",
        "brokerTime": "2025-05-14 15:17:36",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068964",
        "positionId": "56068964",
        "volume": 12.61,
        "price": 3211,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.27,
        "priceIn": 3211,
        "doubleCheck": true
    },
    {
        "dataID": "118790",
        "id": "53114642",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:36",
        "brokerTime": "2025-05-14 15:17:36",
        "commission": -88.27,
        "swap": 0,
        "profit": -365.69,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068966",
        "positionId": "56068964",
        "volume": 12.61,
        "price": 3211.29,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -453.96,
        "priceIn": 3211,
        "doubleCheck": true
    },
    {
        "dataID": "118791",
        "id": "53114643",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:37",
        "brokerTime": "2025-05-14 15:17:37",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068967",
        "positionId": "56068967",
        "volume": 12.61,
        "price": 3211,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.27,
        "priceIn": 3211,
        "doubleCheck": true
    },
    {
        "dataID": "118792",
        "id": "53114644",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:37",
        "brokerTime": "2025-05-14 15:17:37",
        "commission": -88.27,
        "swap": 0,
        "profit": -378.3,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068968",
        "positionId": "56068967",
        "volume": 12.61,
        "price": 3211.3,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -466.57,
        "priceIn": 3211,
        "doubleCheck": true
    },
    {
        "dataID": "118793",
        "id": "53114645",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:38",
        "brokerTime": "2025-05-14 15:17:38",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068969",
        "positionId": "56068969",
        "volume": 12.61,
        "price": 3211.07,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.27,
        "priceIn": 3211.07,
        "doubleCheck": true
    },
    {
        "dataID": "118794",
        "id": "53114646",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:38",
        "brokerTime": "2025-05-14 15:17:38",
        "commission": -88.27,
        "swap": 0,
        "profit": -290.03,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068970",
        "positionId": "56068969",
        "volume": 12.61,
        "price": 3211.3,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -378.29999999999995,
        "priceIn": 3211.07,
        "doubleCheck": true
    },
    {
        "dataID": "118795",
        "id": "53114647",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:39",
        "brokerTime": "2025-05-14 15:17:39",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068971",
        "positionId": "56068971",
        "volume": 12.61,
        "price": 3210.97,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.27,
        "priceIn": 3210.97,
        "doubleCheck": true
    },
    {
        "dataID": "118796",
        "id": "53114649",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:39",
        "brokerTime": "2025-05-14 15:17:40",
        "commission": -88.27,
        "swap": 0,
        "profit": -365.69,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068973",
        "positionId": "56068971",
        "volume": 12.61,
        "price": 3211.26,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -453.96,
        "priceIn": 3210.97,
        "doubleCheck": true
    },
    {
        "dataID": "118797",
        "id": "53114650",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:40",
        "brokerTime": "2025-05-14 15:17:40",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068974",
        "positionId": "56068974",
        "volume": 12.61,
        "price": 3210.95,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.27,
        "priceIn": 3210.95,
        "doubleCheck": true
    },
    {
        "dataID": "118798",
        "id": "53114651",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:40",
        "brokerTime": "2025-05-14 15:17:40",
        "commission": -88.27,
        "swap": 0,
        "profit": 25.22,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068975",
        "positionId": "56068974",
        "volume": 12.61,
        "price": 3210.93,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -63.05,
        "priceIn": 3210.95,
        "doubleCheck": true
    },
    {
        "dataID": "118799",
        "id": "53114653",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:41",
        "brokerTime": "2025-05-14 15:17:41",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068977",
        "positionId": "56068977",
        "volume": 12.61,
        "price": 3210.56,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.27,
        "priceIn": 3210.56,
        "doubleCheck": true
    },
    {
        "dataID": "118800",
        "id": "53114656",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:41",
        "brokerTime": "2025-05-14 15:17:41",
        "commission": -88.27,
        "swap": 0,
        "profit": -290.03,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068979",
        "positionId": "56068977",
        "volume": 12.61,
        "price": 3210.79,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -378.29999999999995,
        "priceIn": 3210.56,
        "doubleCheck": true
    },
    {
        "dataID": "118801",
        "id": "53114657",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:42",
        "brokerTime": "2025-05-14 15:17:42",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068980",
        "positionId": "56068980",
        "volume": 12.61,
        "price": 3210.55,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.27,
        "priceIn": 3210.55,
        "doubleCheck": true
    },
    {
        "dataID": "118802",
        "id": "53114658",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:42",
        "brokerTime": "2025-05-14 15:17:42",
        "commission": -88.27,
        "swap": 0,
        "profit": -252.2,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068981",
        "positionId": "56068980",
        "volume": 12.61,
        "price": 3210.75,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -340.46999999999997,
        "priceIn": 3210.55,
        "doubleCheck": true
    },
    {
        "dataID": "118803",
        "id": "53114663",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:42",
        "brokerTime": "2025-05-14 15:17:42",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068986",
        "positionId": "56068986",
        "volume": 12.61,
        "price": 3210.55,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.27,
        "priceIn": 3210.55,
        "doubleCheck": true
    },
    {
        "dataID": "118804",
        "id": "53114665",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:42",
        "brokerTime": "2025-05-14 15:17:43",
        "commission": -88.27,
        "swap": 0,
        "profit": -277.42,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068988",
        "positionId": "56068986",
        "volume": 12.61,
        "price": 3210.77,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -365.69,
        "priceIn": 3210.55,
        "doubleCheck": true
    },
    {
        "dataID": "118805",
        "id": "53114666",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:43",
        "brokerTime": "2025-05-14 15:17:43",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068989",
        "positionId": "56068989",
        "volume": 12.61,
        "price": 3210.61,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.27,
        "priceIn": 3210.61,
        "doubleCheck": true
    },
    {
        "dataID": "118806",
        "id": "53114667",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:43",
        "brokerTime": "2025-05-14 15:17:44",
        "commission": -88.27,
        "swap": 0,
        "profit": -315.25,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068990",
        "positionId": "56068989",
        "volume": 12.61,
        "price": 3210.86,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -403.52,
        "priceIn": 3210.61,
        "doubleCheck": true
    },
    {
        "dataID": "118807",
        "id": "53114668",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:44",
        "brokerTime": "2025-05-14 15:17:44",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068991",
        "positionId": "56068991",
        "volume": 12.61,
        "price": 3210.65,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.27,
        "priceIn": 3210.65,
        "doubleCheck": true
    },
    {
        "dataID": "118808",
        "id": "53114669",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:44",
        "brokerTime": "2025-05-14 15:17:45",
        "commission": -88.27,
        "swap": 0,
        "profit": -403.52,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068992",
        "positionId": "56068991",
        "volume": 12.61,
        "price": 3210.97,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -491.78999999999996,
        "priceIn": 3210.65,
        "doubleCheck": true
    },
    {
        "dataID": "118809",
        "id": "53114670",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:45",
        "brokerTime": "2025-05-14 15:17:45",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068993",
        "positionId": "56068993",
        "volume": 12.61,
        "price": 3210.9,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.27,
        "priceIn": 3210.9,
        "doubleCheck": true
    },
    {
        "dataID": "118810",
        "id": "53114671",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:45",
        "brokerTime": "2025-05-14 15:17:46",
        "commission": -88.27,
        "swap": 0,
        "profit": -88.27,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068994",
        "positionId": "56068993",
        "volume": 12.61,
        "price": 3210.97,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -176.54,
        "priceIn": 3210.9,
        "doubleCheck": true
    },
    {
        "dataID": "118811",
        "id": "53114672",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:46",
        "brokerTime": "2025-05-14 15:17:46",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068995",
        "positionId": "56068995",
        "volume": 12.61,
        "price": 3210.6,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.27,
        "priceIn": 3210.6,
        "doubleCheck": true
    },
    {
        "dataID": "118812",
        "id": "53114673",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:46",
        "brokerTime": "2025-05-14 15:17:47",
        "commission": -88.27,
        "swap": 0,
        "profit": -390.91,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068996",
        "positionId": "56068995",
        "volume": 12.61,
        "price": 3210.91,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -479.18,
        "priceIn": 3210.6,
        "doubleCheck": true
    },
    {
        "dataID": "118813",
        "id": "53114674",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:47",
        "brokerTime": "2025-05-14 15:17:47",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068997",
        "positionId": "56068997",
        "volume": 12.61,
        "price": 3210.79,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.27,
        "priceIn": 3210.79,
        "doubleCheck": true
    },
    {
        "dataID": "118814",
        "id": "53114675",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:47",
        "brokerTime": "2025-05-14 15:17:48",
        "commission": -88.27,
        "swap": 0,
        "profit": 50.44,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068998",
        "positionId": "56068997",
        "volume": 12.61,
        "price": 3210.75,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -37.83,
        "priceIn": 3210.79,
        "doubleCheck": true
    },
    {
        "dataID": "118815",
        "id": "53114676",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:48",
        "brokerTime": "2025-05-14 15:17:48",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56068999",
        "positionId": "56068999",
        "volume": 12.61,
        "price": 3210.59,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.27,
        "priceIn": 3210.59,
        "doubleCheck": true
    },
    {
        "dataID": "118816",
        "id": "53114677",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:48",
        "brokerTime": "2025-05-14 15:17:48",
        "commission": -88.27,
        "swap": 0,
        "profit": -290.03,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56069000",
        "positionId": "56068999",
        "volume": 12.61,
        "price": 3210.82,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -378.29999999999995,
        "priceIn": 3210.59,
        "doubleCheck": true
    },
    {
        "dataID": "118817",
        "id": "53114678",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:49",
        "brokerTime": "2025-05-14 15:17:49",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56069001",
        "positionId": "56069001",
        "volume": 12.61,
        "price": 3210.54,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.27,
        "priceIn": 3210.54,
        "doubleCheck": true
    },
    {
        "dataID": "118818",
        "id": "53114684",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:49",
        "brokerTime": "2025-05-14 15:17:49",
        "commission": -88.27,
        "swap": 0,
        "profit": -353.08,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56069007",
        "positionId": "56069001",
        "volume": 12.61,
        "price": 3210.82,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -441.34999999999997,
        "priceIn": 3210.54,
        "doubleCheck": true
    },
    {
        "dataID": "118819",
        "id": "53114687",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:50",
        "brokerTime": "2025-05-14 15:17:50",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56069009",
        "positionId": "56069009",
        "volume": 12.61,
        "price": 3210.81,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.27,
        "priceIn": 3210.81,
        "doubleCheck": true
    },
    {
        "dataID": "118820",
        "id": "53114689",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:50",
        "brokerTime": "2025-05-14 15:17:50",
        "commission": -88.27,
        "swap": 0,
        "profit": -151.32,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56069011",
        "positionId": "56069009",
        "volume": 12.61,
        "price": 3210.93,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -239.58999999999997,
        "priceIn": 3210.81,
        "doubleCheck": true
    },
    {
        "dataID": "118821",
        "id": "53114690",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:50",
        "brokerTime": "2025-05-14 15:17:50",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56069012",
        "positionId": "56069012",
        "volume": 12.61,
        "price": 3210.72,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.27,
        "priceIn": 3210.72,
        "doubleCheck": true
    },
    {
        "dataID": "118822",
        "id": "53114691",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:50",
        "brokerTime": "2025-05-14 15:17:51",
        "commission": -88.27,
        "swap": 0,
        "profit": -592.67,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56069013",
        "positionId": "56069012",
        "volume": 12.61,
        "price": 3211.19,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -680.9399999999999,
        "priceIn": 3210.72,
        "doubleCheck": true
    },
    {
        "dataID": "118823",
        "id": "53114692",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:52",
        "brokerTime": "2025-05-14 15:17:52",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56069014",
        "positionId": "56069014",
        "volume": 12.61,
        "price": 3210.8,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.27,
        "priceIn": 3210.8,
        "doubleCheck": true
    },
    {
        "dataID": "118824",
        "id": "53114693",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:52",
        "brokerTime": "2025-05-14 15:17:52",
        "commission": -88.27,
        "swap": 0,
        "profit": -239.59,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56069015",
        "positionId": "56069014",
        "volume": 12.61,
        "price": 3210.99,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -327.86,
        "priceIn": 3210.8,
        "doubleCheck": true
    },
    {
        "dataID": "118825",
        "id": "53114694",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:52",
        "brokerTime": "2025-05-14 15:17:52",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56069016",
        "positionId": "56069016",
        "volume": 12.61,
        "price": 3210.81,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.27,
        "priceIn": 3210.81,
        "doubleCheck": true
    },
    {
        "dataID": "118826",
        "id": "53114695",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:52",
        "brokerTime": "2025-05-14 15:17:53",
        "commission": -88.27,
        "swap": 0,
        "profit": 151.32,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56069049",
        "positionId": "56069016",
        "volume": 12.61,
        "price": 3210.69,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 63.05,
        "priceIn": 3210.81,
        "doubleCheck": true
    },
    {
        "dataID": "118827",
        "id": "53114728",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:53",
        "brokerTime": "2025-05-14 15:17:53",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56069050",
        "positionId": "56069050",
        "volume": 12.61,
        "price": 3210.47,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.27,
        "priceIn": 3210.47,
        "doubleCheck": true
    },
    {
        "dataID": "118828",
        "id": "53114729",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:53",
        "brokerTime": "2025-05-14 15:17:53",
        "commission": -88.27,
        "swap": 0,
        "profit": -302.64,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56069051",
        "positionId": "56069050",
        "volume": 12.61,
        "price": 3210.71,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -390.90999999999997,
        "priceIn": 3210.47,
        "doubleCheck": true
    },
    {
        "dataID": "118829",
        "id": "53114730",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:54",
        "brokerTime": "2025-05-14 15:17:54",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56069052",
        "positionId": "56069052",
        "volume": 12.61,
        "price": 3210.55,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.27,
        "priceIn": 3210.55,
        "doubleCheck": true
    },
    {
        "dataID": "118830",
        "id": "53114732",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:54",
        "brokerTime": "2025-05-14 15:17:54",
        "commission": -88.27,
        "swap": 0,
        "profit": -201.76,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56069054",
        "positionId": "56069052",
        "volume": 12.61,
        "price": 3210.71,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -290.03,
        "priceIn": 3210.55,
        "doubleCheck": true
    },
    {
        "dataID": "118831",
        "id": "53114733",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:54",
        "brokerTime": "2025-05-14 15:17:54",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56069055",
        "positionId": "56069055",
        "volume": 12.61,
        "price": 3210.46,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.27,
        "priceIn": 3210.46,
        "doubleCheck": true
    },
    {
        "dataID": "118832",
        "id": "53114734",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:54",
        "brokerTime": "2025-05-14 15:17:55",
        "commission": -88.27,
        "swap": 0,
        "profit": -290.03,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56069056",
        "positionId": "56069055",
        "volume": 12.61,
        "price": 3210.69,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -378.29999999999995,
        "priceIn": 3210.46,
        "doubleCheck": true
    },
    {
        "dataID": "118833",
        "id": "53114735",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:55",
        "brokerTime": "2025-05-14 15:17:55",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56069057",
        "positionId": "56069057",
        "volume": 12.61,
        "price": 3210.46,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.27,
        "priceIn": 3210.46,
        "doubleCheck": true
    },
    {
        "dataID": "118834",
        "id": "53114736",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:55",
        "brokerTime": "2025-05-14 15:17:56",
        "commission": -88.27,
        "swap": 0,
        "profit": -50.44,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56069058",
        "positionId": "56069057",
        "volume": 12.61,
        "price": 3210.5,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -138.70999999999998,
        "priceIn": 3210.46,
        "doubleCheck": true
    },
    {
        "dataID": "118835",
        "id": "53114737",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:56",
        "brokerTime": "2025-05-14 15:17:56",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56069059",
        "positionId": "56069059",
        "volume": 12.61,
        "price": 3210.28,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.27,
        "priceIn": 3210.28,
        "doubleCheck": true
    },
    {
        "dataID": "118836",
        "id": "53114738",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:56",
        "brokerTime": "2025-05-14 15:17:56",
        "commission": -88.27,
        "swap": 0,
        "profit": -302.64,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56069060",
        "positionId": "56069059",
        "volume": 12.61,
        "price": 3210.52,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -390.90999999999997,
        "priceIn": 3210.28,
        "doubleCheck": true
    },
    {
        "dataID": "118837",
        "id": "53114739",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:57",
        "brokerTime": "2025-05-14 15:17:57",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56069061",
        "positionId": "56069061",
        "volume": 12.61,
        "price": 3210.35,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.27,
        "priceIn": 3210.35,
        "doubleCheck": true
    },
    {
        "dataID": "118838",
        "id": "53114744",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:58",
        "brokerTime": "2025-05-14 15:17:58",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56069066",
        "positionId": "56069066",
        "volume": 12.61,
        "price": 3209.68,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.27,
        "priceIn": 3209.68,
        "doubleCheck": true
    },
    {
        "dataID": "118839",
        "id": "53114747",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:58",
        "brokerTime": "2025-05-14 15:17:59",
        "commission": -88.27,
        "swap": 0,
        "profit": -226.98,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56069068",
        "positionId": "56069066",
        "volume": 12.61,
        "price": 3209.86,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -315.25,
        "priceIn": 3209.68,
        "doubleCheck": true
    },
    {
        "dataID": "118840",
        "id": "53114749",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:59",
        "brokerTime": "2025-05-14 15:17:59",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56069070",
        "positionId": "56069070",
        "volume": 12.61,
        "price": 3209.69,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.27,
        "priceIn": 3209.69,
        "doubleCheck": true
    },
    {
        "dataID": "118841",
        "id": "53114837",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:59",
        "brokerTime": "2025-05-14 15:18:00",
        "commission": -88.27,
        "swap": 0,
        "profit": -403.52,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56069140",
        "positionId": "56069070",
        "volume": 12.61,
        "price": 3210.01,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -491.78999999999996,
        "priceIn": 3209.69,
        "doubleCheck": true
    },
    {
        "dataID": "118842",
        "id": "53114920",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:01",
        "brokerTime": "2025-05-14 15:18:01",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56069224",
        "positionId": "56069224",
        "volume": 12.61,
        "price": 3209.66,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.27,
        "priceIn": 3209.66,
        "doubleCheck": true
    },
    {
        "dataID": "118843",
        "id": "53114962",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:01",
        "brokerTime": "2025-05-14 15:18:01",
        "commission": -88.27,
        "swap": 0,
        "profit": -378.3,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56069257",
        "positionId": "56069224",
        "volume": 12.61,
        "price": 3209.96,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -466.57,
        "priceIn": 3209.66,
        "doubleCheck": true
    },
    {
        "dataID": "118844",
        "id": "53115003",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:01",
        "brokerTime": "2025-05-14 15:18:01",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56069299",
        "positionId": "56069299",
        "volume": 12.61,
        "price": 3209.59,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.27,
        "priceIn": 3209.59,
        "doubleCheck": true
    },
    {
        "dataID": "118845",
        "id": "53115213",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:01",
        "brokerTime": "2025-05-14 15:18:02",
        "commission": -88.27,
        "swap": 0,
        "profit": -151.32,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56069529",
        "positionId": "56069299",
        "volume": 12.61,
        "price": 3209.71,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -239.58999999999997,
        "priceIn": 3209.59,
        "doubleCheck": true
    },
    {
        "dataID": "118846",
        "id": "53115533",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:03",
        "brokerTime": "2025-05-14 15:18:03",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56069679",
        "positionId": "56069679",
        "volume": 12.61,
        "price": 3209.54,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.27,
        "priceIn": 3209.54,
        "doubleCheck": true
    },
    {
        "dataID": "118847",
        "id": "53115656",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:03",
        "brokerTime": "2025-05-14 15:18:03",
        "commission": -88.27,
        "swap": 0,
        "profit": -113.49,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56069793",
        "positionId": "56069679",
        "volume": 12.61,
        "price": 3209.63,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -201.76,
        "priceIn": 3209.54,
        "doubleCheck": true
    },
    {
        "dataID": "118848",
        "id": "53115719",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:04",
        "brokerTime": "2025-05-14 15:18:04",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56069836",
        "positionId": "56069836",
        "volume": 12.61,
        "price": 3209.31,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.27,
        "priceIn": 3209.31,
        "doubleCheck": true
    },
    {
        "dataID": "118849",
        "id": "53115772",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:04",
        "brokerTime": "2025-05-14 15:18:04",
        "commission": -88.27,
        "swap": 0,
        "profit": -340.47,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56069888",
        "positionId": "56069836",
        "volume": 12.61,
        "price": 3209.58,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -428.74,
        "priceIn": 3209.31,
        "doubleCheck": true
    },
    {
        "dataID": "118850",
        "id": "53115786",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:04",
        "brokerTime": "2025-05-14 15:18:04",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56069899",
        "positionId": "56069899",
        "volume": 12.61,
        "price": 3209.3,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.27,
        "priceIn": 3209.3,
        "doubleCheck": true
    },
    {
        "dataID": "118851",
        "id": "53115836",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:04",
        "brokerTime": "2025-05-14 15:18:05",
        "commission": -88.27,
        "swap": 0,
        "profit": -239.59,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56069952",
        "positionId": "56069899",
        "volume": 12.61,
        "price": 3209.49,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -327.86,
        "priceIn": 3209.3,
        "doubleCheck": true
    },
    {
        "dataID": "118852",
        "id": "53115852",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:05",
        "brokerTime": "2025-05-14 15:18:05",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56069975",
        "positionId": "56069975",
        "volume": 12.61,
        "price": 3209.18,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.27,
        "priceIn": 3209.18,
        "doubleCheck": true
    },
    {
        "dataID": "118853",
        "id": "53115883",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:05",
        "brokerTime": "2025-05-14 15:18:06",
        "commission": -88.27,
        "swap": 0,
        "profit": -441.35,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56069994",
        "positionId": "56069975",
        "volume": 12.61,
        "price": 3209.53,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -529.62,
        "priceIn": 3209.18,
        "doubleCheck": true
    },
    {
        "dataID": "118854",
        "id": "53115890",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:06",
        "brokerTime": "2025-05-14 15:18:06",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070002",
        "positionId": "56070002",
        "volume": 12.61,
        "price": 3209.22,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.27,
        "priceIn": 3209.22,
        "doubleCheck": true
    },
    {
        "dataID": "118855",
        "id": "53115939",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:06",
        "brokerTime": "2025-05-14 15:18:06",
        "commission": -88.27,
        "swap": 0,
        "profit": -353.08,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070046",
        "positionId": "56070002",
        "volume": 12.61,
        "price": 3209.5,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -441.34999999999997,
        "priceIn": 3209.22,
        "doubleCheck": true
    },
    {
        "dataID": "118856",
        "id": "53115960",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:06",
        "brokerTime": "2025-05-14 15:18:06",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070072",
        "positionId": "56070072",
        "volume": 12.61,
        "price": 3209.46,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.27,
        "priceIn": 3209.46,
        "doubleCheck": true
    },
    {
        "dataID": "118857",
        "id": "53116033",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:06",
        "brokerTime": "2025-05-14 15:18:07",
        "commission": -88.27,
        "swap": 0,
        "profit": -277.42,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070141",
        "positionId": "56070072",
        "volume": 12.61,
        "price": 3209.68,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -365.69,
        "priceIn": 3209.46,
        "doubleCheck": true
    },
    {
        "dataID": "118858",
        "id": "53116049",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:07",
        "brokerTime": "2025-05-14 15:18:07",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070159",
        "positionId": "56070159",
        "volume": 12.61,
        "price": 3209.47,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.27,
        "priceIn": 3209.47,
        "doubleCheck": true
    },
    {
        "dataID": "118859",
        "id": "53116082",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:07",
        "brokerTime": "2025-05-14 15:18:08",
        "commission": -88.27,
        "swap": 0,
        "profit": -327.86,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070196",
        "positionId": "56070159",
        "volume": 12.61,
        "price": 3209.73,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -416.13,
        "priceIn": 3209.47,
        "doubleCheck": true
    },
    {
        "dataID": "118860",
        "id": "53116106",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:08",
        "brokerTime": "2025-05-14 15:18:08",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070208",
        "positionId": "56070208",
        "volume": 12.61,
        "price": 3209.36,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.27,
        "priceIn": 3209.36,
        "doubleCheck": true
    },
    {
        "dataID": "118861",
        "id": "53116131",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:08",
        "brokerTime": "2025-05-14 15:18:09",
        "commission": -88.27,
        "swap": 0,
        "profit": -252.2,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070236",
        "positionId": "56070208",
        "volume": 12.61,
        "price": 3209.56,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -340.46999999999997,
        "priceIn": 3209.36,
        "doubleCheck": true
    },
    {
        "dataID": "118862",
        "id": "53116156",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:09",
        "brokerTime": "2025-05-14 15:18:09",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070254",
        "positionId": "56070254",
        "volume": 12.61,
        "price": 3210,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.27,
        "priceIn": 3210,
        "doubleCheck": true
    },
    {
        "dataID": "118863",
        "id": "53116194",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:09",
        "brokerTime": "2025-05-14 15:18:10",
        "commission": -88.27,
        "swap": 0,
        "profit": 214.37,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070292",
        "positionId": "56070254",
        "volume": 12.61,
        "price": 3209.83,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 126.10000000000001,
        "priceIn": 3210,
        "doubleCheck": true
    },
    {
        "dataID": "118864",
        "id": "53116208",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:11",
        "brokerTime": "2025-05-14 15:18:11",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070309",
        "positionId": "56070309",
        "volume": 12.61,
        "price": 3209.75,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.27,
        "priceIn": 3209.75,
        "doubleCheck": true
    },
    {
        "dataID": "118865",
        "id": "53116232",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:11",
        "brokerTime": "2025-05-14 15:18:11",
        "commission": -88.27,
        "swap": 0,
        "profit": -63.05,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070329",
        "positionId": "56070309",
        "volume": 12.61,
        "price": 3209.8,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -151.32,
        "priceIn": 3209.75,
        "doubleCheck": true
    },
    {
        "dataID": "118866",
        "id": "53116242",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:11",
        "brokerTime": "2025-05-14 15:18:11",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070337",
        "positionId": "56070337",
        "volume": 12.61,
        "price": 3209.63,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.27,
        "priceIn": 3209.63,
        "doubleCheck": true
    },
    {
        "dataID": "118867",
        "id": "53116261",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:11",
        "brokerTime": "2025-05-14 15:18:12",
        "commission": -88.27,
        "swap": 0,
        "profit": -353.08,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070356",
        "positionId": "56070337",
        "volume": 12.61,
        "price": 3209.91,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -441.34999999999997,
        "priceIn": 3209.63,
        "doubleCheck": true
    },
    {
        "dataID": "118868",
        "id": "53116289",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:12",
        "brokerTime": "2025-05-14 15:18:12",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070382",
        "positionId": "56070382",
        "volume": 12.61,
        "price": 3209.79,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.27,
        "priceIn": 3209.79,
        "doubleCheck": true
    },
    {
        "dataID": "118869",
        "id": "53116312",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:12",
        "brokerTime": "2025-05-14 15:18:13",
        "commission": -88.27,
        "swap": 0,
        "profit": 12.61,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070406",
        "positionId": "56070382",
        "volume": 12.61,
        "price": 3209.78,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -75.66,
        "priceIn": 3209.79,
        "doubleCheck": true
    },
    {
        "dataID": "118870",
        "id": "53116340",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:13",
        "brokerTime": "2025-05-14 15:18:13",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070432",
        "positionId": "56070432",
        "volume": 12.61,
        "price": 3209.52,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.27,
        "priceIn": 3209.52,
        "doubleCheck": true
    },
    {
        "dataID": "118871",
        "id": "53116352",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:13",
        "brokerTime": "2025-05-14 15:18:14",
        "commission": -88.27,
        "swap": 0,
        "profit": -340.47,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070443",
        "positionId": "56070432",
        "volume": 12.61,
        "price": 3209.79,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -428.74,
        "priceIn": 3209.52,
        "doubleCheck": true
    },
    {
        "dataID": "118872",
        "id": "53116382",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:14",
        "brokerTime": "2025-05-14 15:18:14",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070471",
        "positionId": "56070471",
        "volume": 12.61,
        "price": 3209.33,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.27,
        "priceIn": 3209.33,
        "doubleCheck": true
    },
    {
        "dataID": "118873",
        "id": "53116388",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:14",
        "brokerTime": "2025-05-14 15:18:14",
        "commission": -88.27,
        "swap": 0,
        "profit": -113.49,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070475",
        "positionId": "56070471",
        "volume": 12.61,
        "price": 3209.42,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -201.76,
        "priceIn": 3209.33,
        "doubleCheck": true
    },
    {
        "dataID": "118874",
        "id": "53116413",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:15",
        "brokerTime": "2025-05-14 15:18:15",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070501",
        "positionId": "56070501",
        "volume": 12.61,
        "price": 3209.27,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.27,
        "priceIn": 3209.27,
        "doubleCheck": true
    },
    {
        "dataID": "118875",
        "id": "53116431",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:15",
        "brokerTime": "2025-05-14 15:18:16",
        "commission": -88.27,
        "swap": 0,
        "profit": -441.35,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070518",
        "positionId": "56070501",
        "volume": 12.61,
        "price": 3209.62,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -529.62,
        "priceIn": 3209.27,
        "doubleCheck": true
    },
    {
        "dataID": "118876",
        "id": "53116437",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:16",
        "brokerTime": "2025-05-14 15:18:16",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070521",
        "positionId": "56070521",
        "volume": 12.61,
        "price": 3209.39,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.27,
        "priceIn": 3209.39,
        "doubleCheck": true
    },
    {
        "dataID": "118877",
        "id": "53116438",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:16",
        "brokerTime": "2025-05-14 15:18:16",
        "commission": -88.27,
        "swap": 0,
        "profit": -290.03,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070523",
        "positionId": "56070521",
        "volume": 12.61,
        "price": 3209.62,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -378.29999999999995,
        "priceIn": 3209.39,
        "doubleCheck": true
    },
    {
        "dataID": "118878",
        "id": "53116440",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:17",
        "brokerTime": "2025-05-14 15:18:17",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070524",
        "positionId": "56070524",
        "volume": 12.61,
        "price": 3209.44,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.27,
        "priceIn": 3209.44,
        "doubleCheck": true
    },
    {
        "dataID": "118879",
        "id": "53116441",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:17",
        "brokerTime": "2025-05-14 15:18:17",
        "commission": -88.27,
        "swap": 0,
        "profit": -441.35,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070525",
        "positionId": "56070524",
        "volume": 12.61,
        "price": 3209.79,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -529.62,
        "priceIn": 3209.44,
        "doubleCheck": true
    },
    {
        "dataID": "118880",
        "id": "53116443",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:17",
        "brokerTime": "2025-05-14 15:18:17",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070527",
        "positionId": "56070527",
        "volume": 12.61,
        "price": 3209.66,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.27,
        "priceIn": 3209.66,
        "doubleCheck": true
    },
    {
        "dataID": "118881",
        "id": "53116445",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:17",
        "brokerTime": "2025-05-14 15:18:18",
        "commission": -88.27,
        "swap": 0,
        "profit": -302.64,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070529",
        "positionId": "56070527",
        "volume": 12.61,
        "price": 3209.9,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -390.90999999999997,
        "priceIn": 3209.66,
        "doubleCheck": true
    },
    {
        "dataID": "118882",
        "id": "53116446",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:18",
        "brokerTime": "2025-05-14 15:18:18",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070531",
        "positionId": "56070531",
        "volume": 12.61,
        "price": 3209.69,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.27,
        "priceIn": 3209.69,
        "doubleCheck": true
    },
    {
        "dataID": "118883",
        "id": "53116449",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:18",
        "brokerTime": "2025-05-14 15:18:19",
        "commission": -88.27,
        "swap": 0,
        "profit": -176.54,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070533",
        "positionId": "56070531",
        "volume": 12.61,
        "price": 3209.83,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -264.81,
        "priceIn": 3209.69,
        "doubleCheck": true
    },
    {
        "dataID": "118884",
        "id": "53116451",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:19",
        "brokerTime": "2025-05-14 15:18:19",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070535",
        "positionId": "56070535",
        "volume": 12.61,
        "price": 3209.67,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.27,
        "priceIn": 3209.67,
        "doubleCheck": true
    },
    {
        "dataID": "118885",
        "id": "53116458",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:19",
        "brokerTime": "2025-05-14 15:18:20",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070540",
        "positionId": "56070535",
        "volume": 12.61,
        "price": 3209.67,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.27,
        "priceIn": 3209.67,
        "doubleCheck": true
    },
    {
        "dataID": "118886",
        "id": "53116459",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:20",
        "brokerTime": "2025-05-14 15:18:20",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070541",
        "positionId": "56070541",
        "volume": 12.61,
        "price": 3209.39,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.27,
        "priceIn": 3209.39,
        "doubleCheck": true
    },
    {
        "dataID": "118887",
        "id": "53116460",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:20",
        "brokerTime": "2025-05-14 15:18:21",
        "commission": -88.27,
        "swap": 0,
        "profit": -554.84,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070542",
        "positionId": "56070541",
        "volume": 12.61,
        "price": 3209.83,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -643.11,
        "priceIn": 3209.39,
        "doubleCheck": true
    },
    {
        "dataID": "118888",
        "id": "53116461",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:21",
        "brokerTime": "2025-05-14 15:18:21",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070543",
        "positionId": "56070543",
        "volume": 12.61,
        "price": 3209.64,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.27,
        "priceIn": 3209.64,
        "doubleCheck": true
    },
    {
        "dataID": "118889",
        "id": "53116462",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:21",
        "brokerTime": "2025-05-14 15:18:21",
        "commission": -88.27,
        "swap": 0,
        "profit": -75.66,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070544",
        "positionId": "56070543",
        "volume": 12.61,
        "price": 3209.7,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -163.93,
        "priceIn": 3209.64,
        "doubleCheck": true
    },
    {
        "dataID": "118890",
        "id": "53116463",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:22",
        "brokerTime": "2025-05-14 15:18:22",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070545",
        "positionId": "56070545",
        "volume": 12.61,
        "price": 3209.44,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.27,
        "priceIn": 3209.44,
        "doubleCheck": true
    },
    {
        "dataID": "118891",
        "id": "53116464",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:22",
        "brokerTime": "2025-05-14 15:18:23",
        "commission": -88.27,
        "swap": 0,
        "profit": -302.64,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070546",
        "positionId": "56070545",
        "volume": 12.61,
        "price": 3209.68,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -390.90999999999997,
        "priceIn": 3209.44,
        "doubleCheck": true
    },
    {
        "dataID": "118892",
        "id": "53116465",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:23",
        "brokerTime": "2025-05-14 15:18:23",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070547",
        "positionId": "56070547",
        "volume": 12.61,
        "price": 3209.33,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.27,
        "priceIn": 3209.33,
        "doubleCheck": true
    },
    {
        "dataID": "118893",
        "id": "53116467",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:23",
        "brokerTime": "2025-05-14 15:18:23",
        "commission": -88.27,
        "swap": 0,
        "profit": -88.27,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070549",
        "positionId": "56070547",
        "volume": 12.61,
        "price": 3209.4,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -176.54,
        "priceIn": 3209.33,
        "doubleCheck": true
    },
    {
        "dataID": "118894",
        "id": "53116477",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:24",
        "brokerTime": "2025-05-14 15:18:24",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070558",
        "positionId": "56070558",
        "volume": 12.61,
        "price": 3209.05,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.27,
        "priceIn": 3209.05,
        "doubleCheck": true
    },
    {
        "dataID": "118895",
        "id": "53116484",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:24",
        "brokerTime": "2025-05-14 15:18:24",
        "commission": -88.27,
        "swap": 0,
        "profit": -239.59,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070565",
        "positionId": "56070558",
        "volume": 12.61,
        "price": 3209.24,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -327.86,
        "priceIn": 3209.05,
        "doubleCheck": true
    },
    {
        "dataID": "118896",
        "id": "53116487",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:25",
        "brokerTime": "2025-05-14 15:18:25",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070567",
        "positionId": "56070567",
        "volume": 12.61,
        "price": 3209.31,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.27,
        "priceIn": 3209.31,
        "doubleCheck": true
    },
    {
        "dataID": "118897",
        "id": "53116488",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:25",
        "brokerTime": "2025-05-14 15:18:25",
        "commission": -88.27,
        "swap": 0,
        "profit": -277.42,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070568",
        "positionId": "56070567",
        "volume": 12.61,
        "price": 3209.53,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -365.69,
        "priceIn": 3209.31,
        "doubleCheck": true
    },
    {
        "dataID": "118898",
        "id": "53116492",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:25",
        "brokerTime": "2025-05-14 15:18:25",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070573",
        "positionId": "56070573",
        "volume": 12.61,
        "price": 3209.39,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.27,
        "priceIn": 3209.39,
        "doubleCheck": true
    },
    {
        "dataID": "118899",
        "id": "53116495",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:25",
        "brokerTime": "2025-05-14 15:18:26",
        "commission": -88.27,
        "swap": 0,
        "profit": -504.4,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070574",
        "positionId": "56070573",
        "volume": 12.61,
        "price": 3209.79,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -592.67,
        "priceIn": 3209.39,
        "doubleCheck": true
    },
    {
        "dataID": "118900",
        "id": "53116496",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:27",
        "brokerTime": "2025-05-14 15:18:27",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070575",
        "positionId": "56070575",
        "volume": 12.61,
        "price": 3209.82,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.27,
        "priceIn": 3209.82,
        "doubleCheck": true
    },
    {
        "dataID": "118901",
        "id": "53116497",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:27",
        "brokerTime": "2025-05-14 15:18:27",
        "commission": -88.27,
        "swap": 0,
        "profit": -226.98,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070576",
        "positionId": "56070575",
        "volume": 12.61,
        "price": 3210,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -315.25,
        "priceIn": 3209.82,
        "doubleCheck": true
    },
    {
        "dataID": "118902",
        "id": "53116499",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:28",
        "brokerTime": "2025-05-14 15:18:28",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070578",
        "positionId": "56070578",
        "volume": 12.61,
        "price": 3210.02,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.27,
        "priceIn": 3210.02,
        "doubleCheck": true
    },
    {
        "dataID": "118903",
        "id": "53116501",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:28",
        "brokerTime": "2025-05-14 15:18:28",
        "commission": -88.27,
        "swap": 0,
        "profit": 88.27,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070580",
        "positionId": "56070578",
        "volume": 12.61,
        "price": 3209.95,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 0,
        "priceIn": 3210.02,
        "doubleCheck": true
    },
    {
        "dataID": "118904",
        "id": "53116502",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:29",
        "brokerTime": "2025-05-14 15:18:29",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070581",
        "positionId": "56070581",
        "volume": 12.61,
        "price": 3209.52,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.27,
        "priceIn": 3209.52,
        "doubleCheck": true
    },
    {
        "dataID": "118905",
        "id": "53116503",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:29",
        "brokerTime": "2025-05-14 15:18:29",
        "commission": -88.27,
        "swap": 0,
        "profit": -226.98,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070582",
        "positionId": "56070581",
        "volume": 12.61,
        "price": 3209.7,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -315.25,
        "priceIn": 3209.52,
        "doubleCheck": true
    },
    {
        "dataID": "118906",
        "id": "53116504",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:30",
        "brokerTime": "2025-05-14 15:18:30",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070583",
        "positionId": "56070583",
        "volume": 12.61,
        "price": 3209.42,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.27,
        "priceIn": 3209.42,
        "doubleCheck": true
    },
    {
        "dataID": "118907",
        "id": "53116505",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:30",
        "brokerTime": "2025-05-14 15:18:30",
        "commission": -88.27,
        "swap": 0,
        "profit": 315.25,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070584",
        "positionId": "56070583",
        "volume": 12.61,
        "price": 3209.17,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 226.98000000000002,
        "priceIn": 3209.42,
        "doubleCheck": true
    },
    {
        "dataID": "118908",
        "id": "53116506",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:31",
        "brokerTime": "2025-05-14 15:18:31",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070585",
        "positionId": "56070585",
        "volume": 12.61,
        "price": 3209.21,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.27,
        "priceIn": 3209.21,
        "doubleCheck": true
    },
    {
        "dataID": "118909",
        "id": "53116508",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:31",
        "brokerTime": "2025-05-14 15:18:31",
        "commission": -88.27,
        "swap": 0,
        "profit": -239.59,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070587",
        "positionId": "56070585",
        "volume": 12.61,
        "price": 3209.4,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -327.86,
        "priceIn": 3209.21,
        "doubleCheck": true
    },
    {
        "dataID": "118910",
        "id": "53116510",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:32",
        "brokerTime": "2025-05-14 15:18:32",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070589",
        "positionId": "56070589",
        "volume": 12.61,
        "price": 3209.12,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.27,
        "priceIn": 3209.12,
        "doubleCheck": true
    },
    {
        "dataID": "118911",
        "id": "53116511",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:32",
        "brokerTime": "2025-05-14 15:18:32",
        "commission": -88.27,
        "swap": 0,
        "profit": -226.98,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070590",
        "positionId": "56070589",
        "volume": 12.61,
        "price": 3209.3,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -315.25,
        "priceIn": 3209.12,
        "doubleCheck": true
    },
    {
        "dataID": "118912",
        "id": "53116512",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:33",
        "brokerTime": "2025-05-14 15:18:33",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070591",
        "positionId": "56070591",
        "volume": 12.61,
        "price": 3209.1,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.27,
        "priceIn": 3209.1,
        "doubleCheck": true
    },
    {
        "dataID": "118913",
        "id": "53116513",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:33",
        "brokerTime": "2025-05-14 15:18:33",
        "commission": -88.27,
        "swap": 0,
        "profit": -189.15,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070592",
        "positionId": "56070591",
        "volume": 12.61,
        "price": 3209.25,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -277.42,
        "priceIn": 3209.1,
        "doubleCheck": true
    },
    {
        "dataID": "118914",
        "id": "53116514",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:33",
        "brokerTime": "2025-05-14 15:18:33",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070594",
        "positionId": "56070594",
        "volume": 12.61,
        "price": 3209,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -88.27,
        "priceIn": 3209,
        "doubleCheck": true
    },
    {
        "dataID": "118915",
        "id": "53116516",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:33",
        "brokerTime": "2025-05-14 15:18:34",
        "commission": -88.27,
        "swap": 0,
        "profit": 151.32,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070595",
        "positionId": "56070594",
        "volume": 12.61,
        "price": 3208.88,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 63.05,
        "priceIn": 3209,
        "doubleCheck": true
    },
    {
        "dataID": "118916",
        "id": "53116518",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 15:18:34",
        "brokerTime": "2025-05-14 15:18:34",
        "commission": -15.54,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070596",
        "positionId": "56070596",
        "volume": 2.22,
        "price": 3208.88,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3308.88,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -15.54,
        "priceIn": 3208.88,
        "doubleCheck": true
    },
    {
        "dataID": "118917",
        "id": "53116526",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:35",
        "brokerTime": "2025-05-14 15:18:35",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070604",
        "positionId": "56070604",
        "volume": 15.27,
        "price": 3209.05,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.89,
        "priceIn": 3209.05,
        "doubleCheck": true
    },
    {
        "dataID": "118918",
        "id": "53116529",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:35",
        "brokerTime": "2025-05-14 15:18:36",
        "commission": -106.89,
        "swap": 0,
        "profit": -656.61,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070606",
        "positionId": "56070604",
        "volume": 15.27,
        "price": 3209.48,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -763.5,
        "priceIn": 3209.05,
        "doubleCheck": true
    },
    {
        "dataID": "118919",
        "id": "53116532",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:36",
        "brokerTime": "2025-05-14 15:18:36",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070609",
        "positionId": "56070609",
        "volume": 15.27,
        "price": 3209.27,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.89,
        "priceIn": 3209.27,
        "doubleCheck": true
    },
    {
        "dataID": "118920",
        "id": "53116784",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:36",
        "brokerTime": "2025-05-14 15:18:37",
        "commission": -106.89,
        "swap": 0,
        "profit": -167.97,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070840",
        "positionId": "56070609",
        "volume": 15.27,
        "price": 3209.38,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -274.86,
        "priceIn": 3209.27,
        "doubleCheck": true
    },
    {
        "dataID": "118921",
        "id": "53116785",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:37",
        "brokerTime": "2025-05-14 15:18:37",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070841",
        "positionId": "56070841",
        "volume": 15.27,
        "price": 3208.96,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.89,
        "priceIn": 3208.96,
        "doubleCheck": true
    },
    {
        "dataID": "118922",
        "id": "53116801",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:37",
        "brokerTime": "2025-05-14 15:18:38",
        "commission": -106.89,
        "swap": 0,
        "profit": -305.4,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070856",
        "positionId": "56070841",
        "volume": 15.27,
        "price": 3209.16,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -412.28999999999996,
        "priceIn": 3208.96,
        "doubleCheck": true
    },
    {
        "dataID": "118923",
        "id": "53116810",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:38",
        "brokerTime": "2025-05-14 15:18:38",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070863",
        "positionId": "56070863",
        "volume": 15.27,
        "price": 3209.04,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.89,
        "priceIn": 3209.04,
        "doubleCheck": true
    },
    {
        "dataID": "118924",
        "id": "53116811",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:38",
        "brokerTime": "2025-05-14 15:18:39",
        "commission": -106.89,
        "swap": 0,
        "profit": -519.18,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070864",
        "positionId": "56070863",
        "volume": 15.27,
        "price": 3209.38,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -626.0699999999999,
        "priceIn": 3209.04,
        "doubleCheck": true
    },
    {
        "dataID": "118925",
        "id": "53116812",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:39",
        "brokerTime": "2025-05-14 15:18:39",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070865",
        "positionId": "56070865",
        "volume": 15.27,
        "price": 3209.22,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.89,
        "priceIn": 3209.22,
        "doubleCheck": true
    },
    {
        "dataID": "118926",
        "id": "53116813",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:39",
        "brokerTime": "2025-05-14 15:18:40",
        "commission": -106.89,
        "swap": 0,
        "profit": -1221.6,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070866",
        "positionId": "56070865",
        "volume": 15.27,
        "price": 3210.02,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -1328.49,
        "priceIn": 3209.22,
        "doubleCheck": true
    },
    {
        "dataID": "118927",
        "id": "53116815",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:40",
        "brokerTime": "2025-05-14 15:18:40",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070868",
        "positionId": "56070868",
        "volume": 15.27,
        "price": 3209.8,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.89,
        "priceIn": 3209.8,
        "doubleCheck": true
    },
    {
        "dataID": "118928",
        "id": "53116816",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:40",
        "brokerTime": "2025-05-14 15:18:40",
        "commission": -106.89,
        "swap": 0,
        "profit": -229.05,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070869",
        "positionId": "56070868",
        "volume": 15.27,
        "price": 3209.95,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -335.94,
        "priceIn": 3209.8,
        "doubleCheck": true
    },
    {
        "dataID": "118929",
        "id": "53116817",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:41",
        "brokerTime": "2025-05-14 15:18:41",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070870",
        "positionId": "56070870",
        "volume": 15.27,
        "price": 3209.64,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.89,
        "priceIn": 3209.64,
        "doubleCheck": true
    },
    {
        "dataID": "118930",
        "id": "53116818",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:41",
        "brokerTime": "2025-05-14 15:18:41",
        "commission": -106.89,
        "swap": 0,
        "profit": -381.75,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070871",
        "positionId": "56070870",
        "volume": 15.27,
        "price": 3209.89,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -488.64,
        "priceIn": 3209.64,
        "doubleCheck": true
    },
    {
        "dataID": "118931",
        "id": "53116819",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:42",
        "brokerTime": "2025-05-14 15:18:42",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070872",
        "positionId": "56070872",
        "volume": 15.27,
        "price": 3209.65,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.89,
        "priceIn": 3209.65,
        "doubleCheck": true
    },
    {
        "dataID": "118932",
        "id": "53116820",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:42",
        "brokerTime": "2025-05-14 15:18:42",
        "commission": -106.89,
        "swap": 0,
        "profit": -167.97,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070874",
        "positionId": "56070872",
        "volume": 15.27,
        "price": 3209.76,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -274.86,
        "priceIn": 3209.65,
        "doubleCheck": true
    },
    {
        "dataID": "118933",
        "id": "53116822",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:43",
        "brokerTime": "2025-05-14 15:18:43",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070875",
        "positionId": "56070875",
        "volume": 15.27,
        "price": 3209.66,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.89,
        "priceIn": 3209.66,
        "doubleCheck": true
    },
    {
        "dataID": "118934",
        "id": "53116823",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:43",
        "brokerTime": "2025-05-14 15:18:43",
        "commission": -106.89,
        "swap": 0,
        "profit": -198.51,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070876",
        "positionId": "56070875",
        "volume": 15.27,
        "price": 3209.79,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -305.4,
        "priceIn": 3209.66,
        "doubleCheck": true
    },
    {
        "dataID": "118935",
        "id": "53116824",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:44",
        "brokerTime": "2025-05-14 15:18:44",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070877",
        "positionId": "56070877",
        "volume": 15.27,
        "price": 3209.61,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.89,
        "priceIn": 3209.61,
        "doubleCheck": true
    },
    {
        "dataID": "118936",
        "id": "53116825",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:44",
        "brokerTime": "2025-05-14 15:18:44",
        "commission": -106.89,
        "swap": 0,
        "profit": -870.39,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070878",
        "positionId": "56070877",
        "volume": 15.27,
        "price": 3210.18,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -977.28,
        "priceIn": 3209.61,
        "doubleCheck": true
    },
    {
        "dataID": "118937",
        "id": "53116826",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:45",
        "brokerTime": "2025-05-14 15:18:45",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070879",
        "positionId": "56070879",
        "volume": 15.27,
        "price": 3209.92,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.89,
        "priceIn": 3209.92,
        "doubleCheck": true
    },
    {
        "dataID": "118938",
        "id": "53116827",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:45",
        "brokerTime": "2025-05-14 15:18:45",
        "commission": -106.89,
        "swap": 0,
        "profit": -412.29,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070882",
        "positionId": "56070879",
        "volume": 15.27,
        "price": 3210.19,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -519.1800000000001,
        "priceIn": 3209.92,
        "doubleCheck": true
    },
    {
        "dataID": "118939",
        "id": "53116829",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:46",
        "brokerTime": "2025-05-14 15:18:46",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070884",
        "positionId": "56070884",
        "volume": 15.27,
        "price": 3210.22,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.89,
        "priceIn": 3210.22,
        "doubleCheck": true
    },
    {
        "dataID": "118940",
        "id": "53116830",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:46",
        "brokerTime": "2025-05-14 15:18:46",
        "commission": -106.89,
        "swap": 0,
        "profit": -335.94,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070885",
        "positionId": "56070884",
        "volume": 15.27,
        "price": 3210.44,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -442.83,
        "priceIn": 3210.22,
        "doubleCheck": true
    },
    {
        "dataID": "118941",
        "id": "53116831",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:46",
        "brokerTime": "2025-05-14 15:18:46",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070886",
        "positionId": "56070886",
        "volume": 15.27,
        "price": 3210.26,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.89,
        "priceIn": 3210.26,
        "doubleCheck": true
    },
    {
        "dataID": "118942",
        "id": "53116832",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:46",
        "brokerTime": "2025-05-14 15:18:47",
        "commission": -106.89,
        "swap": 0,
        "profit": -320.67,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070887",
        "positionId": "56070886",
        "volume": 15.27,
        "price": 3210.47,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -427.56,
        "priceIn": 3210.26,
        "doubleCheck": true
    },
    {
        "dataID": "118943",
        "id": "53116834",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:48",
        "brokerTime": "2025-05-14 15:18:48",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070889",
        "positionId": "56070889",
        "volume": 15.27,
        "price": 3209.79,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.89,
        "priceIn": 3209.79,
        "doubleCheck": true
    },
    {
        "dataID": "118944",
        "id": "53116835",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:48",
        "brokerTime": "2025-05-14 15:18:48",
        "commission": -106.89,
        "swap": 0,
        "profit": -763.5,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070890",
        "positionId": "56070889",
        "volume": 15.27,
        "price": 3210.29,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -870.39,
        "priceIn": 3209.79,
        "doubleCheck": true
    },
    {
        "dataID": "118945",
        "id": "53116836",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:48",
        "brokerTime": "2025-05-14 15:18:48",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070891",
        "positionId": "56070891",
        "volume": 15.27,
        "price": 3210.16,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.89,
        "priceIn": 3210.16,
        "doubleCheck": true
    },
    {
        "dataID": "118946",
        "id": "53116837",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:48",
        "brokerTime": "2025-05-14 15:18:49",
        "commission": -106.89,
        "swap": 0,
        "profit": -366.48,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070892",
        "positionId": "56070891",
        "volume": 15.27,
        "price": 3210.4,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -473.37,
        "priceIn": 3210.16,
        "doubleCheck": true
    },
    {
        "dataID": "118947",
        "id": "53116838",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:50",
        "brokerTime": "2025-05-14 15:18:50",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070893",
        "positionId": "56070893",
        "volume": 15.27,
        "price": 3210.48,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.89,
        "priceIn": 3210.48,
        "doubleCheck": true
    },
    {
        "dataID": "118948",
        "id": "53116839",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:50",
        "brokerTime": "2025-05-14 15:18:50",
        "commission": -106.89,
        "swap": 0,
        "profit": 335.94,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070894",
        "positionId": "56070893",
        "volume": 15.27,
        "price": 3210.26,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 229.05,
        "priceIn": 3210.48,
        "doubleCheck": true
    },
    {
        "dataID": "118949",
        "id": "53116840",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:50",
        "brokerTime": "2025-05-14 15:18:50",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070895",
        "positionId": "56070895",
        "volume": 15.27,
        "price": 3210.11,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.89,
        "priceIn": 3210.11,
        "doubleCheck": true
    },
    {
        "dataID": "118950",
        "id": "53116841",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:50",
        "brokerTime": "2025-05-14 15:18:51",
        "commission": -106.89,
        "swap": 0,
        "profit": -244.32,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070896",
        "positionId": "56070895",
        "volume": 15.27,
        "price": 3210.27,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -351.21,
        "priceIn": 3210.11,
        "doubleCheck": true
    },
    {
        "dataID": "118951",
        "id": "53116842",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:51",
        "brokerTime": "2025-05-14 15:18:51",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070897",
        "positionId": "56070897",
        "volume": 15.27,
        "price": 3210.05,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.89,
        "priceIn": 3210.05,
        "doubleCheck": true
    },
    {
        "dataID": "118952",
        "id": "53116843",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:51",
        "brokerTime": "2025-05-14 15:18:52",
        "commission": -106.89,
        "swap": 0,
        "profit": -106.89,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070898",
        "positionId": "56070897",
        "volume": 15.27,
        "price": 3210.12,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -213.78,
        "priceIn": 3210.05,
        "doubleCheck": true
    },
    {
        "dataID": "118953",
        "id": "53116844",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:52",
        "brokerTime": "2025-05-14 15:18:52",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070899",
        "positionId": "56070899",
        "volume": 15.27,
        "price": 3209.91,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.89,
        "priceIn": 3209.91,
        "doubleCheck": true
    },
    {
        "dataID": "118954",
        "id": "53116845",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:52",
        "brokerTime": "2025-05-14 15:18:53",
        "commission": -106.89,
        "swap": 0,
        "profit": -1068.9,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070900",
        "positionId": "56070899",
        "volume": 15.27,
        "price": 3210.61,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -1175.7900000000002,
        "priceIn": 3209.91,
        "doubleCheck": true
    },
    {
        "dataID": "118955",
        "id": "53116846",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:53",
        "brokerTime": "2025-05-14 15:18:53",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070901",
        "positionId": "56070901",
        "volume": 15.27,
        "price": 3210.21,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.89,
        "priceIn": 3210.21,
        "doubleCheck": true
    },
    {
        "dataID": "118956",
        "id": "53116847",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:53",
        "brokerTime": "2025-05-14 15:18:54",
        "commission": -106.89,
        "swap": 0,
        "profit": 152.7,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070902",
        "positionId": "56070901",
        "volume": 15.27,
        "price": 3210.11,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 45.80999999999999,
        "priceIn": 3210.21,
        "doubleCheck": true
    },
    {
        "dataID": "118957",
        "id": "53116848",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:54",
        "brokerTime": "2025-05-14 15:18:54",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070903",
        "positionId": "56070903",
        "volume": 15.27,
        "price": 3209.9,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.89,
        "priceIn": 3209.9,
        "doubleCheck": true
    },
    {
        "dataID": "118958",
        "id": "53116849",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:54",
        "brokerTime": "2025-05-14 15:18:55",
        "commission": -106.89,
        "swap": 0,
        "profit": -335.94,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070904",
        "positionId": "56070903",
        "volume": 15.27,
        "price": 3210.12,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -442.83,
        "priceIn": 3209.9,
        "doubleCheck": true
    },
    {
        "dataID": "118959",
        "id": "53116850",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:55",
        "brokerTime": "2025-05-14 15:18:55",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070905",
        "positionId": "56070905",
        "volume": 15.27,
        "price": 3209.81,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.89,
        "priceIn": 3209.81,
        "doubleCheck": true
    },
    {
        "dataID": "118960",
        "id": "53116851",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:55",
        "brokerTime": "2025-05-14 15:18:56",
        "commission": -106.89,
        "swap": 0,
        "profit": -335.94,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070906",
        "positionId": "56070905",
        "volume": 15.27,
        "price": 3210.03,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -442.83,
        "priceIn": 3209.81,
        "doubleCheck": true
    },
    {
        "dataID": "118961",
        "id": "53116852",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:56",
        "brokerTime": "2025-05-14 15:18:56",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070907",
        "positionId": "56070907",
        "volume": 15.27,
        "price": 3209.91,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.89,
        "priceIn": 3209.91,
        "doubleCheck": true
    },
    {
        "dataID": "118962",
        "id": "53116853",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:56",
        "brokerTime": "2025-05-14 15:18:56",
        "commission": -106.89,
        "swap": 0,
        "profit": -305.4,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070908",
        "positionId": "56070907",
        "volume": 15.27,
        "price": 3210.11,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -412.28999999999996,
        "priceIn": 3209.91,
        "doubleCheck": true
    },
    {
        "dataID": "118963",
        "id": "53116854",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:57",
        "brokerTime": "2025-05-14 15:18:57",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070909",
        "positionId": "56070909",
        "volume": 15.27,
        "price": 3209.91,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.89,
        "priceIn": 3209.91,
        "doubleCheck": true
    },
    {
        "dataID": "118964",
        "id": "53116855",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:57",
        "brokerTime": "2025-05-14 15:18:57",
        "commission": -106.89,
        "swap": 0,
        "profit": -305.4,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070910",
        "positionId": "56070909",
        "volume": 15.27,
        "price": 3210.11,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -412.28999999999996,
        "priceIn": 3209.91,
        "doubleCheck": true
    },
    {
        "dataID": "118965",
        "id": "53116856",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:58",
        "brokerTime": "2025-05-14 15:18:58",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070911",
        "positionId": "56070911",
        "volume": 15.27,
        "price": 3210.08,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.89,
        "priceIn": 3210.08,
        "doubleCheck": true
    },
    {
        "dataID": "118966",
        "id": "53116857",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:58",
        "brokerTime": "2025-05-14 15:18:58",
        "commission": -106.89,
        "swap": 0,
        "profit": -656.61,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070912",
        "positionId": "56070911",
        "volume": 15.27,
        "price": 3210.51,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -763.5,
        "priceIn": 3210.08,
        "doubleCheck": true
    },
    {
        "dataID": "118967",
        "id": "53116858",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:59",
        "brokerTime": "2025-05-14 15:18:59",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070913",
        "positionId": "56070913",
        "volume": 15.27,
        "price": 3210.29,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.89,
        "priceIn": 3210.29,
        "doubleCheck": true
    },
    {
        "dataID": "118968",
        "id": "53116859",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:59",
        "brokerTime": "2025-05-14 15:19:00",
        "commission": -106.89,
        "swap": 0,
        "profit": 30.54,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070914",
        "positionId": "56070913",
        "volume": 15.27,
        "price": 3210.27,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -76.35,
        "priceIn": 3210.29,
        "doubleCheck": true
    },
    {
        "dataID": "118969",
        "id": "53116862",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:00",
        "brokerTime": "2025-05-14 15:19:00",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070917",
        "positionId": "56070917",
        "volume": 15.27,
        "price": 3210.12,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.89,
        "priceIn": 3210.12,
        "doubleCheck": true
    },
    {
        "dataID": "118970",
        "id": "53116863",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:00",
        "brokerTime": "2025-05-14 15:19:01",
        "commission": -106.89,
        "swap": 0,
        "profit": -1084.17,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070919",
        "positionId": "56070917",
        "volume": 15.27,
        "price": 3210.83,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -1191.0600000000002,
        "priceIn": 3210.12,
        "doubleCheck": true
    },
    {
        "dataID": "118971",
        "id": "53116864",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:01",
        "brokerTime": "2025-05-14 15:19:01",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070920",
        "positionId": "56070920",
        "volume": 15.27,
        "price": 3210.64,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.89,
        "priceIn": 3210.64,
        "doubleCheck": true
    },
    {
        "dataID": "118972",
        "id": "53116865",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:01",
        "brokerTime": "2025-05-14 15:19:02",
        "commission": -106.89,
        "swap": 0,
        "profit": -702.42,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070921",
        "positionId": "56070920",
        "volume": 15.27,
        "price": 3211.1,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -809.31,
        "priceIn": 3210.64,
        "doubleCheck": true
    },
    {
        "dataID": "118973",
        "id": "53116866",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:03",
        "brokerTime": "2025-05-14 15:19:03",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070922",
        "positionId": "56070922",
        "volume": 15.27,
        "price": 3210.66,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.89,
        "priceIn": 3210.66,
        "doubleCheck": true
    },
    {
        "dataID": "118974",
        "id": "53116867",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:03",
        "brokerTime": "2025-05-14 15:19:03",
        "commission": -106.89,
        "swap": 0,
        "profit": -381.75,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070923",
        "positionId": "56070922",
        "volume": 15.27,
        "price": 3210.91,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -488.64,
        "priceIn": 3210.66,
        "doubleCheck": true
    },
    {
        "dataID": "118975",
        "id": "53116868",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:03",
        "brokerTime": "2025-05-14 15:19:03",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070924",
        "positionId": "56070924",
        "volume": 15.27,
        "price": 3211.06,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.89,
        "priceIn": 3211.06,
        "doubleCheck": true
    },
    {
        "dataID": "118976",
        "id": "53116870",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:03",
        "brokerTime": "2025-05-14 15:19:04",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070926",
        "positionId": "56070924",
        "volume": 15.27,
        "price": 3211.06,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.89,
        "priceIn": 3211.06,
        "doubleCheck": true
    },
    {
        "dataID": "118977",
        "id": "53116871",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:04",
        "brokerTime": "2025-05-14 15:19:04",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070927",
        "positionId": "56070927",
        "volume": 15.27,
        "price": 3210.97,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.89,
        "priceIn": 3210.97,
        "doubleCheck": true
    },
    {
        "dataID": "118978",
        "id": "53116872",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:04",
        "brokerTime": "2025-05-14 15:19:04",
        "commission": -106.89,
        "swap": 0,
        "profit": -717.69,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070928",
        "positionId": "56070927",
        "volume": 15.27,
        "price": 3211.44,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -824.58,
        "priceIn": 3210.97,
        "doubleCheck": true
    },
    {
        "dataID": "118979",
        "id": "53116874",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:05",
        "brokerTime": "2025-05-14 15:19:05",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070930",
        "positionId": "56070930",
        "volume": 15.27,
        "price": 3211.3,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.89,
        "priceIn": 3211.3,
        "doubleCheck": true
    },
    {
        "dataID": "118980",
        "id": "53116875",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:05",
        "brokerTime": "2025-05-14 15:19:05",
        "commission": -106.89,
        "swap": 0,
        "profit": -366.48,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070931",
        "positionId": "56070930",
        "volume": 15.27,
        "price": 3211.54,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -473.37,
        "priceIn": 3211.3,
        "doubleCheck": true
    },
    {
        "dataID": "118981",
        "id": "53116876",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:05",
        "brokerTime": "2025-05-14 15:19:05",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070932",
        "positionId": "56070932",
        "volume": 15.27,
        "price": 3211.34,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.89,
        "priceIn": 3211.34,
        "doubleCheck": true
    },
    {
        "dataID": "118982",
        "id": "53116879",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:05",
        "brokerTime": "2025-05-14 15:19:06",
        "commission": -106.89,
        "swap": 0,
        "profit": -122.16,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070935",
        "positionId": "56070932",
        "volume": 15.27,
        "price": 3211.42,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -229.05,
        "priceIn": 3211.34,
        "doubleCheck": true
    },
    {
        "dataID": "118983",
        "id": "53116880",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:06",
        "brokerTime": "2025-05-14 15:19:06",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070936",
        "positionId": "56070936",
        "volume": 15.27,
        "price": 3211.17,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.89,
        "priceIn": 3211.17,
        "doubleCheck": true
    },
    {
        "dataID": "118984",
        "id": "53116881",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:06",
        "brokerTime": "2025-05-14 15:19:07",
        "commission": -106.89,
        "swap": 0,
        "profit": -335.94,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070937",
        "positionId": "56070936",
        "volume": 15.27,
        "price": 3211.39,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -442.83,
        "priceIn": 3211.17,
        "doubleCheck": true
    },
    {
        "dataID": "118985",
        "id": "53116882",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:07",
        "brokerTime": "2025-05-14 15:19:07",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070938",
        "positionId": "56070938",
        "volume": 15.27,
        "price": 3211.24,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.89,
        "priceIn": 3211.24,
        "doubleCheck": true
    },
    {
        "dataID": "118986",
        "id": "53116883",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:07",
        "brokerTime": "2025-05-14 15:19:08",
        "commission": -106.89,
        "swap": 0,
        "profit": -641.34,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070939",
        "positionId": "56070938",
        "volume": 15.27,
        "price": 3211.66,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -748.23,
        "priceIn": 3211.24,
        "doubleCheck": true
    },
    {
        "dataID": "118987",
        "id": "53116884",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:08",
        "brokerTime": "2025-05-14 15:19:08",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070940",
        "positionId": "56070940",
        "volume": 15.27,
        "price": 3211.55,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.89,
        "priceIn": 3211.55,
        "doubleCheck": true
    },
    {
        "dataID": "118988",
        "id": "53116885",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:08",
        "brokerTime": "2025-05-14 15:19:08",
        "commission": -106.89,
        "swap": 0,
        "profit": -335.94,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070941",
        "positionId": "56070940",
        "volume": 15.27,
        "price": 3211.77,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -442.83,
        "priceIn": 3211.55,
        "doubleCheck": true
    },
    {
        "dataID": "118989",
        "id": "53116886",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:09",
        "brokerTime": "2025-05-14 15:19:09",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070942",
        "positionId": "56070942",
        "volume": 15.27,
        "price": 3211.55,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.89,
        "priceIn": 3211.55,
        "doubleCheck": true
    },
    {
        "dataID": "118990",
        "id": "53116887",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:09",
        "brokerTime": "2025-05-14 15:19:09",
        "commission": -106.89,
        "swap": 0,
        "profit": -656.61,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070943",
        "positionId": "56070942",
        "volume": 15.27,
        "price": 3211.98,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -763.5,
        "priceIn": 3211.55,
        "doubleCheck": true
    },
    {
        "dataID": "118991",
        "id": "53116888",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:09",
        "brokerTime": "2025-05-14 15:19:09",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070944",
        "positionId": "56070944",
        "volume": 15.27,
        "price": 3211.68,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.89,
        "priceIn": 3211.68,
        "doubleCheck": true
    },
    {
        "dataID": "118992",
        "id": "53116889",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:09",
        "brokerTime": "2025-05-14 15:19:10",
        "commission": -106.89,
        "swap": 0,
        "profit": -351.21,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070945",
        "positionId": "56070944",
        "volume": 15.27,
        "price": 3211.91,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -458.09999999999997,
        "priceIn": 3211.68,
        "doubleCheck": true
    },
    {
        "dataID": "118993",
        "id": "53116890",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:10",
        "brokerTime": "2025-05-14 15:19:10",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070946",
        "positionId": "56070946",
        "volume": 15.27,
        "price": 3211.75,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.89,
        "priceIn": 3211.75,
        "doubleCheck": true
    },
    {
        "dataID": "118994",
        "id": "53116891",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:10",
        "brokerTime": "2025-05-14 15:19:11",
        "commission": -106.89,
        "swap": 0,
        "profit": -183.24,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070947",
        "positionId": "56070946",
        "volume": 15.27,
        "price": 3211.87,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -290.13,
        "priceIn": 3211.75,
        "doubleCheck": true
    },
    {
        "dataID": "118995",
        "id": "53116892",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:11",
        "brokerTime": "2025-05-14 15:19:11",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070948",
        "positionId": "56070948",
        "volume": 15.27,
        "price": 3211.82,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.89,
        "priceIn": 3211.82,
        "doubleCheck": true
    },
    {
        "dataID": "118996",
        "id": "53116893",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:11",
        "brokerTime": "2025-05-14 15:19:11",
        "commission": -106.89,
        "swap": 0,
        "profit": -290.13,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070949",
        "positionId": "56070948",
        "volume": 15.27,
        "price": 3212.01,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -397.02,
        "priceIn": 3211.82,
        "doubleCheck": true
    },
    {
        "dataID": "118997",
        "id": "53116895",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:12",
        "brokerTime": "2025-05-14 15:19:12",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070951",
        "positionId": "56070951",
        "volume": 15.27,
        "price": 3211.8,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.89,
        "priceIn": 3211.8,
        "doubleCheck": true
    },
    {
        "dataID": "118998",
        "id": "53116897",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:12",
        "brokerTime": "2025-05-14 15:19:12",
        "commission": -106.89,
        "swap": 0,
        "profit": -473.37,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070952",
        "positionId": "56070951",
        "volume": 15.27,
        "price": 3212.11,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -580.26,
        "priceIn": 3211.8,
        "doubleCheck": true
    },
    {
        "dataID": "118999",
        "id": "53116898",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:13",
        "brokerTime": "2025-05-14 15:19:13",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070953",
        "positionId": "56070953",
        "volume": 15.27,
        "price": 3212.1,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.89,
        "priceIn": 3212.1,
        "doubleCheck": true
    },
    {
        "dataID": "119000",
        "id": "53116899",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:13",
        "brokerTime": "2025-05-14 15:19:14",
        "commission": -106.89,
        "swap": 0,
        "profit": -335.94,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070954",
        "positionId": "56070953",
        "volume": 15.27,
        "price": 3212.32,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -442.83,
        "priceIn": 3212.1,
        "doubleCheck": true
    },
    {
        "dataID": "119001",
        "id": "53116900",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:14",
        "brokerTime": "2025-05-14 15:19:14",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070955",
        "positionId": "56070955",
        "volume": 15.27,
        "price": 3212.13,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.89,
        "priceIn": 3212.13,
        "doubleCheck": true
    },
    {
        "dataID": "119002",
        "id": "53116901",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:14",
        "brokerTime": "2025-05-14 15:19:14",
        "commission": -106.89,
        "swap": 0,
        "profit": -412.29,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070956",
        "positionId": "56070955",
        "volume": 15.27,
        "price": 3212.4,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -519.1800000000001,
        "priceIn": 3212.13,
        "doubleCheck": true
    },
    {
        "dataID": "119003",
        "id": "53116902",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:15",
        "brokerTime": "2025-05-14 15:19:15",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070957",
        "positionId": "56070957",
        "volume": 15.27,
        "price": 3212.23,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.89,
        "priceIn": 3212.23,
        "doubleCheck": true
    },
    {
        "dataID": "119004",
        "id": "53116903",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:15",
        "brokerTime": "2025-05-14 15:19:15",
        "commission": -106.89,
        "swap": 0,
        "profit": -442.83,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070958",
        "positionId": "56070957",
        "volume": 15.27,
        "price": 3212.52,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -549.72,
        "priceIn": 3212.23,
        "doubleCheck": true
    },
    {
        "dataID": "119005",
        "id": "53116916",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:16",
        "brokerTime": "2025-05-14 15:19:16",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070970",
        "positionId": "56070970",
        "volume": 15.27,
        "price": 3213.36,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.89,
        "priceIn": 3213.36,
        "doubleCheck": true
    },
    {
        "dataID": "119006",
        "id": "53116919",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:16",
        "brokerTime": "2025-05-14 15:19:16",
        "commission": -106.89,
        "swap": 0,
        "profit": -183.24,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070974",
        "positionId": "56070970",
        "volume": 15.27,
        "price": 3213.48,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -290.13,
        "priceIn": 3213.36,
        "doubleCheck": true
    },
    {
        "dataID": "119007",
        "id": "53116923",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:17",
        "brokerTime": "2025-05-14 15:19:17",
        "commission": -0.84,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070977",
        "positionId": "56070977",
        "volume": 0.12,
        "price": 3213.44,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3113.25,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.84,
        "priceIn": 3213.44,
        "doubleCheck": true
    },
    {
        "dataID": "119008",
        "id": "53116924",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:17",
        "brokerTime": "2025-05-14 15:19:17",
        "commission": -106.05,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070978",
        "positionId": "56070978",
        "volume": 15.15,
        "price": 3213.64,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.05,
        "priceIn": 3213.64,
        "doubleCheck": true
    },
    {
        "dataID": "119009",
        "id": "53116926",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:17",
        "brokerTime": "2025-05-14 15:19:18",
        "commission": -106.05,
        "swap": 0,
        "profit": -1105.95,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070980",
        "positionId": "56070978",
        "volume": 15.15,
        "price": 3214.37,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -1212,
        "priceIn": 3213.64,
        "doubleCheck": true
    },
    {
        "dataID": "119010",
        "id": "53116927",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:19",
        "brokerTime": "2025-05-14 15:19:19",
        "commission": -106.05,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070981",
        "positionId": "56070981",
        "volume": 15.15,
        "price": 3214.2,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.05,
        "priceIn": 3214.2,
        "doubleCheck": true
    },
    {
        "dataID": "119011",
        "id": "53116928",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:19",
        "brokerTime": "2025-05-14 15:19:19",
        "commission": -106.05,
        "swap": 0,
        "profit": -318.15,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070983",
        "positionId": "56070981",
        "volume": 15.15,
        "price": 3214.41,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -424.2,
        "priceIn": 3214.2,
        "doubleCheck": true
    },
    {
        "dataID": "119012",
        "id": "53116929",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:20",
        "brokerTime": "2025-05-14 15:19:20",
        "commission": -106.05,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56070984",
        "positionId": "56070984",
        "volume": 15.15,
        "price": 3214.21,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.05,
        "priceIn": 3214.21,
        "doubleCheck": true
    },
    {
        "dataID": "119013",
        "id": "53116951",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:20",
        "brokerTime": "2025-05-14 15:19:20",
        "commission": -106.05,
        "swap": 0,
        "profit": -1363.5,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071001",
        "positionId": "56070984",
        "volume": 15.15,
        "price": 3215.11,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -1469.55,
        "priceIn": 3214.21,
        "doubleCheck": true
    },
    {
        "dataID": "119014",
        "id": "53116954",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:21",
        "brokerTime": "2025-05-14 15:19:21",
        "commission": -106.05,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071004",
        "positionId": "56071004",
        "volume": 15.15,
        "price": 3214.93,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.05,
        "priceIn": 3214.93,
        "doubleCheck": true
    },
    {
        "dataID": "119015",
        "id": "53116956",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:21",
        "brokerTime": "2025-05-14 15:19:21",
        "commission": -106.05,
        "swap": 0,
        "profit": -348.45,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071006",
        "positionId": "56071004",
        "volume": 15.15,
        "price": 3215.16,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -454.5,
        "priceIn": 3214.93,
        "doubleCheck": true
    },
    {
        "dataID": "119016",
        "id": "53116957",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:22",
        "brokerTime": "2025-05-14 15:19:22",
        "commission": -106.05,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071007",
        "positionId": "56071007",
        "volume": 15.15,
        "price": 3215.03,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.05,
        "priceIn": 3215.03,
        "doubleCheck": true
    },
    {
        "dataID": "119017",
        "id": "53116958",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:22",
        "brokerTime": "2025-05-14 15:19:22",
        "commission": -106.05,
        "swap": 0,
        "profit": -272.7,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071008",
        "positionId": "56071007",
        "volume": 15.15,
        "price": 3215.21,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -378.75,
        "priceIn": 3215.03,
        "doubleCheck": true
    },
    {
        "dataID": "119018",
        "id": "53116959",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:23",
        "brokerTime": "2025-05-14 15:19:23",
        "commission": -106.05,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071010",
        "positionId": "56071010",
        "volume": 15.15,
        "price": 3215.19,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.05,
        "priceIn": 3215.19,
        "doubleCheck": true
    },
    {
        "dataID": "119019",
        "id": "53116961",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:23",
        "brokerTime": "2025-05-14 15:19:24",
        "commission": -106.05,
        "swap": 0,
        "profit": -439.35,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071011",
        "positionId": "56071010",
        "volume": 15.15,
        "price": 3215.48,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -545.4,
        "priceIn": 3215.19,
        "doubleCheck": true
    },
    {
        "dataID": "119020",
        "id": "53116962",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:24",
        "brokerTime": "2025-05-14 15:19:24",
        "commission": -106.05,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071012",
        "positionId": "56071012",
        "volume": 15.15,
        "price": 3215.15,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.05,
        "priceIn": 3215.15,
        "doubleCheck": true
    },
    {
        "dataID": "119021",
        "id": "53116963",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:24",
        "brokerTime": "2025-05-14 15:19:25",
        "commission": -106.05,
        "swap": 0,
        "profit": -303,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071013",
        "positionId": "56071012",
        "volume": 15.15,
        "price": 3215.35,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -409.05,
        "priceIn": 3215.15,
        "doubleCheck": true
    },
    {
        "dataID": "119022",
        "id": "53116964",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:25",
        "brokerTime": "2025-05-14 15:19:25",
        "commission": -106.05,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071014",
        "positionId": "56071014",
        "volume": 15.15,
        "price": 3215.13,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.05,
        "priceIn": 3215.13,
        "doubleCheck": true
    },
    {
        "dataID": "119023",
        "id": "53116966",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:25",
        "brokerTime": "2025-05-14 15:19:26",
        "commission": -106.05,
        "swap": 0,
        "profit": 121.2,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071016",
        "positionId": "56071014",
        "volume": 15.15,
        "price": 3215.05,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 15.150000000000006,
        "priceIn": 3215.13,
        "doubleCheck": true
    },
    {
        "dataID": "119024",
        "id": "53116967",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:26",
        "brokerTime": "2025-05-14 15:19:26",
        "commission": -106.05,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071017",
        "positionId": "56071017",
        "volume": 15.15,
        "price": 3214.68,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.05,
        "priceIn": 3214.68,
        "doubleCheck": true
    },
    {
        "dataID": "119025",
        "id": "53116968",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:26",
        "brokerTime": "2025-05-14 15:19:26",
        "commission": -106.05,
        "swap": 0,
        "profit": -106.05,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071018",
        "positionId": "56071017",
        "volume": 15.15,
        "price": 3214.75,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -212.1,
        "priceIn": 3214.68,
        "doubleCheck": true
    },
    {
        "dataID": "119026",
        "id": "53116969",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:27",
        "brokerTime": "2025-05-14 15:19:27",
        "commission": -106.05,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071019",
        "positionId": "56071019",
        "volume": 15.15,
        "price": 3214.75,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.05,
        "priceIn": 3214.75,
        "doubleCheck": true
    },
    {
        "dataID": "119027",
        "id": "53116970",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:27",
        "brokerTime": "2025-05-14 15:19:27",
        "commission": -106.05,
        "swap": 0,
        "profit": -530.25,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071020",
        "positionId": "56071019",
        "volume": 15.15,
        "price": 3215.1,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -636.3,
        "priceIn": 3214.75,
        "doubleCheck": true
    },
    {
        "dataID": "119028",
        "id": "53116971",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:28",
        "brokerTime": "2025-05-14 15:19:28",
        "commission": -106.05,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071021",
        "positionId": "56071021",
        "volume": 15.15,
        "price": 3214.78,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.05,
        "priceIn": 3214.78,
        "doubleCheck": true
    },
    {
        "dataID": "119029",
        "id": "53116972",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:28",
        "brokerTime": "2025-05-14 15:19:28",
        "commission": -106.05,
        "swap": 0,
        "profit": -530.25,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071022",
        "positionId": "56071021",
        "volume": 15.15,
        "price": 3215.13,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -636.3,
        "priceIn": 3214.78,
        "doubleCheck": true
    },
    {
        "dataID": "119030",
        "id": "53116973",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:29",
        "brokerTime": "2025-05-14 15:19:29",
        "commission": -106.05,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071023",
        "positionId": "56071023",
        "volume": 15.15,
        "price": 3214.83,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.05,
        "priceIn": 3214.83,
        "doubleCheck": true
    },
    {
        "dataID": "119031",
        "id": "53116974",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:29",
        "brokerTime": "2025-05-14 15:19:29",
        "commission": -106.05,
        "swap": 0,
        "profit": -575.7,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071024",
        "positionId": "56071023",
        "volume": 15.15,
        "price": 3215.21,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -681.75,
        "priceIn": 3214.83,
        "doubleCheck": true
    },
    {
        "dataID": "119032",
        "id": "53116975",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:30",
        "brokerTime": "2025-05-14 15:19:30",
        "commission": -106.05,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071025",
        "positionId": "56071025",
        "volume": 15.15,
        "price": 3215.19,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.05,
        "priceIn": 3215.19,
        "doubleCheck": true
    },
    {
        "dataID": "119033",
        "id": "53116976",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:30",
        "brokerTime": "2025-05-14 15:19:30",
        "commission": -106.05,
        "swap": 0,
        "profit": 257.55,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071026",
        "positionId": "56071025",
        "volume": 15.15,
        "price": 3215.02,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 151.5,
        "priceIn": 3215.19,
        "doubleCheck": true
    },
    {
        "dataID": "119034",
        "id": "53116977",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:31",
        "brokerTime": "2025-05-14 15:19:31",
        "commission": -106.05,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071027",
        "positionId": "56071027",
        "volume": 15.15,
        "price": 3214.81,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.05,
        "priceIn": 3214.81,
        "doubleCheck": true
    },
    {
        "dataID": "119035",
        "id": "53116982",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:31",
        "brokerTime": "2025-05-14 15:19:31",
        "commission": -106.05,
        "swap": 0,
        "profit": -515.1,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071030",
        "positionId": "56071027",
        "volume": 15.15,
        "price": 3215.15,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -621.15,
        "priceIn": 3214.81,
        "doubleCheck": true
    },
    {
        "dataID": "119036",
        "id": "53116983",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:32",
        "brokerTime": "2025-05-14 15:19:32",
        "commission": -106.05,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071031",
        "positionId": "56071031",
        "volume": 15.15,
        "price": 3214.25,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.05,
        "priceIn": 3214.25,
        "doubleCheck": true
    },
    {
        "dataID": "119037",
        "id": "53116985",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:32",
        "brokerTime": "2025-05-14 15:19:33",
        "commission": -106.05,
        "swap": 0,
        "profit": -287.85,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071033",
        "positionId": "56071031",
        "volume": 15.15,
        "price": 3214.44,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -393.90000000000003,
        "priceIn": 3214.25,
        "doubleCheck": true
    },
    {
        "dataID": "119038",
        "id": "53116987",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:33",
        "brokerTime": "2025-05-14 15:19:33",
        "commission": -106.05,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071035",
        "positionId": "56071035",
        "volume": 15.15,
        "price": 3214.15,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.05,
        "priceIn": 3214.15,
        "doubleCheck": true
    },
    {
        "dataID": "119039",
        "id": "53116988",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:33",
        "brokerTime": "2025-05-14 15:19:33",
        "commission": -106.05,
        "swap": 0,
        "profit": -363.6,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071036",
        "positionId": "56071035",
        "volume": 15.15,
        "price": 3214.39,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -469.65000000000003,
        "priceIn": 3214.15,
        "doubleCheck": true
    },
    {
        "dataID": "119040",
        "id": "53116989",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:34",
        "brokerTime": "2025-05-14 15:19:34",
        "commission": -106.05,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071037",
        "positionId": "56071037",
        "volume": 15.15,
        "price": 3214.37,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.05,
        "priceIn": 3214.37,
        "doubleCheck": true
    },
    {
        "dataID": "119041",
        "id": "53116990",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:34",
        "brokerTime": "2025-05-14 15:19:34",
        "commission": -106.05,
        "swap": 0,
        "profit": 75.75,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071038",
        "positionId": "56071037",
        "volume": 15.15,
        "price": 3214.32,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -30.299999999999997,
        "priceIn": 3214.37,
        "doubleCheck": true
    },
    {
        "dataID": "119042",
        "id": "53116991",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:35",
        "brokerTime": "2025-05-14 15:19:35",
        "commission": -106.05,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071039",
        "positionId": "56071039",
        "volume": 15.15,
        "price": 3214.19,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.05,
        "priceIn": 3214.19,
        "doubleCheck": true
    },
    {
        "dataID": "119043",
        "id": "53116992",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:35",
        "brokerTime": "2025-05-14 15:19:35",
        "commission": -106.05,
        "swap": 0,
        "profit": -272.7,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071040",
        "positionId": "56071039",
        "volume": 15.15,
        "price": 3214.37,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -378.75,
        "priceIn": 3214.19,
        "doubleCheck": true
    },
    {
        "dataID": "119044",
        "id": "53116993",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:35",
        "brokerTime": "2025-05-14 15:19:35",
        "commission": -106.05,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071041",
        "positionId": "56071041",
        "volume": 15.15,
        "price": 3214.23,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.05,
        "priceIn": 3214.23,
        "doubleCheck": true
    },
    {
        "dataID": "119045",
        "id": "53116994",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:35",
        "brokerTime": "2025-05-14 15:19:36",
        "commission": -106.05,
        "swap": 0,
        "profit": -575.7,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071042",
        "positionId": "56071041",
        "volume": 15.15,
        "price": 3214.61,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -681.75,
        "priceIn": 3214.23,
        "doubleCheck": true
    },
    {
        "dataID": "119046",
        "id": "53116995",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:36",
        "brokerTime": "2025-05-14 15:19:36",
        "commission": -106.05,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071043",
        "positionId": "56071043",
        "volume": 15.15,
        "price": 3214.39,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.05,
        "priceIn": 3214.39,
        "doubleCheck": true
    },
    {
        "dataID": "119047",
        "id": "53116996",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:36",
        "brokerTime": "2025-05-14 15:19:37",
        "commission": -106.05,
        "swap": 0,
        "profit": -530.25,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071044",
        "positionId": "56071043",
        "volume": 15.15,
        "price": 3214.74,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -636.3,
        "priceIn": 3214.39,
        "doubleCheck": true
    },
    {
        "dataID": "119048",
        "id": "53116997",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:37",
        "brokerTime": "2025-05-14 15:19:37",
        "commission": -106.05,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071045",
        "positionId": "56071045",
        "volume": 15.15,
        "price": 3214.3,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.05,
        "priceIn": 3214.3,
        "doubleCheck": true
    },
    {
        "dataID": "119049",
        "id": "53116998",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:37",
        "brokerTime": "2025-05-14 15:19:37",
        "commission": -106.05,
        "swap": 0,
        "profit": -606,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071046",
        "positionId": "56071045",
        "volume": 15.15,
        "price": 3214.7,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -712.05,
        "priceIn": 3214.3,
        "doubleCheck": true
    },
    {
        "dataID": "119050",
        "id": "53116999",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:38",
        "brokerTime": "2025-05-14 15:19:38",
        "commission": -106.05,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071047",
        "positionId": "56071047",
        "volume": 15.15,
        "price": 3214.45,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.05,
        "priceIn": 3214.45,
        "doubleCheck": true
    },
    {
        "dataID": "119051",
        "id": "53117000",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:38",
        "brokerTime": "2025-05-14 15:19:38",
        "commission": -106.05,
        "swap": 0,
        "profit": -227.25,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071048",
        "positionId": "56071047",
        "volume": 15.15,
        "price": 3214.6,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -333.3,
        "priceIn": 3214.45,
        "doubleCheck": true
    },
    {
        "dataID": "119052",
        "id": "53117001",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:39",
        "brokerTime": "2025-05-14 15:19:39",
        "commission": -106.05,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071049",
        "positionId": "56071049",
        "volume": 15.15,
        "price": 3214.39,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.05,
        "priceIn": 3214.39,
        "doubleCheck": true
    },
    {
        "dataID": "119053",
        "id": "53117002",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:39",
        "brokerTime": "2025-05-14 15:19:39",
        "commission": -106.05,
        "swap": 0,
        "profit": -181.8,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071050",
        "positionId": "56071049",
        "volume": 15.15,
        "price": 3214.51,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -287.85,
        "priceIn": 3214.39,
        "doubleCheck": true
    },
    {
        "dataID": "119054",
        "id": "53117003",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:39",
        "brokerTime": "2025-05-14 15:19:39",
        "commission": -106.05,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071051",
        "positionId": "56071051",
        "volume": 15.15,
        "price": 3214.31,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.05,
        "priceIn": 3214.31,
        "doubleCheck": true
    },
    {
        "dataID": "119055",
        "id": "53117004",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:39",
        "brokerTime": "2025-05-14 15:19:40",
        "commission": -106.05,
        "swap": 0,
        "profit": -166.65,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071052",
        "positionId": "56071051",
        "volume": 15.15,
        "price": 3214.42,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -272.7,
        "priceIn": 3214.31,
        "doubleCheck": true
    },
    {
        "dataID": "119056",
        "id": "53117005",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:40",
        "brokerTime": "2025-05-14 15:19:40",
        "commission": -106.05,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071053",
        "positionId": "56071053",
        "volume": 15.15,
        "price": 3214.25,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.05,
        "priceIn": 3214.25,
        "doubleCheck": true
    },
    {
        "dataID": "119057",
        "id": "53117007",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:40",
        "brokerTime": "2025-05-14 15:19:40",
        "commission": -106.05,
        "swap": 0,
        "profit": -606,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071055",
        "positionId": "56071053",
        "volume": 15.15,
        "price": 3214.65,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -712.05,
        "priceIn": 3214.25,
        "doubleCheck": true
    },
    {
        "dataID": "119058",
        "id": "53117008",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:41",
        "brokerTime": "2025-05-14 15:19:41",
        "commission": -106.05,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071056",
        "positionId": "56071056",
        "volume": 15.15,
        "price": 3214.42,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.05,
        "priceIn": 3214.42,
        "doubleCheck": true
    },
    {
        "dataID": "119059",
        "id": "53117012",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:41",
        "brokerTime": "2025-05-14 15:19:41",
        "commission": -106.05,
        "swap": 0,
        "profit": -348.45,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071061",
        "positionId": "56071056",
        "volume": 15.15,
        "price": 3214.65,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -454.5,
        "priceIn": 3214.42,
        "doubleCheck": true
    },
    {
        "dataID": "119060",
        "id": "53117014",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:41",
        "brokerTime": "2025-05-14 15:19:41",
        "commission": -106.05,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071062",
        "positionId": "56071062",
        "volume": 15.15,
        "price": 3214.61,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.05,
        "priceIn": 3214.61,
        "doubleCheck": true
    },
    {
        "dataID": "119061",
        "id": "53117015",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:41",
        "brokerTime": "2025-05-14 15:19:42",
        "commission": -106.05,
        "swap": 0,
        "profit": -318.15,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071063",
        "positionId": "56071062",
        "volume": 15.15,
        "price": 3214.82,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -424.2,
        "priceIn": 3214.61,
        "doubleCheck": true
    },
    {
        "dataID": "119062",
        "id": "53117016",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:42",
        "brokerTime": "2025-05-14 15:19:42",
        "commission": -106.05,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071064",
        "positionId": "56071064",
        "volume": 15.15,
        "price": 3214.65,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.05,
        "priceIn": 3214.65,
        "doubleCheck": true
    },
    {
        "dataID": "119063",
        "id": "53117017",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:42",
        "brokerTime": "2025-05-14 15:19:43",
        "commission": -106.05,
        "swap": 0,
        "profit": -469.65,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071065",
        "positionId": "56071064",
        "volume": 15.15,
        "price": 3214.96,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -575.6999999999999,
        "priceIn": 3214.65,
        "doubleCheck": true
    },
    {
        "dataID": "119064",
        "id": "53117018",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:43",
        "brokerTime": "2025-05-14 15:19:43",
        "commission": -106.05,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071066",
        "positionId": "56071066",
        "volume": 15.15,
        "price": 3214.82,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.05,
        "priceIn": 3214.82,
        "doubleCheck": true
    },
    {
        "dataID": "119065",
        "id": "53117019",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:43",
        "brokerTime": "2025-05-14 15:19:43",
        "commission": -106.05,
        "swap": 0,
        "profit": -348.45,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071067",
        "positionId": "56071066",
        "volume": 15.15,
        "price": 3215.05,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -454.5,
        "priceIn": 3214.82,
        "doubleCheck": true
    },
    {
        "dataID": "119066",
        "id": "53117020",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:44",
        "brokerTime": "2025-05-14 15:19:44",
        "commission": -106.05,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071068",
        "positionId": "56071068",
        "volume": 15.15,
        "price": 3214.84,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.05,
        "priceIn": 3214.84,
        "doubleCheck": true
    },
    {
        "dataID": "119067",
        "id": "53117021",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:44",
        "brokerTime": "2025-05-14 15:19:45",
        "commission": -106.05,
        "swap": 0,
        "profit": -606,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071069",
        "positionId": "56071068",
        "volume": 15.15,
        "price": 3215.24,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -712.05,
        "priceIn": 3214.84,
        "doubleCheck": true
    },
    {
        "dataID": "119068",
        "id": "53117022",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:45",
        "brokerTime": "2025-05-14 15:19:45",
        "commission": -106.05,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071070",
        "positionId": "56071070",
        "volume": 15.15,
        "price": 3215.08,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.05,
        "priceIn": 3215.08,
        "doubleCheck": true
    },
    {
        "dataID": "119069",
        "id": "53117023",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:45",
        "brokerTime": "2025-05-14 15:19:46",
        "commission": -106.05,
        "swap": 0,
        "profit": 90.9,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071071",
        "positionId": "56071070",
        "volume": 15.15,
        "price": 3215.02,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -15.149999999999991,
        "priceIn": 3215.08,
        "doubleCheck": true
    },
    {
        "dataID": "119070",
        "id": "53117024",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:47",
        "brokerTime": "2025-05-14 15:19:47",
        "commission": -106.05,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071072",
        "positionId": "56071072",
        "volume": 15.15,
        "price": 3214.76,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.05,
        "priceIn": 3214.76,
        "doubleCheck": true
    },
    {
        "dataID": "119071",
        "id": "53117025",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:47",
        "brokerTime": "2025-05-14 15:19:47",
        "commission": -106.05,
        "swap": 0,
        "profit": -363.6,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071073",
        "positionId": "56071072",
        "volume": 15.15,
        "price": 3215,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -469.65000000000003,
        "priceIn": 3214.76,
        "doubleCheck": true
    },
    {
        "dataID": "119072",
        "id": "53117026",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:47",
        "brokerTime": "2025-05-14 15:19:47",
        "commission": -106.05,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071074",
        "positionId": "56071074",
        "volume": 15.15,
        "price": 3214.71,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.05,
        "priceIn": 3214.71,
        "doubleCheck": true
    },
    {
        "dataID": "119073",
        "id": "53117027",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:47",
        "brokerTime": "2025-05-14 15:19:48",
        "commission": -106.05,
        "swap": 0,
        "profit": -530.25,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071075",
        "positionId": "56071074",
        "volume": 15.15,
        "price": 3215.06,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -636.3,
        "priceIn": 3214.71,
        "doubleCheck": true
    },
    {
        "dataID": "119074",
        "id": "53117028",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:48",
        "brokerTime": "2025-05-14 15:19:48",
        "commission": -106.05,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071076",
        "positionId": "56071076",
        "volume": 15.15,
        "price": 3214.63,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.05,
        "priceIn": 3214.63,
        "doubleCheck": true
    },
    {
        "dataID": "119075",
        "id": "53117030",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:48",
        "brokerTime": "2025-05-14 15:19:48",
        "commission": -106.05,
        "swap": 0,
        "profit": 196.95,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071078",
        "positionId": "56071076",
        "volume": 15.15,
        "price": 3214.5,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 90.89999999999999,
        "priceIn": 3214.63,
        "doubleCheck": true
    },
    {
        "dataID": "119076",
        "id": "53117031",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:49",
        "brokerTime": "2025-05-14 15:19:49",
        "commission": -106.05,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071079",
        "positionId": "56071079",
        "volume": 15.15,
        "price": 3213.88,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.05,
        "priceIn": 3213.88,
        "doubleCheck": true
    },
    {
        "dataID": "119077",
        "id": "53117032",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:49",
        "brokerTime": "2025-05-14 15:19:50",
        "commission": -106.05,
        "swap": 0,
        "profit": 106.05,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071081",
        "positionId": "56071079",
        "volume": 15.15,
        "price": 3213.81,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 0,
        "priceIn": 3213.88,
        "doubleCheck": true
    },
    {
        "dataID": "119078",
        "id": "53117034",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:50",
        "brokerTime": "2025-05-14 15:19:50",
        "commission": -106.05,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071082",
        "positionId": "56071082",
        "volume": 15.15,
        "price": 3213.58,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.05,
        "priceIn": 3213.58,
        "doubleCheck": true
    },
    {
        "dataID": "119079",
        "id": "53117035",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:50",
        "brokerTime": "2025-05-14 15:19:50",
        "commission": -106.05,
        "swap": 0,
        "profit": -303,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071083",
        "positionId": "56071082",
        "volume": 15.15,
        "price": 3213.78,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -409.05,
        "priceIn": 3213.58,
        "doubleCheck": true
    },
    {
        "dataID": "119080",
        "id": "53117037",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:51",
        "brokerTime": "2025-05-14 15:19:51",
        "commission": -106.05,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071085",
        "positionId": "56071085",
        "volume": 15.15,
        "price": 3213.41,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.05,
        "priceIn": 3213.41,
        "doubleCheck": true
    },
    {
        "dataID": "119081",
        "id": "53117038",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:51",
        "brokerTime": "2025-05-14 15:19:51",
        "commission": -106.05,
        "swap": 0,
        "profit": -499.95,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071086",
        "positionId": "56071085",
        "volume": 15.15,
        "price": 3213.74,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -606,
        "priceIn": 3213.41,
        "doubleCheck": true
    },
    {
        "dataID": "119082",
        "id": "53117039",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:52",
        "brokerTime": "2025-05-14 15:19:52",
        "commission": -106.05,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071087",
        "positionId": "56071087",
        "volume": 15.15,
        "price": 3213.62,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.05,
        "priceIn": 3213.62,
        "doubleCheck": true
    },
    {
        "dataID": "119083",
        "id": "53117041",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:52",
        "brokerTime": "2025-05-14 15:19:52",
        "commission": -106.05,
        "swap": 0,
        "profit": -181.8,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071089",
        "positionId": "56071087",
        "volume": 15.15,
        "price": 3213.74,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -287.85,
        "priceIn": 3213.62,
        "doubleCheck": true
    },
    {
        "dataID": "119084",
        "id": "53117042",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:53",
        "brokerTime": "2025-05-14 15:19:53",
        "commission": -106.05,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071090",
        "positionId": "56071090",
        "volume": 15.15,
        "price": 3213.44,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.05,
        "priceIn": 3213.44,
        "doubleCheck": true
    },
    {
        "dataID": "119085",
        "id": "53117043",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:53",
        "brokerTime": "2025-05-14 15:19:53",
        "commission": -106.05,
        "swap": 0,
        "profit": -303,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071091",
        "positionId": "56071090",
        "volume": 15.15,
        "price": 3213.64,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -409.05,
        "priceIn": 3213.44,
        "doubleCheck": true
    },
    {
        "dataID": "119086",
        "id": "53117044",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:54",
        "brokerTime": "2025-05-14 15:19:54",
        "commission": -106.05,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071092",
        "positionId": "56071092",
        "volume": 15.15,
        "price": 3213.31,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.05,
        "priceIn": 3213.31,
        "doubleCheck": true
    },
    {
        "dataID": "119087",
        "id": "53117045",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:54",
        "brokerTime": "2025-05-14 15:19:55",
        "commission": -106.05,
        "swap": 0,
        "profit": -666.6,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071093",
        "positionId": "56071092",
        "volume": 15.15,
        "price": 3213.75,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -772.65,
        "priceIn": 3213.31,
        "doubleCheck": true
    },
    {
        "dataID": "119088",
        "id": "53117046",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:55",
        "brokerTime": "2025-05-14 15:19:55",
        "commission": -106.05,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071094",
        "positionId": "56071094",
        "volume": 15.15,
        "price": 3213.53,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.05,
        "priceIn": 3213.53,
        "doubleCheck": true
    },
    {
        "dataID": "119089",
        "id": "53117047",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:55",
        "brokerTime": "2025-05-14 15:19:56",
        "commission": -106.05,
        "swap": 0,
        "profit": -863.55,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071095",
        "positionId": "56071094",
        "volume": 15.15,
        "price": 3214.1,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -969.5999999999999,
        "priceIn": 3213.53,
        "doubleCheck": true
    },
    {
        "dataID": "119090",
        "id": "53117048",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:56",
        "brokerTime": "2025-05-14 15:19:56",
        "commission": -106.05,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071096",
        "positionId": "56071096",
        "volume": 15.15,
        "price": 3213.89,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.05,
        "priceIn": 3213.89,
        "doubleCheck": true
    },
    {
        "dataID": "119091",
        "id": "53117050",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:56",
        "brokerTime": "2025-05-14 15:19:56",
        "commission": -106.05,
        "swap": 0,
        "profit": -424.2,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071098",
        "positionId": "56071096",
        "volume": 15.15,
        "price": 3214.17,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -530.25,
        "priceIn": 3213.89,
        "doubleCheck": true
    },
    {
        "dataID": "119092",
        "id": "53117052",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:57",
        "brokerTime": "2025-05-14 15:19:57",
        "commission": -106.05,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071100",
        "positionId": "56071100",
        "volume": 15.15,
        "price": 3214.16,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.05,
        "priceIn": 3214.16,
        "doubleCheck": true
    },
    {
        "dataID": "119093",
        "id": "53117054",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:57",
        "brokerTime": "2025-05-14 15:19:57",
        "commission": -106.05,
        "swap": 0,
        "profit": -742.35,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071102",
        "positionId": "56071100",
        "volume": 15.15,
        "price": 3214.65,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -848.4,
        "priceIn": 3214.16,
        "doubleCheck": true
    },
    {
        "dataID": "119094",
        "id": "53117055",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:57",
        "brokerTime": "2025-05-14 15:19:57",
        "commission": -106.05,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071103",
        "positionId": "56071103",
        "volume": 15.15,
        "price": 3214.53,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.05,
        "priceIn": 3214.53,
        "doubleCheck": true
    },
    {
        "dataID": "119095",
        "id": "53117056",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:57",
        "brokerTime": "2025-05-14 15:19:59",
        "commission": -106.05,
        "swap": 0,
        "profit": -939.3,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071104",
        "positionId": "56071103",
        "volume": 15.15,
        "price": 3215.15,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -1045.35,
        "priceIn": 3214.53,
        "doubleCheck": true
    },
    {
        "dataID": "119096",
        "id": "53117057",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:59",
        "brokerTime": "2025-05-14 15:19:59",
        "commission": -106.05,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071105",
        "positionId": "56071105",
        "volume": 15.15,
        "price": 3214.95,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.05,
        "priceIn": 3214.95,
        "doubleCheck": true
    },
    {
        "dataID": "119097",
        "id": "53117058",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:59",
        "brokerTime": "2025-05-14 15:20:00",
        "commission": -106.05,
        "swap": 0,
        "profit": -454.5,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071106",
        "positionId": "56071105",
        "volume": 15.15,
        "price": 3215.25,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -560.55,
        "priceIn": 3214.95,
        "doubleCheck": true
    },
    {
        "dataID": "119098",
        "id": "53117059",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:00",
        "brokerTime": "2025-05-14 15:20:00",
        "commission": -106.05,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071107",
        "positionId": "56071107",
        "volume": 15.15,
        "price": 3215.05,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.05,
        "priceIn": 3215.05,
        "doubleCheck": true
    },
    {
        "dataID": "119099",
        "id": "53117069",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:00",
        "brokerTime": "2025-05-14 15:20:01",
        "commission": -106.05,
        "swap": 0,
        "profit": -212.1,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071116",
        "positionId": "56071107",
        "volume": 15.15,
        "price": 3215.19,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -318.15,
        "priceIn": 3215.05,
        "doubleCheck": true
    },
    {
        "dataID": "119100",
        "id": "53117070",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:01",
        "brokerTime": "2025-05-14 15:20:01",
        "commission": -0.98,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071117",
        "positionId": "56071117",
        "volume": 0.14,
        "price": 3214.97,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3114.97,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.98,
        "priceIn": 3214.97,
        "doubleCheck": true
    },
    {
        "dataID": "119101",
        "id": "53117072",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:02",
        "brokerTime": "2025-05-14 15:20:02",
        "commission": -105.07,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071119",
        "positionId": "56071119",
        "volume": 15.01,
        "price": 3214.99,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -105.07,
        "priceIn": 3214.99,
        "doubleCheck": true
    },
    {
        "dataID": "119102",
        "id": "53117073",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:02",
        "brokerTime": "2025-05-14 15:20:03",
        "commission": -105.07,
        "swap": 0,
        "profit": -855.57,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071120",
        "positionId": "56071119",
        "volume": 15.01,
        "price": 3215.56,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -960.6400000000001,
        "priceIn": 3214.99,
        "doubleCheck": true
    },
    {
        "dataID": "119103",
        "id": "53117075",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:03",
        "brokerTime": "2025-05-14 15:20:03",
        "commission": -105.07,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071122",
        "positionId": "56071122",
        "volume": 15.01,
        "price": 3215.38,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -105.07,
        "priceIn": 3215.38,
        "doubleCheck": true
    },
    {
        "dataID": "119104",
        "id": "53117076",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:03",
        "brokerTime": "2025-05-14 15:20:04",
        "commission": -105.07,
        "swap": 0,
        "profit": -120.08,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071124",
        "positionId": "56071122",
        "volume": 15.01,
        "price": 3215.46,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -225.14999999999998,
        "priceIn": 3215.38,
        "doubleCheck": true
    },
    {
        "dataID": "119105",
        "id": "53117077",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:04",
        "brokerTime": "2025-05-14 15:20:04",
        "commission": -105.07,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071125",
        "positionId": "56071125",
        "volume": 15.01,
        "price": 3215.26,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -105.07,
        "priceIn": 3215.26,
        "doubleCheck": true
    },
    {
        "dataID": "119106",
        "id": "53117078",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:04",
        "brokerTime": "2025-05-14 15:20:05",
        "commission": -105.07,
        "swap": 0,
        "profit": -405.27,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071126",
        "positionId": "56071125",
        "volume": 15.01,
        "price": 3215.53,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -510.34,
        "priceIn": 3215.26,
        "doubleCheck": true
    },
    {
        "dataID": "119107",
        "id": "53117079",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:05",
        "brokerTime": "2025-05-14 15:20:05",
        "commission": -105.07,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071127",
        "positionId": "56071127",
        "volume": 15.01,
        "price": 3215.23,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -105.07,
        "priceIn": 3215.23,
        "doubleCheck": true
    },
    {
        "dataID": "119108",
        "id": "53117080",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:05",
        "brokerTime": "2025-05-14 15:20:06",
        "commission": -105.07,
        "swap": 0,
        "profit": -510.34,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071128",
        "positionId": "56071127",
        "volume": 15.01,
        "price": 3215.57,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -615.41,
        "priceIn": 3215.23,
        "doubleCheck": true
    },
    {
        "dataID": "119109",
        "id": "53117082",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:06",
        "brokerTime": "2025-05-14 15:20:06",
        "commission": -105.07,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071130",
        "positionId": "56071130",
        "volume": 15.01,
        "price": 3215.23,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -105.07,
        "priceIn": 3215.23,
        "doubleCheck": true
    },
    {
        "dataID": "119110",
        "id": "53117083",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:06",
        "brokerTime": "2025-05-14 15:20:07",
        "commission": -105.07,
        "swap": 0,
        "profit": -390.26,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071133",
        "positionId": "56071130",
        "volume": 15.01,
        "price": 3215.49,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -495.33,
        "priceIn": 3215.23,
        "doubleCheck": true
    },
    {
        "dataID": "119111",
        "id": "53117088",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:07",
        "brokerTime": "2025-05-14 15:20:07",
        "commission": -105.07,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071136",
        "positionId": "56071136",
        "volume": 15.01,
        "price": 3215.14,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -105.07,
        "priceIn": 3215.14,
        "doubleCheck": true
    },
    {
        "dataID": "119112",
        "id": "53117089",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:07",
        "brokerTime": "2025-05-14 15:20:07",
        "commission": -105.07,
        "swap": 0,
        "profit": -180.12,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071137",
        "positionId": "56071136",
        "volume": 15.01,
        "price": 3215.26,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -285.19,
        "priceIn": 3215.14,
        "doubleCheck": true
    },
    {
        "dataID": "119113",
        "id": "53117090",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:08",
        "brokerTime": "2025-05-14 15:20:08",
        "commission": -105.07,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071138",
        "positionId": "56071138",
        "volume": 15.01,
        "price": 3215.15,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -105.07,
        "priceIn": 3215.15,
        "doubleCheck": true
    },
    {
        "dataID": "119114",
        "id": "53117091",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:08",
        "brokerTime": "2025-05-14 15:20:08",
        "commission": -105.07,
        "swap": 0,
        "profit": -300.2,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071139",
        "positionId": "56071138",
        "volume": 15.01,
        "price": 3215.35,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -405.27,
        "priceIn": 3215.15,
        "doubleCheck": true
    },
    {
        "dataID": "119115",
        "id": "53117092",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:09",
        "brokerTime": "2025-05-14 15:20:09",
        "commission": -105.07,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071140",
        "positionId": "56071140",
        "volume": 15.01,
        "price": 3215.14,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -105.07,
        "priceIn": 3215.14,
        "doubleCheck": true
    },
    {
        "dataID": "119116",
        "id": "53117093",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:09",
        "brokerTime": "2025-05-14 15:20:09",
        "commission": -105.07,
        "swap": 0,
        "profit": -180.12,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071141",
        "positionId": "56071140",
        "volume": 15.01,
        "price": 3215.26,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -285.19,
        "priceIn": 3215.14,
        "doubleCheck": true
    },
    {
        "dataID": "119117",
        "id": "53117094",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:10",
        "brokerTime": "2025-05-14 15:20:10",
        "commission": -105.07,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071142",
        "positionId": "56071142",
        "volume": 15.01,
        "price": 3214.95,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -105.07,
        "priceIn": 3214.95,
        "doubleCheck": true
    },
    {
        "dataID": "119118",
        "id": "53117095",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:10",
        "brokerTime": "2025-05-14 15:20:11",
        "commission": -105.07,
        "swap": 0,
        "profit": -375.25,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071143",
        "positionId": "56071142",
        "volume": 15.01,
        "price": 3215.2,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -480.32,
        "priceIn": 3214.95,
        "doubleCheck": true
    },
    {
        "dataID": "119119",
        "id": "53117096",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:11",
        "brokerTime": "2025-05-14 15:20:11",
        "commission": -105.07,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071144",
        "positionId": "56071144",
        "volume": 15.01,
        "price": 3214.76,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -105.07,
        "priceIn": 3214.76,
        "doubleCheck": true
    },
    {
        "dataID": "119120",
        "id": "53117101",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:11",
        "brokerTime": "2025-05-14 15:20:12",
        "commission": -105.07,
        "swap": 0,
        "profit": 1140.76,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071147",
        "positionId": "56071144",
        "volume": 15.01,
        "price": 3214,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 1035.69,
        "priceIn": 3214.76,
        "doubleCheck": true
    },
    {
        "dataID": "119121",
        "id": "53117102",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:12",
        "brokerTime": "2025-05-14 15:20:12",
        "commission": -105.07,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071148",
        "positionId": "56071148",
        "volume": 15.01,
        "price": 3213.78,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -105.07,
        "priceIn": 3213.78,
        "doubleCheck": true
    },
    {
        "dataID": "119122",
        "id": "53117104",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:12",
        "brokerTime": "2025-05-14 15:20:12",
        "commission": -105.07,
        "swap": 0,
        "profit": -885.59,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071150",
        "positionId": "56071148",
        "volume": 15.01,
        "price": 3214.37,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -990.6600000000001,
        "priceIn": 3213.78,
        "doubleCheck": true
    },
    {
        "dataID": "119123",
        "id": "53117105",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:01",
        "brokerTime": "2025-05-14 15:20:13",
        "commission": -0.98,
        "swap": 0,
        "profit": 7.56,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071151",
        "positionId": "56071117",
        "volume": 0.14,
        "price": 3214.43,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3115.19,
        "brokerComment": "",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 6.58,
        "priceIn": 3214.97,
        "doubleCheck": true
    },
    {
        "dataID": "119124",
        "id": "53117106",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:17",
        "brokerTime": "2025-05-14 15:20:13",
        "commission": -0.84,
        "swap": 0,
        "profit": -11.88,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071152",
        "positionId": "56070977",
        "volume": 0.12,
        "price": 3214.43,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3115.19,
        "brokerComment": "",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -12.72,
        "priceIn": 3213.44,
        "doubleCheck": true
    },
    {
        "dataID": "119125",
        "id": "53117107",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:12",
        "brokerTime": "2025-05-14 15:20:13",
        "commission": -0.7,
        "swap": 0,
        "profit": -25.4,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071153",
        "positionId": "56068484",
        "volume": 0.1,
        "price": 3214.43,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3115.19,
        "brokerComment": "",
        "comment": "RR",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -26.099999999999998,
        "priceIn": 3211.89,
        "doubleCheck": true
    },
    {
        "dataID": "119126",
        "id": "53117120",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:19",
        "brokerTime": "2025-05-14 15:20:19",
        "commission": -0.7,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071166",
        "positionId": "56071166",
        "volume": 0.1,
        "price": 3213.81,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "RR",
        "comment": "RR",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.7,
        "priceIn": 3213.81,
        "doubleCheck": true
    },
    {
        "dataID": "119127",
        "id": "53117121",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:20",
        "brokerTime": "2025-05-14 15:20:20",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071167",
        "positionId": "56071167",
        "volume": 15.27,
        "price": 3213.82,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.89,
        "priceIn": 3213.82,
        "doubleCheck": true
    },
    {
        "dataID": "119128",
        "id": "53117122",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:20",
        "brokerTime": "2025-05-14 15:20:20",
        "commission": -106.89,
        "swap": 0,
        "profit": 76.35,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071168",
        "positionId": "56071167",
        "volume": 15.27,
        "price": 3213.77,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -30.540000000000006,
        "priceIn": 3213.82,
        "doubleCheck": true
    },
    {
        "dataID": "119129",
        "id": "53117123",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:21",
        "brokerTime": "2025-05-14 15:20:21",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071169",
        "positionId": "56071169",
        "volume": 15.27,
        "price": 3213.49,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.89,
        "priceIn": 3213.49,
        "doubleCheck": true
    },
    {
        "dataID": "119130",
        "id": "53117124",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:21",
        "brokerTime": "2025-05-14 15:20:22",
        "commission": -106.89,
        "swap": 0,
        "profit": -91.62,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071170",
        "positionId": "56071169",
        "volume": 15.27,
        "price": 3213.55,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -198.51,
        "priceIn": 3213.49,
        "doubleCheck": true
    },
    {
        "dataID": "119131",
        "id": "53117126",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:22",
        "brokerTime": "2025-05-14 15:20:22",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071172",
        "positionId": "56071172",
        "volume": 15.27,
        "price": 3213.5,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.89,
        "priceIn": 3213.5,
        "doubleCheck": true
    },
    {
        "dataID": "119132",
        "id": "53117127",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:22",
        "brokerTime": "2025-05-14 15:20:22",
        "commission": -106.89,
        "swap": 0,
        "profit": -320.67,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071173",
        "positionId": "56071172",
        "volume": 15.27,
        "price": 3213.71,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -427.56,
        "priceIn": 3213.5,
        "doubleCheck": true
    },
    {
        "dataID": "119133",
        "id": "53117128",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:23",
        "brokerTime": "2025-05-14 15:20:23",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071174",
        "positionId": "56071174",
        "volume": 15.27,
        "price": 3213.5,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.89,
        "priceIn": 3213.5,
        "doubleCheck": true
    },
    {
        "dataID": "119134",
        "id": "53117129",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:23",
        "brokerTime": "2025-05-14 15:20:23",
        "commission": -106.89,
        "swap": 0,
        "profit": -305.4,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071175",
        "positionId": "56071174",
        "volume": 15.27,
        "price": 3213.7,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -412.28999999999996,
        "priceIn": 3213.5,
        "doubleCheck": true
    },
    {
        "dataID": "119135",
        "id": "53117130",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:23",
        "brokerTime": "2025-05-14 15:20:23",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071176",
        "positionId": "56071176",
        "volume": 15.27,
        "price": 3213.46,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.89,
        "priceIn": 3213.46,
        "doubleCheck": true
    },
    {
        "dataID": "119136",
        "id": "53117132",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:23",
        "brokerTime": "2025-05-14 15:20:24",
        "commission": -106.89,
        "swap": 0,
        "profit": -549.72,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071178",
        "positionId": "56071176",
        "volume": 15.27,
        "price": 3213.82,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -656.61,
        "priceIn": 3213.46,
        "doubleCheck": true
    },
    {
        "dataID": "119137",
        "id": "53117133",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:24",
        "brokerTime": "2025-05-14 15:20:24",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071179",
        "positionId": "56071179",
        "volume": 15.27,
        "price": 3213.59,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.89,
        "priceIn": 3213.59,
        "doubleCheck": true
    },
    {
        "dataID": "119138",
        "id": "53117134",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:24",
        "brokerTime": "2025-05-14 15:20:24",
        "commission": -106.89,
        "swap": 0,
        "profit": -427.56,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071180",
        "positionId": "56071179",
        "volume": 15.27,
        "price": 3213.87,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -534.45,
        "priceIn": 3213.59,
        "doubleCheck": true
    },
    {
        "dataID": "119139",
        "id": "53117135",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:24",
        "brokerTime": "2025-05-14 15:20:24",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071181",
        "positionId": "56071181",
        "volume": 15.27,
        "price": 3213.43,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.89,
        "priceIn": 3213.43,
        "doubleCheck": true
    },
    {
        "dataID": "119140",
        "id": "53117136",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:24",
        "brokerTime": "2025-05-14 15:20:25",
        "commission": -106.89,
        "swap": 0,
        "profit": -839.85,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071182",
        "positionId": "56071181",
        "volume": 15.27,
        "price": 3213.98,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -946.74,
        "priceIn": 3213.43,
        "doubleCheck": true
    },
    {
        "dataID": "119141",
        "id": "53117137",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:26",
        "brokerTime": "2025-05-14 15:20:26",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071183",
        "positionId": "56071183",
        "volume": 15.27,
        "price": 3213.83,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.89,
        "priceIn": 3213.83,
        "doubleCheck": true
    },
    {
        "dataID": "119142",
        "id": "53117138",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:26",
        "brokerTime": "2025-05-14 15:20:26",
        "commission": -106.89,
        "swap": 0,
        "profit": -351.21,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071184",
        "positionId": "56071183",
        "volume": 15.27,
        "price": 3214.06,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -458.09999999999997,
        "priceIn": 3213.83,
        "doubleCheck": true
    },
    {
        "dataID": "119143",
        "id": "53117139",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:27",
        "brokerTime": "2025-05-14 15:20:27",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071185",
        "positionId": "56071185",
        "volume": 15.27,
        "price": 3213.72,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.89,
        "priceIn": 3213.72,
        "doubleCheck": true
    },
    {
        "dataID": "119144",
        "id": "53117140",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:27",
        "brokerTime": "2025-05-14 15:20:27",
        "commission": -106.89,
        "swap": 0,
        "profit": -335.94,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071186",
        "positionId": "56071185",
        "volume": 15.27,
        "price": 3213.94,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -442.83,
        "priceIn": 3213.72,
        "doubleCheck": true
    },
    {
        "dataID": "119145",
        "id": "53117141",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:27",
        "brokerTime": "2025-05-14 15:20:27",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071187",
        "positionId": "56071187",
        "volume": 15.27,
        "price": 3213.71,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.89,
        "priceIn": 3213.71,
        "doubleCheck": true
    },
    {
        "dataID": "119146",
        "id": "53117142",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:27",
        "brokerTime": "2025-05-14 15:20:28",
        "commission": -106.89,
        "swap": 0,
        "profit": -427.56,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071188",
        "positionId": "56071187",
        "volume": 15.27,
        "price": 3213.99,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -534.45,
        "priceIn": 3213.71,
        "doubleCheck": true
    },
    {
        "dataID": "119147",
        "id": "53117143",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:29",
        "brokerTime": "2025-05-14 15:20:29",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071189",
        "positionId": "56071189",
        "volume": 15.27,
        "price": 3213.94,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.89,
        "priceIn": 3213.94,
        "doubleCheck": true
    },
    {
        "dataID": "119148",
        "id": "53117144",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:29",
        "brokerTime": "2025-05-14 15:20:29",
        "commission": -106.89,
        "swap": 0,
        "profit": -122.16,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071190",
        "positionId": "56071189",
        "volume": 15.27,
        "price": 3214.02,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -229.05,
        "priceIn": 3213.94,
        "doubleCheck": true
    },
    {
        "dataID": "119149",
        "id": "53117145",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:29",
        "brokerTime": "2025-05-14 15:20:29",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071191",
        "positionId": "56071191",
        "volume": 15.27,
        "price": 3213.72,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.89,
        "priceIn": 3213.72,
        "doubleCheck": true
    },
    {
        "dataID": "119150",
        "id": "53117146",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:29",
        "brokerTime": "2025-05-14 15:20:30",
        "commission": -106.89,
        "swap": 0,
        "profit": -351.21,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071192",
        "positionId": "56071191",
        "volume": 15.27,
        "price": 3213.95,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -458.09999999999997,
        "priceIn": 3213.72,
        "doubleCheck": true
    },
    {
        "dataID": "119151",
        "id": "53117147",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:30",
        "brokerTime": "2025-05-14 15:20:30",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071193",
        "positionId": "56071193",
        "volume": 15.27,
        "price": 3213.84,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.89,
        "priceIn": 3213.84,
        "doubleCheck": true
    },
    {
        "dataID": "119152",
        "id": "53117148",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:30",
        "brokerTime": "2025-05-14 15:20:31",
        "commission": -106.89,
        "swap": 0,
        "profit": -458.1,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071194",
        "positionId": "56071193",
        "volume": 15.27,
        "price": 3214.14,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -564.99,
        "priceIn": 3213.84,
        "doubleCheck": true
    },
    {
        "dataID": "119153",
        "id": "53117149",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:31",
        "brokerTime": "2025-05-14 15:20:31",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071195",
        "positionId": "56071195",
        "volume": 15.27,
        "price": 3214.06,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.89,
        "priceIn": 3214.06,
        "doubleCheck": true
    },
    {
        "dataID": "119154",
        "id": "53117150",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:31",
        "brokerTime": "2025-05-14 15:20:32",
        "commission": -106.89,
        "swap": 0,
        "profit": -366.48,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071197",
        "positionId": "56071195",
        "volume": 15.27,
        "price": 3214.3,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -473.37,
        "priceIn": 3214.06,
        "doubleCheck": true
    },
    {
        "dataID": "119155",
        "id": "53117151",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:32",
        "brokerTime": "2025-05-14 15:20:32",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071199",
        "positionId": "56071199",
        "volume": 15.27,
        "price": 3214.32,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.89,
        "priceIn": 3214.32,
        "doubleCheck": true
    },
    {
        "dataID": "119156",
        "id": "53117152",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:32",
        "brokerTime": "2025-05-14 15:20:33",
        "commission": -106.89,
        "swap": 0,
        "profit": -183.24,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071200",
        "positionId": "56071199",
        "volume": 15.27,
        "price": 3214.44,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -290.13,
        "priceIn": 3214.32,
        "doubleCheck": true
    },
    {
        "dataID": "119157",
        "id": "53117153",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:33",
        "brokerTime": "2025-05-14 15:20:33",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071201",
        "positionId": "56071201",
        "volume": 15.27,
        "price": 3214.21,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.89,
        "priceIn": 3214.21,
        "doubleCheck": true
    },
    {
        "dataID": "119158",
        "id": "53117154",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:33",
        "brokerTime": "2025-05-14 15:20:33",
        "commission": -106.89,
        "swap": 0,
        "profit": -305.4,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071202",
        "positionId": "56071201",
        "volume": 15.27,
        "price": 3214.41,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -412.28999999999996,
        "priceIn": 3214.21,
        "doubleCheck": true
    },
    {
        "dataID": "119159",
        "id": "53117155",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:34",
        "brokerTime": "2025-05-14 15:20:34",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071203",
        "positionId": "56071203",
        "volume": 15.27,
        "price": 3214.18,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.89,
        "priceIn": 3214.18,
        "doubleCheck": true
    },
    {
        "dataID": "119160",
        "id": "53117156",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:34",
        "brokerTime": "2025-05-14 15:20:34",
        "commission": -106.89,
        "swap": 0,
        "profit": -229.05,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071204",
        "positionId": "56071203",
        "volume": 15.27,
        "price": 3214.33,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -335.94,
        "priceIn": 3214.18,
        "doubleCheck": true
    },
    {
        "dataID": "119161",
        "id": "53117157",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:34",
        "brokerTime": "2025-05-14 15:20:34",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071205",
        "positionId": "56071205",
        "volume": 15.27,
        "price": 3214.1,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.89,
        "priceIn": 3214.1,
        "doubleCheck": true
    },
    {
        "dataID": "119162",
        "id": "53117158",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:34",
        "brokerTime": "2025-05-14 15:20:35",
        "commission": -106.89,
        "swap": 0,
        "profit": -305.4,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071206",
        "positionId": "56071205",
        "volume": 15.27,
        "price": 3214.3,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -412.28999999999996,
        "priceIn": 3214.1,
        "doubleCheck": true
    },
    {
        "dataID": "119163",
        "id": "53117159",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:36",
        "brokerTime": "2025-05-14 15:20:36",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071207",
        "positionId": "56071207",
        "volume": 15.27,
        "price": 3214.29,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.89,
        "priceIn": 3214.29,
        "doubleCheck": true
    },
    {
        "dataID": "119164",
        "id": "53117160",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:36",
        "brokerTime": "2025-05-14 15:20:36",
        "commission": -106.89,
        "swap": 0,
        "profit": 76.35,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071208",
        "positionId": "56071207",
        "volume": 15.27,
        "price": 3214.24,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -30.540000000000006,
        "priceIn": 3214.29,
        "doubleCheck": true
    },
    {
        "dataID": "119165",
        "id": "53117161",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:37",
        "brokerTime": "2025-05-14 15:20:37",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071209",
        "positionId": "56071209",
        "volume": 15.27,
        "price": 3214.03,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.89,
        "priceIn": 3214.03,
        "doubleCheck": true
    },
    {
        "dataID": "119166",
        "id": "53117162",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:37",
        "brokerTime": "2025-05-14 15:20:37",
        "commission": -106.89,
        "swap": 0,
        "profit": -335.94,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071210",
        "positionId": "56071209",
        "volume": 15.27,
        "price": 3214.25,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -442.83,
        "priceIn": 3214.03,
        "doubleCheck": true
    },
    {
        "dataID": "119167",
        "id": "53117163",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:37",
        "brokerTime": "2025-05-14 15:20:37",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071211",
        "positionId": "56071211",
        "volume": 15.27,
        "price": 3214.02,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.89,
        "priceIn": 3214.02,
        "doubleCheck": true
    },
    {
        "dataID": "119168",
        "id": "53117164",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:37",
        "brokerTime": "2025-05-14 15:20:38",
        "commission": -106.89,
        "swap": 0,
        "profit": -335.94,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071212",
        "positionId": "56071211",
        "volume": 15.27,
        "price": 3214.24,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -442.83,
        "priceIn": 3214.02,
        "doubleCheck": true
    },
    {
        "dataID": "119169",
        "id": "53117165",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:38",
        "brokerTime": "2025-05-14 15:20:38",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071213",
        "positionId": "56071213",
        "volume": 15.27,
        "price": 3214.02,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.89,
        "priceIn": 3214.02,
        "doubleCheck": true
    },
    {
        "dataID": "119170",
        "id": "53117166",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:38",
        "brokerTime": "2025-05-14 15:20:39",
        "commission": -106.89,
        "swap": 0,
        "profit": -351.21,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071214",
        "positionId": "56071213",
        "volume": 15.27,
        "price": 3214.25,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -458.09999999999997,
        "priceIn": 3214.02,
        "doubleCheck": true
    },
    {
        "dataID": "119171",
        "id": "53117167",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:39",
        "brokerTime": "2025-05-14 15:20:39",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071215",
        "positionId": "56071215",
        "volume": 15.27,
        "price": 3214.17,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.89,
        "priceIn": 3214.17,
        "doubleCheck": true
    },
    {
        "dataID": "119172",
        "id": "53117168",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:39",
        "brokerTime": "2025-05-14 15:20:39",
        "commission": -106.89,
        "swap": 0,
        "profit": -152.7,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071216",
        "positionId": "56071215",
        "volume": 15.27,
        "price": 3214.27,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -259.59,
        "priceIn": 3214.17,
        "doubleCheck": true
    },
    {
        "dataID": "119173",
        "id": "53117169",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:40",
        "brokerTime": "2025-05-14 15:20:40",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071217",
        "positionId": "56071217",
        "volume": 15.27,
        "price": 3214.03,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.89,
        "priceIn": 3214.03,
        "doubleCheck": true
    },
    {
        "dataID": "119174",
        "id": "53117170",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:40",
        "brokerTime": "2025-05-14 15:20:40",
        "commission": -106.89,
        "swap": 0,
        "profit": -305.4,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071218",
        "positionId": "56071217",
        "volume": 15.27,
        "price": 3214.23,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -412.28999999999996,
        "priceIn": 3214.03,
        "doubleCheck": true
    },
    {
        "dataID": "119175",
        "id": "53117171",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:40",
        "brokerTime": "2025-05-14 15:20:40",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071219",
        "positionId": "56071219",
        "volume": 15.27,
        "price": 3214.13,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.89,
        "priceIn": 3214.13,
        "doubleCheck": true
    },
    {
        "dataID": "119176",
        "id": "53117172",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:40",
        "brokerTime": "2025-05-14 15:20:41",
        "commission": -106.89,
        "swap": 0,
        "profit": -564.99,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071220",
        "positionId": "56071219",
        "volume": 15.27,
        "price": 3214.5,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -671.88,
        "priceIn": 3214.13,
        "doubleCheck": true
    },
    {
        "dataID": "119177",
        "id": "53117173",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:41",
        "brokerTime": "2025-05-14 15:20:41",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071221",
        "positionId": "56071221",
        "volume": 15.27,
        "price": 3214.31,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.89,
        "priceIn": 3214.31,
        "doubleCheck": true
    },
    {
        "dataID": "119178",
        "id": "53117175",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:41",
        "brokerTime": "2025-05-14 15:20:42",
        "commission": -106.89,
        "swap": 0,
        "profit": -656.61,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071223",
        "positionId": "56071221",
        "volume": 15.27,
        "price": 3214.74,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -763.5,
        "priceIn": 3214.31,
        "doubleCheck": true
    },
    {
        "dataID": "119179",
        "id": "53117176",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:42",
        "brokerTime": "2025-05-14 15:20:42",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071226",
        "positionId": "56071226",
        "volume": 15.27,
        "price": 3214.62,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.89,
        "priceIn": 3214.62,
        "doubleCheck": true
    },
    {
        "dataID": "119180",
        "id": "53117177",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:42",
        "brokerTime": "2025-05-14 15:20:43",
        "commission": -106.89,
        "swap": 0,
        "profit": -213.78,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071227",
        "positionId": "56071226",
        "volume": 15.27,
        "price": 3214.76,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -320.67,
        "priceIn": 3214.62,
        "doubleCheck": true
    },
    {
        "dataID": "119181",
        "id": "53117178",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:43",
        "brokerTime": "2025-05-14 15:20:43",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071228",
        "positionId": "56071228",
        "volume": 15.27,
        "price": 3214.51,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.89,
        "priceIn": 3214.51,
        "doubleCheck": true
    },
    {
        "dataID": "119182",
        "id": "53117179",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:43",
        "brokerTime": "2025-05-14 15:20:43",
        "commission": -106.89,
        "swap": 0,
        "profit": -519.18,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071229",
        "positionId": "56071228",
        "volume": 15.27,
        "price": 3214.85,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -626.0699999999999,
        "priceIn": 3214.51,
        "doubleCheck": true
    },
    {
        "dataID": "119183",
        "id": "53117180",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:44",
        "brokerTime": "2025-05-14 15:20:44",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071230",
        "positionId": "56071230",
        "volume": 15.27,
        "price": 3214.28,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.89,
        "priceIn": 3214.28,
        "doubleCheck": true
    },
    {
        "dataID": "119184",
        "id": "53117181",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:44",
        "brokerTime": "2025-05-14 15:20:44",
        "commission": -106.89,
        "swap": 0,
        "profit": -626.07,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071231",
        "positionId": "56071230",
        "volume": 15.27,
        "price": 3214.69,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -732.96,
        "priceIn": 3214.28,
        "doubleCheck": true
    },
    {
        "dataID": "119185",
        "id": "53117182",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:45",
        "brokerTime": "2025-05-14 15:20:45",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071232",
        "positionId": "56071232",
        "volume": 15.27,
        "price": 3214.7,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.89,
        "priceIn": 3214.7,
        "doubleCheck": true
    },
    {
        "dataID": "119186",
        "id": "53117183",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:45",
        "brokerTime": "2025-05-14 15:20:45",
        "commission": -106.89,
        "swap": 0,
        "profit": -305.4,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071233",
        "positionId": "56071232",
        "volume": 15.27,
        "price": 3214.9,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -412.28999999999996,
        "priceIn": 3214.7,
        "doubleCheck": true
    },
    {
        "dataID": "119187",
        "id": "53117184",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:46",
        "brokerTime": "2025-05-14 15:20:46",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071234",
        "positionId": "56071234",
        "volume": 15.27,
        "price": 3214.77,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.89,
        "priceIn": 3214.77,
        "doubleCheck": true
    },
    {
        "dataID": "119188",
        "id": "53117185",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:46",
        "brokerTime": "2025-05-14 15:20:46",
        "commission": -106.89,
        "swap": 0,
        "profit": -335.94,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071236",
        "positionId": "56071234",
        "volume": 15.27,
        "price": 3214.99,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -442.83,
        "priceIn": 3214.77,
        "doubleCheck": true
    },
    {
        "dataID": "119189",
        "id": "53117187",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:47",
        "brokerTime": "2025-05-14 15:20:47",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071237",
        "positionId": "56071237",
        "volume": 15.27,
        "price": 3214.99,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.89,
        "priceIn": 3214.99,
        "doubleCheck": true
    },
    {
        "dataID": "119190",
        "id": "53117188",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:47",
        "brokerTime": "2025-05-14 15:20:47",
        "commission": -106.89,
        "swap": 0,
        "profit": -229.05,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071238",
        "positionId": "56071237",
        "volume": 15.27,
        "price": 3215.14,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -335.94,
        "priceIn": 3214.99,
        "doubleCheck": true
    },
    {
        "dataID": "119191",
        "id": "53117189",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:47",
        "brokerTime": "2025-05-14 15:20:47",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071239",
        "positionId": "56071239",
        "volume": 15.27,
        "price": 3215.09,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.89,
        "priceIn": 3215.09,
        "doubleCheck": true
    },
    {
        "dataID": "119192",
        "id": "53117190",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:47",
        "brokerTime": "2025-05-14 15:20:48",
        "commission": -106.89,
        "swap": 0,
        "profit": -244.32,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071240",
        "positionId": "56071239",
        "volume": 15.27,
        "price": 3215.25,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -351.21,
        "priceIn": 3215.09,
        "doubleCheck": true
    },
    {
        "dataID": "119193",
        "id": "53117191",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:48",
        "brokerTime": "2025-05-14 15:20:48",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071241",
        "positionId": "56071241",
        "volume": 15.27,
        "price": 3215.03,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.89,
        "priceIn": 3215.03,
        "doubleCheck": true
    },
    {
        "dataID": "119194",
        "id": "53117192",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:48",
        "brokerTime": "2025-05-14 15:20:49",
        "commission": -106.89,
        "swap": 0,
        "profit": -244.32,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071242",
        "positionId": "56071241",
        "volume": 15.27,
        "price": 3215.19,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -351.21,
        "priceIn": 3215.03,
        "doubleCheck": true
    },
    {
        "dataID": "119195",
        "id": "53117193",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:49",
        "brokerTime": "2025-05-14 15:20:49",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071243",
        "positionId": "56071243",
        "volume": 15.27,
        "price": 3214.94,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.89,
        "priceIn": 3214.94,
        "doubleCheck": true
    },
    {
        "dataID": "119196",
        "id": "53117194",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:49",
        "brokerTime": "2025-05-14 15:20:50",
        "commission": -106.89,
        "swap": 0,
        "profit": -152.7,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071244",
        "positionId": "56071243",
        "volume": 15.27,
        "price": 3215.04,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -259.59,
        "priceIn": 3214.94,
        "doubleCheck": true
    },
    {
        "dataID": "119197",
        "id": "53117195",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:51",
        "brokerTime": "2025-05-14 15:20:51",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071245",
        "positionId": "56071245",
        "volume": 15.27,
        "price": 3214.88,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.89,
        "priceIn": 3214.88,
        "doubleCheck": true
    },
    {
        "dataID": "119198",
        "id": "53117196",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:51",
        "brokerTime": "2025-05-14 15:20:52",
        "commission": -106.89,
        "swap": 0,
        "profit": -610.8,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071246",
        "positionId": "56071245",
        "volume": 15.27,
        "price": 3215.28,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -717.6899999999999,
        "priceIn": 3214.88,
        "doubleCheck": true
    },
    {
        "dataID": "119199",
        "id": "53117197",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:52",
        "brokerTime": "2025-05-14 15:20:52",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071247",
        "positionId": "56071247",
        "volume": 15.27,
        "price": 3214.96,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.89,
        "priceIn": 3214.96,
        "doubleCheck": true
    },
    {
        "dataID": "119200",
        "id": "53117198",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:52",
        "brokerTime": "2025-05-14 15:20:53",
        "commission": -106.89,
        "swap": 0,
        "profit": 15.27,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071248",
        "positionId": "56071247",
        "volume": 15.27,
        "price": 3214.95,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -91.62,
        "priceIn": 3214.96,
        "doubleCheck": true
    },
    {
        "dataID": "119201",
        "id": "53117199",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:54",
        "brokerTime": "2025-05-14 15:20:54",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071249",
        "positionId": "56071249",
        "volume": 15.27,
        "price": 3214.69,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.89,
        "priceIn": 3214.69,
        "doubleCheck": true
    },
    {
        "dataID": "119202",
        "id": "53117200",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:54",
        "brokerTime": "2025-05-14 15:20:54",
        "commission": -106.89,
        "swap": 0,
        "profit": 320.67,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071250",
        "positionId": "56071249",
        "volume": 15.27,
        "price": 3214.48,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 213.78000000000003,
        "priceIn": 3214.69,
        "doubleCheck": true
    },
    {
        "dataID": "119203",
        "id": "53117201",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:55",
        "brokerTime": "2025-05-14 15:20:55",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071251",
        "positionId": "56071251",
        "volume": 15.27,
        "price": 3214.17,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.89,
        "priceIn": 3214.17,
        "doubleCheck": true
    },
    {
        "dataID": "119204",
        "id": "53117202",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:55",
        "brokerTime": "2025-05-14 15:20:55",
        "commission": -106.89,
        "swap": 0,
        "profit": -274.86,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071252",
        "positionId": "56071251",
        "volume": 15.27,
        "price": 3214.35,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -381.75,
        "priceIn": 3214.17,
        "doubleCheck": true
    },
    {
        "dataID": "119205",
        "id": "53117203",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:56",
        "brokerTime": "2025-05-14 15:20:56",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071253",
        "positionId": "56071253",
        "volume": 15.27,
        "price": 3214,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.89,
        "priceIn": 3214,
        "doubleCheck": true
    },
    {
        "dataID": "119206",
        "id": "53117204",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:56",
        "brokerTime": "2025-05-14 15:20:56",
        "commission": -106.89,
        "swap": 0,
        "profit": -305.4,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071254",
        "positionId": "56071253",
        "volume": 15.27,
        "price": 3214.2,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -412.28999999999996,
        "priceIn": 3214,
        "doubleCheck": true
    },
    {
        "dataID": "119207",
        "id": "53117205",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:57",
        "brokerTime": "2025-05-14 15:20:57",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071255",
        "positionId": "56071255",
        "volume": 15.27,
        "price": 3214,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.89,
        "priceIn": 3214,
        "doubleCheck": true
    },
    {
        "dataID": "119208",
        "id": "53117206",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:57",
        "brokerTime": "2025-05-14 15:20:57",
        "commission": -106.89,
        "swap": 0,
        "profit": -366.48,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071256",
        "positionId": "56071255",
        "volume": 15.27,
        "price": 3214.24,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -473.37,
        "priceIn": 3214,
        "doubleCheck": true
    },
    {
        "dataID": "119209",
        "id": "53117207",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:58",
        "brokerTime": "2025-05-14 15:20:58",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071257",
        "positionId": "56071257",
        "volume": 15.27,
        "price": 3213.9,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.89,
        "priceIn": 3213.9,
        "doubleCheck": true
    },
    {
        "dataID": "119210",
        "id": "53117208",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:58",
        "brokerTime": "2025-05-14 15:20:59",
        "commission": -106.89,
        "swap": 0,
        "profit": -122.16,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071258",
        "positionId": "56071257",
        "volume": 15.27,
        "price": 3213.98,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -229.05,
        "priceIn": 3213.9,
        "doubleCheck": true
    },
    {
        "dataID": "119211",
        "id": "53117209",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:59",
        "brokerTime": "2025-05-14 15:20:59",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071259",
        "positionId": "56071259",
        "volume": 15.27,
        "price": 3213.62,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.89,
        "priceIn": 3213.62,
        "doubleCheck": true
    },
    {
        "dataID": "119212",
        "id": "53117210",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:59",
        "brokerTime": "2025-05-14 15:21:00",
        "commission": -106.89,
        "swap": 0,
        "profit": -122.16,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071260",
        "positionId": "56071259",
        "volume": 15.27,
        "price": 3213.7,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -229.05,
        "priceIn": 3213.62,
        "doubleCheck": true
    },
    {
        "dataID": "119213",
        "id": "53117211",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:21:00",
        "brokerTime": "2025-05-14 15:21:00",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071261",
        "positionId": "56071261",
        "volume": 15.27,
        "price": 3213.45,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.89,
        "priceIn": 3213.45,
        "doubleCheck": true
    },
    {
        "dataID": "119214",
        "id": "53117213",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:21:00",
        "brokerTime": "2025-05-14 15:21:00",
        "commission": -106.89,
        "swap": 0,
        "profit": -106.89,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071263",
        "positionId": "56071261",
        "volume": 15.27,
        "price": 3213.52,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -213.78,
        "priceIn": 3213.45,
        "doubleCheck": true
    },
    {
        "dataID": "119215",
        "id": "53117214",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:21:01",
        "brokerTime": "2025-05-14 15:21:01",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071264",
        "positionId": "56071264",
        "volume": 15.27,
        "price": 3213.3,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.89,
        "priceIn": 3213.3,
        "doubleCheck": true
    },
    {
        "dataID": "119216",
        "id": "53117215",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:21:01",
        "brokerTime": "2025-05-14 15:21:01",
        "commission": -106.89,
        "swap": 0,
        "profit": -183.24,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071267",
        "positionId": "56071264",
        "volume": 15.27,
        "price": 3213.42,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -290.13,
        "priceIn": 3213.3,
        "doubleCheck": true
    },
    {
        "dataID": "119217",
        "id": "53117250",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:21:02",
        "brokerTime": "2025-05-14 15:21:02",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071300",
        "positionId": "56071300",
        "volume": 15.27,
        "price": 3213.07,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.89,
        "priceIn": 3213.07,
        "doubleCheck": true
    },
    {
        "dataID": "119218",
        "id": "53117275",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:21:02",
        "brokerTime": "2025-05-14 15:21:02",
        "commission": -106.89,
        "swap": 0,
        "profit": -381.75,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071306",
        "positionId": "56071300",
        "volume": 15.27,
        "price": 3213.32,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -488.64,
        "priceIn": 3213.07,
        "doubleCheck": true
    },
    {
        "dataID": "119219",
        "id": "53117276",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:21:03",
        "brokerTime": "2025-05-14 15:21:03",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071307",
        "positionId": "56071307",
        "volume": 15.27,
        "price": 3213.17,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.89,
        "priceIn": 3213.17,
        "doubleCheck": true
    },
    {
        "dataID": "119220",
        "id": "53117277",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:21:03",
        "brokerTime": "2025-05-14 15:21:03",
        "commission": -106.89,
        "swap": 0,
        "profit": -366.48,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071308",
        "positionId": "56071307",
        "volume": 15.27,
        "price": 3213.41,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -473.37,
        "priceIn": 3213.17,
        "doubleCheck": true
    },
    {
        "dataID": "119221",
        "id": "53117278",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:21:04",
        "brokerTime": "2025-05-14 15:21:04",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071310",
        "positionId": "56071310",
        "volume": 15.27,
        "price": 3213.08,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.89,
        "priceIn": 3213.08,
        "doubleCheck": true
    },
    {
        "dataID": "119222",
        "id": "53117280",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:21:04",
        "brokerTime": "2025-05-14 15:21:05",
        "commission": -106.89,
        "swap": 0,
        "profit": 76.35,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071311",
        "positionId": "56071310",
        "volume": 15.27,
        "price": 3213.03,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -30.540000000000006,
        "priceIn": 3213.08,
        "doubleCheck": true
    },
    {
        "dataID": "119223",
        "id": "53117281",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:21:05",
        "brokerTime": "2025-05-14 15:21:05",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071312",
        "positionId": "56071312",
        "volume": 15.27,
        "price": 3212.85,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.89,
        "priceIn": 3212.85,
        "doubleCheck": true
    },
    {
        "dataID": "119224",
        "id": "53117282",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:21:05",
        "brokerTime": "2025-05-14 15:21:06",
        "commission": -106.89,
        "swap": 0,
        "profit": 91.62,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071313",
        "positionId": "56071312",
        "volume": 15.27,
        "price": 3212.79,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -15.269999999999996,
        "priceIn": 3212.85,
        "doubleCheck": true
    },
    {
        "dataID": "119225",
        "id": "53117283",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:21:06",
        "brokerTime": "2025-05-14 15:21:06",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071314",
        "positionId": "56071314",
        "volume": 15.27,
        "price": 3212.53,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.89,
        "priceIn": 3212.53,
        "doubleCheck": true
    },
    {
        "dataID": "119226",
        "id": "53117284",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:21:06",
        "brokerTime": "2025-05-14 15:21:07",
        "commission": -106.89,
        "swap": 0,
        "profit": -397.02,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071315",
        "positionId": "56071314",
        "volume": 15.27,
        "price": 3212.79,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -503.90999999999997,
        "priceIn": 3212.53,
        "doubleCheck": true
    },
    {
        "dataID": "119227",
        "id": "53117285",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:21:07",
        "brokerTime": "2025-05-14 15:21:07",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071316",
        "positionId": "56071316",
        "volume": 15.27,
        "price": 3211.98,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.89,
        "priceIn": 3211.98,
        "doubleCheck": true
    },
    {
        "dataID": "119228",
        "id": "53117286",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:21:07",
        "brokerTime": "2025-05-14 15:21:07",
        "commission": -106.89,
        "swap": 0,
        "profit": -61.08,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071317",
        "positionId": "56071316",
        "volume": 15.27,
        "price": 3212.02,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -167.97,
        "priceIn": 3211.98,
        "doubleCheck": true
    },
    {
        "dataID": "119229",
        "id": "53117288",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:21:08",
        "brokerTime": "2025-05-14 15:21:08",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071319",
        "positionId": "56071319",
        "volume": 15.27,
        "price": 3211.89,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.89,
        "priceIn": 3211.89,
        "doubleCheck": true
    },
    {
        "dataID": "119230",
        "id": "53117289",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:21:08",
        "brokerTime": "2025-05-14 15:21:08",
        "commission": -106.89,
        "swap": 0,
        "profit": -320.67,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071320",
        "positionId": "56071319",
        "volume": 15.27,
        "price": 3212.1,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -427.56,
        "priceIn": 3211.89,
        "doubleCheck": true
    },
    {
        "dataID": "119231",
        "id": "53117290",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:21:08",
        "brokerTime": "2025-05-14 15:21:08",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071321",
        "positionId": "56071321",
        "volume": 15.27,
        "price": 3211.75,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.89,
        "priceIn": 3211.75,
        "doubleCheck": true
    },
    {
        "dataID": "119232",
        "id": "53117297",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:21:08",
        "brokerTime": "2025-05-14 15:21:09",
        "commission": -106.89,
        "swap": 0,
        "profit": 183.24,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071328",
        "positionId": "56071321",
        "volume": 15.27,
        "price": 3211.63,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 76.35000000000001,
        "priceIn": 3211.75,
        "doubleCheck": true
    },
    {
        "dataID": "119233",
        "id": "53117306",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:21:10",
        "brokerTime": "2025-05-14 15:21:10",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071332",
        "positionId": "56071332",
        "volume": 15.27,
        "price": 3211.4,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.89,
        "priceIn": 3211.4,
        "doubleCheck": true
    },
    {
        "dataID": "119234",
        "id": "53117308",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:21:10",
        "brokerTime": "2025-05-14 15:21:10",
        "commission": -106.89,
        "swap": 0,
        "profit": -534.45,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071334",
        "positionId": "56071332",
        "volume": 15.27,
        "price": 3211.75,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -641.34,
        "priceIn": 3211.4,
        "doubleCheck": true
    },
    {
        "dataID": "119235",
        "id": "53117309",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:19",
        "brokerTime": "2025-05-14 15:21:10",
        "commission": -0.7,
        "swap": 0,
        "profit": 20.5,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071335",
        "positionId": "56071166",
        "volume": 0.1,
        "price": 3211.76,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "RR",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 19.8,
        "priceIn": 3213.81,
        "doubleCheck": true
    },
    {
        "dataID": "119236",
        "id": "53117311",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:21:17",
        "brokerTime": "2025-05-14 15:21:17",
        "commission": -0.7,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071337",
        "positionId": "56071337",
        "volume": 0.1,
        "price": 3212.14,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "RR",
        "comment": "RR",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.7,
        "priceIn": 3212.14,
        "doubleCheck": true
    },
    {
        "dataID": "119237",
        "id": "53117312",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:21:17",
        "brokerTime": "2025-05-14 15:21:17",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071338",
        "positionId": "56071338",
        "volume": 15.27,
        "price": 3212.19,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.89,
        "priceIn": 3212.19,
        "doubleCheck": true
    },
    {
        "dataID": "119238",
        "id": "53117313",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:21:17",
        "brokerTime": "2025-05-14 15:21:18",
        "commission": -106.89,
        "swap": 0,
        "profit": -274.86,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071339",
        "positionId": "56071338",
        "volume": 15.27,
        "price": 3212.37,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -381.75,
        "priceIn": 3212.19,
        "doubleCheck": true
    },
    {
        "dataID": "119239",
        "id": "53117314",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:21:18",
        "brokerTime": "2025-05-14 15:21:18",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071340",
        "positionId": "56071340",
        "volume": 15.27,
        "price": 3212.08,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.89,
        "priceIn": 3212.08,
        "doubleCheck": true
    },
    {
        "dataID": "119240",
        "id": "53117315",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:21:18",
        "brokerTime": "2025-05-14 15:21:18",
        "commission": -106.89,
        "swap": 0,
        "profit": -503.91,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071341",
        "positionId": "56071340",
        "volume": 15.27,
        "price": 3212.41,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -610.8000000000001,
        "priceIn": 3212.08,
        "doubleCheck": true
    },
    {
        "dataID": "119241",
        "id": "53117316",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:21:19",
        "brokerTime": "2025-05-14 15:21:19",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071342",
        "positionId": "56071342",
        "volume": 15.27,
        "price": 3212.43,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.89,
        "priceIn": 3212.43,
        "doubleCheck": true
    },
    {
        "dataID": "119242",
        "id": "53117317",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:21:19",
        "brokerTime": "2025-05-14 15:21:19",
        "commission": -106.89,
        "swap": 0,
        "profit": -397.02,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071343",
        "positionId": "56071342",
        "volume": 15.27,
        "price": 3212.69,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -503.90999999999997,
        "priceIn": 3212.43,
        "doubleCheck": true
    },
    {
        "dataID": "119243",
        "id": "53117318",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:21:20",
        "brokerTime": "2025-05-14 15:21:20",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071345",
        "positionId": "56071345",
        "volume": 15.27,
        "price": 3212.42,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.89,
        "priceIn": 3212.42,
        "doubleCheck": true
    },
    {
        "dataID": "119244",
        "id": "53117319",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:21:20",
        "brokerTime": "2025-05-14 15:21:20",
        "commission": -106.89,
        "swap": 0,
        "profit": -122.16,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071346",
        "positionId": "56071345",
        "volume": 15.27,
        "price": 3212.5,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -229.05,
        "priceIn": 3212.42,
        "doubleCheck": true
    },
    {
        "dataID": "119245",
        "id": "53117320",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:21:21",
        "brokerTime": "2025-05-14 15:21:21",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071347",
        "positionId": "56071347",
        "volume": 15.27,
        "price": 3212.29,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.89,
        "priceIn": 3212.29,
        "doubleCheck": true
    },
    {
        "dataID": "119246",
        "id": "53117321",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:21:21",
        "brokerTime": "2025-05-14 15:21:21",
        "commission": -106.89,
        "swap": 0,
        "profit": -61.08,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071348",
        "positionId": "56071347",
        "volume": 15.27,
        "price": 3212.33,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -167.97,
        "priceIn": 3212.29,
        "doubleCheck": true
    },
    {
        "dataID": "119247",
        "id": "53117322",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:21:22",
        "brokerTime": "2025-05-14 15:21:22",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071349",
        "positionId": "56071349",
        "volume": 15.27,
        "price": 3212.11,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.89,
        "priceIn": 3212.11,
        "doubleCheck": true
    },
    {
        "dataID": "119248",
        "id": "53117323",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:21:22",
        "brokerTime": "2025-05-14 15:21:22",
        "commission": -106.89,
        "swap": 0,
        "profit": -351.21,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071350",
        "positionId": "56071349",
        "volume": 15.27,
        "price": 3212.34,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -458.09999999999997,
        "priceIn": 3212.11,
        "doubleCheck": true
    },
    {
        "dataID": "119249",
        "id": "53117324",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:21:22",
        "brokerTime": "2025-05-14 15:21:22",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071351",
        "positionId": "56071351",
        "volume": 15.27,
        "price": 3212.25,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.89,
        "priceIn": 3212.25,
        "doubleCheck": true
    },
    {
        "dataID": "119250",
        "id": "53117325",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:21:22",
        "brokerTime": "2025-05-14 15:21:23",
        "commission": -106.89,
        "swap": 0,
        "profit": -229.05,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071352",
        "positionId": "56071351",
        "volume": 15.27,
        "price": 3212.4,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -335.94,
        "priceIn": 3212.25,
        "doubleCheck": true
    },
    {
        "dataID": "119251",
        "id": "53117326",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:21:23",
        "brokerTime": "2025-05-14 15:21:23",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071353",
        "positionId": "56071353",
        "volume": 15.27,
        "price": 3212.39,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.89,
        "priceIn": 3212.39,
        "doubleCheck": true
    },
    {
        "dataID": "119252",
        "id": "53117327",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:21:23",
        "brokerTime": "2025-05-14 15:21:24",
        "commission": -106.89,
        "swap": 0,
        "profit": -702.42,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071354",
        "positionId": "56071353",
        "volume": 15.27,
        "price": 3212.85,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -809.31,
        "priceIn": 3212.39,
        "doubleCheck": true
    },
    {
        "dataID": "119253",
        "id": "53117328",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:21:24",
        "brokerTime": "2025-05-14 15:21:24",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071355",
        "positionId": "56071355",
        "volume": 15.27,
        "price": 3212.84,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.89,
        "priceIn": 3212.84,
        "doubleCheck": true
    },
    {
        "dataID": "119254",
        "id": "53117329",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:21:24",
        "brokerTime": "2025-05-14 15:21:25",
        "commission": -106.89,
        "swap": 0,
        "profit": -335.94,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071356",
        "positionId": "56071355",
        "volume": 15.27,
        "price": 3213.06,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -442.83,
        "priceIn": 3212.84,
        "doubleCheck": true
    },
    {
        "dataID": "119255",
        "id": "53117330",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:21:25",
        "brokerTime": "2025-05-14 15:21:25",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071357",
        "positionId": "56071357",
        "volume": 15.27,
        "price": 3212.8,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.89,
        "priceIn": 3212.8,
        "doubleCheck": true
    },
    {
        "dataID": "119256",
        "id": "53117331",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:21:25",
        "brokerTime": "2025-05-14 15:21:26",
        "commission": -106.89,
        "swap": 0,
        "profit": -427.56,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071358",
        "positionId": "56071357",
        "volume": 15.27,
        "price": 3213.08,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -534.45,
        "priceIn": 3212.8,
        "doubleCheck": true
    },
    {
        "dataID": "119257",
        "id": "53117332",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:21:26",
        "brokerTime": "2025-05-14 15:21:26",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071359",
        "positionId": "56071359",
        "volume": 15.27,
        "price": 3212.95,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.89,
        "priceIn": 3212.95,
        "doubleCheck": true
    },
    {
        "dataID": "119258",
        "id": "53117334",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:21:26",
        "brokerTime": "2025-05-14 15:21:27",
        "commission": -106.89,
        "swap": 0,
        "profit": -305.4,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071361",
        "positionId": "56071359",
        "volume": 15.27,
        "price": 3213.15,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -412.28999999999996,
        "priceIn": 3212.95,
        "doubleCheck": true
    },
    {
        "dataID": "119259",
        "id": "53117335",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:21:27",
        "brokerTime": "2025-05-14 15:21:27",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071362",
        "positionId": "56071362",
        "volume": 15.27,
        "price": 3212.96,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.89,
        "priceIn": 3212.96,
        "doubleCheck": true
    },
    {
        "dataID": "119260",
        "id": "53117336",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:21:27",
        "brokerTime": "2025-05-14 15:21:28",
        "commission": -106.89,
        "swap": 0,
        "profit": -549.72,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071364",
        "positionId": "56071362",
        "volume": 15.27,
        "price": 3213.32,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -656.61,
        "priceIn": 3212.96,
        "doubleCheck": true
    },
    {
        "dataID": "119261",
        "id": "53117338",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:21:29",
        "brokerTime": "2025-05-14 15:21:29",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071365",
        "positionId": "56071365",
        "volume": 15.27,
        "price": 3213.18,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.89,
        "priceIn": 3213.18,
        "doubleCheck": true
    },
    {
        "dataID": "119262",
        "id": "53117339",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:21:29",
        "brokerTime": "2025-05-14 15:21:29",
        "commission": -106.89,
        "swap": 0,
        "profit": -259.59,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071366",
        "positionId": "56071365",
        "volume": 15.27,
        "price": 3213.35,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -366.47999999999996,
        "priceIn": 3213.18,
        "doubleCheck": true
    },
    {
        "dataID": "119263",
        "id": "53117340",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:21:29",
        "brokerTime": "2025-05-14 15:21:29",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071367",
        "positionId": "56071367",
        "volume": 15.27,
        "price": 3213.14,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.89,
        "priceIn": 3213.14,
        "doubleCheck": true
    },
    {
        "dataID": "119264",
        "id": "53117341",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:21:29",
        "brokerTime": "2025-05-14 15:21:30",
        "commission": -106.89,
        "swap": 0,
        "profit": -305.4,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071368",
        "positionId": "56071367",
        "volume": 15.27,
        "price": 3213.34,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -412.28999999999996,
        "priceIn": 3213.14,
        "doubleCheck": true
    },
    {
        "dataID": "119265",
        "id": "53117342",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:21:30",
        "brokerTime": "2025-05-14 15:21:30",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071369",
        "positionId": "56071369",
        "volume": 15.27,
        "price": 3213.13,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.89,
        "priceIn": 3213.13,
        "doubleCheck": true
    },
    {
        "dataID": "119266",
        "id": "53117343",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:21:30",
        "brokerTime": "2025-05-14 15:21:31",
        "commission": -106.89,
        "swap": 0,
        "profit": -366.48,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071370",
        "positionId": "56071369",
        "volume": 15.27,
        "price": 3213.37,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -473.37,
        "priceIn": 3213.13,
        "doubleCheck": true
    },
    {
        "dataID": "119267",
        "id": "53117344",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:21:31",
        "brokerTime": "2025-05-14 15:21:31",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071371",
        "positionId": "56071371",
        "volume": 15.27,
        "price": 3213.06,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.89,
        "priceIn": 3213.06,
        "doubleCheck": true
    },
    {
        "dataID": "119268",
        "id": "53117345",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:21:31",
        "brokerTime": "2025-05-14 15:21:32",
        "commission": -106.89,
        "swap": 0,
        "profit": -30.54,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071372",
        "positionId": "56071371",
        "volume": 15.27,
        "price": 3213.08,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -137.43,
        "priceIn": 3213.06,
        "doubleCheck": true
    },
    {
        "dataID": "119269",
        "id": "53117346",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:21:32",
        "brokerTime": "2025-05-14 15:21:32",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071373",
        "positionId": "56071373",
        "volume": 15.27,
        "price": 3212.86,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.89,
        "priceIn": 3212.86,
        "doubleCheck": true
    },
    {
        "dataID": "119270",
        "id": "53117347",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:21:32",
        "brokerTime": "2025-05-14 15:21:33",
        "commission": -106.89,
        "swap": 0,
        "profit": -305.4,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071374",
        "positionId": "56071373",
        "volume": 15.27,
        "price": 3213.06,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -412.28999999999996,
        "priceIn": 3212.86,
        "doubleCheck": true
    },
    {
        "dataID": "119271",
        "id": "53117348",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:21:33",
        "brokerTime": "2025-05-14 15:21:33",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071375",
        "positionId": "56071375",
        "volume": 15.27,
        "price": 3213.53,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.89,
        "priceIn": 3213.53,
        "doubleCheck": true
    },
    {
        "dataID": "119272",
        "id": "53117349",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:21:33",
        "brokerTime": "2025-05-14 15:21:34",
        "commission": -106.89,
        "swap": 0,
        "profit": -30.54,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071376",
        "positionId": "56071375",
        "volume": 15.27,
        "price": 3213.55,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -137.43,
        "priceIn": 3213.53,
        "doubleCheck": true
    },
    {
        "dataID": "119273",
        "id": "53117350",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:21:34",
        "brokerTime": "2025-05-14 15:21:34",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071377",
        "positionId": "56071377",
        "volume": 15.27,
        "price": 3213.34,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -106.89,
        "priceIn": 3213.34,
        "doubleCheck": true
    },
    {
        "dataID": "119274",
        "id": "53117351",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:21:34",
        "brokerTime": "2025-05-14 15:21:35",
        "commission": -106.89,
        "swap": 0,
        "profit": -641.34,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071378",
        "positionId": "56071377",
        "volume": 15.27,
        "price": 3213.76,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -748.23,
        "priceIn": 3213.34,
        "doubleCheck": true
    },
    {
        "dataID": "119275",
        "id": "53117352",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 14:55:07",
        "brokerTime": "2025-05-14 15:21:35",
        "commission": -6.23,
        "swap": 0,
        "profit": -1027.06,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071379",
        "positionId": "56050074",
        "volume": 0.89,
        "price": 3213.42,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_SO",
        "takeProfit": 3308.68,
        "brokerComment": "[so 18.68%/1528.93/8184.87]",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -1033.29,
        "priceIn": 3224.96,
        "doubleCheck": true,
        "isShow": false,
        "collapseIndex": "0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29",
        "tProfit": -7546.03,
        "tnProfit": -7635.7,
        "tVolume": 12.81,
        "tTrades": 18
    },
    {
        "dataID": "119276",
        "id": "53117353",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:21:35",
        "brokerTime": "2025-05-14 15:21:35",
        "commission": -99.4,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071380",
        "positionId": "56071380",
        "volume": 14.2,
        "price": 3213.49,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -99.4,
        "priceIn": 3213.49,
        "doubleCheck": true
    },
    {
        "dataID": "119277",
        "id": "53117354",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:21:35",
        "brokerTime": "2025-05-14 15:21:36",
        "commission": -99.4,
        "swap": 0,
        "profit": -312.4,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071381",
        "positionId": "56071380",
        "volume": 14.2,
        "price": 3213.71,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -411.79999999999995,
        "priceIn": 3213.49,
        "doubleCheck": true
    },
    {
        "dataID": "119278",
        "id": "53117355",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 14:50:05",
        "brokerTime": "2025-05-14 15:21:36",
        "commission": -5.18,
        "swap": 0,
        "profit": -944.98,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071382",
        "positionId": "56049337",
        "volume": 0.74,
        "price": 3213.55,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_SO",
        "takeProfit": 3308.68,
        "brokerComment": "[so 16.72%/1272.80/7610.83]",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -950.16,
        "priceIn": 3226.32,
        "doubleCheck": true
    },
    {
        "dataID": "119279",
        "id": "53117356",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 14:57:01",
        "brokerTime": "2025-05-14 15:21:36",
        "commission": -7.49,
        "swap": 0,
        "profit": -884.89,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071383",
        "positionId": "56050822",
        "volume": 1.07,
        "price": 3213.55,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_SO",
        "takeProfit": 3308.68,
        "brokerComment": "[so 17.84%/1272.80/7133.35]",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -892.38,
        "priceIn": 3221.82,
        "doubleCheck": true
    },
    {
        "dataID": "119280",
        "id": "53117357",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 14:49:02",
        "brokerTime": "2025-05-14 15:21:36",
        "commission": -4.34,
        "swap": 0,
        "profit": -863.04,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071384",
        "positionId": "56049172",
        "volume": 0.62,
        "price": 3213.55,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_SO",
        "takeProfit": 3308.68,
        "brokerComment": "[so 19.75%/1272.80/6443.88]",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -867.38,
        "priceIn": 3227.47,
        "doubleCheck": true
    },
    {
        "dataID": "119281",
        "id": "53117358",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:21:36",
        "brokerTime": "2025-05-14 15:21:36",
        "commission": -79.03,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071385",
        "positionId": "56071385",
        "volume": 11.29,
        "price": 3213.53,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -79.03,
        "priceIn": 3213.53,
        "doubleCheck": true
    },
    {
        "dataID": "119282",
        "id": "53117359",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:21:36",
        "brokerTime": "2025-05-14 15:21:37",
        "commission": -79.03,
        "swap": 0,
        "profit": -237.09,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071386",
        "positionId": "56071385",
        "volume": 11.29,
        "price": 3213.74,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -316.12,
        "priceIn": 3213.53,
        "doubleCheck": true
    },
    {
        "dataID": "119283",
        "id": "53117360",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 14:48:02",
        "brokerTime": "2025-05-14 15:21:37",
        "commission": -3.64,
        "swap": 0,
        "profit": -782.6,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071387",
        "positionId": "56048999",
        "volume": 0.52,
        "price": 3213.53,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_SO",
        "takeProfit": 3308.68,
        "brokerComment": "[so 15.49%/936.11/6043.69]",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -786.24,
        "priceIn": 3228.58,
        "doubleCheck": true
    },
    {
        "dataID": "119284",
        "id": "53117361",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 14:47:21",
        "brokerTime": "2025-05-14 15:21:37",
        "commission": -3.01,
        "swap": 0,
        "profit": -693.16,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071388",
        "positionId": "56048939",
        "volume": 0.43,
        "price": 3213.53,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_SO",
        "takeProfit": 3308.68,
        "brokerComment": "[so 16.40%/936.11/5707.93]",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -696.17,
        "priceIn": 3229.65,
        "doubleCheck": true
    },
    {
        "dataID": "119285",
        "id": "53117362",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 15:01:08",
        "brokerTime": "2025-05-14 15:21:37",
        "commission": -8.96,
        "swap": 0,
        "profit": -663.04,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071389",
        "positionId": "56052929",
        "volume": 1.28,
        "price": 3213.53,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_SO",
        "takeProfit": 3308.68,
        "brokerComment": "[so 17.24%/936.11/5430.19]",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -672,
        "priceIn": 3218.71,
        "doubleCheck": true
    },
    {
        "dataID": "119286",
        "id": "53117363",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:21:37",
        "brokerTime": "2025-05-14 15:21:37",
        "commission": -60.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071390",
        "positionId": "56071390",
        "volume": 8.61,
        "price": 3213.52,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -60.27,
        "priceIn": 3213.52,
        "doubleCheck": true
    },
    {
        "dataID": "119287",
        "id": "53117364",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:21:37",
        "brokerTime": "2025-05-14 15:21:38",
        "commission": -60.27,
        "swap": 0,
        "profit": -766.29,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071391",
        "positionId": "56071390",
        "volume": 8.61,
        "price": 3214.41,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -826.56,
        "priceIn": 3213.52,
        "doubleCheck": true
    },
    {
        "dataID": "119288",
        "id": "53117365",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 14:46:02",
        "brokerTime": "2025-05-14 15:21:38",
        "commission": -2.52,
        "swap": 0,
        "profit": -592.56,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071392",
        "positionId": "56048820",
        "volume": 0.36,
        "price": 3214.2,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_SO",
        "takeProfit": 3308.68,
        "brokerComment": "[so 12.56%/578.72/4606.21]",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -595.0799999999999,
        "priceIn": 3230.66,
        "doubleCheck": true
    },
    {
        "dataID": "119289",
        "id": "53117366",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 14:43:00",
        "brokerTime": "2025-05-14 15:21:38",
        "commission": -2.1,
        "swap": 0,
        "profit": -523.8,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071393",
        "positionId": "56048759",
        "volume": 0.3,
        "price": 3214.2,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_SO",
        "takeProfit": 3308.63,
        "brokerComment": "[so 13.23%/578.72/4373.61]",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -525.9,
        "priceIn": 3231.66,
        "doubleCheck": true
    },
    {
        "dataID": "119290",
        "id": "53117367",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 14:42:39",
        "brokerTime": "2025-05-14 15:21:38",
        "commission": -1.75,
        "swap": 0,
        "profit": -463,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071394",
        "positionId": "56048738",
        "volume": 0.25,
        "price": 3214.2,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_SO",
        "takeProfit": 3308.63,
        "brokerComment": "[so 13.85%/578.72/4179.73]",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -464.75,
        "priceIn": 3232.72,
        "doubleCheck": true
    },
    {
        "dataID": "119291",
        "id": "53117368",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 14:38:53",
        "brokerTime": "2025-05-14 15:21:38",
        "commission": -1.47,
        "swap": 0,
        "profit": -412.23,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071395",
        "positionId": "56048576",
        "volume": 0.21,
        "price": 3214.2,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_SO",
        "takeProfit": 3308.63,
        "brokerComment": "[so 14.40%/578.72/4018.11]",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -413.70000000000005,
        "priceIn": 3233.83,
        "doubleCheck": true
    },
    {
        "dataID": "119292",
        "id": "53117369",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 14:37:06",
        "brokerTime": "2025-05-14 15:21:38",
        "commission": -1.19,
        "swap": 0,
        "profit": -352.92,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071396",
        "positionId": "56048522",
        "volume": 0.17,
        "price": 3214.2,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_SO",
        "takeProfit": 3308.59,
        "brokerComment": "[so 14.91%/578.72/3882.30]",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -354.11,
        "priceIn": 3234.96,
        "doubleCheck": true
    },
    {
        "dataID": "119293",
        "id": "53117370",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:01",
        "brokerTime": "2025-05-14 15:21:38",
        "commission": -7.63,
        "swap": 0,
        "profit": -323.98,
        "symbol": "XAUEUR.PRO",
        "magic": "0",
        "orderId": "56071397",
        "positionId": "56068874",
        "volume": 1.09,
        "price": 2865.85,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_SO",
        "takeProfit": 0,
        "brokerComment": "[so 15.34%/578.72/3772.32]",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -331.61,
        "priceIn": 2863.2,
        "doubleCheck": true
    },
    {
        "dataID": "119294",
        "id": "53117371",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 14:36:01",
        "brokerTime": "2025-05-14 15:21:38",
        "commission": -0.98,
        "swap": 0,
        "profit": -304.64,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071398",
        "positionId": "56048484",
        "volume": 0.14,
        "price": 3214.2,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_SO",
        "takeProfit": 3308.59,
        "brokerComment": "[so 15.34%/578.72/3772.48]",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -305.62,
        "priceIn": 3235.96,
        "doubleCheck": true
    },
    {
        "dataID": "119295",
        "id": "53117372",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 14:32:18",
        "brokerTime": "2025-05-14 15:21:38",
        "commission": -0.84,
        "swap": 0,
        "profit": -274.44,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071399",
        "positionId": "56048322",
        "volume": 0.12,
        "price": 3214.2,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_SO",
        "takeProfit": 3308.59,
        "brokerComment": "[so 15.72%/578.72/3681.89]",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -275.28,
        "priceIn": 3237.07,
        "doubleCheck": true
    },
    {
        "dataID": "119296",
        "id": "53117373",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 14:26:36",
        "brokerTime": "2025-05-14 15:21:38",
        "commission": -0.7,
        "swap": 0,
        "profit": -238.9,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071400",
        "positionId": "56048272",
        "volume": 0.1,
        "price": 3214.2,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_SO",
        "takeProfit": 3308.59,
        "brokerComment": "[so 16.06%/578.72/3604.21]",
        "comment": "RR",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -239.6,
        "priceIn": 3238.09,
        "doubleCheck": true
    },
    {
        "dataID": "119297",
        "id": "53117374",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 15:13:17",
        "brokerTime": "2025-05-14 15:21:38",
        "commission": -10.78,
        "swap": 0,
        "profit": -150.92,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071401",
        "positionId": "56057151",
        "volume": 1.54,
        "price": 3214.2,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_SO",
        "takeProfit": 3308.68,
        "brokerComment": "[so 16.35%/578.72/3539.45]",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -161.7,
        "priceIn": 3215.18,
        "doubleCheck": true
    },
    {
        "dataID": "119298",
        "id": "53117375",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 15:18:34",
        "brokerTime": "2025-05-14 15:21:40",
        "commission": -15.54,
        "swap": 0,
        "profit": 1209.9,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071402",
        "positionId": "56070596",
        "volume": 2.22,
        "price": 3214.33,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3308.68,
        "brokerComment": "",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 1194.3600000000001,
        "priceIn": 3208.88,
        "doubleCheck": true
    },
    {
        "dataID": "119299",
        "id": "53117376",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 15:16:16",
        "brokerTime": "2025-05-14 15:21:40",
        "commission": -12.95,
        "swap": 0,
        "profit": 416.25,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071403",
        "positionId": "56068520",
        "volume": 1.85,
        "price": 3214.33,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3308.68,
        "brokerComment": "",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 403.3,
        "priceIn": 3212.08,
        "doubleCheck": true
    },
    {
        "dataID": "119300",
        "id": "53117377",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 15:21:46",
        "brokerTime": "2025-05-14 15:21:46",
        "commission": -0.7,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071404",
        "positionId": "56071404",
        "volume": 0.1,
        "price": 3214.47,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "RR",
        "comment": "RR",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.7,
        "priceIn": 3214.47,
        "doubleCheck": true
    },
    {
        "dataID": "119301",
        "id": "53117381",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:22:00",
        "brokerTime": "2025-05-14 15:22:00",
        "commission": -0.84,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071408",
        "positionId": "56071408",
        "volume": 0.12,
        "price": 3213.53,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3113.53,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.84,
        "priceIn": 3213.53,
        "doubleCheck": true
    },
    {
        "dataID": "119302",
        "id": "53117415",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:23:00",
        "brokerTime": "2025-05-14 15:23:00",
        "commission": -0.98,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071439",
        "positionId": "56071439",
        "volume": 0.14,
        "price": 3214.84,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3114.84,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.98,
        "priceIn": 3214.84,
        "doubleCheck": true
    },
    {
        "dataID": "119303",
        "id": "53117559",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:24:00",
        "brokerTime": "2025-05-14 15:24:00",
        "commission": -1.19,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071554",
        "positionId": "56071554",
        "volume": 0.17,
        "price": 3216.01,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3116.01,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -1.19,
        "priceIn": 3216.01,
        "doubleCheck": true
    },
    {
        "dataID": "119304",
        "id": "53117831",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:24:00",
        "brokerTime": "2025-05-14 15:24:47",
        "commission": -1.19,
        "swap": 0,
        "profit": -12.75,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071775",
        "positionId": "56071554",
        "volume": 0.17,
        "price": 3216.76,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3116.19,
        "brokerComment": "",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -13.94,
        "priceIn": 3216.01,
        "doubleCheck": true,
        "isShow": false,
        "collapseIndex": "0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35",
        "tProfit": -124.23,
        "tnProfit": -127.94,
        "tVolume": 0.53,
        "tTrades": 4
    },
    {
        "dataID": "119305",
        "id": "53117832",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:23:00",
        "brokerTime": "2025-05-14 15:24:47",
        "commission": -0.98,
        "swap": 0,
        "profit": -26.74,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071776",
        "positionId": "56071439",
        "volume": 0.14,
        "price": 3216.75,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3116.21,
        "brokerComment": "",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -27.72,
        "priceIn": 3214.84,
        "doubleCheck": true
    },
    {
        "dataID": "119306",
        "id": "53117833",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:22:00",
        "brokerTime": "2025-05-14 15:24:47",
        "commission": -0.84,
        "swap": 0,
        "profit": -38.64,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071777",
        "positionId": "56071408",
        "volume": 0.12,
        "price": 3216.75,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3116.29,
        "brokerComment": "",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -39.480000000000004,
        "priceIn": 3213.53,
        "doubleCheck": true
    },
    {
        "dataID": "119307",
        "id": "53117834",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 15:21:46",
        "brokerTime": "2025-05-14 15:24:47",
        "commission": -0.7,
        "swap": 0,
        "profit": 20.8,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071778",
        "positionId": "56071404",
        "volume": 0.1,
        "price": 3216.55,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "RR",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 20.1,
        "priceIn": 3214.47,
        "doubleCheck": true,
        "tProfit": 20.8,
        "tnProfit": 20.1,
        "tVolume": 0.1,
        "tTrades": 1
    },
    {
        "dataID": "119308",
        "id": "53117835",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:21:17",
        "brokerTime": "2025-05-14 15:24:47",
        "commission": -0.7,
        "swap": 0,
        "profit": -46.1,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56071779",
        "positionId": "56071337",
        "volume": 0.1,
        "price": 3216.75,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3116.29,
        "brokerComment": "",
        "comment": "RR",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -46.800000000000004,
        "priceIn": 3212.14,
        "doubleCheck": true
    },
    {
        "dataID": "119309",
        "id": "53117837",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 15:17:00",
        "brokerTime": "2025-05-14 15:24:49",
        "commission": -1.75,
        "swap": 0,
        "profit": 66.22,
        "symbol": "XAUEUR.PRO",
        "magic": "0",
        "orderId": "56071781",
        "positionId": "56068871",
        "volume": 0.25,
        "price": 2865.89,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2963.29,
        "brokerComment": "",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 64.47,
        "priceIn": 2863.53,
        "doubleCheck": true,
        "isShow": false,
        "collapseIndex": "0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34",
        "tProfit": -30.65,
        "tnProfit": -37.58,
        "tVolume": 0.99,
        "tTrades": 6
    },
    {
        "dataID": "119310",
        "id": "53117838",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 15:16:12",
        "brokerTime": "2025-05-14 15:24:49",
        "commission": -1.47,
        "swap": 0,
        "profit": 29.46,
        "symbol": "XAUEUR.PRO",
        "magic": "0",
        "orderId": "56071782",
        "positionId": "56068485",
        "volume": 0.21,
        "price": 2865.95,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2963.29,
        "brokerComment": "",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 27.990000000000002,
        "priceIn": 2864.7,
        "doubleCheck": true
    },
    {
        "dataID": "119311",
        "id": "53117839",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 15:15:01",
        "brokerTime": "2025-05-14 15:24:49",
        "commission": -1.19,
        "swap": 0,
        "profit": -0.19,
        "symbol": "XAUEUR.PRO",
        "magic": "0",
        "orderId": "56071783",
        "positionId": "56068304",
        "volume": 0.17,
        "price": 2865.95,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2963.29,
        "brokerComment": "",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -1.38,
        "priceIn": 2865.96,
        "doubleCheck": true
    },
    {
        "dataID": "119312",
        "id": "53117840",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 15:14:00",
        "brokerTime": "2025-05-14 15:24:49",
        "commission": -0.98,
        "swap": 0,
        "profit": -18.85,
        "symbol": "XAUEUR.PRO",
        "magic": "0",
        "orderId": "56071784",
        "positionId": "56065325",
        "volume": 0.14,
        "price": 2865.95,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2963.29,
        "brokerComment": "",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -19.830000000000002,
        "priceIn": 2867.15,
        "doubleCheck": true
    },
    {
        "dataID": "119313",
        "id": "53117841",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:42",
        "brokerTime": "2025-05-14 15:24:49",
        "commission": -0.7,
        "swap": 0,
        "profit": 10.21,
        "symbol": "XAUEUR.PRO",
        "magic": "0",
        "orderId": "56071785",
        "positionId": "56059993",
        "volume": 0.1,
        "price": 2866.2,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "RR",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 9.510000000000002,
        "priceIn": 2867.11,
        "doubleCheck": true,
        "tProfit": 10.21,
        "tnProfit": 9.51,
        "tVolume": 0.1,
        "tTrades": 1
    },
    {
        "dataID": "119314",
        "id": "53117842",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 15:13:10",
        "brokerTime": "2025-05-14 15:24:49",
        "commission": -0.84,
        "swap": 0,
        "profit": -51.85,
        "symbol": "XAUEUR.PRO",
        "magic": "0",
        "orderId": "56071786",
        "positionId": "56056805",
        "volume": 0.12,
        "price": 2865.94,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2963.29,
        "brokerComment": "",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -52.690000000000005,
        "priceIn": 2869.79,
        "doubleCheck": true
    },
    {
        "dataID": "119315",
        "id": "53117843",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 15:05:52",
        "brokerTime": "2025-05-14 15:24:49",
        "commission": -0.7,
        "swap": 0,
        "profit": -55.44,
        "symbol": "XAUEUR.PRO",
        "magic": "0",
        "orderId": "56071787",
        "positionId": "56054143",
        "volume": 0.1,
        "price": 2865.94,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2963.29,
        "brokerComment": "",
        "comment": "RR",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -56.14,
        "priceIn": 2870.88,
        "doubleCheck": true
    },
    {
        "dataID": "119316",
        "id": "53157918",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 18:01:37",
        "brokerTime": "2025-05-14 18:01:37",
        "commission": -0.7,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUEUR.PRO",
        "magic": "0",
        "orderId": "56102616",
        "positionId": "56102616",
        "volume": 0.1,
        "price": 2839.07,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2939.07,
        "brokerComment": "Buy Order",
        "comment": "Buy Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.7,
        "priceIn": 2839.07,
        "doubleCheck": true
    },
    {
        "dataID": "119317",
        "id": "53157919",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 18:01:38",
        "brokerTime": "2025-05-14 18:01:38",
        "commission": -0.7,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56102617",
        "positionId": "56102617",
        "volume": 0.1,
        "price": 3183.48,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3283.48,
        "brokerComment": "Buy Order",
        "comment": "Buy Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.7,
        "priceIn": 3183.48,
        "doubleCheck": true
    },
    {
        "dataID": "119318",
        "id": "53157920",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 18:01:39",
        "brokerTime": "2025-05-14 18:01:39",
        "commission": -0.7,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56102618",
        "positionId": "56102618",
        "volume": 0.1,
        "price": 3183.19,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3083.19,
        "brokerComment": "Sell Order",
        "comment": "Sell Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.7,
        "priceIn": 3183.19,
        "doubleCheck": true
    },
    {
        "dataID": "119319",
        "id": "53157921",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 18:01:39",
        "brokerTime": "2025-05-14 18:01:39",
        "commission": -0.7,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUEUR.PRO",
        "magic": "0",
        "orderId": "56102619",
        "positionId": "56102619",
        "volume": 0.1,
        "price": 2838.73,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2738.73,
        "brokerComment": "Sell Order",
        "comment": "Sell Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.7,
        "priceIn": 2838.73,
        "doubleCheck": true
    },
    {
        "dataID": "119320",
        "id": "53158559",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 18:02:57",
        "brokerTime": "2025-05-14 18:02:57",
        "commission": -0.84,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56103208",
        "positionId": "56103208",
        "volume": 0.12,
        "price": 3182.47,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3282.47,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.84,
        "priceIn": 3182.47,
        "doubleCheck": true
    },
    {
        "dataID": "119321",
        "id": "53159124",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 18:03:00",
        "brokerTime": "2025-05-14 18:03:00",
        "commission": -0.84,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUEUR.PRO",
        "magic": "0",
        "orderId": "56103772",
        "positionId": "56103772",
        "volume": 0.12,
        "price": 2838.04,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2938.04,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.84,
        "priceIn": 2838.04,
        "doubleCheck": true
    },
    {
        "dataID": "119322",
        "id": "53159346",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 18:03:00",
        "brokerTime": "2025-05-14 18:03:00",
        "commission": -0.98,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56103776",
        "positionId": "56103776",
        "volume": 0.14,
        "price": 3181.17,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3281.17,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.98,
        "priceIn": 3181.17,
        "doubleCheck": true
    },
    {
        "dataID": "119323",
        "id": "53161851",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 18:04:11",
        "brokerTime": "2025-05-14 18:04:11",
        "commission": -1.19,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56105904",
        "positionId": "56105904",
        "volume": 0.17,
        "price": 3180.17,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3280.17,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -1.19,
        "priceIn": 3180.17,
        "doubleCheck": true
    },
    {
        "dataID": "119324",
        "id": "53162475",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 18:06:49",
        "brokerTime": "2025-05-14 18:06:49",
        "commission": -0.84,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUEUR.PRO",
        "magic": "0",
        "orderId": "56106448",
        "positionId": "56106448",
        "volume": 0.12,
        "price": 2839.86,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2739.86,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.84,
        "priceIn": 2839.86,
        "doubleCheck": true
    },
    {
        "dataID": "119325",
        "id": "53162542",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 18:04:11",
        "brokerTime": "2025-05-14 18:07:34",
        "commission": -1.19,
        "swap": 0,
        "profit": 44.88,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56106516",
        "positionId": "56105904",
        "volume": 0.17,
        "price": 3182.81,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3279.95,
        "brokerComment": "",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 43.690000000000005,
        "priceIn": 3180.17,
        "doubleCheck": true,
        "isShow": false,
        "collapseIndex": "0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37",
        "tProfit": 64.86,
        "tnProfit": 61.15,
        "tVolume": 0.53,
        "tTrades": 4
    },
    {
        "dataID": "119326",
        "id": "53162543",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 18:03:00",
        "brokerTime": "2025-05-14 18:07:34",
        "commission": -0.98,
        "swap": 0,
        "profit": 22.82,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56106517",
        "positionId": "56103776",
        "volume": 0.14,
        "price": 3182.8,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3279.96,
        "brokerComment": "",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 21.84,
        "priceIn": 3181.17,
        "doubleCheck": true
    },
    {
        "dataID": "119327",
        "id": "53162544",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 18:02:57",
        "brokerTime": "2025-05-14 18:07:34",
        "commission": -0.84,
        "swap": 0,
        "profit": 3.96,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56106518",
        "positionId": "56103208",
        "volume": 0.12,
        "price": 3182.8,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3279.96,
        "brokerComment": "",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 3.12,
        "priceIn": 3182.47,
        "doubleCheck": true
    },
    {
        "dataID": "119328",
        "id": "53162545",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 18:01:38",
        "brokerTime": "2025-05-14 18:07:34",
        "commission": -0.7,
        "swap": 0,
        "profit": -6.8,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56106519",
        "positionId": "56102617",
        "volume": 0.1,
        "price": 3182.8,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3280.03,
        "brokerComment": "",
        "comment": "Buy Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -7.5,
        "priceIn": 3183.48,
        "doubleCheck": true
    },
    {
        "dataID": "119329",
        "id": "53162547",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 18:07:41",
        "brokerTime": "2025-05-14 18:07:41",
        "commission": -0.7,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56106521",
        "positionId": "56106521",
        "volume": 0.1,
        "price": 3182.3,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "RR",
        "comment": "RR",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.7,
        "priceIn": 3182.3,
        "doubleCheck": true
    },
    {
        "dataID": "119330",
        "id": "53162615",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 18:08:37",
        "brokerTime": "2025-05-14 18:08:37",
        "commission": -0.84,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56106570",
        "positionId": "56106570",
        "volume": 0.12,
        "price": 3181.03,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3281.03,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.84,
        "priceIn": 3181.03,
        "doubleCheck": true
    },
    {
        "dataID": "119331",
        "id": "53162681",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 18:10:50",
        "brokerTime": "2025-05-14 18:10:50",
        "commission": -0.98,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56106631",
        "positionId": "56106631",
        "volume": 0.14,
        "price": 3179.79,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3279.79,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.98,
        "priceIn": 3179.79,
        "doubleCheck": true
    },
    {
        "dataID": "119332",
        "id": "53164694",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 18:18:02",
        "brokerTime": "2025-05-14 18:18:02",
        "commission": -0.98,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUEUR.PRO",
        "magic": "0",
        "orderId": "56108320",
        "positionId": "56108320",
        "volume": 0.14,
        "price": 2840.98,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2740.98,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.98,
        "priceIn": 2840.98,
        "doubleCheck": true
    },
    {
        "dataID": "119333",
        "id": "53164733",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 18:10:50",
        "brokerTime": "2025-05-14 18:18:07",
        "commission": -0.98,
        "swap": 0,
        "profit": 34.86,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56108346",
        "positionId": "56106631",
        "volume": 0.14,
        "price": 3182.28,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3279.63,
        "brokerComment": "",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 33.88,
        "priceIn": 3179.79,
        "doubleCheck": true,
        "isShow": false,
        "collapseIndex": "0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38",
        "tProfit": 50.1,
        "tnProfit": 48.28,
        "tVolume": 0.26,
        "tTrades": 2
    },
    {
        "dataID": "119334",
        "id": "53164734",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 18:08:37",
        "brokerTime": "2025-05-14 18:18:07",
        "commission": -0.84,
        "swap": 0,
        "profit": 15.24,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56108347",
        "positionId": "56106570",
        "volume": 0.12,
        "price": 3182.3,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3279.62,
        "brokerComment": "",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 14.4,
        "priceIn": 3181.03,
        "doubleCheck": true
    },
    {
        "dataID": "119335",
        "id": "53164735",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 18:07:41",
        "brokerTime": "2025-05-14 18:18:07",
        "commission": -0.7,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56108348",
        "positionId": "56106521",
        "volume": 0.1,
        "price": 3182.3,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3279.62,
        "brokerComment": "",
        "comment": "RR",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.7,
        "priceIn": 3182.3,
        "doubleCheck": true
    },
    {
        "dataID": "119336",
        "id": "53164756",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 18:18:14",
        "brokerTime": "2025-05-14 18:18:14",
        "commission": -0.7,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56108362",
        "positionId": "56108362",
        "volume": 0.1,
        "price": 3182.91,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "RR",
        "comment": "RR",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.7,
        "priceIn": 3182.91,
        "doubleCheck": true
    },
    {
        "dataID": "119337",
        "id": "53164955",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 18:19:30",
        "brokerTime": "2025-05-14 18:19:30",
        "commission": -1.19,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUEUR.PRO",
        "magic": "0",
        "orderId": "56108507",
        "positionId": "56108507",
        "volume": 0.17,
        "price": 2841.99,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2741.99,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -1.19,
        "priceIn": 2841.99,
        "doubleCheck": true
    },
    {
        "dataID": "119338",
        "id": "53164961",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 18:19:51",
        "brokerTime": "2025-05-14 18:19:51",
        "commission": -0.84,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56108513",
        "positionId": "56108513",
        "volume": 0.12,
        "price": 3184.3,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3084.27,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.84,
        "priceIn": 3184.3,
        "doubleCheck": true
    },
    {
        "dataID": "119339",
        "id": "53164995",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 18:21:00",
        "brokerTime": "2025-05-14 18:21:00",
        "commission": -1.47,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUEUR.PRO",
        "magic": "0",
        "orderId": "56108545",
        "positionId": "56108545",
        "volume": 0.21,
        "price": 2843.09,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2743.09,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -1.47,
        "priceIn": 2843.09,
        "doubleCheck": true
    },
    {
        "dataID": "119340",
        "id": "53165001",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 18:21:01",
        "brokerTime": "2025-05-14 18:21:01",
        "commission": -0.98,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56108550",
        "positionId": "56108550",
        "volume": 0.14,
        "price": 3185.32,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3085.32,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.98,
        "priceIn": 3185.32,
        "doubleCheck": true
    },
    {
        "dataID": "119341",
        "id": "53165509",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 18:26:48",
        "brokerTime": "2025-05-14 18:26:48",
        "commission": -1.19,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56108920",
        "positionId": "56108920",
        "volume": 0.17,
        "price": 3186.36,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3086.36,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -1.19,
        "priceIn": 3186.36,
        "doubleCheck": true
    },
    {
        "dataID": "119342",
        "id": "53166015",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 18:26:48",
        "brokerTime": "2025-05-14 18:31:47",
        "commission": -1.19,
        "swap": 0,
        "profit": 40.46,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56109365",
        "positionId": "56108920",
        "volume": 0.17,
        "price": 3183.98,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3086.55,
        "brokerComment": "",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 39.27,
        "priceIn": 3186.36,
        "doubleCheck": true,
        "isShow": false,
        "collapseIndex": "0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39",
        "tProfit": 55.16,
        "tnProfit": 51.45,
        "tVolume": 0.53,
        "tTrades": 4
    },
    {
        "dataID": "119343",
        "id": "53166016",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 18:21:01",
        "brokerTime": "2025-05-14 18:31:47",
        "commission": -0.98,
        "swap": 0,
        "profit": 18.76,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56109366",
        "positionId": "56108550",
        "volume": 0.14,
        "price": 3183.98,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3086.55,
        "brokerComment": "",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 17.78,
        "priceIn": 3185.32,
        "doubleCheck": true
    },
    {
        "dataID": "119344",
        "id": "53166017",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 18:19:51",
        "brokerTime": "2025-05-14 18:31:47",
        "commission": -0.84,
        "swap": 0,
        "profit": 3.84,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56109367",
        "positionId": "56108513",
        "volume": 0.12,
        "price": 3183.98,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3086.55,
        "brokerComment": "",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 3,
        "priceIn": 3184.3,
        "doubleCheck": true
    },
    {
        "dataID": "119345",
        "id": "53166018",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 18:01:39",
        "brokerTime": "2025-05-14 18:31:47",
        "commission": -0.7,
        "swap": 0,
        "profit": -7.9,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56109368",
        "positionId": "56102618",
        "volume": 0.1,
        "price": 3183.98,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3086.55,
        "brokerComment": "",
        "comment": "Sell Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -8.6,
        "priceIn": 3183.19,
        "doubleCheck": true
    },
    {
        "dataID": "119346",
        "id": "53166021",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 18:31:54",
        "brokerTime": "2025-05-14 18:31:54",
        "commission": -0.7,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56109371",
        "positionId": "56109371",
        "volume": 0.1,
        "price": 3183.66,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "RR",
        "comment": "RR",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.7,
        "priceIn": 3183.66,
        "doubleCheck": true
    },
    {
        "dataID": "119347",
        "id": "53166030",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 18:32:11",
        "brokerTime": "2025-05-14 18:32:11",
        "commission": -0.84,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56109380",
        "positionId": "56109380",
        "volume": 0.12,
        "price": 3184.72,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3084.72,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.84,
        "priceIn": 3184.72,
        "doubleCheck": true
    },
    {
        "dataID": "119348",
        "id": "53166106",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 18:33:43",
        "brokerTime": "2025-05-14 18:33:43",
        "commission": -0.98,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56109439",
        "positionId": "56109439",
        "volume": 0.14,
        "price": 3186.05,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3086.05,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.98,
        "priceIn": 3186.05,
        "doubleCheck": true
    },
    {
        "dataID": "119349",
        "id": "53166449",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 18:38:12",
        "brokerTime": "2025-05-14 18:38:12",
        "commission": -0.84,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56109710",
        "positionId": "56109710",
        "volume": 0.12,
        "price": 3181.89,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3281.89,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.84,
        "priceIn": 3181.89,
        "doubleCheck": true
    },
    {
        "dataID": "119350",
        "id": "53166500",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 18:33:43",
        "brokerTime": "2025-05-14 18:39:03",
        "commission": -0.98,
        "swap": 0,
        "profit": 51.52,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56109747",
        "positionId": "56109439",
        "volume": 0.14,
        "price": 3182.37,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3086.25,
        "brokerComment": "",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 50.540000000000006,
        "priceIn": 3186.05,
        "doubleCheck": true,
        "isShow": false,
        "collapseIndex": "0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39,40",
        "tProfit": 92.62,
        "tnProfit": 90.1,
        "tVolume": 0.36,
        "tTrades": 3
    },
    {
        "dataID": "119351",
        "id": "53166501",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 18:32:11",
        "brokerTime": "2025-05-14 18:39:03",
        "commission": -0.84,
        "swap": 0,
        "profit": 28.2,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56109748",
        "positionId": "56109380",
        "volume": 0.12,
        "price": 3182.37,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3086.27,
        "brokerComment": "",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 27.36,
        "priceIn": 3184.72,
        "doubleCheck": true
    },
    {
        "dataID": "119352",
        "id": "53166502",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 18:31:54",
        "brokerTime": "2025-05-14 18:39:03",
        "commission": -0.7,
        "swap": 0,
        "profit": 12.9,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56109749",
        "positionId": "56109371",
        "volume": 0.1,
        "price": 3182.37,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3086.27,
        "brokerComment": "",
        "comment": "RR",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 12.200000000000001,
        "priceIn": 3183.66,
        "doubleCheck": true
    },
    {
        "dataID": "119353",
        "id": "53166507",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 18:39:10",
        "brokerTime": "2025-05-14 18:39:10",
        "commission": -0.7,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56109753",
        "positionId": "56109753",
        "volume": 0.1,
        "price": 3182.03,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "RR",
        "comment": "RR",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.7,
        "priceIn": 3182.03,
        "doubleCheck": true
    },
    {
        "dataID": "119354",
        "id": "53167053",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 18:40:42",
        "brokerTime": "2025-05-14 18:40:42",
        "commission": -0.84,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56110139",
        "positionId": "56110139",
        "volume": 0.12,
        "price": 3183.04,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3083.04,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.84,
        "priceIn": 3183.04,
        "doubleCheck": true
    },
    {
        "dataID": "119355",
        "id": "53167341",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 18:44:25",
        "brokerTime": "2025-05-14 18:44:25",
        "commission": -0.98,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56110346",
        "positionId": "56110346",
        "volume": 0.14,
        "price": 3180.71,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3280.85,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.98,
        "priceIn": 3180.71,
        "doubleCheck": true
    },
    {
        "dataID": "119356",
        "id": "53168419",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 18:49:55",
        "brokerTime": "2025-05-14 18:49:55",
        "commission": -1.19,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56111190",
        "positionId": "56111190",
        "volume": 0.17,
        "price": 3179.66,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3279.66,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -1.19,
        "priceIn": 3179.66,
        "doubleCheck": true
    },
    {
        "dataID": "119357",
        "id": "53169856",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 18:49:55",
        "brokerTime": "2025-05-14 19:00:21",
        "commission": -1.19,
        "swap": 0,
        "profit": 51,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56112467",
        "positionId": "56111190",
        "volume": 0.17,
        "price": 3182.66,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3279.47,
        "brokerComment": "",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 49.81,
        "priceIn": 3179.66,
        "doubleCheck": true,
        "isShow": false,
        "collapseIndex": "0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39,40,41",
        "tProfit": 84.82,
        "tnProfit": 81.11,
        "tVolume": 0.53,
        "tTrades": 4
    },
    {
        "dataID": "119358",
        "id": "53169857",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 18:44:25",
        "brokerTime": "2025-05-14 19:00:21",
        "commission": -0.98,
        "swap": 0,
        "profit": 27.3,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56112468",
        "positionId": "56110346",
        "volume": 0.14,
        "price": 3182.66,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3279.47,
        "brokerComment": "",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 26.32,
        "priceIn": 3180.71,
        "doubleCheck": true
    },
    {
        "dataID": "119359",
        "id": "53169858",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 18:38:12",
        "brokerTime": "2025-05-14 19:00:21",
        "commission": -0.84,
        "swap": 0,
        "profit": 9.12,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56112469",
        "positionId": "56109710",
        "volume": 0.12,
        "price": 3182.65,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3279.47,
        "brokerComment": "",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 8.28,
        "priceIn": 3181.89,
        "doubleCheck": true
    },
    {
        "dataID": "119360",
        "id": "53169859",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 18:18:14",
        "brokerTime": "2025-05-14 19:00:21",
        "commission": -0.7,
        "swap": 0,
        "profit": -2.6,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56112470",
        "positionId": "56108362",
        "volume": 0.1,
        "price": 3182.65,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3279.47,
        "brokerComment": "",
        "comment": "RR",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -3.3,
        "priceIn": 3182.91,
        "doubleCheck": true
    },
    {
        "dataID": "119361",
        "id": "53169861",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 19:00:28",
        "brokerTime": "2025-05-14 19:00:28",
        "commission": -0.7,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56112474",
        "positionId": "56112474",
        "volume": 0.1,
        "price": 3182.82,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "RR",
        "comment": "RR",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.7,
        "priceIn": 3182.82,
        "doubleCheck": true
    },
    {
        "dataID": "119362",
        "id": "53170105",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 19:05:42",
        "brokerTime": "2025-05-14 19:05:42",
        "commission": -0.84,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56112677",
        "positionId": "56112677",
        "volume": 0.12,
        "price": 3181.63,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3281.78,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.84,
        "priceIn": 3181.63,
        "doubleCheck": true
    },
    {
        "dataID": "119363",
        "id": "53170131",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 19:06:00",
        "brokerTime": "2025-05-14 19:06:00",
        "commission": -0.98,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56112701",
        "positionId": "56112701",
        "volume": 0.14,
        "price": 3180.59,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3280.59,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.98,
        "priceIn": 3180.59,
        "doubleCheck": true
    },
    {
        "dataID": "119364",
        "id": "53173200",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 19:14:23",
        "brokerTime": "2025-05-14 19:14:23",
        "commission": -1.19,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56114882",
        "positionId": "56114882",
        "volume": 0.17,
        "price": 3179.55,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3279.55,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -1.19,
        "priceIn": 3179.55,
        "doubleCheck": true
    },
    {
        "dataID": "119365",
        "id": "53174250",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 19:22:55",
        "brokerTime": "2025-05-14 19:22:55",
        "commission": -0.98,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56115762",
        "positionId": "56115762",
        "volume": 0.14,
        "price": 3184.08,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3084.08,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.98,
        "priceIn": 3184.08,
        "doubleCheck": true
    },
    {
        "dataID": "119366",
        "id": "53174257",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 19:23:04",
        "brokerTime": "2025-05-14 19:23:04",
        "commission": -1.19,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56115769",
        "positionId": "56115769",
        "volume": 0.17,
        "price": 3185.09,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3085.1,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -1.19,
        "priceIn": 3185.09,
        "doubleCheck": true
    },
    {
        "dataID": "119367",
        "id": "53174264",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 19:14:23",
        "brokerTime": "2025-05-14 19:23:19",
        "commission": -1.19,
        "swap": 0,
        "profit": 89.08,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56115776",
        "positionId": "56114882",
        "volume": 0.17,
        "price": 3184.79,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3279.37,
        "brokerComment": "",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 87.89,
        "priceIn": 3179.55,
        "doubleCheck": true,
        "isShow": false,
        "collapseIndex": "0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39,40,41,42",
        "tProfit": 205.14,
        "tnProfit": 201.43,
        "tVolume": 0.53,
        "tTrades": 4
    },
    {
        "dataID": "119368",
        "id": "53174265",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 19:06:00",
        "brokerTime": "2025-05-14 19:23:20",
        "commission": -0.98,
        "swap": 0,
        "profit": 58.66,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56115777",
        "positionId": "56112701",
        "volume": 0.14,
        "price": 3184.78,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3279.37,
        "brokerComment": "",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 57.68,
        "priceIn": 3180.59,
        "doubleCheck": true
    },
    {
        "dataID": "119369",
        "id": "53174266",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 19:05:42",
        "brokerTime": "2025-05-14 19:23:20",
        "commission": -0.84,
        "swap": 0,
        "profit": 37.8,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56115778",
        "positionId": "56112677",
        "volume": 0.12,
        "price": 3184.78,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3279.37,
        "brokerComment": "",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 36.959999999999994,
        "priceIn": 3181.63,
        "doubleCheck": true
    },
    {
        "dataID": "119370",
        "id": "53174267",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 19:00:28",
        "brokerTime": "2025-05-14 19:23:20",
        "commission": -0.7,
        "swap": 0,
        "profit": 19.6,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56115779",
        "positionId": "56112474",
        "volume": 0.1,
        "price": 3184.78,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3279.37,
        "brokerComment": "",
        "comment": "RR",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 18.900000000000002,
        "priceIn": 3182.82,
        "doubleCheck": true
    },
    {
        "dataID": "119371",
        "id": "53174269",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 19:23:26",
        "brokerTime": "2025-05-14 19:23:26",
        "commission": -0.7,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56115781",
        "positionId": "56115781",
        "volume": 0.1,
        "price": 3184.72,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "RR",
        "comment": "RR",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.7,
        "priceIn": 3184.72,
        "doubleCheck": true
    },
    {
        "dataID": "119372",
        "id": "53174452",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 19:25:28",
        "brokerTime": "2025-05-14 19:25:28",
        "commission": -0.84,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56115910",
        "positionId": "56115910",
        "volume": 0.12,
        "price": 3183.61,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3283.61,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.84,
        "priceIn": 3183.61,
        "doubleCheck": true
    },
    {
        "dataID": "119373",
        "id": "53175456",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 19:27:03",
        "brokerTime": "2025-05-14 19:27:03",
        "commission": -0.98,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56116611",
        "positionId": "56116611",
        "volume": 0.14,
        "price": 3182.61,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3282.61,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.98,
        "priceIn": 3182.61,
        "doubleCheck": true
    },
    {
        "dataID": "119374",
        "id": "53175931",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 19:23:04",
        "brokerTime": "2025-05-14 19:31:26",
        "commission": -1.19,
        "swap": 0,
        "profit": 41.82,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56116964",
        "positionId": "56115769",
        "volume": 0.17,
        "price": 3182.63,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3085.33,
        "brokerComment": "",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 40.63,
        "priceIn": 3185.09,
        "doubleCheck": true,
        "isShow": false,
        "collapseIndex": "0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39,40,41,42,43",
        "tProfit": 61.04,
        "tnProfit": 57.33,
        "tVolume": 0.53,
        "tTrades": 4
    },
    {
        "dataID": "119375",
        "id": "53175932",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 19:22:55",
        "brokerTime": "2025-05-14 19:31:26",
        "commission": -0.98,
        "swap": 0,
        "profit": 20.3,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56116965",
        "positionId": "56115762",
        "volume": 0.14,
        "price": 3182.63,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3085.33,
        "brokerComment": "",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 19.32,
        "priceIn": 3184.08,
        "doubleCheck": true
    },
    {
        "dataID": "119376",
        "id": "53175933",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 18:40:42",
        "brokerTime": "2025-05-14 19:31:26",
        "commission": -0.84,
        "swap": 0,
        "profit": 4.92,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56116966",
        "positionId": "56110139",
        "volume": 0.12,
        "price": 3182.63,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3085.33,
        "brokerComment": "",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 4.08,
        "priceIn": 3183.04,
        "doubleCheck": true
    },
    {
        "dataID": "119377",
        "id": "53175934",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 18:39:10",
        "brokerTime": "2025-05-14 19:31:26",
        "commission": -0.7,
        "swap": 0,
        "profit": -6,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56116967",
        "positionId": "56109753",
        "volume": 0.1,
        "price": 3182.63,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3085.31,
        "brokerComment": "",
        "comment": "RR",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -6.7,
        "priceIn": 3182.03,
        "doubleCheck": true
    },
    {
        "dataID": "119378",
        "id": "53175935",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 19:31:33",
        "brokerTime": "2025-05-14 19:31:33",
        "commission": -0.7,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56116968",
        "positionId": "56116968",
        "volume": 0.1,
        "price": 3181.93,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "RR",
        "comment": "RR",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.7,
        "priceIn": 3181.93,
        "doubleCheck": true
    },
    {
        "dataID": "119379",
        "id": "53176317",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 19:33:21",
        "brokerTime": "2025-05-14 19:33:21",
        "commission": -1.19,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56117226",
        "positionId": "56117226",
        "volume": 0.17,
        "price": 3181.61,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3281.61,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -1.19,
        "priceIn": 3181.61,
        "doubleCheck": true
    },
    {
        "dataID": "119380",
        "id": "53176631",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 19:38:59",
        "brokerTime": "2025-05-14 19:38:59",
        "commission": -0.84,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56117467",
        "positionId": "56117467",
        "volume": 0.12,
        "price": 3182.96,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3082.96,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.84,
        "priceIn": 3182.96,
        "doubleCheck": true
    },
    {
        "dataID": "119381",
        "id": "53177419",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 19:40:41",
        "brokerTime": "2025-05-14 19:40:41",
        "commission": -1.47,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56118108",
        "positionId": "56118108",
        "volume": 0.21,
        "price": 3180.36,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3280.36,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -1.47,
        "priceIn": 3180.36,
        "doubleCheck": true
    },
    {
        "dataID": "119382",
        "id": "53178747",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 19:41:00",
        "brokerTime": "2025-05-14 19:41:00",
        "commission": -1.75,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56119260",
        "positionId": "56119260",
        "volume": 0.25,
        "price": 3177.22,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3277.22,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -1.75,
        "priceIn": 3177.22,
        "doubleCheck": true
    },
    {
        "dataID": "119383",
        "id": "53179997",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 19:42:04",
        "brokerTime": "2025-05-14 19:42:04",
        "commission": -2.1,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56120225",
        "positionId": "56120225",
        "volume": 0.3,
        "price": 3175.37,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3275.44,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -2.1,
        "priceIn": 3175.37,
        "doubleCheck": true
    },
    {
        "dataID": "119384",
        "id": "53180413",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 19:38:59",
        "brokerTime": "2025-05-14 19:42:36",
        "commission": -0.84,
        "swap": 0,
        "profit": 87.24,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56120515",
        "positionId": "56117467",
        "volume": 0.12,
        "price": 3175.69,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3083.19,
        "brokerComment": "",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 86.39999999999999,
        "priceIn": 3182.96,
        "doubleCheck": true,
        "isShow": false,
        "collapseIndex": "0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39,40,41,42,43,44",
        "tProfit": 149.64,
        "tnProfit": 148.1,
        "tVolume": 0.22,
        "tTrades": 2
    },
    {
        "dataID": "119385",
        "id": "53180414",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 19:31:33",
        "brokerTime": "2025-05-14 19:42:36",
        "commission": -0.7,
        "swap": 0,
        "profit": 62.4,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56120516",
        "positionId": "56116968",
        "volume": 0.1,
        "price": 3175.69,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3083.28,
        "brokerComment": "",
        "comment": "RR",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 61.699999999999996,
        "priceIn": 3181.93,
        "doubleCheck": true
    },
    {
        "dataID": "119386",
        "id": "53180415",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 19:42:43",
        "brokerTime": "2025-05-14 19:42:43",
        "commission": -0.7,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56120517",
        "positionId": "56120517",
        "volume": 0.1,
        "price": 3176.5,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "RR",
        "comment": "RR",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.7,
        "priceIn": 3176.5,
        "doubleCheck": true
    },
    {
        "dataID": "119387",
        "id": "53180441",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 19:43:00",
        "brokerTime": "2025-05-14 19:43:00",
        "commission": -0.84,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56120542",
        "positionId": "56120542",
        "volume": 0.12,
        "price": 3177.72,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3077.68,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.84,
        "priceIn": 3177.72,
        "doubleCheck": true
    },
    {
        "dataID": "119388",
        "id": "53180674",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 19:44:07",
        "brokerTime": "2025-05-14 19:44:07",
        "commission": -0.98,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56120722",
        "positionId": "56120722",
        "volume": 0.14,
        "price": 3178.74,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3078.74,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.98,
        "priceIn": 3178.74,
        "doubleCheck": true
    },
    {
        "dataID": "119389",
        "id": "53180962",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 19:45:02",
        "brokerTime": "2025-05-14 19:45:02",
        "commission": -1.19,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56121000",
        "positionId": "56121000",
        "volume": 0.17,
        "price": 3179.77,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3079.77,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -1.19,
        "priceIn": 3179.77,
        "doubleCheck": true
    },
    {
        "dataID": "119390",
        "id": "53181914",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 19:42:04",
        "brokerTime": "2025-05-14 19:45:33",
        "commission": -2.1,
        "swap": 0,
        "profit": 156.9,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56121852",
        "positionId": "56120225",
        "volume": 0.3,
        "price": 3180.6,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3275.13,
        "brokerComment": "",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 154.8,
        "priceIn": 3175.37,
        "doubleCheck": true,
        "isShow": false,
        "collapseIndex": "0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39,40,41,42,43,44,45",
        "tProfit": 127.29,
        "tnProfit": 118.26,
        "tVolume": 1.29,
        "tTrades": 7
    },
    {
        "dataID": "119391",
        "id": "53181915",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 19:41:00",
        "brokerTime": "2025-05-14 19:45:33",
        "commission": -1.75,
        "swap": 0,
        "profit": 84.5,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56121853",
        "positionId": "56119260",
        "volume": 0.25,
        "price": 3180.6,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3274.97,
        "brokerComment": "",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 82.75,
        "priceIn": 3177.22,
        "doubleCheck": true
    },
    {
        "dataID": "119392",
        "id": "53181917",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 19:40:41",
        "brokerTime": "2025-05-14 19:45:33",
        "commission": -1.47,
        "swap": 0,
        "profit": 6.09,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56121854",
        "positionId": "56118108",
        "volume": 0.21,
        "price": 3180.65,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3274.96,
        "brokerComment": "",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 4.62,
        "priceIn": 3180.36,
        "doubleCheck": true
    },
    {
        "dataID": "119393",
        "id": "53181918",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 19:33:21",
        "brokerTime": "2025-05-14 19:45:33",
        "commission": -1.19,
        "swap": 0,
        "profit": -16.32,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56121855",
        "positionId": "56117226",
        "volume": 0.17,
        "price": 3180.65,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3275.06,
        "brokerComment": "",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -17.51,
        "priceIn": 3181.61,
        "doubleCheck": true
    },
    {
        "dataID": "119394",
        "id": "53181919",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 19:27:03",
        "brokerTime": "2025-05-14 19:45:33",
        "commission": -0.98,
        "swap": 0,
        "profit": -27.44,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56121856",
        "positionId": "56116611",
        "volume": 0.14,
        "price": 3180.65,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3275.06,
        "brokerComment": "",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -28.42,
        "priceIn": 3182.61,
        "doubleCheck": true
    },
    {
        "dataID": "119395",
        "id": "53181920",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 19:25:28",
        "brokerTime": "2025-05-14 19:45:33",
        "commission": -0.84,
        "swap": 0,
        "profit": -35.64,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56121857",
        "positionId": "56115910",
        "volume": 0.12,
        "price": 3180.64,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3275.02,
        "brokerComment": "",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -36.480000000000004,
        "priceIn": 3183.61,
        "doubleCheck": true
    },
    {
        "dataID": "119396",
        "id": "53181921",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 19:23:26",
        "brokerTime": "2025-05-14 19:45:33",
        "commission": -0.7,
        "swap": 0,
        "profit": -40.8,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56121858",
        "positionId": "56115781",
        "volume": 0.1,
        "price": 3180.64,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3275,
        "brokerComment": "",
        "comment": "RR",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -41.5,
        "priceIn": 3184.72,
        "doubleCheck": true
    },
    {
        "dataID": "119397",
        "id": "53182346",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 19:45:40",
        "brokerTime": "2025-05-14 19:45:40",
        "commission": -0.7,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56122237",
        "positionId": "56122237",
        "volume": 0.1,
        "price": 3180.71,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "RR",
        "comment": "RR",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.7,
        "priceIn": 3180.71,
        "doubleCheck": true
    },
    {
        "dataID": "119398",
        "id": "53182381",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 19:46:00",
        "brokerTime": "2025-05-14 19:46:00",
        "commission": -1.47,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56122258",
        "positionId": "56122258",
        "volume": 0.21,
        "price": 3181.15,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3081.14,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -1.47,
        "priceIn": 3181.15,
        "doubleCheck": true
    },
    {
        "dataID": "119399",
        "id": "53182499",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 19:46:38",
        "brokerTime": "2025-05-14 19:46:38",
        "commission": -1.75,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUEUR.PRO",
        "magic": "0",
        "orderId": "56122357",
        "positionId": "56122357",
        "volume": 0.25,
        "price": 2844.16,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2744.16,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -1.75,
        "priceIn": 2844.16,
        "doubleCheck": true
    },
    {
        "dataID": "119400",
        "id": "53182582",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 19:47:23",
        "brokerTime": "2025-05-14 19:47:23",
        "commission": -1.75,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56122418",
        "positionId": "56122418",
        "volume": 0.25,
        "price": 3182.16,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3082.16,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -1.75,
        "priceIn": 3182.16,
        "doubleCheck": true
    },
    {
        "dataID": "119401",
        "id": "53182671",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 19:48:55",
        "brokerTime": "2025-05-14 19:48:55",
        "commission": -7.63,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56122487",
        "positionId": "56122487",
        "volume": 1.09,
        "price": 3183.35,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -7.63,
        "priceIn": 3183.35,
        "doubleCheck": true
    },
    {
        "dataID": "119402",
        "id": "53182739",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 19:49:10",
        "brokerTime": "2025-05-14 19:49:10",
        "commission": -2.1,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUEUR.PRO",
        "magic": "0",
        "orderId": "56122536",
        "positionId": "56122536",
        "volume": 0.3,
        "price": 2845.42,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2745.42,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -2.1,
        "priceIn": 2845.42,
        "doubleCheck": true
    },
    {
        "dataID": "119403",
        "id": "53183071",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 19:53:23",
        "brokerTime": "2025-05-14 19:53:23",
        "commission": -2.52,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUEUR.PRO",
        "magic": "0",
        "orderId": "56122797",
        "positionId": "56122797",
        "volume": 0.36,
        "price": 2846.44,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2746.44,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -2.52,
        "priceIn": 2846.44,
        "doubleCheck": true
    },
    {
        "dataID": "119404",
        "id": "53183137",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 19:54:00",
        "brokerTime": "2025-05-14 19:54:00",
        "commission": -3.01,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUEUR.PRO",
        "magic": "0",
        "orderId": "56122865",
        "positionId": "56122865",
        "volume": 0.43,
        "price": 2847.94,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2747.94,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -3.01,
        "priceIn": 2847.94,
        "doubleCheck": true
    },
    {
        "dataID": "119405",
        "id": "53183281",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 19:54:01",
        "brokerTime": "2025-05-14 19:54:01",
        "commission": -15.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUEUR.PRO",
        "magic": "0",
        "orderId": "56123000",
        "positionId": "56123000",
        "volume": 2.28,
        "price": 2848.03,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -15.96,
        "priceIn": 2848.03,
        "doubleCheck": true
    },
    {
        "dataID": "119406",
        "id": "53190736",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 19:48:55",
        "brokerTime": "2025-05-14 21:02:22",
        "commission": -7.63,
        "swap": 0,
        "profit": -331.36,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56129427",
        "positionId": "56122487",
        "volume": 1.09,
        "price": 3180.31,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -338.99,
        "priceIn": 3183.35,
        "doubleCheck": true,
        "tProfit": -331.36,
        "tnProfit": -338.99,
        "tVolume": 1.09,
        "tTrades": 1
    },
    {
        "dataID": "119407",
        "id": "53190754",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 21:03:41",
        "brokerTime": "2025-05-14 21:03:41",
        "commission": -0.84,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56129447",
        "positionId": "56129447",
        "volume": 0.12,
        "price": 3179.6,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3279.68,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.84,
        "priceIn": 3179.6,
        "doubleCheck": true
    },
    {
        "dataID": "119408",
        "id": "53191128",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 19:47:23",
        "brokerTime": "2025-05-14 21:05:01",
        "commission": -1.75,
        "swap": 0,
        "profit": 75.5,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56129719",
        "positionId": "56122418",
        "volume": 0.25,
        "price": 3179.14,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3082.4,
        "brokerComment": "",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 73.75,
        "priceIn": 3182.16,
        "doubleCheck": true,
        "isShow": false,
        "collapseIndex": "0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39,40,41,42,43,44,45,46,47",
        "tProfit": 82.46,
        "tnProfit": 75.53,
        "tVolume": 0.99,
        "tTrades": 6
    },
    {
        "dataID": "119409",
        "id": "53191129",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 19:46:00",
        "brokerTime": "2025-05-14 21:05:01",
        "commission": -1.47,
        "swap": 0,
        "profit": 42.21,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56129720",
        "positionId": "56122258",
        "volume": 0.21,
        "price": 3179.14,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3082.4,
        "brokerComment": "",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 40.74,
        "priceIn": 3181.15,
        "doubleCheck": true
    },
    {
        "dataID": "119410",
        "id": "53191130",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 19:45:02",
        "brokerTime": "2025-05-14 21:05:01",
        "commission": -1.19,
        "swap": 0,
        "profit": 10.71,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56129721",
        "positionId": "56121000",
        "volume": 0.17,
        "price": 3179.14,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3082.4,
        "brokerComment": "",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 9.520000000000001,
        "priceIn": 3179.77,
        "doubleCheck": true
    },
    {
        "dataID": "119411",
        "id": "53191131",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 19:44:07",
        "brokerTime": "2025-05-14 21:05:01",
        "commission": -0.98,
        "swap": 0,
        "profit": -5.6,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56129722",
        "positionId": "56120722",
        "volume": 0.14,
        "price": 3179.14,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3082.4,
        "brokerComment": "",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -6.58,
        "priceIn": 3178.74,
        "doubleCheck": true
    },
    {
        "dataID": "119412",
        "id": "53191132",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 19:43:00",
        "brokerTime": "2025-05-14 21:05:01",
        "commission": -0.84,
        "swap": 0,
        "profit": -15.36,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56129723",
        "positionId": "56120542",
        "volume": 0.12,
        "price": 3179,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3082.4,
        "brokerComment": "",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -16.2,
        "priceIn": 3177.72,
        "doubleCheck": true
    },
    {
        "dataID": "119413",
        "id": "53191133",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 19:42:43",
        "brokerTime": "2025-05-14 21:05:01",
        "commission": -0.7,
        "swap": 0,
        "profit": -25,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56129724",
        "positionId": "56120517",
        "volume": 0.1,
        "price": 3179,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3082.42,
        "brokerComment": "",
        "comment": "RR",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -25.7,
        "priceIn": 3176.5,
        "doubleCheck": true
    },
    {
        "dataID": "119414",
        "id": "53191197",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 21:05:07",
        "brokerTime": "2025-05-14 21:05:07",
        "commission": -0.7,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56129769",
        "positionId": "56129769",
        "volume": 0.1,
        "price": 3178.63,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "RR",
        "comment": "RR",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.7,
        "priceIn": 3178.63,
        "doubleCheck": true
    },
    {
        "dataID": "119415",
        "id": "53191202",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 21:05:09",
        "brokerTime": "2025-05-14 21:05:09",
        "commission": -0.98,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56129773",
        "positionId": "56129773",
        "volume": 0.14,
        "price": 3178.58,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3278.55,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.98,
        "priceIn": 3178.58,
        "doubleCheck": true
    },
    {
        "dataID": "119416",
        "id": "53191760",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 21:06:43",
        "brokerTime": "2025-05-14 21:06:43",
        "commission": -1.19,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56130281",
        "positionId": "56130281",
        "volume": 0.17,
        "price": 3177.58,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3277.58,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -1.19,
        "priceIn": 3177.58,
        "doubleCheck": true
    },
    {
        "dataID": "119417",
        "id": "53191872",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 21:07:53",
        "brokerTime": "2025-05-14 21:07:53",
        "commission": -1.47,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56130368",
        "positionId": "56130368",
        "volume": 0.21,
        "price": 3176.58,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3276.58,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -1.47,
        "priceIn": 3176.58,
        "doubleCheck": true
    },
    {
        "dataID": "119418",
        "id": "53192201",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 21:10:13",
        "brokerTime": "2025-05-14 21:10:13",
        "commission": -1.75,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56130613",
        "positionId": "56130613",
        "volume": 0.25,
        "price": 3175.51,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3275.54,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -1.75,
        "priceIn": 3175.51,
        "doubleCheck": true
    },
    {
        "dataID": "119419",
        "id": "53195905",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 21:10:13",
        "brokerTime": "2025-05-14 21:21:50",
        "commission": -1.75,
        "swap": 0,
        "profit": 69.25,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56133743",
        "positionId": "56130613",
        "volume": 0.25,
        "price": 3178.28,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3275.26,
        "brokerComment": "",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 67.5,
        "priceIn": 3175.51,
        "doubleCheck": true,
        "isShow": false,
        "collapseIndex": "0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39,40,41,42,43,44,45,46,47,48",
        "tProfit": 73.61,
        "tnProfit": 66.68,
        "tVolume": 0.99,
        "tTrades": 6
    },
    {
        "dataID": "119420",
        "id": "53195906",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 21:07:53",
        "brokerTime": "2025-05-14 21:21:50",
        "commission": -1.47,
        "swap": 0,
        "profit": 35.91,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56133744",
        "positionId": "56130368",
        "volume": 0.21,
        "price": 3178.29,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3275.26,
        "brokerComment": "",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 34.44,
        "priceIn": 3176.58,
        "doubleCheck": true
    },
    {
        "dataID": "119421",
        "id": "53195907",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 21:06:43",
        "brokerTime": "2025-05-14 21:21:51",
        "commission": -1.19,
        "swap": 0,
        "profit": 12.07,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56133745",
        "positionId": "56130281",
        "volume": 0.17,
        "price": 3178.29,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3275.26,
        "brokerComment": "",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 10.88,
        "priceIn": 3177.58,
        "doubleCheck": true
    },
    {
        "dataID": "119422",
        "id": "53195908",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 21:05:09",
        "brokerTime": "2025-05-14 21:21:51",
        "commission": -0.98,
        "swap": 0,
        "profit": -3.92,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56133746",
        "positionId": "56129773",
        "volume": 0.14,
        "price": 3178.3,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3275.26,
        "brokerComment": "",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -4.9,
        "priceIn": 3178.58,
        "doubleCheck": true
    },
    {
        "dataID": "119423",
        "id": "53195909",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 21:03:41",
        "brokerTime": "2025-05-14 21:21:51",
        "commission": -0.84,
        "swap": 0,
        "profit": -15.6,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56133747",
        "positionId": "56129447",
        "volume": 0.12,
        "price": 3178.3,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3275.28,
        "brokerComment": "",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -16.44,
        "priceIn": 3179.6,
        "doubleCheck": true
    },
    {
        "dataID": "119424",
        "id": "53195910",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 19:45:40",
        "brokerTime": "2025-05-14 21:21:51",
        "commission": -0.7,
        "swap": 0,
        "profit": -24.1,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56133748",
        "positionId": "56122237",
        "volume": 0.1,
        "price": 3178.3,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3275.28,
        "brokerComment": "",
        "comment": "RR",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -24.8,
        "priceIn": 3180.71,
        "doubleCheck": true
    },
    {
        "dataID": "119425",
        "id": "53195911",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 21:21:57",
        "brokerTime": "2025-05-14 21:21:57",
        "commission": -0.7,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56133750",
        "positionId": "56133750",
        "volume": 0.1,
        "price": 3177.85,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "RR",
        "comment": "RR",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.7,
        "priceIn": 3177.85,
        "doubleCheck": true
    },
    {
        "dataID": "119426",
        "id": "53196378",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 21:26:01",
        "brokerTime": "2025-05-14 21:26:01",
        "commission": -0.84,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56134151",
        "positionId": "56134151",
        "volume": 0.12,
        "price": 3176.85,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3276.85,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.84,
        "priceIn": 3176.85,
        "doubleCheck": true
    },
    {
        "dataID": "119427",
        "id": "53197149",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 21:44:28",
        "brokerTime": "2025-05-14 21:44:28",
        "commission": -0.98,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56134801",
        "positionId": "56134801",
        "volume": 0.14,
        "price": 3175.82,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3275.82,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.98,
        "priceIn": 3175.82,
        "doubleCheck": true
    },
    {
        "dataID": "119428",
        "id": "53197586",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 21:50:44",
        "brokerTime": "2025-05-14 21:50:44",
        "commission": -1.19,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56135113",
        "positionId": "56135113",
        "volume": 0.17,
        "price": 3174.82,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3274.82,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -1.19,
        "priceIn": 3174.82,
        "doubleCheck": true
    },
    {
        "dataID": "119429",
        "id": "53197912",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 21:54:47",
        "brokerTime": "2025-05-14 21:54:47",
        "commission": -1.47,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56135346",
        "positionId": "56135346",
        "volume": 0.21,
        "price": 3173.71,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3273.77,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -1.47,
        "priceIn": 3173.71,
        "doubleCheck": true
    },
    {
        "dataID": "119430",
        "id": "53198294",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 21:56:43",
        "brokerTime": "2025-05-14 21:56:43",
        "commission": -1.75,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56135691",
        "positionId": "56135691",
        "volume": 0.25,
        "price": 3172.26,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3272.27,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -1.75,
        "priceIn": 3172.26,
        "doubleCheck": true
    },
    {
        "dataID": "119431",
        "id": "53199162",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 22:00:12",
        "brokerTime": "2025-05-14 22:00:12",
        "commission": -2.1,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56136424",
        "positionId": "56136424",
        "volume": 0.3,
        "price": 3171.2,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3271.21,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -2.1,
        "priceIn": 3171.2,
        "doubleCheck": true
    },
    {
        "dataID": "119432",
        "id": "53200333",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 22:02:29",
        "brokerTime": "2025-05-14 22:02:29",
        "commission": -2.52,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56137254",
        "positionId": "56137254",
        "volume": 0.36,
        "price": 3169.03,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3269.13,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -2.52,
        "priceIn": 3169.03,
        "doubleCheck": true
    },
    {
        "dataID": "119433",
        "id": "53201730",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 21:05:07",
        "brokerTime": "2025-05-14 22:05:01",
        "commission": -0.7,
        "swap": 0,
        "profit": 76,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56138317",
        "positionId": "56129769",
        "volume": 0.1,
        "price": 3171.03,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "RR",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 75.3,
        "priceIn": 3178.63,
        "doubleCheck": true,
        "isShow": false,
        "collapseIndex": "0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39,40,41,42,43,44,45,46,47,48,49,50,51",
        "tProfit": 72.7,
        "tnProfit": 71.3,
        "tVolume": 0.2,
        "tTrades": 2
    },
    {
        "dataID": "119434",
        "id": "53202050",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 22:05:08",
        "brokerTime": "2025-05-14 22:05:08",
        "commission": -0.7,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56138541",
        "positionId": "56138541",
        "volume": 0.1,
        "price": 3170.15,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "RR",
        "comment": "RR",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.7,
        "priceIn": 3170.15,
        "doubleCheck": true
    },
    {
        "dataID": "119435",
        "id": "53202058",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 22:05:08",
        "brokerTime": "2025-05-14 22:05:13",
        "commission": -0.7,
        "swap": 0,
        "profit": -3.3,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56138546",
        "positionId": "56138541",
        "volume": 0.1,
        "price": 3170.48,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "RR",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -4,
        "priceIn": 3170.15,
        "doubleCheck": true
    },
    {
        "dataID": "119436",
        "id": "53202059",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 22:02:29",
        "brokerTime": "2025-05-14 22:05:13",
        "commission": -2.52,
        "swap": 0,
        "profit": 43.56,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56138547",
        "positionId": "56137254",
        "volume": 0.36,
        "price": 3170.24,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3268.79,
        "brokerComment": "",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 41.04,
        "priceIn": 3169.03,
        "doubleCheck": true,
        "isShow": false,
        "collapseIndex": "0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39,40,41,42,43,44,45,46,47,48,49",
        "tProfit": -420.01,
        "tnProfit": -431.56,
        "tVolume": 1.65,
        "tTrades": 8
    },
    {
        "dataID": "119437",
        "id": "53202060",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 22:00:12",
        "brokerTime": "2025-05-14 22:05:13",
        "commission": -2.1,
        "swap": 0,
        "profit": -28.8,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56138548",
        "positionId": "56136424",
        "volume": 0.3,
        "price": 3170.24,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3268.72,
        "brokerComment": "",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -30.900000000000002,
        "priceIn": 3171.2,
        "doubleCheck": true
    },
    {
        "dataID": "119438",
        "id": "53202061",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 21:56:43",
        "brokerTime": "2025-05-14 22:05:13",
        "commission": -1.75,
        "swap": 0,
        "profit": -50.5,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56138549",
        "positionId": "56135691",
        "volume": 0.25,
        "price": 3170.24,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3268.54,
        "brokerComment": "",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -52.25,
        "priceIn": 3172.26,
        "doubleCheck": true
    },
    {
        "dataID": "119439",
        "id": "53202062",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 21:54:47",
        "brokerTime": "2025-05-14 22:05:13",
        "commission": -1.47,
        "swap": 0,
        "profit": -72.87,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56138551",
        "positionId": "56135346",
        "volume": 0.21,
        "price": 3170.24,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3268.49,
        "brokerComment": "",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -74.34,
        "priceIn": 3173.71,
        "doubleCheck": true
    },
    {
        "dataID": "119440",
        "id": "53202064",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 21:50:44",
        "brokerTime": "2025-05-14 22:05:13",
        "commission": -1.19,
        "swap": 0,
        "profit": -77.86,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56138552",
        "positionId": "56135113",
        "volume": 0.17,
        "price": 3170.24,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3268.35,
        "brokerComment": "",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -79.05,
        "priceIn": 3174.82,
        "doubleCheck": true
    },
    {
        "dataID": "119441",
        "id": "53202065",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 21:44:28",
        "brokerTime": "2025-05-14 22:05:13",
        "commission": -0.98,
        "swap": 0,
        "profit": -78.12,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56138553",
        "positionId": "56134801",
        "volume": 0.14,
        "price": 3170.24,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3268.27,
        "brokerComment": "",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -79.10000000000001,
        "priceIn": 3175.82,
        "doubleCheck": true
    },
    {
        "dataID": "119442",
        "id": "53202066",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 21:26:01",
        "brokerTime": "2025-05-14 22:05:13",
        "commission": -0.84,
        "swap": 0,
        "profit": -79.32,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56138554",
        "positionId": "56134151",
        "volume": 0.12,
        "price": 3170.24,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3268.35,
        "brokerComment": "",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -80.16,
        "priceIn": 3176.85,
        "doubleCheck": true
    },
    {
        "dataID": "119443",
        "id": "53202067",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 21:21:57",
        "brokerTime": "2025-05-14 22:05:13",
        "commission": -0.7,
        "swap": 0,
        "profit": -76.1,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56138555",
        "positionId": "56133750",
        "volume": 0.1,
        "price": 3170.24,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3268.35,
        "brokerComment": "",
        "comment": "RR",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -76.8,
        "priceIn": 3177.85,
        "doubleCheck": true
    },
    {
        "dataID": "119444",
        "id": "53202069",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 19:54:01",
        "brokerTime": "2025-05-14 22:05:14",
        "commission": -15.96,
        "swap": 0,
        "profit": -2467.59,
        "symbol": "XAUEUR.PRO",
        "magic": "0",
        "orderId": "56138557",
        "positionId": "56123000",
        "volume": 2.28,
        "price": 2838.34,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -2483.55,
        "priceIn": 2848.03,
        "doubleCheck": true,
        "isShow": false,
        "collapseIndex": "0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39,40,41,42,43,44,45,46,47,48,49,50",
        "tProfit": -2471.72,
        "tnProfit": -2489.22,
        "tVolume": 2.5,
        "tTrades": 3
    },
    {
        "dataID": "119445",
        "id": "53202070",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 19:54:00",
        "brokerTime": "2025-05-14 22:05:14",
        "commission": -3.01,
        "swap": 0,
        "profit": 447.14,
        "symbol": "XAUEUR.PRO",
        "magic": "0",
        "orderId": "56138558",
        "positionId": "56122865",
        "volume": 0.43,
        "price": 2838.63,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2748.18,
        "brokerComment": "",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 444.13,
        "priceIn": 2847.94,
        "doubleCheck": true,
        "isShow": false,
        "collapseIndex": "0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39,40,41,42,43,44,45,46,47,48,49,50,51,52",
        "tProfit": 1365.89,
        "tnProfit": 1351.33,
        "tVolume": 2.08,
        "tTrades": 9
    },
    {
        "dataID": "119446",
        "id": "53202071",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 19:53:23",
        "brokerTime": "2025-05-14 22:05:14",
        "commission": -2.52,
        "swap": 0,
        "profit": 314.04,
        "symbol": "XAUEUR.PRO",
        "magic": "0",
        "orderId": "56138559",
        "positionId": "56122797",
        "volume": 0.36,
        "price": 2838.63,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2748.18,
        "brokerComment": "",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 311.52000000000004,
        "priceIn": 2846.44,
        "doubleCheck": true
    },
    {
        "dataID": "119447",
        "id": "53202072",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 19:49:10",
        "brokerTime": "2025-05-14 22:05:14",
        "commission": -2.1,
        "swap": 0,
        "profit": 227.52,
        "symbol": "XAUEUR.PRO",
        "magic": "0",
        "orderId": "56138560",
        "positionId": "56122536",
        "volume": 0.3,
        "price": 2838.63,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2748.18,
        "brokerComment": "",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 225.42000000000002,
        "priceIn": 2845.42,
        "doubleCheck": true
    },
    {
        "dataID": "119448",
        "id": "53202073",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 19:46:38",
        "brokerTime": "2025-05-14 22:05:15",
        "commission": -1.75,
        "swap": 0,
        "profit": 154.42,
        "symbol": "XAUEUR.PRO",
        "magic": "0",
        "orderId": "56138561",
        "positionId": "56122357",
        "volume": 0.25,
        "price": 2838.63,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2748.18,
        "brokerComment": "",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 152.67,
        "priceIn": 2844.16,
        "doubleCheck": true
    },
    {
        "dataID": "119449",
        "id": "53202074",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 18:21:00",
        "brokerTime": "2025-05-14 22:05:15",
        "commission": -1.47,
        "swap": 0,
        "profit": 104.61,
        "symbol": "XAUEUR.PRO",
        "magic": "0",
        "orderId": "56138562",
        "positionId": "56108545",
        "volume": 0.21,
        "price": 2838.63,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2748.18,
        "brokerComment": "",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 103.14,
        "priceIn": 2843.09,
        "doubleCheck": true
    },
    {
        "dataID": "119450",
        "id": "53202075",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 18:19:30",
        "brokerTime": "2025-05-14 22:05:15",
        "commission": -1.19,
        "swap": 0,
        "profit": 63.8,
        "symbol": "XAUEUR.PRO",
        "magic": "0",
        "orderId": "56138563",
        "positionId": "56108507",
        "volume": 0.17,
        "price": 2838.63,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2748.18,
        "brokerComment": "",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 62.61,
        "priceIn": 2841.99,
        "doubleCheck": true
    },
    {
        "dataID": "119451",
        "id": "53202076",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 18:18:02",
        "brokerTime": "2025-05-14 22:05:15",
        "commission": -0.98,
        "swap": 0,
        "profit": 36.75,
        "symbol": "XAUEUR.PRO",
        "magic": "0",
        "orderId": "56138564",
        "positionId": "56108320",
        "volume": 0.14,
        "price": 2838.63,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2748.18,
        "brokerComment": "",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 35.77,
        "priceIn": 2840.98,
        "doubleCheck": true
    },
    {
        "dataID": "119452",
        "id": "53202077",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 18:06:49",
        "brokerTime": "2025-05-14 22:05:15",
        "commission": -0.84,
        "swap": 0,
        "profit": 16.49,
        "symbol": "XAUEUR.PRO",
        "magic": "0",
        "orderId": "56138565",
        "positionId": "56106448",
        "volume": 0.12,
        "price": 2838.63,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2748.18,
        "brokerComment": "",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 15.649999999999999,
        "priceIn": 2839.86,
        "doubleCheck": true
    },
    {
        "dataID": "119453",
        "id": "53202078",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 18:03:00",
        "brokerTime": "2025-05-14 22:05:15",
        "commission": -0.84,
        "swap": 0,
        "profit": 4.02,
        "symbol": "XAUEUR.PRO",
        "magic": "0",
        "orderId": "56138566",
        "positionId": "56103772",
        "volume": 0.12,
        "price": 2838.34,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2937.8,
        "brokerComment": "",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 3.1799999999999997,
        "priceIn": 2838.04,
        "doubleCheck": true
    },
    {
        "dataID": "119454",
        "id": "53202079",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 18:01:39",
        "brokerTime": "2025-05-14 22:05:15",
        "commission": -0.7,
        "swap": 0,
        "profit": 1.12,
        "symbol": "XAUEUR.PRO",
        "magic": "0",
        "orderId": "56138567",
        "positionId": "56102619",
        "volume": 0.1,
        "price": 2838.63,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2748.18,
        "brokerComment": "",
        "comment": "Sell Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 0.42000000000000015,
        "priceIn": 2838.73,
        "doubleCheck": true
    },
    {
        "dataID": "119455",
        "id": "53202080",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 18:01:37",
        "brokerTime": "2025-05-14 22:05:15",
        "commission": -0.7,
        "swap": 0,
        "profit": -8.15,
        "symbol": "XAUEUR.PRO",
        "magic": "0",
        "orderId": "56138568",
        "positionId": "56102616",
        "volume": 0.1,
        "price": 2838.34,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2937.76,
        "brokerComment": "",
        "comment": "Buy Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -8.85,
        "priceIn": 2839.07,
        "doubleCheck": true
    },
    {
        "dataID": "119456",
        "id": "53202412",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 22:06:20",
        "brokerTime": "2025-05-14 22:06:20",
        "commission": -0.7,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56138781",
        "positionId": "56138781",
        "volume": 0.1,
        "price": 3170.69,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3270.79,
        "brokerComment": "Buy Order",
        "comment": "Buy Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.7,
        "priceIn": 3170.69,
        "doubleCheck": true
    },
    {
        "dataID": "119457",
        "id": "53202413",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 22:06:21",
        "brokerTime": "2025-05-14 22:06:21",
        "commission": -0.7,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56138782",
        "positionId": "56138782",
        "volume": 0.1,
        "price": 3170.49,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3070.49,
        "brokerComment": "Sell Order",
        "comment": "Sell Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.7,
        "priceIn": 3170.49,
        "doubleCheck": true
    },
    {
        "dataID": "119458",
        "id": "53202414",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 22:06:22",
        "brokerTime": "2025-05-14 22:06:22",
        "commission": -0.7,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUEUR.PRO",
        "magic": "0",
        "orderId": "56138783",
        "positionId": "56138783",
        "volume": 0.1,
        "price": 2838.42,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2738.42,
        "brokerComment": "Sell Order",
        "comment": "Sell Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.7,
        "priceIn": 2838.42,
        "doubleCheck": true
    },
    {
        "dataID": "119459",
        "id": "53202415",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 22:06:23",
        "brokerTime": "2025-05-14 22:06:23",
        "commission": -0.7,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUEUR.PRO",
        "magic": "0",
        "orderId": "56138784",
        "positionId": "56138784",
        "volume": 0.1,
        "price": 2838.66,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2938.66,
        "brokerComment": "Buy Order",
        "comment": "Buy Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.7,
        "priceIn": 2838.66,
        "doubleCheck": true
    },
    {
        "dataID": "119460",
        "id": "53202550",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 22:08:52",
        "brokerTime": "2025-05-14 22:08:52",
        "commission": -0.84,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56138885",
        "positionId": "56138885",
        "volume": 0.12,
        "price": 3171.52,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3071.52,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.84,
        "priceIn": 3171.52,
        "doubleCheck": true
    },
    {
        "dataID": "119461",
        "id": "53202738",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 22:11:26",
        "brokerTime": "2025-05-14 22:11:26",
        "commission": -0.98,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56139025",
        "positionId": "56139025",
        "volume": 0.14,
        "price": 3172.65,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3072.58,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.98,
        "priceIn": 3172.65,
        "doubleCheck": true
    },
    {
        "dataID": "119462",
        "id": "53202973",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 22:15:05",
        "brokerTime": "2025-05-14 22:15:05",
        "commission": -0.84,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUEUR.PRO",
        "magic": "0",
        "orderId": "56139204",
        "positionId": "56139204",
        "volume": 0.12,
        "price": 2837.66,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2937.66,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.84,
        "priceIn": 2837.66,
        "doubleCheck": true
    },
    {
        "dataID": "119463",
        "id": "53203011",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 22:17:22",
        "brokerTime": "2025-05-14 22:17:22",
        "commission": -0.84,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUEUR.PRO",
        "magic": "0",
        "orderId": "56139235",
        "positionId": "56139235",
        "volume": 0.12,
        "price": 2839.53,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2739.53,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.84,
        "priceIn": 2839.53,
        "doubleCheck": true
    },
    {
        "dataID": "119464",
        "id": "53203021",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 22:18:05",
        "brokerTime": "2025-05-14 22:18:05",
        "commission": -1.19,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56139242",
        "positionId": "56139242",
        "volume": 0.17,
        "price": 3173.71,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3073.71,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -1.19,
        "priceIn": 3173.71,
        "doubleCheck": true
    },
    {
        "dataID": "119465",
        "id": "53203111",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 22:21:30",
        "brokerTime": "2025-05-14 22:21:30",
        "commission": -0.98,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUEUR.PRO",
        "magic": "0",
        "orderId": "56139325",
        "positionId": "56139325",
        "volume": 0.14,
        "price": 2840.54,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2740.54,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.98,
        "priceIn": 2840.54,
        "doubleCheck": true
    },
    {
        "dataID": "119466",
        "id": "53203132",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 22:23:53",
        "brokerTime": "2025-05-14 22:23:53",
        "commission": -1.47,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56139344",
        "positionId": "56139344",
        "volume": 0.21,
        "price": 3174.72,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3074.72,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -1.47,
        "priceIn": 3174.72,
        "doubleCheck": true
    },
    {
        "dataID": "119467",
        "id": "53203156",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 22:15:05",
        "brokerTime": "2025-05-14 22:26:05",
        "commission": -0.84,
        "swap": 0,
        "profit": 32.72,
        "symbol": "XAUEUR.PRO",
        "magic": "0",
        "orderId": "56139364",
        "positionId": "56139204",
        "volume": 0.12,
        "price": 2840.1,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2937.39,
        "brokerComment": "",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 31.88,
        "priceIn": 2837.66,
        "doubleCheck": true,
        "isShow": false,
        "collapseIndex": "0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39,40,41,42,43,44,45,46,47,48,49,50,51,52,53",
        "tProfit": 48.81,
        "tnProfit": 47.27,
        "tVolume": 0.22,
        "tTrades": 2
    },
    {
        "dataID": "119468",
        "id": "53203157",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 22:06:23",
        "brokerTime": "2025-05-14 22:26:05",
        "commission": -0.7,
        "swap": 0,
        "profit": 16.09,
        "symbol": "XAUEUR.PRO",
        "magic": "0",
        "orderId": "56139365",
        "positionId": "56138784",
        "volume": 0.1,
        "price": 2840.1,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2937.39,
        "brokerComment": "",
        "comment": "Buy Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 15.39,
        "priceIn": 2838.66,
        "doubleCheck": true
    },
    {
        "dataID": "119469",
        "id": "53203162",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 22:26:11",
        "brokerTime": "2025-05-14 22:26:11",
        "commission": -0.7,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUEUR.PRO",
        "magic": "0",
        "orderId": "56139370",
        "positionId": "56139370",
        "volume": 0.1,
        "price": 2840.56,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "RR",
        "comment": "RR",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.7,
        "priceIn": 2840.56,
        "doubleCheck": true
    },
    {
        "dataID": "119470",
        "id": "53203170",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 22:27:04",
        "brokerTime": "2025-05-14 22:27:04",
        "commission": -0.84,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUEUR.PRO",
        "magic": "0",
        "orderId": "56139378",
        "positionId": "56139378",
        "volume": 0.12,
        "price": 2839.52,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2939.52,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.84,
        "priceIn": 2839.52,
        "doubleCheck": true
    },
    {
        "dataID": "119471",
        "id": "53203260",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 22:34:27",
        "brokerTime": "2025-05-14 22:34:27",
        "commission": -1.19,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUEUR.PRO",
        "magic": "0",
        "orderId": "56139461",
        "positionId": "56139461",
        "volume": 0.17,
        "price": 2841.55,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2741.55,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -1.19,
        "priceIn": 2841.55,
        "doubleCheck": true
    },
    {
        "dataID": "119472",
        "id": "53203263",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 22:34:32",
        "brokerTime": "2025-05-14 22:34:32",
        "commission": -1.75,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56139464",
        "positionId": "56139464",
        "volume": 0.25,
        "price": 3175.73,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3075.73,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -1.75,
        "priceIn": 3175.73,
        "doubleCheck": true
    },
    {
        "dataID": "119473",
        "id": "53203305",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 22:37:21",
        "brokerTime": "2025-05-14 22:37:21",
        "commission": -2.1,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56139497",
        "positionId": "56139497",
        "volume": 0.3,
        "price": 3176.83,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3076.84,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -2.1,
        "priceIn": 3176.83,
        "doubleCheck": true
    },
    {
        "dataID": "119474",
        "id": "53203306",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 22:37:21",
        "brokerTime": "2025-05-14 22:37:21",
        "commission": -1.47,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUEUR.PRO",
        "magic": "0",
        "orderId": "56139498",
        "positionId": "56139498",
        "volume": 0.21,
        "price": 2842.86,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2742.86,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -1.47,
        "priceIn": 2842.86,
        "doubleCheck": true
    },
    {
        "dataID": "119475",
        "id": "53203369",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 22:39:23",
        "brokerTime": "2025-05-14 22:39:23",
        "commission": -1.75,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUEUR.PRO",
        "magic": "0",
        "orderId": "56139559",
        "positionId": "56139559",
        "volume": 0.25,
        "price": 2843.89,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2743.89,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -1.75,
        "priceIn": 2843.89,
        "doubleCheck": true
    },
    {
        "dataID": "119476",
        "id": "53203680",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 22:40:30",
        "brokerTime": "2025-05-14 22:40:30",
        "commission": -2.52,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56139841",
        "positionId": "56139841",
        "volume": 0.36,
        "price": 3177.84,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3077.84,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -2.52,
        "priceIn": 3177.84,
        "doubleCheck": true
    },
    {
        "dataID": "119477",
        "id": "53203708",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 22:41:11",
        "brokerTime": "2025-05-14 22:41:11",
        "commission": -3.01,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56139871",
        "positionId": "56139871",
        "volume": 0.43,
        "price": 3179.02,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3078.99,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -3.01,
        "priceIn": 3179.02,
        "doubleCheck": true
    },
    {
        "dataID": "119478",
        "id": "53203711",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 22:41:11",
        "brokerTime": "2025-05-14 22:41:11",
        "commission": -16.8,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": "0",
        "orderId": "56139873",
        "positionId": "56139873",
        "volume": 2.4,
        "price": 3179.28,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -16.8,
        "priceIn": 3179.28,
        "doubleCheck": true
    },
    {
        "dataID": "119479",
        "id": "53203735",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 22:41:57",
        "brokerTime": "2025-05-14 22:41:57",
        "commission": -2.1,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUEUR.PRO",
        "magic": "0",
        "orderId": "56139897",
        "positionId": "56139897",
        "volume": 0.3,
        "price": 2845.01,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2745.01,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -2.1,
        "priceIn": 2845.01,
        "doubleCheck": true
    },
    {
        "dataID": "119480",
        "id": "53203783",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 22:27:04",
        "brokerTime": "2025-05-14 22:46:49",
        "commission": -0.84,
        "swap": 0,
        "profit": 63.42,
        "symbol": "XAUEUR.PRO",
        "magic": "0",
        "orderId": "56139937",
        "positionId": "56139378",
        "volume": 0.12,
        "price": 2844.25,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2939.27,
        "brokerComment": "",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 62.58,
        "priceIn": 2839.52,
        "doubleCheck": true,
        "isShow": false,
        "collapseIndex": "0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39,40,41,42,43,44,45,46,47,48,49,50,51,52,53,54",
        "tProfit": 104.65,
        "tnProfit": 103.11,
        "tVolume": 0.22,
        "tTrades": 2
    },
    {
        "dataID": "119481",
        "id": "53203784",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 22:26:11",
        "brokerTime": "2025-05-14 22:46:49",
        "commission": -0.7,
        "swap": 0,
        "profit": 41.23,
        "symbol": "XAUEUR.PRO",
        "magic": "0",
        "orderId": "56139938",
        "positionId": "56139370",
        "volume": 0.1,
        "price": 2844.25,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2939.27,
        "brokerComment": "",
        "comment": "RR",
        "accountCurrencyExchangeRate": "1",
        "netProfit": 40.529999999999994,
        "priceIn": 2840.56,
        "doubleCheck": true
    },
    {
        "dataID": "119482",
        "id": "53203785",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 22:46:56",
        "brokerTime": "2025-05-14 22:46:56",
        "commission": -0.7,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUEUR.PRO",
        "magic": "0",
        "orderId": "56139939",
        "positionId": "56139939",
        "volume": 0.1,
        "price": 2844.57,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "RR",
        "comment": "RR",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -0.7,
        "priceIn": 2844.57,
        "doubleCheck": true
    },
    {
        "dataID": "119483",
        "id": "53204038",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 22:53:40",
        "brokerTime": "2025-05-14 22:53:40",
        "commission": -2.52,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUEUR.PRO",
        "magic": "0",
        "orderId": "56140134",
        "positionId": "56140134",
        "volume": 0.36,
        "price": 2846.33,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2746.33,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -2.52,
        "priceIn": 2846.33,
        "doubleCheck": true
    },
    {
        "dataID": "119484",
        "id": "53204086",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 22:54:21",
        "brokerTime": "2025-05-14 22:54:21",
        "commission": -3.01,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUEUR.PRO",
        "magic": "0",
        "orderId": "56140174",
        "positionId": "56140174",
        "volume": 0.43,
        "price": 2847.34,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2747.34,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -3.01,
        "priceIn": 2847.34,
        "doubleCheck": true
    },
    {
        "dataID": "119485",
        "id": "53204087",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 22:54:22",
        "brokerTime": "2025-05-14 22:54:22",
        "commission": -16.8,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUEUR.PRO",
        "magic": "0",
        "orderId": "56140175",
        "positionId": "56140175",
        "volume": 2.4,
        "price": 2847.47,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 0,
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": "1",
        "netProfit": -16.8,
        "priceIn": 2847.47,
        "doubleCheck": true
    }
]